//#region imports

import {
  Alert,
  Autocomplete,
  Box,
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormHelperText,
  Grid,
  IconButton,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  ListItemIcon,
  ListItemText,
  useMediaQuery,
} from "@mui/material";
import React, { forwardRef, useImperativeHandle } from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import RemoveIcon from "@mui/icons-material/Remove";
import CloseIcon from "@mui/icons-material/Close";
import DeleteIcon from "@mui/icons-material/Delete";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import DoneIcon from "@mui/icons-material/Done";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import InfoIcon from "@mui/icons-material/Info";
import Backdrop from "@mui/material/Backdrop";
import AppLoader from '../../../components/AppLoader/AppLoader';
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import InputAdornment from "@mui/material/InputAdornment";
import Paper from "@mui/material/Paper";
import TableContainer from "@mui/material/TableContainer";
import { useEffect, useLayoutEffect, useState } from "react";
import Error from "../../../components/error/error";
import { useLocation, useNavigate } from "react-router-dom";
import InfoImage from "../../../images/informationButton.png";
import ActionsCell from "../../../components/actionCell/ActionCell";
// import ErrorIcon from '@mui/icons-material/Error';
import "../../../style/common.scss";
import "../../../style/dnRejectModal.scss";
import "../Reconnection/ReconnectionWorkflowDialog.scss";
import "../Reconnection/ReconnectionActivityLogExtras.scss";
import "./ChangeOfAttributeWorkflowDialog.scss";
import {
  WORKFLOW_MOBILE_MEDIA,
  workflowDialogClassName,
  workflowDialogShellProps,
} from "../../../utils/workflowDialogShell";
// use scan detection
import useScanDetection from "use-scan-detection";
//jspdf
import { jsPDF } from "jspdf";
import "jspdf-autotable";
//fonts
import ErrorIcon from "@mui/icons-material/Error";
import EventBusyIcon from "@mui/icons-material/EventBusy";
import RestoreIcon from "@mui/icons-material/Restore";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import PrintIcon from "@mui/icons-material/Print";
import DescriptionIcon from "@mui/icons-material/Description";
import TextField from '../../../components/SanitizedTextField/SanitizedTextField';
import { Formik, useFormik } from "formik";
import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import "react-toastify/dist/ReactToastify.css";
import * as Yup from "yup";
import CheckPermissions from "../../../authorization/authorization";
import Base64Image from "../../../components/Base64Image/Base64Image";
import RcoActivityLogDialog, {
  RcoHistoryDoc,
  RcoHistoryField,
} from "../../../components/RcoActivityLogDialog/RcoActivityLogDialog";
import RcoActivityLogDetailDialog, {
  ACTIVITY_LOG_TIMELINE_TYPES,
} from "../../../components/activityLog/RcoActivityLogDetailDialog";
import { buildCoaActivityLogDetailRows, buildCoaActivityLogApplicationDetails } from "../../../utils/coaActivityLogDetail";
import {
  SAFE_FORM_TEXT_MESSAGE,
  isSafePersonName,
  sanitizePersonNameInput,
} from "../../../utils/sanitizeFormText";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import StepProgressBar from "../../../components/StepProgressBar/StepProgressBar";
import ServiceDashboardTables from "../../../components/ServiceDashboardTables/ServiceDashboardTables";
import ProcessingSummaryTable from "../../../components/processingSummaryTable/processingSummaryTable";
import {
  fetchPaginatedChangeOfAttributesNormal,
  filterDateFrom as filterDateFromNormal,
  filterDateTo as filterDateToNormal,
  filterObjectionStatus as filterObjectionStatusNormal,
  filterProgressId as filterProgressIdNormal,
  firstPage as firstPageNormal,
  lastPage as lastPageNormal,
  nextPage as nextPageNormal,
  previousPage as prePageNormal,
  resetDateFilter as resetDateFilterNormal,
  resetObjectionStatusFilter as resetObjectionStatusFilterNormal,
  resetProgressIdFilter as resetProgressIdFilterNormal,
} from "../../../features/generalServices/coaNormalSlice";
import {
  fetchPaginatedChangeOfAttributesOverdue,
  filterDateFrom as filterDateFromOverdue,
  filterDateTo as filterDateToOverdue,
  filterObjectionStatus as filterObjectionStatusOverdue,
  filterProgressId as filterProgressIdOverdue,
  firstPage as firstPageOverdue,
  lastPage as lastPageOverdue,
  nextPage as nextPageOverdue,
  previousPage as prePageOverdue,
  resetDateFilter as resetDateFilterOverdue,
  resetObjectionStatusFilter as resetObjectionStatusFilterOverdue,
  resetProgressIdFilter as resetProgressIdFilterOverdue,
} from "../../../features/generalServices/coaOverdueSlice";
import tickicon from "../../../images/Accept.png";
import FESCOWaterMark from "../../../images/DiscosWater/fesco-watermark.png";
import GEPCOWaterMark from "../../../images/DiscosWater/gepco-watermark.png";
import HAZECOWaterMark from "../../../images/DiscosWater/hazeco-watermark.png";
import HESCOWaterMark from "../../../images/DiscosWater/hesco-watermark.png";
import IESCOWaterMark from "../../../images/DiscosWater/iescowatermark.png";
import LESCOWaterMark from "../../../images/DiscosWater/lescowatermark.png";
import MEPCOWaterMark from "../../../images/DiscosWater/mepcco-watermark.png";
import PESCOWaterMark from "../../../images/DiscosWater/pesco-watermark.png";
import QESCOWaterMark from "../../../images/DiscosWater/qesco-watermark.png";
import SEPCOWaterMark from "../../../images/DiscosWater/sepco-watermark.png";
import TESCOWaterMark from "../../../images/DiscosWater/tesco-watermark.png";
import pdfIcon from "../../../images/pdfIcon.png";
import crossIcon from "../../../images/remove.png";
import pencilIcon from "../../../images/pencil.png";
import { SearchIndividualApplication } from "../../../network/APIs/APIs";
import { cfpBaseUrl } from "../../../network/urls";
import JsBarcode from "jsbarcode";
import FESCOLOGO from "../../../images/DISCO Logos/FESCO.png";
import GEPCOLOGO from "../../../images/DISCO Logos/GEPCO.png";
import HESCOLOGO from "../../../images/DISCO Logos/HESCO.png";
import IESCOLOGO from "../../../images/DISCO Logos/IESCO.png";
import MEPCOLOGO from "../../../images/DISCO Logos/MEPCO.png";
import LESCOLOGO from "../../../images/DISCO Logos/LESCO.png";
import PESCOLOGO from "../../../images/DISCO Logos/PESCO.png";
import QESCOLOGO from "../../../images/DISCO Logos/QESCO.png";
import SEPCOLOGO from "../../../images/DISCO Logos/SEPCO.png";
import TESCOLOGO from "../../../images/DISCO Logos/TESCO.png";
import HAZECOLOGO from "../../../images/DISCO Logos/HAZECO.jpg";
import pitcLogo from "../../../images/pitc.png";
import {
  companyName,
  convertDate,
  convertDatewithTime,
  dBillAPI,
  getConsumerDetails,
  divisionName,
  documentValidation,
  downloadBill,
  getDocumentBackGroundColor,
  handleFileUpload,
  companyShortName,
  calculateBoqCharges,
  formatBoqChargeAmount,
  numberFormatting,
  printStamp,
  statusFunc,
  subdivisionName,
  isPdf,
  isImage,
  convertDatewithTimeWithoutSecond,
  normalizeDocumentDataUrl,
} from "../../../services/Functions";
import { getDocument, GlobalWorkerOptions } from "pdfjs-dist";
import { openBase64Image } from "../../../services/OpenBase64Image";
import OpenBase64ImageInPopup from "../../../services/OpenBase64ImageInPopup";
import { tableStyle, tableStyleOverDue } from "../../../style/common";
import { documentExtensions, portalName } from "../../../utils/PortalName";
import { getInitialAdminOfficeCode, resolveDiscoCompanyCodeForBranding, resolveDiscoCodeForDocument, getDiscoUseOnlyWatermarkText } from "../../../utils/adminCompany";
import { addDnPaymentQrCodesToPdf, COA_DN_QR_LAYOUT } from "../../../utils/generateDnPaymentQr";
import { drawDnDetailValue, drawDnDueDate } from "../../../utils/dnPdfReadableFonts";
import "../NewConnection/NewConnectionForm.scss";
import ProcessingSummaryTableForCoa from "../../../components/processingSummaryTable/processingSummaryTableForCoa";
import IESCODDLOGO from "../../../images/discologos/iesco logo.png";
import FESCODDLOGO from "../../../images/discologos/fesco.jpg";
import GEPCODDLOGO from "../../../images/discologos/gepco.jpg";
import HAZECODDLOGO from "../../../images/discologos/hazeco_logo-removebg-preview.png";
import HESCODDLOGO from "../../../images/discologos/hesco logo.png";
import LESCODDLOGO from "../../../images/discologos/lesco.jpg";
import MEPCODDLOGO from "../../../images/discologos/mepco1.jpg";
import PESCODDLOGO from "../../../images/discologos/pesco1.jpg";
import PITCDDLOGO from "../../../images/discologos/pitc11-removebg-preview.png";
import QESCODDLOGO from "../../../images/discologos/qesco.png";
import SEPCODDLOGO from "../../../images/discologos/sepco.jpg";
import TESCODDLOGO from "../../../images/discologos/tesco.jpg";
import useFetchData from "../../../hooks/fetchData";
//#endregion

/** Disco 13 / 14 (IESCO) / 15 — show Capital Cost / Security Raast IDs like New Connection. */
const isCoaRaastIdApplication = (applicationId) => {
  const companyCode = applicationId?.slice(3, 5);
  return (
    companyCode === "13" ||
    companyCode === "14" ||
    companyCode === "15"
  );
};

const canDownloadCoaDemandNotice = (applicationProgressId) => {
  const progress = Number(applicationProgressId);
  return Number.isFinite(progress) && progress >= 6;
};

const ChangeAttributesTable = forwardRef((props, ref) => {
  const dispatch = useDispatch();

  const {
    currentPage: currentPageNormal,
    data: dataNormal,
    pageSize: pageSizeNormal,
    totalPages: totalPagesNormal,
    totalRecords: totalRecordsNormal,
    dateFrom: dateFromNormal,
    dateTo: dateToNormal,
    applicationProgressId: applicationProgressIdNormal,
    objectionStatus: objectionStatusNormal,
    error: coaNormalError,
    isLoading: isLoad,
  } = useSelector((state) => state.coaNormalPaginated);
  const {
    currentPage: currentPageOverdue,
    data: dataOverdue,
    pageSize: pageSizeOverdue,
    totalPages: totalPagesOverdue,
    totalRecords: totalRecordsOverdue,
    dateFrom: dateFromOverdue,
    dateTo: dateToOverdue,
    applicationProgressId: applicationProgressIdOverdue,
    objectionStatus: objectionStatusOverdue,
    error: coaOverdueError,
    isLoading: isLoadd,
  } = useSelector((state) => state.coaOverduePaginated);
  const handleNextPageNormal = () => {
    dispatch(nextPageNormal());
  };

  const handleDateFromFilterNormal = (value) => {
    if (value) {
      setViewBackdrop(true);
      dispatch(filterDateFromNormal(value));
    }
  };

  const handleDateToFilterNormal = (value) => {
    if (value) {
      setViewBackdrop(true);
      dispatch(filterDateToNormal(value));
    }
  };

  const handleResetDateFilterNormal = () => {
    setViewBackdrop(true);
    dispatch(resetDateFilterNormal());
    dispatch(firstPageNormal());
  };

  const handleProgressIdFilterNormal = (value) => {
    if (value || value === 0) {
      setViewBackdrop(true);
      dispatch(filterProgressIdNormal(value));
    }
  };

  const handleResetProgressIdFilterNormal = () => {
    setViewBackdrop(true);
    dispatch(resetProgressIdFilterNormal());
    dispatch(firstPageNormal());
  };

  const handleObjectionStatusFilterNormal = (value) => {
    if (value || value === 0) {
      setViewBackdrop(true);
      dispatch(filterObjectionStatusNormal(value));
    }
  };

  const handleResetObjectionStatusFilterNormal = () => {
    setViewBackdrop(true);
    dispatch(resetObjectionStatusFilterNormal());
    dispatch(firstPageNormal());
  };

  const handlePreviousPageNormal = () => {
    dispatch(prePageNormal());
  };

  const handleFirstPageNormal = () => {
    dispatch(firstPageNormal());
  };

  const handleLastPageNormal = (page) => {
    dispatch(lastPageNormal(typeof page === 'number' ? page : totalPagesNormal));
  };

  useEffect(() => {
    if (dataNormal) {
      setChangeOfNameApplications(dataNormal);
      setViewBackdrop(false);
    }
  }, [dataNormal]);

  const scoHandleClose = () => {
    setScoPopUp(false);
  };

  const handleNextPageOverdue = () => {
    dispatch(nextPageOverdue());
  };

  const handleDateFromFilterOverdue = (value) => {
    if (value) {
      setViewBackdrop(true);
      dispatch(filterDateFromOverdue(value));
    }
  };

  const handleDateToFilterOverdue = (value) => {
    if (value) {
      setViewBackdrop(true);
      dispatch(filterDateToOverdue(value));
    }
  };
  const handleResetDateFilterOverdue = () => {
    setViewBackdrop(true);
    dispatch(resetDateFilterOverdue());
    dispatch(firstPageOverdue());
  };
  const handleProgressIdFilterOverdue = (value) => {
    if (value) {
      setViewBackdrop(true);
      dispatch(filterProgressIdOverdue(value));
    }
  };

  const handleResetProgressIdFilterOverdue = () => {
    setViewBackdrop(true);
    dispatch(resetProgressIdFilterOverdue());
    dispatch(firstPageOverdue());
  };

  const handleObjectionStatusFilterOverdue = (value) => {
    if (value) {
      setViewBackdrop(true);
      dispatch(filterObjectionStatusOverdue(value));
    }
  };

  const handleResetObjectionStatusFilterOverdue = () => {
    setViewBackdrop(true);
    dispatch(resetObjectionStatusFilterOverdue());
    dispatch(firstPageOverdue());
  };

  const handlePreviousPageOverdue = () => {
    dispatch(prePageOverdue());
  };

  const handleFirstPageOverdue = () => {
    dispatch(firstPageOverdue());
  };

  const handleLastPageOverdue = (page) => {
    dispatch(lastPageOverdue(typeof page === 'number' ? page : totalPagesOverdue));
  };

  useEffect(() => {
    if (dataOverdue) {
      setChangeOfNameApplicationsOverDue(dataOverdue);
      setViewBackdrop(false);
    }
  }, [dataOverdue]);

  //#region initial values

  const initialValues = {
    iv_objection_Type: 1,
    iv_objection_Descripton: "",
    iv_distance: "",
    iv_sketch_diagram: "",
    iv_property_reference_no: "",
    iv_material_required: false,
    iv_meter_to_replace: false,
    iv_batch_change: false,
    iv_seasonal: 0,
    iv_area_type: "",
    iv_reference_to_allot: "",
    iv_batch: "",
    iv_sub_batch: "",
    iv_arear_paid_bill_document: "",
    iv_arear_paid_bill_date: "",
    iv_meter_type: 1,
    iv_signed_consent_image: "",
    iv_old_referenceNumber: "",
    iv_location_code: "P",
    iv_remarks_others: "",
    // Charge fields
    iv_grid_sharing_cost: 0,
    iv_feeder_rehab_charges: 0,
    iv_civil_work_charges: 0,
    iv_mnt_charges: 0,
    iv_labour_charges: 0,
    iv_design_vetting_fee: 0,
    iv_consultancy_charges: 0,
    iv_variation_charges: 0,
    iv_dismantlement_charges: 0,
    iv_earthing_charges: 0,
    iv_payment_date: "",
    iv_receipt_image: "",
  };

  const {
    token,
    userId,
    hierarchy,
    roleId,
    roleName,
    permissions,
    code,
    roleTypeId,
    selectedAdminCompanyCode,
  } = useSelector((state) => state.auth);
  const isWorkflowMobile = useMediaQuery(WORKFLOW_MOBILE_MEDIA);
  const [installedMeterImageThumbnail, setInstalledMeterImageThumbnail] =
    useState("");

  const calculateMF = (ctNom, ctDenom, ptNom, ptDenom) => {
    let mf = (ctNom / ctDenom) * (ptNom / ptDenom);
    return mf;
  };

  const subDivisions = (() => {
    try {
      const raw = window.localStorage.getItem("subDivisions");
      if (!raw) return [];
      const parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  })();
  let userCompany = resolveDiscoCompanyCodeForBranding(
    code,
    roleId,
    selectedAdminCompanyCode,
  );

  const getDocumentDiscoCode = (applicationId, fallbackCompanyCode = "") =>
    resolveDiscoCodeForDocument(
      applicationId,
      code,
      roleId,
      selectedAdminCompanyCode,
      fallbackCompanyCode,
    );

  const getWaterMarkLogo = (code) => {
    switch (code) {
      case "11":
        return LESCOWaterMark;
      case "12":
        return GEPCOWaterMark;
      case "13":
        return FESCOWaterMark;
      case "14":
        return IESCOWaterMark;
      case "15":
        return MEPCOWaterMark;
      case "26":
        return PESCOWaterMark;
      case "27":
        return HAZECOWaterMark;
      case "37":
        return HESCOWaterMark;
      case "38":
        return SEPCOWaterMark;
      case "48":
        return QESCOWaterMark;
      case "59":
        return TESCOWaterMark;
      default:
        return MEPCOWaterMark;
    }
  };

  const getCompanies = (code) => {
    switch (code) {
      case "10":
        return "Power Information Technology Company";
      case "11":
        return "Lahore Electric Supply Company";
      case "12":
        return "Gujranwala Electric Power Company";
      case "13":
        return "Faisalabad Electric Supply Company";
      case "14":
        return "Islamabad Electric Supply Company";
      case "15":
        return "Multan Electric Power Company";
      case "26":
        return "Peshawar Electric Supply Company";
      case "27":
        return "Hazara Electric Supply Company";
      case "38":
        return "Sukkur Electric Power Company";
      case "37":
        return "Hyderabad Electric Supply Company";
      case "48":
        return "Quetta Electric Supply Company";
      case "59":
        return "Tribal Electric Supply Company";
    }
  };

  const getLogo = (code) => {
    switch (code) {
      case "10":
        return pitcLogo;
      case "11":
        return LESCOLOGO;
      case "12":
        return GEPCOLOGO;
      case "13":
        return FESCOLOGO;
      case "14":
        return IESCOLOGO;
      case "15":
        return MEPCOLOGO;
      case "26":
        return PESCOLOGO;
      case "27":
        return HAZECOLOGO;
      case "37":
        return HESCOLOGO;
      case "38":
        return SEPCOLOGO;
      case "48":
        return QESCOLOGO;
      case "59":
        return TESCOLOGO;
      default:
        return MEPCOLOGO;
    }
  };

  //#endregion

  //#region states
  const [frontImg, setFrontImg] = useState(null);
  const [backImg, setBackImg] = useState(null);
  const [showMasterForm, setShowMasterForm] = useState(false);
  const [open, setOpen] = React.useState(false);
  const [dialogRowData, setDialogRowData] = React.useState({});
  const [showEditPopup, setShowEditPopup] = useState(false);
  const [editSections, setEditSections] = useState({
    name: false,
    load: false,
    tariff: false,
  });
  const [editLoadError, setEditLoadError] = useState("");
  const [editLoadChangeTypeError, setEditLoadChangeTypeError] = useState("");
  const [editNameErrors, setEditNameErrors] = useState({
    newName: "",
    guardianName: "",
    newCNIC: "",
    newPhone: "",
  });
  const [editTariffError, setEditTariffError] = useState("");
  const [editSaveError, setEditSaveError] = useState("");
  const [editFbrDocument, setEditFbrDocument] = useState("");
  const [editFbrDocumentThumbnail, setEditFbrDocumentThumbnail] = useState("");
  const [editFbrDocumentError, setEditFbrDocumentError] = useState("");
  const [editFbrDocumentCleared, setEditFbrDocumentCleared] = useState(false);
  const [editWiringTestReportDocument, setEditWiringTestReportDocument] = useState("");
  const [editWiringTestReportThumbnail, setEditWiringTestReportThumbnail] = useState("");
  const [editWiringTestReportError, setEditWiringTestReportError] = useState("");
  const [editWiringTestReportCleared, setEditWiringTestReportCleared] = useState(false);
  const [editNtnError, setEditNtnError] = useState("");
  const [editFormData, setEditFormData] = useState({
    // Common fields
    referenceNo: "",
    address: "",
    connectionType: "",
    tariff: "",
    city: "",
    circle: "",
    division: "",
    subdivision: "",
    // Change of Name fields
    currentName: "",
    currentCNIC: "",
    currentPhone: "",
    newName: "",
    newCNIC: "",
    newPhone: "",
    relation: "",
    guardianName: "",
    telcoCode: "",
    // Change of Load fields
    loadChangeType: "",
    currentLoad: "",
    newLoad: "",
    // Change of Tariff fields
    currentTariff: "",
    newTariff: "",
    ntnNo: "",
    newEmail: "",
  });
  /** Snapshot of values when Edit popup opened — used to detect real changes before Save API. */
  const [editFormBaseline, setEditFormBaseline] = useState(null);
  const [editCircleList, setEditCircleList] = useState([]);
  const [editDivisionList, setEditDivisionList] = useState([]);
  const [editSubDivisionList, setEditSubDivisionList] = useState([]);
  const [changeOfNameApplications, setChangeOfNameApplications] = useState([]);
  const [
    changeOfNameApplicationsToDataGrid,
    setChangeOfNameApplicationsToDataGrid,
  ] = useState([]);
  const [changeOfNameApplicationsOverDue, setChangeOfNameApplicationsOverDue] =
    useState([]);
  const [
    changeOfNameApplicationsOverDueToDataGrid,
    setChangeOfNameApplicationsOverDueToDataGrid,
  ] = useState([]);
  const [arrearFlag, setArearFlag] = useState(0);
  const [viewDropBackForEfile, setViewDropBackForEfile] = useState(false);
  const [arearPaidBillUpload, setArearPaidBillUpload] = useState(false);
  const [arearPaidBillDocument, setArearPaidBillDocument] = useState("");
  const [arearPaidBillDocumentError, setArearPaidBillDocumentError] =
    useState("");
  const [arearPaidBillDocumentThumbnail, setArearPaidBillDocumentThumbnail] =
    useState("");
  const [consentVerificationFlag, setConsentVerificationFlag] = useState(0);
  const [dnRejectModalOpen, setDnRejectModalOpen] = useState(false);
  const [dnDocumentsCertified, setDnDocumentsCertified] = useState(false);
  const [flag_wiringTestReport, setFlag_wiringTestReport] = useState(null);
  const [wiringTestReportObjectionRemarks, setWiringTestReportObjectionRemarks] =
    useState("");
  const [wiringTestReportVerifyPopUp, setWiringTestReportVerifyPopUp] =
    useState(false);
  const [newWiringTestReportDocument, setNewWiringTestReportDocument] =
    useState("");
  const [newWiringTestReportDocumentThumbnail, setNewWiringTestReportDocumentThumbnail] =
    useState("");
  const [newWiringTestReportDocumentError, setNewWiringTestReportDocumentError] =
    useState("");
  const [wiringTestReportLoading, setWiringTestReportLoading] = useState(false);
  const [historyWiringTestReportImg, setHistoryWiringTestReportImg] =
    useState("");
  const [historyWiringTestReportImgLoading, setHistoryWiringTestReportImgLoading] =
    useState(false);
  const [dnPaymentRemarks, setDnPaymentRemarks] = useState("");
  const [showDNPayment, setShowDNPayment] = useState(true);
  const [paidDNImagePopUp, setPaidDNImagePopUp] = useState(false);
  const [paidDnViewerDocument, setPaidDnViewerDocument] = useState(null);
  const [responseMessage, setResponseMessage] = useState("");
  const [responseMessageError, setResponseMessageError] = useState("");
  const [responseStoreRequisitionNo, setResponseStoreRequisitionNo] =
    useState("");
  const [responseType, setResponseType] = useState(""); // "success" or "error"
  const [openResponseModal, setOpenResponseModal] = useState(false);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });
  const [dnApprovalPayload, setDnApprovalPayload] = useState(null);
  const [dnPaymentVerification, setDnPaymentVerification] = useState(null);
  const [dnNumber, setDnNumber] = useState();
  const [dnPaymentDate, setDnPaymentDate] = useState();
  const [dnApproveStep, setDnApproveStep] = useState([]);
  const [dnDets, setDnDets] = useState([]);
  const [dnImage, setDnImage] = useState();
  const [paidDNVoucherImg, setPaidDNVoucherImg] = useState(null);
  const [historyPaidDnImg, setHistoryPaidDnImg] = useState("");
  const [showSJOPart1Form, setShowSJOPart1Form] = useState(false);
  const [showSJOPart2Form, setShowSJOPart2Form] = useState(false);
  const [dnPaymentVerifyAlert, setDnPaymentVerifyAlert] = React.useState(false);
  const [dnPaymentRejectAlert, setDnPaymentRejectAlert] = React.useState(false);
  const [sjoApproveAlert, setSjoApproveAlert] = React.useState(false);
  const [noArrears, setNoArrears] = useState("");
  const [officeHierarchy, setOfficeHierarchy] = useState();
  const navigate = useNavigate();
  const [signedConsentFormImage, setSignedConsentFormImageImage] = useState();
  const [
    signedConsentFormImageThumbnail,
    setSignedConsentFormImageImageThumbnail,
  ] = useState();
  const [signedConsentFormImageError, setSignedConsentFormImageError] =
    useState();
  const [dnReceiptImage, setDnReceiptImage] = useState();
  const [arrearPaidReceiptImage, setArrearPaidReceiptImage] = useState();
  const [arrearPaidReceiptImageThumbnail, setArrearPaidReceiptImageThumbnail] =
    useState();
  const [dnReceiptImageThumbnail, setDnReceiptImageThumbnail] = useState();
  const [objectionPopUpOpen, setObjectionPopUpOpen] = React.useState(false);
  const [cancelApplicationPopUpOpen, setCancelApplicationPopUpOpen] =
    React.useState(false);
  const [cancelApplicationConfirmOpen, setCancelApplicationConfirmOpen] =
    React.useState(false);
  const [cancelApplicationRemarks, setCancelApplicationRemarks] = useState("");
  const [cancelRemarksError, setCancelRemarksError] = useState("");
  const [restoreApplicationPopUpOpen, setRestoreApplicationPopUpOpen] =
    useState(false);
  const [restoreApplicationConfirmOpen, setRestoreApplicationConfirmOpen] =
    useState(false);
  const [restoreApplicationRemarks, setRestoreApplicationRemarks] = useState("");
  const [restoreRemarksError, setRestoreRemarksError] = useState("");
  const [restoreRequiresLoeDocument, setRestoreRequiresLoeDocument] =
    useState(false);
  const [restoreLoeDocument, setRestoreLoeDocument] = useState("");
  const [restoreLoeDocumentThumbnail, setRestoreLoeDocumentThumbnail] =
    useState("");
  const [restoreLoeDocumentError, setRestoreLoeDocumentError] = useState("");
  const [arrearsEntryPopUpOpen, setArrearsEntryPopUpOpen] =
    React.useState(false);
  const [docVerifyAlert, setDocVerifyAlert] = React.useState(false);
  const [fieldVerifyAlert, setFieldVerifyAlert] = React.useState(false);
  const [
    signedConsentRejectionRemovalAlert,
    setSignedConsentRejectionRemovalAlert,
  ] = React.useState(false);
  const [arrearRejectionRemovalAlert, setArrearRejectionRemovalAlert] =
    React.useState(false);
  const [arrearsVerifyPopUpOpen, setArrearsVerifyPopUpOpen] =
    React.useState(false);
  const [eFileData, setEFileData] = useState([]);
  const [eFileCurrentStatus, setEFileCurrentStatus] = useState(null);
  const [activityLogDetailOpen, setActivityLogDetailOpen] = useState(false);
  const [activityLogCollapsed, setActivityLogCollapsed] = useState(true);
  const [error, setError] = useState("");
  const [previousSecurity, setPreviousSecurity] = useState();
  const [sanctionedLoad, setSanctionedLoad] = useState();
  const [connectionCategoryType, setConnectionCategoryType] = useState();
  const [bankName, setBankName] = useState();
  const [progressBarStepName, setProgressBarStepName] = useState();
  const [paidDnImageDetails, setPaidDnImageDetails] = useState({
    id: null,
    applicationId: "",
    demandNoticeNo: "",
    paidDNImage: "",
    uploadedBy: "",
    uploadedAt: "",
    paymentDate: "",
    painDNImageVerification: null,
  });
  const [selectedRow, setSelectedRow] = useState(null);
  const [coaApplicationUpdatedPopUp, setCoaApplicationUpdatedPopUp] =
    useState(false);
  const [coaApplicationRevertedSubPopUp, setCoaApplicationRevertedSubPopUp] =
    useState(false);
  const [coaApplicationUpdatedHistoryData, setCoaApplicationUpdatedHistoryData] =
    useState(null);
  const [documentsVerifiedSubPopUp, setDocumentsVerifiedSubPopUp] =
    useState(false);
  const [applicationSubittedPopUp, setApplicationSubmittedPopUp] =
    useState(false);
  const [arrearVerifiedSubPopUp, setArrearVerifiedSubPopUp] = useState(false);
  const [fieldSurveyedSubPopUp, setFieldSurveyedSubPopUp] = useState(false);
  const [fieldSurveyedObjectionSubPopUp, setFieldSurveyedObjectionSubPopUp] =
    useState(false);

  const [dnApprovalSubPopUp, setDnApprovalSubPopUp] = useState(false);
  const [dnPaymentSubmittedSubPopUp, setDnPaymentSubmittedSubPopUp] =
    useState(false);
  const [dnPaymentVerifiedSubPopUp, setDnPaymentVerifiedSubPopUp] =
    useState(false);
  const [
    serviceConnectionOrderedSubPopUp,
    setServiceConnectionOrderedSubPopUp,
  ] = useState(false);
  const [meterInstalledSubPopUp, setMeterInstalledSubPopUp] = useState(false);
  const [readyForBillingSubPopUp, setReadyForBillingSubPopUp] = useState(false);

  const [paymentStatus, setPaymentStatus] = useState("");
  const [arrearAmount, setArrearAmount] = useState("");
  const [billMonth, setBillMonth] = useState("");

  const [lookUpDataOfCON, setLookUpDataOfCON] = useState(null);
  const [sketchDiagramThumbnail, setSketchDiagramThumbnail] = useState("");
  const [sketchDiagram, setSketchDiagram] = useState();
  const [sketchDiagramError, setSketchDiagramError] = useState();
  const [sketchDiagramUploaded, setSketchDiagramUploaded] = useState();
  const [partialValue, setPartialValue] = useState("");
  const [showBoq, setShowBoq] = React.useState(false);
  const [errormessageBoqEstimation, setErrormessageBoqEstimation] =
    useState("");
  const [grandTotalCharges, setGrandTotalCharges] = useState(0);
  const [itemsArray, setItemsArray] = useState([]);
  const [fixedChargesOfMetering, setFixedChargesOfMetering] = useState(0);
  const [boqItems, setBoqItems] = useState([]);
  const [costEstimationForNC, setCostEstimationForNC] = React.useState({});
  const [allMaterialList, setAllMaterialList] = useState([]);
  const [installRefNo, setInstallRefNo] = useState([]);
  const [meterTypeValue, setMeterTypeValue] = useState("");
  const [tariff, setTariff] = useState();
  const [gridSharingCost, setGridSharingCost] = useState(0);
  const [lessTheCost, setLessTheCost] = useState(0);
  const [totalCharges, setTotalCharges] = useState(0);
  const [miscellaneousCharges, setMiscellaneousCharges] = useState(0);
  const [civilWorkCharges, setCivilWorkCharges] = useState(0);
  const [feederRehabilitationCharges, setFeederRehabilitationCharges] =
    useState(0);
  const [mntCharges, setMntCharges] = useState(0);
  const [labourCharges, setLabourCharges] = useState(0);
  const [designVettingFee, setDesignVettingFee] = useState(0);
  const [consultancyCharges, setConsultancyCharges] = useState(0);
  const [variationCharges, setVariationCharges] = useState(0);
  const [dismantlementCharges, setDismantlementCharges] = useState(0);
  const [earthingCharges, setEarthingCharges] = useState(0);
  const [installationCharges, setInstallationCharges] = useState(null);
  const [errormessageCostEstimation, setErrormessageCostEstimation] =
    useState("");
  const [meterAlreadyInstalled, setMeterAlreadyInstalled] = useState("");
  const [itemsAmount, setItemsAmount] = useState(null);
  const [storeCharges, setStoreCharges] = useState(null);
  const [showCostEstimation, setShowCostEstimation] = React.useState(false);
  const [estimateDistance, setEstimateDistance] = useState("");
  const [installedMeterImage, setInstalledMeterImage] = useState("");
  const [installedMeterImageVerifyPopUp, setInstalledMeterImageVerifyPopUp] =
    useState(false);

  const [
    applicantCNICFrontObjectionRemarks,
    setApplicantCNICFrontObjectionRemarks,
  ] = useState("");
  const [
    applicantCNICBackObjectionRemarks,
    setApplicantCNICBackObjectionRemarks,
  ] = useState("");
  const [owenershipObjectionRemarks, setowenershipObjectionRemarks] =
    useState("");
  const [electricityBillObjectionRemarks, setElectricityBillObjectionRemarks] =
    useState("");
  const [fbrDocumentObjectionRemarks, setFbrDocumentObjectionRemarks] =
    useState("");

  const [
    preOwnerCNICFrontObjectionRemarks,
    setpreOwnerCNICFrontObjectionRemarks,
  ] = useState("");
  const [
    preOwnerCNICBackObjectionRemarks,
    setpreOwnerCNICBackObjectionRemarks,
  ] = useState("");
  const [perOwenerNOCObjectionRemarks, setperOwenerNOCObjectionRemarks] =
    useState("");
  const [
    newOwenerAffidaviteObjectionRemarks,
    setnewOwenerAffidaviteObjectionRemarks,
  ] = useState("");
  const [
    addDocCivicAuthorityObjectionRemarks,
    setaddDocCivicAuthorityObjectionRemarks,
  ] = useState("");
  const [addDocAnyOtherObjectionRemarks, setaddDocAnyOtherObjectionRemarks] =
    useState("");
  const [addCONConsentObjectionRemarks, setaddCONConsentObjectionRemarks] =
    useState("");

  const [additionalCivicDocument, setAdditionalCivicDocument] = useState("");
  const [
    additionalCivicDocumentThumbnail,
    setAdditionalCivicDocumentThumbnail,
  ] = useState("");
  const [additionalCivicDocumentError, setAdditionalCivicDocumentError] =
    useState("");
  const [inputValue, setInputValue] = useState("");

  const [debouncedInputValue, setDebouncedInputValue] = useState(inputValue);

  const [openObjectionPopup, setOpenObjectionPopup] = useState(false);
  const [allTariffList, setAllTariffList] = useState([]);

  const [receiptImage, setReceiptImage] = useState("");
  const [receiptImageThumbnail, setReceiptImageThumbnail] = useState("");
  const [receiptImageError, setReceiptImageError] = useState("");
  const [dnReceiptImageUploaded, setDnReceiptImageUploaded] = useState("");
  const [paymentDateError, setPaymentDateError] = useState("");
  const [rejectModalOpen, setRejectModalOpen] = useState(false);
  const [remarks, setRemarks] = useState("");
  const [remarksError, setRemarksError] = useState(""); // new state
  const [phase, setPhase] = useState();
  const [installedMeterImageError, setInstalledMeterImageError] = useState("");
  const [scoPopUp, setScoPopUp] = useState(false);
  const [showDnExpiryPopup, setShowDnExpiryPopup] = useState(false);
  const [dnExpiryDialogData, setDnExpiryDialogData] = useState({
    applicationId: "",
    issueDate: "",
  });
  const [dialogDnExpiryFlag, setDialogDnExpiryFlag] = useState(null);

  const getCoaHistoryProgressId = (row) =>
    Number(row?.historyProgressId ?? row?.applicationProgressId);

  // Show Previous/Updated comparison table for info edits before DN Payment (up to DN Approval).
  // 1=Doc Verification, 2=Wiring Test, 3=Arrear, 4=Field Survey, 5=DN Approval
  const COA_APPLICATION_UPDATED_PROGRESS_IDS = [1, 2, 3, 4, 5];

  const isCoaApplicationUpdatedAllowedProgress = (row) => {
    if (!row) return false;
    const applicationProgressId = Number(row.applicationProgressId);
    const historyProgressId = Number(row.historyProgressId);
    if (COA_APPLICATION_UPDATED_PROGRESS_IDS.includes(applicationProgressId)) {
      return true;
    }
    if (COA_APPLICATION_UPDATED_PROGRESS_IDS.includes(historyProgressId)) {
      return true;
    }
    return false;
  };

  const getCoaApplicationUpdatedStepProgressId = (row) => {
    const applicationProgressId = Number(row?.applicationProgressId);
    const historyProgressId = Number(row?.historyProgressId);
    if (COA_APPLICATION_UPDATED_PROGRESS_IDS.includes(applicationProgressId)) {
      return applicationProgressId;
    }
    if (COA_APPLICATION_UPDATED_PROGRESS_IDS.includes(historyProgressId)) {
      return historyProgressId;
    }
    return getCoaHistoryProgressId(row);
  };

  const getCoaHistoryId = (row) =>
    row?.historyId ?? row?.historyID ?? row?.id ?? null;

  const resolveActivityLogHistoryRow = (row) => {
    if (!row || typeof row !== "object") return row;
    return row._raw ?? row;
  };

  const getCoaActivityStepLabel = (stepRowOrTableRow, historyRow) => {
    if (typeof stepRowOrTableRow === "string") return stepRowOrTableRow;
    if (stepRowOrTableRow?.stepName) return stepRowOrTableRow.stepName;
    return historyRow?.coaProgStatusName ?? "";
  };

  const resolveCoaHistoryWiringTestReportFlag = (hist) => {
    if (!hist) return null;
    const historyWiringFlag = hist.wiringTestReportDocumentFlag;
    if (
      historyWiringFlag === 1 ||
      historyWiringFlag === -1 ||
      historyWiringFlag === 2 ||
      historyWiringFlag === "1" ||
      historyWiringFlag === "-1" ||
      historyWiringFlag === "2"
    ) {
      return Number(historyWiringFlag);
    }
    if (
      Number(hist.applicationProgressId) === 2 &&
      Number(hist.objectionStatus) === 1
    ) {
      return -1;
    }
    if (
      Number(hist.applicationProgressId) === 2 &&
      Number(hist.objectionStatus) === 2
    ) {
      return 2;
    }
    return null;
  };

  const buildCoaHistoryViewFlags = (data) => {
    if (!data) return null;
    return {
      applicantCNICFront: data.applicantCNICFrontFlag ?? null,
      applicantCNICBack: data.applicantCNICBackFlag ?? null,
      owenershipDocument: data.ownershipImageFlag ?? null,
      electricityBillDocument: data.electricityBillFlag ?? null,
      fbrDocument: data.fbrDocumentFlag ?? null,
      addDocAnyOther: data.anyOtherDocumentFlag ?? null,
      wiringTestReport: resolveCoaHistoryWiringTestReportFlag(data),
    };
  };

  const getCoaHistoryAnyOtherDocument = (data) =>
    data?.anyOtherDocument || data?.addDocAnyOther || "";

  const mergeCoaHistoryDocuments = (hist, docs) => {
    if (!hist) return hist;
    if (!docs) return hist;

    return {
      ...hist,
      applicantCNICFront: hist.applicantCNICFront || docs.applicantCNICFront,
      applicantCNICBack: hist.applicantCNICBack || docs.applicantCNICBack,
      ownershipImage: hist.ownershipImage || docs.ownershipImage,
      electricityBill: hist.electricityBill || docs.electricityBill,
      fbrDocument: hist.fbrDocument || docs.fbrDocument,
      anyOtherDocument: hist.anyOtherDocument || docs.anyOtherDocument,
      addDocAnyOther:
        hist.addDocAnyOther || hist.anyOtherDocument || docs.anyOtherDocument,
      applicantCNICFrontFlag:
        hist.applicantCNICFrontFlag ?? docs.applicantCNICFrontFlag,
      applicantCNICBackFlag:
        hist.applicantCNICBackFlag ?? docs.applicantCNICBackFlag,
      ownershipImageFlag: hist.ownershipImageFlag ?? docs.ownershipImageFlag,
      electricityBillFlag: hist.electricityBillFlag ?? docs.electricityBillFlag,
      fbrDocumentFlag: hist.fbrDocumentFlag ?? docs.fbrDocumentFlag,
      anyOtherDocumentFlag:
        hist.anyOtherDocumentFlag ?? docs.anyOtherDocumentFlag,
    };
  };

  const applyCoaHistoryViewFlags = (data) => {
    setHistoryViewFlags(buildCoaHistoryViewFlags(data));
  };

  const closeAllCoaDocumentVerifyPopups = () => {
    setCopyOfApplicantCNICVerifyPopUp(false);
    setPreOwnerCNICVerifyPopUp(false);
    setOwenershipDocumentVerifyPopUp(false);
    setElectricityBillDocumentVerifyPopUp(false);
    setFbrDocumentVerifyPopUp(false);
    setPaidBillPopUp(false);
    setPerOwenerNOCVerifyPopUp(false);
    setNewOwenerAffidaviteVerifyPopUp(false);
    setAddDocCivicAuthorityVerifyPopUp(false);
    setAddDocAnyOtherVerifyPopUp(false);
    setAddDocCONConsentVerifyPopUp(false);
    setWiringTestReportVerifyPopUp(false);
    setArrearsVerifyPopUpOpen(false);
    setInstalledMeterImageVerifyPopUp(false);
  };

  const syncCoaLiveDocumentFlagsFromDialog = () => {
    if (!dialogRowData?.applicationId) return;

    const item = dialogRowData;
    setFlag_applicantCNICFront(item.applicantCNICFrontFlag ?? null);
    setFlag_applicantCNICBack(item.applicantCNICBackFlag ?? null);
    setFlag_owenershipDocument(item.ownershipImageFlag ?? null);
    setFlag_electricityBillDocument(item.electricityBillFlag ?? null);
    setFlag_fbrDocument(item.fbrDocumentFlag ?? null);
    setFlag_addDocAnyOther(item.anyOtherDocumentFlag ?? null);
    setApplicantCNICFrontObjectionRemarks(item.applicantCNICFrontRemarks || "");
    setApplicantCNICBackObjectionRemarks(item.applicantCNICBackRemarks || "");
    setowenershipObjectionRemarks(item.ownershipImageRemarks || "");
    setElectricityBillObjectionRemarks(item.electricityBillRemarks || "");
    setFbrDocumentObjectionRemarks(item.fbrDocumentRemarks || "");
    setaddDocAnyOtherObjectionRemarks(item.anyOtherDocumentRemarks || "");
    syncCoaWiringTestReportFlags(item);
  };

  const isCoaApplicationSubmittedHistoryView = (data) => {
    if (!data) return false;
    const progressId = Number(data.applicationProgressId);
    if (progressId === 0) return true;
    return (
      progressId === 1 &&
      data.remarks !== "Revert to Documents Verification" &&
      data.remarks !== "Documents Rejected"
    );
  };

  const isCoaWiringTestReportHistory = (hist) => {
    if (!hist) return false;
    const remarks = String(hist.remarks || "").toLowerCase();
    return (
      Boolean(hist.wiringTestReportDocument) ||
      remarks.includes("wiring test report") ||
      Number(hist.historyProgressId) === 2
    );
  };

  const isCoaWiringTestReportHistoryView = (hist) =>
    hist &&
    Number(hist.applicationProgressId) === 3 &&
    Number(hist.objectionStatus) === 0 &&
    isCoaWiringTestReportHistory(hist);

  const isCoaWiringTestReportRejectedHistoryView = (hist) =>
    hist &&
    Number(hist.applicationProgressId) === 2 &&
    Number(hist.objectionStatus) === 1;

  const isCoaWiringTestReportReuploadedHistoryView = (hist) =>
    hist &&
    Number(hist.applicationProgressId) === 2 &&
    Number(hist.objectionStatus) === 2;

  const isCoaWiringTestReportPopupView = (hist) =>
    isCoaWiringTestReportHistoryView(hist) ||
    isCoaWiringTestReportRejectedHistoryView(hist) ||
    isCoaWiringTestReportReuploadedHistoryView(hist);

  const isCoaDocumentVerificationObjectionView = (hist) =>
    hist &&
    Number(hist.applicationProgressId) === 1 &&
    Number(hist.objectionStatus) === 1;

  const isCoaDocumentsVerifiedHistoryView = (hist) => {
    if (!hist || Number(hist.objectionStatus) !== 0) return false;
    if (hist.remarks === "Revert to Arrear Verification") return false;
    if (isCoaWiringTestReportPopupView(hist)) return false;

    const progressId = Number(hist.applicationProgressId);
    if (progressId === 2) return true;

    if (progressId === 3) {
      const remarks = String(hist.remarks || "").trim();
      if (remarks === "Arrears Verified") return false;
      if (remarks === "Revert to Field Survey.") return false;
      if (remarks === "Field Survey Objection Removed.") return false;
      return true;
    }

    return false;
  };

  const shouldShowCoaDocumentsVerifiedHistoryGrid = (hist) =>
    isCoaDocumentVerificationObjectionView(hist) ||
    isCoaDocumentsVerifiedHistoryView(hist);

  const getCoaHistoryRemarksText = (hist) =>
    `${hist?.remarks || ""} ${hist?.remarksDetail || ""}`.trim();

  const mergeCoaHistoryData = (hist, stepName) => ({
    ...hist,
    remarks: hist?.remarks ?? stepName?.remarks ?? "",
    remarksDetail: hist?.remarksDetail ?? stepName?.remarksDetail ?? "",
    applicationProgressId:
      hist?.applicationProgressId ?? stepName?.applicationProgressId,
    objectionStatus: hist?.objectionStatus ?? stepName?.objectionStatus,
  });

  const getCoaPopupProgressId = (hist, stepName) => {
    const historyProgressId = Number(
      hist?.historyProgressId ?? stepName?.historyProgressId
    );
    if (!Number.isNaN(historyProgressId) && historyProgressId >= 0) {
      return historyProgressId;
    }

    const applicationProgressId = Number(
      hist?.applicationProgressId ?? stepName?.applicationProgressId
    );
    if (!Number.isNaN(applicationProgressId) && applicationProgressId >= 0) {
      return applicationProgressId;
    }

    return null;
  };

  const isCoaArrearVerificationHistoryView = (hist) =>
    hist &&
    Number(hist.applicationProgressId) === 4 &&
    Number(hist.objectionStatus) === 0 &&
    String(hist.remarks || "")
      .toLowerCase()
      .includes("arrears verified");

  const isCoaRevertToFieldSurveyRemarks = (remarks) => {
    const text = String(remarks || "").toLowerCase();
    return (
      text.includes("revert to field survey") ||
      text.includes("reverted to field survey")
    );
  };

  const isCoaRevertToDocumentsVerificationRemarks = (remarks) => {
    const text = String(remarks || "").toLowerCase();
    return (
      text.includes("revert to documents verification") ||
      text.includes("reverted to documents verification")
    );
  };

  const isCoaApplicationRevertedRemarks = (remarks) => {
    const text = String(remarks || "").trim().toLowerCase();
    return text.startsWith("revert to");
  };

  const isCoaApplicationRevertedHistoryView = (hist) =>
    hist && isCoaApplicationRevertedRemarks(hist.remarks);

  const isCoaRevertToDocumentsVerificationHistoryView = (hist) =>
    hist &&
    Number(hist.applicationProgressId) === 4 &&
    Number(hist.objectionStatus) === 0 &&
    isCoaRevertToDocumentsVerificationRemarks(getCoaHistoryRemarksText(hist));

  const isCoaDemandNoteRejectionHistoryView = (hist) =>
    hist &&
    Number(hist.applicationProgressId) === 6 &&
    Number(hist.objectionStatus) === 1;

  const getCoaHistoryPaidDnImage = (hist) =>
    hist?.paidDNImage || dnImage || paidDnImageDetails?.paidDNImage || "";

  const resolvePaidDnPreviewImage = (rawSource) => {
    if (!rawSource) return null;
    if (
      rawSource === dnImage ||
      rawSource === dnApproveStep?.paidDNImage
    ) {
      return paidDNVoucherImg;
    }
    if (
      rawSource === historyData?.paidDNImage ||
      rawSource === paidDnImageDetails?.paidDNImage
    ) {
      return historyPaidDnImg || (String(rawSource).startsWith("data:image") ? rawSource : null);
    }
    if (String(rawSource).startsWith("data:image")) return rawSource;
    return paidDNVoucherImg || historyPaidDnImg;
  };

  const isCoaSundryJobOrderApprovedHistoryView = (hist) =>
    hist &&
    Number(hist.applicationProgressId) === 9 &&
    Number(hist.objectionStatus) === 0;

  const isCoaSundryJobOrderSubmittedHistoryView = (hist) =>
    hist &&
    Number(hist.applicationProgressId) === 8 &&
    Number(hist.objectionStatus) === 0;

  const isCoaReadyForBillingApprovedHistoryView = (hist) =>
    hist &&
    Number(hist.applicationProgressId) === 10 &&
    Number(hist.objectionStatus) === 0;

  const loadCoaDemandNoteDataForHistory = async (applicationId) => {
    if (!applicationId) return;
    try {
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      myHeaders.append("Content-Type", "application/json");

      const response = await fetch(
        cfpBaseUrl + "changeOfAttributes/getDemandNoteData",
        {
          method: "POST",
          headers: myHeaders,
          body: JSON.stringify({ applicationId }),
          redirect: "follow",
        }
      );
      const result = await response.json();
      if (result.status === "200" && result.data?.[0]) {
        setDnApproveStep(result.data[0]);
        setDnDets(result.data[0]);
      }
    } catch (error) { /* ignored */ }
  };

  const isCoaRevertToFieldSurveyHistoryView = (hist) => {
    if (
      !hist ||
      Number(hist.applicationProgressId) !== 4 ||
      Number(hist.objectionStatus) !== 0
    ) {
      return false;
    }
    if (isCoaArrearVerificationHistoryView(hist)) return false;
    if (isCoaRevertToDocumentsVerificationHistoryView(hist)) return false;
    if (
      String(hist.remarks || "")
        .toLowerCase()
        .includes("field survey objection removed")
    ) {
      return false;
    }
    return true;
  };

  const syncCoaWiringTestReportFlags = (hist) => {
    if (!hist) return;
    const historyWiringFlag = hist.wiringTestReportDocumentFlag;
    let resolvedFlag = null;

    if (
      historyWiringFlag === 1 ||
      historyWiringFlag === -1 ||
      historyWiringFlag === 2 ||
      historyWiringFlag === "1" ||
      historyWiringFlag === "-1" ||
      historyWiringFlag === "2"
    ) {
      resolvedFlag = Number(historyWiringFlag);
    } else if (
      Number(hist.applicationProgressId) === 2 &&
      Number(hist.objectionStatus) === 1
    ) {
      resolvedFlag = null;
    } else if (
      Number(hist.applicationProgressId) === 2 &&
      Number(hist.objectionStatus) === 2
    ) {
      resolvedFlag = 2;
    }

    setFlag_wiringTestReport(resolvedFlag);
    setWiringTestReportObjectionRemarks(
      getCoaWiringTestReportDocumentRemarks(hist, resolvedFlag)
    );
  };

  const getCoaWiringTestReportDocumentRemarks = (
    row = dialogRowData,
    flagOverride = flag_wiringTestReport
  ) => {
    const flagRaw =
      flagOverride !== null && flagOverride !== undefined && flagOverride !== ""
        ? flagOverride
        : row?.wiringTestReportDocumentFlag;
    const flag =
      flagRaw === null || flagRaw === undefined || flagRaw === ""
        ? null
        : Number(flagRaw);

    const localRemarks = wiringTestReportObjectionRemarks || "";
    const serverRemarks =
      row?.wiringTestReportDocumentObjectionRemarks ||
      row?.wiringTestReportDocumentRemarks ||
      "";

    // After Accept/Reject (before submit), local flag/remarks must win
    if (flag === 1) {
      return localRemarks || "Verified";
    }
    if (flag === -1) {
      return localRemarks || serverRemarks || "";
    }

    const storedRemarks = localRemarks || serverRemarks || "";
    const isReuploaded =
      flag === 2 ||
      Number(row?.objectionStatus) === 2 ||
      String(storedRemarks).toLowerCase().includes("reupload") ||
      String(row?.remarks || "").toLowerCase().includes("reupload");

    if (isReuploaded) {
      return storedRemarks || "Reuploaded";
    }

    return storedRemarks;
  };

  const resolveCoaWiringTestReportFlag = (
    flagOverride = flag_wiringTestReport
  ) => {
    const resolved =
      flagOverride ?? dialogRowData?.wiringTestReportDocumentFlag;
    if (resolved === null || resolved === undefined || resolved === "") {
      return null;
    }
    return Number(resolved);
  };

  const getCoaWiringTestReportDisplayFlag = (
    flagOverride = flag_wiringTestReport
  ) => {
    if (
      flagOverride !== null &&
      flagOverride !== undefined &&
      flagOverride !== "" &&
      (Number(flagOverride) === 1 || Number(flagOverride) === -1)
    ) {
      return Number(flagOverride);
    }

    const serverFlag = dialogRowData?.wiringTestReportDocumentFlag;
    if (serverFlag === null || serverFlag === undefined || serverFlag === "") {
      return null;
    }

    const normalizedServer = Number(serverFlag);
    if (normalizedServer === 1 || normalizedServer === -1) {
      return normalizedServer;
    }

    return 0;
  };

  const getCoaDocVerificationCardClass = (flagValue) => {
    const normalizedFlag =
      flagValue === null || flagValue === undefined || flagValue === ""
        ? null
        : Number(flagValue);

    if (normalizedFlag === 1) {
      return "doc-verification-card doc-verification-card--verified";
    }
    if (normalizedFlag === -1) {
      return "doc-verification-card doc-verification-card--rejected";
    }
    if (normalizedFlag === 0 || normalizedFlag === 2) {
      return "doc-verification-card doc-verification-card--pending";
    }
    return "doc-verification-card";
  };

  /** Accept(1)/Reject(-1) only — null/0/2 (reupload pending) is not actionable yet. */
  const hasCoaDocumentActionTaken = (flagValue) => {
    const normalized = Number(flagValue);
    return normalized === 1 || normalized === -1;
  };

  const isCoaDocumentVerificationReadyToSubmit = () => {
    const requiredReady =
      hasCoaDocumentActionTaken(flag_applicantCNICFront) &&
      hasCoaDocumentActionTaken(flag_applicantCNICBack) &&
      hasCoaDocumentActionTaken(flag_owenershipDocument) &&
      hasCoaDocumentActionTaken(flag_electricityBillDocument);

    const tariff = String(dialogRowData?.newTariff || "").replace("-", "");
    const needsFbr = tariff.startsWith("A2") || tariff.startsWith("B");
    if (needsFbr) {
      return requiredReady && hasCoaDocumentActionTaken(flag_fbrDocument);
    }
    return requiredReady;
  };

  const getCoaWiringTestObjectionCardFlag = () => {
    if (!newWiringTestReportDocumentThumbnail) {
      return -1;
    }
    if (flag_wiringTestReport === 1 || flag_wiringTestReport === -1) {
      return flag_wiringTestReport;
    }
    return 0;
  };

  const shouldShowCoaWiringTestObjectionStatusIcon = () =>
    Boolean(newWiringTestReportDocumentThumbnail) &&
    (flag_wiringTestReport === 1 || flag_wiringTestReport === -1);

  const openCoaStepLabelPopup = async (stepLabel, hist) => {
    const label = String(stepLabel || "").trim();
    if (!label) return false;

    let data = hist ?? dialogRowData;
    closeAllCoaDocumentVerifyPopups();

    const isDocumentsVerifiedLabel =
      label === "Document Verification" ||
      label === "DOCUMENT VERIFICATION" ||
      label === "Documents Verified" ||
      label === "DOCUMENTS VERIFIED";

    if (isDocumentsVerifiedLabel) {
      const applicationDocs = await getDocumentApi(dialogRowData.applicationId);
      data = mergeCoaHistoryDocuments(data, applicationDocs);
    }

    setHistoryData(data);
    applyCoaHistoryViewFlags(data);

    if (
      data.applicationProgressId == 0
    ) {
      setApplicationSubmittedPopUp(true);
      return true;
    }
    if (
      label === "Document Verification" ||
      label === "DOCUMENT VERIFICATION" ||
      label === "Documents Verified" ||
      label === "DOCUMENTS VERIFIED"
    ) {
      setDocumentsVerifiedSubPopUp(true);
      return true;
    }
    if (label === "Wiring Test Report" || label === "WIRING TEST REPORT") {
      setDocumentsVerifiedSubPopUp(true);
      return true;
    }
    if (
      label === "Arrear Verification" ||
      label === "ARREAR VERIFICATION"
    ) {
      setArrearVerifiedSubPopUp(true);
      return true;
    }
    if (label === "Field Survey" || label === "FIELD SURVEY" || label === "Estimation") {
      await callAsyncGetConsentImage(dialogRowData.applicationId);
      setFieldSurveyedSubPopUp(true);
      return true;
    }
    if (label === "DN Approval" || label === "DN APPROVAL") {
      await callAsyncDnDetailsAPI(dialogRowData.applicationId);
      setDnApprovalSubPopUp(true);
      return true;
    }
    if (label === "DN Submission" || label === "DN SUBMISSION") {
      await callAsyncGetPaidDnImageAPI(dialogRowData.applicationId);
      setDnPaymentSubmittedSubPopUp(true);
      return true;
    }
    if (
      label === "DN Payment Verification" ||
      label === "DN PAYMENT VERIFICATION"
    ) {
      setDnPaymentVerifiedSubPopUp(true);
      return true;
    }
    if (
      label === "Sundary Jobs Order" ||
      label === "SUNDARY JOBS ORDER" ||
      label === "Sundry Job Order" ||
      label === "SUNDRY JOB ORDER" ||
      label === "Sundry Jobs Order" ||
      label === "SUNDRY JOBS ORDER"
    ) {
      await loadCoaDemandNoteDataForHistory(dialogRowData.applicationId);
      setServiceConnectionOrderedSubPopUp(true);
      return true;
    }
    if (
      label === "Ready for Billing" ||
      label === "READY FOR BILLING"
    ) {
      setReadyForBillingSubPopUp(true);
      return true;
    }
    return false;
  };

  const tryOpenCoaHistoryDetailPopup = (hist, historyRow) => {
    if (!hist || !historyRow) return false;

    const mergedHistoryData = mergeCoaHistoryData(hist, historyRow);
    setHistoryData(mergedHistoryData);
    applyCoaHistoryViewFlags(mergedHistoryData);

    if (isCoaApplicationRevertedHistoryView(mergedHistoryData)) {
      setCoaApplicationRevertedSubPopUp(true);
      return true;
    }

    if (
      historyRow.applicationProgressId == 1 &&
      historyRow.objectionStatus == 1
    ) {
      setDocumentsVerifiedSubPopUp(true);
      return true;
    }
    if (
      hist.applicationProgressId == 1 &&
      historyRow.objectionStatus != 1 &&
      historyRow.remarks !== "Revert to Documents Verification"
    ) {
      setApplicationSubmittedPopUp(true);
      return true;
    }
    if (
      hist.applicationProgressId == 1 &&
      historyRow.objectionStatus != 1 &&
      historyRow.remarks === "Revert to Documents Verification"
    ) {
      setApplicationSubmittedPopUp(true);
      return true;
    }
    if (hist.applicationProgressId == 2) {
      setDocumentsVerifiedSubPopUp(true);
      return true;
    }
    if (
      hist.applicationProgressId == 3 &&
      historyRow.objectionStatus != 1 &&
      historyRow.remarks !== "Revert to Arrear Verification"
    ) {
      setDocumentsVerifiedSubPopUp(true);
      return true;
    }
    if (
      hist.applicationProgressId == 3 &&
      historyRow.objectionStatus != 1 &&
      historyRow.remarks === "Revert to Arrear Verification"
    ) {
      setDocumentsVerifiedSubPopUp(true);
      return true;
    }
    if (
      hist.applicationProgressId == 1 &&
      historyRow.objectionStatus == 2
    ) {
      setDocumentsVerifiedSubPopUp(true);
      return true;
    }
    if (hist.applicationProgressId == 3 && historyRow.objectionStatus == 1) {
      setArrearVerifiedSubPopUp(true);
      return true;
    }
    if (
      hist.applicationProgressId == 4 &&
      Number(historyRow.objectionStatus) === 0 &&
      (historyRow.remarks === "Arrears Verified" ||
        String(historyRow.remarks || "")
          .toLowerCase()
          .includes("arrears verified"))
    ) {
      setArrearVerifiedSubPopUp(true);
      return true;
    }
    if (
      hist.applicationProgressId == 4 &&
      Number(historyRow.objectionStatus) === 0 &&
      isCoaRevertToDocumentsVerificationRemarks(
        getCoaHistoryRemarksText(mergedHistoryData)
      )
    ) {
      setApplicationSubmittedPopUp(true);
      return true;
    }
    if (
      hist.applicationProgressId == 4 &&
      Number(historyRow.objectionStatus) === 0
    ) {
      setFieldSurveyedSubPopUp(true);
      return true;
    }
    if (
      hist.applicationProgressId == 4 &&
      historyRow.objectionStatus != 1 &&
      historyRow.remarks === "Field Survey Objection Removed."
    ) {
      setFieldSurveyedSubPopUp(true);
      return true;
    }
    if (hist.applicationProgressId == 4 && historyRow.objectionStatus == 1) {
      setFieldSurveyedSubPopUp(true);
      return true;
    }
    if (
      hist.applicationProgressId == 5 &&
      Number(historyRow.objectionStatus) === 0
    ) {
      setFieldSurveyedSubPopUp(true);
      return true;
    }
    if (hist.applicationProgressId == 6) {
      setDnApprovalSubPopUp(true);
      return true;
    }
    if (hist.applicationProgressId == 7) {
      setDnPaymentSubmittedSubPopUp(true);
      return true;
    }
    if (hist.applicationProgressId == 8) {
      setDnPaymentVerifiedSubPopUp(true);
      return true;
    }
    if (
      hist.applicationProgressId == 9 &&
      Number(historyRow.objectionStatus) === 0
    ) {
      setServiceConnectionOrderedSubPopUp(true);
      return true;
    }
    if (
      hist.applicationProgressId == 10 &&
      Number(historyRow.objectionStatus) === 0
    ) {
      setReadyForBillingSubPopUp(true);
      return true;
    }
    return false;
  };

  const isCoaApplicationUpdatedRemarks = (row) =>
    String(row?.remarks || "")
      .toLowerCase()
      .includes("application updated");

  const shouldOpenCoaApplicationUpdatedPopUp = (historyRow, tableRow) => {
    if (!historyRow || typeof historyRow !== "object") return false;
    if (!isCoaApplicationUpdatedRemarks(historyRow)) return false;
    if (!getCoaHistoryId(historyRow)) return false;

    if (isCoaApplicationUpdatedAllowedProgress(historyRow)) return true;

    const stepLabel = String(
      tableRow?.stepName || historyRow?.coaProgStatusName || ""
    ).toLowerCase();
    return (
      stepLabel.includes("document") ||
      stepLabel.includes("wiring") ||
      stepLabel.includes("arrear") ||
      stepLabel.includes("field survey") ||
      stepLabel.includes("dn approval")
    );
  };

  const tableColumnsProcessingSummary = [
    {
      header: "Step Name",
      accessorKey: "stepName",
    },
    {
      header: "Processed By",
      accessorKey: "processedBy",
    },
    {
      header: "Date",
      accessorKey: "date",
    },
    {
      header: "Remarks",
      accessorKey: "remarks",
    },
  ];
  let batchArray = [
    "01",
    "02",
    "03",
    "04",
    "05",
    "06",
    "07",
    "08",
    "09",
    "10",
    "11",
    "12",
    "13",
    "14",
    "15",
    "16",
    "17",
    "18",
    "19",
    "20",
    "21",
    "22",
    "23",
    "24",
    "25",
    "27",
    "28",
    "29",
    "30",
    "31",
    "32",
    "33",
  ];
  const [tableDataProcessingSummary, setTableDataProcessingSummary] = useState([
    {
      stepName: "Application Submission",
      processedBy: "Akram",
      date: "24-Dec-2023",
      time: "02:23:19 AM",
      remarks: "-",
    },
    {
      stepName: "Application Submission",
      processedBy: "Akram",
      date: "24-Dec-2023",
      time: "02:23:19 AM",
      remarks: "-",
    },
    {
      stepName: "Application Submission",
      processedBy: "Akram",
      date: "24-Dec-2023",
      time: "02:23:19 AM",
      remarks: "-",
    },
    {
      stepName: "Application Submission",
      processedBy: "Akram",
      date: "24-Dec-2023",
      time: "02:23:19 AM",
      remarks: "-",
    },
  ]);

  const [arrearsDetails, setArrearsDetails] = useState({
    arrearsAmount: "",
    meterStatus: "",
    tariffDesc: "",
    meterType: "",
    phase: "",
    consumerName: "",
    consumerNo: "",
    consumerAddress: "",
    consumerEmail: "",
  });

  const [arrearsDetailsToDisplay, setArrearsDetailsToDisplay] = useState({
    refNo: "",
    arrearsAmount: "",
    meterStatus: "",
    tariffDesc: "",
    meterType: "",
    phase: "",
    consumerName: "",
    consumerNo: "",
    consumerAddress: "",
    consumerEmail: "",
    paidArearImage: "",
    paidArearDate: "",
  });

  const [consentImageDetails, setConsentImageDetails] = useState({
    consentImageChnageofName: "",
    consentImageChnageofNameFlag: "",
  });
  const [consentImagePopUp, setConsentImagePopUp] = useState(false);

  const [dnDetails, setDnDetails] = useState({
    demandNoticeNo: "",
    issueDate: "",
    applicationId: "",
    dueDate: "",
    roOfficeAddress: "",
    consumerAccountNo: "",
    batchNo: "",
    tariff: "",
    bankName: "",
    industryFactoryType: null,
    connectionAccountNo: "",
    dnPaymentFlag: null,
    paymentMethod: null,
    dnPaymentVerificationFlag: null,
    previousSecurity: null,
    sanctionLoad: "",
    filledBy: null,
    filledDate: "",
    filledFlag: null,
    approvedBy: null,
    approvedDate: null,
    approvedFlag: null,
    connectionCatagoryType: null,
    dNamount: null,
  });

  const [sjoDetails, setSjoDetails] = useState({
    subDivisionCode: null,
    sCONo: "",
    scoCreationDate: "",
    applicationId: "",
    applicationSubmissionDate: null,
    accountNo: null,
    feederNo: null,
    batch: null,
    applicantNewName: null,
    applicantOldTariff: null,
    applicantOldLoad: null,
    applicantNewTariff: null,
    applicantNewLoad: null,
    applicationType: null,
    mobileNo: null,
    date: null,
    materNo: null,
    cNICNo: null,
    securityDepositDNNo: null,
    dNCreationDate: null,
    ammountOfSecurityDeposit: null,
    dNPaymentDate: null,
    ammountOfCapitalCost: 0,
    capitalCostPaymentDate: null,
    filledBy: null,
    filledDate: null,
    filledFlag: null,
    approvedBy: null,
    approvedDate: null,
    approvedFlag: null,
  });

  const [masterDataFormDetails, setMasterDataFormDetails] = useState({
    applicationId: "",
    electricityDuty: "",
    governmentDepartment: "",
    standardClassificationCode: "",
    incomeTax: "",
    reason: "",
    authority: "",
    filledBy: "",
    filledByDate: "",
    filledByFlag: "",
    approvedBy: "",
    approvalDate: "",
    approvalFlag: "",
  });

  const [scoDetails, setScoDetails] = useState({
    scoId: "",
    applicationId: "",
    scoCreationDate: "",
    urbanRural: "",
    fataPata: "",
    refNo: "",
    feederNo: "",
    batch: "",
    subBatch: "",
    fGovt: "",
    cantonmentBoard: "",
    pGovt: "",
    localBodies: "",
    scoP1FilledBy: "",
    scoP1FillingDate: "",
    scoP1FillFlag: "",
    authorizedByName: "",
    dateOfAuthorization: "",
    scoP1ApprovedFlag: "",
    storeRequisitionNo: "",
    storeRequisitionDate: "",
    seasonalFlag: "",
    senctionLoad: "",
    noOfACs: "",
    noOfMeters: "",
    noOfMeterSets: "",
    noOfSubSets: "",
    noOfSupplyPoints: "",
    installedTransformerCapacity: "",
    meterId: "",
    meterNo: "",
    locationCode: "",
    meterCode: "",
    manufacturerCode: "",
    multiplyingFactor: "",
    meterRange: "",
    meterReading: "",
    dateOfConnection: "",
    cp78ItemNo: "",
    tieUpNonTieUp: "",
    sealOnMeter: "",
    sealOnBox: "",
    securitySlipOrPriceBondNo: "",
    connectionInstallerName: "",
    scoP2FilledBy: "",
    scoP2FillingDate: "",
    scoP2FillFlag: "",
    scoP2ApprovedBy: "",
    scoP2ApprovalDate: "",
    scoP2ApprovalFlag: "",
    installedMeterImage: "",
    meterType: null,
    threePhasePeak: null,
    threePhaseOffPeak: null,
    mdi: null,
    noOfMDIreset: null,
    cT: "",
    pT: "",
    threePhasePeakKVARH: "",
    threePhaseOffPeakKVARH: "",
    threePhasePeakKWH: "",
    threePhaseOffPeakKWH: "",
  });

  const [viewBackdrop, setViewBackdrop] = useState(false);

  const documentObjections = [
    -"Applicant CNIC document doesn't matches the entered applicant CNIC number.",
    "Owner CNIC document doesn't matches the entered owner CNIC.",
    "Invalid applicant CNIC document attached.",
    "Invalid owner CNIC document attached.",
    "Invalid property document attached.",
    "Invalid owner NOC attached.",
    "Others",
  ];

  const fieldObjections = [
    "Unelectrified area / No Lt network.",
    "Meters already installed at applied premisies.",
    "Invalid address.",
    "Premises / Property is disputed or sub judice.",
    "Load at site exceeds than applied.",
    "No load / building at site.",
    "Transformer overloaded",
    "Others",
  ];
  let subBatchArray = [
    "01",
    "02",
    "03",
    "04",
    "05",
    "06",
    "07",
    "08",
    "09",
    "10",
    "11",
    "12",
    "13",
    "14",
    "15",
    "16",
    "17",
    "18",
    "19",
    "20",
    "21",
    "22",
    "23",
    "24",
    "25",
    "26",
    "27",
    "28",
    "29",
    "30",
    "31",
    "32",
    "33",
    "34",
    "35",
    "36",
    "37",
    "38",
    "39",
    "40",
    "41",
    "42",
    "43",
    "44",
    "45",
    "46",
  ];
  const [copyOfApplicantCNICVerifyPopUp, setCopyOfApplicantCNICVerifyPopUp] =
    useState(false);
  const [preOwnerCNICVerifyPopUp, setPreOwnerCNICVerifyPopUp] = useState(false);
  const [owenershipDocumentVerifyPopUp, setOwenershipDocumentVerifyPopUp] =
    useState(false);
  const [
    electricityBillDocumentVerifyPopUp,
    setElectricityBillDocumentVerifyPopUp,
  ] = useState(false);
  const [fbrDocumentVerifyPopUp, setFbrDocumentVerifyPopUp] = useState(false);
  const [paidBillPopUp, setPaidBillPopUp] = useState(false);

  const [perOwenerNOCVerifyPopUp, setPerOwenerNOCVerifyPopUp] = useState(false);
  const [newOwenerAffidaviteVerifyPopUp, setNewOwenerAffidaviteVerifyPopUp] =
    useState(false);
  const [addDocCivicAuthorityVerifyPopUp, setAddDocCivicAuthorityVerifyPopUp] =
    useState(false);
  const [addDocAnyOtherVerifyPopUp, setAddDocAnyOtherVerifyPopUp] =
    useState(false);
  const [addDocCONConsentVerifyPopUp, setAddDocCONConsentVerifyPopUp] =
    useState(false);

  const [flag_applicantCNICFront, setFlag_applicantCNICFront] = useState(null);
  const [flag_applicantCNICBack, setFlag_applicantCNICBack] = useState(null);
  const [flag_owenershipDocument, setFlag_owenershipDocument] = useState(null);
  const [flag_electricityBillDocument, setFlag_electricityBillDocument] =
    useState(null);
  const [flag_fbrDocument, setFlag_fbrDocument] = useState(null);

  const [flag_preOwnerCNICFront, setFlag_PreOwnerCNICFront] = useState(null);
  const [flag_preOwnerCNICBack, setFlag_PreOwnerCNICBack] = useState(null);
  const [flag_perOwenerNOC, setFlag_perOwenerNOC] = useState(null);
  const [flag_newOwenerAffidavite, setFlag_newOwenerAffidavite] =
    useState(null);
  const [flag_addDocCivicAuthority, setFlag_addDocCivicAuthority] =
    useState(null);
  const [flag_addDocAnyOther, setFlag_addDocAnyOther] = useState(null);
  const [flag_addCONConsent, setFlag_addDocCONConsent] = useState(null);
  const [manufacturerCode, setManufcaturerCode] = useState({
    code: null,
    name: "",
  });
  const manufacturesList = [
    { code: 1, name: "General Electric" },
    { code: 10, name: "Climax" },
    { code: 11, name: "Escorts" },
    { code: 12, name: "Schlumburger France" },
    { code: 13, name: "CHINA" },
    { code: 14, name: "TIP" },
    { code: 15, name: "RUSSIAN" },
    { code: 16, name: "BULGARIA" },
    { code: 17, name: "BRAZIL" },
    { code: 18, name: "GANZ" },
    { code: 19, name: "BELGIUM" },
    { code: 2, name: "Westinghouse" },
    { code: 20, name: "SWITZERLAND" },
    { code: 21, name: "KRIZIK" },
    { code: 22, name: "HITACHI" },
    { code: 23, name: "ISKARA" },
    { code: 24, name: "ELGMA(TOU)" },
    { code: 25, name: "USA(TOD)" },
    { code: 26, name: "SABEECO" },
    { code: 27, name: "MICRO TECH" },
    { code: 28, name: "ETHOPIA" },
    { code: 29, name: "LETHIANIA" },
    { code: 3, name: "Landis & Gyr" },
    { code: 30, name: "M.T.I Micro Tech" },
    { code: 31, name: "SBEEC" },
    { code: 32, name: "Hexing(China)" },
    { code: 33, name: "Creative Electronics" },
    { code: 34, name: "Elektromed" },
    { code: 35, name: "J n P" },
    { code: 36, name: "TRANSFAB" },
    { code: 37, name: "HAMEED" },
    { code: 38, name: "ELEMATIC" },
    { code: 39, name: "TRANSPAK" },
    { code: 4, name: "Aeg" },
    { code: 40, name: "NECOPE" },
    { code: 41, name: "TRANSFOPOWER" },
    { code: 42, name: "IRAN" },
    { code: 43, name: "ACE INDIGO" },
    { code: 44, name: "PAN POWER" },
    { code: 45, name: "AB AMPERRE" },
    { code: 46, name: "POWER TECH" },
    { code: 47, name: "J.F.INDUSTRIES" },
    { code: 48, name: "KBK" },
    { code: 49, name: "M / S HAMMAD" },
    { code: 5, name: "Siemens" },
    { code: 50, name: "M / S NATIONAL" },
    { code: 51, name: "M / S IMS" },
    { code: 52, name: "ACCURATE COMPANY" },
    { code: 53, name: "VERTEX STATIC" },
    { code: 54, name: "ELSTER" },
    { code: 55, name: "RECLAIMED" },
    { code: 56, name: "KAIFA" },
    { code: 57, name: "XJ" },
    { code: 58, name: "CHINT" },
    { code: 59, name: "PEL" },
    { code: 6, name: "GEC" },
    { code: 7, name: "Ferranti" },
    { code: 8, name: "Mitsubishi" },
    { code: 9, name: "Syed Bhais" },
  ];
  // Dropdown companies list
  const companies = [
    { code: "11", name: "LESCO", logo: LESCODDLOGO },
    { code: "12", name: "GEPCO", logo: GEPCODDLOGO },
    { code: "13", name: "FESCO", logo: FESCODDLOGO },
    { code: "14", name: "IESCO", logo: IESCODDLOGO },
    { code: "15", name: "MEPCO", logo: MEPCODDLOGO },
    { code: "26", name: "PESCO", logo: PESCODDLOGO },
    { code: "27", name: "HAZECO", logo: HAZECODDLOGO },
    { code: "37", name: "HESCO", logo: HESCODDLOGO },
    { code: "38", name: "SEPCO", logo: SEPCODDLOGO },
    { code: "48", name: "QESCO", logo: QESCODDLOGO },
    { code: "59", name: "TESCO", logo: TESCODDLOGO },
  ];

  // Selected officeCode state
  const [selectedOfficeCode, setSelectedOfficeCode] = useState(
    getInitialAdminOfficeCode(code, selectedAdminCompanyCode),
  );

  useEffect(() => {
    if (String(code) === "10" && selectedAdminCompanyCode) {
      setSelectedOfficeCode(String(selectedAdminCompanyCode));
    }
  }, [code, selectedAdminCompanyCode]);
  const [foundInCON, setFoundInCON] = useState();
  const { state, pathname } = useLocation();
  const foundId = state && typeof state === "object" ? state.foundId : undefined;

  //#endregion
  useEffect(() => {
    const myHeaders = new Headers();
    myHeaders.append("Authorization", token);

    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(
      cfpBaseUrl + "changeOfAttributes/getChangeOfAttributesLookupData",
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (result.status === "200") {
          setLookUpDataOfCON(result.data);
        }
      })
      .catch(() => { });
  }, [token, cfpBaseUrl]);

  useEffect(() => {
    setPartialValue(dialogRowData.subDivisionCode);
  }, [dialogRowData]);

  useEffect(() => {
    if (props.showTable && currentPath == "/change-of-attributes-table") {
      dispatch(
        fetchPaginatedChangeOfAttributesOverdue({
          page: currentPageOverdue,
          pageSize: pageSizeOverdue,
          dateFrom: dateFromOverdue,
          dateTo: dateToOverdue,
          applicationProgressId: applicationProgressIdOverdue,
          objectionStatus: objectionStatusOverdue,
          officeCode: selectedOfficeCode || code,
        })
      );
    }
  }, [
    currentPageOverdue,
    pageSizeOverdue,
    dateFromOverdue,
    dateToOverdue,
    applicationProgressIdOverdue,
    objectionStatusOverdue,
    selectedOfficeCode,
  ]);

  useEffect(() => {
    if (props.showTable && currentPath == "/change-of-attributes-table") {
      if (token) {
        dispatch(
          fetchPaginatedChangeOfAttributesNormal({
            page: currentPageNormal,
            pageSize: pageSizeNormal,
            dateFrom: dateFromNormal,
            dateTo: dateToNormal,
            applicationProgressId: applicationProgressIdNormal,
            objectionStatus: objectionStatusNormal,
            officeCode: selectedOfficeCode || code,
          })
        );
      }
    }
  }, [
    currentPageNormal,
    pageSizeNormal,
    dateFromNormal,
    dateToNormal,
    applicationProgressIdNormal,
    objectionStatusNormal,
    selectedOfficeCode,
  ]);

  // useEffect(() => {
  //   if (props.showTable && currentPath == "/change-of-attributes-table") {
  //     setViewBackdrop(true);
  //     dispatch(
  //       fetchPaginatedChangeOfAttributesNormal({
  //         page: currentPageNormal,
  //         pageSize: pageSizeNormal,
  //         dateFrom: dateFromNormal,
  //         dateTo: dateToNormal,
  //         applicationProgressId: applicationProgressIdNormal,
  //         objectionStatus: objectionStatusNormal,
  //         officeCode: selectedOfficeCode || code,
  //       })
  //     );
  //   }
  // }, []);
  //#region formiks

  const filterOptions = (options, { inputValue }, fields = []) => {
    const trimmedInputValue = inputValue.trim().toLowerCase();
    const inputLength = trimmedInputValue.length;
    let count = 0;

    return inputLength === 0
      ? options
      : options.filter((option) => {
        const optionLabel = fields
          .map((field) => option[field])
          .join("")
          .toLowerCase();

        const containsInput = optionLabel.includes(trimmedInputValue);
        const match = containsInput && count < 5;
        if (match) {
          count += 1;
        }
        return match;
      });
  };

  const arearsFormik = useFormik({
    initialValues,
    validationSchema: Yup.object().shape({
      iv_property_reference_no: Yup.string()
        .required("Enter the reference number to get arrear details.")
        .min(14, "Enter 14 digit reference number.")
        .max(14, "Enter 14 digit reference number."),
    }),
    onSubmit: async (values, { resetForm }) => {
      setViewBackdrop(true);
      try {
        var formdata = new FormData();
        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);
        formdata.append("refNo", values.iv_property_reference_no);
        formdata.append("arrearAmount", arrearsDetails.arrearsAmount);
        formdata.append("meterStatus", arrearsDetails.meterStatus);
        formdata.append("tariff", arrearsDetails.tariffDesc);
        formdata.append("meterType", arrearsDetails.meterType);
        formdata.append("phase", arrearsDetails.phase);
        formdata.append("consumerName", arrearsDetails.consumerName);
        formdata.append("consumerPhoneNo", arrearsDetails.consumerNo);
        formdata.append("consumerEmail", arrearsDetails.consumerEmail);
        formdata.append("consumerAddress", arrearsDetails.consumerAddress);
        formdata.append("applicationNo", dialogRowData.applicationId);

        var requestOptions = {
          method: "POST",
          body: formdata,
          headers: myHeaders,
          redirect: "follow",
        };

        const response = await fetch(cfpBaseUrl + "comman/insertArrear", requestOptions);
        const result = await response.json();

        if (result.status === "200") {
          if (arrearsDetails.arrearsAmount !== "") {
            await callChangeObjectionStatus(
              "Arrears Verification",
              1,
              "Arrears Objection"
            );
            setArrearsEntryPopUpOpen(false);
            setViewBackdrop(false);
          } else {
            await callChangeObjectionStatus(
              "Arrears Verification",
              0,
              "Arrears Objection Removed",
              "-",
              false
            );
            await callArrearVerificationAPI(
              dialogRowData.applicationId,
              dialogRowData.applicationProgressId + 1,
              0,
              "Arrears Verified",
              "Arrears Verified"
            );
            resetForm();
            setArrearsEntryPopUpOpen(false);
            setOpen(false);
          }
        } else {
          setError("Arrears objection submission failed!");
          setViewBackdrop(false);
        }
      } catch (error) {
        setViewBackdrop(false);
      }
    },
  });

  const fieldFormik = useFormik({
    initialValues,
    validationSchema: Yup.object().shape({
      iv_batch: Yup.mixed().when(["iv_batch_change", "iv_objection_Type"], {
        is: (iv_batch_change, iv_objection_Type) =>
          iv_batch_change === true ||
          iv_batch_change === "true" ||
          iv_objection_Type === "5" ||
          iv_objection_Type === 5,
        then: (schema) => schema.required("Select batch."),
        otherwise: (schema) => schema.notRequired(),
      }),

      iv_reference_to_allot: Yup.string().when(
        ["iv_batch_change", "iv_objection_Type"],
        {
          is: (iv_batch_change, iv_objection_Type) =>
            iv_batch_change === true ||
            iv_batch_change === "true" ||
            iv_objection_Type === "5" ||
            iv_objection_Type === 5,
          then: (schema) =>
            schema
              .required("Enter reference no. to allot.")
              .min(7, `Reference no. can't be < 7 digits.`)
              .max(7, `Reference no. can't > 7 digits.`)
              .matches(/^[0-9]+$/, "Enter reference no. as 0123456"),
          otherwise: (schema) => schema.notRequired(),
        }
      ),
      iv_remarks_others: Yup.string().when(["iv_objection_Type"], {
        is: (iv_objection_Type) =>
          iv_objection_Type === "6" || iv_objection_Type === 6,
        then: (schema) =>
          schema
            .required("Enter remarks.")
            .min(10, "Remarks must be at least 10 characters long."),
        otherwise: (schema) => schema.notRequired(),
      }),

      iv_sub_batch: Yup.mixed().when("iv_batch_change", {
        is: true,
        then: (schema) => schema.required("Select sub batch."),
        otherwise: (schema) => schema.notRequired(),
      }),

      iv_sketch_diagram: Yup.mixed().when("iv_material_required", {
        is: (iv_material_required) => iv_material_required === true,
        then: Yup.mixed().required("Upload the sketch diagram."),
        otherwise: Yup.mixed().optional(),
      }),
    }),
    onSubmit: async (values, { resetForm }) => {
      if (values.iv_objection_Type == 1) {
        if (boqItems.length == 0 && values.iv_material_required === true) {
          setErrormessageBoqEstimation(
            "Please add BOQ items before submitting."
          );
          return;
        }

        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);
        myHeaders.append("Content-Type", "application/json");

        const raw = JSON.stringify({
          areaType: values.iv_area_type,
          tariff:
            dialogRowData.changeOfAttributesType == 3 ||
              dialogRowData.changeOfAttributesType == 4 ||
              dialogRowData.changeOfAttributesType == 6 ||
              dialogRowData.changeOfAttributesType == 7
              ? dialogRowData.newTariff?.replace(/-/g, "")
              : dialogRowData.currentTariff?.replace(/-/g, ""),
          connectionType:
            dialogRowData.changeOfAttributesType == 3 ||
              dialogRowData.changeOfAttributesType == 4 ||
              dialogRowData.changeOfAttributesType == 6 ||
              dialogRowData.changeOfAttributesType == 7
              ? (dialogRowData.newConnectionType ?? dialogRowData.connectionType)
              : dialogRowData.connectionType,
          sanctionLoad:
            dialogRowData.changeOfAttributesType == 2 ||
              dialogRowData.changeOfAttributesType == 4 ||
              dialogRowData.changeOfAttributesType == 5 ||
              dialogRowData.changeOfAttributesType == 7
              ? dialogRowData.newSanctionLoad
              : dialogRowData.currentSanctionLoad,
          applicationId: dialogRowData.applicationId,
        });

        const requestOptions = {
          method: "POST",
          headers: myHeaders,
          body: raw,
          redirect: "follow",
        };

        fetch(
          cfpBaseUrl + "changeOfAttributes/costEstimationForCOA",
          requestOptions
        )
          .then((response) => response.json())
          .then((result) => {
            if (result.status == "200" && result.data?.[0]) {
              setCostEstimationForNC(result.data[0]);
              setErrormessageCostEstimation("");
              setShowCostEstimation(true);
            } else {
              showCoaWorkflowResult(
                result.message || "Cost estimation failed. Please try again.",
                "error"
              );
            }
          })
          .catch(() => {
            showCoaWorkflowResult(
              "Something went wrong. Please try again.",
              "error"
            );
          });
      } else {
        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);
        myHeaders.append("Content-Type", "application/json");

        const raw = JSON.stringify({
          applicationId: dialogRowData.applicationId,
          applicationProgressId: dialogRowData.applicationProgressId,
          objectionStatus: 1,
          remarks: "Field Surveyed with Objection.",
          remarksDetail:
            values.iv_objection_Type == 6
              ? values.iv_remarks_others
              : "Field Surveyed with Objection.",
          sketchDiagram: "",
          observationType: values.iv_objection_Type,
          alreadyInstalledRefNo:
            fieldFormik.values.iv_objection_Type == "5"
              ? fieldFormik.values.iv_batch +
              partialValue +
              fieldFormik.values.iv_reference_to_allot
              : "",
          isMaterialRequired: "",
          isMeterNeedsToBeReplaced: "",
          submittedThrough: "e-Operation",
          areaType: "",
          tariff: "",
          sanctionLoad: "",
          bankName: "",
          isBatchChangeRequired: "",
          batchNo: "",
          subBatchNo: "",
          connectionAccountNo: "",
          amountOfGridSharing: "",
          amountOfFeederRehab: "",
          civilWorkCharges: "",
          fixedChargesOfMetering: "",
          miscellaneousCharges: "",
          lessTheCost: "",
          capitalCostAmount: "",
          securityDepositAmount: "",
          meterType: "",
          BoQItems: [],
          seasonalFlag: "",
        });

        const requestOptions = {
          method: "POST",
          headers: myHeaders,
          body: raw,
          redirect: "follow",
        };

        fetch(
          cfpBaseUrl +
          "changeOfAttributes/saveFieldSurveyAndCostEstimateForCOA",
          requestOptions
        )
          .then((response) => response.json())
          .then((result) => {
            setShowCostEstimation(false);
            if (result.status === "200") {
              completeCoaWorkflowStep(
                result.message || "Field survey saved successfully."
              );
            } else {
              completeCoaWorkflowStep(
                result.message || "Failed to save field survey.",
                "error"
              );
            }
          })
          .catch(() => { });
      }
    },
  });

  const fieldRemoveObjectionFormik = useFormik({
    enableReinitialize: true, // ensures it reacts to changes
    initialValues: {
      iv_additional_civic_document: "",
      iv_remarks: "",
    },
    validationSchema: Yup.object({
      iv_additional_civic_document: Yup.string().when([], {
        is: () => fieldFormik?.values?.iv_objection_Type == "4",
        then: (schema) =>
          schema.required("Please upload civic authority document."),
        otherwise: (schema) => schema.notRequired(),
      }),
      iv_remarks: Yup.string()
        .min(10, "Minimum 10 characters required.")
        .max(300, "Maximum 300 characters allowed.")
        .required("Please enter remarks."),
    }),
    onSubmit: async (values) => {
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      myHeaders.append("Content-Type", "application/json");

      const raw = JSON.stringify({
        applicationId: dialogRowData.applicationId,
        applicationProgressId: dialogRowData.applicationProgressId,
        objectionStatus: 0,
        remarks: "Field Survey Objection Removed.",
        remarksDetail: values.iv_remarks,
        submittedThrough: "e-Operation",
        civicAuthorityDocs:
          fieldFormik.values.iv_objection_Type == "4"
            ? additionalCivicDocumentThumbnail
            : "",
      });

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      await fetch(
        cfpBaseUrl + "changeOfAttributes/romeveCOAFieldSurveyObjecton",
        requestOptions
      )
        .then((response) => response.json())
        .then((result) => {
          if (result.status === "200") {
            fieldRemoveObjectionFormik.resetForm({
              values: {
                iv_additional_civic_document: "",
                iv_remarks: "",
              },
            });
            setAdditionalCivicDocument("");
            setAdditionalCivicDocumentThumbnail("");
            setAdditionalCivicDocumentError("");
            completeCoaWorkflowStep(
              result.message || "Field survey objection removed successfully."
            );
          } else {
            showCoaWorkflowResult(
              result.message || "Failed to remove field survey objection.",
              "error"
            );
          }
        })
        .catch(() => { });
    },
  });

  const scoPart1Formik = useFormik({
    initialValues,
    validationSchema: Yup.object().shape({
      iv_store_requisition_no: Yup.string()
        .required("Store Requisition No. is required")
        .test(
          "check-iv_store_requisition_no",
          "Store Requisition No. must be 6 digits",
          function (value) {
            const { dialogRowData } = this.options.context;
            const appId = dialogRowData?.applicationId || "";
            const status = dialogRowData?.status;
            if (appId.slice(3, 5) === "13") {
              return true;
            }

            if (status === "Approved") {
              return !!value && value.length === 6;
            }
            return true;
          }
        ),

      iv_store_requisition_date: dialogRowData?.storeRequisitionDate
        ? Yup.string()
        : Yup.string().required("Store Requisition Date is required"),
      iv_sanctioned_load: Yup.number()
        .when([], {
          is: () => dialogRowData.connectionType === "Domestic",
          then: Yup.number()
            .min(2, "Load can't be less than 2.")
            .max(1000, "Residential Maximum Load 1000kW.")
            .required("Enter sanctioned load."),
        })
        .when([], {
          is: () => dialogRowData.connectionType === "Commercial",
          then: Yup.number()
            .min(2, "Load can't be less than 2.")
            .max(5000, "Commercial Maximum Load 5000kW.")
            .required("Enter sanctioned load."),
        })
        .when([], {
          is: () => dialogRowData.connectionType === "Industrial",
          then: Yup.number()
            .min(2, "Load can't be less than 2.")
            .required("Enter sanctioned load."),
        })
        .when([], {
          is: () => dialogRowData.connectionType === "Agriculture",
          then: Yup.number()
            .min(2, "Load can't be less than 2.")
            .max(5000, "Applied load cannot be more than 5000kW.")
            .required("Enter sanctioned load."),
        })
        .when([], {
          is: () =>
            [
              "Tubewell",
              "Temporary",
              "GeneralServices",
              "Electrification",
              "StreetLight",
              "CorporateCompany",
            ].includes(dialogRowData.connectionType),
          then: Yup.number()
            .min(2, "Load can't be less than 2.")
            .max(5000, "Applied load cannot be more than 5000kW.")
            .required("Enter sanctioned load."),
        })
        .required("Enter sanctioned load."),
      iv_seasonal_flag: Yup.mixed().when("phase", {
        is: () => phase != "Single Phase" || phase != "3 Phase",
        then: Yup.mixed().required("Select seasonal / non seasonal value."),
        otherwise: Yup.mixed().optional(),
      }),
      iv_meter_range: Yup.number("Range should be a number.")
        .min(4, "Range can't be less than 4.")
        .max(8, "Range can't be greater than 8.")
        .required("Enter meter range."),
      iv_meter_code1: Yup.string().when("phase", {
        is: () => phase != "Single Phase" && phase != "3 Phase", // Apply validations if phase is 'Three Phase'
        then: Yup.string()
          .matches(/^[0-9]{6}$/, "Code must be a 6-digit number.") // Ensure it's a 6-digit number
          .test(
            "valid-start",
            "The first two digits must be 00, 01, 02, 03, 04, or 05.",
            (value) => {
              if (!value) return false; // Ensure value exists
              const firstTwoDigits = parseInt(value.substring(0, 2), 10);
              return [0, 1, 2, 3, 4, 5].includes(firstTwoDigits);
            }
          )
          .test(
            "validate-3rd-digit",
            "The 3rd digit must be 0, 1, 2.",
            (value) => {
              if (!value) return false; // Ensure value exists
              const thirdDigit = parseInt(value.substring(2, 3), 10);
              return [0, 1, 2].includes(thirdDigit);
            }
          )
          .test(
            "validate-4th-digit",
            "The 4th digit must be 1, 2, 6, 7.",
            (value) => {
              if (!value) return false; // Ensure value exists
              const fourthDigit = parseInt(value.substring(3, 4), 10);
              return [1, 2, 6, 7].includes(fourthDigit);
            }
          )
          .test(
            "last-digits",
            "The last 2 digits must be 00, 02, 03, 04, 05, 06, 07, 08, 09, 10, 11, 12, 13.",
            (value) => {
              if (!value) return false; // Ensure value exists
              const lastDigits = parseInt(value.substring(4), 10);
              return [0, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13].includes(
                lastDigits
              );
            }
          )
          .test(
            "single-phase-code",
            "Code can't be of single phase.",
            (value) => {
              if (!value) return false;
              return value != "000002";
            }
          )
          .test(
            "three-phase-code",
            "Code can't be of 3 phase (whole current).",
            (value) => {
              if (!value) return false;
              return value != "050502" || value != "050602";
            }
          )
          .required("Enter meter code."),
        otherwise: Yup.string()
          .oneOf(
            ["000002", "050502"],
            "For Single Phase, the meter code must be 000002."
          )
          .required("Enter meter code."),
      }),
      iv_meter_code2: Yup.string().when("phase", {
        is: () => phase != "Single Phase" && phase != "3 Phase",
        then: Yup.string()
          .matches(/^[0-9]{6}$/, "Code must be a 6-digit number.") // Ensure it's a 6-digit number
          .test(
            "valid-start",
            "The first two digits must be 00, 01, 02, 03, 04, or 05.",
            (value) => {
              if (!value) return false; // Ensure value exists
              const firstTwoDigits = parseInt(value.substring(0, 2), 10);
              return [0, 1, 2, 3, 4, 5].includes(firstTwoDigits);
            }
          )
          .test(
            "validate-3rd-digit",
            "The 3rd digit must be 0, 1, 2.",
            (value) => {
              if (!value) return false; // Ensure value exists
              const thirdDigit = parseInt(value.substring(2, 3), 10);
              return [0, 1, 2].includes(thirdDigit);
            }
          )
          .test(
            "validate-4th-digit",
            "The 4th digit must be 1, 2, 6, 7.",
            (value) => {
              if (!value) return false; // Ensure value exists
              const fourthDigit = parseInt(value.substring(3, 4), 10);
              return [1, 2, 6, 7].includes(fourthDigit);
            }
          )
          .test(
            "last-digits",
            "The last 2 digits must be 00, 02, 03, 04, 05, 06, 07, 08, 09, 10, 11, 12, 13.",
            (value) => {
              if (!value) return false; // Ensure value exists
              const lastDigits = parseInt(value.substring(4), 10);
              return [0, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13].includes(
                lastDigits
              );
            }
          )
          .test(
            "single-phase-code",
            "Code can't be of single phase.",
            (value) => {
              if (!value) return false;
              return value != "000002";
            }
          )
          .test(
            "three-phase-code",
            "Code can't be of 3 phase (whole current).",
            (value) => {
              if (!value) return false;
              return value != "050502" || value != "050602";
            }
          )
          .required("Enter meter code."),
        otherwise: Yup.string().optional().nullable(),
      }),
      iv_transformer_code: Yup.string().optional(),
      iv_transformer_refNo: Yup.string().when("$userCompany", {
        is: (val) => val !== "13", // Compare as string
        then: Yup.string()
          .required("Transformer reference no is required.")
          .min(14, "Please enter 14 digit transformer reference no.")
          .max(14, "Please enter 14 digit transformer reference no.")
          .matches(
            /^[0-9]+$/,
            "Enter 14 digit transformer reference no as 01234567891234"
          ),
        otherwise: Yup.string() // optional if userCompany is '13'
          .min(14, "Please enter 14 digit transformer reference no.")
          .max(14, "Please enter 14 digit transformer reference no.")
          .matches(
            /^[0-9]+$/,
            "Enter 14 digit transformer reference no as 01234567891234"
          )
          .optional(),
      }),

      iv_location_code: Yup.mixed().required("Select location."),
      iv_manufacturer_code: Yup.string().required("Select Manufacturer."),
      // iv_meter_serial_no: Yup.string()
      //   .required('Enter meter number.')
      //   .min(7, 'Meter no. should be 7 digits.')
      //   .max(15, 'Meter no. should be 15 digits.')
      //   .matches(/^[0-9]+$/, "Meter no. should be number only.")
      //   .when('iv_manufacturer_code', (iv_manufacturer_code, schema) => {
      //     return schema.test(
      //       'starts-with-manufacturer-code',
      //       'Meter number should start with the manufacturer code.',
      //       (value) => value && value.startsWith(iv_manufacturer_code.toString())
      //     )
      //   }
      //   ),
      // iv_meter_serial_no: Yup.string()
      //   .required('Enter meter number.')
      //   .length(10, 'Meter number should be exactly 10 digits.')
      //   .matches(/^\d{10}$/, 'Meter number should contain digits only.')
      //   .when('iv_manufacturer_code', (iv_manufacturer_code, schema) => {
      //     return schema.test(
      //       'starts-with-manufacturer-code',
      //       'Meter number should start with the manufacturer code.',
      //       (value) =>
      //         value &&
      //         iv_manufacturer_code &&
      //         value.startsWith(iv_manufacturer_code.toString())
      //     );
      //   }),
      iv_meter_serial_no: Yup.string()
        .required("Enter Meter serial no.")
        .length(10, "Meter serial no. should be exactly 10 digits.")
        .matches(/^\d{10}$/, "Meter serial no. should contain digits only."),

      // iv_sim_number: Yup.string().when([], {
      //   is: () => scoDetails?.meterType === 1 || scoDetails?.meterType === "1",
      //   then: (schema) =>
      //     schema
      //       .required('Enter SIM number.')
      //       .matches(/^03[0-9]{9}$/, 'SIM number must start with 03 and be 11 digits total.'),
      //   otherwise: (schema) => schema.notRequired(),
      // }),

      // iv_sim_ID: Yup.string().when([], {
      //   is: () => scoDetails?.meterType === 1 || scoDetails?.meterType === "1",
      //   then: (schema) =>
      //     schema
      //       .required('Enter SIM ID.')
      //       .min(18, 'SIM ID should be at least 18 characters.')
      //       .max(20, 'SIM ID should not exceed 20 characters.'),
      //   otherwise: (schema) => schema.notRequired(),
      // }),
      iv_sim_number: Yup.string()
        .nullable()
        .when([], {
          is: () =>
            scoDetails?.meterType !== 0 && scoDetails?.meterType !== "0",
          then: (schema) =>
            schema
              .required("Enter SIM number.")
              .matches(
                /^03[0-9]{9}$/,
                "SIM number must start with 03 and be 11 digits total."
              ),
          otherwise: (schema) => schema.notRequired(),
        }),

      iv_sim_ID: Yup.string()
        .nullable()
        .when([], {
          is: () =>
            scoDetails?.meterType !== 0 && scoDetails?.meterType !== "0",
          then: (schema) =>
            schema
              .required("Enter SIM ID.")
              .min(18, "SIM ID should be at least 18 characters.")
              .max(20, "SIM ID should not exceed 20 characters."),
          otherwise: (schema) => schema.notRequired(),
        }),

      iv_meter_reading: Yup.string().when("phase", {
        is: () => phase === "Single Phase",
        then: Yup.string()
          .max(9, "Meter reading can not be more than 999999999.")
          .min(1, "Meter reading can not be less than 1.")
          .required("Enter meter reading.")
          .matches(/^[0-9]+$/, "Enter meter reading in numbers."),
        otherwise: Yup.string().optional(),
      }),
      iv_meter_reading_peak_kwh: Yup.string().when("phase", {
        is: () => phase != "Single Phase",
        then: Yup.string()
          .required("Enter peak reading.")
          .test(
            "is-decimal",
            "Enter peak reading in numbers with up to 3 decimal places.",
            (value) => /^[0-9]+(\.[0-9]{1,3})?$/.test(value)
          ),
        otherwise: Yup.string().optional().nullable(),
      }),
      iv_meter_reading_off_peak_kwh: Yup.string().when("phase", {
        is: () => phase != "Single Phase",
        then: Yup.string()
          .required("Enter off peak reading.")
          .test(
            "is-decimal",
            "Enter off peak reading in numbers with up to 3 decimal places.",
            (value) => /^[0-9]+(\.[0-9]{1,3})?$/.test(value)
          ),
        otherwise: Yup.string().optional().nullable(),
      }),
      iv_meter_reading_peak_kvarh: Yup.string().when("phase", {
        is: () => phase != "Single Phase" && phase != "3 Phase",
        then: Yup.string()
          .required("Enter peak reading.")
          .test(
            "is-decimal",
            "Enter peak reading in numbers with up to 3 decimal places.",
            (value) => /^[0-9]+(\.[0-9]{1,3})?$/.test(value)
          ),
        otherwise: Yup.string().optional().nullable(),
      }),
      iv_meter_reading_off_peak_kvarh: Yup.string().when("phase", {
        is: () => phase != "Single Phase" && phase != "3 Phase",
        then: Yup.string()
          .required("Enter peak reading.")
          .test(
            "is-decimal",
            "Enter off peak reading in numbers with up to 3 decimal places.",
            (value) => /^[0-9]+(\.[0-9]{1,3})?$/.test(value)
          ),
        otherwise: Yup.string().optional().nullable(),
      }),
      iv_date_of_connection: Yup.date()
        .max(new Date(), "Connection date must be in the past.")
        .required("Enter connection date."),
      iv_connection_installer_name: Yup.string()
        .required("Enter installed by name.")
        .max(30, "Name should be less than 30 characters."),
      iv_installed_meter_image: Yup.mixed().when("scoDetails.scoP2FillFlag", {
        is: () => {
          return (
            scoDetails?.scoP2FillFlag === 0 ||
            scoDetails?.scoP2FillFlag === "" ||
            scoDetails?.scoP2FillFlag === null
          );
        },
        then: Yup.mixed().required("Upload meter image."),
        otherwise: Yup.mixed().optional(),
      }),
      iv_meter_type: Yup.mixed().required("Select meter type!"),
      iv_ct_nom: Yup.string().when("phase", {
        is: () => phase !== "Single Phase" && phase !== "3 Phase",
        then: Yup.string()
          .required("Enter CT Nom.")
          .matches(
            /^[1-9]\d*$/,
            "Enter CT Nom in whole numbers greater than 0."
          )
          .test(
            "is-positive",
            "CT Nom must be greater than 0.",
            (value) => parseFloat(value) > 0
          )
          .test(
            "ct-standard-values",
            "The CT Nom must be 100, 200, 300, 400, 600, 800, 1000.",
            (value) => {
              if (!value) return false; // Ensure value exists
              const ctNom = parseInt(value, 10);
              return [100, 200, 300, 400, 600, 800, 1000].includes(ctNom);
            }
          ),
        otherwise: Yup.string().optional().nullable(),
      }),
      iv_ct_denom: Yup.string().when("phase", {
        is: (phase) => phase !== "Single Phase" && phase !== "3 Phase",
        then: Yup.string()
          .required("Enter CT Denom.")
          .matches(
            /^[1-9]\d*$/,
            "Enter CT Denom in whole numbers greater than 0."
          )
          .test(
            "is-positive",
            "CT Denom must be greater than 0.",
            (value) => parseFloat(value) > 0
          )
          .test(
            "is-less-than-nom",
            "CT Denom must be less than CT Nom.",
            function (value) {
              const { iv_ct_nom } = this.parent; // Access sibling field
              if (!iv_ct_nom || !value) return true; // Skip validation if either value is missing
              return (
                (iv_ct_nom == 1 && value == 1) ||
                parseInt(value, 10) < parseInt(iv_ct_nom, 10)
              );
            }
          ),
        otherwise: Yup.string().optional().nullable(),
      }),
      iv_pt_nom: Yup.string().when("phase", {
        is: () => phase !== "Single Phase" && phase !== "3 Phase",
        then: Yup.string()
          .required("Enter PT Nom.")
          .matches(
            /^[1-9]\d*$/,
            "Enter PT Nom in natural numbers greater than 0."
          )
          .test(
            "is-positive",
            "PT Denom must be greater than 0.",
            (value) => parseFloat(value) > 0
          )
          .test(
            "is-less-than-nom",
            "PT Denom must be less than PT Nom.",
            function (value) {
              const { iv_pt_nom } = this.parent; // Access sibling field
              if (!iv_pt_nom || !value) return true; // Skip validation if either value is missing
              return parseInt(value, 10) >= parseInt(iv_pt_nom, 10);
            }
          ),
        otherwise: Yup.string().optional().nullable(),
      }),
      iv_pt_denom: Yup.string().when("phase", {
        is: () => phase !== "Single Phase" && phase !== "3 Phase",
        then: Yup.string()
          .required("Enter PT Nom.")
          .matches(
            /^[1-9]\d*$/,
            "Enter PT Denom in natural numbers greater than 0."
          )
          .test(
            "is-positive",
            "PT Nom must be greater than 0.",
            (value) => parseFloat(value) > 0
          ),
        otherwise: Yup.string().optional().nullable(),
      }),
      iv_mdi: Yup.string().when("phase", {
        is: () => phase != "Single Phase" && phase != "3 Phase",
        then: Yup.string()
          .required("Enter PT Denom.")
          .matches(/^[1-9]\d*$/, "Enter PT Denom in numbers greater than 0.")
          .test(
            "is-positive",
            "PT Denom must be greater than 0.",
            (value) => parseFloat(value) > 0
          ),
        otherwise: Yup.string().optional().nullable(),
      }),
      iv_no_of_mdi_resets: Yup.string().when("phase", {
        is: () => phase != "Single Phase" && phase != "3 Phase",
        then: Yup.string()
          .max(5, "No. of MDI reset can not be more than 99999.")
          .min(1, "No. of MDI reset can not be less than 1.")
          .required("Enter No. of MDI reset.")
          .matches(/^[0-9]+$/, "Enter No. of MDI reset in numbers."),
        otherwise: Yup.string().optional().nullable(),
      }),
    }),
    onSubmit: async (values, { resetForm }) => {
      setViewBackdrop(true);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      myHeaders.append("Content-Type", "application/json");

      const raw = JSON.stringify({
        applicationId: dialogRowData.applicationId,
        objectionStatus: 0,
        applicationProgressId: 8,
        remarks: "Meter Installed on premises.",
        remarksDetail: "Meter Installed on premises.",
        scoFillFlag: 1,
        scoApprovalFlag: 0,
        storeRequisitionNo: values.iv_store_requisition_no,
        storeRequisitionDate: values.iv_store_requisition_date,
        seasonalFlag: values.iv_seasonal_flag,
        senctionLoad: values.iv_sanctioned_load,
        installedTransformerCapacity: values.iv_transformer_code,
        transformerRefNo: values.iv_transformer_refNo,
        meterNo: values.iv_meter_serial_no,
        locationCode: values.iv_location_code,

        meterCode1: values.iv_meter_code1,
        meterCode2: values.iv_meter_code2,
        manufacturerCode: values.iv_manufacturer_code,
        multiplyingFactor:
          phase != "Single Phase" && phase != "3 Phase"
            ? calculateMF(
              values.iv_ct_nom,
              values.iv_ct_denom,
              values.iv_pt_nom,
              values.iv_pt_denom
            )
            : "",
        meterRange: values.iv_meter_range,
        meterReading: phase === "Single Phase" ? values.iv_meter_reading : "",
        dateOfConnection: values.iv_date_of_connection,
        installedMeterImage: installedMeterImageThumbnail,

        cT:
          phase != "Single Phase" && phase != "3 Phase"
            ? values.iv_ct_nom / values.iv_ct_denom
            : "",
        cTD:
          phase != "Single Phase" && phase != "3 Phase"
            ? values.iv_ct_denom
            : "",
        cTN:
          phase != "Single Phase" && phase != "3 Phase" ? values.iv_ct_nom : "",
        pT:
          phase != "Single Phase" && phase != "3 Phase"
            ? values.iv_pt_nom / values.iv_pt_denom
            : "",
        pTD:
          phase != "Single Phase" && phase != "3 Phase"
            ? values.iv_pt_denom
            : "",
        pTN:
          phase != "Single Phase" && phase != "3 Phase" ? values.iv_pt_nom : "",
        threePhasePeakKVARH:
          phase != "Single Phase" && phase != "3 Phase"
            ? values.iv_meter_reading_peak_kvarh
            : "",
        threePhaseOffPeakKVARH:
          phase != "Single Phase" && phase != "3 Phase"
            ? values.iv_meter_reading_off_peak_kvarh
            : "",
        threePhasePeakKWH:
          phase != "Single Phase" && phase != "3 Phase"
            ? values.iv_meter_reading_peak_kwh
            : "",
        threePhaseOffPeakKWH:
          phase != "Single Phase" && phase != "3 Phase"
            ? values.iv_meter_reading_off_peak_kwh
            : "",
        connectionInstallerName: values.iv_connection_installer_name,
        meterType: values.iv_meter_type,
        threePhasePeak:
          phase === "3 Phase" ? values.iv_meter_reading_peak_kwh : "",
        threePhaseOffPeak:
          phase === "3 Phase" ? values.iv_meter_reading_off_peak_kwh : "",
        mdi: phase != "Single Phase" && phase != "3 Phase" ? values.iv_mdi : "",
        noOfMDIreset:
          phase != "Single Phase" && phase != "3 Phase"
            ? values.iv_no_of_mdi_resets
            : "",
        simId: values.iv_sim_ID,
        simNumber: values.iv_sim_number,
        submittedThrough: "e-Operation",
      });
      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      fetch(cfpBaseUrl + "changeOfAttributes/processSCO", requestOptions)
        .then((response) => response.json())
        .then((result) => {
          if (result.status === "200") {
            openCoaResponseModal(
              result.message || "Service connection order processed successfully."
            );
          } else {
            openCoaResponseModal(
              result.message || "Unexpected error occurred.",
              { isError: true }
            );
          }
        })
        .catch(() => { });
    },
  });

  const EditFbrDocument = (event) => {
    if (event.target.files) {
      const newFileName =
        "fbrDocument." + event.target.files[0].name.split(".").pop();
      handleFileUpload(
        event,
        () => { },
        setEditFbrDocument,
        setEditFbrDocumentError,
        setEditFbrDocumentThumbnail,
        newFileName
      );
    }
  };

  const EditWiringTestReportDocument = (event) => {
    const file = event.target.files?.[0];
    if (!file) return;

    const maxSize = 2 * 1024 * 1024;
    if (file.size > maxSize) {
      setEditWiringTestReportError("File size exceeds 2MB limit.");
      setEditWiringTestReportDocument("");
      setEditWiringTestReportThumbnail("");
      event.target.value = "";
      return;
    }

    const documentValidate = documentValidation(file, maxSize);
    if (documentValidate !== 1) {
      setEditWiringTestReportError(
        documentValidate === 2
          ? "File size exceeds 2MB limit."
          : "Invalid file type. Only JPG, PNG, and PDF are allowed.",
      );
      setEditWiringTestReportDocument("");
      setEditWiringTestReportThumbnail("");
      event.target.value = "";
      return;
    }

    const reader = new FileReader();
    reader.onloadend = () => {
      setEditWiringTestReportDocument(file.name);
      setEditWiringTestReportThumbnail(reader.result);
      setEditWiringTestReportError("");
      setEditWiringTestReportCleared(false);
    };
    reader.onerror = () => {
      setEditWiringTestReportError("Failed to read file. Please try again.");
      setEditWiringTestReportDocument("");
      setEditWiringTestReportThumbnail("");
      event.target.value = "";
    };
    reader.readAsDataURL(file);
  };

  const AdditionalCivicDocument = (event) => {
    if (event.target.files && event.target.files[0]) {
      const file = event.target.files[0];
      const newFileName =
        "additionalCivicDocument." + file.name.split(".").pop();

      const uploaded = handleFileUpload(
        event,
        fieldRemoveObjectionFormik.handleChange,
        setAdditionalCivicDocument,
        setAdditionalCivicDocumentError,
        setAdditionalCivicDocumentThumbnail,
        newFileName
      );

      if (uploaded === true) {
        setAdditionalCivicDocumentError("");
        fieldRemoveObjectionFormik.setFieldValue(
          "iv_additional_civic_document",
          newFileName
        );
        fieldRemoveObjectionFormik.setFieldError(
          "iv_additional_civic_document",
          undefined
        );
      } else {
        fieldRemoveObjectionFormik.setFieldValue(
          "iv_additional_civic_document",
          ""
        );
        setAdditionalCivicDocument("");
        setAdditionalCivicDocumentThumbnail("");
      }
    }
  };

  const clearAdditionalCivicDocument = () => {
    setAdditionalCivicDocument("");
    setAdditionalCivicDocumentThumbnail("");
    setAdditionalCivicDocumentError("");
    fieldRemoveObjectionFormik.setFieldValue("iv_additional_civic_document", "");
    fieldRemoveObjectionFormik.setFieldError(
      "iv_additional_civic_document",
      undefined
    );
    fieldRemoveObjectionFormik.setFieldTouched(
      "iv_additional_civic_document",
      false
    );
    const fileInput = document.getElementById("iv_additional_civic_document");
    if (fileInput) {
      fileInput.value = "";
    }
  };

  const handleRemoveFieldSurveyObjection = async () => {
    const needsCivicDoc = fieldFormik.values.iv_objection_Type == "4";

    if (needsCivicDoc && !additionalCivicDocumentThumbnail?.trim()) {
      setAdditionalCivicDocumentError((prev) =>
        prev?.trim()
          ? prev
          : "Please upload civic authority document."
      );
    } else {
      setAdditionalCivicDocumentError("");
    }

    const errors = await fieldRemoveObjectionFormik.validateForm();
    fieldRemoveObjectionFormik.setTouched({
      iv_remarks: true,
      iv_additional_civic_document: needsCivicDoc,
    });

    if (needsCivicDoc && !additionalCivicDocumentThumbnail?.trim()) {
      return;
    }

    if (Object.keys(errors).length === 0) {
      fieldRemoveObjectionFormik.handleSubmit();
    }
  };

  const getTariffAndMeterType = async (
    appliedLoad,
    connectionType,
    seasonalNonSeasonal,
    tariffs,
    applicationProgressId
  ) => {
    let phase = "";
    if (connectionType === "Industrial") {
      if (seasonalNonSeasonal == 1) {
        const seasonalTariff = tariffs.find((item) => item.tariffCode === "F");
        if (seasonalTariff) {
          setTariff(seasonalTariff.tariffName || "");
          if (applicationProgressId === 5) {
            fieldFormik.values.iv_tariff_to_allot =
              seasonalTariff.tariffName || "";
          }
        } else {
          setTariff("");
        }
        if (appliedLoad <= 500) {
          setPhase("MDI (LT)(CT)");
          phase = "MDI (LT)(CT)";
        } else if (appliedLoad > 500) {
          setPhase("MDI (HT)(CT/PT)");
          phase = "MDI (HT)(CT/PT)";
        }
      } else if (seasonalNonSeasonal == 0 || !seasonalNonSeasonal) {
        let shortListedTariffsArray = tariffs.filter(
          (item) => item.consumerType === connectionType
        );
        shortListedTariffsArray = shortListedTariffsArray.filter(
          (item) =>
            parseInt(item.from) <= appliedLoad &&
            parseInt(item.to) > appliedLoad
        );
        let selectedTariff = shortListedTariffsArray[0];
        if (selectedTariff) {
          setTariff(selectedTariff.tariffName || "");
          if (applicationProgressId === 5) {
            fieldFormik.values.iv_tariff_to_allot =
              selectedTariff.tariffName || "";
          }
        } else {
          setTariff("");
        }
        if (appliedLoad <= 500) {
          setPhase("MDI (LT)(CT)");
          phase = "MDI (LT)(CT)";
        } else if (appliedLoad > 500) {
          setPhase("MDI (HT)(CT/PT)");
          phase = "MDI (HT)(CT/PT)";
        }
      }
    } else {
      if (appliedLoad && appliedLoad > 0 && tariffs) {

        let shortListedTariffsArray = tariffs.filter(
          (item) =>
            item.consumerType?.toLowerCase() === connectionType?.toLowerCase()
        );

        shortListedTariffsArray = shortListedTariffsArray.filter(
          (item) =>
            parseInt(item.from) <= appliedLoad &&
            parseInt(item.to) > appliedLoad
        );

        if (shortListedTariffsArray.length > 0) {
          setTariff(shortListedTariffsArray[0].tariffName);
          if (applicationProgressId === 5) {
            fieldFormik.values.iv_tariff_to_allot =
              shortListedTariffsArray[0].tariffName || "";
          }
          if (parseInt(appliedLoad) < 5) {
            setPhase("Single Phase");
            phase = "Single Phase";
          } else if (appliedLoad >= 5 && appliedLoad < 20) {
            setPhase("3 Phase");
            phase = "3 Phase";
          } else if (appliedLoad >= 20 && appliedLoad < 500) {
            setPhase("MDI (LT)(CT)");
            phase = "MDI (LT)(CT)";
          } else if (appliedLoad >= 500) {
            setPhase("MDI (HT)(CT/PT)");
            phase = "MDI (HT)(CT/PT)";
          }
        } else {
          setPhase("");
          phase = "";
          setTariff("");
        }
      }

    }
    return phase;
  };

  const hideInstalledMeterImageVerifyAlert = (x) => {
    setInstalledMeterImageVerifyPopUp(x);
  };

  const signedConsentImageFormik = useFormik({
    initialValues,
    validationSchema: Yup.object().shape({
      iv_signed_consent_image: Yup.mixed().when("consentVerificationFlag", {
        is: () => consentVerificationFlag === 1,
        then: Yup.mixed().required("Upload the signed consent image."),
        otherwise: Yup.mixed().optional(),
      }),
    }),
    onSubmit: async (values, { resetForm }) => {
      setViewBackdrop(true);
      var formdata = new FormData();
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      formdata.append(
        "consentImageChnageofName",
        signedConsentFormImageThumbnail
      );
      formdata.append("applicationId", dialogRowData.applicationId);

      var requestOptions = {
        method: "POST",
        body: formdata,
        headers: myHeaders,
        redirect: "follow",
      };

      await fetch(
        cfpBaseUrl + "changeOfName/uploadConsentFormForChangeOfName",
        requestOptions
      )
        .then((response) => response.json())
        .then((result) => {
          if (result.status === "200") {
            callArrearVerificationAPI(
              dialogRowData.applicationProgressId + 1,
              "Consent Uploaded",
              "",
              dialogRowData.applicationId
            );
          }
        })
        .catch(() => { });
      setViewBackdrop(false);
    },
  });

  const masterDataFormik = useFormik({
    initialValues,
    validationSchema: Yup.object().shape({
      iv_govt_dept: Yup.mixed().required("Select Govt Dept."),
      iv_ed_code: Yup.mixed().required("Select Electricity Duty code."),
      iv_standard_classification_code: Yup.mixed().required(
        "Select Std. classification code."
      ),
      iv_income_tax: Yup.mixed().required("Select Income tax value."),
      iv_authority: Yup.mixed().optional("Select Authority."),
    }),
    onSubmit: async (values, { resetForm }) => {
      var formdata = new FormData();
      formdata.append("applicationId", dialogRowData.applicationId);
      formdata.append("electricityDuty", masterDataFormik.values.iv_ed_code);
      formdata.append(
        "governmentDepartment",
        masterDataFormik.values.iv_govt_dept
      );
      formdata.append(
        "standardClassificationCode",
        masterDataFormik.values.iv_standard_classification_code
      );
      formdata.append("incomeTax", masterDataFormik.values.iv_income_tax);
      formdata.append("reason", "Change of Name");
      formdata.append("authority", "SDO");
      formdata.append("filledBy", userId);
      formdata.append("filledByFlag", 1);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);

      var requestOptions = {
        method: "POST",
        body: formdata,
        headers: myHeaders,
        redirect: "follow",
      };

      await fetch(
        cfpBaseUrl + "cpForm136/cpForm136DataInsertion",
        requestOptions
      )
        .then((response) => response.json())
        .then((result) => {
          if (result.status === "200") {
            if (masterDataFormDetails.filledByFlag === null) {
              resetForm();
              setOpen(false);
            } else {
              resetForm();
              setOpen(false);
            }
          } else {
          }
        })
        .catch(() => { });
    },
  });

  const arearBillDocumentFormik = useFormik({
    initialValues,
    validationSchema: Yup.object().shape({
      iv_arear_paid_bill_document: Yup.mixed().required(
        "Upload arears paid bill document!"
      ),
      iv_arear_paid_bill_date: Yup.string().required(
        "Enter date on which arears are paid!"
      ),
    }),
    onSubmit: async (values, { resetForm }) => {
      setViewBackdrop(true);
      try {
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        var raw = JSON.stringify({
          applicationId: dialogRowData.applicationId,
          paidBillDate: values.iv_arear_paid_bill_date,
          paidBillImage: arearPaidBillDocumentThumbnail,
        });

        var requestOptions = {
          method: "POST",
          headers: myHeaders,
          body: raw,
          redirect: "follow",
        };

        const response = await fetch(
          cfpBaseUrl + "comman/updateENCArearPaidBillImage",
          requestOptions
        );
        const result = await response.json();

        if (result.status === "200") {
          await callChangeObjectionStatus(
            "Arrears Verification",
            0,
            "Arrears Objection Removed",
            "-",
            false
          );
          await callArrearVerificationAPI(
            dialogRowData.applicationId,
            dialogRowData.applicationProgressId + 1,
            0,
            "Arrears Verified",
            "Arrears Verified"
          );
          resetForm();
        } else {
          setError(result.message);
          setViewBackdrop(false);
        }
      } catch (error) {
        setError(error);
        setViewBackdrop(false);
      }
    },
  });

  let CONStatusBarArray = [
    {
      title1: "DOCUMENT",
      title2: "SUBMISSION",
    },
    {
      title1: "DOCUMENT",
      title2: "VERIFICATION",
    },
    {
      title1: "WIRING TEST",
      title2: "REPORT",
    },
    {
      title1: "ARREAR",
      title2: "VERIFICATION",
    },
    {
      title1: "FIELD",
      title2: "SURVEY",
    },
    {
      title1: "DN",
      title2: "APPROVAL",
    },
    {
      title1: "DN",
      title2: "SUBMISSION",
    },
    {
      title1: "DN PAYMENT",
      title2: "VERIFICATION",
    },
    {
      title1: "SUNDARY",
      title2: "JOBS ORDER",
    },
    {
      title1: "READY FOR",
      title2: "BILLING",
    },
    {
      title1: "COMPLETED",
      title2: "",
    },
  ];
  const costEstimation = async (
    applicationId,
    referenceNo,
    applicationProgressId,
    objectionStatus,
    remarks,
    bankName,
    previousSecurityAmount,
    currentEstimatedSecurityAmount,
    totalEstimatedAmount
  ) => {

    setViewBackdrop(true);

    const myHeaders = new Headers();
    myHeaders.append("Authorization", token);
    myHeaders.append("Content-Type", "application/json");

    const raw = JSON.stringify({
      applicationId,
      referenceNo,
      applicationProgressId,
      objectionStatus,
      remarks,
      bankName,
      previousSecurityAmount,
      currentEstimatedSecurityAmount,
      totalEstimatedAmount,
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    try {
      const response = await fetch(
        cfpBaseUrl + "changeOfName/saveCostEstimateForCON",
        requestOptions
      );
      const result = await response.json();

      if (result.status === "200") {
        openCoaResponseModal(result.message || "Action completed successfully.");
      } else {
        openCoaResponseModal(
          result.message || "Unexpected error occurred.",
          { isError: true }
        );
      }
    } catch (error) {
      openCoaResponseModal("Something went wrong. Please try again.", {
        isError: true,
      });
    } finally {
      setViewBackdrop(false);
    }
  };

  const DNApproveAPI = async (
    applicationId,
    applicationProgressId,
    objectionStatus,
    remarks
  ) => {
    setViewBackdrop(true);

    const myHeaders = new Headers();
    myHeaders.append("Authorization", token);
    myHeaders.append("Content-Type", "application/json");

    const raw = JSON.stringify({
      applicationId: applicationId,
      applicationProgressId: applicationProgressId,
      objectionStatus: objectionStatus,
      remarks: "Demand Note Issued",
      remarksDetail: "Demand Note Issued",
      submittedThrough: "e-Operation",
    });
    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    try {
      const response = await fetch(
        cfpBaseUrl + "changeOfAttributes/approveDemandNote",
        requestOptions
      );
      const result = await response.json();

      if (result.status === "200") {
        openCoaResponseModal(result.message || "Demand note approved successfully.");
      } else {
        openCoaResponseModal(
          result.message || "Unexpected error occurred.",
          { isError: true }
        );
      }
    } catch (error) {
      openCoaResponseModal("Something went wrong. Please try again.", {
        isError: true,
      });
    } finally {
      setViewBackdrop(false);
    }
  };

  // DN Renewal API for expired demand notes
  const callDemandNoteRenewalAPI = async (applicationId) => {
    try {
      setViewBackdrop(true);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      myHeaders.append("Content-Type", "application/json");

      const raw = JSON.stringify({
        applicationId: applicationId,
        remarks: "DN Renewed.",
      });

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      await fetch(cfpBaseUrl + "changeOfAttributes/renewExpiredDN", requestOptions)
        .then((response) => response.json())
        .then((result) => {
          if (result.status === "200") {
            setShowDnExpiryPopup(false);
            completeCoaWorkflowStep(result.message || "Demand note renewed successfully.");
          } else {
            showCoaWorkflowResult(
              result.message || "Demand note renewal failed.",
              "error"
            );
          }
        })
        .catch(() => { });
    } catch (e) { /* ignored */ } finally {
      setViewBackdrop(false);
    }
  };

  const DNPaymentVerificationAPI = async (
    applicationId,
    applicationProgressId,
    objectionStatus,
    remarks,
    remarksDetails
  ) => {

    setViewBackdrop(true);

    const myHeaders = new Headers();
    myHeaders.append("Authorization", token);
    myHeaders.append("Content-Type", "application/json");

    const raw = JSON.stringify({
      applicationId: applicationId,
      objectionStatus: objectionStatus,
      applicationProgressId: applicationProgressId,
      remarks: remarks,
      remarksDetail: remarksDetails,
    });
    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    try {
      const response = await fetch(
        cfpBaseUrl + "changeOfAttributes/verifyOrRejectPaidDemandNote",
        requestOptions
      );
      const result = await response.json();

      if (result.status === "200") {
        openCoaResponseModal(result.message || "Demand note payment verified successfully.", {
          storeRequisitionNo:
            objectionStatus === 0 && result.storeRequisitionNo
              ? result.storeRequisitionNo
              : "",
        });
      } else {
        openCoaResponseModal(
          result.message || "Unexpected error occurred.",
          { isError: true }
        );
      }
    } catch (error) {
      openCoaResponseModal("Something went wrong. Please try again.", {
        isError: true,
      });
    } finally {
      setViewBackdrop(false); // Allow re-submission after completion
    }
  };

  const SundaryJobSubmissionAPI = async (
    applicationId,
    applicationProgressId,
    objectionStatus,
    remarks
  ) => {
    setViewBackdrop(true);

    const myHeaders = new Headers();
    myHeaders.append("Authorization", token);
    myHeaders.append("Content-Type", "application/json");

    const raw = JSON.stringify({
      applicationId: dialogRowData.applicationId,
      objectionStatus: 0,
      applicationProgressId: 8,
      remarks: "Sundry Job Order Submitted.",
      remarksDetail: "Sundry Job Order Submitted.",
      scoFillFlag: 1,
      scoApprovalFlag: 0,
      storeRequisitionNo: 0,
      storeRequisitionDate: "",
      seasonalFlag: 0,
      installedTransformerCapacity: "",
      meterNo: 0,
      locationCode: "",
      meterCode1: "",
      meterCode2: "",
      manufacturerCode: 0,
      multiplyingFactor: 0,
      meterRange: 0,
      meterReading: "",
      dateOfConnection: "",
      installedMeterImage: "",
      cT: 0,
      cTD: "",
      cTN: "",
      pT: 0,
      pTD: "0",
      pTN: "0",
      threePhasePeakKVARH: "",
      threePhaseOffPeakKVARH: "",
      threePhasePeakKWH: "",
      threePhaseOffPeakKWH: "",
      connectionInstallerName: "",
      threePhasePeak: "",
      threePhaseOffPeak: "",
      mdi: "",
      noOfMDIreset: "",
      simId: "",
      simNumber: "",
      transformerRefNo: "",
      submittedThrough: "e-Operation",
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(cfpBaseUrl + "changeOfAttributes/processSCO", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        setViewBackdrop(false);
        if (result.status === "200") {
          openCoaResponseModal(
            result.message || "Sundry job order submitted successfully."
          );
        } else {
          openCoaResponseModal(
            result.message || "Unexpected error occurred.",
            { isError: true }
          );
        }
      })
      .catch(() => { });
  };

  const InstalledMeterImage = (event) => {
    if (event.target.files) {
      const newFileName =
        "installedMeterImage." + event.target.files[0].name.split(".").pop();
      handleFileUpload(
        event,
        scoPart1Formik.handleChange,
        setInstalledMeterImage,
        setInstalledMeterImageError,
        setInstalledMeterImageThumbnail,
        newFileName
      );
      setInstalledMeterImageError("");
    }
  };

  const SundaryJobApprovalAPI = async () => {
    setViewBackdrop(true);

    const myHeaders = new Headers();
    myHeaders.append("Authorization", token);
    myHeaders.append("Content-Type", "application/json");

    const raw = JSON.stringify({
      applicationId: dialogRowData.applicationId,
      objectionStatus: 0,
      applicationProgressId: 9,
      remarks: "Sundry Job Order Approved.",
      remarksDetail: "Sundry Job Order Approved.",
      scoFillFlag: 1,
      scoApprovalFlag: 1,
      storeRequisitionNo: 0,
      storeRequisitionDate: "",
      seasonalFlag: 0,
      installedTransformerCapacity: "",
      meterNo: 0,
      locationCode: "",
      meterCode1: "",
      meterCode2: "",
      manufacturerCode: 0,
      multiplyingFactor: 0,
      meterRange: 0,
      meterReading: "",
      dateOfConnection: "",
      installedMeterImage: "",
      cT: 0,
      cTD: "",
      cTN: "",
      pT: 0,
      pTD: "0",
      pTN: "0",
      threePhasePeakKVARH: "",
      threePhaseOffPeakKVARH: "",
      threePhasePeakKWH: "",
      threePhaseOffPeakKWH: "",
      connectionInstallerName: "",
      threePhasePeak: "",
      threePhaseOffPeak: "",
      mdi: "",
      noOfMDIreset: "",
      simId: "",
      simNumber: "",
      transformerRefNo: "",
      submittedThrough: "e-Operation",
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(cfpBaseUrl + "changeOfAttributes/processSCO", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        setViewBackdrop(false);
        if (result.status === "200") {
          openCoaResponseModal(
            result.message || "Sundry job order approved successfully."
          );
        } else {
          openCoaResponseModal(
            result.message || "Unexpected error occurred.",
            { isError: true }
          );
        }
      })
      .catch(() => { });
  };

  const [openRemarksDialog, setOpenRemarksDialog] = useState(false);
  const [readyForBillingError, setReadyForBillingError] = useState("");

  const [odRemarks, setOdRemarks] = useState("");

  const processForBilling = () => {
    setOpenRemarksDialog(true);
  };

  // 🚪 Close popup
  const handleCloseRemarks = () => {
    setOpenRemarksDialog(false);
    setOdRemarks("");
    setRemarksError("");
    setReadyForBillingError("");
  };

  const handleSubmitRemarks = () => {
    if (odRemarks.trim().length < 10) {
      setRemarksError("Remarks must be at least 10 characters long.");
      return; // stops execution here ✅
    }

    const myHeaders = new Headers();
    myHeaders.append("Authorization", token);
    myHeaders.append("Content-Type", "application/json");

    const raw = JSON.stringify({
      applicationId: dialogRowData.applicationId,
      applicationProgressId: dialogRowData.applicationProgressId + 1,
      remarks: odRemarks,
      objectionStatus: 0,
      submittedThrough: "e-Operation",
      electricityDuty: 0,
      governmentDepartment: 0,
      standardClassificationCode: "0000",
      incomeTax: 0,
      reason: odRemarks,
      filledByFlag: 1,
      approvalFlag: 1,
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(cfpBaseUrl + "changeOfAttributes/processForBilling", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.status === "200") {
          setRemarksError("");
          setOpenRemarksDialog(false);
          setReadyForBillingError("");
          setOdRemarks("");
          completeCoaWorkflowStep(
            result.message || "Application processed for billing successfully."
          );
        } else {
          setReadyForBillingError(result.message);
          showCoaWorkflowResult(
            result.message || "Failed to process for billing.",
            "error"
          );
        }
      })
      .catch(() => { });
  };

  const dnPymentReceiptFormik = useFormik({
    initialValues,
    validationSchema: Yup.object().shape({
      iv_payment_date: Yup.date()
        .nullable()
        .typeError("Invalid payment date")
        .max(new Date(), "Payment date must be in the past!")
        .required("Payment date is required!"),
      iv_receipt_image: Yup.mixed().required(
        "Upload paid demand notice receipt image."
      ),
    }),
    onSubmit: async (values, { resetForm }) => {
      if (!dnReceiptImageThumbnail?.trim()) {
        setReceiptImageError("Upload paid demand notice receipt image.");
        return;
      }

      setViewBackdrop(true);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      myHeaders.append("Content-Type", "application/json");

      const raw = JSON.stringify({
        applicationId: dialogRowData.applicationId,
        applicationProgressId: dialogRowData.applicationProgressId + 1,
        objectionStatus: 0,
        remarks: "Demand Note Uploaded.",
        remarksDetail: "Demand Note Uploaded.",
        submittedThrough: "e-Operation",
        paymentDate: values.iv_payment_date,
        paidDNImage: dnReceiptImageThumbnail,
      });

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      try {
        const response = await fetch(
          cfpBaseUrl + "changeOfAttributes/uploadPaidDemandNote",
          requestOptions
        );
        const text = await response.text();
        let result = {};
        try {
          result = text ? JSON.parse(text) : {};
        } catch {
          setViewBackdrop(false);
          showCoaWorkflowResult(
            "Failed to upload demand note. Server returned an invalid response.",
            "error"
          );
          return;
        }

        resetForm();
        setDnReceiptImage();
        setDnReceiptImageThumbnail();
        setShowDNPayment(true);
        if (result.status === "200" || result.status === 200) {
          completeCoaWorkflowStep(
            result.message || "Demand note uploaded successfully."
          );
        } else {
          setViewBackdrop(false);
          showCoaWorkflowResult(
            result.message || "Failed to upload demand note.",
            "error"
          );
        }
      } catch {
        setViewBackdrop(false);
        showCoaWorkflowResult(
          "Failed to upload demand note. Please try again.",
          "error"
        );
      }
    },
  });

  const [thumbnail, setThumbnail] = useState("");

  const arrearPaymentReceiptFormik = useFormik({
    initialValues: {
      iv_arrear_paid_bill_document: "",
    },

    validationSchema: Yup.object().shape({
      iv_arrear_paid_bill_document: Yup.mixed()
        .required("Paid Bill Receipt is required.")
        .test(
          "file-present",
          "Paid Bill Receipt is required.",
          (value) => !!value
        ),
    }),

    onSubmit: (values) => {
      callArrearVerificationAPI(
        dialogRowData.applicationId,
        dialogRowData.applicationProgressId + 1,
        0,
        "Arrears Verified",
        "Arrears Verified"
      );
    },
  });

  const sjoFormik = useFormik({
    initialValues,
    validationSchema: Yup.object().shape({}),
    onSubmit: async (values, { resetForm }) => {
      var formdata = new FormData();

      formdata.append("applicationId", dialogRowData.applicationId);
      formdata.append("applicationSubmissionDate", dialogRowData.creationDate);
      formdata.append("accountNo", dialogRowData.referenceNumber);
      formdata.append("feederNo", "");
      formdata.append("batch", dialogRowData.referenceNumber.slice(0, 2));
      formdata.append("applicantNewName", dialogRowData.newName);
      formdata.append("applicantOldTariff", "");
      formdata.append("applicantOldLoad", "");
      formdata.append("applicantNewTariff", "");
      formdata.append("applicantNewLoad", "");
      formdata.append("applicationType", "3");
      formdata.append("mobileNo", dialogRowData.newPhone);
      formdata.append("date", "");
      formdata.append("materNo", "");
      formdata.append("cNICNo", dialogRowData.newCNIC);
      formdata.append("securityDepositDNNo", dnDetails.demandNoticeNo);
      formdata.append("dNCreationDate", dnDetails.issueDate);
      formdata.append("ammountOfSecurityDeposit", dnDetails.dNamount);
      formdata.append("dNPaymentDate", dnPaymentDate);
      formdata.append("ammountOfCapitalCost", 0);
      formdata.append("capitalCostPaymentDate", "");
      formdata.append("filledBy", userId);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);

      var requestOptions = {
        method: "POST",
        body: formdata,
        headers: myHeaders,
        redirect: "follow",
      };

      await fetch(cfpBaseUrl + "changeOfName/sjoDataInsertion", requestOptions)
        .then((response) => response.json())
        .then((result) => {
          if (result.status === "200") {
            callSJOApproveAPI(dialogRowData.applicationId);
            resetForm();
            setOpen(false);
          } else {
          }
        })
        .catch(() => { });
    },
  });

  const dnRejectFormik = useFormik({
    initialValues: {
      reasonType: "",
      remarks: "",
    },
    validationSchema: Yup.object({
      reasonType: Yup.string().required("Please select a reason."),
      remarks: Yup.string()
        .required("Remarks are required.")
        .min(10, "Remarks must be at least 10 characters long."),
    }),
    onSubmit: async (values, { resetForm }) => {
      try {
        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);
        myHeaders.append("Content-Type", "application/json");

        const raw = JSON.stringify({
          applicationId: dialogRowData.applicationId,
          objectionStatus: 0,
          applicationProgressId: values.reasonType,
          remarks: `Revert to ${values.reasonType == 3
            ? "Field Survey"
            : values.reasonType == 2
              ? "Arrear Verification"
              : "Documents Verification"
            }`,
          remarksDetail: values.remarks,
          submittedThrough: "e-Operation",
        });

        const requestOptions = {
          method: "POST",
          headers: myHeaders,
          body: raw,
          redirect: "follow",
        };

        fetch(
          cfpBaseUrl + "changeOfAttributes/revertApplication",
          requestOptions
        )
          .then((response) => response.json())
          .then((result) => {
            setDnRejectModalOpen(false);
            resetForm();
            if (result.status === "200") {
              completeCoaWorkflowStep(
                result.message || "Application reverted successfully."
              );
            } else {
              showCoaWorkflowResult(
                result.message || "Failed to revert application.",
                "error"
              );
            }
          })
          .catch(() => { });
      } catch (error) { /* ignored */ }
    },
  });

  const getCoaRevertStepLabel = (step) => {
    if (String(step) === "4") return "Field Survey";
    if (String(step) === "3") return "Arrear Verification";
    return "Documents Verification";
  };

  const objectionRevertFormik = useFormik({
    initialValues: {
      iv_objection_step: 4,
      iv_objection_Descripton: "",
    },
    validationSchema: Yup.object({
      iv_objection_step: Yup.number().required("Select a step."),
      iv_objection_Descripton: Yup.string()
        .required("Enter reason for rejection.")
        .min(10, "Reason should be between 10 to 200 characters!")
        .max(200, "Reason should be between 10 to 200 characters!"),
    }),
    onSubmit: async (values, { resetForm }) => {
      if (!dialogRowData?.applicationId) return;

      setViewBackdrop(true);

      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      myHeaders.append("Content-Type", "application/json");

      const raw = JSON.stringify({
        applicationId: dialogRowData.applicationId,
        objectionStatus: 0,
        applicationProgressId: values.iv_objection_step,
        remarks: `Revert to ${getCoaRevertStepLabel(values.iv_objection_step)}`,
        remarksDetail: values.iv_objection_Descripton,
        submittedThrough: "e-Operation",
      });

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      try {
        const response = await fetch(
          cfpBaseUrl + "changeOfAttributes/revertApplication",
          requestOptions
        );
        const result = await response.json();
        if (result.status === "200") {
          hideObjectionPopup();
          resetForm();
          completeCoaWorkflowStep(
            result.message || "Application reverted successfully."
          );
        } else {
          showCoaWorkflowResult(
            result.message || "Failed to revert application.",
            "error"
          );
        }
      } catch (error) {
        showCoaWorkflowResult(
          "Failed to revert application. Please try again.",
          "error"
        );
      } finally {
        setViewBackdrop(false);
      }
    },
  });

  const showObjectionPopup = () => {
    setObjectionPopUpOpen(true);
  };

  const hideObjectionPopup = () => {
    objectionRevertFormik.handleReset();
    setObjectionPopUpOpen(false);
  };

  const showCancelApplicationPopup = () => {
    setCancelRemarksError("");
    setCancelApplicationPopUpOpen(true);
  };

  const hideCancelApplicationPopup = () => {
    setCancelApplicationRemarks("");
    setCancelRemarksError("");
    setCancelApplicationPopUpOpen(false);
  };

  const validateCancelRemarks = () => {
    const remarks = cancelApplicationRemarks.trim();
    if (!remarks) {
      setCancelRemarksError("Enter cancellation remarks.");
      return false;
    }
    if (remarks.length < 10) {
      setCancelRemarksError("Remarks must be at least 10 characters.");
      return false;
    }
    setCancelRemarksError("");
    return true;
  };

  const showCancelApplicationConfirm = () => {
    if (!validateCancelRemarks()) return;
    setCancelApplicationConfirmOpen(true);
  };

  const hideCancelApplicationConfirm = () => {
    setCancelApplicationConfirmOpen(false);
  };

  const submitCancelApplication = async () => {
    if (!dialogRowData?.applicationId) return;
    if (!validateCancelRemarks()) {
      hideCancelApplicationConfirm();
      return;
    }

    const remarks = cancelApplicationRemarks.trim();

    setViewBackdrop(true);
    hideCancelApplicationConfirm();
    setCancelApplicationPopUpOpen(false);

    const myHeaders = new Headers();
    myHeaders.append("Authorization", token);
    myHeaders.append("Content-Type", "application/json");

    const raw = JSON.stringify({
      applicationId: dialogRowData.applicationId,
      remarks,
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    try {
      const response = await fetch(
        cfpBaseUrl + "changeOfAttributes/cancelApplication",
        requestOptions
      );
      const result = await response.json();
      if (result.status == "200") {
        setCancelApplicationRemarks("");
        setCancelRemarksError("");
        completeCoaWorkflowStep(
          result.message || "Application cancelled successfully."
        );
      } else {
        showCoaWorkflowResult(
          result.message || "Failed to cancel application.",
          "error"
        );
      }
    } catch (error) {
      showCoaWorkflowResult(
        "Failed to cancel application. Please try again.",
        "error"
      );
    } finally {
      setViewBackdrop(false);
    }
  };

  const COA_RESTORE_ALLOWED_DAYS = 7;
  const RESTORE_MONTH_INDEX = {
    jan: 0,
    feb: 1,
    mar: 2,
    apr: 3,
    may: 4,
    jun: 5,
    jul: 6,
    aug: 7,
    sep: 8,
    oct: 9,
    nov: 10,
    dec: 11,
  };

  const parseRestoreDateValue = (dateValue) => {
    if (dateValue instanceof Date) {
      return Number.isNaN(dateValue.getTime()) ? null : dateValue;
    }
    if (typeof dateValue === "number") {
      const parsedNumberDate = new Date(dateValue);
      return Number.isNaN(parsedNumberDate.getTime()) ? null : parsedNumberDate;
    }
    if (Array.isArray(dateValue) && dateValue.length >= 3) {
      const parsedArrayDate = new Date(
        Number(dateValue[0]),
        Number(dateValue[1]) - 1,
        Number(dateValue[2]),
        Number(dateValue[3] || 0),
        Number(dateValue[4] || 0),
        Number(dateValue[5] || 0),
      );
      return Number.isNaN(parsedArrayDate.getTime()) ? null : parsedArrayDate;
    }
    if (!dateValue) return null;

    const raw = String(dateValue).trim();
    if (!raw) return null;

    const makeDate = (year, monthIndex, day, hour = 0, minute = 0, second = 0) => {
      const parsed = new Date(
        Number(year),
        Number(monthIndex),
        Number(day),
        Number(hour),
        Number(minute),
        Number(second),
      );
      return Number.isNaN(parsed.getTime()) ? null : parsed;
    };

    const isoMatch = raw.match(
      /^(\d{4})-(\d{2})-(\d{2})(?:[T\s](\d{1,2}):(\d{2})(?::(\d{2}))?)?/,
    );
    if (isoMatch) {
      return makeDate(
        isoMatch[1],
        Number(isoMatch[2]) - 1,
        isoMatch[3],
        isoMatch[4],
        isoMatch[5],
        isoMatch[6],
      );
    }

    const monthNameMatch = raw.match(
      /^(\d{1,2})[-\s]([A-Za-z]{3})[-\s](\d{2,4})(?:\s+(\d{1,2}):(\d{2})(?::(\d{2}))?)?/,
    );
    if (monthNameMatch) {
      const monthIndex = RESTORE_MONTH_INDEX[monthNameMatch[2].toLowerCase()];
      if (monthIndex != null) {
        let year = Number(monthNameMatch[3]);
        if (year < 100) year += 2000;
        return makeDate(
          year,
          monthIndex,
          monthNameMatch[1],
          monthNameMatch[4],
          monthNameMatch[5],
          monthNameMatch[6],
        );
      }
    }

    const dmyMatch = raw.match(
      /^(\d{1,2})[\/\-.](\d{1,2})[\/\-.](\d{2,4})(?:\s+(\d{1,2}):(\d{2})(?::(\d{2}))?)?/,
    );
    if (dmyMatch) {
      let year = Number(dmyMatch[3]);
      if (year < 100) year += 2000;
      return makeDate(
        year,
        Number(dmyMatch[2]) - 1,
        dmyMatch[1],
        dmyMatch[4],
        dmyMatch[5],
        dmyMatch[6],
      );
    }

    if (/^\d{10,13}$/.test(raw)) {
      const timestamp = raw.length === 10 ? Number(raw) * 1000 : Number(raw);
      const parsedTimestamp = new Date(timestamp);
      return Number.isNaN(parsedTimestamp.getTime()) ? null : parsedTimestamp;
    }

    const nativeParsed = new Date(raw.replace(" ", "T"));
    return Number.isNaN(nativeParsed.getTime()) ? null : nativeParsed;
  };

  const getDaysSinceCoaLastModification = (lastModificationDate) => {
    const modifiedDate = parseRestoreDateValue(lastModificationDate);
    if (!modifiedDate) return null;

    const today = new Date();
    const startOfModified = new Date(
      modifiedDate.getFullYear(),
      modifiedDate.getMonth(),
      modifiedDate.getDate(),
    );
    const startOfToday = new Date(
      today.getFullYear(),
      today.getMonth(),
      today.getDate(),
    );

    return Math.floor(
      (startOfToday.getTime() - startOfModified.getTime()) /
      (1000 * 60 * 60 * 24),
    );
  };

  const isCoaRestoreAllowedWithinDays = (
    lastModificationDate,
    allowedDays = COA_RESTORE_ALLOWED_DAYS,
  ) => {
    const daysSince = getDaysSinceCoaLastModification(lastModificationDate);
    if (daysSince === null) return false;
    return daysSince < allowedDays;
  };

  const shouldApplyCoaRestoreDayLimit = (applicationProgressId) =>
    Number(applicationProgressId) === 6;

  const getCoaRestoreReferenceDate = (row = dialogRowData) => {
    const progressId = Number(row?.applicationProgressId);
    const historyItems = Array.isArray(eFileData) ? eFileData : [];
    const rejectionHistory = historyItems
      .filter((item) => Number(item?.objectionStatus) === 1)
      .filter((item) => {
        if (Number.isNaN(progressId)) return true;
        const itemProgress = Number(
          item?.historyProgressId ?? item?.applicationProgressId,
        );
        return itemProgress === progressId;
      })
      .sort((a, b) => {
        const aTime =
          parseRestoreDateValue(a?.lastModificationDate)?.getTime() || 0;
        const bTime =
          parseRestoreDateValue(b?.lastModificationDate)?.getTime() || 0;
        return bTime - aTime;
      })[0];

    return (
      rejectionHistory?.lastModificationDate ||
      row?.lastModificationDate ||
      row?.creationDate ||
      null
    );
  };

  const hasCoaRestoreApplicationPermission = () =>
    CheckPermissions(
      permissions,
      "General Services",
      "Change of Attributes",
      "Workflow Permissions",
      "Restore Application",
    );

  const hasCoaRestoreAfterLoePermission = () =>
    CheckPermissions(
      permissions,
      "General Services",
      "Change of Attributes",
      "Workflow Permissions",
      "Restore after LOE",
    );

  const isCoaRestoreAfterLoeWindow = (row = dialogRowData) =>
    shouldApplyCoaRestoreDayLimit(row?.applicationProgressId) &&
    !isCoaRestoreAllowedWithinDays(getCoaRestoreReferenceDate(row));

  const resetRestoreApplicationForm = () => {
    setRestoreApplicationRemarks("");
    setRestoreRemarksError("");
    setRestoreRequiresLoeDocument(false);
    setRestoreLoeDocument("");
    setRestoreLoeDocumentThumbnail("");
    setRestoreLoeDocumentError("");
  };

  const handleRestoreLoeDocumentUpload = (event) => {
    if (!event?.target?.files?.[0]) return;
    const newFileName =
      "loeDocument." + event.target.files[0].name.split(".").pop();
    handleFileUpload(
      event,
      () => { },
      setRestoreLoeDocument,
      setRestoreLoeDocumentError,
      setRestoreLoeDocumentThumbnail,
      newFileName,
    );
    event.target.value = "";
  };

  const renderRestoreLoeDocumentField = (inputId) => (
    <div className="nc-restore-loe-field">
      <label className="nc-restore-loe-field__label" htmlFor={inputId}>
        Letter of Explanation (LOE) Document
        <span className="nc-restore-loe-field__required"> *</span>
      </label>
      {restoreLoeDocument || restoreLoeDocumentThumbnail ? (
        <div className="nc-restore-loe-field__preview">
          {restoreLoeDocumentThumbnail &&
            isImage(restoreLoeDocumentThumbnail) ? (
            <img src={restoreLoeDocumentThumbnail} alt="Letter of Explanation" />
          ) : (
            <img src={pdfIcon} alt="LOE PDF" />
          )}
          <button
            type="button"
            className="nc-restore-loe-field__remove"
            onClick={() => {
              setRestoreLoeDocument("");
              setRestoreLoeDocumentThumbnail("");
              setRestoreLoeDocumentError("Upload Letter of Explanation (LOE) document.");
            }}
            aria-label="Remove Letter of Explanation"
          >
            <CloseIcon fontSize="small" />
          </button>
        </div>
      ) : (
        <Button
          variant="outlined"
          component="label"
          startIcon={<FileUploadOutlinedIcon />}
          className="nc-restore-loe-field__upload-btn"
        >
          Upload Letter of Explanation
          <input
            hidden
            accept={documentExtensions}
            id={inputId}
            name={inputId}
            type="file"
            onChange={handleRestoreLoeDocumentUpload}
          />
        </Button>
      )}
      {restoreLoeDocumentError ? (
        <p className="nc-restore-loe-field__error">{restoreLoeDocumentError}</p>
      ) : null}
    </div>
  );

  const showRestoreApplicationPopup = () => {
    const needsLoeDocument = isCoaRestoreAfterLoeWindow();
    if (needsLoeDocument && !hasCoaRestoreAfterLoePermission()) {
      showCoaWorkflowResult(
        `The ${COA_RESTORE_ALLOWED_DAYS}-day restore window has expired.`,
        "error",
      );
      return;
    }

    setRestoreApplicationRemarks("");
    setRestoreRemarksError("");
    setRestoreRequiresLoeDocument(needsLoeDocument);
    setRestoreLoeDocument("");
    setRestoreLoeDocumentThumbnail("");
    setRestoreLoeDocumentError("");
    setRestoreApplicationPopUpOpen(true);
  };

  const hideRestoreApplicationPopup = () => {
    resetRestoreApplicationForm();
    setRestoreApplicationPopUpOpen(false);
  };

  const validateRestoreRemarks = () => {
    const remarks = restoreApplicationRemarks.trim();
    if (!remarks) {
      setRestoreRemarksError("Enter restore remarks.");
      return false;
    }
    if (remarks.length < 10) {
      setRestoreRemarksError("Remarks must be at least 10 characters.");
      return false;
    }
    setRestoreRemarksError("");
    return true;
  };

  const validateRestoreLoeDocument = () => {
    const needsLoeDocument =
      restoreRequiresLoeDocument || isCoaRestoreAfterLoeWindow();
    if (!needsLoeDocument) {
      setRestoreLoeDocumentError("");
      return true;
    }
    if (!restoreLoeDocument && !restoreLoeDocumentThumbnail) {
      setRestoreLoeDocumentError("Upload Letter of Explanation (LOE) document.");
      return false;
    }
    setRestoreLoeDocumentError("");
    return true;
  };

  const showRestoreApplicationConfirm = () => {
    const remarksValid = validateRestoreRemarks();
    const loeDocumentValid = validateRestoreLoeDocument();
    if (!remarksValid || !loeDocumentValid) return;
    setRestoreApplicationConfirmOpen(true);
  };

  const hideRestoreApplicationConfirm = () => {
    setRestoreApplicationConfirmOpen(false);
  };

  const submitRestoreApplication = async () => {
    if (!dialogRowData?.applicationId) return;

    const needsLoeDocument = isCoaRestoreAfterLoeWindow();
    if (needsLoeDocument && !hasCoaRestoreAfterLoePermission()) {
      hideRestoreApplicationConfirm();
      showCoaWorkflowResult(
        `The ${COA_RESTORE_ALLOWED_DAYS}-day restore window has expired.`,
        "error",
      );
      return;
    }
    if (!validateRestoreRemarks() || !validateRestoreLoeDocument()) {
      hideRestoreApplicationConfirm();
      return;
    }

    const remarks = restoreApplicationRemarks.trim();

    setViewBackdrop(true);
    hideRestoreApplicationConfirm();
    setRestoreApplicationPopUpOpen(false);

    const myHeaders = new Headers();
    myHeaders.append("Authorization", token);
    myHeaders.append("Content-Type", "application/json");

    const payload = {
      applicationId: dialogRowData.applicationId,
      applicationType: "15",
      applicationProgressId: dialogRowData.applicationProgressId,
      remarks,
    };
    if (needsLoeDocument) {
      payload.loeDocument = restoreLoeDocumentThumbnail;
    }

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: JSON.stringify(payload),
      redirect: "follow",
    };

    try {
      const response = await fetch(
        cfpBaseUrl + "comman/restoreCancelApplications",
        requestOptions
      );
      const result = await response.json();
      if (result.status == "200") {
        resetRestoreApplicationForm();
        completeCoaWorkflowStep(
          result.message || "Application restored successfully."
        );
      } else {
        showCoaWorkflowResult(
          result.message || "Failed to restore application.",
          "error"
        );
      }
    } catch (error) {
      showCoaWorkflowResult(
        "Failed to restore application. Please try again.",
        "error"
      );
    } finally {
      setViewBackdrop(false);
    }
  };

  useEffect(() => {
    if (changeOfNameApplications) {
      apiToDataGridConversionNormal();
    }
  }, [changeOfNameApplications]);

  useEffect(() => {
    if (changeOfNameApplicationsOverDue) apiToDataGridConversionOverdue();
  }, [changeOfNameApplicationsOverDue]);

  useEffect(() => {
    if (!(props.showTable && pathname === "/change-of-attributes-table")) return;
    if (foundId && foundId !== "") {
      setFoundInCON(foundId);
    }
  }, [foundId, props.showTable, pathname]);

  useEffect(() => {
    if (!(props.showTable && pathname === "/change-of-attributes-table")) return;
    if (foundInCON) {
      handleRowClick(foundInCON);
    }
  }, [foundInCON, props.showTable, pathname]);

  useLayoutEffect(() => {
    if (!(props.showTable && pathname === "/change-of-attributes-table")) return;
    if (changeOfNameApplications.length >= 1) {
      if (foundInCON && foundInCON !== "") {
        handleRowClick(foundInCON);
      }
    }
  }, [changeOfNameApplications, props.showTable, pathname]);

  //#endregion

  //#region functions

  const updateDocFlag = (documentName, value, remarks) => {
    switch (documentName) {
      case "copyOfApplicantCNIC":
        setFlag_applicantCNICFront(value);
        setFlag_applicantCNICBack(value);
        setApplicantCNICFrontObjectionRemarks(remarks);
        setApplicantCNICBackObjectionRemarks(remarks);
        setCopyOfApplicantCNICVerifyPopUp(false);
        break;
      case "owenershipDocument":
        setFlag_owenershipDocument(value);
        setowenershipObjectionRemarks(remarks);
        setOwenershipDocumentVerifyPopUp(false);
        break;
      case "electricityBillDocument":
        setFlag_electricityBillDocument(value);
        setElectricityBillObjectionRemarks(remarks);
        setElectricityBillDocumentVerifyPopUp(false);
        break;
      case "fbrDocument":
        setFlag_fbrDocument(value);
        setFbrDocumentObjectionRemarks(remarks);
        setFbrDocumentVerifyPopUp(false);
        break;
      case "preOwnerCNIC":
        setFlag_PreOwnerCNICFront(value);
        setFlag_PreOwnerCNICBack(value);
        setpreOwnerCNICBackObjectionRemarks(remarks);
        setpreOwnerCNICFrontObjectionRemarks(remarks);
        setPreOwnerCNICVerifyPopUp(false);
        break;
      case "perOwenerNOC":
        setFlag_perOwenerNOC(value);
        setperOwenerNOCObjectionRemarks(remarks);
        setPerOwenerNOCVerifyPopUp(false);
        break;
      case "newOwenerAffidavite":
        setFlag_newOwenerAffidavite(value);
        setnewOwenerAffidaviteObjectionRemarks(remarks);
        setNewOwenerAffidaviteVerifyPopUp(false);
        break;
      case "addDocCivicAuthority":
        setFlag_addDocCivicAuthority(value);
        setaddDocCivicAuthorityObjectionRemarks(remarks);
        setAddDocCivicAuthorityVerifyPopUp(false);
        break;
      case "addDocAnyOther":
        setFlag_addDocAnyOther(value);
        setaddDocAnyOtherObjectionRemarks(remarks);
        setAddDocAnyOtherVerifyPopUp(false);
        break;
      case "addDocCONConsent":
        setFlag_addDocCONConsent(value);
        setaddCONConsentObjectionRemarks(remarks);
        setAddDocCONConsentVerifyPopUp(false);
        break;
      case "wiringTestReport":
        setFlag_wiringTestReport(value);
        {
          const nextRemarks =
            value === 1
              ? remarks || "Verified"
              : value === -1
                ? remarks || ""
                : remarks || wiringTestReportObjectionRemarks || "";
          setWiringTestReportObjectionRemarks(nextRemarks);
          setDialogRowData((prev) =>
            prev
              ? {
                ...prev,
                wiringTestReportDocumentFlag: value,
                wiringTestReportDocumentRemarks: nextRemarks,
                wiringTestReportDocumentObjectionRemarks: nextRemarks,
              }
              : prev
          );
        }
        setWiringTestReportVerifyPopUp(false);
        break;
      default:
        break;
    }
  };

  const applicationName = (code) => {
    if (code) {
      switch (code) {
        case 1:
          return "Change of Name";
        case 2:
          return "Change of Load";
        case 3:
          return "Change of Tariff";
        case 4:
          return "Change of Attributes";
        case 5:
          return "Change of Name | Load";
        case 6:
          return "Change of Name | Tariff";
        case 7:
          return "Change of Load | Tariff";
        default:
          return "Application Type";
      }
    }
  };

  const coaIncludesName = (type) => [1, 4, 5, 6].includes(Number(type));
  const coaIncludesLoad = (type) => [2, 4, 5, 7].includes(Number(type));
  const coaIncludesTariff = (type) => [3, 4, 6, 7].includes(Number(type));
  const isChangeOfNameOnlyApplication = (changeOfAttributesType) =>
    Number(changeOfAttributesType) === 1;

  const hasMultipleCoaSections = (type) => {
    const t = Number(type);
    return (
      [coaIncludesName(t), coaIncludesLoad(t), coaIncludesTariff(t)].filter(Boolean)
        .length > 1
    );
  };

  const initEditSections = (type) => {
    const t = Number(type);
    const multiple = hasMultipleCoaSections(t);
    return {
      name: coaIncludesName(t) && !multiple,
      load: coaIncludesLoad(t) && !multiple,
      tariff: coaIncludesTariff(t) && !multiple,
    };
  };

  const normalizeTariffForAuthority = (tariff, tariffList = []) => {
    if (!tariff) return "";
    const raw = String(tariff).trim();
    const matched = tariffList?.find(
      (item) =>
        item.tariffName === raw ||
        String(item.tariffCode) === raw ||
        String(item.tariffName || "").replace(/[^A-Za-z0-9]/g, "").toUpperCase() ===
        raw.replace(/[^A-Za-z0-9]/g, "").toUpperCase()
    );
    const name = matched?.tariffName || raw;
    return String(name).replace(/[^A-Za-z0-9]/g, "").toUpperCase();
  };

  const COA_TARIFF_CHANGE_TYPES = [3, 4, 6, 7];

  const getCoaAuthorityTariff = (rowData) => {
    const type = Number(rowData?.changeOfAttributesType);
    if (COA_TARIFF_CHANGE_TYPES.includes(type)) {
      return rowData?.newTariff || rowData?.currentTariff;
    }
    return rowData?.currentTariff;
  };

  const getCoaAuthoritySanctionLoad = (rowData) =>
    Number(rowData?.newSanctionLoad || rowData?.currentSanctionLoad) || 0;

  const isCoaA1A2A3Tariff = (normalizedTariff) =>
    ["A1", "A2", "A3"].some((code) => normalizedTariff?.startsWith(code));

  const matchesCoaApprovalCategory = (
    userPermissions,
    rowData,
    tariffList = []
  ) => {
    const sanctionLoad = getCoaAuthoritySanctionLoad(rowData);
    const authorityTariff = normalizeTariffForAuthority(
      getCoaAuthorityTariff(rowData),
      tariffList
    );
    const coaApprovalPath = [
      "General Services",
      "Change of Attributes",
      "Workflow Permissions",
      "Approval Category",
    ];

    return (
      (CheckPermissions(
        userPermissions,
        ...coaApprovalPath,
        "Load Sanctioning",
        "15"
      ) &&
        sanctionLoad > 0 &&
        sanctionLoad <= 15 &&
        ((CheckPermissions(
          userPermissions,
          ...coaApprovalPath,
          "Tariff Authority",
          "A1"
        ) &&
          authorityTariff?.startsWith("A1")) ||
          (CheckPermissions(
            userPermissions,
            ...coaApprovalPath,
            "Tariff Authority",
            "A2"
          ) &&
            authorityTariff?.startsWith("A2")) ||
          (CheckPermissions(
            userPermissions,
            ...coaApprovalPath,
            "Tariff Authority",
            "A3"
          ) &&
            authorityTariff?.startsWith("A3")))) ||
      (CheckPermissions(
        userPermissions,
        ...coaApprovalPath,
        "Load Sanctioning",
        "70"
      ) &&
        sanctionLoad > 0 &&
        sanctionLoad <= 70 &&
        !isCoaA1A2A3Tariff(authorityTariff)) ||
      (CheckPermissions(
        userPermissions,
        ...coaApprovalPath,
        "Load Sanctioning",
        "70"
      ) &&
        sanctionLoad > 15 &&
        sanctionLoad <= 70) ||
      (CheckPermissions(
        userPermissions,
        ...coaApprovalPath,
        "Load Sanctioning",
        "500"
      ) &&
        sanctionLoad > 70 &&
        sanctionLoad <= 500) ||
      (CheckPermissions(
        userPermissions,
        ...coaApprovalPath,
        "Load Sanctioning",
        "5000"
      ) &&
        sanctionLoad > 500)
    );
  };

  const requiresFbrDocument = (tariff) => {
    if (!tariff) return false;
    const cleaned = normalizeTariffForAuthority(tariff);
    return /^(A2|B)/.test(cleaned);
  };

  const validateEditNtn = (ntn, tariff) => {
    if (!requiresFbrDocument(tariff)) return "";
    const trimmed = String(ntn || "").trim();
    if (!trimmed) return "NTN No. is required.";
    if (!/^\d+$/.test(trimmed)) return "NTN must contain only numbers.";
    if (trimmed.length > 13) return "NTN must be at most 13 digits.";
    return "";
  };

  const hasExistingEditNtn = (rowData) =>
    String(rowData?.ntnNo || "").trim().length > 0;

  const hasExistingEditFbrDocument = (rowData) =>
    Boolean(rowData?.fbrDocument);

  const hasExistingEditWiringTestReport = (rowData) =>
    Boolean(rowData?.wiringTestReportDocument);

  const resolveEditWiringTestReportDocument = (rowData) =>
    editWiringTestReportThumbnail ||
    (!editWiringTestReportCleared && rowData?.wiringTestReportDocument) ||
    "";

  const isEditLoadOrTariffValueChanged = ({
    shouldEditLoad,
    shouldEditTariff,
  }) => {
    if (!editFormBaseline) return false;

    const cur = editFormData;
    const base = editFormBaseline;
    const changed = (a, b) =>
      normalizeEditCompareValue(a) !== normalizeEditCompareValue(b);

    // Wiring is required only when the user changes new load / new tariff in this
    // edit session (vs values when the popup opened), and the new value differs
    // from sanctioned load / old tariff.
    if (shouldEditLoad) {
      const sanctionedLoad =
        cur.currentLoad ?? dialogRowData.currentSanctionLoad ?? "";
      if (
        changed(cur.newLoad, base.newLoad) &&
        changed(cur.newLoad, sanctionedLoad)
      ) {
        return true;
      }
    }
    if (shouldEditTariff) {
      const oldTariff = cur.currentTariff ?? dialogRowData.currentTariff ?? "";
      if (
        changed(cur.newTariff, base.newTariff) &&
        changed(cur.newTariff, oldTariff)
      ) {
        return true;
      }
    }
    return false;
  };

  const getLoadChangeTypeName = (typeId) => {
    const item = lookUpDataOfCON?.lookupLoadChangeType?.find(
      (t) => Number(t.typeId) === Number(typeId)
    );
    return (item?.typeName || "").toLowerCase();
  };

  const validateEditName = () => {
    const errors = {
      newName: "",
      guardianName: "",
      newCNIC: "",
      newPhone: "",
    };
    const { newName, guardianName, newCNIC, newPhone, relation } = editFormData;

    if (!String(newName || "").trim()) {
      errors.newName = "Enter new name.";
    } else if (!isSafePersonName(String(newName).trim())) {
      errors.newName = SAFE_FORM_TEXT_MESSAGE;
    }

    let relationLabel = "guardian's";
    if (Number(relation) === 1 || Number(relation) === 2) {
      relationLabel = "father's";
    } else if (Number(relation) === 3) {
      relationLabel = "husband's";
    } else if (Number(relation) === 4) {
      relationLabel = "care of's";
    }

    if (!String(guardianName || "").trim()) {
      errors.guardianName = `Enter ${relationLabel} new name.`;
    } else if (!isSafePersonName(String(guardianName).trim())) {
      errors.guardianName = SAFE_FORM_TEXT_MESSAGE;
    }

    const cnic = String(newCNIC || "").trim();
    if (!cnic) {
      errors.newCNIC = "Enter new CNIC.";
    } else if (!/^\d{13}$/.test(cnic)) {
      errors.newCNIC = "CNIC must be 13 digits.";
    }

    const phone = String(newPhone || "").trim();
    if (!phone) {
      errors.newPhone = "Phone number is required.";
    } else if (!/^03[0-9]{9}$/.test(phone)) {
      errors.newPhone = "Phone must start with 03 and be 11 digits.";
    }

    return errors;
  };

  const validateEditTariff = (newTariff) => {
    if (!String(newTariff ?? "").trim()) {
      return "Please select new tariff.";
    }
    return "";
  };

  const getInitialEditNewTariff = (rowData) => {
    const fromApi = String(rowData?.newTariff || "").trim();
    if (!fromApi) return "";
    const matched = allTariffList?.find(
      (item) =>
        item.tariffName === fromApi ||
        String(item.tariffName || "").replace(/-/g, "") === fromApi.replace(/-/g, "")
    );
    return matched?.tariffName || fromApi;
  };

  const mergeEditApiResponseIntoDialog = (apiPayload, { resolvedNewTariff, shouldEditTariff }) => {
    const apiData = Array.isArray(apiPayload) ? apiPayload[0] : apiPayload;
    if (!apiData || typeof apiData !== "object") return;

    setDialogRowData((prev) => ({
      ...prev,
      ...apiData,
      ...(shouldEditTariff
        ? {
          newTariff:
            apiData.newTariff != null && String(apiData.newTariff).trim()
              ? apiData.newTariff
              : resolvedNewTariff,
          currentTariff: apiData.currentTariff ?? prev.currentTariff,
          ntnNo: apiData.ntnNo ?? prev.ntnNo,
          fbrDocument: apiData.fbrDocument ?? prev.fbrDocument,
        }
        : {}),
    }));
  };

  const refreshDialogRowFromServer = async (applicationId) => {
    const myHeaders = new Headers();
    myHeaders.append("Authorization", token);
    myHeaders.append("Content-Type", "application/json");

    const response = await fetch(
      `${cfpBaseUrl}changeOfAttributes/getBasicCOAHistory`,
      {
        method: "POST",
        headers: myHeaders,
        body: JSON.stringify({ applicationId }),
      }
    );
    const result = await response.json();

    if (result.status === "200" && result.data?.currentStatus?.[0]) {
      const current = result.data.currentStatus[0];
      setDialogRowData((prev) => ({
        ...prev,
        ...current,
      }));
      return current;
    }
    return null;
  };

  const validateEditLoad = () => {
    const { loadChangeType, currentLoad, newLoad } = editFormData;
    const errors = { loadChangeType: "", newLoad: "" };

    if (
      loadChangeType === "" ||
      loadChangeType === null ||
      loadChangeType === undefined
    ) {
      errors.loadChangeType = "Please select load change type.";
    }

    const newLoadStr = String(newLoad ?? "").trim();
    if (!newLoadStr) {
      errors.newLoad = "Please enter new load.";
    }

    const current = parseFloat(currentLoad);
    const updated = parseFloat(newLoadStr);

    if (newLoadStr && Number.isNaN(updated)) {
      errors.newLoad = "Enter valid load value.";
    } else if (newLoadStr && updated < 0.1) {
      errors.newLoad = "New load cannot be less than 0.1 kW.";
    } else if (
      newLoadStr &&
      !Number.isNaN(current) &&
      !Number.isNaN(updated)
    ) {
      const typeName = getLoadChangeTypeName(loadChangeType);

      if (typeName.includes("addition") && updated <= current) {
        errors.newLoad =
          "For Addition, new load must be greater than sanctioned load.";
      }
      if (typeName.includes("reduction") && updated >= current) {
        errors.newLoad =
          "For Reduction, new load must be less than sanctioned load.";
      }
    }

    return errors;
  };

  const getFirstEditValidationError = (nameErrors, loadErrors, tariffError) => {
    const nameError = Object.values(nameErrors || {}).find(Boolean);
    if (nameError) return nameError;
    if (loadErrors?.loadChangeType) return loadErrors.loadChangeType;
    if (loadErrors?.newLoad) return loadErrors.newLoad;
    if (tariffError) return tariffError;
    return "";
  };

  const normalizeEditCompareValue = (value) => String(value ?? "").trim();

  /**
   * Returns true if at least one field in the selected edit section(s)
   * differs from the values loaded when the Edit popup was opened.
   */
  const hasSelectedEditChanges = ({
    shouldEditName,
    shouldEditLoad,
    shouldEditTariff,
  }) => {
    if (!editFormBaseline) return true;

    const cur = editFormData;
    const base = editFormBaseline;
    const changed = (a, b) =>
      normalizeEditCompareValue(a) !== normalizeEditCompareValue(b);

    if (shouldEditName) {
      if (
        changed(cur.newName, base.newName) ||
        changed(cur.relation, base.relation) ||
        changed(cur.guardianName, base.guardianName) ||
        changed(cur.newCNIC, base.newCNIC) ||
        changed(cur.newPhone, base.newPhone) ||
        changed(cur.telcoCode, base.telcoCode) ||
        changed(cur.newEmail, base.newEmail)
      ) {
        return true;
      }
    }

    if (shouldEditLoad) {
      if (
        changed(cur.loadChangeType, base.loadChangeType) ||
        changed(cur.newLoad, base.newLoad)
      ) {
        return true;
      }
    }

    if (shouldEditTariff) {
      if (
        changed(cur.newTariff, base.newTariff) ||
        changed(cur.ntnNo, base.ntnNo) ||
        Boolean(editFbrDocumentThumbnail) ||
        editFbrDocumentCleared
      ) {
        return true;
      }
    }

    return false;
  };

  const closeEditApplicationPopup = () => {
    setEditSaveError("");
    setEditFbrDocument("");
    setEditFbrDocumentThumbnail("");
    setEditFbrDocumentError("");
    setEditFbrDocumentCleared(false);
    setEditWiringTestReportDocument("");
    setEditWiringTestReportThumbnail("");
    setEditWiringTestReportError("");
    setEditWiringTestReportCleared(false);
    setEditNtnError("");
    setEditLoadChangeTypeError("");
    setEditNameErrors({
      newName: "",
      guardianName: "",
      newCNIC: "",
      newPhone: "",
    });
    setEditTariffError("");
    setEditFormBaseline(null);
    setShowEditPopup(false);
  };

  const updateDocumentStatus = async () => {
    let remarksToSave = "";
    let objectionStatus = null;
    let applicationProgressId = dialogRowData.applicationProgressId;

    if (
      flag_applicantCNICFront === -1 ||
      flag_applicantCNICBack === -1 ||
      flag_owenershipDocument === -1 ||
      flag_electricityBillDocument === -1 ||
      flag_fbrDocument === -1 ||
      flag_addDocAnyOther === -1
    ) {
      objectionStatus = 1;
      applicationProgressId = 1;
      remarksToSave = "Documents objection in: ";

      if (flag_applicantCNICFront === -1) {
        remarksToSave += "Applicant CNIC Front, ";
      }
      if (flag_applicantCNICBack === -1) {
        remarksToSave += "Applicant CNIC Back, ";
      }
      if (flag_owenershipDocument === -1) {
        remarksToSave += "Ownership Document, ";
      }
      if (flag_electricityBillDocument === -1) {
        remarksToSave += "Electricity Bill Document, ";
      }
      if (flag_fbrDocument === -1) {
        remarksToSave += "FBR Document, ";
      }
      if (flag_addDocAnyOther === -1) {
        remarksToSave += "Any Other Document, ";
      }
    } else {
      objectionStatus = 0;
      const skipWiringTestReport = isChangeOfNameOnlyApplication(
        dialogRowData.changeOfAttributesType
      );
      // Document verification remarks only — do not claim Wiring Test Report verified here
      remarksToSave = "Documents Verified.";
      applicationProgressId = skipWiringTestReport ? 3 : 2;
    }

    if (
      !isCoaDocumentVerificationReadyToSubmit()
    ) {
      return;
    }

    if (
      (flag_applicantCNICFront !== null &&
        flag_applicantCNICBack !== null &&
        flag_owenershipDocument !== null &&
        flag_electricityBillDocument !== null) ||
      flag_fbrDocument != null
    ) {
      callingUpdateDocumentStatusAPI(
        dialogRowData.applicationId,
        applicationProgressId,
        objectionStatus,
        flag_applicantCNICFront,
        flag_applicantCNICBack,
        flag_owenershipDocument,
        flag_electricityBillDocument,
        flag_fbrDocument,
        flag_addDocAnyOther,
        applicantCNICBackObjectionRemarks,
        applicantCNICFrontObjectionRemarks,
        owenershipObjectionRemarks,
        electricityBillObjectionRemarks,
        fbrDocumentObjectionRemarks,
        addDocAnyOtherObjectionRemarks,
        remarksToSave
      );
    } else {
    }
  };

  const numberFormatting = (num) => {
    const n = parseFloat(num);
    return isNaN(n) || n === 0 ? "0" : n.toLocaleString("en-US");
  };

  const getAmountText = (amount) => {
    if (amount == null || amount === "" || amount === undefined) return "0";
    const num = parseFloat(amount);
    return isNaN(num) ? "0" : numberFormatting(num);
  };

  const formatAmount = (value) => {
    const num = Number(value) || 0; // convert safely
    return num.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  const downloadDNPDF = async (applicationId, dnDets, applicationData = null) => {
    setViewBackdrop(true);
    try {

      let application = applicationData ||
        changeOfNameApplications.find(
          (item) => item.applicationId === applicationId
        ) ||
        changeOfNameApplicationsOverDue.find(
          (item) => item.applicationId === applicationId
        );

      if (!application) {
        setViewBackdrop(false);
        toast.error("Application not found for DN download");
        return;
      }

      if (!canDownloadCoaDemandNotice(application.applicationProgressId)) {
        setViewBackdrop(false);
        toast.error(
          "Demand Note download is available from DN Submission (progress 6) onward.",
        );
        return;
      }

      let DiscoCode = getDocumentDiscoCode(
        applicationId,
        application.companyCode,
      );
      let officeCode = application.subDivisionCode.toString();
      let officeName = subdivisionName(parseInt(officeCode), subDivisions);
      let authorizedByName = dnDets.approvedBy ? dnDets.approvedBy : "---";
      let authorizedByDesignation = dnDets.approvedByDesignation
        ? dnDets.approvedByDesignation
        : "Role";
      let dateToPrint = dnDets.approvedDate
        ? new Date(dnDets.approvedDate).toLocaleDateString()
        : "---";
      let stampData = printStamp(
        officeCode,
        officeName,
        authorizedByName,
        authorizedByDesignation,
        dateToPrint
      );

      const yy = applicationId.slice(8, 10); // 25
      const mm = applicationId.slice(10, 12); // 11
      const dd = applicationId.slice(12, 14); // 18

      const monthNames = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];

      // Convert to: 18-Nov-2025
      const formattedDate = `${dd}-${monthNames[parseInt(mm) - 1]}-20${yy}`;


      const fontSize = 8;
      const doc = new jsPDF({ compressPdf: true });

      if (dnDets.approvedBy) {
        doc.addImage(stampData, "PNG", 20, 170, 55, 40); // 200 → 170
        doc.addImage(stampData, "PNG", 140, 250, 55, 40); // 265 → 235
      }

      await addDnPaymentQrCodesToPdf(doc, {
        dnDets,
        applicationId,
        token,
        securityAmount: parseFloat(dnDets.securityDepositeAmount) || 0,
        capitalCost: parseFloat(dnDets.capitalCostAmount) || 0,
        discoCode: DiscoCode,
        layout: COA_DN_QR_LAYOUT,
      });

      //#region Line 1
      var padding = 10;
      var line2Height = 10;
      var lineHeightIncreament = 5;
      doc.setFontSize(fontSize);
      doc.setFont("helvetica", "bold");
      drawDnDueDate(
        doc,
        (!dnDets.demandNoteExpiryCount ? "Due Date: " : "Extended Due Date: ") +
        convertDate(dnDets.dueDate),
        padding,
        line2Height,
        {}
      );

      doc.setFont("helvetica", "normal");
      const dnCompanyDiscoCode =
        String(code) === "10"
          ? getDocumentDiscoCode(applicationId, application.companyCode)
          : dnDets.connectionAccountNo.slice(2, 4);
      doc.text(
        companyName(dnCompanyDiscoCode),
        doc.internal.pageSize.getWidth() / 2,
        line2Height,
        {
          align: "center",
        }
      );

      var line2Height = line2Height + lineHeightIncreament;
      doc.text(
        "(Department of Electricity)",
        doc.internal.pageSize.getWidth() / 2,
        line2Height,
        {
          align: "center",
        }
      );

      var line2Height = line2Height + lineHeightIncreament;
      var lineSpace = 12;
      var text1 = "Demand Notice Serial No.: ";
      var text2 = dnDets.demandNoteNo;
      var text3 = "Application Id: ";
      var text4 = applicationId;
      var text5 = "Apply Date: ";
      var text6 = formattedDate;

      doc.text(text1, padding, line2Height);
      drawDnDetailValue(
        doc,
        text2,
        doc.getTextWidth(text1) + padding + lineSpace,
        line2Height
      );
      doc.line(
        doc.getTextWidth(text1) + padding,
        line2Height + 1,
        doc.getTextWidth(text1) +
        padding +
        (doc.getTextWidth(text2) + lineSpace * 2),
        line2Height + 1
      );

      doc.text(
        text3,
        doc.getTextWidth(text1) +
        padding +
        (doc.getTextWidth(text2) + lineSpace * 2),
        line2Height
      );
      drawDnDetailValue(
        doc,
        text4,
        doc.getTextWidth(text2) +
        doc.getTextWidth(text1) +
        doc.getTextWidth(text3) +
        padding +
        lineSpace * 3,
        line2Height
      );
      doc.line(
        doc.getTextWidth(text1) +
        doc.getTextWidth(text2) +
        doc.getTextWidth(text3) +
        padding +
        lineSpace * 2,
        line2Height + 1,
        doc.getTextWidth(text1) +
        doc.getTextWidth(text2) +
        doc.getTextWidth(text3) +
        padding +
        lineSpace * 2 +
        (doc.getTextWidth(text4) + lineSpace * 2),
        line2Height + 1
      );

      doc.text(
        text5,
        doc.getTextWidth(text2) +
        doc.getTextWidth(text1) +
        doc.getTextWidth(text3) +
        padding +
        lineSpace * 2 +
        (doc.getTextWidth(text4) + lineSpace * 2),
        line2Height
      );
      drawDnDetailValue(
        doc,
        text6,
        doc.getTextWidth(text1) +
        doc.getTextWidth(text2) +
        doc.getTextWidth(text3) +
        doc.getTextWidth(text4) +
        doc.getTextWidth(text5) +
        padding +
        lineSpace * 5,
        line2Height
      );
      doc.line(
        doc.getTextWidth(text1) +
        doc.getTextWidth(text2) +
        doc.getTextWidth(text3) +
        doc.getTextWidth(text4) +
        doc.getTextWidth(text5) +
        padding +
        lineSpace * 4,
        line2Height + 1,
        doc.getTextWidth(text1) +
        doc.getTextWidth(text2) +
        doc.getTextWidth(text3) +
        doc.getTextWidth(text4) +
        doc.getTextWidth(text5) +
        padding +
        lineSpace * 4 +
        doc.getTextWidth(text6) +
        lineSpace * 2,
        line2Height + 1
      );
      //#endregion

      //#region Line 4
      var line2Height = line2Height + lineHeightIncreament;
      var lineSpace = 3.35;
      var text1 = "Demand Notice Issuance Date: ";
      var text2 = dnDets.issueDate ? convertDate(dnDets.issueDate) : "-";
      var text3 = "Application Type: ";
      var text4 = application.changeOfAttributesType
        ? applicationName(application.changeOfAttributesType)
        : "-";
      var text5 = "Load: ";
      var text6 = application.newSanctionLoad
        ? String(application.newSanctionLoad)
        : application.currentSanctionLoad
          ? String(application.currentSanctionLoad)
          : "-";

      doc.text(text1, padding, line2Height);
      drawDnDetailValue(
        doc,
        text2,
        doc.getTextWidth(text1) + padding + lineSpace,
        line2Height
      );
      doc.line(
        doc.getTextWidth(text1) + padding,
        line2Height + 1,
        doc.getTextWidth(text1) +
        padding +
        (doc.getTextWidth(text2) + lineSpace * 2),
        line2Height + 1
      );

      doc.text(
        text3,
        doc.getTextWidth(text1) +
        padding +
        (doc.getTextWidth(text2) + lineSpace * 2),
        line2Height
      );
      drawDnDetailValue(
        doc,
        text4,
        doc.getTextWidth(text2) +
        doc.getTextWidth(text1) +
        doc.getTextWidth(text3) +
        padding +
        lineSpace * 3,
        line2Height
      );
      doc.line(
        doc.getTextWidth(text1) +
        doc.getTextWidth(text2) +
        doc.getTextWidth(text3) +
        padding +
        lineSpace * 2,
        line2Height + 1,
        doc.getTextWidth(text1) +
        doc.getTextWidth(text2) +
        doc.getTextWidth(text3) +
        padding +
        lineSpace * 2 +
        (doc.getTextWidth(text4) + lineSpace * 2),
        line2Height + 1
      );

      doc.text(
        text5,
        doc.getTextWidth(text2) +
        doc.getTextWidth(text1) +
        doc.getTextWidth(text3) +
        padding +
        lineSpace * 2 +
        (doc.getTextWidth(text4) + lineSpace * 2),
        line2Height
      );
      drawDnDetailValue(
        doc,
        text6,
        doc.getTextWidth(text1) +
        doc.getTextWidth(text2) +
        doc.getTextWidth(text3) +
        doc.getTextWidth(text4) +
        doc.getTextWidth(text5) +
        padding +
        lineSpace * 5,
        line2Height
      );
      doc.line(
        doc.getTextWidth(text1) +
        doc.getTextWidth(text2) +
        doc.getTextWidth(text3) +
        doc.getTextWidth(text4) +
        doc.getTextWidth(text5) +
        padding +
        lineSpace * 4,
        line2Height + 1,
        doc.getTextWidth(text1) +
        doc.getTextWidth(text2) +
        doc.getTextWidth(text3) +
        doc.getTextWidth(text4) +
        doc.getTextWidth(text5) +
        padding +
        lineSpace * 4 +
        doc.getTextWidth(text6) +
        lineSpace * 2,
        line2Height + 1
      );

      // doc.text(text5, (doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (doc.getTextWidth(text4) + (lineSpace * 2)), line2Height);
      // doc.text(text6, doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + padding + (lineSpace * 5), line2Height);
      // doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + padding + (lineSpace * 4), line2Height + 1, doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + padding + (lineSpace * 4) + doc.getTextWidth(text6) + (lineSpace * 2), line2Height + 1);
      //#endregion

      //#region Line 5
      var line2Height = line2Height + lineHeightIncreament;
      var lineSpace = 6.6;
      var text1 = "Account No. for acquisition connection: ";
      var text2 = dnDets.connectionAccountNo ? dnDets.connectionAccountNo : "-";
      var text3 = "User Mobile No.: ";
      var text4 = application.applicantPhoneNo
        ? application.applicantPhoneNo
        : "-";
      var text5 = "Connection type: ";
      var text6 = dnDets.connectionType ? dnDets.connectionType : dnDets.newConnectionType && "-";

      doc.text(text1, padding, line2Height);
      drawDnDetailValue(
        doc,
        text2,
        doc.getTextWidth(text1) + padding + lineSpace,
        line2Height
      );
      doc.line(
        doc.getTextWidth(text1) + padding,
        line2Height + 1,
        doc.getTextWidth(text1) +
        padding +
        (doc.getTextWidth(text2) + lineSpace * 2),
        line2Height + 1
      );

      doc.text(
        text3,
        doc.getTextWidth(text1) +
        padding +
        (doc.getTextWidth(text2) + lineSpace * 2),
        line2Height
      );
      drawDnDetailValue(
        doc,
        text4,
        doc.getTextWidth(text2) +
        doc.getTextWidth(text1) +
        doc.getTextWidth(text3) +
        padding +
        lineSpace * 3,
        line2Height
      );
      doc.line(
        doc.getTextWidth(text1) +
        doc.getTextWidth(text2) +
        doc.getTextWidth(text3) +
        padding +
        lineSpace * 2,
        line2Height + 1,
        doc.getTextWidth(text1) +
        doc.getTextWidth(text2) +
        doc.getTextWidth(text3) +
        padding +
        lineSpace * 2 +
        (doc.getTextWidth(text4) + lineSpace * 2),
        line2Height + 1
      );

      doc.text(
        text5,
        doc.getTextWidth(text2) +
        doc.getTextWidth(text1) +
        doc.getTextWidth(text3) +
        padding +
        lineSpace * 2 +
        (doc.getTextWidth(text4) + lineSpace * 2),
        line2Height
      );
      drawDnDetailValue(
        doc,
        text6,
        doc.getTextWidth(text1) +
        doc.getTextWidth(text2) +
        doc.getTextWidth(text3) +
        doc.getTextWidth(text4) +
        doc.getTextWidth(text5) +
        padding +
        lineSpace * 5,
        line2Height
      );
      doc.line(
        doc.getTextWidth(text1) +
        doc.getTextWidth(text2) +
        doc.getTextWidth(text3) +
        doc.getTextWidth(text4) +
        doc.getTextWidth(text5) +
        padding +
        lineSpace * 4,
        line2Height + 1,
        doc.getTextWidth(text1) +
        doc.getTextWidth(text2) +
        doc.getTextWidth(text3) +
        doc.getTextWidth(text4) +
        doc.getTextWidth(text5) +
        padding +
        lineSpace * 4 +
        doc.getTextWidth(text6) +
        lineSpace * 2,
        line2Height + 1
      );
      //#endregion

      //#region Line 6
      var line2Height = line2Height + lineHeightIncreament;
      var lineSpace = 7;
      var text1 =
        "(under which the funds are to be deposited in the bank with the concerned officer of the institution)";

      doc.setFontSize(8);
      doc.text(text1, padding, line2Height);

      //#endregion

      //#region Line 7
      var line2Height = line2Height + lineHeightIncreament;
      var lineSpace = 16;
      var text1 = "Alloted Tariff : ";
      var text2 = application.newTariff ? application.newTariff : application.currentTariff;
      var text3 = `Department's approved Bank name: `;
      var text4 = dnDets.bankName ? dnDets.bankName : "-";

      doc.text(text1, padding, line2Height);
      drawDnDetailValue(
        doc,
        text2,
        doc.getTextWidth(text1) + padding + lineSpace,
        line2Height
      );
      doc.line(
        doc.getTextWidth(text1) + padding,
        line2Height + 1,
        doc.getTextWidth(text1) +
        padding +
        (doc.getTextWidth(text2) + lineSpace * 2),
        line2Height + 1
      );

      doc.text(
        text3,
        doc.getTextWidth(text1) +
        padding +
        (doc.getTextWidth(text2) + lineSpace * 2 + 30),
        line2Height
      );
      drawDnDetailValue(
        doc,
        text4,
        doc.getTextWidth(text1) +
        doc.getTextWidth(text3) +
        padding +
        lineSpace * 3 + 30,
        line2Height
      );
      doc.line(
        doc.getTextWidth(text1) +
        doc.getTextWidth(text3) +
        padding +
        lineSpace * 2 + 30,
        line2Height + 1,
        doc.getTextWidth(text1) +
        doc.getTextWidth(text3) +
        padding +
        lineSpace * 2 +
        (doc.getTextWidth(text4) + lineSpace * 2) + 30,
        line2Height + 1
      );
      //#endregion

      //#region Line 10
      var line2Height = line2Height + lineHeightIncreament;

      doc.setFont("helvetica", "bold");
      doc.text(
        "DEMAND NOTICE",
        doc.internal.pageSize.getWidth() / 2,
        line2Height,
        {
          align: "center",
        }
      );
      doc.setFont("helvetica", "normal");
      //#endregion

      //#region Line 11
      var line2Height = line2Height + lineHeightIncreament;

      doc.text(
        "(Notification of Approval Application and Demand Under Guarantee)",
        doc.internal.pageSize.getWidth() / 2,
        line2Height,
        {
          align: "center",
        }
      );
      //#endregion

      //#region Line 12
      var line2Height = line2Height + lineHeightIncreament;

      doc.text(
        `Applicant's part`,
        doc.internal.pageSize.getWidth() / 2,
        line2Height,
        {
          align: "center",
        }
      );
      //#endregion

      //#region Line 13
      var line2Height = line2Height + lineHeightIncreament;
      var lineSpace = 16;
      text1 = "Mr. / Mrs.";
      const guardianRelation =
        application.applicantGuardianType == 1 ? "S/O"
          : application.applicantGuardianType == 2 ? "D/O"
            : application.applicantGuardianType == 3 ? "W/O"
              : application.applicantGuardianType == 4 ? "C/O"
                : "";
      const applicantNameText = application.applicantName
        ? application.applicantName.trim()
        : "";
      const rawGuardianName = application.applicantGuardianName
        ? application.applicantGuardianName.trim()
        : "";
      const guardianNameWithRelation = guardianRelation
        ? `${guardianRelation}${rawGuardianName ? ` ${rawGuardianName}` : ""}`
        : rawGuardianName;
      const addressText = application.consumerAddress
        ? application.consumerAddress.trim()
        : "";
      text2 = [applicantNameText, guardianNameWithRelation].filter(Boolean).join(" ").trim();
      text2 = text2
        ? `${text2}${addressText ? ` | ${addressText}` : ""}`
        : addressText || "-";


      var text3 = ``;

      doc.text(text1, padding, line2Height);
      drawDnDetailValue(
        doc,
        text2,
        doc.getTextWidth(text1) + padding + lineSpace,
        line2Height
      );
      doc.line(
        doc.getTextWidth(text1) + padding,
        line2Height + 1,
        doc.getTextWidth(text1) +
        padding +
        (doc.getTextWidth(text2) + lineSpace * 2),
        line2Height + 1
      );

      doc.setFontSize(6);
      doc.text(
        text3,
        doc.getTextWidth(text1) +
        padding +
        (doc.getTextWidth(text2) + lineSpace * 2),
        line2Height
      );
      //#endregion

      //#region Line 14
      lineHeightIncreament = 4;
      var line2Height = line2Height + lineHeightIncreament;
      doc.setFontSize(fontSize);
      var maxWidth = doc.internal.pageSize.getWidth() - padding * 2;
      var text1 = `You are hereby informed by demand notice that your application for change of name/load/tariff whose particulars are mentioned above has been approved by the authorized officer.`;
      var lines = doc.splitTextToSize(text1, maxWidth);
      // Iterate through each line and add it to the PDF
      for (var i = 0; i < lines.length; i++) {
        doc.text(lines[i], padding, line2Height);
        line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
      }
      //#endregion

      //#region Line 15
      doc.setFontSize(fontSize);
      var maxWidth = doc.internal.pageSize.getWidth() - padding * 2;
      var noOfDays = "30";
      var text1 = `1. You should deposit the following amounts in the approved bank of the department or with the concerned officer of the department itself within [word1] days from the date of issue of this notice and inform my office with the receipt number and date of their payment.`;
      var lines = doc.splitTextToSize(text1, maxWidth);
      // Iterate through each line and add it to the PDF
      for (var i = 0; i < lines.length; i++) {
        var lineText = lines[i].replace("[word1]", noOfDays);
        doc.text(lineText, padding, line2Height);
        line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
      }

      doc.setFontSize(fontSize);
      var maxWidth = doc.internal.pageSize.getWidth() - padding * 2;
      var noOfDays = "30";
      var text1 = `A. Expenditure service connection as per approved estimate ______________ and Security _______________ PKR. (this amount is to be deposited with the concerned officer of the department). If the charges are found to be more than the service approved estimate prior to connection, a deposit equal to the difference in the amount collected will be issued for which additional demand notice will be issued.`;

      // SAFE AMOUNTS
      const capitalText = getAmountText(dnDets.capitalCostAmount);
      const securityText = getAmountText(dnDets.securityDepositeAmount);

      var lines = doc.splitTextToSize(text1, maxWidth);

      // Print bold amounts first
      doc.setFont("helvetica", "bold");
      doc.text(capitalText, 90, line2Height);
      doc.text(securityText, 130, line2Height);
      doc.setFont("helvetica", "normal");

      // Print lines with replace
      for (var i = 0; i < lines.length; i++) {
        var lineText = lines[i]
          .replace("[capitalCost]", capitalText)
          .replace("[securityCost]", securityText);

        doc.text(lineText, padding, line2Height);
        line2Height = line2Height + lineHeightIncreament;
      }
      //#endregion

      //#region Line 18
      doc.setFontSize(fontSize);
      var maxWidth = doc.internal.pageSize.getWidth() - padding * 2;
      var noOfDays = "30";
      var text1 = `NOTE: If you are an applicant or consumer of domestic, commercial, industrial wholesale supply, you should fill the demand notice in this regard on the sub-layer (reserved for your business) and affix your signature and date on it and send back to my office.`;
      var lines = doc.splitTextToSize(text1, maxWidth);
      // Iterate through each line and add it to the PDF
      for (var i = 0; i < lines.length; i++) {
        doc.text(lines[i], padding, line2Height);
        line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
      }
      //#endregion

      //#region Line 22
      doc.text(
        `(Irrelevant should be cut down)`,
        doc.internal.pageSize.getWidth() / 2,
        line2Height,
        {
          align: "center",
        }
      );
      //#endregion

      //#region Line 23
      doc.setFontSize(fontSize);
      var line2Height = line2Height + lineHeightIncreament;
      var maxWidth = doc.internal.pageSize.getWidth() - padding * 2;
      var noOfMonth = "1";
      var text1 = `If you do not comply with the above conditions in response to the demand notice within the prescribed period, your application form for change of name/load/tariff will not be considered with the serial number allotted. Demand notices thereof ( [noOfMonth] month after the date of issue) shall automatically be deemed ineffective.`;
      var lines = doc.splitTextToSize(text1, maxWidth);
      // Iterate through each line and add it to the PDF
      for (var i = 0; i < lines.length; i++) {
        var lineText = lines[i].replace("[noOfMonth]", noOfMonth);
        doc.text(lineText, padding, line2Height);
        line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
      }
      //#endregion

      //#region Line 24
      // doc.setFontSize(fontSize);
      // var line24Y = line2Height;
      // var text1 = "Regards";
      var spaceLeft = 100;
      // doc.text(text1, padding + spaceLeft, line24Y);

      //#endregion

      //#region Line 25
      // doc.setFontSize(fontSize);
      // var line2Height = line2Height + lineHeightIncreament;
      // var text1 =
      //   application.appliedLoad < 15
      //     ? "Sub-Division Office " +
      //       applicationId.slice(3, 8) +
      //       "-" +
      //       subdivisionName(
      //         parseInt(application.subDivisionCode),
      //         subDivisions
      //       ) +
      //       " SDO " +
      //       companyShortName(DiscoCode)
      //     : "Division Office " +
      //       applicationId.slice(3, 7) +
      //       " - " +
      //       divisionName(parseInt(application.divisionCode), subDivisions) +
      //       " XEN " +
      //       companyShortName(DiscoCode);
      // doc.text(text1, padding + spaceLeft, line2Height);
      //#endregion

      //#region Line 26
      doc.setFontSize(fontSize);
      var line2Height = line2Height + lineHeightIncreament;
      // Signature Bank Officer label removed (QR codes use this area)
      //#endregion

      //#region Line 27
      doc.setFontSize(fontSize);
      var line2Height = line2Height + lineHeightIncreament;
      spaceLeft = 10;
      var text1 =
        "--------------------------------------------------------------------------------------------------------------------------------------------------------------------------------";
      doc.text(text1, padding + spaceLeft, line2Height);
      //#endregion

      //#region Line 28
      lineHeightIncreament = 5;
      var line2Height = line2Height + lineHeightIncreament;
      drawDnDueDate(
        doc,
        "DUE Date: " + convertDate(dnDets.dueDate),
        padding,
        line2Height,
        {}
      );
      doc.text(
        "For Bank Use Only",
        doc.internal.pageSize.getWidth() / 2,
        line2Height,
        {
          align: "center",
        }
      );
      //#endregion

      //#region Line 29
      var line2Height = line2Height + lineHeightIncreament;
      doc.text(
        "(The concerned bank will separate this layer from the demand notice and send it to the revenue officer along with its bank scroll)",
        doc.internal.pageSize.getWidth() / 2,
        line2Height,
        {
          align: "center",
        }
      );
      //#endregion

      //#region Line 30
      var line2Height = line2Height + lineHeightIncreament;
      var lineSpace = 16;
      var spaceLeft = 50;

      var text1 = `1. Applicant's Name and Complete address `;
      // prefer DN-level guardian info when available
      var guardianType = (dnDets && dnDets.applicantGuardianType) || application.applicantGuardianType;
      var guardianName = (dnDets && dnDets.applicantGuardianName) || application.applicantGuardianName;
      var guardianText =
        guardianType == 1 || guardianType == 'S/O' ? 'S/O' :
          guardianType == 2 || guardianType == 'D/O' ? 'D/O' :
            guardianType == 3 || guardianType == 'W/O' ? 'W/O' :
              guardianType == 4 || guardianType == 'C/O' ? 'C/O' : '';

      var applicantAddressText = application.consumerAddress
        ? " | " + application.consumerAddress.trim()
        : "";

      var normalizedGuardianName = guardianName ? guardianName.trim() : '';
      var guardianDisplay = guardianText
        ? guardianText + (normalizedGuardianName ? ' ' + normalizedGuardianName : '')
        : normalizedGuardianName;

      var applicantDisplayName = [application.applicantName ? application.applicantName.trim() : '', guardianDisplay]
        .filter(Boolean)
        .join(' ')
        .trim();
      var text2 = applicantDisplayName
        ? applicantDisplayName + applicantAddressText
        : "-";

      var text3 = `Details of paid amount`;

      doc.text(text1, padding, line2Height);
      drawDnDetailValue(
        doc,
        text2,
        doc.getTextWidth(text1) + padding + lineSpace,
        line2Height
      );
      doc.line(
        doc.getTextWidth(text1) + padding,
        line2Height + 1,
        doc.getTextWidth(text1) +
        padding +
        (doc.getTextWidth(text2) + lineSpace * 2),
        line2Height + 1
      );

      doc.setFontSize(6);
      doc.text(
        text3,
        doc.getTextWidth(text1) +
        padding +
        (doc.getTextWidth(text2) + lineSpace * 2 + spaceLeft),
        line2Height
      );
      //#endregion

      //#region Line 31
      doc.setFontSize(fontSize);
      var line2Height = line2Height + lineHeightIncreament;
      var lineSpace = 6.6;

      var text1 = "2. Application Id: ";
      var text2 = application.applicationId ? application.applicationId : "-";
      var text3 = "Date: ";
      var text4 = application.creationDate
        ? convertDate(application.creationDate)
        : "-";
      var text5 = "1. Security:";
      var text6 = dnDets.securityDepositeAmount
        ? numberFormatting(dnDets.securityDepositeAmount)
        : "-";
      var leftSpace = 40;

      doc.text(text1, padding, line2Height);
      drawDnDetailValue(
        doc,
        text2,
        doc.getTextWidth(text1) + padding + lineSpace,
        line2Height
      );
      doc.line(
        doc.getTextWidth(text1) + padding,
        line2Height + 1,
        doc.getTextWidth(text1) +
        padding +
        (doc.getTextWidth(text2) + lineSpace * 2),
        line2Height + 1
      );

      doc.text(
        text3,
        doc.getTextWidth(text1) +
        padding +
        (doc.getTextWidth(text2) + lineSpace * 2),
        line2Height
      );
      drawDnDetailValue(
        doc,
        text4,
        doc.getTextWidth(text2) +
        doc.getTextWidth(text1) +
        doc.getTextWidth(text3) +
        padding +
        lineSpace * 3,
        line2Height
      );
      doc.line(
        doc.getTextWidth(text1) +
        doc.getTextWidth(text2) +
        doc.getTextWidth(text3) +
        padding +
        lineSpace * 2,
        line2Height + 1,
        doc.getTextWidth(text1) +
        doc.getTextWidth(text2) +
        doc.getTextWidth(text3) +
        padding +
        lineSpace * 2 +
        (doc.getTextWidth(text4) + lineSpace * 2),
        line2Height + 1
      );

      doc.text(
        text5,
        doc.getTextWidth(text2) +
        doc.getTextWidth(text1) +
        doc.getTextWidth(text3) +
        padding +
        lineSpace * 2 +
        leftSpace +
        (doc.getTextWidth(text4) + lineSpace * 2),
        line2Height
      );

      doc.setFont("helvetica", "bold");
      drawDnDetailValue(
        doc,
        text6,
        doc.getTextWidth(text1) +
        doc.getTextWidth(text2) +
        doc.getTextWidth(text3) +
        doc.getTextWidth(text4) +
        doc.getTextWidth(text5) +
        padding +
        lineSpace * 5 +
        leftSpace,
        line2Height
      ); // reset back to normal

      doc.line(
        doc.getTextWidth(text1) +
        doc.getTextWidth(text2) +
        doc.getTextWidth(text3) +
        doc.getTextWidth(text4) +
        doc.getTextWidth(text5) +
        padding +
        lineSpace * 4 +
        leftSpace,
        line2Height + 1,
        doc.getTextWidth(text1) +
        doc.getTextWidth(text2) +
        doc.getTextWidth(text3) +
        doc.getTextWidth(text4) +
        doc.getTextWidth(text5) +
        padding +
        lineSpace * 4 +
        doc.getTextWidth(text6) +
        lineSpace * 2 +
        leftSpace,
        line2Height + 1
      );

      //#region Line 32
      doc.setFontSize(fontSize);
      var line2Height = line2Height + lineHeightIncreament;
      var lineSpace = 6.6;
      var text1 = "3. Demand Notice Serial No.: ";
      var text2 = dnDets.demandNoteNo ? dnDets.demandNoteNo : "-";
      var text3 = "Date: ";
      var text4 = dnDets.issueDate ? convertDate(dnDets.issueDate) : "-";
      var text5 = "2. Capital Cost: ";
      var text6 = dnDets.capitalCostAmount
        ? numberFormatting(dnDets.capitalCostAmount)
        : "-";
      var leftSpace = 35;

      doc.text(text1, padding, line2Height);
      drawDnDetailValue(
        doc,
        text2,
        doc.getTextWidth(text1) + padding + lineSpace,
        line2Height
      );
      doc.line(
        doc.getTextWidth(text1) + padding,
        line2Height + 1,
        doc.getTextWidth(text1) +
        padding +
        (doc.getTextWidth(text2) + lineSpace * 2),
        line2Height + 1
      );

      doc.text(
        text3,
        doc.getTextWidth(text1) +
        padding +
        (doc.getTextWidth(text2) + lineSpace * 2),
        line2Height
      );
      drawDnDetailValue(
        doc,
        text4,
        doc.getTextWidth(text2) +
        doc.getTextWidth(text1) +
        doc.getTextWidth(text3) +
        padding +
        lineSpace * 3,
        line2Height
      );
      doc.line(
        doc.getTextWidth(text1) +
        doc.getTextWidth(text2) +
        doc.getTextWidth(text3) +
        padding +
        lineSpace * 2,
        line2Height + 1,
        doc.getTextWidth(text1) +
        doc.getTextWidth(text2) +
        doc.getTextWidth(text3) +
        padding +
        lineSpace * 2 +
        (doc.getTextWidth(text4) + lineSpace * 2),
        line2Height + 1
      );
      const marginTop = 2;

      doc.text(
        text5,
        doc.getTextWidth(text2) +
        doc.getTextWidth(text1) +
        doc.getTextWidth(text3) +
        padding +
        lineSpace * 2 +
        20 +
        (doc.getTextWidth(text4) + lineSpace * 2),
        line2Height + marginTop
      );

      doc.setFont("helvetica", "bold");
      drawDnDetailValue(
        doc,
        text6,
        doc.getTextWidth(text1) +
        doc.getTextWidth(text2) +
        doc.getTextWidth(text3) +
        doc.getTextWidth(text4) +
        doc.getTextWidth(text5) +
        padding +
        lineSpace * 5 +
        20,
        line2Height + marginTop
      );

      doc.setFont("helvetica", "normal");
      doc.line(
        doc.getTextWidth(text1) +
        doc.getTextWidth(text2) +
        doc.getTextWidth(text3) +
        doc.getTextWidth(text4) +
        doc.getTextWidth(text5) +
        padding +
        lineSpace * 4 +
        20,
        line2Height + 1 + marginTop,
        doc.getTextWidth(text1) +
        doc.getTextWidth(text2) +
        doc.getTextWidth(text3) +
        doc.getTextWidth(text4) +
        doc.getTextWidth(text5) +
        padding +
        lineSpace * 4 +
        doc.getTextWidth(text6) +
        lineSpace * 2 +
        leftSpace,
        line2Height + 1 + marginTop
      );

      //#region Line 33
      doc.setFontSize(fontSize);
      var line2Height = line2Height + lineHeightIncreament;
      var lineSpace = 6.6;
      var text1 = "4. Account No. for acquisition connection: ";
      var text2 = dnDets.connectionAccountNo ? dnDets.connectionAccountNo : "-";
      var text3 = " ";
      var text4 = " ";

      doc.text(text1, padding, line2Height);
      drawDnDetailValue(
        doc,
        text2,
        doc.getTextWidth(text1) + padding + lineSpace,
        line2Height
      );
      doc.line(
        doc.getTextWidth(text1) + padding,
        line2Height + 1,
        doc.getTextWidth(text1) +
        padding +
        (doc.getTextWidth(text2) + lineSpace * 2),
        line2Height + 1
      );
      //#endregion

      //#region Line 34
      doc.setFontSize(fontSize);
      var line2Height = line2Height + lineHeightIncreament;
      var lineSpace = 6.6;
      var text1 = "5. Approved bank name and address:";
      var text2 = dnDets.bankName ? dnDets.bankName : "-";
      var text5 = "3. Total: ";
      var text6 = getAmountText(
        parseInt(dnDets.securityDepositeAmount || 0) +
        parseInt(dnDets.capitalCostAmount || 0)
      );
      var leftSpace = 35;

      doc.text(text1, padding, line2Height);
      drawDnDetailValue(
        doc,
        text2,
        doc.getTextWidth(text1) + padding + lineSpace,
        line2Height
      );
      doc.line(
        doc.getTextWidth(text1) + padding,
        line2Height + 1,
        doc.getTextWidth(text1) +
        padding +
        (doc.getTextWidth(text2) + lineSpace * 2),
        line2Height + 1
      );

      doc.text(
        text3,
        doc.getTextWidth(text1) +
        padding +
        (doc.getTextWidth(text2) + lineSpace * 2),
        line2Height
      );
      drawDnDetailValue(
        doc,
        text4,
        doc.getTextWidth(text2) +
        doc.getTextWidth(text1) +
        doc.getTextWidth(text3) +
        padding +
        lineSpace * 3,
        line2Height
      );
      doc.line(
        doc.getTextWidth(text1) +
        doc.getTextWidth(text2) +
        doc.getTextWidth(text3) +
        padding +
        lineSpace * 2,
        line2Height + 1,
        doc.getTextWidth(text1) +
        doc.getTextWidth(text2) +
        doc.getTextWidth(text3) +
        padding +
        lineSpace * 2 +
        (doc.getTextWidth(text4) + lineSpace * 2),
        line2Height + 1
      );

      doc.text(
        text5,
        doc.getTextWidth(text2) +
        doc.getTextWidth(text1) +
        doc.getTextWidth(text3) +
        padding +
        lineSpace * 2 +
        30 +
        (doc.getTextWidth(text4) + lineSpace * 2),
        line2Height
      );

      doc.setFont("helvetica", "bold");
      drawDnDetailValue(
        doc,
        text6,
        doc.getTextWidth(text1) +
        doc.getTextWidth(text2) +
        doc.getTextWidth(text3) +
        doc.getTextWidth(text4) +
        doc.getTextWidth(text5) +
        padding +
        lineSpace * 5 +
        30,
        line2Height
      );

      // 🟡 Add “(NOT Payable)” when applicable
      if (
        dnDets.isDNPayable === false ||
        dnDets.isDNPayable === "false" ||
        dnDets.isDNPayable === null ||
        dnDets.isDNPayable === "null" ||
        dnDets.isDNPayable === 0 ||
        dnDets.isDNPayable === "0" ||
        dnDets.isDNPayable === "" ||
        dnDets.isDNPayable === undefined
      ) {
        doc.setFont("helvetica", "normal");
        doc.setTextColor(255, 0, 0); // 🔴 set red color

        const notPayableText = "(Not Payable)";
        const notPayableX =
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          doc.getTextWidth(text4) +
          doc.getTextWidth(text5) +
          doc.getTextWidth(text6) +
          padding +
          lineSpace * 7 + // small gap
          30;

        doc.text(notPayableText, notPayableX, line2Height);

        doc.setTextColor(0, 0, 0); // ⚫ reset back to black
      }

      doc.setFont("helvetica", "normal");
      doc.line(
        doc.getTextWidth(text1) +
        doc.getTextWidth(text2) +
        doc.getTextWidth(text3) +
        doc.getTextWidth(text4) +
        doc.getTextWidth(text5) +
        padding +
        lineSpace * 4 +
        30,
        line2Height + 1,
        doc.getTextWidth(text1) +
        doc.getTextWidth(text2) +
        doc.getTextWidth(text3) +
        doc.getTextWidth(text4) +
        doc.getTextWidth(text5) +
        padding +
        lineSpace * 4 +
        doc.getTextWidth(text6) +
        lineSpace * 2 +
        leftSpace,
        line2Height + 1
      );

      //#endregion

      //#region Line 35
      doc.setFontSize(fontSize);
      var line2Height =
        line2Height + lineHeightIncreament + lineHeightIncreament;
      // Signature Bank Officer label removed (QR codes use this area)
      //#endregion

      //#region Line 36
      doc.setFontSize(fontSize);
      var line2Height = line2Height + lineHeightIncreament;
      var lineSpace = 6.6;
      var text1 = "                                     ";
      var text2 = " ";
      var text3 = " ";
      var text4 = " ";
      var text5 = " ";
      var text6 = " ";
      var leftSpace = 10;
      doc.setFontSize(6);
      doc.text(text1, padding, line2Height);
      //#endregion

      //#region Line 37
      doc.setFontSize(fontSize);
      var line2Height = line2Height + lineHeightIncreament;
      spaceLeft = 10;
      doc.text(
        "                                                                                               ",
        10,
        line2Height
      );
      var line2Height = line2Height + lineHeightIncreament;
      doc.text(
        "                                                                                               ",
        10,
        line2Height
      );
      var line2Height = line2Height + lineHeightIncreament;
      doc.text(
        "                                                                                               ",
        10,
        line2Height
      );
      var line2Height = line2Height + lineHeightIncreament;
      var text1 =
        "--------------------------------------------------------------------------------------------------------------------------------------------------------------------------------";
      doc.text(text1, padding + spaceLeft, line2Height);
      //#endregion

      //#region Line 38
      lineHeightIncreament = 4;
      var line2Height = line2Height + lineHeightIncreament;
      drawDnDueDate(
        doc,
        (!dnDets.demandNoteExpiryCount ? "Due Date: " : "Extended Due Date: ") +
        convertDate(dnDets.dueDate),
        padding,
        line2Height,
        {}
      );
      doc.text(
        `Applicant's Response`,
        doc.internal.pageSize.getWidth() / 2,
        line2Height,
        {
          align: "center",
        }
      );
      //#endregion

      //#region Line 39
      lineHeightIncreament = 4;
      var line2Height = line2Height + lineHeightIncreament;
      doc.setFontSize(fontSize);
      var maxWidth = doc.internal.pageSize.getWidth() - padding * 2;
      var text1 = `1. I/We have submitted the security amount of [securityCost] and service connection of [capitalCost] only in the department's approved bank [bankName] by receipt no. _______________________________________ on date _______________________________.`;
      var lines = doc.splitTextToSize(text1, maxWidth);
      // Iterate through each line and add it to the PDF
      for (var i = 0; i < lines.length; i++) {
        var lineText = lines[i].replace(
          "[capitalCost]",
          numberFormatting(dnDets.capitalCostAmount)
        );
        lineText = lineText.replace(
          "[securityCost]",
          numberFormatting(dnDets.securityDepositeAmount)
        );
        lineText = lineText.replace(
          "[bankName]",
          dnDets.bankName ? dnDets.bankName : "-"
        );
        doc.text(lineText, padding, line2Height);
        line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
      }
      //#endregion

      //#region Line 40
      doc.setFontSize(fontSize);
      var maxWidth = doc.internal.pageSize.getWidth() - padding * 2;
      var noOfDays = "30";
      var text1 = `2. Since I/We did not provide funds to buy meter to the department, I am/We are responsible to pay monthly rent of ______ PKR as meter rent.`;
      var lines = doc.splitTextToSize(text1, maxWidth);
      // Iterate through each line and add it to the PDF
      for (var i = 0; i < lines.length; i++) {
        doc.text(lines[i], padding, line2Height);
        line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
      }
      //#endregion

      //#region Line 41
      doc.setFontSize(fontSize);
      var maxWidth = doc.internal.pageSize.getWidth() - padding * 2;
      var noOfDays = "30";
      var text1 = `3. I am/We are sending herewith demand notice, a certified list report from a government approved wiring contractor to prove that the internal wiring of my/our building is sound and of standard and that the installation of my/our utility equipment has been completed. I will send within the specified period.`;
      var lines = doc.splitTextToSize(text1, maxWidth);
      // Iterate through each line and add it to the PDF
      for (var i = 0; i < lines.length; i++) {
        doc.text(lines[i], padding, line2Height);
        line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
      }
      //#endregion

      //#region Line 42
      lineHeightIncreament = 5;
      var line2Height = line2Height + lineHeightIncreament;
      doc.text(
        `For Computer Center Use`,
        doc.internal.pageSize.getWidth() / 2,
        line2Height,
        {
          align: "center",
        }
      );
      //#endregion

      //#region Line 43
      var line2Height = line2Height + lineHeightIncreament;
      doc.text(
        `(Demand Notice Data)`,
        doc.internal.pageSize.getWidth() / 2,
        line2Height,
        {
          align: "center",
        }
      );
      //#endregion

      //#region Line 44
      var line2Height = line2Height + lineHeightIncreament;
      var lineHeightIncreament = 5;
      var padding = 10;
      var lineSpace = 7.5;
      var text1 = "Demand Notice Serial No.: ";
      var text2 = dnDets.demandNoteNo ? dnDets.demandNoteNo : "-";
      var text3 = "Application Id: ";
      var text4 = applicationId ? applicationId : "-";
      var text5 = "Application Form No.: ";
      var text6 = dnDets.demandNoteNo ? dnDets.demandNoteNo : "-";

      doc.text(text1, padding, line2Height);
      drawDnDetailValue(
        doc,
        text2,
        doc.getTextWidth(text1) + padding + lineSpace,
        line2Height
      );
      doc.line(
        doc.getTextWidth(text1) + padding,
        line2Height + 1,
        doc.getTextWidth(text1) +
        padding +
        (doc.getTextWidth(text2) + lineSpace * 2),
        line2Height + 1
      );

      doc.text(
        text3,
        doc.getTextWidth(text1) +
        padding +
        (doc.getTextWidth(text2) + lineSpace * 2),
        line2Height
      );
      drawDnDetailValue(
        doc,
        text4,
        doc.getTextWidth(text2) +
        doc.getTextWidth(text1) +
        doc.getTextWidth(text3) +
        padding +
        lineSpace * 3,
        line2Height
      );
      doc.line(
        doc.getTextWidth(text1) +
        doc.getTextWidth(text2) +
        doc.getTextWidth(text3) +
        padding +
        lineSpace * 2,
        line2Height + 1,
        doc.getTextWidth(text1) +
        doc.getTextWidth(text2) +
        doc.getTextWidth(text3) +
        padding +
        lineSpace * 2 +
        (doc.getTextWidth(text4) + lineSpace * 2),
        line2Height + 1
      );

      doc.text(
        text5,
        doc.getTextWidth(text2) +
        doc.getTextWidth(text1) +
        doc.getTextWidth(text3) +
        padding +
        lineSpace * 2 +
        (doc.getTextWidth(text4) + lineSpace * 2),
        line2Height
      );
      drawDnDetailValue(
        doc,
        text6,
        doc.getTextWidth(text1) +
        doc.getTextWidth(text2) +
        doc.getTextWidth(text3) +
        doc.getTextWidth(text4) +
        doc.getTextWidth(text5) +
        padding +
        lineSpace * 5,
        line2Height
      );
      doc.line(
        doc.getTextWidth(text1) +
        doc.getTextWidth(text2) +
        doc.getTextWidth(text3) +
        doc.getTextWidth(text4) +
        doc.getTextWidth(text5) +
        padding +
        lineSpace * 4,
        line2Height + 1,
        doc.getTextWidth(text1) +
        doc.getTextWidth(text2) +
        doc.getTextWidth(text3) +
        doc.getTextWidth(text4) +
        doc.getTextWidth(text5) +
        padding +
        lineSpace * 4 +
        doc.getTextWidth(text6) +
        lineSpace * 2,
        line2Height + 1
      );
      //#endregion

      //#region Line 45
      var lineHeightIncreament = 5;
      var line2Height = line2Height + lineHeightIncreament;
      var padding = 10;
      var lineSpace = 7.5;

      var text1 = "Demand Notice Issuance Date: ";
      var text2 = dnDets.issueDate ? convertDate(dnDets.issueDate) : "-";
      var text3 = "Amount to be paid: ";
      var text4 = dnDets.securityDepositeAmount
        ? numberFormatting(
          parseInt(dnDets.securityDepositeAmount) +
          parseInt(dnDets.capitalCostAmount || 0)
        )
        : "-";

      var text5 = " ";
      var text6 = " ";

      // ---- Normal text (left side)
      doc.setFont("helvetica", "normal");
      doc.text(text1, padding, line2Height);
      drawDnDetailValue(
        doc,
        text2,
        doc.getTextWidth(text1) + padding + lineSpace,
        line2Height
      );
      doc.line(
        doc.getTextWidth(text1) + padding,
        line2Height + 1,
        doc.getTextWidth(text1) +
        padding +
        (doc.getTextWidth(text2) + lineSpace * 2),
        line2Height + 1
      );

      // ---- Bold for Amount section
      doc.setFont("helvetica", "bold");
      doc.text(
        text3,
        doc.getTextWidth(text1) +
        padding +
        (doc.getTextWidth(text2) + lineSpace * 2),
        line2Height
      );
      drawDnDetailValue(
        doc,
        text4,
        doc.getTextWidth(text2) +
        doc.getTextWidth(text1) +
        doc.getTextWidth(text3) +
        padding +
        lineSpace * 3,
        line2Height
      );
      doc.line(
        doc.getTextWidth(text1) +
        doc.getTextWidth(text2) +
        doc.getTextWidth(text3) +
        padding +
        lineSpace * 2,
        line2Height + 1,
        doc.getTextWidth(text1) +
        doc.getTextWidth(text2) +
        doc.getTextWidth(text3) +
        padding +
        lineSpace * 2 +
        (doc.getTextWidth(text4) + lineSpace * 2),
        line2Height + 1
      );

      if (
        dnDets.isDNPayable === false ||
        dnDets.isDNPayable === "false" ||
        dnDets.isDNPayable === null ||
        dnDets.isDNPayable === "null" ||
        dnDets.isDNPayable === 0 ||
        dnDets.isDNPayable === "0" ||
        dnDets.isDNPayable === "" ||
        dnDets.isDNPayable === undefined
      ) {
        doc.setFont("helvetica", "normal");
        doc.setTextColor(255, 0, 0); // 🔴 red color

        const notPayableText = "(Not Payable)";
        const notPayableX =
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          doc.getTextWidth(text4) +
          padding +
          lineSpace * 4;

        doc.text(notPayableText, notPayableX, line2Height);

        doc.setTextColor(0, 0, 0);
        doc.setFont("helvetica", "normal");
      }

      //#endregion

      //#region Line 46
      doc.setFontSize(fontSize);
      var line2Height =
        line2Height + lineHeightIncreament + lineHeightIncreament / 2;
      var lineSpace = 6.6;
      var text1 = " ";
      var text2 = " ";
      var text3 = " ";
      var text4 = " ";
      var text5 = " ";
      var text6 = application.appliedLoad < 15 ? " " : " ";
      var leftSpace = 110;
      drawDnDetailValue(
        doc,
        text6,
        doc.getTextWidth(text1) +
        doc.getTextWidth(text2) +
        doc.getTextWidth(text3) +
        doc.getTextWidth(text4) +
        doc.getTextWidth(text5) +
        padding +
        lineSpace * 5 +
        +leftSpace,
        line2Height
      );
      //#endregion

      //#region Line 47
      doc.setFontSize(6);
      lineHeightIncreament = 2;
      var maxWidth = doc.internal.pageSize.getWidth() - padding * 8;
      var text1 =
        "NOTE - Computer generated demand notice, Hence no signature is required. This subject cited has been processed in accordance with documents uploaded/produced by the owner/appplicant. In case any document is found false at later stages,the said connection is likely to be cancelled and as a result of concealment of facts or fraud at any stage and if codal formalities are not followed and campany reserved its rights to take legal action against owner/applicant. ";
      var lineSpace = 6.6;
      var lines = doc.splitTextToSize(text1, maxWidth);
      for (var i = 0; i < lines.length; i++) {
        doc.text(lines[i], padding, line2Height);
        line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
      }
      //#endregion

      //#endregion

      const totalPages = doc.internal.getNumberOfPages();

      for (let i = 1; i <= totalPages; i++) {
        doc.setPage(i);
        doc.addImage(
          getWaterMarkLogo(DiscoCode),
          "PNG",
          0,
          0,
          doc.internal.pageSize.getWidth(),
          doc.internal.pageSize.getHeight()
        );
      }

      // Open DN PDF in a new tab (same as New Connection)
      const pdfBlob = doc.output("blob");
      const pdfDataUrl = URL.createObjectURL(pdfBlob);
      window.open(pdfDataUrl, "_blank");
    } catch (e) { /* ignored */ }
    setViewBackdrop(false);
  };

  // Handler for dialog DN download with expiry check
  const handleDialogDnDownload = () => {
    if (!canDownloadCoaDemandNotice(dialogRowData?.applicationProgressId)) {
      toast.error(
        "Demand Note download is available from DN Submission (progress 6) onward.",
      );
      return;
    }
    // Show expiry popup ONLY at DN Submission step (applicationProgressId === 6)
    // For other steps, download DN directly even if expired
    if (dialogDnExpiryFlag != 0 && dialogRowData.applicationProgressId === 6) {
      // DN is expired AND we're at DN Submission step, show the expiry popup
      setDnExpiryDialogData({
        applicationId: dialogRowData.applicationId,
        issueDate: dnDets.issueDate,
      });
      setShowDnExpiryPopup(true);
    } else {
      // DN is not expired OR we're not at DN Submission step, proceed with download
      downloadDNPDF(dialogRowData.applicationId, dnDets, dialogRowData);
    }
  };

  const downloadRejectionNoticePDF = async (application) => {
    setViewBackdrop(true);
    try {
      let applicationDetails = { ...application };
      const applicationId = applicationDetails.applicationId;

      if (!applicationDetails.subDivisionCode) {
        try {
          applicationDetails = await SearchIndividualApplication(
            token,
            applicationDetails.applicationId,
            "15"
          );
        } catch (e) { /* ignored */ }
      }

      let rejectionData = null;
      let rejectedBy = "";
      let rejectedOn = "";
      let rejectionStep = "";
      let applicationHistoryData = eFileData;

      if (!applicationHistoryData || applicationHistoryData.length === 0) {
        try {
          const myHeaders = new Headers();
          myHeaders.append("Authorization", token);
          myHeaders.append("Content-Type", "application/json");

          const response = await fetch(
            `${cfpBaseUrl}changeOfAttributes/getBasicCOAHistory`,
            {
              method: "POST",
              headers: myHeaders,
              body: JSON.stringify({ applicationId }),
            }
          );
          const result = await response.json();

          if (result.status === "200" && result.data) {
            const applicationHistory = result.data.history || [];
            applicationHistoryData = [...applicationHistory].sort(
              (a, b) =>
                new Date(b.lastModificationDate || 0) -
                new Date(a.lastModificationDate || 0)
            );
          }
        } catch (e) { /* ignored */ }
      }

      const getStepNameForRejection = (progressId) =>
        progFunc(Number(progressId)) || "Processing";

      if (applicationHistoryData && applicationHistoryData.length > 0) {
        rejectionData = applicationHistoryData.find(
          (item) =>
            Number(item.objectionStatus) === 1 ||
            (item.remarks && item.remarks.toLowerCase().includes("reject"))
        );

        if (rejectionData) {
          rejectedBy = rejectionData.lastModifiedBy || "";
          rejectedOn = rejectionData.lastModificationDate
            ? convertDate(rejectionData.lastModificationDate)
            : "";
          rejectionStep = getStepNameForRejection(
            rejectionData.applicationProgressId
          );
        }
      }

      const rejectionRemarks = rejectionData?.remarks || "";

      if (!rejectionStep) {
        rejectionStep = getStepNameForRejection(
          applicationDetails.applicationProgressId
        );
      }

      const rejectionNoticeNo =
        "FCOA-RN-" + String(applicationId).replace(/^[^-]+-/, "").slice(0, 15);

      const fontSize = 11;
      const doc = new jsPDF({ compressPdf: true });
      const pageWidth = doc.internal.pageSize.getWidth();
      const padding = 20;
      let yPos = 10;
      const lineHeight = 7;

      const discoCode = getDocumentDiscoCode(
        applicationId,
        applicationDetails.companyCode,
      );
      const companyFullName = companyName(discoCode);
      const companyShort = companyShortName(discoCode);

      const smallLogoCodes = ["12", "13", "11", "16", "26", "27", "48", "59"];
      const logoWidth = smallLogoCodes.includes(discoCode) ? 25 : 30;
      const logoHeight = smallLogoCodes.includes(discoCode) ? 15 : 12;

      doc.addImage(getLogo(discoCode), "PNG", padding, yPos, logoWidth, logoHeight);
      doc.addImage(pitcLogo, "PNG", pageWidth - padding - logoWidth, yPos, logoWidth, logoHeight);

      yPos += logoHeight / 2 + 2;
      doc.setFontSize(14);
      doc.setFont("helvetica", "normal");
      doc.text(companyFullName, pageWidth / 2, yPos, { align: "center" });
      yPos += logoHeight / 2 + 5;

      yPos += 15;
      doc.setFontSize(16);
      doc.setFont("helvetica", "bold");
      doc.text("Rejection Notice", pageWidth / 2, yPos, { align: "center" });

      const titleWidth = doc.getTextWidth("Rejection Notice");
      doc.line(
        (pageWidth - titleWidth) / 2,
        yPos + 2,
        (pageWidth + titleWidth) / 2,
        yPos + 2
      );

      yPos += 15;
      doc.setFontSize(fontSize);
      doc.setFont("helvetica", "normal");
      doc.text(
        `Rejection Notice No: ${rejectionNoticeNo}    Rejected On: ${rejectedOn || convertDate(new Date())}`,
        padding,
        yPos
      );

      yPos += 10;
      doc.setFont("helvetica", "bold");
      doc.text(`Rejected at Step: ${rejectionStep}`, padding, yPos);
      doc.setFont("helvetica", "normal");

      if (rejectionRemarks) {
        yPos += 10;
        doc.setFont("helvetica", "bold");
        doc.text("Remarks: ", padding, yPos);
        doc.setFont("helvetica", "normal");
        const remarksText = doc.splitTextToSize(
          rejectionRemarks,
          pageWidth - padding * 2 - doc.getTextWidth("Remarks: ")
        );
        doc.text(remarksText, padding + doc.getTextWidth("Remarks: "), yPos);
        yPos += remarksText.length * lineHeight;
      }

      yPos += 12;
      const applicantDisplayName =
        applicationDetails.applicantName ||
        applicationDetails.consumerName ||
        "";
      const applicantAddress =
        applicationDetails.consumerAddress ||
        applicationDetails.premisesAddress ||
        applicationDetails.address ||
        "-";
      const bodyText = `This is to inform you that ${companyShort} has considered your application for change of attributes of electricity connection vide Tracking No.${applicationId} submitted on ${convertDate(applicationDetails.creationDate)} in the name of ${applicantDisplayName} located at ${applicantAddress}. The authority has rejected your application at the stage "${rejectionStep}".`;

      const splitBody = doc.splitTextToSize(bodyText, pageWidth - padding * 2);
      doc.text(splitBody, padding, yPos);
      yPos += splitBody.length * lineHeight + 5;

      yPos += 10;
      doc.text(
        "This is system generated report and doesn't require signature.",
        padding,
        yPos
      );
      yPos += lineHeight;
      doc.text(
        `Processed by ${rejectedBy || "System"} dated ${rejectedOn || convertDate(new Date())}`,
        padding,
        yPos
      );

      const totalPages = doc.internal.getNumberOfPages();
      for (let i = 1; i <= totalPages; i++) {
        doc.setPage(i);
        doc.addImage(
          getWaterMarkLogo(discoCode),
          "PNG",
          0,
          0,
          doc.internal.pageSize.getWidth(),
          doc.internal.pageSize.getHeight()
        );
      }

      const pdfBlob = doc.output("blob");
      const pdfDataUrl = URL.createObjectURL(pdfBlob);
      window.open(pdfDataUrl, "_blank");
    } catch (e) { /* ignored */ }
    setViewBackdrop(false);
  };

  const downloadEFile = async (application) => {
    setViewBackdrop(true);
    try {
      // Round off values without decimal points for E-File
      const formatAmount = (value) => {
        const num = Number(value) || 0;
        const rounded = Math.round(num);
        return rounded.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      };
      let applicationId = application.applicationId;
      let DiscoCode = getDocumentDiscoCode(
        applicationId,
        application.companyCode,
      );

      // ⬇⬇ GET DOCUMENTS FROM YOUR NEW API
      const applicationDocs = await getDocumentApi(applicationId);

      if (!applicationDocs) {
        return;
      }

      const normalizeEfileDocument = (value) => {
        if (value == null) return "";
        const trimmed = String(value).trim();
        if (
          !trimmed ||
          trimmed.toLowerCase() === "null" ||
          trimmed.toLowerCase() === "undefined"
        ) {
          return "";
        }
        const normalized = normalizeDocumentDataUrl(trimmed);
        return normalized && typeof normalized === "string"
          ? normalized.trim()
          : "";
      };

      // ⬇⬇ CALL E-FILE API TO GET eFileData
      const eFileTableData = await callEfileAPI(applicationId, application);

      let paidDemandNoteImage = "";
      let dnDets = null;
      let boqItems = [];

      // Only call Demand Note API if application has reached DN Approval or higher
      if (application.applicationProgressId >= 5) {
        try {
          const myHeaders = new Headers();
          myHeaders.append("Authorization", token);
          myHeaders.append("Content-Type", "application/json");

          const raw = JSON.stringify({
            applicationId: application.applicationId,
          });

          const requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: raw,
            redirect: "follow",
          };

          const response = await fetch(
            cfpBaseUrl + "changeOfAttributes/getDemandNoteData",
            requestOptions
          );

          const result = await response.json();

          if (
            result.status === "200" &&
            result.data &&
            result.data.length > 0
          ) {
            dnDets = result.data[0];
            paidDemandNoteImage = normalizeEfileDocument(dnDets.paidDNImage);
            boqItems = result.BoQitems || [];
          } else {
          }
        } catch (error) { /* ignored */ }
      } else {
      }

      // Read all document URLs safely
      const copyOfApplicantCNICFront = normalizeEfileDocument(
        applicationDocs.applicantCNICFront,
      );
      const copyOfApplicantCNICBack = normalizeEfileDocument(
        applicationDocs.applicantCNICBack,
      );
      const premisesDocument = normalizeEfileDocument(
        applicationDocs.ownershipImage,
      );
      const scannedCopyOfNearByElectricityBill = normalizeEfileDocument(
        applicationDocs.electricityBill,
      );
      const fbrDocument = normalizeEfileDocument(applicationDocs.fbrDocument);
      const anyOtherDocument = normalizeEfileDocument(
        applicationDocs.anyOtherDocument,
      );

      const hasValidEfileDocument = (value) => {
        const str = normalizeEfileDocument(value);
        if (!str) return false;

        const lower = str.toLowerCase();
        if (lower.startsWith("data:")) {
          if (
            !lower.startsWith("data:image/") &&
            !lower.startsWith("data:application/pdf")
          ) {
            return false;
          }
          const commaIndex = str.indexOf(",");
          if (commaIndex === -1) return false;
          const payload = str.slice(commaIndex + 1).replace(/\s/g, "");
          return payload.length >= 100;
        }
        return (
          lower.startsWith("http://") ||
          lower.startsWith("https://") ||
          lower.startsWith("blob:")
        );
      };

      const hasValidCnicDocument = (value) => hasValidEfileDocument(value);

      const convertPdfDataUrlToImages = async (pdfDataUrl) => {
        try {
          GlobalWorkerOptions.workerSrc =
            "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/4.0.379/pdf.worker.min.mjs";

          const normalized = normalizeEfileDocument(pdfDataUrl);
          if (!normalized) return [];

          const base64Body = String(normalized).includes(",")
            ? String(normalized).split(",")[1]
            : String(normalized).replace(/^data:application\/pdf;base64,/, "");
          const binary = atob(base64Body);
          const bytes = new Uint8Array(binary.length);
          for (let i = 0; i < binary.length; i += 1) {
            bytes[i] = binary.charCodeAt(i);
          }

          const pdf = await getDocument({ data: bytes }).promise;
          const images = [];

          for (let pageNum = 1; pageNum <= pdf.numPages; pageNum += 1) {
            const page = await pdf.getPage(pageNum);
            const viewport = page.getViewport({ scale: 1.5 });
            const canvas = document.createElement("canvas");
            const context = canvas.getContext("2d");
            canvas.height = viewport.height;
            canvas.width = viewport.width;
            await page.render({ canvasContext: context, viewport }).promise;
            images.push(canvas.toDataURL("image/png"));
          }

          return images;
        } catch (error) {
          return [];
        }
      };

      const doc = new jsPDF({ compressPdf: true });

      // Helper function to add page header
      const addPageHeader = (doc, DiscoCode, applicationId, documentTitle) => {
        const pageWidth = doc.internal.pageSize.getWidth();
        const padding = 10;
        const smallLogoCodes = ["12", "13", "11", "16", "26", "27", "48", "59"];
        const logoWidth = smallLogoCodes.includes(DiscoCode) ? 25 : 30;
        const logoHeight = smallLogoCodes.includes(DiscoCode) ? 15 : 8;
        const logoX = (pageWidth - logoWidth) / 2;

        let height = 10;

        doc.addImage(
          getLogo(DiscoCode),
          "PNG",
          logoX,
          5,
          logoWidth,
          logoHeight
        );

        height += 15;
        doc.setFontSize(12);
        doc.setFont("helvetica", "bold");
        doc.text(getCompanies(DiscoCode), pageWidth / 2, height, {
          align: "center",
        });

        height += 10;
        doc.setFont("helvetica", "normal");
        doc.text("Application Id: ", padding, height);
        doc.text(
          applicationId,
          padding + doc.getTextWidth("Application Id: "),
          height
        );

        height += 10;
        const rectWidth = 195;
        const rectHeight = 10;
        const rectX = (pageWidth - rectWidth) / 2;

        doc.setFillColor(199, 199, 199);
        doc.rect(rectX, height - 6.5, rectWidth, rectHeight, "DF");
        doc.setFont("helvetica", "bold");
        doc.text(documentTitle, pageWidth / 2, height, { align: "center" });

        return height + 3.5;
      };

      // Helper function to add document image/PDF with fixed dimensions
      const addDocumentContent = async (
        doc,
        documentData,
        startHeight,
        continuedTitle = "Document (Continued)",
      ) => {
        documentData = normalizeEfileDocument(documentData);
        if (!documentData) {
          return false;
        }

        const pageWidth = doc.internal.pageSize.getWidth();
        const rectWidth = 195;
        const rectHeight = 234;
        const rectX = (pageWidth - rectWidth) / 2;

        const cardWidth = 190;
        const cardHeight = 228;
        const xPos = (pageWidth - cardWidth) / 2;
        const yPos = startHeight + 3;

        const isString = typeof documentData === "string";
        const lower = isString ? documentData.toLowerCase() : "";

        const blobToDataUrl = (blob) =>
          new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.onerror = reject;
            reader.readAsDataURL(blob);
          });

        try {
          if (isString && lower.startsWith("data:image/")) {
            if (lower.includes("jpeg") || lower.includes("jpg")) {
              doc.addImage(documentData, "JPEG", xPos, yPos, cardWidth, cardHeight);
            } else if (lower.includes("png")) {
              doc.addImage(documentData, "PNG", xPos, yPos, cardWidth, cardHeight);
            } else {
              doc.addImage(documentData, "JPEG", xPos, yPos, cardWidth, cardHeight);
            }
            return true;
          }

          if (
            isString &&
            (lower.startsWith("data:application/pdf") || isPdfDataUrl(documentData))
          ) {
            return await addPdfasImage(
              documentData,
              rectX,
              startHeight,
              rectWidth,
              rectHeight,
              continuedTitle,
            );
          }

          if (
            isString &&
            (lower.startsWith("http://") ||
              lower.startsWith("https://") ||
              lower.startsWith("blob:"))
          ) {
            try {
              const response = await fetch(documentData);
              const contentType = (
                response.headers.get("content-type") || ""
              ).toLowerCase();
              const blob = await response.blob();

              if (contentType.includes("pdf")) {
                const dataUrl = await blobToDataUrl(blob);
                return await addPdfasImage(
                  dataUrl,
                  rectX,
                  startHeight,
                  rectWidth,
                  rectHeight,
                  continuedTitle,
                );
              }

              if (contentType.startsWith("image/")) {
                const dataUrl = await blobToDataUrl(blob);
                if (contentType.includes("png")) {
                  doc.addImage(dataUrl, "PNG", xPos, yPos, cardWidth, cardHeight);
                } else {
                  doc.addImage(dataUrl, "JPEG", xPos, yPos, cardWidth, cardHeight);
                }
                return true;
              }
            } catch (err) {
              return false;
            }
          }

          if (isString) {
            try {
              doc.addImage(documentData, "JPEG", xPos, yPos, cardWidth, cardHeight);
              return true;
            } catch (err) {
              return false;
            }
          }
        } catch (err) {
          return false;
        }

        return false;
      };

      // Helper function to add CNIC images with fixed size to fit in border
      const addCNICImage = async (
        doc,
        cnicData,
        startHeight,
        containerHeight = 234
      ) => {
        const pageWidth = doc.internal.pageSize.getWidth();

        const cardWidth = 150;
        const cardHeight = 95;
        const xPos = (pageWidth - cardWidth) / 2;
        const yPos = startHeight + (containerHeight - cardHeight) / 2;

        const normalizedCnic = normalizeEfileDocument(cnicData);
        if (!normalizedCnic) {
          return false;
        }

        if (isPdfDataUrl(normalizedCnic)) {
          const pdfImages = await convertPdfDataUrlToImages(normalizedCnic);
          if (!pdfImages.length) {
            return false;
          }
          doc.addImage(pdfImages[0], "PNG", xPos, yPos, cardWidth, cardHeight);
          return true;
        }

        const fileType = normalizedCnic.slice(0, 6);
        let extension = "";

        if (fileType === "data:i") {
          extension = normalizedCnic.slice(11, 15);
        } else if (fileType === "data:a") {
          extension = normalizedCnic.slice(17, 19);
        }

        if (extension.startsWith("jp")) {
          doc.addImage(normalizedCnic, "jpeg", xPos, yPos, cardWidth, cardHeight);
          return true;
        }
        if (extension.startsWith("pn")) {
          doc.addImage(normalizedCnic, "png", xPos, yPos, cardWidth, cardHeight);
          return true;
        }

        return false;
      };

      const addPdfasImage = async (
        pdfInBase64,
        rectX,
        rectY,
        rectWidth,
        rectHeight,
        continuedTitle = "Document (Continued)",
      ) => {
        const base64ImagesArray = await convertPdfDataUrlToImages(pdfInBase64);

        if (base64ImagesArray.length === 0) {
          return false;
        }

        try {
          const cardWidth = 190;
          const cardHeight = 228;
          const xPos = (doc.internal.pageSize.getWidth() - cardWidth) / 2;
          const yPos = rectY + 3;

          base64ImagesArray.forEach((imageDataUrl, index) => {
            if (index > 0) {
              doc.addPage();
              const contentHeight = addPageHeader(
                doc,
                DiscoCode,
                applicationId,
                continuedTitle,
              );
              doc.rect(rectX, contentHeight, rectWidth, rectHeight);
              doc.addImage(
                imageDataUrl,
                "PNG",
                xPos,
                contentHeight + 3,
                cardWidth,
                cardHeight,
              );
            } else {
              doc.addImage(
                imageDataUrl,
                "PNG",
                xPos,
                yPos,
                cardWidth,
                cardHeight,
              );
            }
          });

          return true;
        } catch (error) {
          return false;
        }
      };

      const removeLastPdfPage = (pageCountBefore) => {
        if (doc.internal.getNumberOfPages() > pageCountBefore) {
          doc.deletePage(doc.internal.getNumberOfPages());
        }
      };

      const addEfileDocumentPage = async (
        documentTitle,
        documentData,
        { useCnic = false } = {},
      ) => {
        const isValid = useCnic
          ? hasValidCnicDocument(documentData)
          : hasValidEfileDocument(documentData);
        if (!isValid) return;

        const pageCountBefore = doc.internal.getNumberOfPages();
        doc.addPage();
        const contentHeight = addPageHeader(
          doc,
          DiscoCode,
          applicationId,
          documentTitle,
        );

        const rectWidth = 195;
        const rectHeight = 234;
        const rectX =
          (doc.internal.pageSize.getWidth() - rectWidth) / 2;
        doc.rect(rectX, contentHeight, rectWidth, rectHeight);

        const rendered = useCnic
          ? await addCNICImage(doc, documentData, contentHeight, rectHeight)
          : await addDocumentContent(
            doc,
            documentData,
            contentHeight,
            `${documentTitle} (Continued)`,
          );

        if (!rendered) {
          removeLastPdfPage(pageCountBefore);
        }
      };

      // FIRST PAGE - Application Summary
      const pageWidth = doc.internal.pageSize.getWidth();
      const pageHeight = doc.internal.pageSize.getHeight();

      // Generate the barcode
      const barcodeCanvas = document.createElement("canvas");
      JsBarcode(barcodeCanvas, applicationId);
      const barcodeDataURL = barcodeCanvas.toDataURL("image/png");

      const smallLogoCodes = ["12", "13", "11", "16", "26", "27", "48", "59"];
      const logoWidth = smallLogoCodes.includes(DiscoCode) ? 25 : 30;
      const logoHeight = smallLogoCodes.includes(DiscoCode) ? 15 : 8;
      const logoX = (pageWidth - logoWidth) / 2;

      doc.addImage(barcodeDataURL, "PNG", pageWidth - 50, 5, 40, 20);
      doc.addImage(getLogo(DiscoCode), "PNG", logoX, 5, logoWidth, logoHeight);

      let height = 25;
      const padding = 10;
      const leftMargin = 50;

      doc.setFontSize(12);
      doc.setFont("helvetica", "bold");
      doc.text(getCompanies(DiscoCode), pageWidth / 2, height, {
        align: "center",
      });

      height += 8;
      doc.setFontSize(18);
      doc.text("E-Document", pageWidth / 2, height, { align: "center" });

      height += 8;
      doc.setFontSize(12);
      doc.setFont("helvetica", "normal");
      height += 8;

      doc.text("Document Type: ", padding, height);
      doc.text(
        `Change of ${application.changeOfAttributesType == 1
          ? "Name"
          : application.changeOfAttributesType == 2
            ? "Load"
            : application.changeOfAttributesType == 3
              ? "Tariff"
              : application.changeOfAttributesType == 4
                ? "Name, Load and Tariff"
                : application.changeOfAttributesType == 5
                  ? "Name and Load"
                  : application.changeOfAttributesType == 6
                    ? "Name and Tariff"
                    : application.changeOfAttributesType == 7
                      ? "Load and Tariff"
                      : ""
        }`,
        padding + leftMargin,
        height
      );
      doc.text("Tracking Id:", padding + leftMargin + leftMargin, height);
      doc.text(
        applicationId,
        padding + leftMargin + leftMargin + leftMargin,
        height
      );

      height += 6;
      doc.text("Application Status: ", padding, height);
      doc.text(
        statusFunc(
          application.applicationProgressId,
          application.objectionStatus
        ),
        padding + leftMargin,
        height
      );
      doc.text("Application Date:", padding + leftMargin + leftMargin, height);
      doc.text(
        convertDate(application.creationDate),
        padding + leftMargin + leftMargin + leftMargin,
        height
      );

      height += 6;
      doc.text("Sub-Division: ", padding, height);
      doc.text(
        subdivisionName(parseInt(application.subDivisionCode), subDivisions),
        padding + leftMargin,
        height
      );
      doc.text("Connection Type:", padding + leftMargin + leftMargin, height);
      doc.text(
        application.connectionType || application.newConnectionType || "-",
        padding + leftMargin + leftMargin + leftMargin,
        height
      );

      height += 6;
      doc.text("Phase / Load: ", padding, height);
      doc.text(
        application.currentSanctionLoad.toString(),
        padding + leftMargin,
        height
      );
      doc.text("Connection Date:", padding + leftMargin + leftMargin, height);
      doc.text("-", padding + leftMargin + leftMargin + leftMargin, height);

      height += 20;
      let rectWidth = 195;
      let rectHeight = 10;
      let rectX = (pageWidth - rectWidth) / 2;

      doc.setFillColor(200, 200, 200);
      doc.rect(rectX, height - 6.5, rectWidth, rectHeight, "DF");
      doc.setFont("helvetica", "bold");
      doc.text("Applicant Particulars", pageWidth / 2, height, {
        align: "center",
      });

      height += 6;
      rectHeight = 30;
      doc.rect(rectX, height - 2.5, rectWidth, rectHeight);

      doc.setFont("helvetica", "normal");
      height += 8;
      const extraPadding = 5;

      doc.text("Applicant Name:", padding + extraPadding, height);
      doc.text(application.applicantName, padding + 70, height);

      height += 6;
      doc.text("CNIC:", padding + extraPadding, height);
      doc.text(application.applicantCNIC, padding + 70, height);

      height += 6;
      doc.text("Present Address:", padding + extraPadding, height);
      doc.text(application.consumerAddress, padding + 70, height);

      height += 6;
      doc.text("Phone No.:", padding + extraPadding, height);
      doc.text(application.applicantPhoneNo, padding + 70, height);

      // Add spacing before Application Summary section
      height += 15;
      rectHeight = 10;

      doc.setFillColor(199, 199, 199);
      doc.rect(rectX, height - 6.5, rectWidth, rectHeight, "DF");
      doc.setFont("helvetica", "bold");
      doc.text("Application Summary", pageWidth / 2, height, {
        align: "center",
      });

      doc.setFontSize(12);
      height += 3.5;

      const summaryTableProps = {
        margin: { left: rectX, right: rectX },
        startY: height,
        tableWidth: rectWidth,
        styles: {
          fontSize: 11,
          fontStyle: "normal",
          halign: "center",
          valign: "middle",
          lineWidth: 0,
          fillColor: [255, 255, 255],
          textColor: [0, 0, 0],
          minCellHeight: 10,
        },
        headStyles: {
          fillColor: [255, 255, 255],
          textColor: [0, 0, 0],
          fontSize: 11,
          fontStyle: "bold",
          halign: "center",
          valign: "middle",
          lineWidth: 0,
        },
        alternateRowStyles: {
          fillColor: [235, 235, 235],
        },
        columnStyles: {
          0: { halign: "center", cellWidth: 15 },
          1: { halign: "center", cellWidth: 40 },
          2: { halign: "center", cellWidth: 35 },
          3: { halign: "center", cellWidth: 30 },
          4: { halign: "center", cellWidth: 65 },
        },
        theme: "plain",
        tableLineWidth: 0.5,
        tableLineColor: [0, 0, 0],
      };

      const summaryData = [];
      // Check if eFileResult exists and has data
      if (eFileTableData && eFileTableData.length > 0) {
        // Sort the array by applicationProgressId in descending order
        const sortedData = [...eFileTableData].sort(
          (a, b) => b.applicationProgressId - a.applicationProgressId
        );

        let srNumber = sortedData.length;

        for (let i = 0; i < sortedData.length; i++) {
          const row = sortedData[i];

          const stepProgressId = stepName(
            row.applicationProgressId,
            row.remarks
          );

          // If applicationProgressId is 1, use "Application Submitted." as remarks
          const remarksToShow =
            row.applicationProgressId === 1
              ? "Application Submitted."
              : row.remarks || "";

          summaryData.push([
            srNumber.toString(),
            row.stepName || "",
            row.processedBy || "",
            convertDatewithTimeWithoutSecond(row.date).slice(0, 11),
            remarksToShow,
          ]);

          srNumber--;
        }
      }
      // Draw the table
      doc.autoTable({
        head: [["Sr.", "Step", "Processed By", "Date", "Remarks"]],
        body: summaryData,
        ...summaryTableProps,
      });

      // ADD OTHER DOCUMENTS ON NEW PAGES
      await addEfileDocumentPage(
        "Applicant CNIC - Front",
        copyOfApplicantCNICFront,
        { useCnic: true },
      );
      await addEfileDocumentPage(
        "Applicant CNIC - Back",
        copyOfApplicantCNICBack,
        { useCnic: true },
      );
      await addEfileDocumentPage("Property Document", premisesDocument);
      await addEfileDocumentPage(
        "Electricity Bill",
        scannedCopyOfNearByElectricityBill,
      );
      await addEfileDocumentPage("FBR Document", fbrDocument);
      await addEfileDocumentPage("Any Other Document", anyOtherDocument);

      if (application.applicationProgressId >= 6) {
        await addEfileDocumentPage("Paid Demand Note", paidDemandNoteImage);
      }
      // ⬇⬇ ADD DEMAND NOTE CONTENT ONLY IF CONDITIONS ARE MET
      if (
        dnDets &&
        dnDets.approvedFlag == 1 &&
        application.applicationProgressId > 5
      ) {
        doc.addPage();

        // === Setup ===
        const fontSize = 8;
        let padding = 10;
        let line2Height = 10;
        let lineHeightIncreament = 5;
        let lineSpace = 12;
        let spaceLeft = 100;
        let leftSpace = 40;

        // Stamp
        const officeCode = application.subDivisionCode;
        const officeName = subdivisionName(parseInt(officeCode), subDivisions);
        const authorizedByName = dnDets.approvedBy || "---";
        const authorizedByDesignation = dnDets.approvedByDesignation || "Role";
        const dateToPrint = dnDets.approvedDate
          ? new Date(dnDets.approvedDate).toLocaleDateString()
          : "---";
        const stampData = printStamp(
          officeCode,
          officeName,
          authorizedByName,
          authorizedByDesignation,
          dateToPrint
        );

        if (dnDets.approvedBy) {
          doc.addImage(stampData, "PNG", 20, 190, 55, 40);
          doc.addImage(stampData, "PNG", 140, 265, 55, 40);
        }

        await addDnPaymentQrCodesToPdf(doc, {
          dnDets,
          applicationId,
          token,
          securityAmount: parseFloat(dnDets.securityDepositeAmount) || 0,
          capitalCost: parseFloat(dnDets.capitalCostAmount) || 0,
          discoCode: DiscoCode,
          layout: COA_DN_QR_LAYOUT,
        });

        // Application Date Formatting
        const yy = applicationId.slice(8, 10);
        const mm = applicationId.slice(10, 12);
        const dd = applicationId.slice(12, 14);
        const monthNames = [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ];
        const formattedDate = `${dd}-${monthNames[parseInt(mm) - 1]}-20${yy}`;

        // Header: Due Date + Company Name
        doc.setFontSize(fontSize);
        doc.setFont("helvetica", "bold");
        drawDnDueDate(
          doc,
          (!dnDets.demandNoteExpiryCount
            ? "Due Date: "
            : "Extended Due Date: ") + convertDate(dnDets.dueDate),
          padding,
          line2Height
        );

        doc.setFont("helvetica", "normal");
        const companyFullName =
          companyName(dnDets.connectionAccountNo.slice(2, 4));

        doc.text(
          companyFullName,
          doc.internal.pageSize.getWidth() / 2,
          line2Height,
          { align: "center" }
        );
        line2Height += lineHeightIncreament;
        doc.text(
          "(Department of Electricity)",
          doc.internal.pageSize.getWidth() / 2,
          line2Height,
          { align: "center" }
        );

        // Line 3: Serial, App ID, Apply Date
        line2Height += lineHeightIncreament;
        lineSpace = 12;
        let text1 = "Demand Notice Serial No.: ";
        let text2 = dnDets.demandNoteNo || "-";
        let text3 = "Application Id: ";
        let text4 = applicationId;
        let text5 = "Apply Date: ";
        let text6 = formattedDate;

        doc.text(text1, padding, line2Height);
        drawDnDetailValue(
          doc,
          text2,
          doc.getTextWidth(text1) + padding + lineSpace,
          line2Height
        );
        doc.line(
          doc.getTextWidth(text1) + padding,
          line2Height + 1,
          doc.getTextWidth(text1) +
          padding +
          doc.getTextWidth(text2) +
          lineSpace * 2,
          line2Height + 1
        );

        doc.text(
          text3,
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          padding +
          lineSpace * 2,
          line2Height
        );
        drawDnDetailValue(
          doc,
          text4,
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 3,
          line2Height
        );
        doc.line(
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 2,
          line2Height + 1,
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 2 +
          doc.getTextWidth(text4) +
          lineSpace * 2,
          line2Height + 1
        );

        doc.text(
          text5,
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          doc.getTextWidth(text4) +
          padding +
          lineSpace * 4,
          line2Height
        );
        drawDnDetailValue(
          doc,
          text6,
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          doc.getTextWidth(text4) +
          doc.getTextWidth(text5) +
          padding +
          lineSpace * 4,
          line2Height
        );
        doc.line(
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          doc.getTextWidth(text4) +
          doc.getTextWidth(text5) +
          padding +
          lineSpace * 4,
          line2Height + 1,
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          doc.getTextWidth(text4) +
          doc.getTextWidth(text5) +
          padding +
          lineSpace * 4 +
          doc.getTextWidth(text6) +
          lineSpace * 2,
          line2Height + 1
        );

        // Line 4
        line2Height += lineHeightIncreament;
        lineSpace = 3.35;
        text1 = "Demand Notice Issuance Date: ";
        text2 = dnDets.issueDate ? convertDate(dnDets.issueDate) : "-";
        text3 = "Application Type: ";
        text4 = application.changeOfAttributesType
          ? applicationName(application.changeOfAttributesType)
          : "-";
        text5 = "Load: ";
        text6 = application.newSanctionLoad
          ? String(application.newSanctionLoad)
          : application.currentSanctionLoad
            ? String(application.currentSanctionLoad)
            : "-";

        doc.text(text1, padding, line2Height);
        drawDnDetailValue(
          doc,
          text2,
          doc.getTextWidth(text1) + padding + lineSpace,
          line2Height
        );
        doc.line(
          doc.getTextWidth(text1) + padding,
          line2Height + 1,
          doc.getTextWidth(text1) +
          padding +
          doc.getTextWidth(text2) +
          lineSpace * 2,
          line2Height + 1
        );

        doc.text(
          text3,
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          padding +
          lineSpace * 2,
          line2Height
        );
        drawDnDetailValue(
          doc,
          text4,
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 3,
          line2Height
        );
        doc.line(
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 2,
          line2Height + 1,
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 2 +
          doc.getTextWidth(text4) +
          lineSpace * 2,
          line2Height + 1
        );

        doc.text(
          text5,
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          doc.getTextWidth(text4) +
          padding +
          lineSpace * 4,
          line2Height
        );
        drawDnDetailValue(
          doc,
          text6,
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          doc.getTextWidth(text4) +
          doc.getTextWidth(text5) +
          padding +
          lineSpace * 5,
          line2Height
        );
        doc.line(
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          doc.getTextWidth(text4) +
          doc.getTextWidth(text5) +
          padding +
          lineSpace * 4,
          line2Height + 1,
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          doc.getTextWidth(text4) +
          doc.getTextWidth(text5) +
          padding +
          lineSpace * 4 +
          doc.getTextWidth(text6) +
          lineSpace * 2,
          line2Height + 1
        );

        // Line 5
        line2Height += lineHeightIncreament;
        lineSpace = 6.6;
        text1 = "Account No. for acquisition connection: ";
        text2 = dnDets.connectionAccountNo || "-";
        text3 = "User Mobile No.: ";
        text4 = application.applicantPhoneNo || "-";
        text5 = "Connection type: ";
        text6 = dnDets.connectionType || dnDets.newConnectionType || "-";

        doc.text(text1, padding, line2Height);
        drawDnDetailValue(
          doc,
          text2,
          doc.getTextWidth(text1) + padding + lineSpace,
          line2Height
        );
        doc.line(
          doc.getTextWidth(text1) + padding,
          line2Height + 1,
          doc.getTextWidth(text1) +
          padding +
          doc.getTextWidth(text2) +
          lineSpace * 2,
          line2Height + 1
        );

        doc.text(
          text3,
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          padding +
          lineSpace * 2,
          line2Height
        );
        drawDnDetailValue(
          doc,
          text4,
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 3,
          line2Height
        );
        doc.line(
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 2,
          line2Height + 1,
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 2 +
          doc.getTextWidth(text4) +
          lineSpace * 2,
          line2Height + 1
        );

        doc.text(
          text5,
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          doc.getTextWidth(text4) +
          padding +
          lineSpace * 4,
          line2Height
        );
        drawDnDetailValue(
          doc,
          text6,
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          doc.getTextWidth(text4) +
          doc.getTextWidth(text5) +
          padding +
          lineSpace * 6,
          line2Height
        );
        doc.line(
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          doc.getTextWidth(text4) +
          doc.getTextWidth(text5) +
          padding +
          lineSpace * 5,
          line2Height + 1,
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          doc.getTextWidth(text4) +
          doc.getTextWidth(text5) +
          padding +
          lineSpace * 5 +
          doc.getTextWidth(text6) +
          lineSpace * 2,
          line2Height + 1
        );

        // Line 6
        line2Height += lineHeightIncreament;
        doc.text(
          "(under which the funds are to be deposited in the bank with the concerned officer of the institution)",
          padding,
          line2Height
        );

        // Line 7 - Tariff and Bank Name
        line2Height += lineHeightIncreament;
        lineSpace = 16;
        text1 = "Alloted Tariff : ";
        text2 = application.newTariff ? application.newTariff : application.currentTariff;
        text3 = "Department's approved Bank name: ";
        text4 = dnDets.bankName || "-";

        doc.text(text1, padding, line2Height);
        drawDnDetailValue(
          doc,
          text2,
          doc.getTextWidth(text1) + padding + lineSpace,
          line2Height
        );
        doc.line(
          doc.getTextWidth(text1) + padding,
          line2Height + 1,
          doc.getTextWidth(text1) +
          padding +
          doc.getTextWidth(text2) +
          lineSpace * 2,
          line2Height + 1
        );

        doc.text(
          text3,
          doc.getTextWidth(text1) +
          padding +
          doc.getTextWidth(text2) +
          lineSpace * 2 + 30,
          line2Height
        );
        drawDnDetailValue(
          doc,
          text4,
          doc.getTextWidth(text1) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 3 + 30,
          line2Height
        );
        doc.line(
          doc.getTextWidth(text1) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 2 + 30,
          line2Height + 1,
          doc.getTextWidth(text1) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 2 +
          doc.getTextWidth(text4) +
          lineSpace * 2 + 30,
          line2Height + 1
        );

        // Title
        line2Height += 15;
        doc.setFont("helvetica", "bold");
        doc.text(
          "DEMAND NOTICE",
          doc.internal.pageSize.getWidth() / 2,
          line2Height,
          { align: "center" }
        );
        doc.setFont("helvetica", "normal");
        line2Height += 8;
        doc.setFont("helvetica", "normal");
        doc.setFontSize(fontSize);
        doc.text(
          "(Notification of Approval Application and Demand Under Guarantee)",
          doc.internal.pageSize.getWidth() / 2,
          line2Height,
          { align: "center" }
        );
        line2Height += lineHeightIncreament;
        doc.text(
          "Applicant's part",
          doc.internal.pageSize.getWidth() / 2,
          line2Height,
          { align: "center" }
        );

        // Applicant Name
        line2Height += lineHeightIncreament;
        lineSpace = 16;
        text1 = "Mr. / Mrs.";
        const guardianRelation =
          application.applicantGuardianType == 1 ? "S/O"
            : application.applicantGuardianType == 2 ? "D/O"
              : application.applicantGuardianType == 3 ? "W/O"
                : application.applicantGuardianType == 4 ? "C/O"
                  : "";
        const applicantNameText = application.applicantName
          ? application.applicantName.trim()
          : "";
        const guardianNameWithRelation = guardianRelation
          ? `${guardianRelation}${application.applicantGuardianName ? ` ${application.applicantGuardianName}` : ""}`
          : "";
        const addressText = application.consumerAddress
          ? application.consumerAddress.trim()
          : "";
        text2 = [applicantNameText, guardianNameWithRelation].filter(Boolean).join(" ").trim();
        text2 = text2
          ? `${text2}${addressText ? ` | ${addressText}` : ""}`
          : addressText || "-";

        doc.text(text1, padding, line2Height);
        drawDnDetailValue(
          doc,
          text2,
          doc.getTextWidth(text1) + padding + lineSpace,
          line2Height
        );
        doc.line(
          doc.getTextWidth(text1) + padding,
          line2Height + 1,
          doc.getTextWidth(text1) +
          padding +
          doc.getTextWidth(text2) +
          lineSpace * 2,
          line2Height + 1
        );

        // Main Content Paragraphs
        lineHeightIncreament = 4;
        line2Height += 5;
        const maxWidth = doc.internal.pageSize.getWidth() - padding * 2;

        const paras = [
          "You are hereby informed by demand notice that your application for change of name/load/tariff whose particulars are mentioned above has been approved by the authorized officer.",
          "1. You should deposit the following amounts in the approved bank of the department or with the concerned officer of the department itself within 30 days from the date of issue of this notice and inform my office with the receipt number and date of their payment.",
          "A. Expenditure service connection as per approved estimate ______________ and Security _______________ PKR. (this amount is to be deposited with the concerned officer of the department). If the charges are found to be more than the service approved estimate prior to connection, a deposit equal to the difference in the amount collected will be issued for which additional demand notice will be issued.",
          "NOTE: If you are an applicant or consumer of domestic, commercial, industrial wholesale supply, you should fill the demand notice in this regard on the sub-layer (reserved for your business) and affix your signature and date on it and send back to my office.",
          "(Irrelevant should be cut down)",
          "If you do not comply with the above conditions in response to the demand notice within the prescribed period, your application form for change of name/load/tariff will not be considered with the serial number allotted. Demand notices thereof (1 month after the date of issue) shall automatically be deemed ineffective.",
        ];

        const capitalText = getAmountText(dnDets.capitalCostAmount || 0);
        const securityText = getAmountText(dnDets.securityDepositeAmount || 0);

        paras.forEach((p, i) => {
          if (i === 4) {
            doc.text(p, doc.internal.pageSize.getWidth() / 2, line2Height, {
              align: "center",
            });
            line2Height += lineHeightIncreament;
            return;
          }

          // For paragraph with amounts, replace placeholders first
          let paraText = p;
          if (i === 2) {
            paraText = p
              .replace("______________", `{{CAPITAL}}`)
              .replace("_______________", `{{SECURITY}}`);
          }

          const lines = doc.splitTextToSize(paraText, maxWidth);

          lines.forEach((line) => {
            if (
              i === 2 &&
              (line.includes("{{CAPITAL}}") || line.includes("{{SECURITY}}"))
            ) {
              // Split line into parts around the placeholders
              const parts = line.split(/({{CAPITAL}}|{{SECURITY}})/g);
              let currentX = padding;

              parts.forEach((part) => {
                if (part === "{{CAPITAL}}") {
                  doc.setFont("helvetica", "bold");
                  doc.text(capitalText, currentX, line2Height);
                  const textWidth = doc.getTextWidth(capitalText);
                  // Draw line below the text
                  doc.line(
                    currentX,
                    line2Height + 1,
                    currentX + textWidth,
                    line2Height + 1
                  );
                  currentX += textWidth;
                  doc.setFont("helvetica", "normal");
                } else if (part === "{{SECURITY}}") {
                  doc.setFont("helvetica", "bold");
                  doc.text(securityText, currentX, line2Height);
                  const textWidth = doc.getTextWidth(securityText);
                  // Draw line below the text
                  doc.line(
                    currentX,
                    line2Height + 1,
                    currentX + textWidth,
                    line2Height + 1
                  );
                  currentX += textWidth;
                  doc.setFont("helvetica", "normal");
                } else if (part) {
                  doc.text(part, currentX, line2Height);
                  currentX += doc.getTextWidth(part);
                }
              });
            } else {
              doc.text(line, padding, line2Height);
            }
            line2Height += lineHeightIncreament;
          });
        });

        doc.setTextColor(220, 0, 0);
        doc.setFont("helvetica", "bold");
        doc.setFontSize(24);
        doc.text(
          "NOT VALID FOR BANKS",
          doc.internal.pageSize.getWidth() / 2,
          145,
          {
            align: "center",
            angle: 320,
          },
        );
        doc.setTextColor(0, 0, 0);
        doc.setFont("helvetica", "normal");
        doc.setFontSize(fontSize);

        // // Signature
        // line2Height += 5;
        // doc.text("Regards", padding + spaceLeft, line2Height);
        // line2Height += 7;
        // doc.text(
        //   application.appliedLoad < 15
        //     ? `Sub-Division Office ${applicationId.slice(
        //       3,
        //       8
        //     )}-${subdivisionName(
        //       parseInt(application.subDivisionCode),
        //       subDivisions
        //     )} SDO ${companyShortName(DiscoCode)}`
        //     : `Division Office ${applicationId.slice(3, 7)} - ${divisionName(
        //       parseInt(application.divisionCode),
        //       subDivisions
        //     )} XEN ${companyShortName(DiscoCode)}`,
        //   padding + spaceLeft,
        //   line2Height
        // );

        // === BANK COPY SECTION (FULL FROM YOUR SECOND CODE) ===
        line2Height += lineHeightIncreament;
        // Signature Bank Officer label removed (QR codes use this area)

        line2Height += lineHeightIncreament;
        doc.text(
          "--------------------------------------------------------------------------------------------------------------------------------------------------------------------------------",
          padding + 10,
          line2Height
        );

        lineHeightIncreament = 5;
        line2Height += lineHeightIncreament;
        drawDnDueDate(
          doc,
          (!dnDets.demandNoteExpiryCount
            ? "Due Date: "
            : "Extended Due Date: ") + convertDate(dnDets.dueDate),
          padding,
          line2Height
        );
        doc.text(
          "For Bank Use Only",
          doc.internal.pageSize.getWidth() / 2,
          line2Height,
          { align: "center" }
        );

        line2Height += lineHeightIncreament;
        doc.text(
          "(The concerned bank will separate this layer from the demand notice and send it to the revenue officer along with its bank scroll)",
          doc.internal.pageSize.getWidth() / 2,
          line2Height,
          { align: "center" }
        );

        line2Height += lineHeightIncreament;
        lineSpace = 16;
        spaceLeft = 50;
        text1 = `1. Applicant's Name and Complete address `;
        var guardianType = (application && application.applicantGuardianType) || application.applicantGuardianType;
        var guardianName = (dnDets && dnDets.applicantGuardianName) || application.applicantGuardianName;

        var guardianText =
          guardianType == 1 || guardianType == 'S/O' ? 'S/O' :
            guardianType == 2 || guardianType == 'D/O' ? 'D/O' :
              guardianType == 3 || guardianType == 'W/O' ? 'W/O' :
                guardianType == 4 || guardianType == 'C/O' ? 'C/O' : '';

        var applicantAddressText = application.consumerAddress
          ? " | " + application.consumerAddress.trim()
          : "";

        var normalizedGuardianName = guardianName ? guardianName.trim() : '';
        var guardianDisplay = guardianText
          ? guardianText + (normalizedGuardianName ? ' ' + normalizedGuardianName : '')
          : normalizedGuardianName;

        var applicantDisplayName = [application.applicantName ? application.applicantName.trim() : '', guardianDisplay]
          .filter(Boolean)
          .join(' ')
          .trim();
        text2 = applicantDisplayName
          ? applicantDisplayName + applicantAddressText
          : "-";
        text3 = `Details of paid amount`;

        doc.text(text1, padding, line2Height);
        drawDnDetailValue(
          doc,
          text2,
          doc.getTextWidth(text1) + padding + lineSpace,
          line2Height
        );
        doc.line(
          doc.getTextWidth(text1) + padding,
          line2Height + 1,
          doc.getTextWidth(text1) +
          padding +
          (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height + 1
        );

        doc.setFontSize(6);
        doc.text(
          text3,
          doc.getTextWidth(text1) +
          padding +
          (doc.getTextWidth(text2) + lineSpace * 2 + spaceLeft),
          line2Height
        );

        // Line 31
        doc.setFontSize(fontSize);
        line2Height += lineHeightIncreament;
        lineSpace = 6.6;
        text1 = "2. Application Id: ";
        text2 = application.applicationId ? application.applicationId : "-";
        text3 = "Date: ";
        text4 = application.creationDate
          ? convertDate(application.creationDate)
          : "-";
        text5 = "1. Security:";
        text6 = dnDets.securityDepositeAmount
          ? numberFormatting(dnDets.securityDepositeAmount)
          : "-";
        leftSpace = 40;

        doc.text(text1, padding, line2Height);
        drawDnDetailValue(
          doc,
          text2,
          doc.getTextWidth(text1) + padding + lineSpace,
          line2Height
        );
        doc.line(
          doc.getTextWidth(text1) + padding,
          line2Height + 1,
          doc.getTextWidth(text1) +
          padding +
          (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height + 1
        );

        doc.text(
          text3,
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          padding +
          lineSpace * 2,
          line2Height
        );
        drawDnDetailValue(
          doc,
          text4,
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 3,
          line2Height
        );
        doc.line(
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 2,
          line2Height + 1,
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 2 +
          (doc.getTextWidth(text4) + lineSpace * 2),
          line2Height + 1
        );

        doc.text(
          text5,
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 2 +
          leftSpace +
          (doc.getTextWidth(text4) + lineSpace * 2),
          line2Height
        );

        doc.setFont("helvetica", "bold");
        drawDnDetailValue(
          doc,
          text6,
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          doc.getTextWidth(text4) +
          doc.getTextWidth(text5) +
          padding +
          lineSpace * 5 +
          leftSpace,
          line2Height
        );
        doc.setFont("helvetica", "normal");

        doc.line(
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          doc.getTextWidth(text4) +
          doc.getTextWidth(text5) +
          padding +
          lineSpace * 4 +
          leftSpace,
          line2Height + 1,
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          doc.getTextWidth(text4) +
          doc.getTextWidth(text5) +
          padding +
          lineSpace * 4 +
          doc.getTextWidth(text6) +
          lineSpace * 2 +
          leftSpace,
          line2Height + 1
        );

        // Line 32
        line2Height += lineHeightIncreament;
        lineSpace = 6.6;
        text1 = "3. Demand Notice Serial No.: ";
        text2 = dnDets.demandNoteNo ? dnDets.demandNoteNo : "-";
        text3 = "Date: ";
        text4 = dnDets.issueDate ? convertDate(dnDets.issueDate) : "-";
        text5 = "2. Capital Cost: ";
        text6 = dnDets.capitalCostAmount
          ? numberFormatting(dnDets.capitalCostAmount)
          : "-";
        leftSpace = 35;

        doc.text(text1, padding, line2Height);
        drawDnDetailValue(
          doc,
          text2,
          doc.getTextWidth(text1) + padding + lineSpace,
          line2Height
        );
        doc.line(
          doc.getTextWidth(text1) + padding,
          line2Height + 1,
          doc.getTextWidth(text1) +
          padding +
          (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height + 1
        );

        doc.text(
          text3,
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          padding +
          lineSpace * 2,
          line2Height
        );
        drawDnDetailValue(
          doc,
          text4,
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 3,
          line2Height
        );
        doc.line(
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 2,
          line2Height + 1,
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 2 +
          (doc.getTextWidth(text4) + lineSpace * 2),
          line2Height + 1
        );

        const marginTop = 2;
        doc.text(
          text5,
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 2 +
          20 +
          (doc.getTextWidth(text4) + lineSpace * 2),
          line2Height + marginTop
        );

        doc.setFont("helvetica", "bold");
        drawDnDetailValue(
          doc,
          text6,
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          doc.getTextWidth(text4) +
          doc.getTextWidth(text5) +
          padding +
          lineSpace * 5 +
          20,
          line2Height + marginTop
        );

        doc.setFont("helvetica", "normal");
        doc.line(
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          doc.getTextWidth(text4) +
          doc.getTextWidth(text5) +
          padding +
          lineSpace * 4 +
          20,
          line2Height + 1 + marginTop,
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          doc.getTextWidth(text4) +
          doc.getTextWidth(text5) +
          padding +
          lineSpace * 4 +
          doc.getTextWidth(text6) +
          lineSpace * 2 +
          leftSpace,
          line2Height + 1 + marginTop
        );

        // Line 33
        line2Height += lineHeightIncreament;
        lineSpace = 6.6;
        text1 = "4. Account No. for acquisition connection: ";
        text2 = dnDets.connectionAccountNo ? dnDets.connectionAccountNo : "-";
        text3 = " ";
        text4 = " ";

        doc.text(text1, padding, line2Height);
        drawDnDetailValue(
          doc,
          text2,
          doc.getTextWidth(text1) + padding + lineSpace,
          line2Height
        );
        doc.line(
          doc.getTextWidth(text1) + padding,
          line2Height + 1,
          doc.getTextWidth(text1) +
          padding +
          (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height + 1
        );

        // Line 34
        line2Height += lineHeightIncreament;
        lineSpace = 6.6;
        text1 = "5. Approved bank name and address:";
        text2 = dnDets.bankName ? dnDets.bankName : "-";
        text5 = "3. Total: ";
        text6 = getAmountText(
          parseInt(dnDets.securityDepositeAmount || 0) +
          parseInt(dnDets.capitalCostAmount || 0)
        );
        leftSpace = 35;

        doc.text(text1, padding, line2Height);
        drawDnDetailValue(
          doc,
          text2,
          doc.getTextWidth(text1) + padding + lineSpace,
          line2Height
        );
        doc.line(
          doc.getTextWidth(text1) + padding,
          line2Height + 1,
          doc.getTextWidth(text1) +
          padding +
          (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height + 1
        );

        doc.text(
          text3,
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          padding +
          lineSpace * 2,
          line2Height
        );
        drawDnDetailValue(
          doc,
          text4,
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 3,
          line2Height
        );
        doc.line(
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 2,
          line2Height + 1,
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 2 +
          (doc.getTextWidth(text4) + lineSpace * 2),
          line2Height + 1
        );

        doc.text(
          text5,
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 2 +
          30 +
          (doc.getTextWidth(text4) + lineSpace * 2),
          line2Height
        );

        doc.setFont("helvetica", "bold");
        drawDnDetailValue(
          doc,
          text6,
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          doc.getTextWidth(text4) +
          doc.getTextWidth(text5) +
          padding +
          lineSpace * 5 +
          30,
          line2Height
        );

        if (
          dnDets.isDNPayable === false ||
          dnDets.isDNPayable === "false" ||
          dnDets.isDNPayable === null ||
          dnDets.isDNPayable === "null" ||
          dnDets.isDNPayable === 0 ||
          dnDets.isDNPayable === "0" ||
          dnDets.isDNPayable === "" ||
          dnDets.isDNPayable === undefined
        ) {
          doc.setFont("helvetica", "normal");
          doc.setTextColor(255, 0, 0);
          const notPayableText = "(Not Payable)";
          const notPayableX =
            doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            doc.getTextWidth(text4) +
            doc.getTextWidth(text5) +
            doc.getTextWidth(text6) +
            padding +
            lineSpace * 7 +
            30;
          doc.text(notPayableText, notPayableX, line2Height);
          doc.setTextColor(0, 0, 0);
        }

        doc.setFont("helvetica", "normal");
        doc.line(
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          doc.getTextWidth(text4) +
          doc.getTextWidth(text5) +
          padding +
          lineSpace * 4 +
          30,
          line2Height + 1,
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          doc.getTextWidth(text4) +
          doc.getTextWidth(text5) +
          padding +
          lineSpace * 4 +
          doc.getTextWidth(text6) +
          lineSpace * 2 +
          leftSpace,
          line2Height + 1
        );

        //  // Line 35
        // line2Height += lineHeightIncreament + lineHeightIncreament;  // Keep original
        // lineSpace = 6.6;
        // text1 = " ";
        // text2 = " ";
        // text3 = " ";
        // text4 = " ";
        // text5 = " ";
        // text6 = "Signature Bank Officer ";
        // leftSpace = 20;
        // doc.text(text1, padding, line2Height);
        // drawDnDetailValue(doc, text6, doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + padding + (lineSpace * 5) + leftSpace, line2Height);

        // // Line 36 - Reduced spacing
        // line2Height += Math.round(lineHeightIncreament * 0.6);  // Was 5 → now ~3px only

        // lineSpace = 6.6;
        // text1 = " ";
        // text2 = " ";
        // text3 = " ";
        // text4 = " ";
        // text5 = " ";
        // text6 = " ";
        // leftSpace = 10;
        // doc.setFontSize(6);
        // doc.text(text1, padding, line2Height);

        // // Line 37 - MASSIVELY REDUCED GAP (from 4 lines → just 1 small gap)
        // line2Height += Math.round(lineHeightIncreament * 0.8);  // Tiny gap (~4px)

        // spaceLeft = 20;
        // doc.text(" ", 10, line2Height);                 // Only 1 blank line instead of 3
        // // Removed the other two blank lines completely

        // line2Height += lineHeightIncreament;  // Final normal spacing before dash
        // doc.text("--------------------------------------------------------------------------------------------------------------------------------------------------------------------------------", padding + spaceLeft, line2Height);

        // Line 35 — Signature Bank Officer label removed (QR codes use this area)
        line2Height += lineHeightIncreament + lineHeightIncreament;
        lineSpace = 6.6;

        // Line 36 — tiny spacing
        line2Height += Math.round(lineHeightIncreament * 0.8);

        // Keep dummy text (no change)
        text1 = " ";
        text2 = " ";
        text3 = " ";
        text4 = " ";
        text5 = " ";
        text6 = " ";
        leftSpace = 10;
        doc.setFontSize(6);
        doc.text(text1, padding, line2Height);

        // Line 37 — reduced gap + dash line
        line2Height += Math.round(lineHeightIncreament * 0.8);
        doc.text(" ", 10, line2Height); // only one tiny blank line

        line2Height += lineHeightIncreament;
        doc.text(
          "--------------------------------------------------------------------------------------------------------------------------------------------------------------------------------",
          padding + 10,
          line2Height
        );

        // Line 38
        lineHeightIncreament = 4;
        line2Height += lineHeightIncreament;
        drawDnDueDate(
          doc,
          (!dnDets.demandNoteExpiryCount
            ? "Due Date: "
            : "Extended Due Date: ") + convertDate(dnDets.dueDate),
          padding,
          line2Height
        );
        doc.text(
          `Applicant's Response`,
          doc.internal.pageSize.getWidth() / 2,
          line2Height,
          { align: "center" }
        );

        // Line 39
        lineHeightIncreament = 4;
        line2Height += lineHeightIncreament;
        doc.setFontSize(fontSize);
        let text = `1. I/We have submitted the security amount of [securityCost] and service connection of [capitalCost] only in the department's approved bank [bankName] by receipt no. _______________________________________ on date _______________________________.`;
        let lines = doc.splitTextToSize(text, maxWidth);
        for (let i = 0; i < lines.length; i++) {
          let lineText = lines[i]
            .replace(
              "[capitalCost]",
              numberFormatting(dnDets.capitalCostAmount)
            )
            .replace(
              "[securityCost]",
              numberFormatting(dnDets.securityDepositeAmount)
            )
            .replace("[bankName]", dnDets.bankName ? dnDets.bankName : "-");
          doc.text(lineText, padding, line2Height);
          line2Height += lineHeightIncreament;
        }

        // Line 40
        text = `2. Since I/We did not provide funds to buy meter to the department, I am/We are responsible to pay monthly rent of ______ PKR as meter rent.`;
        lines = doc.splitTextToSize(text, maxWidth);
        for (let i = 0; i < lines.length; i++) {
          doc.text(lines[i], padding, line2Height);
          line2Height += lineHeightIncreament;
        }

        // Line 41
        text = `3. I am/We are sending herewith demand notice, a certified list report from a government approved wiring contractor to prove that the internal wiring of my/our building is sound and of standard and that the installation of my/our utility equipment has been completed. I will send within the specified period.`;
        lines = doc.splitTextToSize(text, maxWidth);
        for (let i = 0; i < lines.length; i++) {
          doc.text(lines[i], padding, line2Height);
          line2Height += lineHeightIncreament;
        }

        // Line 42
        lineHeightIncreament = 5;
        line2Height += lineHeightIncreament;
        doc.text(
          `For Computer Center Use`,
          doc.internal.pageSize.getWidth() / 2,
          line2Height,
          { align: "center" }
        );

        // Line 43
        line2Height += lineHeightIncreament;
        doc.text(
          `(Demand Notice Data)`,
          doc.internal.pageSize.getWidth() / 2,
          line2Height,
          { align: "center" }
        );

        // Line 44
        line2Height += lineHeightIncreament;
        lineHeightIncreament = 5;
        padding = 10;
        lineSpace = 7.5;
        text1 = "Demand Notice Serial No.: ";
        text2 = dnDets.demandNoteNo ? dnDets.demandNoteNo : "-";
        text3 = "Application Id: ";
        text4 = applicationId ? applicationId : "-";
        text5 = "Application Form No.: ";
        text6 = dnDets.demandNoteNo ? dnDets.demandNoteNo : "-";

        doc.text(text1, padding, line2Height);
        drawDnDetailValue(
          doc,
          text2,
          doc.getTextWidth(text1) + padding + lineSpace,
          line2Height
        );
        doc.line(
          doc.getTextWidth(text1) + padding + lineSpace,
          line2Height + 1,
          doc.getTextWidth(text1) +
          padding +
          lineSpace +
          doc.getTextWidth(text2),
          line2Height + 1
        );

        doc.text(
          text3,
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          padding +
          lineSpace * 2,
          line2Height
        );
        drawDnDetailValue(
          doc,
          text4,
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 3,
          line2Height
        );
        doc.line(
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 3,
          line2Height + 1,
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 4 +
          doc.getTextWidth(text4),
          line2Height + 1
        );

        // Added extra spacing (lineSpace * 5) to move "Application Form No.:" to the right
        doc.text(
          text5,
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          doc.getTextWidth(text4) +
          padding +
          lineSpace * 4,
          line2Height
        );
        drawDnDetailValue(
          doc,
          text6,
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          doc.getTextWidth(text4) +
          doc.getTextWidth(text5) +
          padding +
          lineSpace * 5,
          line2Height
        );
        doc.line(
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          doc.getTextWidth(text4) +
          doc.getTextWidth(text5) +
          padding +
          lineSpace * 5,
          line2Height + 1,
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          doc.getTextWidth(text4) +
          doc.getTextWidth(text5) +
          padding +
          lineSpace * 8 +
          doc.getTextWidth(text6),
          line2Height + 1
        );

        // Line 45
        lineHeightIncreament = 5;
        line2Height += lineHeightIncreament;
        padding = 10;
        lineSpace = 7.5;
        text1 = "Demand Notice Issuance Date: ";
        text2 = dnDets.issueDate ? convertDate(dnDets.issueDate) : "-";
        text3 = "Amount to be paid: ";
        text4 = dnDets.securityDepositeAmount
          ? numberFormatting(
            parseInt(dnDets.securityDepositeAmount) +
            parseInt(dnDets.capitalCostAmount || 0)
          )
          : "-";
        text5 = " ";
        text6 = " ";

        doc.setFont("helvetica", "normal");
        doc.text(text1, padding, line2Height);
        drawDnDetailValue(
          doc,
          text2,
          doc.getTextWidth(text1) + padding + lineSpace,
          line2Height
        );
        doc.line(
          doc.getTextWidth(text1) + padding + lineSpace,
          line2Height + 1,
          doc.getTextWidth(text1) +
          padding +
          lineSpace +
          doc.getTextWidth(text2),
          line2Height + 1
        );

        doc.setFont("helvetica", "normal");
        const text3X =
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          padding +
          lineSpace * 3;
        doc.text(text3, text3X, line2Height);

        doc.setFont("helvetica", "bold");
        const text4X = text3X + doc.getTextWidth(text3) + lineSpace;
        drawDnDetailValue(doc, text4, text4X, line2Height);
        const text4Width = doc.getTextWidth(text4);
        doc.line(text4X, line2Height + 1, text4X + text4Width, line2Height + 1);
        doc.setFont("helvetica", "normal");

        if (
          dnDets.isDNPayable === false ||
          dnDets.isDNPayable === "false" ||
          dnDets.isDNPayable === null ||
          dnDets.isDNPayable === "null" ||
          dnDets.isDNPayable === 0 ||
          dnDets.isDNPayable === "0" ||
          dnDets.isDNPayable === "" ||
          dnDets.isDNPayable === undefined
        ) {
          doc.setTextColor(255, 0, 0);
          const notPayableText = "(Not Payable)";
          const notPayableX = text4X + text4Width + lineSpace;
          doc.text(notPayableText, notPayableX, line2Height);
          doc.setTextColor(0, 0, 0);
        }

        // Line 46
        line2Height += lineHeightIncreament + lineHeightIncreament / 2;
        lineSpace = 6.6;
        text1 = " ";
        text2 = " ";
        text3 = " ";
        text4 = " ";
        text5 = " ";
        text6 = application.appliedLoad < 15 ? " " : " ";
        leftSpace = 110;
        drawDnDetailValue(
          doc,
          text6,
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          doc.getTextWidth(text4) +
          doc.getTextWidth(text5) +
          padding +
          lineSpace * 5 +
          leftSpace,
          line2Height
        );

        // Line 47
        doc.setFontSize(6);
        lineHeightIncreament = 2;
        let noteText =
          "NOTE - Computer generated demand notice, Hence no signature is required. This subject cited has been processed in accordance with documents uploaded/produced by the owner/applicant. In case any document is found false at later stages,the said connection is likely to be cancelled and as a result of concealment of facts or fraud at any stage and if codal formalities are not followed and company reserved its rights to take legal action against owner/applicant. ";
        lines = doc.splitTextToSize(
          noteText,
          doc.internal.pageSize.getWidth() - padding * 8
        );
        for (let i = 0; i < lines.length; i++) {
          doc.text(lines[i], padding, line2Height);
          line2Height += lineHeightIncreament;
        }
      }

      if (application.applicationProgressId >= 5 && dnDets) {
        const smallLogoCodes = ["12", "13", "11", "16", "26", "27", "48", "59"];
        const logoWidth = smallLogoCodes.includes(DiscoCode) ? 25 : 30;
        const logoHeight = smallLogoCodes.includes(DiscoCode) ? 15 : 8;
        const logoX = (pageWidth - logoWidth) / 2;

        const boqHeaders = [["Sr.", "Item Name", "Unit", "Qty", "Amount"]];
        const boqData = [];
        let itemsTotal = 0;

        if (Array.isArray(boqItems) && boqItems.length > 0) {
          const materialsList = await callMaterials(applicationId, token);
          const normalizeCode = (code) => String(code).replace(/^0+/, "");

          for (let i = 0; i < boqItems.length; i++) {
            const rowData = boqItems[i];

            const item = materialsList.find(
              (mat) =>
                normalizeCode(mat.item_Code) ===
                normalizeCode(rowData.itemCode),
            );

            if (!item) {
              continue;
            }

            const serialNo = boqData.length + 1;
            const itemName = item.item_Name;
            const unit = item.item_Unit;
            const qty = numberFormatting(rowData.qty);
            const amount = numberFormatting(rowData.qty * item.item_Amount);
            itemsTotal += rowData.qty * item.item_Amount;

            boqData.push([
              serialNo.toString(),
              itemName,
              unit,
              qty,
              amount,
            ]);
          }
        }

        if (boqData.length > 0) {
          doc.addPage();
          let height = 10;
          doc.addImage(
            getLogo(DiscoCode),
            "PNG",
            logoX,
            5,
            logoWidth,
            logoHeight
          );

          var increment = 15;
          height += increment;
          doc.setFontSize(12);
          doc.setFont("helvetica", "bold");
          doc.text(getCompanies(DiscoCode), pageWidth / 2, height, {
            align: "center",
          });

          increment = 10;
          height += increment;
          doc.text("Application Id: ", padding, height);
          doc.text(
            applicationId,
            padding + doc.getTextWidth("Application Id: "),
            height
          );
          doc.text("Name: ", pageWidth / 2 - 5, height);
          doc.text(
            String(
              application?.consumerName ||
              application?.applicantName ||
              application?.ownerName ||
              "-",
            ),
            pageWidth / 2 - 5 + doc.getTextWidth("Name: "),
            height,
          );
          height += increment;

          doc.setFillColor(199, 199, 199);
          doc.rect(rectX, height - 6.5, rectWidth, rectHeight, "DF");
          doc.setFont("helvetica", "bold");
          doc.text("Items List", pageWidth / 2, height, { align: "center" });

          height += 3.5;
          rectHeight = 230;
          doc.rect(rectX, height, rectWidth, rectHeight);

          const boqTableProps = {
            margin: { top: 0, right: 20, bottom: 20, left: 20 },
            cellHeight: 10,
            headerColor: "#000",
            rowColors: ["#EEE", "#FFF"],
            lineWidth: 1,
            lineColor: "#000",
            headStyles: {
              fillColor: "#FFF",
              textColor: "#000",
              fontSize: 11,
              fontStyle: "bold",
              halign: "left",
              valign: "middle",
            },
            styles: {
              fontSize: 11,
              fontStyle: "normal",
              lineWidth: 0,
              lineColor: [0, 0, 0],
              fillColor: [255, 255, 255],
              textColor: [0, 0, 0],
            },
            alternateRowStyles: { fillColor: [235, 235, 235] },
          };

          doc.autoTable({
            startY: 50,
            head: boqHeaders,
            body: boqData,
            theme: "grid",
            ...boqTableProps,
          });
        }

        doc.addPage();
        let height = 10;
        doc.addImage(
          getLogo(DiscoCode),
          "PNG",
          logoX,
          5,
          logoWidth,
          logoHeight
        );

        var increment = 15;
        height += increment;
        doc.setFontSize(12);
        doc.setFont("helvetica", "bold");
        doc.text(getCompanies(DiscoCode), pageWidth / 2, height, {
          align: "center",
        });

        increment = 10;
        height += increment;
        doc.text("Application Id: ", padding, height);
        doc.text(
          applicationId,
          padding + doc.getTextWidth("Application Id: "),
          height
        );
        doc.text("Name: ", pageWidth / 2 - 5, height);
        doc.text(
          String(
            application?.applicantName ||
            "-",
          ),
          pageWidth / 2 - 5 + doc.getTextWidth("Name: "),
          height,
        );
        height += increment;

        rectWidth = 195;
        rectHeight = 10;
        rectX = (pageWidth - rectWidth) / 2;
        doc.setFillColor(199, 199, 199);
        doc.rect(rectX, height - 6.5, rectWidth, rectHeight, "DF");
        doc.setFont("helvetica", "bold");
        doc.text("Service Cost Estimate", pageWidth / 2, height, {
          align: "center",
        });
        increment = 10;
        height += increment;

        const amountText = (value) => `${formatAmount(value)}.00 /-`;
        const roundInt = (value) => Math.round(Number(value) || 0);

        const itemsTotalValue = roundInt(itemsTotal);
        const isNC13 = applicationId?.slice(3, 5) === "13";
        const storeCharges = isNC13
          ? 0
          : Math.floor((itemsTotalValue * 12 + 50) / 100);
        const installationCharges = Math.floor(
          ((itemsTotalValue + storeCharges) * 8 + 50) / 100,
        );
        const gridSharing = roundInt(dnDets.amountOfGridSharing);
        const feederRehab = roundInt(dnDets.amountOfFeederRehab);
        const civilWork = roundInt(dnDets.civilWorkCharges);
        const metering = roundInt(dnDets.fixedChargesOfMetering);
        const miscCharges = roundInt(dnDets.miscellaneousCharges);
        const mntChargesValue = roundInt(dnDets.mntCharges ?? dnDets.mtCharges);
        const labourChargesValue = roundInt(dnDets.labourCharges);
        const designVettingFeeValue = roundInt(
          dnDets.designVettingFee ?? dnDets.designVetteingFee,
        );
        const consultancyChargesValue = roundInt(dnDets.consultancyCharges);
        const variationChargesValue = roundInt(
          dnDets.variationCharges ?? dnDets.variationsCharges,
        );
        const dismantlementChargesValue = roundInt(
          dnDets.dismantlementCharges ?? dnDets.dismentalmentCharges,
        );
        const earthingChargesValue = roundInt(dnDets.earthingCharges);
        const lessCost = roundInt(dnDets.lessTheCost);
        const securityDeposit = roundInt(dnDets.securityDepositeAmount);

        const subtotalA = itemsTotalValue + storeCharges;
        const subtotalB = installationCharges + gridSharing + feederRehab;
        const subtotalC =
          civilWork + miscCharges + mntChargesValue + labourChargesValue;
        const subtotalD =
          metering +
          designVettingFeeValue +
          consultancyChargesValue +
          variationChargesValue +
          dismantlementChargesValue +
          earthingChargesValue;

        const calculatedNetTotal =
          subtotalA + subtotalB + subtotalC + subtotalD - lessCost;
        const hasApiCapitalCost =
          dnDets.capitalCostAmount !== null &&
          dnDets.capitalCostAmount !== undefined &&
          dnDets.capitalCostAmount !== "";
        const netTotal = hasApiCapitalCost
          ? roundInt(dnDets.capitalCostAmount)
          : calculatedNetTotal;
        const grossTotal = netTotal + lessCost;
        const grandTotal = netTotal + securityDeposit;

        const sectionHeader = (title) => {
          doc.setFillColor(233, 233, 233);
          doc.rect(padding, height - 5, pageWidth - padding * 2, 7, "F");
          doc.setFont("helvetica", "bold");
          doc.setTextColor(44, 62, 80);
          doc.text(title, padding + 3, height);
          doc.setTextColor(0, 0, 0);
          height += 8;
        };

        const drawLine = (label, amount, isBold = false) => {
          const labelX = padding + 12;
          const amountX = pageWidth - padding - 4;
          doc.setFont("helvetica", isBold ? "bold" : "normal");
          doc.text(label, labelX, height);
          doc.setDrawColor(190, 190, 190);
          doc.setLineDash([1, 1], 0);
          doc.line(labelX + 46, height - 1, amountX - 35, height - 1);
          doc.setLineDash([], 0);
          doc.text(amountText(amount), amountX, height, { align: "right" });
          height += 6;
        };

        sectionHeader("A. Material & Store Cost");
        drawLine("Items Total Amount", itemsTotalValue);
        drawLine(isNC13 ? "Store Charges (0%)" : "Store Charges (12%)", storeCharges);
        drawLine("Subtotal (A)", subtotalA, true);

        sectionHeader("B. Installation & Technical Cost");
        drawLine("Installation Charges (8%)", installationCharges);
        drawLine("Grid Sharing Cost", gridSharing);
        drawLine("Feeder Rehab Charges", feederRehab);
        drawLine("Subtotal (B)", subtotalB, true);

        sectionHeader("C. Civil & Miscellaneous");
        drawLine("Civil Work Charges", civilWork);
        drawLine("Misc. Charges", miscCharges);
        drawLine("MNT Charges", mntChargesValue);
        drawLine("Labour Charges", labourChargesValue);
        drawLine("Subtotal (C)", subtotalC, true);

        sectionHeader("D. Other Charges");
        drawLine("Fixed Charges Of Metering", metering);
        drawLine("Design Vetting Fee", designVettingFeeValue);
        drawLine("Consultancy Charges", consultancyChargesValue);
        drawLine("Variation Charges", variationChargesValue);
        drawLine("Dismantlement Charges", dismantlementChargesValue);
        drawLine("Earthing Charges", earthingChargesValue);
        drawLine("Subtotal (D)", subtotalD, true);

        height += 1;
        doc.setDrawColor(150, 150, 150);
        doc.line(padding, height, pageWidth - padding, height);
        height += 6;

        doc.setFont("helvetica", "bold");
        doc.text("Gross Total (A+B+C+D)", padding + 3, height);
        doc.text(amountText(grossTotal), pageWidth - padding - 4, height, {
          align: "right",
        });
        height += 6;

        doc.setTextColor(160, 30, 30);
        doc.text("Less:", padding + 3, height);
        doc.setTextColor(0, 0, 0);
        doc.text("Cost Adjustment", padding + 18, height);
        doc.text(`-${amountText(lessCost)}`, pageWidth - padding - 4, height, {
          align: "right",
        });
        height += 6;

        doc.setFillColor(236, 248, 236);
        doc.rect(padding, height - 5, pageWidth - padding * 2, 8, "F");
        doc.setTextColor(22, 120, 55);
        doc.setFont("helvetica", "bold");
        doc.text("Capital Cost (Net Total)", padding + 3, height);
        doc.text(amountText(netTotal), pageWidth - padding - 4, height, {
          align: "right",
        });
        doc.setTextColor(0, 0, 0);
        height += 6;

        doc.setFont("helvetica", "bold");
        doc.text("Security Deposit", padding + 3, height);
        doc.text(amountText(securityDeposit), pageWidth - padding - 4, height, {
          align: "right",
        });
        height += 7;

        doc.setFillColor(236, 248, 236);
        doc.rect(padding, height - 5, pageWidth - padding * 2, 8, "F");
        doc.setTextColor(22, 120, 55);
        doc.setFont("helvetica", "bold");
        doc.text("GRAND TOTAL PAYABLE", padding + 3, height);
        doc.text(amountText(grandTotal), pageWidth - padding - 4, height, {
          align: "right",
        });
        doc.setTextColor(0, 0, 0);
      }

      // ⬇⬇ ADD SJO PAGE IF CONDITIONS ARE MET
      if (
        dnDets &&
        String(dnDets.sjoData || "").trim() &&
        application.applicationProgressId >= 6
      ) {
        // Get SCO Details for stamp
        let scoDetails = null;
        try {
          const scoHeaders = new Headers();
          scoHeaders.append("Authorization", token);
          scoHeaders.append("Content-Type", "application/json");

          const scoRaw = JSON.stringify({
            applicationId: applicationId,
          });

          const scoRequestOptions = {
            method: "POST",
            headers: scoHeaders,
            body: scoRaw,
            redirect: "follow",
          };

          const scoResponse = await fetch(
            cfpBaseUrl + "changeOfAttributes/getSCODetail",
            scoRequestOptions
          );
          const scoResult = await scoResponse.json();
          if (scoResult.status === "200" && scoResult.data && scoResult.data.length > 0) {
            scoDetails = scoResult.data[0];
          }
        } catch (error) { /* ignored */ }

        doc.addPage();

        const sjoPageWidth = doc.internal.pageSize.getWidth();
        const smallLogoCodes = ["12", "13", "11", "16", "26", "27", "48", "59"];
        const sjoLogoWidth = smallLogoCodes.includes(DiscoCode) ? 25 : 30;
        const sjoLogoHeight = smallLogoCodes.includes(DiscoCode) ? 15 : 8;
        const sjoLogoX = (sjoPageWidth - sjoLogoWidth) / 2;

        let sjoHeight = 10;

        doc.addImage(getLogo(DiscoCode), "PNG", sjoLogoX, 5, sjoLogoWidth, sjoLogoHeight);

        sjoHeight += 15;
        doc.setFontSize(12);
        doc.setFont("helvetica", "bold");
        doc.text(getCompanies(DiscoCode), sjoPageWidth / 2, sjoHeight, {
          align: "center",
        });

        doc.setFontSize(12);
        doc.text("Sundary Job Orders", 105, 34, { align: "center" });

        let sjoY = 50;
        doc.setFontSize(10);

        doc.setFont(undefined, "bold");
        doc.text("Application No.: ", 20, sjoY);
        doc.setFont(undefined, "normal");
        doc.text(applicationId || "-", 60, sjoY);
        doc.setFont(undefined, "bold");
        doc.text("Sub-Division: ", 110, sjoY);
        doc.setFont(undefined, "normal");
        doc.text(
          application.subDivisionCode +
          " (" +
          subdivisionName(
            parseInt(application.subDivisionCode),
            subDivisions
          ) +
          ")" || "-",
          150,
          sjoY
        );
        sjoY += 6;

        doc.setFont(undefined, "bold");
        doc.text("Reference No.: ", 20, sjoY);
        doc.setFont(undefined, "normal");
        doc.text(application.referenceNumber || "-", 60, sjoY);
        doc.setFont(undefined, "bold");
        doc.text("Customer Id: ", 110, sjoY);
        doc.setFont(undefined, "normal");
        doc.text(application.customerId || "-", 150, sjoY);
        sjoY += 6;

        doc.setFont(undefined, "bold");
        doc.text("DN Approval Date: ", 20, sjoY);
        doc.setFont(undefined, "normal");
        doc.text(
          dnDets?.approvedDate ? convertDate(dnDets.approvedDate) : "-",
          60,
          sjoY
        );
        doc.setFont(undefined, "bold");
        doc.text("Meter Number: ", 110, sjoY);
        doc.setFont(undefined, "normal");
        doc.text(dnDets?.meterNo || "-", 150, sjoY);
        sjoY += 6;

        doc.setFont(undefined, "bold");
        doc.text("Feeder Name & Code: ", 20, sjoY);
        doc.setFont(undefined, "normal");
        doc.text(dnDets?.feederNo || "-", 60, sjoY);
        sjoY += 10;

        doc.setFontSize(10);
        doc.setFont(undefined, "normal");

        const sjoText = dnDets.sjoData || "-";
        const sjoMaxWidth = sjoPageWidth - 40;
        const sjoLines = doc.splitTextToSize(sjoText, sjoMaxWidth);

        sjoLines.forEach((line, index) => {
          if (index < sjoLines.length - 1) {
            doc.text(line, 20, sjoY, { align: "justify", maxWidth: sjoMaxWidth });
          } else {
            doc.text(line, 20, sjoY);
          }
          sjoY += 6;
        });

        sjoY += 4;

        const isCurrentNewFormat = [1, 4, 5, 6].includes(
          application.changeOfAttributesType
        );
        const col2Header = isCurrentNewFormat ? "Current" : "Old";
        const col3Header = "New";

        const tableRows = getTableRows(application);

        doc.autoTable({
          startY: sjoY,
          head: [["", col2Header, col3Header]],
          body: tableRows.map((row) => [
            row.label || "-",
            row.current || "-",
            row.newVal || "-",
          ]),
          theme: "grid",
          headStyles: {
            fillColor: [30, 82, 167],
            textColor: [255, 255, 255],
            fontStyle: "bold",
            lineWidth: 0.5,
            lineColor: [21, 101, 192],
            halign: "left",
            cellPadding: { top: 3, right: 5, bottom: 3, left: 5 },
          },
          bodyStyles: {
            lineWidth: 0.5,
            lineColor: [224, 224, 224],
            cellPadding: { top: 4, right: 8, bottom: 4, left: 8 },
          },
          alternateRowStyles: { fillColor: [213, 229, 255] },
          columnStyles: { 0: { fontStyle: "bold" } },
          margin: { left: 20, right: 20 },
          tableWidth: "auto",
        });

        // Add stamp if SCO details available
        if (scoDetails && scoDetails.scoApprovedBy) {
          const sjoOfficeCode = application.subDivisionCode || "---";
          const sjoOfficeName = subdivisionName(parseInt(application.subDivisionCode), subDivisions) || "---";
          const sjoAuthorizedByName = scoDetails.scoApprovedBy || "---";
          const sjoAuthorizedByDesignation = scoDetails.scoApprovedByDesignation || "Role";
          const sjoDateToPrint = scoDetails.scoApprovalDate
            ? new Date(scoDetails.scoApprovalDate).toLocaleDateString()
            : "---";

          const sjoStampData = printStamp(
            sjoOfficeCode,
            sjoOfficeName,
            sjoAuthorizedByName,
            sjoAuthorizedByDesignation,
            sjoDateToPrint
          );

          doc.addImage(sjoStampData, "PNG", 170, 150, 55, 40);
        }
      }

      // Add watermark and page numbers
      const totalPages = doc.internal.getNumberOfPages();

      for (let i = 1; i <= totalPages; i++) {
        doc.setPage(i);
        doc.addImage(
          getWaterMarkLogo(DiscoCode),
          "PNG",
          0,
          0,
          doc.internal.pageSize.getWidth(),
          doc.internal.pageSize.getHeight()
        );
      }

      doc.setFontSize(8);
      for (let i = 1; i <= totalPages; i++) {
        doc.setPage(i);
        const pageNumberY = doc.internal.pageSize.getHeight() - 10;
        doc.text(
          "Page " + i + " of " + totalPages,
          doc.internal.pageSize.getWidth() / 2,
          pageNumberY,
          { align: "center" }
        );
      }

      const pdfBlob = doc.output("blob");
      const pdfURL = URL.createObjectURL(pdfBlob);
      window.open(pdfURL, "_blank");

      setEFileData([]);
    } catch (e) { /* ignored */ } finally {
      setViewBackdrop(false);
    }
  };

  const downloadApplicationPDF = async (application) => {
    setViewBackdrop(true);
    try {
      let applicationId = application.applicationId;
      let DiscoCode = getDocumentDiscoCode(
        applicationId,
        application.companyCode,
      );

      // ⬇⬇ GET DOCUMENTS FROM YOUR NEW API
      const applicationDocs = await getDocumentApi(applicationId);

      if (!applicationDocs) {
        return;
      }

      await callEfileAPI(applicationId, application);

      // ⬇⬇ FETCH DEMAND NOTE DATA FOR CHARGES
      let demandNoteData = null;
      if (application.applicationProgressId >= 5) {
        try {
          const dnHeaders = new Headers();
          dnHeaders.append("Authorization", token);
          dnHeaders.append("Content-Type", "application/json");

          const dnResponse = await fetch(
            cfpBaseUrl + "changeOfAttributes/getDemandNoteData",
            {
              method: "POST",
              headers: dnHeaders,
              body: JSON.stringify({ applicationId }),
              redirect: "follow",
            }
          );
          const dnResult = await dnResponse.json();
          if (dnResult.status === "200" && dnResult.data && dnResult.data[0]) {
            demandNoteData = dnResult.data[0];
          }
        } catch (error) { /* ignored */ }
      }

      // Read all document URLs safely
      const copyOfApplicantCNICFront = applicationDocs.applicantCNICFront || "";
      const copyOfApplicantCNICBack = applicationDocs.applicantCNICBack || "";
      const premisesDocument = applicationDocs.ownershipImage || "";
      const scannedCopyOfNearByElectricityBill =
        applicationDocs.electricityBill || "";
      const fbrDocument = applicationDocs.fbrDocument || "";
      const anyOtherDocument = applicationDocs.anyOtherDocument || "";
      const doc = new jsPDF({ compressPdf: true });

      // Helper function to add page header
      const addPageHeader = (doc, DiscoCode, applicationId, documentTitle) => {
        const pageWidth = doc.internal.pageSize.getWidth();
        const padding = 10;
        const smallLogoCodes = ["12", "13", "11", "16", "26", "27", "48", "59"];
        const logoWidth = smallLogoCodes.includes(DiscoCode) ? 25 : 30;
        const logoHeight = smallLogoCodes.includes(DiscoCode) ? 15 : 8;
        const logoX = (pageWidth - logoWidth) / 2;

        let height = 10;

        // Add logo
        doc.addImage(
          getLogo(DiscoCode),
          "PNG",
          logoX,
          5,
          logoWidth,
          logoHeight
        );

        // Add company name
        height += 15;
        doc.setFontSize(12);
        doc.setFont("helvetica", "bold");
        doc.text(getCompanies(DiscoCode), pageWidth / 2, height, {
          align: "center",
        });

        // Add application ID
        height += 10;
        doc.setFont("helvetica", "normal");
        doc.text("Application Id: ", padding, height);
        doc.text(
          applicationId,
          padding + doc.getTextWidth("Application Id: "),
          height
        );

        // Add document title with border
        height += 10;
        const rectWidth = 195;
        const rectHeight = 10;
        const rectX = (pageWidth - rectWidth) / 2;

        doc.setFillColor(199, 199, 199);
        doc.rect(rectX, height - 6.5, rectWidth, rectHeight, "DF");
        doc.setFont("helvetica", "bold");
        doc.text(documentTitle, pageWidth / 2, height, { align: "center" });

        return height + 3.5; // Return the Y position where content should start
      };

      // Helper function to add document image/PDF with fixed dimensions
      const addDocumentContent = async (doc, documentData, startHeight) => {
        const pageWidth = doc.internal.pageSize.getWidth();
        const rectWidth = 195;
        const rectHeight = 234;
        const rectX = (pageWidth - rectWidth) / 2;

        // Draw rectangle for document
        doc.rect(rectX, startHeight, rectWidth, rectHeight);

        if (!documentData) {
          doc.setFontSize(12);
          doc.text("No document available", pageWidth / 2, startHeight + rectHeight / 2, { align: "center" });
          return;
        }

        // Fixed dimensions to fit within the border (with small padding)
        const cardWidth = 190;
        const cardHeight = 228;
        const xPos = (pageWidth - cardWidth) / 2;
        const yPos = startHeight + 3;

        const isString = typeof documentData === "string";
        const lower = isString ? documentData.toLowerCase() : "";

        const blobToDataUrl = (blob) =>
          new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.onerror = reject;
            reader.readAsDataURL(blob);
          });

        try {
          if (isString && lower.startsWith("data:image/")) {
            if (lower.includes("jpeg") || lower.includes("jpg")) {
              doc.addImage(documentData, "JPEG", xPos, yPos, cardWidth, cardHeight);
            } else if (lower.includes("png")) {
              doc.addImage(documentData, "PNG", xPos, yPos, cardWidth, cardHeight);
            } else {
              doc.addImage(documentData, "JPEG", xPos, yPos, cardWidth, cardHeight);
            }
          } else if (isString && lower.startsWith("data:application/pdf")) {
            await addPdfasImage(documentData, rectX, startHeight, rectWidth, rectHeight);
          } else if (isString && (lower.startsWith("http://") || lower.startsWith("https://") || lower.startsWith("blob:"))) {
            // fetch remote resource and render based on content-type
            try {
              const response = await fetch(documentData);
              const contentType = (response.headers.get("content-type") || "").toLowerCase();
              const blob = await response.blob();

              if (contentType.includes("pdf")) {
                const dataUrl = await blobToDataUrl(blob);
                await addPdfasImage(dataUrl, rectX, startHeight, rectWidth, rectHeight);
              } else if (contentType.startsWith("image/")) {
                const dataUrl = await blobToDataUrl(blob);
                if (contentType.includes("png")) {
                  doc.addImage(dataUrl, "PNG", xPos, yPos, cardWidth, cardHeight);
                } else {
                  doc.addImage(dataUrl, "JPEG", xPos, yPos, cardWidth, cardHeight);
                }
              } else {
                doc.setFontSize(12);
                doc.text("Unsupported document type", pageWidth / 2, yPos + cardHeight / 2, { align: "center" });
              }
            } catch (err) {
              doc.setFontSize(12);
              doc.text("Failed to load remote document", pageWidth / 2, yPos + cardHeight / 2, { align: "center" });
            }
          } else if (isString) {
            // Fallback for non-data URL strings (try image)
            try {
              doc.addImage(documentData, "JPEG", xPos, yPos, cardWidth, cardHeight);
            } catch (err) {
              doc.setFontSize(12);
              doc.text("Failed to render document", pageWidth / 2, yPos + cardHeight / 2, { align: "center" });
            }
          } else {
            doc.setFontSize(12);
            doc.text("Unsupported document format", pageWidth / 2, yPos + cardHeight / 2, { align: "center" });
          }
        } catch (err) {
          doc.setFontSize(12);
          doc.text("Failed to load document", pageWidth / 2, yPos + cardHeight / 2, { align: "center" });
        }
      };

      // Helper function to add CNIC images with fixed size to fit in border
      const addCNICImage = (
        doc,
        cnicData,
        startHeight,
        containerHeight = 234
      ) => {
        const pageWidth = doc.internal.pageSize.getWidth();

        // Fixed CNIC dimensions to fit nicely in the container
        const cardWidth = 150;
        const cardHeight = 95;
        const xPos = (pageWidth - cardWidth) / 2;

        // Center vertically within the container
        const yPos = startHeight + (containerHeight - cardHeight) / 2;

        const fileType = cnicData.slice(0, 6);
        let extension = "";

        if (fileType === "data:i") {
          extension = cnicData.slice(11, 15);
        } else if (fileType === "data:a") {
          extension = cnicData.slice(17, 19);
        }

        if (extension.startsWith("jp")) {
          doc.addImage(cnicData, "jpeg", xPos, yPos, cardWidth, cardHeight);
        } else if (extension.startsWith("pn")) {
          doc.addImage(cnicData, "png", xPos, yPos, cardWidth, cardHeight);
        }

        return yPos + cardHeight;
      };

      const addPdfasImage = async (
        pdfInBase64,
        rectX,
        rectY,
        rectWidth,
        rectHeight
      ) => {
        let base64ImagesArray = [];

        try {
          if (!window.pdfjsLib) {
            await new Promise((resolve, reject) => {
              const script = document.createElement("script");
              script.src =
                "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/4.0.379/pdf.min.mjs";
              script.type = "module";
              script.onload = () => {
                setTimeout(resolve, 100);
              };
              script.onerror = reject;
              document.head.appendChild(script);
            });
          }

          const pdfjsLib = window.pdfjsLib;
          pdfjsLib.GlobalWorkerOptions.workerSrc =
            "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/4.0.379/pdf.worker.min.mjs";

          const pdfData = atob(pdfInBase64.split(",")[1]);
          const pdf = await pdfjsLib.getDocument({ data: pdfData }).promise;
          const docPageNumbers = pdf.numPages;

          const renderPageToBase64 = async (pageNumber) => {
            try {
              const pdfPage = await pdf.getPage(pageNumber);
              const scale = 1.5;
              const viewport = pdfPage.getViewport({ scale });
              const canvas = document.createElement("canvas");
              const canvasContext = canvas.getContext("2d");
              canvas.width = viewport.width;
              canvas.height = viewport.height;
              await pdfPage.render({ canvasContext, viewport }).promise;
              const imageDataUrl = canvas.toDataURL("image/png");
              return imageDataUrl;
            } catch (error) {
              return null;
            }
          };

          for (let i = 1; i <= docPageNumbers; i++) {
            const imageDataUrl = await renderPageToBase64(i);
            if (imageDataUrl) {
              base64ImagesArray.push(imageDataUrl);
            }
          }

          // Fixed dimensions to fit within border
          const cardWidth = 190;
          const cardHeight = 228;
          const xPos = (doc.internal.pageSize.getWidth() - cardWidth) / 2;
          const yPos = rectY + 3;

          base64ImagesArray.forEach((imageDataUrl, index) => {
            if (index > 0) {
              doc.addPage();
              // Add header for additional PDF pages
              const contentHeight = addPageHeader(
                doc,
                DiscoCode,
                applicationId,
                "Property Document (Continued)"
              );
              doc.rect(rectX, contentHeight, rectWidth, rectHeight);
              doc.addImage(
                imageDataUrl,
                "PNG",
                xPos,
                contentHeight + 3,
                cardWidth,
                cardHeight
              );
            } else {
              doc.addImage(
                imageDataUrl,
                "PNG",
                xPos,
                yPos,
                cardWidth,
                cardHeight
              );
            }
          });
        } catch (error) {
          alert("Failed to process PDF document. Please try again.");
        }
      };

      // FIRST PAGE - Application Summary
      const pageWidth = doc.internal.pageSize.getWidth();
      const pageHeight = doc.internal.pageSize.getHeight();

      // Generate the barcode
      const barcodeCanvas = document.createElement("canvas");
      JsBarcode(barcodeCanvas, applicationId);
      const barcodeDataURL = barcodeCanvas.toDataURL("image/png");

      const smallLogoCodes = ["12", "13", "11", "16", "26", "27", "48", "59"];
      const logoWidth = smallLogoCodes.includes(DiscoCode) ? 25 : 30;
      const logoHeight = smallLogoCodes.includes(DiscoCode) ? 15 : 8;
      const logoX = (pageWidth - logoWidth) / 2;

      doc.addImage(barcodeDataURL, "PNG", pageWidth - 50, 5, 40, 20);
      doc.addImage(getLogo(DiscoCode), "PNG", logoX, 5, logoWidth, logoHeight);

      let height = 25;
      const padding = 10;
      const leftMargin = 50;

      doc.setFontSize(12);
      doc.setFont("helvetica", "bold");
      doc.text(getCompanies(DiscoCode), pageWidth / 2, height, {
        align: "center",
      });

      height += 8;
      doc.setFontSize(18);
      doc.text("E-Document", pageWidth / 2, height, { align: "center" });

      height += 8;
      doc.setFontSize(12);
      doc.setFont("helvetica", "normal");
      height += 8;

      doc.text("Document Type: ", padding, height);
      doc.text(
        `Change of ${application.changeOfAttributesType == 1
          ? "Name"
          : application.changeOfAttributesType == 2
            ? "Load"
            : application.changeOfAttributesType == 3
              ? "Tariff"
              : application.changeOfAttributesType == 4
                ? "Name, Load and Tariff"
                : application.changeOfAttributesType == 5
                  ? "Name and Load"
                  : application.changeOfAttributesType == 6
                    ? "Name and Tariff"
                    : application.changeOfAttributesType == 7
                      ? "Load and Tariff"
                      : ""
        }`,
        padding + leftMargin,
        height
      );
      doc.text("Tracking Id:", padding + leftMargin + leftMargin, height);
      doc.text(
        applicationId,
        padding + leftMargin + leftMargin + leftMargin,
        height
      );

      height += 6;
      doc.text("Application Status: ", padding, height);
      doc.text(
        statusFunc(
          application.applicationProgressId,
          application.objectionStatus
        ),
        padding + leftMargin,
        height
      );
      doc.text("Application Date:", padding + leftMargin + leftMargin, height);
      doc.text(
        convertDate(application.creationDate),
        padding + leftMargin + leftMargin + leftMargin,
        height
      );

      height += 6;
      doc.text("Sub-Division: ", padding, height);
      doc.text(
        subdivisionName(parseInt(application.subDivisionCode), subDivisions),
        padding + leftMargin,
        height
      );
      doc.text("Connection Type:", padding + leftMargin + leftMargin, height);
      doc.text(
        application.connectionType || application.newConnectionType || "-",
        padding + leftMargin + leftMargin + leftMargin,
        height
      );

      height += 6;
      doc.text("Phase / Load: ", padding, height);
      doc.text(
        "34",
        //  application.appliedLoad.toString(),
        padding + leftMargin,
        height
      );
      doc.text("Connection Date:", padding + leftMargin + leftMargin, height);
      doc.text("-", padding + leftMargin + leftMargin + leftMargin, height);

      height += 20;
      let rectWidth = 195;
      let rectHeight = 10;
      let rectX = (pageWidth - rectWidth) / 2;

      doc.setFillColor(200, 200, 200);
      doc.rect(rectX, height - 6.5, rectWidth, rectHeight, "DF");
      doc.setFont("helvetica", "bold");
      doc.text("Applicant Particulars", pageWidth / 2, height, {
        align: "center",
      });

      height += 6;
      rectHeight = 30;
      doc.rect(rectX, height - 2.5, rectWidth, rectHeight);

      doc.setFont("helvetica", "normal");
      height += 8;
      const extraPadding = 5;

      doc.text("Applicant Name:", padding + extraPadding, height);
      doc.text(application.applicantName, padding + 70, height);

      height += 6;
      doc.text("CNIC:", padding + extraPadding, height);
      doc.text(application.applicantCNIC, padding + 70, height);

      height += 6;
      doc.text("Present Address:", padding + extraPadding, height);
      doc.text(application.consumerAddress, padding + 70, height);

      height += 6;
      doc.text("Phone No.:", padding + extraPadding, height);
      doc.text(application.applicantPhoneNo, padding + 70, height);

      // Add spacing before Application Summary section
      height += 15;
      rectHeight = 10;

      doc.setFillColor(199, 199, 199);
      doc.rect(rectX, height - 6.5, rectWidth, rectHeight, "DF");
      doc.setFont("helvetica", "bold");
      doc.text(
        "Application Summary",
        doc.internal.pageSize.getWidth() / 2,
        height,
        {
          align: "center",
        }
      );

      doc.setFontSize(12);
      height += 3.5; // Add small spacing after header

      // doc.rect(rectX, height, rectWidth, rectHeight);

      const summaryTableProps = {
        margin: { left: rectX, right: rectX },
        startY: height,
        tableWidth: rectWidth,
        styles: {
          fontSize: 11,
          fontStyle: "normal",
          halign: "center",
          valign: "middle",
          lineWidth: 0,
          fillColor: [255, 255, 255],
          textColor: [0, 0, 0],
          minCellHeight: 10,
        },
        headStyles: {
          fillColor: "#FFF",
          textColor: "#000",
          fontSize: 11,
          fontStyle: "bold",
          halign: "center",
          valign: "middle",
          lineWidth: 0,
        },
        alternateRowStyles: {
          fillColor: [235, 235, 235],
        },
        columnStyles: {
          0: { halign: "center", cellWidth: 15 }, // Sr.
          1: { halign: "center", cellWidth: 40 }, // Step
          2: { halign: "center", cellWidth: 30 }, // Processed By
          3: { halign: "center", cellWidth: 25 }, // Date
          4: { halign: "center", cellWidth: 20 }, // Time
          5: { halign: "left", cellWidth: 65 }, // Remarks
        },
      };

      const summaryData = [];

      // Sort the array by applicationProgressId in descending order
      const sortedData = [...eFileData].sort(
        (a, b) => b.applicationProgressId - a.applicationProgressId
      );

      let srNumber = sortedData.length;

      for (let i = 0; i < sortedData.length; i++) {
        const row = sortedData[i];

        const stepProgressId = stepName(row.applicationProgressId, row.remarks);

        // If applicationProgressId is 1, use "Application Submitted." as remarks
        const remarksToShow =
          row.applicationProgressId === 1
            ? "Application Submitted."
            : row.remarks;

        summaryData.push([
          srNumber.toString(),
          stepProgressId || "",
          row.lastModifiedBy,
          convertDatewithTimeWithoutSecond(row.lastModificationDate).slice(
            0,
            11
          ),
          convertDatewithTimeWithoutSecond(row.lastModificationDate).slice(11),
          remarksToShow,
        ]);

        srNumber--;
      }

      // Draw the table - it will automatically fit within the specified width
      doc.autoTable({
        startY: height + 5,
        head: [["Sr.", "Step", "Processed By", "Date", "Time", "Remarks"]],
        body: summaryData,
        theme: "grid",
        ...summaryTableProps,
      });

      // ⬇⬇ ADD CHARGES DETAILS SECTION (NEW PAGE)
      if (demandNoteData) {
        doc.addPage();

        // Add header for charges page
        const chargesPageWidth = doc.internal.pageSize.getWidth();
        const chargesPadding = 10;
        const chargesSmallLogoCodes = ["12", "13", "11", "16", "26", "27", "48", "59"];
        const chargesLogoWidth = chargesSmallLogoCodes.includes(DiscoCode) ? 25 : 30;
        const chargesLogoHeight = chargesSmallLogoCodes.includes(DiscoCode) ? 15 : 8;
        const chargesLogoX = (chargesPageWidth - chargesLogoWidth) / 2;

        let chargesHeight = 10;

        // Add logo
        doc.addImage(
          getLogo(DiscoCode),
          "PNG",
          chargesLogoX,
          5,
          chargesLogoWidth,
          chargesLogoHeight
        );

        // Add company name
        chargesHeight += 15;
        doc.setFontSize(12);
        doc.setFont("helvetica", "bold");
        doc.text(getCompanies(DiscoCode), chargesPageWidth / 2, chargesHeight, {
          align: "center",
        });

        // Add application ID
        chargesHeight += 10;
        doc.setFont("helvetica", "normal");
        doc.text("Application Id: ", chargesPadding, chargesHeight);
        doc.text(
          applicationId,
          chargesPadding + doc.getTextWidth("Application Id: "),
          chargesHeight
        );

        // Add Charges Details title
        chargesHeight += 10;
        const chargesRectWidth = 195;
        const chargesRectX = (chargesPageWidth - chargesRectWidth) / 2;

        doc.setFillColor(199, 199, 199);
        doc.rect(chargesRectX, chargesHeight - 6.5, chargesRectWidth, 10, "DF");
        doc.setFont("helvetica", "bold");
        doc.text("Charges Details", chargesPageWidth / 2, chargesHeight, { align: "center" });

        chargesHeight += 10;

        // Helper function to format amounts
        const formatChargeAmount = (value) => {
          const num = parseFloat(value) || 0;
          return num.toLocaleString();
        };

        // Check if it's NC13 case (store charges 0%)
        const isNC13Case = applicationId?.slice(3, 5) === "13";

        // Calculate charges
        const itemsTotalValue = parseFloat(demandNoteData.capitalCostAmount) || 0;
        const storeChargesValue = isNC13Case
          ? 0
          : Math.floor((itemsTotalValue * 12 + 50) / 100);
        const installationChargesValue = Math.floor(
          ((itemsTotalValue + storeChargesValue) * 8 + 50) / 100
        );
        const feederRehabValue = parseFloat(demandNoteData.amountOfFeederRehab) || 0;
        const civilWorkValue = parseFloat(demandNoteData.civilWorkCharges) || 0;
        const mntChargesValue =
          parseFloat(demandNoteData.mntCharges ?? demandNoteData.mtCharges) || 0;
        const labourChargesValue = parseFloat(demandNoteData.labourCharges) || 0;
        const designVettingFeeValue =
          parseFloat(
            demandNoteData.designVettingFee ?? demandNoteData.designVetteingFee
          ) || 0;
        const consultancyChargesValue = parseFloat(demandNoteData.consultancyCharges) || 0;
        const variationChargesValue =
          parseFloat(
            demandNoteData.variationCharges ?? demandNoteData.variationsCharges
          ) || 0;
        const dismantlementChargesValue =
          parseFloat(
            demandNoteData.dismantlementCharges ?? demandNoteData.dismentalmentCharges
          ) || 0;
        const earthingChargesValue = parseFloat(demandNoteData.earthingCharges) || 0;
        const fixedChargesValue = parseFloat(demandNoteData.fixedChargesOfMetering) || 0;
        const miscChargesValue = parseFloat(demandNoteData.miscellaneousCharges) || 0;
        const gridSharingValue = parseFloat(demandNoteData.amountOfGridSharing) || 0;
        const lessTheCostValue = parseFloat(demandNoteData.lessTheCost) || 0;
        const securityDepositValue = parseFloat(demandNoteData.securityDepositeAmount) || 0;

        // Calculate grand total
        const grandTotalValue =
          itemsTotalValue +
          storeChargesValue +
          installationChargesValue +
          feederRehabValue +
          civilWorkValue +
          mntChargesValue +
          labourChargesValue +
          designVettingFeeValue +
          consultancyChargesValue +
          variationChargesValue +
          dismantlementChargesValue +
          earthingChargesValue +
          fixedChargesValue +
          miscChargesValue +
          gridSharingValue -
          lessTheCostValue +
          securityDepositValue;

        // Build charges data for table
        const chargesData = [];

        if (itemsTotalValue > 0) {
          chargesData.push(["Material Cost", `Rs. ${formatChargeAmount(itemsTotalValue)}`]);
        }
        chargesData.push([isNC13Case ? "Store Charges (0%)" : "Store Charges (12%)", `Rs. ${formatChargeAmount(storeChargesValue)}`]);
        chargesData.push(["Installation Charges (8%)", `Rs. ${formatChargeAmount(installationChargesValue)}`]);
        if (feederRehabValue > 0) {
          chargesData.push(["Feeder Rehab. Charges", `Rs. ${formatChargeAmount(feederRehabValue)}`]);
        }
        if (civilWorkValue > 0) {
          chargesData.push(["Civil Work Charges", `Rs. ${formatChargeAmount(civilWorkValue)}`]);
        }
        if (mntChargesValue > 0) {
          chargesData.push(["M&T Charges", `Rs. ${formatChargeAmount(mntChargesValue)}`]);
        }
        if (labourChargesValue > 0) {
          chargesData.push(["Labour Charges", `Rs. ${formatChargeAmount(labourChargesValue)}`]);
        }
        if (designVettingFeeValue > 0) {
          chargesData.push(["Design Vetting Fee", `Rs. ${formatChargeAmount(designVettingFeeValue)}`]);
        }
        if (consultancyChargesValue > 0) {
          chargesData.push(["Consultancy Charges", `Rs. ${formatChargeAmount(consultancyChargesValue)}`]);
        }
        if (variationChargesValue > 0) {
          chargesData.push(["Variation Charges", `Rs. ${formatChargeAmount(variationChargesValue)}`]);
        }
        if (dismantlementChargesValue > 0) {
          chargesData.push(["Dismantlement Charges", `Rs. ${formatChargeAmount(dismantlementChargesValue)}`]);
        }
        if (earthingChargesValue > 0) {
          chargesData.push(["Earthing Charges", `Rs. ${formatChargeAmount(earthingChargesValue)}`]);
        }
        if (fixedChargesValue > 0) {
          chargesData.push(["Fixed Charges of Metering", `Rs. ${formatChargeAmount(fixedChargesValue)}`]);
        }
        if (miscChargesValue > 0) {
          chargesData.push(["Miscellaneous Charges", `Rs. ${formatChargeAmount(miscChargesValue)}`]);
        }
        if (gridSharingValue > 0) {
          chargesData.push(["Grid Sharing Cost", `Rs. ${formatChargeAmount(gridSharingValue)}`]);
        }
        if (lessTheCostValue > 0) {
          chargesData.push(["Less the Cost", `Rs. -${formatChargeAmount(lessTheCostValue)}`]);
        }
        if (securityDepositValue > 0) {
          chargesData.push(["Security Deposit", `Rs. ${formatChargeAmount(securityDepositValue)}`]);
        }
        chargesData.push(["Grand Total", `Rs. ${formatChargeAmount(grandTotalValue)}`]);

        // Draw charges table
        doc.autoTable({
          startY: chargesHeight,
          head: [["Description", "Amount"]],
          body: chargesData,
          theme: "grid",
          margin: { left: chargesRectX, right: chargesRectX },
          tableWidth: chargesRectWidth,
          styles: {
            fontSize: 11,
            fontStyle: "normal",
            halign: "left",
            valign: "middle",
            lineWidth: 0.1,
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0],
            minCellHeight: 8,
          },
          headStyles: {
            fillColor: [200, 200, 200],
            textColor: [0, 0, 0],
            fontSize: 11,
            fontStyle: "bold",
            halign: "center",
            valign: "middle",
          },
          columnStyles: {
            0: { halign: "left", cellWidth: 120 },
            1: { halign: "right", cellWidth: 75 },
          },
          didParseCell: function (data) {
            // Make Grand Total row bold
            if (data.row.index === chargesData.length - 1) {
              data.cell.styles.fontStyle = "bold";
              data.cell.styles.fillColor = [230, 230, 230];
            }
          },
        });
      }

      // ADD OTHER DOCUMENTS ON NEW PAGES
      if (copyOfApplicantCNICFront !== "") {
        doc.addPage();
        let contentHeight = addPageHeader(
          doc,
          DiscoCode,
          applicationId,
          "Applicant CNIC - Front"
        );

        const rectWidth = 195;
        const rectHeight = 234;
        const rectX = (pageWidth - rectWidth) / 2;
        doc.rect(rectX, contentHeight, rectWidth, rectHeight);

        await addCNICImage(
          doc,
          copyOfApplicantCNICFront,
          contentHeight,
          rectHeight
        );
      }

      if (copyOfApplicantCNICBack !== "") {
        doc.addPage();
        let contentHeight = addPageHeader(
          doc,
          DiscoCode,
          applicationId,
          "Applicant CNIC - Back"
        );

        const rectWidth = 195;
        const rectHeight = 234;
        const rectX = (pageWidth - rectWidth) / 2;
        doc.rect(rectX, contentHeight, rectWidth, rectHeight);

        await addCNICImage(
          doc,
          copyOfApplicantCNICBack,
          contentHeight,
          rectHeight
        );
      }

      // PREMISES DOCUMENT
      if (premisesDocument !== "") {
        doc.addPage();
        let contentHeight = addPageHeader(
          doc,
          DiscoCode,
          applicationId,
          "Property Document"
        );
        await addDocumentContent(doc, premisesDocument, contentHeight);
      }

      // NEARBY ELECTRICITY BILL
      if (scannedCopyOfNearByElectricityBill !== "") {
        doc.addPage();
        let contentHeight = addPageHeader(
          doc,
          DiscoCode,
          applicationId,
          "Electricity Bill"
        );
        await addDocumentContent(
          doc,
          scannedCopyOfNearByElectricityBill,
          contentHeight
        );
      }

      // FBR DOCUMENT
      if (fbrDocument !== "") {
        doc.addPage();
        let contentHeight = addPageHeader(
          doc,
          DiscoCode,
          applicationId,
          "FBR Document"
        );
        await addDocumentContent(doc, fbrDocument, contentHeight);
      }

      // ANY OTHER DOCUMENT
      if (anyOtherDocument !== "") {
        doc.addPage();
        let contentHeight = addPageHeader(
          doc,
          DiscoCode,
          applicationId,
          "Any Other Document"
        );
        await addDocumentContent(doc, anyOtherDocument, contentHeight);
      }

      // Add watermark and page numbers
      const totalPages = doc.internal.getNumberOfPages();

      for (let i = 1; i <= totalPages; i++) {
        doc.setPage(i);
        doc.addImage(
          getWaterMarkLogo(DiscoCode),
          "PNG",
          0,
          0,
          doc.internal.pageSize.getWidth(),
          doc.internal.pageSize.getHeight()
        );
      }

      doc.setFontSize(8);
      for (let i = 1; i <= totalPages; i++) {
        doc.setPage(i);
        const pageNumberY = doc.internal.pageSize.getHeight() - 10;
        doc.text(
          "Page " + i + " of " + totalPages,
          doc.internal.pageSize.getWidth() / 2,
          pageNumberY,
          { align: "center" }
        );
      }

      const pdfBlob = doc.output("blob");
      const pdfURL = URL.createObjectURL(pdfBlob);
      window.open(pdfURL, "_blank");
    } catch (e) { /* ignored */ } finally {
      // This will run after download is triggered (and small delay)
      setViewBackdrop(false); // Hide loader ONLY when everything is done
    }
  };

  const hideDocVerifyAlert = () => {
    setDocVerifyAlert(false);
  };

  const hideArrearsEntryAlert = () => {
    setArrearsEntryPopUpOpen(false);
  };

  const getClassName = (x) => {
    if (x === "Pending") {
      return "pending-button";
    } else if (x === "In Process") {
      return "inprocess-button";
    } else if (x === "Approved") {
      return "approved-button";
    } else if (x === "Objection") {
      return "objection-button";
    }
  };

  const handleClose = async () => {
    //applied load field
    fieldFormik.values.iv_remarks_others = "";
    setBoqItems([]);
    setItemsAmount("");
    setStoreCharges("");
    setInstallationCharges("");
    setEFileData([]);
    setTableDataProcessingSummary([]);
    setTotalCharges("");
    setItemsArray("");
    setFixedChargesOfMetering("");
    fieldRemoveObjectionFormik.values.iv_objection_remarks = "";
    fieldRemoveObjectionFormik.values.iv_additional_civic_document = "";
    setAdditionalCivicDocumentThumbnail("");
    setOpenObjectionPopup(false);
    setFeederRehabilitationCharges(0);
    setInstallationCharges();
    setItemsAmount();
    setStoreCharges();
    setFixedChargesOfMetering("");
    setItemsArray([]);
    setBoqItems([]);
    setGridSharingCost(0);
    fieldFormik.resetForm();
    fieldItemFormik.resetForm();
    fieldFormik.values.iv_coverage_area = "";
    fieldFormik.values.iv_sanctioned_load = "";
    fieldFormik.values.iv_batch = "";
    fieldFormik.values.iv_reference_to_allot = "";
    fieldFormik.values.iv_meter_rent = 0;
    fieldFormik.values.iv_service_rent = 0;
    setArearPaidBillUpload(false);
    setArearPaidBillDocument("");
    setArearPaidBillDocumentThumbnail("");
    arearBillDocumentFormik.values.iv_arear_paid_bill_document = "";
    arearBillDocumentFormik.values.iv_arear_paid_bill_date = "";
    fieldFormik.values.iv_grid_sharing_cost = 0;
    fieldFormik.values.iv_feeder_rehab_charges = 0;
    fieldFormik.values.iv_tariff_to_allot = "";
    fieldFormik.values.iv_survey_date = "";
    fieldFormik.values.iv_surveyed_by = "";
    sjoFormik.resetForm();
    sjoFormik.values.iv_feeder_no = "";
    sjoFormik.values.iv_cantonment_board = "";
    sjoFormik.values.iv_fgovt = "";
    sjoFormik.values.iv_pgovt = "";
    sjoFormik.values.iv_local_bodies = "";
    sjoFormik.values.iv_batch = "";
    sjoFormik.values.iv_sub_batch = "";
    sjoFormik.resetForm();
    sjoFormik.values.iv_store_requisition_no = "";
    sjoFormik.values.iv_store_requisition_date = "";
    sjoFormik.values.iv_sanctioned_load = "";
    sjoFormik.values.iv_no_of_meters = 0;
    sjoFormik.values.iv_no_of_acs = 0;
    sjoFormik.values.iv_no_of_meter_sets = 0;
    sjoFormik.values.iv_no_of_sub_sets = 0;
    sjoFormik.values.iv_no_ofsupply_points = 0;
    sjoFormik.values.iv_installed_transformer_capacity = "";
    sjoFormik.values.iv_seasonal_flag = 1;
    sjoFormik.values.iv_meter_id = "";
    sjoFormik.values.iv_meter_no = "";
    sjoFormik.values.iv_location_code = "";
    sjoFormik.values.iv_meter_code = "";
    sjoFormik.values.iv_manufacturer_code = "";
    sjoFormik.values.iv_multiplying_factor = "";
    sjoFormik.values.iv_meter_range = "";
    sjoFormik.values.iv_meter_reading = "";
    sjoFormik.values.iv_seal_on_meter = "";
    sjoFormik.values.iv_seal_on_box = "";
    sjoFormik.values.iv_connection_installer_name = "";
    sjoFormik.values.iv_date_of_connection = "";
    sjoFormik.values.iv_cp_78_item_no = "";
    sjoFormik.values.iv_security_slip_or_price_bond_no = "";
    sjoFormik.values.iv_tie_up_non_tie_up = 0;
    masterDataFormik.resetForm();
    arearsFormik.values.iv_property_reference_no = "";
    masterDataFormik.values.iv_govt_dept = 0;
    masterDataFormik.values.iv_income_tax = 0;
    masterDataFormik.values.iv_standard_classification_code = "";
    setDnDetails({
      demandNoticeNo: "",
      issueDate: "",
      applicationId: "",
      dueDate: "",
      roOfficeAddress: "",
      consumerAccountNo: "",
      batchNo: "",
      tariff: "",
      bankName: "",
      industryFactoryType: null,
      connectionAccountNo: "",
      dnPaymentFlag: null,
      paymentMethod: null,
      dnPaymentVerificationFlag: null,
      previousSecurity: null,
      sanctionLoad: "",
      filledBy: null,
      filledDate: "",
      filledFlag: null,
      approvedBy: null,
      approvedDate: null,
      approvedFlag: null,
      connectionCatagoryType: null,
      dNamount: null,
    });
    setDnReceiptImage();
    setDnReceiptImageThumbnail();
    setReceiptImageError("");
    setPaymentDateError("");
    dnPymentReceiptFormik.resetForm();
    setSjoDetails({
      subDivisionCode: null,
      sCONo: "",
      scoCreationDate: "",
      applicationId: "",
      applicationSubmissionDate: null,
      accountNo: null,
      feederNo: null,
      batch: null,
      applicantNewName: null,
      applicantOldTariff: null,
      applicantOldLoad: null,
      applicantNewTariff: null,
      applicantNewLoad: null,
      applicationType: null,
      mobileNo: null,
      date: null,
      materNo: null,
      cNICNo: null,
      securityDepositDNNo: null,
      dNCreationDate: null,
      ammountOfSecurityDeposit: null,
      dNPaymentDate: null,
      ammountOfCapitalCost: 0,
      capitalCostPaymentDate: null,
      filledBy: null,
      filledDate: null,
      filledFlag: null,
      approvedBy: null,
      approvedDate: null,
      approvedFlag: null,
    });
    setDialogRowData((prevObject) => ({
      ...prevObject,
      copyOfApplicantCNIC: "",
      owenershipDocument: "",
      electricityBillDocument: "",
      fbrDocument: "",
      previousOwnerCNIC: "",
      perOwenerNOC: "",
      affidaviteApplicant: "",
      additionalCivicDocument: "",
      addDocAnyOther: "",
      addDocCONConsent: "",
    }));

    setFoundInCON();
    setShowMasterForm(false);
    setApplicantCNICBackObjectionRemarks("");
    setApplicantCNICFrontObjectionRemarks("");
    setowenershipObjectionRemarks("");
    setElectricityBillObjectionRemarks("");
    setFbrDocumentObjectionRemarks("");
    setpreOwnerCNICBackObjectionRemarks("");
    setpreOwnerCNICFrontObjectionRemarks("");
    setperOwenerNOCObjectionRemarks("");
    setnewOwenerAffidaviteObjectionRemarks("");
    setaddCONConsentObjectionRemarks("");
    setaddDocAnyOtherObjectionRemarks("");
    setaddDocCivicAuthorityObjectionRemarks("");
    resetRestoreApplicationForm();
    setRestoreApplicationPopUpOpen(false);
    setRestoreApplicationConfirmOpen(false);
    setOpen(false);
    setEFileData([]);
    setPaymentStatus("");
    setArrearAmount("");
    setBillMonth("");
    setSketchDiagramThumbnail();
    setSketchDiagram();
    setSketchDiagramError();
    setSketchDiagramUploaded();
    setDnDocumentsCertified(false);
    setFlag_wiringTestReport(null);
    setWiringTestReportObjectionRemarks("");
    setWiringTestReportVerifyPopUp(false);
    setNewWiringTestReportDocument("");
    setNewWiringTestReportDocumentThumbnail("");
    setNewWiringTestReportDocumentError("");
    setWiringTestReportLoading(false);
    dispatch(
      fetchPaginatedChangeOfAttributesNormal({
        page: currentPageNormal,
        pageSize: pageSizeNormal,
        dateFrom: dateFromNormal,
        dateTo: dateToNormal,
        applicationProgressId: applicationProgressIdNormal,
        objectionStatus: objectionStatusNormal,
        officeCode: selectedOfficeCode || code,
      })
    );
    dispatch(
      fetchPaginatedChangeOfAttributesOverdue({
        page: currentPageNormal,
        pageSize: pageSizeNormal,
        dateFrom: dateFromNormal,
        dateTo: dateToNormal,
        applicationProgressId: applicationProgressIdNormal,
        objectionStatus: objectionStatusNormal,
        officeCode: selectedOfficeCode || code,
      })
    );
  };

  const getCoaResultDialogMeta = (severity, message = "") => {
    const msg = String(message).toLowerCase();
    if (severity === "error") {
      return { title: "Request Failed", isReject: true };
    }
    if (msg.includes("successfully")) {
      if (msg.includes("objection")) {
        return { title: "Objection Raised Successfully", isReject: false };
      }
      if (
        msg.includes("submit") ||
        msg.includes("uploaded") ||
        msg.includes("upload") ||
        msg.includes("reupload")
      ) {
        return { title: "Submitted Successfully", isReject: false };
      }
      if (msg.includes("verif")) {
        return { title: "Verified Successfully", isReject: false };
      }
      return { title: "Request Approved", isReject: false };
    }
    if (
      msg.includes("reject") ||
      msg.includes("objection") ||
      msg.includes("declined")
    ) {
      return { title: "Request Rejected", isReject: true };
    }
    if (
      msg.includes("submit") ||
      msg.includes("uploaded") ||
      msg.includes("upload") ||
      msg.includes("reupload")
    ) {
      return { title: "Submitted Successfully", isReject: false };
    }
    if (msg.includes("verif")) {
      return { title: "Verified Successfully", isReject: false };
    }
    return { title: "Request Approved", isReject: false };
  };

  const showCoaWorkflowResult = (message, severity = "success") => {
    setSnackbar({
      open: true,
      message: message || (severity === "error" ? "Something went wrong." : "Action completed successfully."),
      severity,
    });
  };

  const completeCoaWorkflowStep = (message, severity = "success") => {
    handleClose();
    showCoaWorkflowResult(message, severity);
  };

  const openCoaResponseModal = (
    message,
    { isError = false, storeRequisitionNo = "" } = {}
  ) => {
    if (isError) {
      setResponseMessage("");
      setResponseMessageError(message);
      setResponseStoreRequisitionNo("");
    } else {
      setResponseMessage(message);
      setResponseMessageError("");
      setResponseStoreRequisitionNo(storeRequisitionNo);
    }
    setOpenResponseModal(true);
    handleClose();
  };

  const SketchDiagram = (event) => {
    if (event.target.files) {
      const newFileName =
        "sketchDiagram." + event.target.files[0].name.split(".").pop();
      handleFileUpload(
        event,
        fieldFormik.handleChange,
        setSketchDiagram,
        setSketchDiagramError,
        setSketchDiagramThumbnail,
        newFileName
      );
    }
  };

  const clearSketchDiagramSelection = (event) => {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    setSketchDiagram("");
    setSketchDiagramUploaded("");
    setSketchDiagramThumbnail("");
    setSketchDiagramError("");
    fieldFormik.setFieldValue("iv_sketch_diagram", "");
    fieldFormik.setFieldTouched("iv_sketch_diagram", false);

    const sketchInput = document.getElementById("iv_sketch_diagram");
    if (sketchInput) {
      sketchInput.value = "";
    }
  };

  const NewWiringTestReportDocument = (event) => {
    const file = event.target.files?.[0];
    if (!file) return;

    const maxSize = 2 * 1024 * 1024; // 2MB
    // Direct size check first (clearer than relying only on documentValidation)
    if (file.size > maxSize) {
      setNewWiringTestReportDocumentError("File size exceeds 2MB limit.");
      setNewWiringTestReportDocument("");
      setNewWiringTestReportDocumentThumbnail("");
      event.target.value = "";
      return;
    }

    const documentValidate = documentValidation(file, maxSize);
    if (documentValidate !== 1) {
      setNewWiringTestReportDocumentError(
        documentValidate === 2
          ? "File size exceeds 2MB limit."
          : "Invalid file type. Only JPG, PNG, and PDF are allowed."
      );
      setNewWiringTestReportDocument("");
      setNewWiringTestReportDocumentThumbnail("");
      event.target.value = "";
      return;
    }

    const reader = new FileReader();
    reader.onloadend = () => {
      setNewWiringTestReportDocument(file.name);
      setNewWiringTestReportDocumentThumbnail(reader.result);
      setNewWiringTestReportDocumentError("");
      setFlag_wiringTestReport(null);
    };
    reader.onerror = () => {
      setNewWiringTestReportDocumentError("Failed to read file. Please try again.");
      setNewWiringTestReportDocument("");
      setNewWiringTestReportDocumentThumbnail("");
      event.target.value = "";
    };
    reader.readAsDataURL(file);
  };
  const ArearPaidBillDocument = (event) => {
    arearBillDocumentFormik.handleChange(event);
    if (event.target.files.length > 0) {
      let file = event.target.files[0];
      let fileName = file.name;
      let fileNameArray = fileName.split(".");
      let extension = fileNameArray[fileNameArray.length - 1];
      const maxSize = 2 * 1024 * 1024; // 2MB in bytes
      const documentValidate = documentValidation(file, maxSize);
      if (documentValidate === 1) {
        const newFileName = "paidBillArear." + extension;
        const renamedFile = new File([file], newFileName, { type: file.type });
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");

        const image = new Image();
        image.src = URL.createObjectURL(renamedFile);

        image.onload = () => {
          canvas.width = image.width;
          canvas.height = image.height;
          ctx.drawImage(image, 0, 0);
          const waterMarkText = getDiscoUseOnlyWatermarkText(
            getDocumentDiscoCode(
              dialogRowData?.applicationId,
              dialogRowData?.companyCode,
            ),
          );
          ctx.font = "24px Arial";
          ctx.fillStyle = "rgba(255, 255, 255, 0.5)";
          ctx.fillText(waterMarkText, 10, canvas.height - 10);
          const watermarkedBase64 = canvas.toDataURL();
          setArearPaidBillDocument(renamedFile);
          arearBillDocumentFormik.values.iv_arear_paid_bill_document =
            "uploaded";
          setArearPaidBillDocumentThumbnail(watermarkedBase64);
        };
      } else if (documentValidate === 2) {
        setArearPaidBillDocumentError(
          "File size exceeds " + maxSize / 1024 / 1024 + "MB limit."
        );
      } else {
        setArearPaidBillDocumentError(
          "Invalid file type. Only JPG, PNG, and PDF are allowed."
        );
      }
    }
  };

  const SignedConsentFormImage = (event) => {
    signedConsentImageFormik.handleChange(event);
    if (event.target.files.length > 0) {
      let file = event.target.files[0];
      let fileName = file.name;
      let fileNameArray = fileName.split(".");
      let extension = fileNameArray[fileNameArray.length - 1];
      const maxSize = 2 * 1024 * 1024; // 2MB in bytes
      const documentValidate = documentValidation(file, maxSize);
      if (documentValidate === 1) {
        const newFileName = "signedConsentFormImage." + extension;
        const renamedFile = new File([file], newFileName, { type: file.type });
        setSignedConsentFormImageImage(renamedFile);
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
          // Set the thumbnail image as the data URL
          const base64Image = reader.result;
          setSignedConsentFormImageImageThumbnail(base64Image);
        };
      } else if (documentValidate === 2) {
        setSignedConsentFormImageError(
          "File size exceeds " + maxSize / 1024 / 1024 + "MB limit."
        );
      } else {
        setSignedConsentFormImageError(
          "Invalid file type. Only JPG, PNG, and PDF are allowed."
        );
      }
    }
  };

  const DnReceiptImage = (event) => {
    if (event.target.files && event.target.files[0]) {
      const file = event.target.files[0];
      const newFileName = "dnReceiptImage." + file.name.split(".").pop();

      const uploaded = handleFileUpload(
        event,
        dnPymentReceiptFormik.handleChange,
        setDnReceiptImage,
        setReceiptImageError,
        setDnReceiptImageThumbnail,
        newFileName
      );

      if (uploaded === true) {
        dnPymentReceiptFormik.setFieldValue("iv_receipt_image", file);
        dnPymentReceiptFormik.setFieldError("iv_receipt_image", undefined);
      } else {
        dnPymentReceiptFormik.setFieldValue("iv_receipt_image", null);
        dnPymentReceiptFormik.setFieldError("iv_receipt_image", undefined);
      }
    }
  };

  const handleDnPaymentReceiptSubmit = () => {
    if (!dnReceiptImageThumbnail?.trim()) {
      setReceiptImageError("Upload paid demand notice receipt image.");
      dnPymentReceiptFormik.setFieldTouched("iv_payment_date", true, false);
      dnPymentReceiptFormik.validateForm();
      return;
    }

    dnPymentReceiptFormik.validateForm().then((errors) => {
      if (Object.keys(errors).length === 0) {
        setDnApprovalPayload({
          applicationId: dialogRowData.applicationId,
          applicationProgressId: dialogRowData.applicationProgressId + 1,
          objectionStatus: 0,
          remarks: "Paid DN Uploaded.",
        });
        dnPymentReceiptFormik.handleSubmit();
      } else {
        dnPymentReceiptFormik.setTouched({
          iv_payment_date: true,
          iv_receipt_image: true,
        });
      }
    });
  };

  const clearDnReceiptImage = () => {
    setDnReceiptImage("");
    setDnReceiptImageThumbnail("");
    setDnReceiptImageUploaded("");
    setReceiptImageError("");
    dnPymentReceiptFormik.setFieldValue("iv_receipt_image", null);
    dnPymentReceiptFormik.setFieldError("iv_receipt_image", undefined);
    dnPymentReceiptFormik.setFieldTouched("iv_receipt_image", false);
    const fileInput = document.getElementById("iv_receipt_image");
    if (fileInput) {
      fileInput.value = "";
    }
  };

  const ArrearPaidReceiptImage = (event) => {
    arrearPaymentReceiptFormik.handleChange(event);
    if (event.target.files.length > 0) {
      let file = event.target.files[0];
      let fileName = file.name;
      let fileNameArray = fileName.split(".");
      let extension = fileNameArray[fileNameArray.length - 1];
      const maxSize = 2 * 1024 * 1024; // 2MB in bytes
      const documentValidate = documentValidation(file, maxSize);
      if (documentValidate === 1) {
        const newFileName = "ArrearPaidReceiptImage." + extension;
        const renamedFile = new File([file], newFileName, { type: file.type });
        setArrearPaidReceiptImage(renamedFile);
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
          // Set the thumbnail image as the data URL
          const base64Image = reader.result;
          setArrearPaidReceiptImageThumbnail(base64Image);
        };
      } else if (documentValidate === 2) {
      } else {
      }
    }
  };

  const [currentEfileApplication, setCurrentEfileApplication] = useState([]);

  const callEfileAPI = async (applicationId, application) => {
    try {
      setViewDropBackForEfile(true);

      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      myHeaders.append("Content-Type", "application/json");

      const raw = JSON.stringify({ applicationId });

      const response = await fetch(
        `${cfpBaseUrl}changeOfAttributes/getBasicCOAHistory`,
        {
          method: "POST",
          headers: myHeaders,
          body: raw,
        }
      );

      const result = await response.json();

      if (result.status === "200" && result.data) {
        let applicationHistory = result.data.history || [];
        let applicationCurrentState = result.data.currentStatus?.[0] || {};

        const getHistorySortValue = (item) => ({
          time: new Date(
            item?.lastModificationDate || item?.creationDate || 0,
          ).getTime(),
          progress: Number(
            item?.historyProgressId ?? item?.applicationProgressId ?? 0,
          ),
        });

        const compareHistoryItems = (a, b, direction = "desc") => {
          const aSort = getHistorySortValue(a);
          const bSort = getHistorySortValue(b);
          const timeDiff =
            direction === "desc"
              ? bSort.time - aSort.time
              : aSort.time - bSort.time;
          if (timeDiff !== 0) return timeDiff;
          return direction === "desc"
            ? bSort.progress - aSort.progress
            : aSort.progress - bSort.progress;
        };

        const newestFirstHistory = [...applicationHistory].sort((a, b) =>
          compareHistoryItems(a, b, "desc"),
        );
        const oldestHistoryItem =
          [...applicationHistory].sort((a, b) =>
            compareHistoryItems(a, b, "asc"),
          )[0] ?? null;

        const isOldestHistoryItem = (item) => {
          if (!oldestHistoryItem || !item) return false;
          const oldestSort = getHistorySortValue(oldestHistoryItem);
          const itemSort = getHistorySortValue(item);
          return (
            itemSort.time === oldestSort.time &&
            itemSort.progress === oldestSort.progress &&
            item.lastModificationDate ===
            oldestHistoryItem.lastModificationDate &&
            item.applicationProgressId ===
            oldestHistoryItem.applicationProgressId
          );
        };

        setEFileData(newestFirstHistory);
        setEFileCurrentStatus({
          ...applicationCurrentState,
          applicationProgressId:
            application?.applicationProgressId ??
            applicationCurrentState.applicationProgressId,
        });

        const dataforTable = newestFirstHistory.map((item) => {
          return {
            stepName: item.coaProgStatusName,
            processedBy:
              item.lastModifiedBy || applicationCurrentState.createdBy,
            date: item.lastModificationDate
              ? convertDatewithTime(item.lastModificationDate)
              : convertDatewithTime(applicationCurrentState.creationDate),
            remarks: isOldestHistoryItem(item)
              ? "Application Submitted."
              : item.remarks || "-",
            historyId: getCoaHistoryId(item),
            applicationProgressId: item.applicationProgressId,
            historyProgressId: item.historyProgressId,
            isApplicationUpdatedEntry: shouldOpenCoaApplicationUpdatedPopUp(
              item,
              { stepName: item.coaProgStatusName }
            ),
            _raw: item,
          };
        });

        // keep for UI
        setTableDataProcessingSummary(dataforTable);

        // ✅ IMPORTANT: RETURN DATA
        return dataforTable;
      }

      return [];
    } catch (error) {
      return [];
    } finally {
      setViewDropBackForEfile(false);
    }
  };

  const getStepIndex = (progressId) => {
    const id = Number(progressId);
    if (!Number.isNaN(id) && id >= 0 && id <= 10) return id;
    return progressId;
  };

  const progFunc = (x) => {
    if (x === 0) {
      return "Documents Uploading";
    } else if (x === 1) {
      return "Documents Verification";
    } else if (x === 2) {
      return "Wiring Test Report";
    } else if (x === 3) {
      return "Arrear Verification";
    } else if (x === 4) {
      return "Field Survey";
    } else if (x === 5) {
      return "DN Approval";
    } else if (x === 6) {
      return "DN Submission";
    } else if (x === 7) {
      return "DN Payment Verification";
    } else if (x === 8) {
      return "Sundary Jobs Order";
    } else if (x === 9) {
      return "Ready for Billing";
    } else if (x === 10) {
      return "Completed";
    }
  };

  const dnPaymentVerificationAlertBox = () => {
    setDnPaymentVerifyAlert(true);
  };

  const dnPaymentVerificationRejectionAlertBox = () => {
    setDnPaymentRejectAlert(true);
  };

  const apiToDataGridConversionNormal = async () => {
    try {
      const tempArray = [];
      if (changeOfNameApplications) {
        changeOfNameApplications.forEach((item) => {
          let dataGridObject = {};
          if (item.applicationId) {
            if (item.objectionStatus === 0 || item.objectionStatus === 2) {
              dataGridObject = {
                applicationId: item.applicationId,
                creationDate: convertDate(item.creationDate),
                applicantName: item.applicantName,
                referenceno: item.referenceNumber,
                applicationStatusId: statusFunc(
                  item.applicationStatusId,
                  item.objectionStatus
                ),
                applicationStep: progFunc(item.applicationProgressId),
                // downloadDNPDF: async () => {
                //   let application = await filterCONApp(item.applicationId);
                //   await downloadDNPDF(application,dnDets);
                // },
                downloadDNPDF: async () => {
                  if (!canDownloadCoaDemandNotice(item.applicationProgressId)) {
                    toast.error(
                      "Demand Note download is available from DN Submission (progress 6) onward.",
                    );
                    return;
                  }

                  let myHeaders = new Headers();
                  myHeaders.append("Authorization", token);
                  myHeaders.append("Content-Type", "application/json");

                  const raw = JSON.stringify({
                    applicationId: item.applicationId,
                  });

                  const requestOptions = {
                    method: "POST",
                    headers: myHeaders,
                    body: raw,
                    redirect: "follow",
                  };

                  try {
                    const response = await fetch(
                      cfpBaseUrl + "changeOfAttributes/getDemandNoteData",
                      requestOptions
                    );

                    const result = await response.json();

                    if (result.status === "200") {
                      const dnDets = result.data[0];
                      // Check multiple possible expiry flag sources
                      const dnExpiryFlag = result.dnExpiryFlag || dnDets.demandNoteExpiryFlag;
                      const dnExpiryCount = result.dnExpiryCount || dnDets.demandNoteExpiryCount;


                      // Check if DN is expired - check both flag and count
                      const isExpired = dnExpiryFlag === "1" || dnExpiryFlag === 1 ||
                        (dnExpiryCount !== null && dnExpiryCount !== undefined && dnExpiryCount > 0);


                      // Show expiry popup ONLY at DN Submission step (applicationProgressId === 6)
                      // For other steps, download DN directly even if expired
                      if (isExpired && item.applicationProgressId === 6) {
                        setDnExpiryDialogData({
                          applicationId: item.applicationId,
                          issueDate: dnDets.issueDate,
                        });
                        setShowDnExpiryPopup(true);
                        return;
                      }

                      await downloadDNPDF(item.applicationId, dnDets);
                    } else {
                    }
                  } catch (error) {
                    return;
                  }
                },
                downloadEFile: async () => {
                  let application = await filterCONApp(item.applicationId);
                  await downloadEFile(application);
                },
                applicationProgressId: item.applicationProgressId,
                applicationProgressNumber: item.applicationProgressId,
                applicationType: item.applicationType ?? 3,
                releventApplicationFlage: item.releventApplicationFlage,
              };
            } else if (item.objectionStatus === 1) {
              dataGridObject = {
                applicationId: item.applicationId,
                creationDate: convertDate(item.creationDate),
                applicantName: item.applicantName,
                referenceno: item.referenceNumber,
                applicationStatusId: statusFunc(
                  item.applicationStatusId,
                  item.objectionStatus
                ),
                applicationStep: item.remarks,
                downloadDNPDF: async () => {
                  if (!canDownloadCoaDemandNotice(item.applicationProgressId)) {
                    toast.error(
                      "Demand Note download is available from DN Submission (progress 6) onward.",
                    );
                    return;
                  }

                  let myHeaders = new Headers();
                  myHeaders.append("Authorization", token);
                  myHeaders.append("Content-Type", "application/json");

                  const raw = JSON.stringify({
                    applicationId: item.applicationId,
                  });

                  const requestOptions = {
                    method: "POST",
                    headers: myHeaders,
                    body: raw,
                    redirect: "follow",
                  };

                  try {
                    const response = await fetch(
                      cfpBaseUrl + "changeOfAttributes/getDemandNoteData",
                      requestOptions
                    );

                    const result = await response.json();

                    if (result.status === "200") {
                      const dnDets = result.data[0];
                      // Check multiple possible expiry flag sources
                      const dnExpiryFlag = result.dnExpiryFlag || dnDets.demandNoteExpiryFlag;
                      const dnExpiryCount = result.dnExpiryCount || dnDets.demandNoteExpiryCount;


                      // Check if DN is expired - check both flag and count
                      const isExpired = dnExpiryFlag === "1" || dnExpiryFlag === 1 ||
                        (dnExpiryCount !== null && dnExpiryCount !== undefined && dnExpiryCount > 0);


                      // Show expiry popup ONLY at DN Submission step (applicationProgressId === 6)
                      // For other steps, download DN directly even if expired
                      if (isExpired && item.applicationProgressId === 6) {
                        setDnExpiryDialogData({
                          applicationId: item.applicationId,
                          issueDate: dnDets.issueDate,
                        });
                        setShowDnExpiryPopup(true);
                        return;
                      }

                      await downloadDNPDF(item.applicationId, dnDets);
                    } else {
                    }
                  } catch (error) {
                    return;
                  }
                },
                downloadEFile: async () => {
                  let application = await filterCONApp(item.applicationId);
                  await downloadEFile(application);
                },
                applicationProgressId: item.applicationProgressId,
                applicationProgressNumber: item.applicationProgressId,
                applicationType: item.applicationType ?? 3,
                releventApplicationFlage: item.releventApplicationFlage,
              };
            }
            tempArray.push(dataGridObject);
          }
        });
      } else {
        const dataGridObject = {
          applicationId: " ",
          creationDate: "",
          applicantName: " ",
          referenceNo: " ",
          applicationStatusId: statusFunc(" "),
          description: " ",
        };
        tempArray.push(dataGridObject);
      }

      setChangeOfNameApplicationsToDataGrid(tempArray);
      setViewBackdrop(false);
    } catch (e) { /* ignored */ }
  };

  const apiToDataGridConversionOverdue = async () => {
    try {
      const tempArray = [];
      if (changeOfNameApplicationsOverDue) {
        changeOfNameApplicationsOverDue.forEach((item) => {
          let dataGridObject = {};
          if (item.applicationId) {
            if (item.objectionStatus === 0 || item.objectionStatus === 2) {
              dataGridObject = {
                applicationId: item.applicationId,
                creationDate: convertDate(item.creationDate),
                applicantName: item.applicantName,
                referenceno: item.referenceNumber,
                applicationStatusId: statusFunc(
                  item.applicationStatusId,
                  item.objectionStatus
                ),
                applicationStep: progFunc(item.applicationProgressId),
                exceededDuration: item.exceededDuration,
                releventApplicationFlage: item.releventApplicationFlage,
                downloadDNPDF: async () => {
                  if (!canDownloadCoaDemandNotice(item.applicationProgressId)) {
                    toast.error(
                      "Demand Note download is available from DN Submission (progress 6) onward.",
                    );
                    return;
                  }

                  let myHeaders = new Headers();
                  myHeaders.append("Authorization", token);
                  myHeaders.append("Content-Type", "application/json");

                  const raw = JSON.stringify({
                    applicationId: item.applicationId,
                  });

                  const requestOptions = {
                    method: "POST",
                    headers: myHeaders,
                    body: raw,
                    redirect: "follow",
                  };

                  try {
                    const response = await fetch(
                      cfpBaseUrl + "changeOfAttributes/getDemandNoteData",
                      requestOptions
                    );

                    const result = await response.json();

                    if (result.status === "200") {
                      const dnDets = result.data[0];
                      // Check multiple possible expiry flag sources
                      const dnExpiryFlag = result.dnExpiryFlag || dnDets.demandNoteExpiryFlag;
                      const dnExpiryCount = result.dnExpiryCount || dnDets.demandNoteExpiryCount;


                      // Check if DN is expired - check both flag and count
                      const isExpired = dnExpiryFlag === "1" || dnExpiryFlag === 1 ||
                        (dnExpiryCount !== null && dnExpiryCount !== undefined && dnExpiryCount > 0);


                      // Show expiry popup ONLY at DN Submission step (applicationProgressId === 6)
                      // For other steps, download DN directly even if expired
                      if (isExpired && item.applicationProgressId === 6) {
                        setDnExpiryDialogData({
                          applicationId: item.applicationId,
                          issueDate: dnDets.issueDate,
                        });
                        setShowDnExpiryPopup(true);
                        return;
                      }

                      await downloadDNPDF(item.applicationId, dnDets);
                    } else {
                    }
                  } catch (error) {
                    return;
                  }
                },
                downloadEFile: async () => {
                  let application = await filterCONApp(item.applicationId);
                  await downloadEFile(application);
                },
                applicationProgressId: item.applicationProgressId,
                applicationProgressNumber: item.applicationProgressId,
                applicationType: item.applicationType ?? 3,
              };
            } else if (item.objectionStatus === 1) {
              dataGridObject = {
                applicationId: item.applicationId,
                creationDate: convertDate(item.creationDate),
                applicantName: item.applicantName,
                referenceno: item.referenceNumber,
                applicationStatusId: statusFunc(
                  item.applicationStatusId,
                  item.objectionStatus
                ),
                applicationStep: item.remarks,
                downloadDNPDF: async () => {
                  if (!canDownloadCoaDemandNotice(item.applicationProgressId)) {
                    toast.error(
                      "Demand Note download is available from DN Submission (progress 6) onward.",
                    );
                    return;
                  }

                  let myHeaders = new Headers();
                  myHeaders.append("Authorization", token);
                  myHeaders.append("Content-Type", "application/json");

                  const raw = JSON.stringify({
                    applicationId: item.applicationId,
                  });

                  const requestOptions = {
                    method: "POST",
                    headers: myHeaders,
                    body: raw,
                    redirect: "follow",
                  };

                  try {
                    const response = await fetch(
                      cfpBaseUrl + "changeOfAttributes/getDemandNoteData",
                      requestOptions
                    );

                    const result = await response.json();

                    if (result.status === "200") {
                      const dnDets = result.data[0];
                      // Check multiple possible expiry flag sources
                      const dnExpiryFlag = result.dnExpiryFlag || dnDets.demandNoteExpiryFlag;
                      const dnExpiryCount = result.dnExpiryCount || dnDets.demandNoteExpiryCount;


                      // Check if DN is expired - check both flag and count
                      const isExpired = dnExpiryFlag === "1" || dnExpiryFlag === 1 ||
                        (dnExpiryCount !== null && dnExpiryCount !== undefined && dnExpiryCount > 0);


                      // Show expiry popup ONLY at DN Submission step (applicationProgressId === 6)
                      // For other steps, download DN directly even if expired
                      if (isExpired && item.applicationProgressId === 6) {
                        setDnExpiryDialogData({
                          applicationId: item.applicationId,
                          issueDate: dnDets.issueDate,
                        });
                        setShowDnExpiryPopup(true);
                        return;
                      }

                      await downloadDNPDF(item.applicationId, dnDets);
                    } else {
                    }
                  } catch (error) {
                    return;
                  }
                },
                downloadEFile: async () => {
                  let application = await filterCONApp(item.applicationId);
                  await downloadEFile(application);
                },
                applicationProgressId: item.applicationProgressId,
                applicationProgressNumber: item.applicationProgressId,
                applicationType: item.applicationType ?? 3,
                exceededDuration: item.exceededDuration,
                releventApplicationFlage: item.releventApplicationFlage,
              };
            }
            tempArray.push(dataGridObject);
          }
        });
      } else {
        const dataGridObject = {
          applicationId: " ",
          creationDate: "",
          applicantName: " ",
          referenceNo: " ",
          applicationStatusId: statusFunc(" "),
          description: " ",
        };
        tempArray.push(dataGridObject);
      }

      setChangeOfNameApplicationsOverDueToDataGrid(tempArray);
      setViewBackdrop(false);
    } catch (e) { /* ignored */ }
  };

  useScanDetection({
    onComplete: async (code) => {
      if (code) {
        code = code.replace(/Shift/g, "");
        const regex = /^[A-Z]{2}-\d{14,15}$/;
        if (regex.test(code)) {
          await handleRowClick(code);
        } else {
        }
      }
    },
    minLength: 4, // EAN13
  });

  const filterCONApp = async (applicationId) => {
    const nameArray = changeOfNameApplications;
    let allApplications = nameArray.concat(changeOfNameApplicationsOverDue);
    let itemFound = allApplications.find(
      (item) => item.applicationId === applicationId
    );
    if (itemFound === undefined) {
      itemFound = await SearchIndividualApplication(token, applicationId, "15");
    }
    return itemFound;
  };

  const submitObjection = () => {
    setObjectionPopUpOpen(false);
  };

  const docVerificationAlertBox = () => {
    setDocVerifyAlert(true);
  };

  const fieldVerificationAlertBox = () => {
    setFieldVerifyAlert(true);
  };

  const hideArrearsVerifyAlert = () => {
    setArrearsVerifyPopUpOpen(false);
  };

  const getWiringTestReport = async (applicationId) => {
    if (!applicationId) return null;

    setWiringTestReportLoading(true);
    const myHeaders = new Headers();
    myHeaders.append("Authorization", token);
    myHeaders.append("Content-Type", "application/json");

    const raw = JSON.stringify({ applicationId });

    try {
      const response = await fetch(
        cfpBaseUrl + "changeOfAttributes/getWiringTestReport",
        {
          method: "POST",
          headers: myHeaders,
          body: raw,
          redirect: "follow",
        }
      );
      const result = await response.json();
      const reportRow = Array.isArray(result?.data)
        ? result.data[0]
        : result?.data;

      if (
        (result.status === "200" || result.status === 200) &&
        reportRow?.wiringTestReportDocument &&
        String(reportRow.wiringTestReportDocument).startsWith("data:")
      ) {
        const wiringTestReportDocument = reportRow.wiringTestReportDocument;
        const documentFlag = reportRow.wiringTestReportDocumentFlag ?? null;
        const objectionRemarks =
          reportRow.wiringTestReportDocumentObjectionRemarks ??
          reportRow.wiringTestReportDocumentRemarks ??
          "";

        if (
          documentFlag === 1 ||
          documentFlag === -1 ||
          documentFlag === 2 ||
          documentFlag === "1" ||
          documentFlag === "-1" ||
          documentFlag === "2"
        ) {
          setFlag_wiringTestReport(Number(documentFlag));
        } else if (Number(reportRow.objectionStatus) === 2) {
          setFlag_wiringTestReport(2);
        }

        const resolvedFlag =
          documentFlag === 1 ||
            documentFlag === -1 ||
            documentFlag === 2 ||
            documentFlag === "1" ||
            documentFlag === "-1" ||
            documentFlag === "2"
            ? Number(documentFlag)
            : Number(reportRow.objectionStatus) === 2
              ? 2
              : flag_wiringTestReport;

        setWiringTestReportObjectionRemarks(
          getCoaWiringTestReportDocumentRemarks(
            {
              ...dialogRowData,
              ...reportRow,
              wiringTestReportDocumentObjectionRemarks: objectionRemarks,
              wiringTestReportDocumentRemarks: objectionRemarks,
            },
            resolvedFlag
          )
        );

        setDialogRowData((prevObject) => ({
          ...prevObject,
          wiringTestReportDocument,
          wiringTestReportDocumentFlag: documentFlag,
          wiringTestReportDocumentObjectionRemarks: objectionRemarks,
          wiringTestReportDocumentRemarks: objectionRemarks,
        }));

        return reportRow;
      }
      return null;
    } catch (error) {
      return null;
    } finally {
      setWiringTestReportLoading(false);
    }
  };

  const getDocumentApi = async (applicationId) => {
    try {
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      myHeaders.append("Content-Type", "application/json");

      const raw = JSON.stringify({ applicationId });

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const response = await fetch(
        cfpBaseUrl + "changeOfAttributes/getChangeOfAttributesDocuments",
        requestOptions
      );

      const result = await response.json();

      if (result?.data && result.data.length > 0) {
        const docData = {
          applicantCNICFront: result.data[0].applicantCNICFront,
          applicantCNICBack: result.data[0].applicantCNICBack,
          // keep existing key for backwards-compatibility
          ownershipDocument: result.data[0].ownershipImage,
          // also provide `ownershipImage` which other code expects
          ownershipImage: result.data[0].ownershipImage,
          electricityBill: result.data[0].electricityBill,
          fbrDocument: result.data[0].fbrDocument,
          anyOtherDocument: result.data[0].anyOtherDocument,
          applicantCNICFrontFlag: result.data[0].applicantCNICFrontFlag,
          applicantCNICBackFlag: result.data[0].applicantCNICBackFlag,
          ownershipImageFlag: result.data[0].ownershipImageFlag,
          electricityBillFlag: result.data[0].electricityBillFlag,
          fbrDocumentFlag: result.data[0].fbrDocumentFlag,
          anyOtherDocumentFlag: result.data[0].anyOtherDocumentFlag,
        };

        // ✅ Update your dialog state also
        setDialogRowData((prevObject) => ({
          ...prevObject,
          applicantCNICFront: docData.applicantCNICFront,
          applicantCNICBack: docData.applicantCNICBack,
          owenershipDocument: docData.ownershipDocument,
          electricityBillDocument: docData.electricityBill,
          fbrDocument: docData.fbrDocument,
          addDocAnyOther: docData.anyOtherDocument,
        }));

        // ✅ Return the data (important for PDF)
        return docData;
      }

      return null;
    } catch (error) {
      return null;
    }
  };

  const onPressViewActivityLog = async () => {
    if (dialogRowData.applicationProgressId >= 3) {
      getDocumentApi(dialogRowData.applicationId);
    }
    await callEfileAPI(dialogRowData.applicationId, dialogRowData);
  };

  useEffect(() => {
    callTariffList();
  }, []);

  useEffect(() => {
    if (
      open &&
      dialogRowData?.applicationId &&
      Number(dialogRowData.applicationProgressId) === 2
    ) {
      getWiringTestReport(dialogRowData.applicationId);
    }
  }, [open, dialogRowData?.applicationId, dialogRowData?.applicationProgressId]);
  const callTariffList = async () => {
    let tariffList = [];
    try {
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);

      var requestOptions = {
        method: "POST",
        redirect: "follow",
        headers: myHeaders,
      };

      await fetch(
        cfpBaseUrl + "customerFaciliationPortal/getTariffsDetail",
        requestOptions
      )
        .then((response) => response.json())
        .then((result) => {
          tariffList = result.data;
          setAllTariffList(result.data);
        })
        .catch(() => { });
      return tariffList;
    } catch (e) { /* ignored */ } finally {
      return tariffList;
    }
  };

  const handleRowClick = async (applicationId) => {
    setViewBackdrop(true);

    callMaterials(applicationId);
    if (applicationId) {
      const item = await filterCONApp(applicationId);
      if (item && item.applicationId) {
        let phase = await getTariffAndMeterType(
          item.newSanctionLoad,
          item.connectionType,
          item.seasonalFlag,
          allTariffList,
          item.applicationProgressId
        );
        scoPart1Formik.values.iv_seasonal_flag = item.seasonalFlag;
        if (phase == "Single Phase") {
          scoPart1Formik.values.iv_meter_code1 = "000002";
        } else if (phase == "3 Phase") {
          scoPart1Formik.values.iv_meter_code1 = "050502";
          scoPart1Formik.values.iv_meter_code2 = "050602";
        }

        if (phase == "MDI (LT)(CT)" || phase == "MDI (HT)(CT/PT)") {
          scoPart1Formik.values.iv_ct_nom = "100";
          scoPart1Formik.values.iv_ct_denom = "5";
        } else {
          scoPart1Formik.values.iv_ct_nom = "1";
          scoPart1Formik.values.iv_ct_denom = "1";
        }

        if (phase == "MDI (HT)(CT/PT)") {
          scoPart1Formik.values.iv_pt_nom = "11000";
          scoPart1Formik.values.iv_pt_denom = "110";
        }
        scoPart1Formik.values.iv_connection_installer_name = userId;
        if (
          dialogRowData.changeOfAttributesType == 2 ||
          dialogRowData.changeOfAttributesType == 4 ||
          dialogRowData.changeOfAttributesType == 5 ||
          dialogRowData.changeOfAttributesType == 7
        ) {
          scoPart1Formik.values.iv_sanctioned_load = item.newSanctionLoad;
        } else {
          scoPart1Formik.values.iv_sanctioned_load = item.currentSanctionLoad;
        }

        setFlag_applicantCNICFront(item.applicantCNICFrontFlag);
        setFlag_applicantCNICBack(item.applicantCNICBackFlag);
        setFlag_owenershipDocument(item.ownershipImageFlag);
        setFlag_electricityBillDocument(item.electricityBillFlag);

        setFlag_fbrDocument(item.fbrDocumentFlag || null);
        setFlag_addDocAnyOther(item.anyOtherDocumentFlag || null);
        setApplicantCNICFrontObjectionRemarks(item.applicantCNICFrontRemarks || "");
        setApplicantCNICBackObjectionRemarks(item.applicantCNICBackRemarks || "");
        setowenershipObjectionRemarks(item.ownershipImageRemarks || "");
        setElectricityBillObjectionRemarks(item.electricityBillRemarks || "");
        setFbrDocumentObjectionRemarks(item.fbrDocumentRemarks || "");
        setaddDocAnyOtherObjectionRemarks(item.anyOtherDocumentRemarks || "");
        const wiringFlag = item.wiringTestReportDocumentFlag;
        let resolvedWiringFlag = null;
        if (
          Number(item.applicationProgressId) === 2 &&
          (Number(item.objectionStatus) != 1 ||
            Number(item.objectionStatus) == 2)
        ) {
          if (
            wiringFlag === 1 ||
            wiringFlag === -1 ||
            wiringFlag === 2 ||
            wiringFlag === "1" ||
            wiringFlag === "-1" ||
            wiringFlag === "2"
          ) {
            resolvedWiringFlag = Number(wiringFlag);
          } else if (Number(item.objectionStatus) === 2) {
            resolvedWiringFlag = 2;
          }
        } else if (
          wiringFlag === 1 ||
          wiringFlag === -1 ||
          wiringFlag === 2 ||
          wiringFlag === "1" ||
          wiringFlag === "-1" ||
          wiringFlag === "2"
        ) {
          resolvedWiringFlag = Number(wiringFlag);
        } else if (wiringFlag != null && wiringFlag !== "") {
          resolvedWiringFlag = Number(wiringFlag);
        }
        if (
          Number(item.applicationProgressId) === 2 &&
          Number(item.objectionStatus) === 1
        ) {
          resolvedWiringFlag = null;
        }
        setFlag_wiringTestReport(resolvedWiringFlag);
        setWiringTestReportObjectionRemarks(
          getCoaWiringTestReportDocumentRemarks(item, resolvedWiringFlag)
        );
        setDialogRowData(item);
        await getDocumentApi(item.applicationId);

        if (Number(item.applicationProgressId) === 2) {
          await getWiringTestReport(item.applicationId);
        }

        if (item.applicationProgressId == 4 || item.objectionStatus == 1) {

          fieldFormik.setFieldValue(
            "iv_objection_Type",
            item.observationType
          );
        } else {

          fieldFormik.setFieldValue(
            "iv_objection_Type",
            1
          );
        }

        let subDivisionObject = null;
        if (item.referenceNumber) {
          subDivisionObject = subDivisions.find(
            (objs) =>
              objs.subDivisionCode == parseInt(item.referenceNumber.slice(2, 7))
          );
          if (subDivisionObject) {
            setBankName(subDivisionObject.subDivBankName);
          }
        }

        if (item.applicationProgressId === 4 && item.objectionStatus === 0) {
          let subDivisionObject = subDivisions.find(
            (objs) => objs.subDivisionCode === item.subDivisionCode
          );
          if (subDivisionObject) {
            setBankName(subDivisionObject.subDivBankName);
          }
        }
        if (
          (item.applicationProgressId >= 4 &&
            (item.objectionStatus === 0 ||
              item.objectionStatus === 1 ||
              item.objectionStatus === 2)) ||
          (dialogRowData.applicationProgressId === 6 &&
            (dialogRowData.objectionStatus === 0 ||
              dialogRowData.objectionStatus === 2 ||
              dialogRowData.objectionStatus === 1)) ||
          (dialogRowData.applicationProgressId === 7 &&
            (dialogRowData.objectionStatus === 0 ||
              dialogRowData.objectionStatus === 2)) ||
          (dialogRowData.applicationProgressId === 8 &&
            (dialogRowData.objectionStatus === 0 ||
              dialogRowData.objectionStatus === 2))
        ) {
          const myHeaders = new Headers();
          myHeaders.append("Authorization", token);
          myHeaders.append("Content-Type", "application/json");

          const raw = JSON.stringify({
            applicationId: item.applicationId,
          });

          const requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: raw,
            redirect: "follow",
          };

          try {
            const dnResponse = await fetch(
              cfpBaseUrl + "changeOfAttributes/getDemandNoteData",
              requestOptions
            );
            const dnText = await dnResponse.text();
            const result = dnText ? JSON.parse(dnText) : {};
            if (result.status === "200" && result.data?.[0]) {
              setDnImage(result.data[0].paidDNImage);
              setDnApproveStep(result.data[0]);
              setDnDets(result.data[0]);
              // Store the expiry flag for dialog DN download check
              const dnExpiryFlag = result.dnExpiryFlag || result.data[0].demandNoteExpiryFlag;
              const isExpired = dnExpiryFlag === "1" || dnExpiryFlag === 1;
              setDialogDnExpiryFlag(isExpired);
            }
          } catch {
            /* invalid / HTML response — keep existing DN details */
          }
        }

        if (item.applicationProgressId >= 7) {
          const myHeaders = new Headers();
          myHeaders.append("Authorization", token);
          myHeaders.append("Content-Type", "application/json");

          const raw = JSON.stringify({
            applicationId: item.applicationId,
          });

          const requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: raw,
            redirect: "follow",
          };

          fetch(cfpBaseUrl + "changeOfAttributes/getSCODetail", requestOptions)
            .then((response) => response.json())
            .then((result) => {
              setScoDetails(result.data[0]);
            })
            .catch(() => { });
        }
        // if (item.applicationProgressId >= 4) {
        //   var formdata = new FormData();
        //   const myHeaders = new Headers();
        //   myHeaders.append("Authorization", token);
        //   formdata.append("applicationId", item.applicationId);

        //   var requestOptions = {
        //     method: 'POST',
        //     body: formdata,
        //     headers: myHeaders,
        //     redirect: 'follow',
        //   };

        //   await fetch(cfpBaseUrl + "changeOfName/getPaidDNForChangeOfName", requestOptions)
        //     .then(response => response.json())
        //     .then(result => {
        //       if (result.status === "200") {
        //         setDnImage(result.data[0].paidDNImage)
        //         setDnPaymentDate(result.data[0].paymentDate)
        //       }
        //     })
        // }

        // if (item.applicationProgressId >= 5) {
        //   var formdata = new FormData();
        //   formdata.append("applicationId", item.applicationId);
        //   const myHeaders = new Headers();
        //   myHeaders.append("Authorization", token);;

        //   var requestOptions = {
        //     method: 'POST',
        //     body: formdata,
        //     headers: myHeaders,
        //     redirect: 'follow',
        //   };

        //   await fetch(cfpBaseUrl + "changeOfName/getDNForChangeOfName", requestOptions)
        //     .then(response => response.json())
        //     .then(result => {
        //       setDnDetails(result.data[0])
        //       sjoFormik.values.iv_batch = result.data[0].batchNo
        //     })

        //   callGetSJOAPI(item.applicationId)
        // }

        setViewBackdrop(false);
        setOpen(true);
      } else {
        setViewBackdrop(false);
      }
    } else {
      setViewBackdrop(false);
    }
  };

  const showArrearsVerifyPopup = () => {
    setArrearsVerifyPopUpOpen(true);
  };

  const showArrearsEntryPopup = async () => {
    await referenceApi();
    setArrearsEntryPopUpOpen(true);
  };

  const downloadSJOPDF = async (
    applicationId,
    scoDetails,
    dialogRowData,
    dnDets
  ) => {
    setViewBackdrop(true);
    try {
      const doc = new jsPDF();
      const pageWidth = doc.internal.pageSize.getWidth();

      let application =
        changeOfNameApplications.find(
          (item) => item.applicationId === applicationId
        ) ||
        changeOfNameApplicationsOverDue.find(
          (item) => item.applicationId === applicationId
        ) ||
        dialogRowData;

      let officeCode = dialogRowData.subDivisionCode || "---";
      let officeName =
        subdivisionName(
          parseInt(dialogRowData.subDivisionCode),
          subDivisions
        ) || "---";
      let authorizedByName = scoDetails.scoApprovedBy || "---";
      let authorizedByDesignation =
        scoDetails.scoApprovedByDesignation || "Role";
      let dateToPrint = scoDetails.scoApprovalDate
        ? new Date(scoDetails.scoApprovalDate).toLocaleDateString()
        : "---";

      let stampData = printStamp(
        officeCode,
        officeName,
        authorizedByName,
        authorizedByDesignation,
        dateToPrint
      );
      // doc.addImage(stampData, "PNG", 170, 170, 55, 40);

      let CompanyName = getDocumentDiscoCode(
        dialogRowData.applicationId,
        dialogRowData.companyCode,
      );
      const DiscoCode = CompanyName;

      const smallLogoCodes = ["12", "13", "11", "16", "26", "27", "48", "59"];
      const logoWidth = smallLogoCodes.includes(DiscoCode) ? 25 : 30;
      const logoHeight = smallLogoCodes.includes(DiscoCode) ? 15 : 8;
      const logoX = (pageWidth - logoWidth) / 2;

      let height = 10;

      doc.addImage(getLogo(DiscoCode), "PNG", logoX, 5, logoWidth, logoHeight);

      height += 15;
      doc.setFontSize(12);
      doc.setFont("helvetica", "bold");
      doc.text(getCompanies(DiscoCode), pageWidth / 2, height, {
        align: "center",
      });

      doc.setFontSize(12);
      doc.text("Sundary Job Orders", 105, 34, { align: "center" });

      let y = 50;

      doc.setFontSize(10);

      doc.setFont(undefined, "bold");
      doc.text("Application No.: ", 20, y);
      doc.setFont(undefined, "normal");
      doc.text(dialogRowData.applicationId || "-", 60, y);
      doc.setFont(undefined, "bold");
      doc.text("Sub-Division: ", 110, y);
      doc.setFont(undefined, "normal");
      doc.text(
        dialogRowData.subDivisionCode +
        " (" +
        subdivisionName(
          parseInt(dialogRowData.subDivisionCode),
          subDivisions
        ) +
        ")" || "-",
        150,
        y
      );
      y += 6;

      doc.setFont(undefined, "bold");
      doc.text("Reference No.: ", 20, y);
      doc.setFont(undefined, "normal");
      doc.text(dialogRowData.referenceNumber || "-", 60, y);
      doc.setFont(undefined, "bold");
      doc.text("Customer Id: ", 110, y);
      doc.setFont(undefined, "normal");
      doc.text(dialogRowData.customerId || "-", 150, y);
      y += 6;

      doc.setFont(undefined, "bold");
      doc.text("DN Approval Date: ", 20, y);
      doc.setFont(undefined, "normal");
      doc.text(
        dnDets?.approvedDate ? convertDate(dnDets.approvedDate) : "-",
        60,
        y
      );
      doc.setFont(undefined, "bold");
      doc.text("Meter Number: ", 110, y);
      doc.setFont(undefined, "normal");
      doc.text(dnDets?.meterNo || "-", 150, y);
      y += 6;

      doc.setFont(undefined, "bold");
      doc.text("Feeder Name & Code: ", 20, y);
      doc.setFont(undefined, "normal");
      doc.text(dnDets?.feederNo || "-", 60, y);
      y += 10;

      doc.setFontSize(10);
      doc.setFont(undefined, "normal");

      const sjoText = dnDets.sjoData || "-";
      const maxWidth = pageWidth - 40;
      const lines = doc.splitTextToSize(sjoText, maxWidth);

      lines.forEach((line, index) => {
        if (index < lines.length - 1) {
          doc.text(line, 20, y, { align: "justify", maxWidth: maxWidth });
        } else {
          doc.text(line, 20, y);
        }
        y += 6;
      });

      y += 4;

      const isCurrentNewFormat = [1, 4, 5, 6].includes(
        dialogRowData.changeOfAttributesType
      );
      const col2Header = isCurrentNewFormat ? "Current" : "Old";
      const col3Header = "New";

      const tableRows = getTableRows(dialogRowData);

      doc.autoTable({
        startY: y,
        head: [["", col2Header, col3Header]],
        body: tableRows.map((row) => [
          row.label || "-",
          row.current || "-",
          row.newVal || "-",
        ]),
        theme: "grid",
        headStyles: {
          fillColor: [30, 82, 167],
          textColor: [255, 255, 255],
          fontStyle: "bold",
          lineWidth: 0.5,
          lineColor: [21, 101, 192],
          halign: "left",
          cellPadding: { top: 3, right: 5, bottom: 3, left: 5 },
        },
        bodyStyles: {
          lineWidth: 0.5,
          lineColor: [224, 224, 224],
          cellPadding: { top: 4, right: 8, bottom: 4, left: 8 },
        },
        alternateRowStyles: { fillColor: [213, 229, 255] },
        columnStyles: { 0: { fontStyle: "bold" } },
        margin: { left: 20, right: 20 },
        tableWidth: "auto",
      });

      doc.addImage(stampData, "PNG", 170, 150, 55, 40);

      const totalPages = doc.internal.getNumberOfPages();
      for (let i = 1; i <= totalPages; i++) {
        doc.setPage(i);
        doc.addImage(
          getWaterMarkLogo(CompanyName),
          "PNG",
          0,
          0,
          doc.internal.pageSize.getWidth(),
          doc.internal.pageSize.getHeight()
        );
      }

      const pdfBlob = doc.output("blob");
      const pdfUrl = URL.createObjectURL(pdfBlob);
      window.open(pdfUrl, "_blank");
    } catch (e) { /* ignored */ }
    setViewBackdrop(false);
  };

  const hideArrearRejectionRemovalAlert = () => {
    setArearPaidBillDocument("");
    setArearPaidBillDocumentThumbnail("");
    arearBillDocumentFormik.resetForm();
    setArrearRejectionRemovalAlert(false);
  };

  const hideSignedConsentRejectionRemovalAlert = () => {
    setSignedConsentRejectionRemovalAlert(false);
    setSignedConsentFormImageImage("");
    setConsentVerificationFlag(0);
    setSignedConsentFormImageImageThumbnail("");
  };

  const [historyData, setHistoryData] = useState();
  const [historyViewFlags, setHistoryViewFlags] = useState(null);

  const closeCoaHistoryPopup = (setPopUpOpen) => {
    setPopUpOpen(false);
    setHistoryData(null);
    setHistoryViewFlags(null);
    closeAllCoaDocumentVerifyPopups();
    syncCoaLiveDocumentFlagsFromDialog();
  };

  const getCoaApplicationSubmittedActivityTitle = (data) => {
    if (isCoaApplicationSubmittedHistoryView(data)) return "Application Submitted";
    if (
      (data?.applicationProgressId == 1 || data?.applicationProgressId == 4) &&
      isCoaRevertToDocumentsVerificationRemarks(getCoaHistoryRemarksText(data))
    ) {
      return "Objection";
    }
    if (data?.applicationProgressId == 1 && data?.remarks === "Documents Rejected") {
      return "Document Objections";
    }
    return "Application Submitted";
  };

  const getCoaApplicationSubmittedActivityFooter = (data) => {
    if (
      (data?.applicationProgressId == 1 || data?.applicationProgressId == 4) &&
      isCoaRevertToDocumentsVerificationRemarks(getCoaHistoryRemarksText(data))
    ) {
      return `Application reverted to Document Verification by: ${data?.lastModifiedBy} on: ${convertDatewithTime(data?.lastModificationDate)}`;
    }
    return `Application Submitted by: ${data?.createdBy} on: ${convertDatewithTime(data?.creationDate)}`;
  };

  const getCoaDocumentsVerifiedActivityTitle = (data) => {
    if (isCoaWiringTestReportRejectedHistoryView(data)) {
      return "Wiring Test Report Rejected";
    }
    if (isCoaWiringTestReportReuploadedHistoryView(data)) {
      return "Wiring Test Report Reuploaded";
    }
    if (isCoaWiringTestReportHistoryView(data)) {
      if (historyViewFlags?.wiringTestReport === -1) {
        return "Wiring Test Report Rejected";
      }
      if (historyViewFlags?.wiringTestReport === 2) {
        return "Wiring Test Report Reuploaded";
      }
      return "Wiring Test Report Verified";
    }
    if (isCoaDocumentVerificationObjectionView(data)) return "Document Verification";
    if (isCoaDocumentsVerifiedHistoryView(data)) return "Documents Verified";
    if (
      data?.applicationProgressId == 3 &&
      data?.objectionStatus == 0 &&
      data?.remarks !== "Revert to Arrear Verification"
    ) {
      return "Documents Verified";
    }
    if (
      data?.applicationProgressId == 3 &&
      data?.objectionStatus == 0 &&
      data?.remarks === "Revert to Arrear Verification"
    ) {
      return "Objection";
    }
    return "Documents Verified";
  };

  const getCoaDocumentsVerifiedActivityFooter = (data) => {
    if (isCoaWiringTestReportRejectedHistoryView(data)) {
      return `Wiring Test Report is rejected by: ${data?.lastModifiedBy} on: ${convertDatewithTime(data?.lastModificationDate)}`;
    }
    if (isCoaWiringTestReportReuploadedHistoryView(data)) {
      return `Wiring Test Report is reuploaded by: ${data?.lastModifiedBy} on: ${convertDatewithTime(data?.lastModificationDate)}`;
    }
    if (isCoaWiringTestReportHistoryView(data)) {
      return `${data?.remarks || "Wiring Test Report Verified"} by: ${data?.lastModifiedBy} on: ${convertDatewithTime(data?.lastModificationDate)}`;
    }
    return `Documents Verified by: ${data?.lastModifiedBy} on: ${convertDatewithTime(data?.lastModificationDate)}`;
  };

  const getCoaArrearVerifiedActivityTitle = (data) => {
    if (isCoaArrearVerificationHistoryView(data)) return "Arrear Verification";
    if (data?.applicationProgressId == 4 && data?.objectionStatus == 0) {
      return "Arrear Verified";
    }
    return "Arrear Objection";
  };

  const getCoaFieldSurveyActivityTitle = (data) => {
    if (data?.applicationProgressId == 5 && data?.objectionStatus == 0) {
      return "Field Survey";
    }
    if (isCoaRevertToFieldSurveyHistoryView(data)) {
      return "Application Reverted to Field Survey";
    }
    if (data?.applicationProgressId == 4 && data?.objectionStatus == 1) {
      return "Field Survey Objection";
    }
    if (
      data?.applicationProgressId == 4 &&
      data?.objectionStatus != 1 &&
      data?.remarks == "Field Survey Objection Removed."
    ) {
      return "Field Survey";
    }
    return "Field Survey";
  };

  const getCoaDnApprovalActivityTitle = (data) => {
    if (isCoaDemandNoteRejectionHistoryView(data)) return "Demand Note Rejected";
    if (data?.applicationProgressId == 6 && data?.objectionStatus == 1) {
      return "Demand Note Objection";
    }
    return "Demand Note Approved";
  };

  const openCoaApplicationUpdatedPopUp = async (stepRow) => {
    const historyId = getCoaHistoryId(stepRow);
    if (!historyId || !dialogRowData?.applicationId) return;

    setViewBackdrop(true);
    try {
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      myHeaders.append("Content-Type", "application/json");

      const response = await fetch(
        cfpBaseUrl + "changeOfAttributes/getDetailByHistoryId",
        {
          method: "POST",
          headers: myHeaders,
          body: JSON.stringify({
            applicationId: dialogRowData.applicationId,
            historyId,
          }),
        }
      );
      const result = await response.json();

      if (result.status === "200" && result.data?.[0]) {
        setCoaApplicationUpdatedHistoryData(result.data[0]);
        setCoaApplicationUpdatedPopUp(true);
      }
    } catch (error) { /* ignored */ } finally {
      setViewBackdrop(false);
    }
  };

  const openCoaFetchedHistoryPopup = async (hist, stepName) => {
    if (shouldOpenCoaApplicationUpdatedPopUp(hist, stepName)) {
      setCoaApplicationUpdatedHistoryData(hist);
      setCoaApplicationUpdatedPopUp(true);
      return true;
    }

    const mergedHistoryData = mergeCoaHistoryData(hist, stepName);
    closeAllCoaDocumentVerifyPopups();

    let resolvedHistoryData = mergedHistoryData;
    if (
      isCoaDocumentsVerifiedHistoryView(mergedHistoryData) ||
      isCoaDocumentVerificationObjectionView(mergedHistoryData)
    ) {
      const applicationDocs = await getDocumentApi(dialogRowData.applicationId);
      resolvedHistoryData = mergeCoaHistoryDocuments(
        mergedHistoryData,
        applicationDocs,
      );
    }

    setHistoryData(resolvedHistoryData);
    applyCoaHistoryViewFlags(resolvedHistoryData);

    if (isCoaApplicationRevertedHistoryView(mergedHistoryData)) {
      setCoaApplicationRevertedSubPopUp(true);
      return true;
    }

    const popupProgressId = getCoaPopupProgressId(hist, stepName);

    if (
      Number(hist.applicationProgressId) === 0 ||
      Number(stepName.applicationProgressId) === 0
    ) {
      setApplicationSubmittedPopUp(true);
    } else if (stepName.applicationProgressId == 1 && stepName.objectionStatus == 1) {
      setDocumentsVerifiedSubPopUp(true);
    } else if (
      hist.applicationProgressId == 1 &&
      stepName.objectionStatus != 1) {
      setApplicationSubmittedPopUp(true);
    } else if (
      hist.applicationProgressId == 1 &&
      stepName.objectionStatus != 1
    ) {
      setApplicationSubmittedPopUp(true);
    } else if (
      hist.applicationProgressId == 2 &&
      stepName.objectionStatus == 0
    ) {
      setDocumentsVerifiedSubPopUp(true);
    } else if (
      hist.applicationProgressId == 2 &&
      stepName.objectionStatus == 1
    ) {
      setDocumentsVerifiedSubPopUp(true);
    } else if (
      hist.applicationProgressId == 2 &&
      Number(stepName.objectionStatus) === 2
    ) {
      setDocumentsVerifiedSubPopUp(true);
    } else if (
      hist.applicationProgressId == 2 &&
      stepName.objectionStatus != 1 &&
      stepName.remarks === "Revert to Arrear Verification"
    ) {
      setDocumentsVerifiedSubPopUp(true);
    } else if (hist.applicationProgressId == 1 && stepName.objectionStatus == 2) {
      setDocumentsVerifiedSubPopUp(true);
    } else if (isCoaDocumentsVerifiedHistoryView(resolvedHistoryData)) {
      setDocumentsVerifiedSubPopUp(true);
    } else if (
      hist.applicationProgressId == 3 &&
      Number(stepName.objectionStatus) === 0 &&
      isCoaWiringTestReportHistory(hist)
    ) {
      setDocumentsVerifiedSubPopUp(true);
    } else if (
      hist.applicationProgressId == 3 &&
      stepName.objectionStatus != 1 &&
      stepName.remarks === "Arrears Verified"
    ) {
      setArrearVerifiedSubPopUp(true);
    } else if (
      hist.applicationProgressId == 3 &&
      stepName.objectionStatus != 1 &&
      stepName.remarks === "Revert to Field Survey."
    ) {
      setFieldSurveyedSubPopUp(true);
    } else if (
      hist.applicationProgressId == 3 &&
      stepName.objectionStatus != 1 &&
      stepName.remarks === "Field Survey Objection Removed."
    ) {
      setFieldSurveyedSubPopUp(true);
    } else if (hist.applicationProgressId == 3 && stepName.objectionStatus == 1) {
      setFieldSurveyedSubPopUp(true);
    } else if (
      hist.applicationProgressId == 4 &&
      Number(stepName.objectionStatus) === 0 &&
      (hist.remarks === "Arrears Verified" ||
        stepName.remarks === "Arrears Verified")
    ) {
      setArrearVerifiedSubPopUp(true);
    } else if (
      hist.applicationProgressId == 4 &&
      Number(stepName.objectionStatus) === 0 &&
      isCoaRevertToDocumentsVerificationRemarks(
        getCoaHistoryRemarksText(mergedHistoryData)
      )
    ) {
      setApplicationSubmittedPopUp(true);
    } else if (
      hist.applicationProgressId == 4 &&
      Number(stepName.objectionStatus) === 0
    ) {
      setFieldSurveyedSubPopUp(true);
    } else if (hist.applicationProgressId == 4) {
      await callAsyncGetConsentImage(dialogRowData.applicationId);
      setFieldSurveyedSubPopUp(true);
    } else if (
      hist.applicationProgressId == 5 &&
      Number(stepName.objectionStatus) === 0
    ) {
      setFieldSurveyedSubPopUp(true);
    } else if (hist.applicationProgressId == 5) {
      await callAsyncDnDetailsAPI(dialogRowData.applicationId);
      setDnApprovalSubPopUp(true);
    } else if (hist.applicationProgressId == 6) {
      if (Number(stepName.objectionStatus) === 1) {
        await callAsyncGetPaidDnImageAPI(dialogRowData.applicationId);
      } else {
        await callAsyncDnDetailsAPI(dialogRowData.applicationId);
      }
      setDnApprovalSubPopUp(true);
    } else if (hist.applicationProgressId == 7) {
      await callAsyncGetPaidDnImageAPI(dialogRowData.applicationId);
      setDnPaymentSubmittedSubPopUp(true);
    } else if (popupProgressId === 7) {
      setDnPaymentVerifiedSubPopUp(true);
    } else if (popupProgressId === 8 && Number(stepName.objectionStatus) === 0) {
      await loadCoaDemandNoteDataForHistory(dialogRowData.applicationId);
      setServiceConnectionOrderedSubPopUp(true);
    } else if (popupProgressId === 9 && Number(stepName.objectionStatus) === 0) {
      setReadyForBillingSubPopUp(true);
    } else {
      return false;
    }

    return true;
  };

  const openDetailsPopUp = async (stepRowOrTableRow) => {
    const stepName = resolveActivityLogHistoryRow(stepRowOrTableRow);

    if (
      stepRowOrTableRow?.isApplicationUpdatedEntry === true ||
      shouldOpenCoaApplicationUpdatedPopUp(stepName, stepRowOrTableRow)
    ) {
      await openCoaApplicationUpdatedPopUp(stepName);
      return;
    }

    let openedFromFetch = false;
    let fetchedHist = null;

    if (
      stepName &&
      typeof stepName === "object" &&
      stepName.applicationProgressId != undefined
    ) {
      const historyId =
        getCoaHistoryId(stepName) ?? getCoaHistoryId(stepRowOrTableRow);

      if (historyId) {
        setViewBackdrop(true);
        try {
          const myHeaders = new Headers();
          myHeaders.append("Authorization", token);
          myHeaders.append("Content-Type", "application/json");

          const response = await fetch(
            cfpBaseUrl + "changeOfAttributes/getDetailByHistoryId",
            {
              method: "POST",
              headers: myHeaders,
              body: JSON.stringify({
                applicationId: dialogRowData.applicationId,
                historyId,
              }),
            }
          );
          const result = await response.json();

          if (result.status === "200" && result.data?.[0]) {
            fetchedHist = result.data[0];
            openedFromFetch = await openCoaFetchedHistoryPopup(
              fetchedHist,
              stepName
            );
          }
        } catch (error) { /* ignored */ } finally {
          setViewBackdrop(false);
        }
      }
    }

    if (openedFromFetch) return;

    const stepLabel =
      typeof stepRowOrTableRow === "string"
        ? stepRowOrTableRow
        : stepRowOrTableRow?.stepName ||
        getCoaActivityStepLabel(stepRowOrTableRow, stepName);

    if (
      stepLabel === "Application Submitted" ||
      stepLabel === "DOCUMENT SUBMISSION" ||
      stepLabel === "Document Submission"
    ) {
      if (stepName && typeof stepName === "object") {
        closeAllCoaDocumentVerifyPopups();
        setHistoryData(stepName);
        applyCoaHistoryViewFlags(stepName);
      }
      setApplicationSubmittedPopUp(true);
      return;
    }

    await openCoaStepLabelPopup(
      stepLabel,
      fetchedHist ?? (stepName && typeof stepName === "object" ? stepName : null),
    );
  };

  const hideCopyOfApplicantCNICVerifyAlert = (x) => {
    setCopyOfApplicantCNICVerifyPopUp(x);
  };

  const hidePreOwenerCnicVerifyAlert = (x) => {
    setPreOwnerCNICVerifyPopUp(x);
  };

  const hideElectricityBillVerifyAlert = (x) => {
    setElectricityBillDocumentVerifyPopUp(x);
  };

  const hideFbrDocumentVerifyAlert = (x) => {
    setFbrDocumentVerifyPopUp(x);
  };

  const hidePaidBillAlert = (x) => {
    setPaidBillPopUp(x);
  };
  const hidePerOwenerNOCVerifyAlert = (x) => {
    setPerOwenerNOCVerifyPopUp(x);
  };

  const hideNewOwenerAffidaviteVerifyAlert = (x) => {
    setNewOwenerAffidaviteVerifyPopUp(x);
  };

  const hideAddDocCivicAuthorityVerifyAlert = (x) => {
    setAddDocCivicAuthorityVerifyPopUp(x);
  };

  const hideAddAnyOtherVerifyAlert = (x) => {
    setAddDocAnyOtherVerifyPopUp(x);
  };
  const hideAddConsentCONVerifyAlert = (x) => {
    setAddDocCONConsentVerifyPopUp(x);
  };

  const hidePropertyDocVerifyAlert = (x) => {
    setOwenershipDocumentVerifyPopUp(x);
  };

  const hideFbrDocVerifyAlert = (x) => {
    setFbrDocumentVerifyPopUp(x);
  };

  const hideConsentImagePopUp = () => {
    setConsentImagePopUp(false);
  };

  const hidePaidDnImagePopUp = () => {
    setPaidDNImagePopUp(false);
    setPaidDnViewerDocument(null);
  };

  const openPaidDnImageViewer = (imageSrc) => {
    if (!imageSrc) return;
    setPaidDnViewerDocument(imageSrc);
    setPaidDNImagePopUp(true);
  };

  const hideWiringTestReportVerifyAlert = (x) => {
    setWiringTestReportVerifyPopUp(x);
  };

  const stepName = (x) => {
    if (x === 0) {
      return "Document Submission";
    }
    // else if (x === 1) {
    //   return 'Document Submission'
    // }
    else if (x === 1) {
      return "Document Verification";
    } else if (x === 2) {
      return "Wiring Test Report";
    } else if (x === 3) {
      return "Arrear Verification";
    } else if (x === 4) {
      return "Field Survey";
    } else if (x === 5) {
      return "DN Approval";
    } else if (x === 6) {
      return "DN Submission";
    } else if (x === 7) {
      return "DN Payment Verification";
    } else if (x === 8) {
      return "Sundary Jobs Order";
    }
  };

  //#endregion

  //#region API Functions

  const callResetObjectionStatus = async (applicationId) => {
    var formdata = new FormData();
    formdata.append("applicationId", applicationId);
    const myHeaders = new Headers();
    myHeaders.append("Authorization", token);

    var requestOptions = {
      method: "POST",
      body: formdata,
      headers: myHeaders,
      redirect: "follow",
    };

    await fetch(
      cfpBaseUrl + "changeOfName/resetObjectionStatus",
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (result.status === "200") {
          completeCoaWorkflowStep(result.message || "Objection status updated.");
        } else {
          showCoaWorkflowResult(
            result.message || "Failed to update objection status.",
            "error"
          );
        }
      })
      .catch(() => { });
  };

  // const AdditionalCivicDocument = (event) => {
  //   const newFileName = 'additionalCivicDocument.' + event.target.files[0].name.split(".").pop();
  //   handleFileUpload(event, handleChange, setAdditionalCivicDocument, setAdditionalCivicDocumentError, setAdditionalCivicDocumentThumbnail, newFileName);
  // };

  // const callingUpdateDocumentStatusAPI = async (
  //   applicationId = dialogRowData.applicationId,
  //   applicationProgressId = dialogRowData.applicationProgressId,
  //   objectionStatus = dialogRowData.objectionStatus,
  //   flag_applicantCNICFront,
  //   flag_applicantCNICBack,
  //   flag_owenershipDocument,
  //   flag_electricityBillDocument,
  //   applicantCNICBackObjectionRemarks,
  //   applicantCNICFrontObjectionRemarks,
  //   owenershipObjectionRemarks,
  //   electricityBillObjectionRemarks,
  //   remarks
  // ) => {
  //   const myHeaders = new Headers();
  //   myHeaders.append("Authorization", token);
  //   myHeaders.append("Content-Type", "application/json");

  //   const remarksDetails = (
  //     (applicantCNICFrontObjectionRemarks
  //       ? `Applicant CNIC Front: ${applicantCNICFrontObjectionRemarks}`
  //       : "") +
  //     (applicantCNICBackObjectionRemarks
  //       ? `, Applicant CNIC Back: ${applicantCNICBackObjectionRemarks}`
  //       : "") +
  //     (electricityBillObjectionRemarks
  //       ? `, Electricity Bill Document: ${electricityBillObjectionRemarks}`
  //       : "") +
  //     (owenershipObjectionRemarks
  //       ? `, Ownership Document: ${owenershipObjectionRemarks}`
  //       : "") +
  //     (fbrDocumentObjectionRemarks
  //       ? `, Fbr Document: ${fbrDocumentObjectionRemarks}`
  //       : "")
  //   ).replace(/^, /, "");

  //   const raw = JSON.stringify({
  //     applicationId: applicationId,
  //     applicationProgressId: applicationProgressId,
  //     objectionStatus: objectionStatus,
  //     remarks:
  //       flag_applicantCNICFront === -1 ||
  //       flag_applicantCNICBack === -1 ||
  //       flag_owenershipDocument === -1 ||
  //       flag_electricityBillDocument === -1
  //         ? "Documents Rejected"
  //         : "Documents Verified",
  //     remarksDetail: remarksDetails,
  //     applicantCNICFrontFlag: flag_applicantCNICFront,
  //     applicantCNICBackFlag: flag_applicantCNICBack,
  //     electricityBillFlag: flag_electricityBillDocument,
  //     ownershipImageFlag: flag_owenershipDocument,
  //     fbrDocumentFlag: flag_fbrDocument,
  //     applicantCNICFrontRemarks: applicantCNICFrontObjectionRemarks,
  //     applicantCNICBackRemarks: applicantCNICFrontObjectionRemarks,
  //     electricityBillRemarks: electricityBillObjectionRemarks,
  //     ownershipImageRemarks: owenershipObjectionRemarks,
  //     fbrDocumentRemarks: fbrDocumentObjectionRemarks,
  //   });

  //   const requestOptions = {
  //     method: "POST",
  //     headers: myHeaders,
  //     body: raw,
  //     redirect: "follow",
  //   };

  //   await fetch(
  //     cfpBaseUrl + "changeOfAttributes/verifyDocuments",
  //     requestOptions
  //   )
  //     .then((response) => response.json())
  //     .then((result) => {
  //       if (result.status === "200") {
  //         setFlag_owenershipDocument(null);
  //         setFlag_electricityBillDocument(null);
  //         setFlag_fbrDocument(null);
  //         setFlag_applicantCNICBack(null);
  //         setFlag_applicantCNICFront(null);
  //         handleClose();
  //       } else {
  //       }
  //     })
  //     .catch(() => {});
  // };

  const callingUpdateDocumentStatusAPI = async (
    applicationId = dialogRowData.applicationId,
    applicationProgressId = dialogRowData.applicationProgressId,
    objectionStatus = dialogRowData.objectionStatus,
    flag_applicantCNICFront,
    flag_applicantCNICBack,
    flag_owenershipDocument,
    flag_electricityBillDocument,
    flag_fbrDocumentParam,
    flag_addDocAnyOtherParam,
    applicantCNICBackObjectionRemarks,
    applicantCNICFrontObjectionRemarks,
    owenershipObjectionRemarks,
    electricityBillObjectionRemarks,
    fbrDocumentObjectionRemarksParam,
    addDocAnyOtherObjectionRemarksParam,
    remarks
  ) => {
    setViewBackdrop(true); // 🔵 Loader ON

    try {
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      myHeaders.append("Content-Type", "application/json");

      const remarksDetails = (
        (applicantCNICFrontObjectionRemarks
          ? `Applicant CNIC Front: ${applicantCNICFrontObjectionRemarks}`
          : "") +
        (applicantCNICBackObjectionRemarks
          ? `, Applicant CNIC Back: ${applicantCNICBackObjectionRemarks}`
          : "") +
        (electricityBillObjectionRemarks
          ? `, Electricity Bill Document: ${electricityBillObjectionRemarks}`
          : "") +
        (owenershipObjectionRemarks
          ? `, Ownership Document: ${owenershipObjectionRemarks}`
          : "") +
        (fbrDocumentObjectionRemarksParam
          ? `, FBR Document: ${fbrDocumentObjectionRemarksParam}`
          : "") +
        (addDocAnyOtherObjectionRemarksParam
          ? `, Any Other Document: ${addDocAnyOtherObjectionRemarksParam}`
          : "")
      ).replace(/^, /, "");

      const isChangeOfNameOnly = isChangeOfNameOnlyApplication(
        dialogRowData.changeOfAttributesType
      );
      const isDocumentsRejected =
        flag_applicantCNICFront === -1 ||
        flag_applicantCNICBack === -1 ||
        flag_owenershipDocument === -1 ||
        flag_electricityBillDocument === -1 ||
        flag_addDocAnyOtherParam === -1;

      const resolvedApplicationProgressId =
        isChangeOfNameOnly && Number(objectionStatus) === 0 && !isDocumentsRejected
          ? 3
          : Number(applicationProgressId);

      const skipWiringTestReport =
        isChangeOfNameOnly && resolvedApplicationProgressId === 3;

      const raw = JSON.stringify({
        applicationId,
        applicationProgressId: resolvedApplicationProgressId,
        objectionStatus,
        remarks: isDocumentsRejected ? "Documents Rejected." : "Documents Verified.",
        remarksDetail: remarksDetails,
        applicantCNICFrontFlag: flag_applicantCNICFront,
        applicantCNICBackFlag: flag_applicantCNICBack,
        electricityBillFlag: flag_electricityBillDocument,
        ownershipImageFlag: flag_owenershipDocument,
        fbrDocumentFlag: flag_fbrDocumentParam ? flag_fbrDocumentParam : null,
        anyOtherDocumentFlag: flag_addDocAnyOtherParam ? flag_addDocAnyOtherParam : null,
        applicantCNICFrontRemarks: applicantCNICFrontObjectionRemarks,
        applicantCNICBackRemarks: applicantCNICBackObjectionRemarks
          ? applicantCNICBackObjectionRemarks
          : "Verified",
        electricityBillRemarks: electricityBillObjectionRemarks,
        ownershipImageRemarks: owenershipObjectionRemarks,
        fbrDocumentRemarks: fbrDocumentObjectionRemarksParam,
        anyOtherDocumentRemarks: addDocAnyOtherObjectionRemarksParam,
        // Change of Name only: skip wiring step in progress, but do not put
        // "Wiring Test Report Verified" into document-verification remarks.
        ...(skipWiringTestReport
          ? {
            wiringTestReportDocumentFlag: "1",
            wiringTestReportDocumentRemarks: "Not required - Change of Name only",
            wiringTestReportDocumentObjectionRemarks:
              "Not required - Change of Name only",
          }
          : {}),
      });

      const response = await fetch(
        cfpBaseUrl + "changeOfAttributes/verifyDocuments",
        {
          method: "POST",
          headers: myHeaders,
          body: raw,
        }
      );

      const result = await response.json();

      if (result.status === "200") {
        setFlag_owenershipDocument(null);
        setFlag_electricityBillDocument(null);
        setFlag_fbrDocument(null);
        setFlag_addDocAnyOther(null);
        setFlag_applicantCNICBack(null);
        setFlag_applicantCNICFront(null);
        completeCoaWorkflowStep(
          result.message ||
          (isDocumentsRejected
            ? "Documents rejected successfully."
            : "Documents verified successfully.")
        );
      } else {
        showCoaWorkflowResult(
          result.message || "Failed to update document status.",
          "error"
        );
      }
    } catch (error) { /* ignored */ } finally {
      setViewBackdrop(false); // 🔵 Loader OFF (always)
    }
  };

  const verifyOrRejectWiringTestReport = async (
    applicationId,
    progressId,
    objectionStatus,
    remarks,
    wiringTestReportDocumentFlag,
    wiringTestReportDocumentRemarks
  ) => {
    setViewBackdrop(true);

    const myHeaders = new Headers();
    myHeaders.append("Authorization", token);
    myHeaders.append("Content-Type", "application/json");

    const raw = JSON.stringify({
      applicationId,
      applicationProgressId: progressId,
      objectionStatus,
      remarks,
      remarksDetail: remarks,
      wiringTestReportDocumentFlag: String(wiringTestReportDocumentFlag),
      wiringTestReportDocumentRemarks: wiringTestReportDocumentRemarks || "",
      wiringTestReportDocumentObjectionRemarks:
        wiringTestReportDocumentRemarks || "",
      lastModifiedBy: userId,
    });

    try {
      const response = await fetch(
        cfpBaseUrl + "changeOfAttributes/verifyWiringTestReport",
        {
          method: "POST",
          headers: myHeaders,
          body: raw,
        }
      );
      const result = await response.json();

      if (result.status === "200" || result.status === 200) {
        setFlag_wiringTestReport(null);
        setWiringTestReportVerifyPopUp(false);
        completeCoaWorkflowStep(
          result.message || remarks || "Wiring test report updated successfully."
        );
      } else {
        showCoaWorkflowResult(
          result.message || "Failed to update wiring test report.",
          "error"
        );
      }
    } catch (error) { /* ignored */ } finally {
      setViewBackdrop(false);
    }
  };

  const reuploadWiringTestReportAndRemoveObjection = async () => {
    if (!newWiringTestReportDocumentThumbnail) {
      setNewWiringTestReportDocumentError(
        "Please upload new Wiring Test Report document"
      );
      return;
    }

    setViewBackdrop(true);
    const myHeaders = new Headers();
    myHeaders.append("Authorization", token);
    myHeaders.append("Content-Type", "application/json");

    const raw = JSON.stringify({
      applicationId: dialogRowData.applicationId,
      applicationProgressId: 2,
      objectionStatus: 2,
      wiringTestReportDocument: newWiringTestReportDocumentThumbnail,
      lastModifiedBy: userId,
      remarks: "Wiring Test Report Reupload.",
    });

    try {
      const response = await fetch(
        cfpBaseUrl + "changeOfAttributes/reuploadWiringTestReport",
        {
          method: "POST",
          headers: myHeaders,
          body: raw,
          redirect: "follow",
        }
      );
      const result = await response.json();

      if (result.status === "200" || result.status === 200) {
        setNewWiringTestReportDocument("");
        setNewWiringTestReportDocumentThumbnail("");
        setNewWiringTestReportDocumentError("");
        setWiringTestReportVerifyPopUp(false);
        completeCoaWorkflowStep(
          result.message || "Wiring test report re-uploaded successfully."
        );
      } else {
        setNewWiringTestReportDocumentError(
          result.message || "Failed to reupload document"
        );
        showCoaWorkflowResult(
          result.message || "Failed to reupload document.",
          "error"
        );
      }
    } catch (error) {
      setNewWiringTestReportDocumentError("Failed to reupload document");
    } finally {
      setViewBackdrop(false);
    }
  };

  const uploadWiringTestReport = async () => {
    if (!newWiringTestReportDocumentThumbnail) {
      setNewWiringTestReportDocumentError(
        "Please upload Wiring Test Report document"
      );
      return;
    }

    setViewBackdrop(true);
    const myHeaders = new Headers();
    myHeaders.append("Authorization", token);
    myHeaders.append("Content-Type", "application/json");

    const raw = JSON.stringify({
      applicationId: dialogRowData.applicationId,
      applicationProgressId: 2,
      objectionStatus: 0,
      wiringTestReportDocument: newWiringTestReportDocumentThumbnail,
      lastModifiedBy: userId,
      remarks: "Wiring Test Report Uploaded.",
    });

    try {
      const response = await fetch(
        cfpBaseUrl + "changeOfAttributes/reuploadWiringTestReport",
        {
          method: "POST",
          headers: myHeaders,
          body: raw,
          redirect: "follow",
        }
      );
      const result = await response.json();

      if (result.status === "200" || result.status === 200) {
        setNewWiringTestReportDocument("");
        setNewWiringTestReportDocumentThumbnail("");
        setNewWiringTestReportDocumentError("");
        setWiringTestReportVerifyPopUp(false);
        completeCoaWorkflowStep(
          result.message || "Wiring test report uploaded successfully."
        );
      } else {
        setNewWiringTestReportDocumentError(
          result.message || "Failed to upload document"
        );
        showCoaWorkflowResult(
          result.message || "Failed to upload document.",
          "error"
        );
      }
    } catch (error) {
      setNewWiringTestReportDocumentError("Failed to upload document");
    } finally {
      setViewBackdrop(false);
    }
  };

  const callArrearVerificationAPI = async (
    applicationId,
    applicationProgresId,
    objectionStatuss,
    remarks,
    remarksDetails,
    // billMonth,
    arrearsImg
  ) => {
    setViewBackdrop(true);

    const myHeaders = new Headers();
    myHeaders.append("Authorization", token);
    myHeaders.append("Content-Type", "application/json");

    const raw = JSON.stringify({
      applicationId: applicationId,
      applicationProgressId: applicationProgresId,
      objectionStatus: objectionStatuss,
      remarks: remarks,
      remarksDetail: remarksDetails,
      arrearsAmount: arrearAmount,
      arrearsMonth: billMonth,
      electricityBill: arrearAmount > 0 ? arrearPaidReceiptImageThumbnail : "",
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };
    try {
      const response = await fetch(
        cfpBaseUrl + "changeOfAttributes/processArrearsVerification",
        requestOptions
      );
      const result = await response.json();

      if (result.status === "200") {
        openCoaResponseModal(
          result.message || "Arrears verification completed successfully."
        );
      } else {
        openCoaResponseModal(
          result.message || "Unexpected error occurred.",
          { isError: true }
        );
      }
    } catch (error) {
      openCoaResponseModal("Something went wrong. Please try again.", {
        isError: true,
      });
    } finally {
      setViewBackdrop(false);
      setDocVerifyAlert(false);
      setArrearsVerifyPopUpOpen(false);
      setFieldVerifyAlert(false);
    }
  };

  const callChangeObjectionStatus = async (
    step,
    objectionStatus,
    remarks,
    remarksDetails = "-",
    showResult = true
  ) => {
    var formdata = new FormData();
    formdata.append("applicationId", dialogRowData.applicationId);
    formdata.append("objectionStatus", objectionStatus);
    formdata.append("remarks", remarks);
    formdata.append("remarksDetails", remarksDetails);
    formdata.append("lastModifiedBy", userId);
    const myHeaders = new Headers();
    myHeaders.append("Authorization", token);

    var requestOptions = {
      method: "POST",
      body: formdata,
      headers: myHeaders,
      redirect: "follow",
    };

    await fetch(cfpBaseUrl + "comman/changeObjectionStatus", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.status === "200") {
          if (showResult) {
            completeCoaWorkflowStep(
              result.message || remarks || "Action completed successfully."
            );
          }
        } else if (showResult) {
          showCoaWorkflowResult(
            result.message || "Failed to remove objection.",
            "error"
          );
        }
      })
      .catch(() => { });
    setArrearRejectionRemovalAlert(false);
    setObjectionPopUpOpen(false);
  };

  useEffect(() => {
    if (
      dialogRowData.applicationProgressId === 3 &&
      dialogRowData.objectionStatus === 1
    ) {
      referenceApi(dialogRowData.referenceNumber);
    }
  }, [dialogRowData]);
  const referenceApi = async (referenceNo = dialogRowData.referenceNumber) => {
    setViewBackdrop(true);
    try {
      const searchById = String(referenceNo || "").replace(/\s/g, "");
      if (!searchById) {
        setPaymentStatus("");
        setArrearAmount("");
        setBillMonth("");
        return;
      }

      const apiResponse = await getConsumerDetails(token, searchById);

      if (apiResponse?.status === "200" && apiResponse?.data?.length > 0) {
        const consumerData = apiResponse.data[0];
        const arrear = Number(consumerData.ARREAR || 0);

        if (arrear > 0) {
          setPaymentStatus("Arrear exists");
          setArrearAmount(String(arrear));
          setBillMonth(consumerData.BILL_MONTH || "");
        } else {
          setArrearAmount("");
          setBillMonth("");
          setPaymentStatus("No arrear exists");
        }
      } else {
        setArrearAmount("");
        setBillMonth("");
        setPaymentStatus("No arrear exists");
      }
    } catch (e) {
      setArrearAmount("");
      setBillMonth("");
      setPaymentStatus("");
    } finally {
      setViewBackdrop(false);
    }
  };

  const callAsyncDnDetailsAPI = async (applicationId) => {
    try {
      let dnDets = {};

      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      myHeaders.append("Content-Type", "application/json");

      const raw = JSON.stringify({
        applicationId: applicationId,
      });

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      await fetch(cfpBaseUrl + "changeOfName/getDNData", requestOptions)
        .then((response) => response.json())
        .then((result) => {
          if (result.status === "200") {
            dnDets = result.data[0];
          }
        })
        .catch(() => { });
      return dnDets;
    } catch (e) { /* ignored */ }
  };

  const callSJOCreationAPI = async (applicationId) => {
    if (applicationId) {
      var formdata = new FormData();
      formdata.append("paidDNImageVerifiedBy", userId);
      formdata.append("applicationId", applicationId);
      formdata.append(
        "subDivisionCode",
        dialogRowData.referenceNumber.slice(2, 7)
      );
      formdata.append("changeofAttributeTypeId", "2");
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);

      var requestOptions = {
        method: "POST",
        body: formdata,
        headers: myHeaders,
        redirect: "follow",
      };

      await fetch(cfpBaseUrl + "changeOfName/sjoCreation", requestOptions)
        .then((response) => response.json())
        .then((result) => {
          if (result.status === "200") {
            callArrearVerificationAPI(
              dialogRowData.applicationProgressId + 1,
              "DN Payment Verified",
              "",
              dialogRowData.applicationID
            );
          } else {
          }
        })
        .catch((error) => {
        });
    }
  };

  const callAsyncResetDocsFlags = async (
    applicationId = dialogRowData.applicationId
  ) => {
    var formdata = new FormData();
    formdata.append("applicationNo", applicationId);
    formdata.append("applicantCNICFrontFlag", "");
    formdata.append("applicantCNICBackFlag", "");
    formdata.append("owenershipDocumentFlag", "");
    formdata.append("electricityBillDocumentFlag", "");
    formdata.append("preOwnerCNICFrontFlag", "");
    formdata.append("preOwnerCNICBackFlag", "");
    formdata.append("perOwenerNOCFlag", "");
    formdata.append("newOwenerAffidaviteFlag", "");
    formdata.append("addDocCivicAuthorityFlag", "");
    formdata.append("anyOtherDocumentFlag", "");
    const myHeaders = new Headers();
    myHeaders.append("Authorization", token);

    var requestOptions = {
      method: "POST",
      body: formdata,
      headers: myHeaders,
      redirect: "follow",
    };

    await fetch(
      cfpBaseUrl + "changeOfName/updateCONDocumentFlag",
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (result.status === "200") {
          let allApplications = changeOfNameApplications;
          let index = changeOfNameApplications.findIndex(
            (item) => item.applicationId === applicationId
          );
          allApplications[index].applicantCNICFrontFlag = null;
          allApplications[index].applicantCNICBackFlag = null;
          allApplications[index].owenershipDocumentFlag = null;
          allApplications[index].electricityBillDocumentFlag = null;
          allApplications[index].preOwnerCNICFrontFlag = null;
          allApplications[index].preOwnerCNICBackFlag = null;
          allApplications[index].perOwenerNOCFlag = null;
          allApplications[index].newOwenerAffidaviteFlag = null;
          allApplications[index].addDocCivicAuthorityFlag = null;
          allApplications[index].anyOtherDocumentFlag = null;
          window.localStorage.setItem(
            "change-of-name-applications",
            JSON.stringify(allApplications)
          );
        } else {
        }
      })
      .catch(() => { });
  };

  const callAsyncGetConsentImage = async (
    applicationId = dialogRowData.applicationId
  ) => {
    try {
      var formdata = new FormData();
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      formdata.append("applicationId", applicationId);

      var requestOptions = {
        method: "POST",
        body: formdata,
        headers: myHeaders,
        redirect: "follow",
      };

      await fetch(
        cfpBaseUrl + "changeOfName/getConsentFormForChangeOfName",
        requestOptions
      )
        .then((response) => response.json())
        .then((result) => {
          if (result.status === "200") {
            setConsentImageDetails(result.data[0]);
          }
        })
        .catch(() => { });
    } catch (e) { /* ignored */ }
  };

  const callBillingToGetPreviousSecurity = async (
    referenceNo = dialogRowData.referenceNumber
  ) => {
    try {
      let apiResponse = await dBillAPI(token, referenceNo);
      if (apiResponse.status) {
        let basicInfo = apiResponse.basicInfo;
        let previousSecurity = basicInfo.sec_amnt;
        let sanctionedLoad = basicInfo.sactionLoad ? basicInfo.sactionLoad : 3;
        let connectionCatagoryType = basicInfo.cons_cat;
        if (
          connectionCatagoryType === "DOMESTIC" ||
          connectionCatagoryType === "DOMMESTIC"
        ) {
          setConnectionCategoryType(1);
        } else if (connectionCatagoryType === "COMMERCIAL") {
          setConnectionCategoryType(2);
        } else if (connectionCatagoryType === "INDUSTRIAL") {
          setConnectionCategoryType(3);
        }
        setPreviousSecurity(previousSecurity);
        setSanctionedLoad(sanctionedLoad);
      } else {
        setError("Reference No. not found!");
      }
    } catch (e) { /* ignored */ }
  };

  const callAsyncCreateDnForChangeOfName = async (
    applicationId = dialogRowData.applicationId
  ) => {
    try {
      var formdata = new FormData();

      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      formdata.append("applicationId", applicationId);
      formdata.append(
        "previousSecurity",
        previousSecurity ? previousSecurity : 0
      );
      formdata.append("sanctionLoad", sanctionedLoad ? sanctionedLoad : 1);
      formdata.append(
        "connectionCatagoryType",
        connectionCategoryType ? connectionCategoryType : 1
      );
      formdata.append(
        "roOfficeAddress",
        divisionName(
          parseInt(dialogRowData.referenceNumber.slice(2, 6)),
          subDivisions
        )
      );
      formdata.append(
        "consumerAccountNo",
        dialogRowData.referenceNumber.slice(5)
      );
      formdata.append("batchNo", dialogRowData.referenceNumber.slice(0, 2));
      formdata.append("tariff", "Old Tariff");
      formdata.append("bankName", bankName);
      formdata.append("connectionAccountNo", dialogRowData.referenceNumber);
      formdata.append("filledBy", userId);

      var requestOptions = {
        method: "POST",
        body: formdata,
        headers: myHeaders,
        redirect: "follow",
      };

      await fetch(
        cfpBaseUrl + "/changeOfName/createDNforChangeOfName",
        requestOptions
      )
        .then((response) => response.json())
        .then((result) => {
          if (result.status === "200") {
            callArrearVerificationAPI(
              dialogRowData.applicationProgressId + 2,
              "Demand Note Issued",
              "-",
              dialogRowData.applicationId
            );
          }
        })
        .catch(() => { });
    } catch (e) { /* ignored */ }
  };

  const callSJOApproveAPI = async (applicationId) => {
    var formdata = new FormData();
    formdata.append("applicationId", applicationId);
    formdata.append("approvedBy", userId);
    formdata.append("approvedFlag", 1);
    const myHeaders = new Headers();
    myHeaders.append("Authorization", token);

    var requestOptions = {
      method: "POST",
      body: formdata,
      headers: myHeaders,
      redirect: "follow",
    };

    await fetch(cfpBaseUrl + "changeOfName/sjoApproval", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.status === "200") {
          callArrearVerificationAPI(
            dialogRowData.applicationProgressId + 1,
            "Service Connection Order Approved",
            "Service Connection Order Approved"
          );
        } else {
        }
      })
      .catch(() => { });
  };

  const callAsyncGetPaidDnImageAPI = async (applicationId) => {
    try {
      let dnImage = "";
      var formdata = new FormData();

      formdata.append("applicationNo", applicationId);
      formdata.append("demandNoticeNo", "");

      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);

      var requestOptions = {
        method: "POST",
        body: formdata,
        headers: myHeaders,
        redirect: "follow",
      };

      await fetch(cfpBaseUrl + "demandNotice/getPaidDNImage", requestOptions)
        .then((response) => response.json())
        .then((result) => {
          if (result.status === "200") {
            setPaidDnImageDetails(result.data[0]);
            setDnImage(result.data[0].paidDNImage);
            dnImage = result.data[0].paidDNImage;
          }
        })
        .catch(() => { });
      return dnImage;
    } catch (e) { /* ignored */ }
  };

  //#endregion

  const tblColumns = [
    {
      field: "applicationId",
      type: "text",
      headerName: "Application No.",
      align: "center",
      sortable: false,
      filterable: false,
      headerStyle: tableStyle.headerStyle,
      headerCellStyle: tableStyle.headerCellStyle,
      rowCellStyle: tableStyle.rowCellStyle,
    },
    {
      field: "creationDate",
      type: "date",
      headerName: "Submission Date",
      align: "center",
      sortable: false,
      filterable: true,
      headerStyle: tableStyle.headerStyle,
      headerCellStyle: tableStyle.headerCellStyle,
      rowCellStyle: tableStyle.rowCellStyle,
    },
    {
      field: "applicantName",
      type: "text",
      headerName: "Applicant Name",
      align: "center",
      sortable: false,
      filterable: false,
      headerStyle: tableStyle.headerStyle,
      headerCellStyle: tableStyle.headerCellStyle,
      rowCellStyle: tableStyle.rowCellStyle,
    },
    {
      field: "referenceno",
      type: "text",
      headerName: "Reference No.",
      align: "center",
      sortable: false,
      filterable: false,
      headerStyle: tableStyle.headerStyle,
      headerCellStyle: tableStyle.headerCellStyle,
      rowCellStyle: tableStyle.rowCellStyle,
    },
    // {
    //   field: "applicationStatusId",
    //   headerStyle: tableStyle.headerStyle,
    //   headerCellStyle: tableStyle.headerCellStyle,
    //   rowCellStyle: tableStyle.rowCellStyle,
    //   headerName: "Status",
    //   align: "center",
    //   sortable: false,
    //   filterable: true,
    //   type: "singleSelect",
    //   valueOptions: [
    //     "Pending",
    //     "In Process",
    //     "Approved",
    //     "Completed",
    //     "Objection",
    //   ],
    //   renderCell: (params) => {
    //     let btnText = params.applicationStatusId;
    //     return <div className={getClassName(btnText)}>{btnText}</div>;
    //   },
    // },
    // {
    //   field: "description",
    //   type: "dateTime",
    //   headerName: "Description",
    //   align: "center",
    //   sortable: false,
    //   filterable: false,
    //   headerStyle: tableStyle.headerStyle,
    //   headerCellStyle: tableStyle.headerCellStyle,
    //   rowCellStyle: tableStyle.rowCellStyle,
    // },
    {
      field: "applicationStep",
      type: "singleSelect",
      sortable: false,
      filterable: true,
      valueOptions: [
        "Documents Uploading",
        "Documents Verification",
        "Wiring Test Report",
        "Arrear Verification",
        "Field Survey",
        "DN Approval",
        "DN Submission",
        "DN Payment Verification",
        "Sundary Jobs Order",
        "Ready for Billing",
        "Completed",
      ],
      headerName: "Description",
      align: "left",
      headerStyle: tableStyle.headerStyle,
      headerCellStyle: tableStyle.headerCellStyle,
      rowCellStyle: { ...tableStyle.rowCellStyle, fontSize: "12px" },
    },
    {
      headerName: "Docs.",
      disableColumnMenu: true,
      sortable: false,
      filterable: false,
      flex: 1,
      filterable: false,
      headerStyle: tableStyle.headerStyle,
      headerCellStyle: tableStyle.headerCellStyle,
      rowCellStyle: {
        ...tableStyle.rowCellStyle,
        fontSize: "15px",
        overflow: "visible",
      },
      field: "downloads",
      align: "center",
      headerAlign: "center",
      renderCell: (params) => {
        return (
          <ActionsCell data={params} serviceKind="coa" />
        );
      },
    },
  ];

  const tblColumnsOverDue = [
    {
      field: "applicationId",
      type: "text",
      headerName: "Application No.",
      align: "center",
      sortable: false,
      filterable: false,
      headerStyle: tableStyleOverDue.headerStyle,
      headerCellStyle: tableStyleOverDue.headerCellStyle,
      rowCellStyle: tableStyleOverDue.rowCellStyle,
    },
    {
      field: "creationDate",
      type: "date",
      headerName: "Submission Date",
      align: "center",
      sortable: false,
      filterable: true,
      headerStyle: tableStyleOverDue.headerStyle,
      headerCellStyle: tableStyleOverDue.headerCellStyle,
      rowCellStyle: tableStyleOverDue.rowCellStyle,
    },
    {
      field: "applicantName",
      type: "text",
      headerName: "Applicant Name",
      align: "center",
      sortable: false,
      filterable: false,
      headerStyle: tableStyleOverDue.headerStyle,
      headerCellStyle: tableStyleOverDue.headerCellStyle,
      rowCellStyle: tableStyleOverDue.rowCellStyle,
    },
    {
      field: "referenceno",
      type: "text",
      headerName: "Reference No.",
      align: "center",
      sortable: false,
      filterable: false,
      headerStyle: tableStyleOverDue.headerStyle,
      headerCellStyle: tableStyleOverDue.headerCellStyle,
      rowCellStyle: tableStyleOverDue.rowCellStyle,
    },
    // {
    //   field: "applicationStatusId",
    //   headerStyle: tableStyleOverDue.headerStyle,
    //   headerCellStyle: tableStyleOverDue.headerCellStyle,
    //   rowCellStyle: tableStyleOverDue.rowCellStyle,
    //   headerName: "Status",
    //   align: "center",
    //   sortable: false,
    //   filterable: true,
    //   type: "singleSelect",
    //   valueOptions: [
    //     "Pending",
    //     "In Process",
    //     "Approved",
    //     "Completed",
    //     "Objection",
    //   ],
    //   renderCell: (params) => {
    //     let btnText = params.applicationStatusId;
    //     return <div className={getClassName(btnText)}>{btnText}</div>;
    //   },
    // },
    // {
    //   field: "description",
    //   type: "dateTime",
    //   headerName: "Description",
    //   align: "center",
    //   sortable: false,
    //   filterable: false,
    //   headerStyle: tableStyleOverDue.headerStyle,
    //   headerCellStyle: tableStyleOverDue.headerCellStyle,
    //   rowCellStyle: tableStyleOverDue.rowCellStyle,
    // },
    {
      field: "applicationStep",
      type: "singleSelect",
      sortable: false,
      filterable: true,
      align: "center",
      valueOptions: [
        "Documents Uploading",
        "Documents Verification",
        "Wiring Test Report",
        "Arrear Verification",
        "Field Survey",
        "DN Approval",
        "DN Submission",
        "DN Payment Verification",
        "Sundary Jobs Order",
        "Ready for Billing",
        "Completed",
      ],
      headerName: "Description",
      align: "left",
      headerStyle: tableStyleOverDue.headerStyle,
      headerCellStyle: tableStyleOverDue.headerCellStyle,
      rowCellStyle: { ...tableStyleOverDue.rowCellStyle, fontSize: "12px" },
    },
    {
      field: "exceededDuration",
      type: "text",
      sortable: false,
      filterable: false,
      headerName: "Days",
      align: "center",
      headerStyle: tableStyleOverDue.headerStyle,
      headerCellStyle: tableStyleOverDue.headerCellStyle,
      rowCellStyle: {
        ...tableStyleOverDue.rowCellStyle,
        color: "red",
        minWidth: "20px",
      },
    },
    {
      headerName: "Docs.",
      disableColumnMenu: true,
      sortable: false,
      filterable: false,
      flex: 1,
      filterable: false,
      headerStyle: tableStyleOverDue.headerStyle,
      headerCellStyle: tableStyleOverDue.headerCellStyle,
      rowCellStyle: {
        ...tableStyleOverDue.rowCellStyle,
        fontSize: "15px",
        overflow: "visible",
      },
      field: "downloads",
      align: "center",
      headerAlign: "center",
      renderCell: (params) => {
        return <ActionsCell data={params} serviceKind="coa" theme="overdue" />;
      },
    },
  ];

  useImperativeHandle(ref, () => ({
    handleRowClick,
    downloadEFileFromSearch: async (applicationId) => {
      if (!applicationId) return;
      try {
        const application = await filterCONApp(applicationId);
        if (!application?.applicationId) return;
        await downloadEFile(application);
      } finally {
        setViewBackdrop(false);
      }
    },
  }));
  const location = useLocation();
  const currentPath = location.pathname;
  useEffect(() => {
    if (dialogRowData && dialogRowData.applicationId) {
      // callMaterials(dialogRowData.applicationId);
    }
  }, [dialogRowData]);
  const callMaterials = async (applicationId) => {
    try {
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      myHeaders.append("Content-Type", "application/json");

      const raw = JSON.stringify({
        // subDivisionCode: dialogRowData.applicationId.slice(3, 8)
        // subDivisionCode: '15175'
        subDivisionCode: applicationId.slice(3, 8),
      });

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const response = await fetch(
        "https://eopsapi.pitc.com.pk/enc/getMaterialDetails",
        requestOptions
      );
      const result = await response.json();
      setAllMaterialList(result.data);

      return result.data;
    } catch (e) {
      return [];
    }
  };
  const calculateCharges = (arrayOfItems, isNC13 = false) =>
    calculateBoqCharges(arrayOfItems, isNC13);

  const onPressAddPrepare = useCallback(() => {
    const isNC13 = dialogRowData?.applicationId?.slice(3, 5) === "13";
    let itemsToCalculate = itemsArray;

    if (
      itemsArray.length === 0 &&
      boqItems?.length > 0 &&
      allMaterialList?.length > 0
    ) {
      const restoredItems = boqItems.map((row) => {
        const material = allMaterialList.find(
          (m) =>
            String(m.item_Code || m.Item_Code)
              .trim()
              .toLowerCase() === String(row.itemCode).trim().toLowerCase()
        );
        const qty = Number(row.qty) || 0;
        const rate = material
          ? Number(material.item_Amount || material.Item_Amount) || 0
          : qty > 0
            ? Number(row.itemAmount) / qty
            : 0;
        const amount =
          Number(row.itemAmount) || Math.round(qty * rate);

        return {
          item_Code: row.itemCode,
          item_Name: material?.item_Name || material?.Item_Name || row.itemCode,
          unit: material?.item_Unit || material?.Item_Unit || "",
          rate,
          qty,
          amount,
        };
      });

      itemsToCalculate = restoredItems;
      setItemsArray(restoredItems);
    }

    if (itemsToCalculate.length > 0) {
      const { totalAmountofItems, store_charges, installation_charges } =
        calculateCharges(itemsToCalculate, isNC13);

      setItemsAmount(totalAmountofItems);
      setStoreCharges(store_charges);
      setInstallationCharges(installation_charges);
      setTotalCharges(
        totalAmountofItems + store_charges + installation_charges
      );
    }

    setShowBoq(true);
  }, [allMaterialList, boqItems, itemsArray, dialogRowData?.applicationId]);
  const onSaveCostEstimationConfirm = () => {
    setErrormessageBoqEstimation("");
    setShowBoq(false);
    const BoQItems = itemsArray.map((item) => ({
      qty: String(item.qty),
      itemCode: String(item.item_Code),
      itemAmount: String(item.amount),
    }));
    setBoqItems(BoQItems);
    // }
  };
  const onPressCostEstimationConfirm = () => {
    if (fieldFormik.values.iv_objection_Type == "1") {
      setViewBackdrop(true);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      myHeaders.append("Content-Type", "application/json");

      const raw = JSON.stringify({
        applicationId: dialogRowData.applicationId,
        applicationProgressId: dialogRowData.applicationProgressId + 1,
        objectionStatus: 0,
        remarks: "Field surveyed and Cost estimated.",
        remarksDetail: "Field surveyed and Cost estimated.",
        sketchDiagram: sketchDiagramThumbnail ? sketchDiagramThumbnail : "",
        observationType: fieldFormik.values.iv_objection_Type
          ? fieldFormik.values.iv_objection_Type
          : "",
        alreadyInstalledRefNo: "",
        isMaterialRequired: fieldFormik.values.iv_material_required,
        isMeterNeedsToBeReplaced: fieldFormik.values.iv_meter_to_replace,
        submittedThrough: "e-Operation",
        areaType: fieldFormik.values.iv_area_type
          ? fieldFormik.values.iv_area_type
          : "",
        tariff:
          dialogRowData.changeOfAttributesType == 3 ||
            dialogRowData.changeOfAttributesType == 4 ||
            dialogRowData.changeOfAttributesType == 6 ||
            dialogRowData.changeOfAttributesType == 7
            ? dialogRowData.newTariff?.replace(/-/g, "")
            : dialogRowData.currentTariff?.replace(/-/g, ""),
        sanctionLoad:
          dialogRowData.changeOfAttributesType == 2 ||
            dialogRowData.changeOfAttributesType == 4 ||
            dialogRowData.changeOfAttributesType == 5 ||
            dialogRowData.changeOfAttributesType == 7
            ? dialogRowData.newSanctionLoad
            : dialogRowData.currentSanctionLoad,
        bankName: bankName,
        isBatchChangeRequired: fieldFormik.values.iv_batch_change,
        batchNo: fieldFormik.values.iv_batch ? fieldFormik.values.iv_batch : "",
        subBatchNo: fieldFormik.values.iv_sub_batch
          ? fieldFormik.values.iv_sub_batch
          : "",
        connectionAccountNo:
          fieldFormik.values.iv_batch_change === false
            ? dialogRowData.referenceNumber
            : fieldFormik.values.iv_batch +
            partialValue +
            fieldFormik.values.iv_reference_to_allot,
        amountOfGridSharing: gridSharingCost ? gridSharingCost : 0,
        amountOfFeederRehab: feederRehabilitationCharges
          ? feederRehabilitationCharges
          : 0,
        civilWorkCharges: civilWorkCharges ? civilWorkCharges : 0,
        fixedChargesOfMetering: fixedChargesOfMetering
          ? fixedChargesOfMetering
          : 0,
        miscellaneousCharges: miscellaneousCharges ? miscellaneousCharges : 0,
        lessTheCost: lessTheCost ? lessTheCost : 0,
        mtCharges: mntCharges ? mntCharges : 0,
        labourCharges: labourCharges ? labourCharges : 0,
        designVetteingFee: designVettingFee ? designVettingFee : 0,
        consultancyCharges: consultancyCharges ? consultancyCharges : 0,
        variationsCharges: variationCharges ? variationCharges : 0,
        dismentalmentCharges: dismantlementCharges ? dismantlementCharges : 0,
        earthingCharges: earthingCharges ? earthingCharges : 0,
        capitalCostAmount:
          boqItems && boqItems.length > 0
            ? (itemsAmount || 0) +
            (dialogRowData?.applicationId?.slice(3, 5) === "13" ? 0 : (storeCharges || 0)) +
            (installationCharges || 0) +
            (civilWorkCharges || 0) +
            (fixedChargesOfMetering || 0) +
            (gridSharingCost || 0) +
            (feederRehabilitationCharges || 0) +
            (miscellaneousCharges || 0) +
            (mntCharges || 0) +
            (labourCharges || 0) +
            (designVettingFee || 0) +
            (consultancyCharges || 0) +
            (variationCharges || 0) +
            (dismantlementCharges || 0) +
            (earthingCharges || 0) -
            (lessTheCost || 0)
            : (costEstimationForNC?.estimatedCapitalCost) + (gridSharingCost || 0) + (feederRehabilitationCharges || 0) || 0,
        securityDepositAmount: (costEstimationForNC?.estimatedSecurityAmount)
          ? Math.max(
            (Number(costEstimationForNC?.estimatedSecurityAmount) || 0) -
            (Number(costEstimationForNC?.currentSecurityAmount) || 0),
            0
          )
          : 0,
        estimatedSecurityAmount: costEstimationForNC?.estimatedSecurityAmount
          ? costEstimationForNC?.estimatedSecurityAmount
          : 0,
        meterType: fieldFormik.values.iv_meter_type,
        BoQItems: boqItems ? boqItems : [],
        seasonalFlag: fieldFormik.values.iv_seasonal,
      });

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      fetch(
        cfpBaseUrl + "changeOfAttributes/saveFieldSurveyAndCostEstimateForCOA",
        requestOptions
      )
        .then((response) => response.json())
        .then((result) => {
          setViewBackdrop(false);
          setShowCostEstimation(false);
          if (result.status === "200") {
            completeCoaWorkflowStep(
              result.message || "Field survey submitted successfully."
            );
          } else {
            completeCoaWorkflowStep(
              result.message || "Failed to submit field survey.",
              "error"
            );
          }
        })
        .catch(() => { });
    } else {
    }
  };
  const deleteItem = (code) => {
    const itemsInArray = itemsArray.filter(
      (item) => String(item.item_Code ?? item.Id) !== String(code)
    );

    if (itemsInArray.length === itemsArray.length) return;

    const isNC13 = dialogRowData?.applicationId?.slice(3, 5) === "13";
    const { totalAmountofItems, store_charges, installation_charges } =
      calculateCharges(itemsInArray, isNC13);

    const total_charges =
      totalAmountofItems + store_charges + installation_charges;

    fieldItemFormik.setFieldValue("iv_items_array", itemsInArray);
    setItemsAmount(totalAmountofItems);
    setStoreCharges(store_charges);
    setInstallationCharges(installation_charges);
    setTotalCharges(total_charges);
    setItemsArray(itemsInArray);
  };

  const updateItemQtyByDelta = (code, delta) => {
    if (dnDetails && dnDetails.filledFlag === 1) return;

    const index = itemsArray.findIndex(
      (item) => String(item.item_Code ?? item.Id) === String(code)
    );
    if (index === -1) return;

    const currentQty = parseInt(itemsArray[index].qty, 10) || 0;
    const nextQty = Math.max(1, currentQty + delta);
    const itemsInArray = itemsArray.map((item, i) =>
      i === index
        ? {
          ...item,
          qty: nextQty,
          amount: Math.round(nextQty * parseFloat(item.rate || 0)),
        }
        : item
    );

    const isNC13 = dialogRowData?.applicationId?.slice(3, 5) === "13";
    const { totalAmountofItems, store_charges, installation_charges } =
      calculateCharges(itemsInArray, isNC13);
    const total_charges =
      totalAmountofItems + store_charges + installation_charges;

    fieldItemFormik.setFieldValue("iv_items_array", itemsInArray);
    setItemsAmount(totalAmountofItems);
    setStoreCharges(store_charges);
    setInstallationCharges(installation_charges);
    setTotalCharges(total_charges);
    setItemsArray(itemsInArray);
  };
  const fieldItemFormik = useFormik({
    initialValues: {
      iv_fieldItemId: "",
      iv_fieldItemQty: "",
      iv_fieldItemRate: "",
      iv_fieldItemUnit: "",
      iv_fieldItemAmount: "",
      iv_items_array: itemsArray,
    },
    validationSchema: Yup.object().shape({
      iv_fieldItemId: Yup.mixed().required("Select the item from list."),
      iv_fieldItemQty: Yup.number()
        .typeError("Enter qty.")
        .integer("Fractional qty not allowed.")
        .moreThan(0, "Qty must be greater than 0.")
        .required("Enter qty."),
      iv_fieldItemRate: Yup.string().optional(),
      iv_fieldItemUnit: Yup.string().optional(),
      iv_fieldItemAmount: Yup.string().optional(),
    }),
    // onSubmit: (values, { resetForm }) => {
    //   let itemToBeAdded = {};
    //   let arrayOfItems = [...itemsArray];
    //   itemToBeAdded.Id = values.iv_fieldItemId;

    //   let alreadyPresent = arrayOfItems.find(item => item.Id === itemToBeAdded.Id);

    //   if (alreadyPresent) {
    //     const index = arrayOfItems.findIndex(item => item.Id === itemToBeAdded.Id);
    //     arrayOfItems[index].qty = (parseInt(arrayOfItems[index].qty) + parseInt(values.iv_fieldItemQty)).toString();
    //     arrayOfItems[index].amount = parseInt(arrayOfItems[index].qty) * parseInt(arrayOfItems[index].rate);
    //   } else {
    //     let it = allMaterialList.find(item => item.Id === itemToBeAdded.Id);
    //     if (it) {
    //       itemToBeAdded.name = it.ItemName;
    //       itemToBeAdded.Id = it.Id;
    //       itemToBeAdded.itemCode = it.ItemCode;
    //     }
    //     itemToBeAdded.qty = values.iv_fieldItemQty;
    //     itemToBeAdded.rate = values.iv_fieldItemRate;
    //     itemToBeAdded.unit = values.iv_fieldItemUnit;
    //     itemToBeAdded.amount = parseInt(values.iv_fieldItemQty) * parseInt(values.iv_fieldItemRate);
    //     arrayOfItems.push(itemToBeAdded);
    //   }

    //   const { totalAmountofItems, store_charges, installation_charges } = calculateCharges(arrayOfItems);

    //   const total_charges = totalAmountofItems + store_charges + installation_charges

    //   setItemsAmount(totalAmountofItems);
    //   setStoreCharges(store_charges);
    //   setInstallationCharges(installation_charges);
    //   setTotalCharges(total_charges);
    //   setItemsArray(arrayOfItems);
    //   resetForm();
    // }
    onSubmit: (values, { resetForm }) => {
      let itemToBeAdded = {};
      let arrayOfItems = [...itemsArray];

      const qty = parseInt(values.iv_fieldItemQty, 10);
      const rate = parseFloat(values.iv_fieldItemRate);

      if (isNaN(qty) || qty <= 0) {
        return;
      }
      if (isNaN(rate) || rate < 0) {
        return;
      }

      itemToBeAdded.item_Code = values.iv_fieldItemId;

      let alreadyPresent = arrayOfItems.find(
        (item) => item.item_Code === itemToBeAdded.item_Code
      );

      if (alreadyPresent) {
        const index = arrayOfItems.findIndex(
          (item) => item.item_Code === itemToBeAdded.item_Code
        );
        const nextQty = parseInt(arrayOfItems[index].qty, 10) + qty;
        arrayOfItems = arrayOfItems.map((item, i) =>
          i === index
            ? {
              ...item,
              qty: nextQty,
              amount: Math.round(nextQty * parseFloat(item.rate)),
            }
            : item
        );
      } else {
        let it = allMaterialList.find(
          (item) => item.item_Code === itemToBeAdded.item_Code
        );
        if (it) {
          itemToBeAdded.item_Code = it.item_Code;
          itemToBeAdded.Id = it.item_Code;
          itemToBeAdded.item_Name = it.item_Name;
          itemToBeAdded.unit = it.item_Unit;
          itemToBeAdded.rate = it.item_Amount;
        } else {
          return;
        }
        itemToBeAdded.qty = qty;
        itemToBeAdded.amount = Math.round(qty * itemToBeAdded.rate);
        arrayOfItems = [...arrayOfItems, itemToBeAdded];
      }

      const isNC13 = dialogRowData?.applicationId?.slice(3, 5) === "13";
      const { totalAmountofItems, store_charges, installation_charges } =
        calculateCharges(arrayOfItems, isNC13);

      const total_charges =
        totalAmountofItems + store_charges + installation_charges;

      setItemsAmount(totalAmountofItems);
      setStoreCharges(store_charges);
      setInstallationCharges(installation_charges);
      setTotalCharges(total_charges);
      setItemsArray(arrayOfItems);

      resetForm();
    },
  });

  const sanitizeWholeNumberInput = (value) =>
    String(value ?? "")
      .replace(/,/g, "")
      .replace(/[^\d]/g, "");

  const formatWholeNumberInput = (value) => {
    const sanitized = sanitizeWholeNumberInput(value);
    if (!sanitized) {
      return "";
    }

    return Number(sanitized).toLocaleString("en-US");
  };

  const handleWholeNumberFieldChange = (fieldName, setter) => (event) => {
    const sanitized = sanitizeWholeNumberInput(event.target.value);
    fieldFormik.setFieldValue(fieldName, sanitized);
    setter(sanitized === "" ? 0 : Number(sanitized));
  };
  useEffect(() => {
    if (fieldItemFormik.values.iv_fieldItemId) {

      let item = allMaterialList.find(
        (item) => item.item_Code === fieldItemFormik.values.iv_fieldItemId
      );

      fieldItemFormik.values.iv_fieldItemRate = item.item_Amount;
      fieldItemFormik.values.iv_fieldItemUnit = item.item_Unit;
    }
  }, [fieldItemFormik.values.iv_fieldItemId]);

  useEffect(() => {
    let totalCost = totalCharges;

    const totalChargesValue = isNaN(parseInt(totalCharges))
      ? 0
      : parseInt(totalCharges);
    const gridSharingCostValue = isNaN(parseInt(gridSharingCost))
      ? 0
      : parseInt(gridSharingCost);
    const feederRehabilitationChargesValue = isNaN(
      parseInt(feederRehabilitationCharges)
    )
      ? 0
      : parseInt(feederRehabilitationCharges);
    const civilWorkChargesValue = isNaN(parseInt(civilWorkCharges))
      ? 0
      : parseInt(civilWorkCharges);
    const fixedChargesOfMeteringValue = isNaN(parseInt(fixedChargesOfMetering))
      ? 0
      : parseInt(fixedChargesOfMetering);
    const miscellaneousChargesValue = isNaN(parseInt(miscellaneousCharges))
      ? 0
      : parseInt(miscellaneousCharges);
    const lessTheCostValue = isNaN(parseInt(lessTheCost))
      ? 0
      : parseInt(lessTheCost);
    const mntChargesValue = isNaN(parseInt(mntCharges))
      ? 0
      : parseInt(mntCharges);
    const labourChargesValue = isNaN(parseInt(labourCharges))
      ? 0
      : parseInt(labourCharges);
    const designVettingFeeValue = isNaN(parseInt(designVettingFee))
      ? 0
      : parseInt(designVettingFee);
    const consultancyChargesValue = isNaN(parseInt(consultancyCharges))
      ? 0
      : parseInt(consultancyCharges);
    const variationChargesValue = isNaN(parseInt(variationCharges))
      ? 0
      : parseInt(variationCharges);
    const dismantlementChargesValue = isNaN(parseInt(dismantlementCharges))
      ? 0
      : parseInt(dismantlementCharges);
    const earthingChargesValue = isNaN(parseInt(earthingCharges))
      ? 0
      : parseInt(earthingCharges);

    totalCost =
      totalChargesValue +
      gridSharingCostValue +
      feederRehabilitationChargesValue +
      civilWorkChargesValue +
      fixedChargesOfMeteringValue +
      miscellaneousChargesValue +
      mntChargesValue +
      labourChargesValue +
      designVettingFeeValue +
      consultancyChargesValue +
      variationChargesValue +
      dismantlementChargesValue +
      earthingChargesValue -
      lessTheCostValue;

    setGrandTotalCharges(totalCost);
  }, [
    civilWorkCharges,
    fixedChargesOfMetering,
    miscellaneousCharges,
    lessTheCost,
    totalCharges,
    gridSharingCost,
    feederRehabilitationCharges,
    mntCharges,
    labourCharges,
    designVettingFee,
    consultancyCharges,
    variationCharges,
    dismantlementCharges,
    earthingCharges,
  ]);
  useEffect(() => {
    if (!boqItems || boqItems.length === 0) {
      fieldFormik.setFieldValue("iv_grid_sharing_cost", 0);
      setGridSharingCost(0);

      fieldFormik.setFieldValue("iv_feeder_rehab_charges", 0);
      setFeederRehabilitationCharges(0);
      fieldFormik.setFieldValue("iv_civil_work_charges", 0);
      setCivilWorkCharges(0);
      fieldFormik.setFieldValue("iv_miscellaneous_charges", 0);
      setMiscellaneousCharges(0);
      fieldFormik.setFieldValue("iv_fixed_charges_of_metering", 0);
      setFixedChargesOfMetering(0);
      fieldFormik.setFieldValue("iv_less_the_cost", 0);
      setLessTheCost(0);
      // Reset new charge fields
      fieldFormik.setFieldValue("iv_mnt_charges", 0);
      setMntCharges(0);
      fieldFormik.setFieldValue("iv_labour_charges", 0);
      setLabourCharges(0);
      fieldFormik.setFieldValue("iv_design_vetting_fee", 0);
      setDesignVettingFee(0);
      fieldFormik.setFieldValue("iv_consultancy_charges", 0);
      setConsultancyCharges(0);
      fieldFormik.setFieldValue("iv_variation_charges", 0);
      setVariationCharges(0);
      fieldFormik.setFieldValue("iv_dismantlement_charges", 0);
      setDismantlementCharges(0);
      fieldFormik.setFieldValue("iv_earthing_charges", 0);
      setEarthingCharges(0);
    }
  }, [boqItems]);

  useEffect(() => {
    if (dialogRowData && dialogRowData.areaType) {
      const areaType = dialogRowData.areaType.toLowerCase();

      if (areaType === "u") {
        fieldFormik.setFieldValue("iv_area_type", "U");
      } else if (areaType === "r") {
        fieldFormik.setFieldValue("iv_area_type", "R");
      }
    }
  }, [dialogRowData]);

  const handleCostEstimationClose = () => {
    setShowCostEstimation(false);
    setErrormessageCostEstimation("");
  };

  useEffect(() => {
    if (dialogRowData.objectionStatus !== 1) {
      fieldFormik.setFieldValue("iv_objection_Type", 1);
    }
  }, [dialogRowData]);

  const getTableRows = (data) => {
    const type = data.changeOfAttributesType;

    const rows = [];

    // Owner Change: Types 1,4,5,6
    if ([1, 5, 6].includes(type)) {
      rows.push({
        label: "Name",
        current: data.currentOwnerName,
        newVal: `${data.applicantName || ""} ${data.applicantGuardianType == 1
          ? "S/O"
          : data.applicantGuardianType == 2
            ? "D/O"
            : data.applicantGuardianType == 3
              ? "W/O"
              : data.applicantGuardianType == 4
                ? "C/O"
                : ""
          } ${data.applicantGuardianName || ""}`.trim(),
      });
      rows.push({
        label: "CNIC",
        current: data.currentOwnerCNIC,
        newVal: data.applicantCNIC,
      });
      rows.push({
        label: "Phone No.",
        current: data.currentOwnerPhoneNo,
        newVal: data.applicantPhoneNo,
      });
      rows.push({
        label: "Email",
        current: data.currentOwnerEmail,
        newVal: data.applicantEmail,
      });
    }

    if ([4].includes(type)) {
      rows.push({
        label: "Name",
        current: data.currentOwnerName,
        newVal: `${data.applicantName || ""} ${data.applicantGuardianType == 1
          ? "S/O"
          : data.applicantGuardianType == 2
            ? "D/O"
            : data.applicantGuardianType == 3
              ? "W/O"
              : data.applicantGuardianType == 4
                ? "C/O"
                : ""
          } ${data.applicantGuardianName || ""}`.trim(),
      });
      rows.push({
        label: "CNIC",
        current: data.currentOwnerCNIC,
        newVal: data.applicantCNIC,
      });
      rows.push({
        label: "Phone No.",
        current: data.currentOwnerPhoneNo,
        newVal: data.applicantPhoneNo,
      });
      rows.push({
        label: "Email",
        current: data.currentOwnerEmail,
        newVal: data.applicantEmail,
      });
      rows.push({
        label: "Tariff",
        current: data.currentTariff,
        newVal: data.newTariff,
      });
      rows.push({
        label: "Load",
        current: data.currentSanctionLoad,
        newVal: data.newSanctionLoad,
      });
    }
    if ([3, 6, 7].includes(type)) {
      rows.push({
        label: "Tariff",
        current: data.currentTariff,
        newVal: data.newTariff,
      });
    }
    if ([5].includes(type)) {
      rows.push({
        label: "Load",
        current: data.currentSanctionLoad,
        newVal: data.newSanctionLoad,
      });
    }
    if ([2, 7].includes(type)) {
      rows.push({
        label: "Load",
        current: data.currentSanctionLoad,
        newVal: data.newSanctionLoad,
      });
    }

    return rows;
  };

  const formatCoaApplicantDisplayName = (row, useApplicantFields = false) => {
    if (!row) return "";

    if (!useApplicantFields) {
      const currentName = row.currentOwnerName;
      if (currentName && String(currentName).trim()) {
        return String(currentName).trim();
      }
    }

    const guardianLabel =
      row.applicantGuardianType == 1
        ? "S/O"
        : row.applicantGuardianType == 2
          ? "D/O"
          : row.applicantGuardianType == 3
            ? "W/O"
            : row.applicantGuardianType == 4
              ? "C/O"
              : "";

    return `${row.applicantName || ""} ${guardianLabel} ${row.applicantGuardianName || ""}`.trim();
  };

  const displayCoaComparisonValue = (value) => {
    if (value === null || value === undefined) return "-";
    if (typeof value === "number") return String(value);
    return String(value).trim() ? String(value).trim() : "-";
  };

  const getCoaApplicationUpdatedTableRows = (
    historyRow,
    applicationRow = dialogRowData
  ) => {
    const type = Number(historyRow?.changeOfAttributesType);
    const hist = historyRow || {};
    const app = applicationRow || {};
    const rows = [];

    const previousValue = (historyKey, applicationKey) =>
      displayCoaComparisonValue(
        hist[historyKey] ?? app[applicationKey ?? historyKey]
      );

    const updatedValue = (primaryKey, fallbackKey) =>
      displayCoaComparisonValue(
        hist[primaryKey] ?? (fallbackKey ? hist[fallbackKey] : undefined)
      );

    if (coaIncludesName(type)) {
      rows.push({
        label: "Name",
        current: displayCoaComparisonValue(
          hist.currentOwnerName ??
          app.currentOwnerName ??
          formatCoaApplicantDisplayName(app, false)
        ),
        newVal: displayCoaComparisonValue(
          formatCoaApplicantDisplayName(hist, true)
        ),
      });
      rows.push({
        label: "CNIC",
        current: previousValue("currentOwnerCNIC", "currentOwnerCNIC"),
        newVal: updatedValue("applicantCNIC"),
      });
      rows.push({
        label: "Phone No.",
        current: previousValue("currentOwnerPhoneNo", "currentOwnerPhoneNo"),
        newVal: updatedValue("applicantPhoneNo"),
      });
      rows.push({
        label: "Email",
        current: previousValue("currentOwnerEmail", "currentOwnerEmail"),
        newVal: updatedValue("applicantEmail"),
      });
    }

    if (coaIncludesTariff(type)) {
      rows.push({
        label: "Tariff",
        current: previousValue("currentTariff", "currentTariff"),
        newVal: updatedValue("newTariff", "tariff"),
      });
    }

    if (coaIncludesLoad(type)) {
      rows.push({
        label: "Load",
        current: previousValue("currentSanctionLoad", "currentSanctionLoad"),
        newVal: updatedValue("newSanctionLoad", "sanctionLoad"),
      });
    }

    return rows;
  };

  const getTariff = (
    appliedLoad,
    connectionType,
    seasonalNonSeasonal,
    tariffs
  ) => {
    if (tariffs) {
      let tariff = "";
      if (connectionType === "Industrial") {
        if (seasonalNonSeasonal == 1) {
          const seasonalTariff = tariffs.find(
            (item) => item.tariffCode === "F"
          );
          if (seasonalTariff) {
            tariff = seasonalTariff.tariffName;
          } else {
            tariff = "";
          }
        } else if (seasonalNonSeasonal == 0 || !seasonalNonSeasonal) {
          let shortListedTariffsArray = tariffs.filter(
            (item) => item.consumerType === connectionType
          );
          shortListedTariffsArray = shortListedTariffsArray.filter(
            (item) =>
              parseInt(item.from) <= appliedLoad &&
              parseInt(item.to) > appliedLoad
          );
          let selectedTariff = shortListedTariffsArray[0];
          if (selectedTariff) {
            tariff = selectedTariff.tariffName;
          } else {
            tariff = "";
          }
        }
      } else {
        if (appliedLoad && appliedLoad > 0 && tariffs) {
          let shortListedTariffsArray = tariffs.filter(
            (item) => item.consumerType === connectionType
          );
          shortListedTariffsArray = shortListedTariffsArray.filter(
            (item) =>
              parseInt(item.from) <= appliedLoad &&
              parseInt(item.to) > appliedLoad
          );
          tariff = shortListedTariffsArray[0]
            ? shortListedTariffsArray[0].tariffName
            : "-";
        } else {
          tariff = "";
        }
      }
      return tariff;
    }
  };

  const isPdfDataUrl = (value) => {
    const normalized = normalizeDocumentDataUrl(value);
    if (!normalized || typeof normalized !== "string") return false;
    return (
      normalized.startsWith("data:application/pdf") ||
      normalized.slice(0, 6) === "data:a"
    );
  };

  const pdfToImage = async (base64) => {
    try {
      GlobalWorkerOptions.workerSrc =
        "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/4.0.379/pdf.worker.min.mjs";

      const normalized = normalizeDocumentDataUrl(base64);
      if (!normalized) return null;

      const base64Body = String(normalized).includes(",")
        ? String(normalized).split(",")[1]
        : String(normalized).replace(/^data:application\/pdf;base64,/, "");
      const binary = atob(base64Body);
      const bytes = new Uint8Array(binary.length);
      for (let i = 0; i < binary.length; i += 1) {
        bytes[i] = binary.charCodeAt(i);
      }

      const pdf = await getDocument({ data: bytes }).promise;
      const page = await pdf.getPage(1);
      const viewport = page.getViewport({ scale: 1.5 });
      const canvas = document.createElement("canvas");
      const context = canvas.getContext("2d");
      canvas.height = viewport.height;
      canvas.width = viewport.width;
      await page.render({ canvasContext: context, viewport }).promise;
      return canvas.toDataURL("image/png");
    } catch (error) {
      console.error("PDF to image conversion failed:", error);
      return null;
    }
  };

  const getCoaHistoryDocumentPreview = (document, convertedImage) => {
    if (convertedImage) return convertedImage;
    if (document?.startsWith("data:image")) return document;
    return null;
  };

  useEffect(() => {
    const convertHistoryWiringTestReport = async () => {
      const doc = historyData?.wiringTestReportDocument;
      if (
        !documentsVerifiedSubPopUp ||
        !doc ||
        !isCoaWiringTestReportPopupView(historyData)
      ) {
        setHistoryWiringTestReportImg("");
        setHistoryWiringTestReportImgLoading(false);
        return;
      }

      if (isPdfDataUrl(doc)) {
        setHistoryWiringTestReportImgLoading(true);
        try {
          const img = await pdfToImage(doc);
          setHistoryWiringTestReportImg(img || "");
        } catch (error) {
          setHistoryWiringTestReportImg("");
        } finally {
          setHistoryWiringTestReportImgLoading(false);
        }
        return;
      }

      if (String(doc).startsWith("data:image")) {
        setHistoryWiringTestReportImg(doc);
        setHistoryWiringTestReportImgLoading(false);
        return;
      }

      setHistoryWiringTestReportImg("");
      setHistoryWiringTestReportImgLoading(false);
    };

    convertHistoryWiringTestReport();
  }, [
    documentsVerifiedSubPopUp,
    historyData?.wiringTestReportDocument,
    historyData?.applicationProgressId,
    historyData?.objectionStatus,
  ]);

  useEffect(() => {
    const convert = async () => {
      const front = dialogRowData?.applicantCNICFront;
      const back = dialogRowData?.applicantCNICBack;

      if (!front && !back) {
        setFrontImg(null);
        setBackImg(null);
        return;
      }

      if (isPdfDataUrl(front)) {
        const img = await pdfToImage(front);
        setFrontImg(img);
      } else {
        setFrontImg(normalizeDocumentDataUrl(front) || front || null);
      }

      if (isPdfDataUrl(back)) {
        const img = await pdfToImage(back);
        setBackImg(img);
      } else {
        setBackImg(normalizeDocumentDataUrl(back) || back || null);
      }
    };

    convert();
  }, [dialogRowData?.applicantCNICFront, dialogRowData?.applicantCNICBack]);

  useEffect(() => {
    const convertPaidDnImages = async () => {
      const workflowSource = dnImage || dnApproveStep?.paidDNImage;
      if (!workflowSource) {
        setPaidDNVoucherImg(null);
      } else if (String(workflowSource).startsWith("data:application/pdf")) {
        try {
          const img = await pdfToImage(workflowSource);
          setPaidDNVoucherImg(img);
        } catch (error) {
          setPaidDNVoucherImg(null);
        }
      } else {
        setPaidDNVoucherImg(workflowSource);
      }

      const historySource =
        historyData?.paidDNImage || paidDnImageDetails?.paidDNImage;
      if (!historySource) {
        setHistoryPaidDnImg("");
      } else if (String(historySource).startsWith("data:application/pdf")) {
        try {
          const img = await pdfToImage(historySource);
          setHistoryPaidDnImg(img);
        } catch (error) {
          setHistoryPaidDnImg("");
        }
      } else {
        setHistoryPaidDnImg(historySource);
      }
    };

    convertPaidDnImages();
  }, [
    dnImage,
    dnApproveStep?.paidDNImage,
    historyData?.paidDNImage,
    paidDnImageDetails?.paidDNImage,
  ]);

  const errorCloses = () => {
    setReadyForBillingError("");
  };

  const handleCloseSnackbarDialog = () => {
    setSnackbar((prev) => ({ ...prev, open: false }));
  };

  const handleCloseResponseModal = () => {
    setOpenResponseModal(false);
    setResponseMessage("");
    setResponseMessageError("");
    setResponseStoreRequisitionNo("");
  };

  const snackbarDialogMeta = getCoaResultDialogMeta(
    snackbar.severity === "error" ? "error" : "success",
    snackbar.message
  );
  const responseModalMeta = getCoaResultDialogMeta(
    responseMessageError ? "error" : "success",
    responseMessageError || responseMessage
  );

  const isCoaActivityLogDialogOpen =
    applicationSubittedPopUp ||
    documentsVerifiedSubPopUp ||
    arrearVerifiedSubPopUp ||
    fieldSurveyedSubPopUp ||
    fieldSurveyedObjectionSubPopUp ||
    dnApprovalSubPopUp ||
    dnPaymentSubmittedSubPopUp ||
    dnPaymentVerifiedSubPopUp ||
    serviceConnectionOrderedSubPopUp ||
    meterInstalledSubPopUp ||
    readyForBillingSubPopUp ||
    coaApplicationUpdatedPopUp ||
    coaApplicationRevertedSubPopUp;

  return (
    <>
      <ServiceDashboardTables
        enabled={props.showTable && currentPath === "/change-of-attributes-table"}
        isLoadingNormal={isLoad}
        isLoadingOverdue={isLoadd}
        normalTitle={`Change of Attribute ( ${numberFormatting(totalRecordsNormal) ? numberFormatting(totalRecordsNormal) : "-"} )`}
        overdueCount={numberFormatting(totalRecordsOverdue) ? numberFormatting(totalRecordsOverdue) : "-"}
        normalColumns={tblColumns}
        overdueColumns={tblColumnsOverDue}
        normalData={changeOfNameApplicationsToDataGrid}
        overdueData={changeOfNameApplicationsOverDueToDataGrid}
        onRowClick={handleRowClick}
        mobileFields={["applicationId", "applicantName", "applicationStatusId"]}
        showCompanyFilter={code == 10}
        companies={companies}
        selectedOfficeCode={selectedOfficeCode}
        onOfficeCodeChange={setSelectedOfficeCode}
        normalTableProps={{
          firstPage: handleFirstPageNormal,
          lastPage: handleLastPageNormal,
          totalPages: totalPagesNormal,
          totalRecords: totalRecordsNormal,
          currentPage: currentPageNormal,
          handleFilterDateFrom: handleDateFromFilterNormal,
          handleFilterDateTo: handleDateToFilterNormal,
          resetDateFilter: handleResetDateFilterNormal,
          handleFilterProgressId: handleProgressIdFilterNormal,
          handleFilterObjectionStatus: handleObjectionStatusFilterNormal,
          resetProgressIdFilter: handleResetProgressIdFilterNormal,
          resetObjectionStatusFilter: handleResetObjectionStatusFilterNormal,
          nextPage: handleNextPageNormal,
          previousPage: handlePreviousPageNormal,
        }}
        overdueTableProps={{
          firstPage: handleFirstPageOverdue,
          lastPage: handleLastPageOverdue,
          nextPage: handleNextPageOverdue,
          previousPage: handlePreviousPageOverdue,
          handleFilterDateFrom: handleDateFromFilterOverdue,
          handleFilterDateTo: handleDateToFilterOverdue,
          resetDateFilter: handleResetDateFilterOverdue,
          resetProgressIdFilter: handleResetProgressIdFilterOverdue,
          resetObjectionStatusFilter: handleResetObjectionStatusFilterOverdue,
          handleFilterProgressId: handleProgressIdFilterOverdue,
          handleFilterObjectionStatus: handleObjectionStatusFilterOverdue,
          totalPages: totalPagesOverdue,
          totalRecords: totalRecordsOverdue,
          currentPage: currentPageOverdue,
        }}
      />

      <Dialog
        open={open}
        onClose={handleClose}
        fullWidth={true}
        maxWidth="xl"
        {...workflowDialogShellProps(isWorkflowMobile)}
        className={workflowDialogClassName(
          "main-dialog rco-workflow-dialog rco-workflow-dialog--reconnection",
          isWorkflowMobile,
        )}
        PaperProps={{ className: "rco-workflow-dialog-paper" }}
      >
        <DialogTitle className="dialog-title">
          <div className="rco-dialog-header coa-dialog-header">
            <Typography className="applicationTitleText">
              Change of{" "}
              {dialogRowData.changeOfAttributesType == 1
                ? "Name"
                : dialogRowData.changeOfAttributesType == 2
                  ? "Load"
                  : dialogRowData.changeOfAttributesType == 3
                    ? "Tariff"
                    : dialogRowData.changeOfAttributesType == 4
                      ? "Name, Load and Tariff"
                      : dialogRowData.changeOfAttributesType == 5
                        ? "Name and Load"
                        : dialogRowData.changeOfAttributesType == 6
                          ? "Name and Tariff"
                          : dialogRowData.changeOfAttributesType == 7
                            ? "Load and Tariff"
                            : ""}{" "}
              -
              <span style={{ color: "white" }}>
                {dialogRowData.applicationProgressId === 0 &&
                  " Document Submission"}
                {dialogRowData.applicationProgressId === 1 &&
                  " Document Verification"}
                {dialogRowData.applicationProgressId === 2 &&
                  " Wiring Test Report Verification"}
                {dialogRowData.applicationProgressId === 3 &&
                  " Arrear Verification"}
                {dialogRowData.applicationProgressId === 4 &&
                  " Field Survey"}
                {dialogRowData.applicationProgressId === 5 && " DN Approval"}
                {dialogRowData.applicationProgressId === 6 && "DN Submission"}
                {dialogRowData.applicationProgressId === 7 &&
                  " DN Payment Verification"}
                {dialogRowData.applicationProgressId === 8 &&
                  " Sundary Jobs Order"}
                {dialogRowData.applicationProgressId === 9 &&
                  " Ready For Billing"}
                {dialogRowData.applicationProgressId === 10 && " Completed"}
              </span>
            </Typography>
            <div className="coa-dialog-header__actions">
              {Number(dialogRowData.objectionStatus) === 1 && (
                <DescriptionIcon
                  className="coa-dialog-header__reject-icon"
                  onClick={() => downloadRejectionNoticePDF(dialogRowData)}
                  titleAccess="Download Rejection Notice"
                />
              )}
              <button
                type="button"
                className="rco-print-btn"
                onClick={() => downloadEFile(dialogRowData)}
                aria-label="Print E-File"
              >
                <PrintIcon />
              </button>
              <button
                type="button"
                className="closeIcon"
                onClick={handleClose}
                aria-label="Close dialog"
              >
                <CloseIcon id="clearPopup" sx={{ color: "white" }} />
              </button>
            </div>
          </div>
        </DialogTitle>
        <DialogContent>
          <DialogContentText component="div" className="dialog-content">
            <Grid container className="headercontainer">
              <Grid item lg={12} className="status-bar">
                <StepProgressBar
                  array={CONStatusBarArray}
                  applicationProgressId={getStepIndex(
                    dialogRowData.applicationProgressId
                  )}
                  objection={dialogRowData.objectionStatus}
                  openDetailsPopUp={openDetailsPopUp}
                  pageName="Change of Name"
                />
              </Grid>
              <Grid item xs={12} className="application-details">
                <div className="rco-application-details-body">
                  {/* Edit Button - all change-of-attribute types (before DN Approval) */}
                  {Number(dialogRowData.applicationProgressId) < 3 &&
                    CheckPermissions(
                      permissions,
                      "General Services",
                      "Change of Attributes",
                      "Basic Permissions",
                      "Update"
                    ) && (
                      <img
                        src={pencilIcon}
                        alt="edit"
                        width={20}
                        height={20}
                        className="coa-details-edit-btn"
                        onClick={() => {
                          // Extract unique circles from subDivisions
                          const circles = [];
                          const circleMap = {};
                          subDivisions?.forEach(sd => {
                            if (sd.circleCode && !circleMap[sd.circleCode]) {
                              circleMap[sd.circleCode] = true;
                              circles.push({ code: sd.circleCode, name: sd.circleName || sd.circleCode });
                            }
                          });
                          setEditCircleList(circles);

                          // Extract divisions for current circle
                          const divisions = [];
                          const divisionMap = {};
                          subDivisions?.forEach(sd => {
                            if (sd.circleCode == dialogRowData.circleCode && sd.divisionCode && !divisionMap[sd.divisionCode]) {
                              divisionMap[sd.divisionCode] = true;
                              divisions.push({ code: sd.divisionCode, name: sd.divisionName || sd.divisionCode });
                            }
                          });
                          setEditDivisionList(divisions);

                          // Extract subdivisions for current division
                          const subdivisionsList = [];
                          subDivisions?.forEach(sd => {
                            if (sd.divisionCode == dialogRowData.divisionCode && sd.subDivisionCode) {
                              subdivisionsList.push({ code: sd.subDivisionCode, name: sd.subDivisionName || sd.subDivisionCode });
                            }
                          });
                          setEditSubDivisionList(subdivisionsList);

                          setEditFormData({
                            // Common fields
                            referenceNo: dialogRowData.referenceNumber || "",
                            address: dialogRowData.consumerAddress || "",
                            connectionType: dialogRowData.newConnectionType || "",
                            tariff: dialogRowData.currentTariff || "",
                            city: dialogRowData.cityDistrict || "",
                            circle: dialogRowData.circleCode || "",
                            division: dialogRowData.divisionCode || "",
                            subdivision: dialogRowData.subDivisionCode || "",
                            // Change of Name fields
                            currentName: dialogRowData.currentOwnerName || "",
                            currentCNIC: dialogRowData.currentOwnerCNIC || "",
                            currentPhone: dialogRowData.currentOwnerPhoneNo || "",
                            newName: dialogRowData.applicantName || "",
                            newCNIC: dialogRowData.applicantCNIC || "",
                            newPhone: dialogRowData.applicantPhoneNo || "",
                            relation: dialogRowData.applicantGuardianType || "",
                            guardianName: dialogRowData.applicantGuardianName || "",
                            telcoCode: dialogRowData.telcoCode || "",
                            newEmail: dialogRowData.applicantEmail || "",
                            // Change of Load fields
                            loadChangeType:
                              dialogRowData.changeOfLoadType != null &&
                                dialogRowData.changeOfLoadType !== ""
                                ? String(dialogRowData.changeOfLoadType)
                                : "",
                            currentLoad: dialogRowData.currentSanctionLoad || "",
                            newLoad:
                              dialogRowData.newSanctionLoad != null &&
                                dialogRowData.newSanctionLoad !== ""
                                ? String(dialogRowData.newSanctionLoad)
                                : "",
                            // Change of Tariff fields
                            currentTariff: dialogRowData.currentTariff || "",
                            newTariff: getInitialEditNewTariff(dialogRowData),
                            ntnNo: dialogRowData.ntnNo || "",
                          });
                          setEditFormBaseline({
                            referenceNo: dialogRowData.referenceNumber || "",
                            address: dialogRowData.consumerAddress || "",
                            connectionType: dialogRowData.newConnectionType || "",
                            tariff: dialogRowData.currentTariff || "",
                            city: dialogRowData.cityDistrict || "",
                            circle: dialogRowData.circleCode || "",
                            division: dialogRowData.divisionCode || "",
                            subdivision: dialogRowData.subDivisionCode || "",
                            currentName: dialogRowData.currentOwnerName || "",
                            currentCNIC: dialogRowData.currentOwnerCNIC || "",
                            currentPhone: dialogRowData.currentOwnerPhoneNo || "",
                            newName: dialogRowData.applicantName || "",
                            newCNIC: dialogRowData.applicantCNIC || "",
                            newPhone: dialogRowData.applicantPhoneNo || "",
                            relation: dialogRowData.applicantGuardianType || "",
                            guardianName: dialogRowData.applicantGuardianName || "",
                            telcoCode: dialogRowData.telcoCode || "",
                            newEmail: dialogRowData.applicantEmail || "",
                            loadChangeType:
                              dialogRowData.changeOfLoadType != null &&
                                dialogRowData.changeOfLoadType !== ""
                                ? String(dialogRowData.changeOfLoadType)
                                : "",
                            currentLoad: dialogRowData.currentSanctionLoad || "",
                            newLoad:
                              dialogRowData.newSanctionLoad != null &&
                                dialogRowData.newSanctionLoad !== ""
                                ? String(dialogRowData.newSanctionLoad)
                                : "",
                            currentTariff: dialogRowData.currentTariff || "",
                            newTariff: getInitialEditNewTariff(dialogRowData),
                            ntnNo: dialogRowData.ntnNo || "",
                          });
                          setEditSections(initEditSections(dialogRowData.changeOfAttributesType));
                          setEditLoadError("");
                          setEditLoadChangeTypeError("");
                          setEditNameErrors({
                            newName: "",
                            guardianName: "",
                            newCNIC: "",
                            newPhone: "",
                          });
                          setEditTariffError("");
                          setEditSaveError("");
                          setEditNtnError("");
                          setEditFbrDocument("");
                          setEditFbrDocumentThumbnail("");
                          setEditFbrDocumentError("");
                          setEditFbrDocumentCleared(false);
                          setEditWiringTestReportDocument("");
                          setEditWiringTestReportThumbnail("");
                          setEditWiringTestReportError("");
                          setEditWiringTestReportCleared(false);
                          setShowEditPopup(true);
                        }}
                      />
                    )}
                  <Grid container gap={"4%"} className="first-row">
                    <Grid item lg={1.5} className="first-row-item">
                      <p className="prop-title"> Application Id.</p>
                      <p className="prop-detail">
                        {" "}
                        {dialogRowData.applicationId}
                      </p>
                    </Grid>
                    {
                      ((dialogRowData.changeOfAttributesType == 2 || dialogRowData.changeOfAttributesType == 3 || dialogRowData.changeOfAttributesType == 7)) &&
                      <Grid item lg={1.5} className="first-row-item">
                        <p className="prop-title"> Applicant Name </p>
                        <p className="prop-detail">
                          {" "}
                          {dialogRowData.applicantName
                            ? dialogRowData.applicantName
                            : "-"}
                        </p>
                      </Grid>
                    }
                    <Grid item lg={1.5} className="first-row-item">
                      <p className="prop-title"> Reference No.</p>
                      <p className="prop-detail">
                        {" "}
                        {dialogRowData.referenceNumber
                          ? dialogRowData.referenceNumber
                          : "-"}
                      </p>
                    </Grid>
                    <Grid item lg={3.5} className="first-row-item rco-details-grid__address">
                      <p className="prop-title"> Address</p>
                      <p className="prop-detail">
                        {" "}
                        {dialogRowData.consumerAddress
                          ? dialogRowData.consumerAddress
                          : "-"}
                      </p>
                    </Grid>
                    <Grid item lg={1} className="first-row-item">
                      <p className="prop-title"> Connection Type </p>
                      <p className="prop-detail">
                        {" "}
                        {dialogRowData.newConnectionType
                          ? dialogRowData.newConnectionType
                          : dialogRowData.connectionType || "-"}
                      </p>
                    </Grid>
                    {(dialogRowData.changeOfAttributesType == 1 ||
                      dialogRowData.changeOfAttributesType == 2 ||
                      dialogRowData.changeOfAttributesType == 5) && (
                        <Grid item lg={1} className="first-row-item">
                          <p className="prop-title"> Tariff </p>
                          <p className="prop-detail">
                            {" "}
                            {dialogRowData.currentTariff
                              ? dialogRowData.currentTariff
                              : "-"}
                          </p>
                        </Grid>
                      )}
                    <Grid item lg={1} className="first-row-item">
                      <p className="prop-title"> Subdivision </p>
                      <p className="prop-detail">
                        {" "}
                        {subdivisionName(
                          dialogRowData.subDivisionCode,
                          subDivisions
                        )}
                      </p>
                    </Grid>
                    {dialogRowData.changeOfAttributesType == 1 && (
                      <>
                        <Grid item lg={1.5} className="first-row-item coa-details-grid__current-name">
                          <p className="prop-title"> Current Name </p>
                          <p className="prop-detail">
                            {" "}
                            {dialogRowData.currentOwnerName
                              ? dialogRowData.currentOwnerName
                              : "-"}
                          </p>
                        </Grid>
                        <Grid item lg={1.5} className="first-row-item coa-details-grid__current-cnic">
                          <p className="prop-title"> Current CNIC</p>
                          <p className="prop-detail">
                            {" "}
                            {dialogRowData.currentOwnerCNIC
                              ? dialogRowData.currentOwnerCNIC
                              : "-"}
                          </p>
                        </Grid>
                        <Grid item lg={1.5} className="first-row-item">
                          <p className="prop-title"> Current Phone</p>
                          <p className="prop-detail">
                            {" "}
                            {dialogRowData.currentOwnerPhoneNo
                              ? dialogRowData.currentOwnerPhoneNo
                              : "-"}
                          </p>
                        </Grid>
                        <Grid item lg={1.5} className="first-row-item coa-details-grid__new-name">
                          <p className="prop-title"> New Name</p>
                          <p className="prop-detail">
                            {" "}
                            {dialogRowData.applicantName
                              ? `${dialogRowData.applicantName} ${dialogRowData.applicantGuardianType == 1 ? "S/O" :
                                dialogRowData.applicantGuardianType == 2 ? "D/O" :
                                  dialogRowData.applicantGuardianType == 3 ? "W/O" :
                                    dialogRowData.applicantGuardianType == 4 ? "C/O" : ""
                              } ${dialogRowData.applicantGuardianName || ""}`
                              : "-"}
                          </p>
                        </Grid>
                        <Grid item lg={1.5} className="first-row-item">
                          <p className="prop-title"> New CNIC</p>
                          <p className="prop-detail">
                            {" "}
                            {dialogRowData.applicantCNIC
                              ? dialogRowData.applicantCNIC
                              : "-"}
                          </p>
                        </Grid>
                        <Grid item lg={1.5} className="first-row-item">
                          <p className="prop-title"> New Phone</p>
                          <p className="prop-detail">
                            {" "}
                            {dialogRowData.applicantPhoneNo
                              ? dialogRowData.applicantPhoneNo
                              : "-"}
                          </p>
                        </Grid>
                      </>
                    )}
                    {dialogRowData.changeOfAttributesType == 2 && (
                      <>
                        <Grid item lg={1.5} className="first-row-item">
                          <p className="prop-title"> Current Load </p>
                          <p className="prop-detail">
                            {" "}
                            {dialogRowData.currentSanctionLoad
                              ? dialogRowData.currentSanctionLoad
                              : "-"}
                          </p>
                        </Grid>
                        <Grid item lg={1.5} className="first-row-item">
                          <p className="prop-title"> New Load</p>
                          <p className="prop-detail">
                            {" "}
                            {dialogRowData.newSanctionLoad
                              ? dialogRowData.newSanctionLoad
                              : "-"}
                          </p>
                        </Grid>
                      </>
                    )}
                    {dialogRowData.changeOfAttributesType == 3 && (
                      <>
                        <Grid item lg={1.5} className="first-row-item">
                          <p className="prop-title"> Current Tariff </p>
                          <p className="prop-detail">
                            {" "}
                            {dialogRowData.currentTariff
                              ? dialogRowData.currentTariff
                              : "-"}
                          </p>
                        </Grid>
                        <Grid item lg={1.5} className="first-row-item">
                          <p className="prop-title"> New Tariff</p>
                          <p className="prop-detail">
                            {" "}
                            {dialogRowData.newTariff
                              ? dialogRowData.newTariff
                              : "-"}
                          </p>
                        </Grid>
                      </>
                    )}
                    {dialogRowData.changeOfAttributesType == 4 && (
                      <>
                        <Grid item lg={1.5} className="first-row-item coa-details-grid__current-name">
                          <p className="prop-title"> Current Name </p>
                          <p className="prop-detail">
                            {" "}
                            {dialogRowData.currentOwnerName
                              ? dialogRowData.currentOwnerName
                              : "-"}
                          </p>
                        </Grid>
                        <Grid item lg={1.5} className="first-row-item coa-details-grid__current-cnic">
                          <p className="prop-title"> Current CNIC</p>
                          <p className="prop-detail">
                            {" "}
                            {dialogRowData.currentOwnerCNIC
                              ? dialogRowData.currentOwnerCNIC
                              : "-"}
                          </p>
                        </Grid>
                        <Grid item lg={1.5} className="first-row-item">
                          <p className="prop-title"> Current Phone</p>
                          <p className="prop-detail">
                            {" "}
                            {dialogRowData.currentOwnerPhoneNo
                              ? dialogRowData.currentOwnerPhoneNo
                              : "-"}
                          </p>
                        </Grid>
                        <Grid item lg={1.5} className="first-row-item coa-details-grid__new-name">
                          <p className="prop-title"> New Name</p>
                          <p className="prop-detail">
                            {" "}
                            {dialogRowData.applicantName
                              ? `${dialogRowData.applicantName} ${dialogRowData.applicantGuardianType == 1 ? "S/O" :
                                dialogRowData.applicantGuardianType == 2 ? "D/O" :
                                  dialogRowData.applicantGuardianType == 3 ? "W/O" :
                                    dialogRowData.applicantGuardianType == 4 ? "C/O" : ""
                              } ${dialogRowData.applicantGuardianName || ""}`
                              : "-"}
                          </p>
                        </Grid>
                        <Grid item lg={1.5} className="first-row-item">
                          <p className="prop-title"> New CNIC</p>
                          <p className="prop-detail">
                            {" "}
                            {dialogRowData.applicantCNIC
                              ? dialogRowData.applicantCNIC
                              : "-"}
                          </p>
                        </Grid>
                        <Grid item lg={1.5} className="first-row-item">
                          <p className="prop-title"> New Phone</p>
                          <p className="prop-detail">
                            {" "}
                            {dialogRowData.applicantPhoneNo
                              ? dialogRowData.applicantPhoneNo
                              : "-"}
                          </p>
                        </Grid>
                        <Grid item lg={1.5} className="first-row-item">
                          <p className="prop-title"> Current Load </p>
                          <p className="prop-detail">
                            {" "}
                            {dialogRowData.currentSanctionLoad
                              ? dialogRowData.currentSanctionLoad
                              : "-"}
                          </p>
                        </Grid>
                        <Grid item lg={1.5} className="first-row-item">
                          <p className="prop-title"> New Load</p>
                          <p className="prop-detail">
                            {" "}
                            {dialogRowData.newSanctionLoad
                              ? dialogRowData.newSanctionLoad
                              : "-"}
                          </p>
                        </Grid>
                        <Grid item lg={1.5} className="first-row-item">
                          <p className="prop-title"> Current Tariff </p>
                          <p className="prop-detail">
                            {" "}
                            {dialogRowData.currentTariff
                              ? dialogRowData.currentTariff
                              : "-"}
                          </p>
                        </Grid>
                        <Grid item lg={1.5} className="first-row-item">
                          <p className="prop-title"> New Tariff</p>
                          <p className="prop-detail">
                            {" "}
                            {dialogRowData.newTariff
                              ? dialogRowData.newTariff
                              : "-"}
                          </p>
                        </Grid>
                      </>
                    )}
                    {dialogRowData.changeOfAttributesType == 5 && (
                      <>
                        <Grid item lg={1.5} className="first-row-item coa-details-grid__current-name">
                          <p className="prop-title"> Current Name </p>
                          <p className="prop-detail">
                            {" "}
                            {dialogRowData.currentOwnerName
                              ? dialogRowData.currentOwnerName
                              : "-"}
                          </p>
                        </Grid>
                        <Grid item lg={1.5} className="first-row-item coa-details-grid__current-cnic">
                          <p className="prop-title"> Current CNIC</p>
                          <p className="prop-detail">
                            {" "}
                            {dialogRowData.currentOwnerCNIC
                              ? dialogRowData.currentOwnerCNIC
                              : "-"}
                          </p>
                        </Grid>
                        <Grid item lg={1.5} className="first-row-item">
                          <p className="prop-title"> Current Phone</p>
                          <p className="prop-detail">
                            {" "}
                            {dialogRowData.currentOwnerPhoneNo
                              ? dialogRowData.currentOwnerPhoneNo
                              : "-"}
                          </p>
                        </Grid>
                        <Grid item lg={1.5} className="first-row-item coa-details-grid__new-name">
                          <p className="prop-title"> New Name</p>
                          <p className="prop-detail">
                            {" "}
                            {dialogRowData.applicantName
                              ? `${dialogRowData.applicantName} ${dialogRowData.applicantGuardianType == 1 ? "S/O" :
                                dialogRowData.applicantGuardianType == 2 ? "D/O" :
                                  dialogRowData.applicantGuardianType == 3 ? "W/O" :
                                    dialogRowData.applicantGuardianType == 4 ? "C/O" : ""
                              } ${dialogRowData.applicantGuardianName || ""}`
                              : "-"}
                          </p>
                        </Grid>
                        <Grid item lg={1.5} className="first-row-item">
                          <p className="prop-title"> New CNIC</p>
                          <p className="prop-detail">
                            {" "}
                            {dialogRowData.applicantCNIC
                              ? dialogRowData.applicantCNIC
                              : "-"}
                          </p>
                        </Grid>
                        <Grid item lg={1.5} className="first-row-item">
                          <p className="prop-title"> New Phone</p>
                          <p className="prop-detail">
                            {" "}
                            {dialogRowData.applicantPhoneNo
                              ? dialogRowData.applicantPhoneNo
                              : "-"}
                          </p>
                        </Grid>
                        <Grid item lg={1.5} className="first-row-item">
                          <p className="prop-title"> Current Load </p>
                          <p className="prop-detail">
                            {" "}
                            {dialogRowData.currentSanctionLoad
                              ? dialogRowData.currentSanctionLoad
                              : "-"}
                          </p>
                        </Grid>
                        <Grid item lg={1.5} className="first-row-item">
                          <p className="prop-title"> New Load</p>
                          <p className="prop-detail">
                            {" "}
                            {dialogRowData.newSanctionLoad
                              ? dialogRowData.newSanctionLoad
                              : "-"}
                          </p>
                        </Grid>
                      </>
                    )}
                    {dialogRowData.changeOfAttributesType == 6 && (
                      <>
                        <Grid item lg={1.5} className="first-row-item coa-details-grid__current-name">
                          <p className="prop-title"> Current Name </p>
                          <p className="prop-detail">
                            {" "}
                            {dialogRowData.currentOwnerName
                              ? dialogRowData.currentOwnerName
                              : "-"}
                          </p>
                        </Grid>
                        <Grid item lg={1.5} className="first-row-item coa-details-grid__current-cnic">
                          <p className="prop-title"> Current CNIC</p>
                          <p className="prop-detail">
                            {" "}
                            {dialogRowData.currentOwnerCNIC
                              ? dialogRowData.currentOwnerCNIC
                              : "-"}
                          </p>
                        </Grid>
                        <Grid item lg={1.5} className="first-row-item">
                          <p className="prop-title"> Current Phone</p>
                          <p className="prop-detail">
                            {" "}
                            {dialogRowData.currentOwnerPhoneNo
                              ? dialogRowData.currentOwnerPhoneNo
                              : "-"}
                          </p>
                        </Grid>
                        <Grid item lg={1.5} className="first-row-item coa-details-grid__new-name">
                          <p className="prop-title"> New Name</p>
                          <p className="prop-detail">
                            {" "}
                            {dialogRowData.applicantName
                              ? `${dialogRowData.applicantName} ${dialogRowData.applicantGuardianType == 1 ? "S/O" :
                                dialogRowData.applicantGuardianType == 2 ? "D/O" :
                                  dialogRowData.applicantGuardianType == 3 ? "W/O" :
                                    dialogRowData.applicantGuardianType == 4 ? "C/O" : ""
                              } ${dialogRowData.applicantGuardianName || ""}`
                              : "-"}
                          </p>
                        </Grid>
                        <Grid item lg={1.5} className="first-row-item">
                          <p className="prop-title"> New CNIC</p>
                          <p className="prop-detail">
                            {" "}
                            {dialogRowData.applicantCNIC
                              ? dialogRowData.applicantCNIC
                              : "-"}
                          </p>
                        </Grid>
                        <Grid item lg={1.5} className="first-row-item">
                          <p className="prop-title"> New Phone</p>
                          <p className="prop-detail">
                            {" "}
                            {dialogRowData.applicantPhoneNo
                              ? dialogRowData.applicantPhoneNo
                              : "-"}
                          </p>
                        </Grid>
                        <Grid item lg={1.5} className="first-row-item">
                          <p className="prop-title"> Current Tariff </p>
                          <p className="prop-detail">
                            {" "}
                            {dialogRowData.currentTariff
                              ? dialogRowData.currentTariff
                              : "-"}
                          </p>
                        </Grid>
                        <Grid item lg={1.5} className="first-row-item">
                          <p className="prop-title"> New Tariff</p>
                          <p className="prop-detail">
                            {" "}
                            {dialogRowData.newTariff
                              ? dialogRowData.newTariff
                              : "-"}
                          </p>
                        </Grid>
                      </>
                    )}
                    {dialogRowData.changeOfAttributesType == 7 && (
                      <>
                        <Grid item lg={1.5} className="first-row-item">
                          <p className="prop-title"> Current Load </p>
                          <p className="prop-detail">
                            {" "}
                            {dialogRowData.currentSanctionLoad
                              ? dialogRowData.currentSanctionLoad
                              : "-"}
                          </p>
                        </Grid>
                        <Grid item lg={1.5} className="first-row-item">
                          <p className="prop-title"> New Load</p>
                          <p className="prop-detail">
                            {" "}
                            {dialogRowData.newSanctionLoad
                              ? dialogRowData.newSanctionLoad
                              : "-"}
                          </p>
                        </Grid>
                        <Grid item lg={1.5} className="first-row-item">
                          <p className="prop-title"> Current Tariff </p>
                          <p className="prop-detail">
                            {" "}
                            {dialogRowData.currentTariff
                              ? dialogRowData.currentTariff
                              : "-"}
                          </p>
                        </Grid>
                        <Grid item lg={1.5} className="first-row-item">
                          <p className="prop-title"> New Tariff</p>
                          <p className="prop-detail">
                            {" "}
                            {dialogRowData.newTariff
                              ? dialogRowData.newTariff
                              : "-"}
                          </p>
                        </Grid>
                      </>
                    )}
                  </Grid>
                </div>
              </Grid>
              <Grid item xs={12} className="rco-workflow-panels-wrap">
                <div
                  className={`rco-workflow-panels${
                    activityLogCollapsed
                      ? " rco-workflow-panels--activity-collapsed"
                      : ""
                  }`}
                >
                  <div
                    className={`processing-summary${
                      activityLogCollapsed ? " processing-summary--collapsed" : ""
                    }`}
                  >
                    <div className="rco-activity-log-head">
                      <button
                        type="button"
                        className="rco-activity-collapse-btn"
                        onClick={() => setActivityLogCollapsed((prev) => !prev)}
                        aria-expanded={!activityLogCollapsed}
                        aria-label={
                          activityLogCollapsed
                            ? "Expand Activity Log"
                            : "Collapse Activity Log"
                        }
                        title={
                          activityLogCollapsed
                            ? "Expand Activity Log"
                            : "Collapse Activity Log"
                        }
                      >
                        {activityLogCollapsed ? (
                          <ChevronRightIcon fontSize="small" />
                        ) : (
                          <ChevronLeftIcon fontSize="small" />
                        )}
                      </button>
                      <p className="title">Activity Log</p>
                      {!activityLogCollapsed &&
                      eFileData &&
                      eFileData.length > 0 ? (
                        <button
                          type="button"
                          className="rco-activity-view-detail-btn"
                          onClick={() => setActivityLogDetailOpen(true)}
                        >
                          <VisibilityOutlinedIcon />
                          Timeline
                        </button>
                      ) : null}
                    </div>

                    {!activityLogCollapsed ? (
                      <div className="rco-activity-log-body">
                        {viewDropBackForEfile ? (
                          <div className="rco-load-activity-wrap rco-load-activity-wrap--loading">
                            <AppLoader size={30} />
                          </div>
                        ) : eFileData && eFileData.length > 0 ? (
                          <ProcessingSummaryTableForCoa
                            key={tableDataProcessingSummary.length}
                            data={tableDataProcessingSummary}
                            columns={tableColumnsProcessingSummary}
                            openDetailsPopUp={(fullRow) => {
                              void openDetailsPopUp(fullRow);
                            }}
                            isApplicationUpdatedRow={(row) =>
                              row?.isApplicationUpdatedEntry === true
                            }
                          />
                        ) : (
                          <div className="rco-load-activity-wrap">
                            <button
                              onClick={onPressViewActivityLog}
                              type="button"
                              className="rco-load-activity-btn"
                            >
                              Load Activity Log
                            </button>
                          </div>
                        )}
                      </div>
                    ) : null}
                  </div>
                  <div className="action-form">
                    <div className="fields">
                      {dialogRowData.applicationProgressId === 0 ? (
                        <>
                          <h3 className="step-title">Documents Pending</h3>
                          <div className="description-box description-box--error">
                            <p className="group-description">
                              <InfoIcon className="icon" />
                              {CheckPermissions(
                                permissions,
                                "General Services",
                                "Change of Attributes"
                              )
                                ? "To process application, some documents are yet to be provided by the customer. If available, you can upload the remaining documents by clicking below button."
                                : "To process application, some documents are yet to be provided by the customer."}
                            </p>
                          </div>
                        </>
                      ) : dialogRowData.applicationProgressId === 1 &&
                        (dialogRowData.objectionStatus === 0 ||
                          dialogRowData.objectionStatus === 2) ? (
                        CheckPermissions(
                          permissions,
                          "General Services",
                          "Change of Attributes",
                          "Workflow Permissions",
                          "Documents Verification"
                        ) ? (
                          <>
                            <h3 className="step-title">Document Verification</h3>
                            <Grid
                              className="document-verification-container"
                              container
                              spacing={1}
                            >
                              {(dialogRowData.applicantCNICFront ||
                                dialogRowData.applicantCNICBack) && (
                                  <Grid item lg={2}>
                                    <Grid
                                      container
                                      sx={{
                                        backgroundColor: getDocumentBackGroundColor(
                                          flag_applicantCNICFront
                                        ),
                                        borderRadius: "10px",
                                        minHeight: "150px",
                                        height: "auto",
                                      }}
                                    >
                                      <Grid
                                        item
                                        lg={12}
                                        style={{
                                          display: "flex",
                                          justifyContent: "center",
                                          alignItems: "center",
                                          paddingBottom: "5px",
                                        }}
                                      >
                                        <div
                                          onClick={() => {
                                            if (!copyOfApplicantCNICVerifyPopUp) {
                                              setCopyOfApplicantCNICVerifyPopUp(true);
                                            }
                                          }}
                                          style={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            flexDirection: "column",
                                            alignItems: "center",
                                          }}
                                        >
                                          {dialogRowData.applicantCNICFront &&
                                            dialogRowData.applicantCNICFront.slice(
                                              0,
                                              6
                                            ) === "data:i" ? (
                                            <Base64Image
                                              data={
                                                dialogRowData.applicantCNICFront
                                              }
                                              width="80"
                                              height="50"
                                            />
                                          ) : dialogRowData.applicantCNICFront ? (
                                            <Base64Image data={pdfIcon} width="40" />
                                          ) : null}
                                          {dialogRowData.applicantCNICBack &&
                                            dialogRowData.applicantCNICBack.slice(
                                              0,
                                              6
                                            ) === "data:i" ? (
                                            <Base64Image
                                              data={dialogRowData.applicantCNICBack}
                                              width="80"
                                              height="50"
                                            />
                                          ) : dialogRowData.applicantCNICBack ? (
                                            <Base64Image data={pdfIcon} width="40" />
                                          ) : null}
                                          {flag_applicantCNICFront === 1 && (
                                            <img
                                              src={tickicon}
                                              width="25px"
                                              height="25px"
                                              alt="Tick Icon"
                                              className="doc-verification-status-icon"
                                            />
                                          )}
                                          {flag_applicantCNICFront === -1 && (
                                            <img
                                              src={crossIcon}
                                              width="25px"
                                              height="25px"
                                              alt="Cross Icon"
                                              className="doc-verification-status-icon"
                                            />
                                          )}
                                          {!isCoaActivityLogDialogOpen && copyOfApplicantCNICVerifyPopUp && (
                                            <OpenBase64ImageInPopup
                                              docVerifyPopUp={
                                                copyOfApplicantCNICVerifyPopUp
                                              }
                                              hideDocVerifyPopup={
                                                hideCopyOfApplicantCNICVerifyAlert
                                              }
                                              documentName="Applicant CNIC"
                                              documentImage={
                                                dialogRowData.applicantCNICFront
                                              }
                                              backDocumentImage={
                                                dialogRowData.applicantCNICBack
                                              }
                                              width={"100%"}
                                              document={
                                                dialogRowData.applicantCNICFront
                                              }
                                              documentFlag={
                                                dialogRowData.applicantCNICFrontFlag
                                              }
                                              applicationProgressId={
                                                dialogRowData.applicationProgressId
                                              }
                                              objectionStatus={
                                                dialogRowData.objectionStatus
                                              }
                                              updateDocFlag={updateDocFlag}
                                              documentRemarks={
                                                applicantCNICBackObjectionRemarks
                                              }
                                              titleToUpdateFlag="copyOfApplicantCNIC"
                                              flag_document={flag_applicantCNICFront}
                                              flag_documentBack={
                                                flag_applicantCNICBack
                                              }
                                            />
                                          )}
                                        </div>
                                      </Grid>
                                      <Grid item lg={12} className="tittlegrid">
                                        <p className="docTitle">Applicant's CNIC.</p>
                                      </Grid>
                                    </Grid>
                                  </Grid>
                                )}
                              {dialogRowData.owenershipDocument && (
                                <Grid item lg={2}>
                                  <Grid
                                    container
                                    sx={{
                                      backgroundColor: getDocumentBackGroundColor(
                                        flag_owenershipDocument
                                      ),
                                      borderRadius: "10px",
                                      minHeight: "150px",
                                      height: "auto",
                                    }}
                                  >
                                    <Grid
                                      item
                                      lg={12}
                                      style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                      }}
                                    >
                                      <div
                                        onClick={() => {
                                          if (!owenershipDocumentVerifyPopUp) {
                                            setOwenershipDocumentVerifyPopUp(true);
                                          }
                                        }}
                                        style={{
                                          display: "flex",
                                          justifyContent: "space-between",
                                        }}
                                      >
                                        {dialogRowData.owenershipDocument.slice(
                                          0,
                                          6
                                        ) === "data:i" ? (
                                          flag_owenershipDocument === 1 ? (
                                            <>
                                              <Base64Image
                                                data={
                                                  dialogRowData.owenershipDocument
                                                }
                                                width="80"
                                                height="110"
                                              />
                                              <img
                                                src={tickicon}
                                                width="25px"
                                                height="25px"
                                                alt="Tick Icon"
                                                className="doc-verification-status-icon"
                                              />
                                            </>
                                          ) : flag_owenershipDocument === -1 ? (
                                            <>
                                              <Base64Image
                                                data={
                                                  dialogRowData.owenershipDocument
                                                }
                                                width="80"
                                                height="110"
                                              />
                                              <img
                                                src={crossIcon}
                                                width="25px"
                                                height="25px"
                                                alt="Cross Icon"
                                                className="doc-verification-status-icon"
                                              />
                                            </>
                                          ) : (
                                            <Base64Image
                                              data={
                                                dialogRowData.owenershipDocument
                                              }
                                              width="80"
                                              height="110"
                                            />
                                          )
                                        ) : flag_owenershipDocument === 1 ? (
                                          <>
                                            <Base64Image data={pdfIcon} width="40" />
                                            <img
                                              src={tickicon}
                                              width="25px"
                                              height="25px"
                                              alt="Tick Icon"
                                              className="doc-verification-status-icon"
                                            />
                                          </>
                                        ) : flag_owenershipDocument === -1 ? (
                                          <>
                                            <Base64Image data={pdfIcon} width="40" />
                                            <img
                                              src={crossIcon}
                                              width="25px"
                                              height="25px"
                                              alt="Cross Icon"
                                              className="doc-verification-status-icon"
                                            />
                                          </>
                                        ) : (
                                          <Base64Image data={pdfIcon} width="40" />
                                        )}
                                        {!isCoaActivityLogDialogOpen && owenershipDocumentVerifyPopUp && (
                                          <OpenBase64ImageInPopup
                                            docVerifyPopUp={
                                              owenershipDocumentVerifyPopUp
                                            }
                                            hideDocVerifyPopup={
                                              hidePropertyDocVerifyAlert
                                            }
                                            documentName="Property Document"
                                            documentImage={
                                              dialogRowData.owenershipDocument
                                            }
                                            width={"100%"}
                                            document={
                                              dialogRowData.owenershipDocument
                                            }
                                            documentFlag={
                                              dialogRowData.owenershipDocumentFlag
                                            }
                                            applicationProgressId={
                                              dialogRowData.applicationProgressId
                                            }
                                            objectionStatus={
                                              dialogRowData.objectionStatus
                                            }
                                            updateDocFlag={updateDocFlag}
                                            documentRemarks={
                                              owenershipObjectionRemarks
                                            }
                                            titleToUpdateFlag="owenershipDocument"
                                            flag_document={flag_owenershipDocument}
                                          />
                                        )}
                                      </div>
                                    </Grid>
                                    <Grid item lg={12} className="tittlegrid">
                                      <p className="docTitle">Proof of Ownership</p>
                                    </Grid>
                                  </Grid>
                                </Grid>
                              )}
                              {dialogRowData.electricityBillDocument && (
                                <Grid item lg={2}>
                                  <Grid
                                    container
                                    sx={{
                                      backgroundColor: getDocumentBackGroundColor(
                                        flag_electricityBillDocument
                                      ),
                                      borderRadius: "10px",
                                      minHeight: "150px",
                                      height: "auto",
                                    }}
                                  >
                                    <Grid
                                      item
                                      lg={12}
                                      style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                      }}
                                    >
                                      <div
                                        onClick={() => {
                                          if (!electricityBillDocumentVerifyPopUp) {
                                            setElectricityBillDocumentVerifyPopUp(
                                              true
                                            );
                                          }
                                        }}
                                        style={{
                                          display: "flex",
                                          justifyContent: "space-between",
                                        }}
                                      >
                                        {dialogRowData.electricityBillDocument.slice(
                                          0,
                                          6
                                        ) === "data:i" ? (
                                          flag_electricityBillDocument === 1 ? (
                                            <>
                                              <Base64Image
                                                data={
                                                  dialogRowData.electricityBillDocument
                                                }
                                                width="80"
                                                height="110"
                                              />
                                              <img
                                                src={tickicon}
                                                width="25px"
                                                height="25px"
                                                alt="Tick Icon"
                                                className="doc-verification-status-icon"
                                              />
                                            </>
                                          ) : flag_electricityBillDocument ===
                                            -1 ? (
                                            <>
                                              <Base64Image
                                                data={
                                                  dialogRowData.electricityBillDocument
                                                }
                                                width="80"
                                                height="110"
                                              />
                                              <img
                                                src={crossIcon}
                                                width="25px"
                                                height="25px"
                                                alt="Cross Icon"
                                                className="doc-verification-status-icon"
                                              />
                                            </>
                                          ) : (
                                            <Base64Image
                                              data={
                                                dialogRowData.electricityBillDocument
                                              }
                                              width="80"
                                              height="110"
                                            />
                                          )
                                        ) : flag_electricityBillDocument === 1 ? (
                                          <>
                                            <Base64Image data={pdfIcon} width="40" />
                                            <img
                                              src={tickicon}
                                              width="25px"
                                              height="25px"
                                              alt="Tick Icon"
                                              className="doc-verification-status-icon"
                                            />
                                          </>
                                        ) : flag_electricityBillDocument === -1 ? (
                                          <>
                                            <Base64Image data={pdfIcon} width="40" />
                                            <img
                                              src={crossIcon}
                                              width="25px"
                                              height="25px"
                                              alt="Cross Icon"
                                              className="doc-verification-status-icon"
                                            />
                                          </>
                                        ) : (
                                          <Base64Image data={pdfIcon} width="40" />
                                        )}
                                        {!isCoaActivityLogDialogOpen && electricityBillDocumentVerifyPopUp && (
                                          <OpenBase64ImageInPopup
                                            docVerifyPopUp={
                                              electricityBillDocumentVerifyPopUp
                                            }
                                            hideDocVerifyPopup={
                                              hideElectricityBillVerifyAlert
                                            }
                                            documentName="Electricity Bill Document"
                                            documentImage={
                                              dialogRowData.electricityBillDocument
                                            }
                                            width={"100%"}
                                            document={
                                              dialogRowData.electricityBillDocument
                                            }
                                            documentFlag={
                                              dialogRowData.electricityBillDocumentFlag
                                            }
                                            applicationProgressId={
                                              dialogRowData.applicationProgressId
                                            }
                                            objectionStatus={
                                              dialogRowData.objectionStatus
                                            }
                                            updateDocFlag={updateDocFlag}
                                            documentRemarks={
                                              electricityBillObjectionRemarks
                                            }
                                            titleToUpdateFlag="electricityBillDocument"
                                            flag_document={
                                              flag_electricityBillDocument
                                            }
                                          />
                                        )}
                                      </div>
                                    </Grid>
                                    <Grid item lg={12} className="tittlegrid">
                                      <p className="docTitle">
                                        Electricity Bill Document
                                      </p>
                                    </Grid>
                                  </Grid>
                                </Grid>
                              )}

                              {dialogRowData.fbrDocument && (
                                <Grid item lg={2}>
                                  <Grid
                                    container
                                    sx={{
                                      backgroundColor: getDocumentBackGroundColor(
                                        flag_fbrDocument
                                      ),
                                      borderRadius: "10px",
                                      minHeight: "150px",
                                      height: "auto",
                                    }}
                                  >
                                    <Grid
                                      item
                                      lg={12}
                                      style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                      }}
                                    >
                                      <div
                                        onClick={() => {
                                          if (!fbrDocumentVerifyPopUp) {
                                            setFbrDocumentVerifyPopUp(true);
                                          }
                                        }}
                                        style={{
                                          display: "flex",
                                          justifyContent: "space-between",
                                        }}
                                      >
                                        {dialogRowData.fbrDocument.slice(0, 6) ===
                                          "data:i" ? (
                                          flag_fbrDocument === 1 ? (
                                            <>
                                              <Base64Image
                                                data={dialogRowData.fbrDocument}
                                                width="80"
                                                height="110"
                                              />
                                              <img
                                                src={tickicon}
                                                width="25px"
                                                height="25px"
                                                alt="Tick Icon"
                                                className="doc-verification-status-icon"
                                              />
                                            </>
                                          ) : flag_fbrDocument === -1 ? (
                                            <>
                                              <Base64Image
                                                data={dialogRowData.fbrDocument}
                                                width="80"
                                                height="110"
                                              />
                                              <img
                                                src={crossIcon}
                                                width="25px"
                                                height="25px"
                                                alt="Cross Icon"
                                                className="doc-verification-status-icon"
                                              />
                                            </>
                                          ) : (
                                            <Base64Image
                                              data={dialogRowData.fbrDocument}
                                              width="80"
                                              height="110"
                                            />
                                          )
                                        ) : flag_fbrDocument === 1 ? (
                                          <>
                                            <Base64Image data={pdfIcon} width="40" />
                                            <img
                                              src={tickicon}
                                              width="25px"
                                              height="25px"
                                              alt="Tick Icon"
                                              className="doc-verification-status-icon"
                                            />
                                          </>
                                        ) : flag_fbrDocument === -1 ? (
                                          <>
                                            <Base64Image data={pdfIcon} width="40" />
                                            <img
                                              src={crossIcon}
                                              width="25px"
                                              height="25px"
                                              alt="Cross Icon"
                                              className="doc-verification-status-icon"
                                            />
                                          </>
                                        ) : (
                                          <Base64Image data={pdfIcon} width="40" />
                                        )}
                                        {!isCoaActivityLogDialogOpen && fbrDocumentVerifyPopUp && (
                                          <OpenBase64ImageInPopup
                                            docVerifyPopUp={fbrDocumentVerifyPopUp}
                                            hideDocVerifyPopup={
                                              hideFbrDocVerifyAlert
                                            }
                                            documentName="FBR Document"
                                            documentImage={
                                              dialogRowData.fbrDocument
                                            }
                                            width={"100%"}
                                            document={dialogRowData.fbrDocument}
                                            documentFlag={
                                              dialogRowData.fbrDocumentFlag
                                            }
                                            applicationProgressId={
                                              dialogRowData.applicationProgressId
                                            }
                                            objectionStatus={
                                              dialogRowData.objectionStatus
                                            }
                                            updateDocFlag={updateDocFlag}
                                            documentRemarks={
                                              fbrDocumentObjectionRemarks
                                            }
                                            titleToUpdateFlag="fbrDocument"
                                            flag_document={flag_fbrDocument}
                                          />
                                        )}
                                      </div>
                                    </Grid>
                                    <Grid item lg={12} className="tittlegrid">
                                      <p className="docTitle">FBR Document</p>
                                    </Grid>
                                  </Grid>
                                </Grid>
                              )}

                              {dialogRowData.addDocAnyOther && (
                                <Grid item lg={2}>
                                  <Grid
                                    container
                                    sx={{
                                      backgroundColor: getDocumentBackGroundColor(
                                        flag_addDocAnyOther
                                      ),
                                      borderRadius: "10px",
                                      minHeight: "150px",
                                      height: "auto",
                                    }}
                                  >
                                    <Grid
                                      item
                                      lg={12}
                                      style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                      }}
                                    >
                                      <div
                                        onClick={() => {
                                          if (!addDocAnyOtherVerifyPopUp) {
                                            setAddDocAnyOtherVerifyPopUp(true);
                                          }
                                        }}
                                        style={{
                                          display: "flex",
                                          justifyContent: "space-between",
                                        }}
                                      >
                                        {dialogRowData.addDocAnyOther.slice(0, 6) ===
                                          "data:i" ? (
                                          flag_addDocAnyOther === 1 ? (
                                            <>
                                              <Base64Image
                                                data={dialogRowData.addDocAnyOther}
                                                width="80"
                                                height="110"
                                              />
                                              <img
                                                src={tickicon}
                                                width="25px"
                                                height="25px"
                                                alt="Tick Icon"
                                                className="doc-verification-status-icon"
                                              />
                                            </>
                                          ) : flag_addDocAnyOther === -1 ? (
                                            <>
                                              <Base64Image
                                                data={dialogRowData.addDocAnyOther}
                                                width="80"
                                                height="110"
                                              />
                                              <img
                                                src={crossIcon}
                                                width="25px"
                                                height="25px"
                                                alt="Cross Icon"
                                                className="doc-verification-status-icon"
                                              />
                                            </>
                                          ) : (
                                            <Base64Image
                                              data={dialogRowData.addDocAnyOther}
                                              width="80"
                                              height="110"
                                            />
                                          )
                                        ) : flag_addDocAnyOther === 1 ? (
                                          <>
                                            <Base64Image data={pdfIcon} width="40" />
                                            <img
                                              src={tickicon}
                                              width="25px"
                                              height="25px"
                                              alt="Tick Icon"
                                              className="doc-verification-status-icon"
                                            />
                                          </>
                                        ) : flag_addDocAnyOther === -1 ? (
                                          <>
                                            <Base64Image data={pdfIcon} width="40" />
                                            <img
                                              src={crossIcon}
                                              width="25px"
                                              height="25px"
                                              alt="Cross Icon"
                                              className="doc-verification-status-icon"
                                            />
                                          </>
                                        ) : (
                                          <Base64Image data={pdfIcon} width="40" />
                                        )}
                                        {!isCoaActivityLogDialogOpen && addDocAnyOtherVerifyPopUp && (
                                          <OpenBase64ImageInPopup
                                            docVerifyPopUp={addDocAnyOtherVerifyPopUp}
                                            hideDocVerifyPopup={
                                              hideAddAnyOtherVerifyAlert
                                            }
                                            documentName="Any Other Document"
                                            documentImage={
                                              dialogRowData.addDocAnyOther
                                            }
                                            width={"100%"}
                                            document={dialogRowData.addDocAnyOther}
                                            documentFlag={
                                              dialogRowData.anyOtherDocumentFlag
                                            }
                                            applicationProgressId={
                                              dialogRowData.applicationProgressId
                                            }
                                            objectionStatus={
                                              dialogRowData.objectionStatus
                                            }
                                            updateDocFlag={updateDocFlag}
                                            documentRemarks={
                                              addDocAnyOtherObjectionRemarks
                                            }
                                            titleToUpdateFlag="addDocAnyOther"
                                            flag_document={flag_addDocAnyOther}
                                          />
                                        )}
                                      </div>
                                    </Grid>
                                    <Grid item lg={12} className="tittlegrid">
                                      <p className="docTitle">Any Other Document</p>
                                    </Grid>
                                  </Grid>
                                </Grid>
                              )}
                            </Grid>
                          </>
                        ) : (
                          <>
                            <h3 className="step-title">Document Verification</h3>
                            <div className="description-box description-box--error">
                              <p className="group-description">
                                <InfoIcon className="icon" /> Document verification
                                is in process by the Customer Service Lead.
                              </p>
                            </div>
                          </>
                        )
                      ) : dialogRowData.applicationProgressId === 1 &&
                        dialogRowData.objectionStatus === 1 ? (
                        <>
                          <h3 className="step-title">Documents Objection</h3>
                          <Grid
                            className="document-verification-container"
                            container
                            spacing={1}
                          >
                            {(dialogRowData.applicantCNICFront ||
                              dialogRowData.applicantCNICBack) && (
                                <Grid item lg={2}>
                                  <Grid
                                    container
                                    sx={{
                                      backgroundColor: getDocumentBackGroundColor(
                                        flag_applicantCNICFront
                                      ),
                                      borderRadius: "10px",
                                      minHeight: "150px",
                                      height: "auto",
                                    }}
                                  >
                                    <Grid
                                      item
                                      lg={12}
                                      style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        paddingBottom: "5px",
                                      }}
                                    >
                                      <div
                                        onClick={() => {
                                          if (!copyOfApplicantCNICVerifyPopUp) {
                                            setCopyOfApplicantCNICVerifyPopUp(true);
                                          }
                                        }}
                                        style={{
                                          display: "flex",
                                          justifyContent: "space-between",
                                          flexDirection: "column",
                                          alignItems: "center",
                                        }}
                                      >
                                        {dialogRowData.applicantCNICFront &&
                                          dialogRowData.applicantCNICFront.slice(
                                            0,
                                            6
                                          ) === "data:i" ? (
                                          <Base64Image
                                            data={dialogRowData.applicantCNICFront}
                                            width="80"
                                            height="50"
                                          />
                                        ) : dialogRowData.applicantCNICFront ? (
                                          <Base64Image data={pdfIcon} width="40" />
                                        ) : null}
                                        {dialogRowData.applicantCNICBack &&
                                          dialogRowData.applicantCNICBack.slice(
                                            0,
                                            6
                                          ) === "data:i" ? (
                                          <Base64Image
                                            data={dialogRowData.applicantCNICBack}
                                            width="80"
                                            height="50"
                                          />
                                        ) : dialogRowData.applicantCNICBack ? (
                                          <Base64Image data={pdfIcon} width="40" />
                                        ) : null}
                                        {flag_applicantCNICFront === 1 && (
                                          <img
                                            src={tickicon}
                                            width="25px"
                                            height="25px"
                                            alt="Tick Icon"
                                            className="doc-verification-status-icon"
                                          />
                                        )}
                                        {flag_applicantCNICFront === -1 && (
                                          <img
                                            src={crossIcon}
                                            width="25px"
                                            height="25px"
                                            alt="Cross Icon"
                                            className="doc-verification-status-icon"
                                          />
                                        )}
                                        {!isCoaActivityLogDialogOpen && copyOfApplicantCNICVerifyPopUp && (
                                          <OpenBase64ImageInPopup
                                            docVerifyPopUp={
                                              copyOfApplicantCNICVerifyPopUp
                                            }
                                            hideDocVerifyPopup={
                                              hideCopyOfApplicantCNICVerifyAlert
                                            }
                                            documentName="Applicant CNIC"
                                            documentImage={
                                              dialogRowData.applicantCNICFront
                                            }
                                            backDocumentImage={
                                              dialogRowData.applicantCNICBack
                                            }
                                            width={"100%"}
                                            document={
                                              dialogRowData.applicantCNICFront
                                            }
                                            documentFlag={
                                              dialogRowData.applicantCNICFrontFlag
                                            }
                                            applicationProgressId={
                                              dialogRowData.applicationProgressId
                                            }
                                            objectionStatus={
                                              dialogRowData.objectionStatus
                                            }
                                            updateDocFlag={updateDocFlag}
                                            documentRemarks={
                                              applicantCNICBackObjectionRemarks
                                            }
                                            titleToUpdateFlag="copyOfApplicantCNIC"
                                            flag_document={flag_applicantCNICFront}
                                            flag_documentBack={flag_applicantCNICBack}
                                          />
                                        )}
                                      </div>
                                    </Grid>
                                    <Grid item lg={12} className="tittlegrid">
                                      <p className="docTitle">Applicant's CNIC.</p>
                                    </Grid>
                                  </Grid>
                                </Grid>
                              )}
                            {dialogRowData.owenershipDocument && (
                              <Grid item lg={2}>
                                <Grid
                                  container
                                  sx={{
                                    backgroundColor: getDocumentBackGroundColor(
                                      flag_owenershipDocument
                                    ),
                                    borderRadius: "10px",
                                    minHeight: "150px",
                                    height: "auto",
                                  }}
                                >
                                  <Grid
                                    item
                                    lg={12}
                                    style={{
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                    }}
                                  >
                                    <div
                                      onClick={() => {
                                        if (!owenershipDocumentVerifyPopUp) {
                                          setOwenershipDocumentVerifyPopUp(true);
                                        }
                                      }}
                                      style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                      }}
                                    >
                                      {dialogRowData.owenershipDocument.slice(
                                        0,
                                        6
                                      ) === "data:i" ? (
                                        flag_owenershipDocument === 1 ? (
                                          <>
                                            <Base64Image
                                              data={
                                                dialogRowData.owenershipDocument
                                              }
                                              width="80"
                                              height="110"
                                            />
                                            <img
                                              src={tickicon}
                                              width="25px"
                                              height="25px"
                                              alt="Tick Icon"
                                              className="doc-verification-status-icon"
                                            />
                                          </>
                                        ) : flag_owenershipDocument === -1 ? (
                                          <>
                                            <Base64Image
                                              data={
                                                dialogRowData.owenershipDocument
                                              }
                                              width="80"
                                              height="110"
                                            />
                                            <img
                                              src={crossIcon}
                                              width="25px"
                                              height="25px"
                                              alt="Cross Icon"
                                              className="doc-verification-status-icon"
                                            />
                                          </>
                                        ) : (
                                          <Base64Image
                                            data={dialogRowData.owenershipDocument}
                                            width="80"
                                            height="110"
                                          />
                                        )
                                      ) : flag_owenershipDocument === 1 ? (
                                        <>
                                          <Base64Image data={pdfIcon} width="40" />
                                          <img
                                            src={tickicon}
                                            width="25px"
                                            height="25px"
                                            alt="Tick Icon"
                                            className="doc-verification-status-icon"
                                          />
                                        </>
                                      ) : flag_owenershipDocument === -1 ? (
                                        <>
                                          <Base64Image data={pdfIcon} width="40" />
                                          <img
                                            src={crossIcon}
                                            width="25px"
                                            height="25px"
                                            alt="Cross Icon"
                                            className="doc-verification-status-icon"
                                          />
                                        </>
                                      ) : (
                                        <Base64Image data={pdfIcon} width="40" />
                                      )}
                                      {!isCoaActivityLogDialogOpen && owenershipDocumentVerifyPopUp && (
                                        <OpenBase64ImageInPopup
                                          docVerifyPopUp={
                                            owenershipDocumentVerifyPopUp
                                          }
                                          hideDocVerifyPopup={
                                            hidePropertyDocVerifyAlert
                                          }
                                          documentName="Property Document"
                                          documentImage={
                                            dialogRowData.owenershipDocument
                                          }
                                          width={"100%"}
                                          document={
                                            dialogRowData.owenershipDocument
                                          }
                                          documentFlag={
                                            dialogRowData.owenershipDocumentFlag
                                          }
                                          applicationProgressId={
                                            dialogRowData.applicationProgressId
                                          }
                                          objectionStatus={
                                            dialogRowData.objectionStatus
                                          }
                                          updateDocFlag={updateDocFlag}
                                          documentRemarks={
                                            owenershipObjectionRemarks
                                          }
                                          titleToUpdateFlag="owenershipDocument"
                                          flag_document={flag_owenershipDocument}
                                        />
                                      )}
                                    </div>
                                  </Grid>
                                  <Grid item lg={12} className="tittlegrid">
                                    <p className="docTitle">Proof of Ownership</p>
                                  </Grid>
                                </Grid>
                              </Grid>
                            )}
                            {dialogRowData.electricityBillDocument && (
                              <Grid item lg={2}>
                                <Grid
                                  container
                                  sx={{
                                    backgroundColor: getDocumentBackGroundColor(
                                      flag_electricityBillDocument
                                    ),
                                    borderRadius: "10px",
                                    minHeight: "150px",
                                    height: "auto",
                                  }}
                                >
                                  <Grid
                                    item
                                    lg={12}
                                    style={{
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                    }}
                                  >
                                    <div
                                      onClick={() => {
                                        if (!electricityBillDocumentVerifyPopUp) {
                                          setElectricityBillDocumentVerifyPopUp(
                                            true
                                          );
                                        }
                                      }}
                                      style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                      }}
                                    >
                                      {dialogRowData.electricityBillDocument.slice(
                                        0,
                                        6
                                      ) === "data:i" ? (
                                        flag_electricityBillDocument === 1 ? (
                                          <>
                                            <Base64Image
                                              data={
                                                dialogRowData.electricityBillDocument
                                              }
                                              width="80"
                                              height="110"
                                            />
                                            <img
                                              src={tickicon}
                                              width="25px"
                                              height="25px"
                                              alt="Tick Icon"
                                              className="doc-verification-status-icon"
                                            />
                                          </>
                                        ) : flag_electricityBillDocument === -1 ? (
                                          <>
                                            <Base64Image
                                              data={
                                                dialogRowData.electricityBillDocument
                                              }
                                              width="80"
                                              height="110"
                                            />
                                            <img
                                              src={crossIcon}
                                              width="25px"
                                              height="25px"
                                              alt="Cross Icon"
                                              className="doc-verification-status-icon"
                                            />
                                          </>
                                        ) : (
                                          <Base64Image
                                            data={
                                              dialogRowData.electricityBillDocument
                                            }
                                            width="80"
                                            height="110"
                                          />
                                        )
                                      ) : flag_electricityBillDocument === 1 ? (
                                        <>
                                          <Base64Image data={pdfIcon} width="40" />
                                          <img
                                            src={tickicon}
                                            width="25px"
                                            height="25px"
                                            alt="Tick Icon"
                                            className="doc-verification-status-icon"
                                          />
                                        </>
                                      ) : flag_electricityBillDocument === -1 ? (
                                        <>
                                          <Base64Image data={pdfIcon} width="40" />
                                          <img
                                            src={crossIcon}
                                            width="25px"
                                            height="25px"
                                            alt="Cross Icon"
                                            className="doc-verification-status-icon"
                                          />
                                        </>
                                      ) : (
                                        <Base64Image data={pdfIcon} width="40" />
                                      )}
                                      {!isCoaActivityLogDialogOpen && electricityBillDocumentVerifyPopUp && (
                                        <OpenBase64ImageInPopup
                                          docVerifyPopUp={
                                            electricityBillDocumentVerifyPopUp
                                          }
                                          hideDocVerifyPopup={
                                            hideElectricityBillVerifyAlert
                                          }
                                          documentName="Electricity Bill Document"
                                          documentImage={
                                            dialogRowData.electricityBillDocument
                                          }
                                          width={"100%"}
                                          document={
                                            dialogRowData.electricityBillDocument
                                          }
                                          documentFlag={
                                            dialogRowData.electricityBillDocumentFlag
                                          }
                                          applicationProgressId={
                                            dialogRowData.applicationProgressId
                                          }
                                          objectionStatus={
                                            dialogRowData.objectionStatus
                                          }
                                          updateDocFlag={updateDocFlag}
                                          documentRemarks={
                                            electricityBillObjectionRemarks
                                          }
                                          titleToUpdateFlag="electricityBillDocument"
                                          flag_document={
                                            flag_electricityBillDocument
                                          }
                                        />
                                      )}
                                    </div>
                                  </Grid>
                                  <Grid item lg={12} className="tittlegrid">
                                    <p className="docTitle">
                                      Electricity Bill Document
                                    </p>
                                  </Grid>
                                </Grid>
                              </Grid>
                            )}
                            {dialogRowData.fbrDocument && (
                              <Grid item lg={2}>
                                <Grid
                                  container
                                  sx={{
                                    backgroundColor: getDocumentBackGroundColor(
                                      flag_fbrDocument
                                    ),
                                    borderRadius: "10px",
                                    minHeight: "150px",
                                    height: "auto",
                                  }}
                                >
                                  <Grid
                                    item
                                    lg={12}
                                    style={{
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                    }}
                                  >
                                    <div
                                      onClick={() => {
                                        if (!fbrDocumentVerifyPopUp) {
                                          setFbrDocumentVerifyPopUp(true);
                                        }
                                      }}
                                      style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                      }}
                                    >
                                      {dialogRowData.fbrDocument.slice(0, 6) ===
                                        "data:i" ? (
                                        flag_fbrDocument === 1 ? (
                                          <>
                                            <Base64Image
                                              data={dialogRowData.fbrDocument}
                                              width="80"
                                              height="110"
                                            />
                                            <img
                                              src={tickicon}
                                              width="25px"
                                              height="25px"
                                              alt="Tick Icon"
                                              className="doc-verification-status-icon"
                                            />
                                          </>
                                        ) : flag_fbrDocument === -1 ? (
                                          <>
                                            <Base64Image
                                              data={dialogRowData.fbrDocument}
                                              width="80"
                                              height="110"
                                            />
                                            <img
                                              src={crossIcon}
                                              width="25px"
                                              height="25px"
                                              alt="Cross Icon"
                                              className="doc-verification-status-icon"
                                            />
                                          </>
                                        ) : (
                                          <Base64Image
                                            data={dialogRowData.fbrDocument}
                                            width="80"
                                            height="110"
                                          />
                                        )
                                      ) : (
                                        <Base64Image data={pdfIcon} width="40" />
                                      )}
                                      {!isCoaActivityLogDialogOpen && fbrDocumentVerifyPopUp && (
                                        <OpenBase64ImageInPopup
                                          docVerifyPopUp={fbrDocumentVerifyPopUp}
                                          hideDocVerifyPopup={hideFbrDocVerifyAlert}
                                          documentName="FBR Document"
                                          documentImage={dialogRowData.fbrDocument}
                                          width={"100%"}
                                          document={dialogRowData.fbrDocument}
                                          documentFlag={
                                            dialogRowData.fbrDocumentFlag
                                          }
                                          applicationProgressId={
                                            dialogRowData.applicationProgressId
                                          }
                                          objectionStatus={
                                            dialogRowData.objectionStatus
                                          }
                                          updateDocFlag={updateDocFlag}
                                          documentRemarks={
                                            fbrDocumentObjectionRemarks
                                          }
                                          titleToUpdateFlag="fbrDocument"
                                          flag_document={flag_fbrDocument}
                                        />
                                      )}
                                    </div>
                                  </Grid>
                                  <Grid item lg={12} className="tittlegrid">
                                    <p className="docTitle">FBR Document</p>
                                  </Grid>
                                </Grid>
                              </Grid>
                            )}
                            {dialogRowData.addDocAnyOther && (
                              <Grid item lg={2}>
                                <Grid
                                  container
                                  sx={{
                                    backgroundColor: getDocumentBackGroundColor(
                                      flag_addDocAnyOther
                                    ),
                                    borderRadius: "10px",
                                    minHeight: "150px",
                                    height: "auto",
                                  }}
                                >
                                  <Grid
                                    item
                                    lg={12}
                                    style={{
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                    }}
                                  >
                                    <div
                                      onClick={() => {
                                        if (!addDocAnyOtherVerifyPopUp) {
                                          setAddDocAnyOtherVerifyPopUp(true);
                                        }
                                      }}
                                      style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                      }}
                                    >
                                      {dialogRowData.addDocAnyOther.slice(0, 6) ===
                                        "data:i" ? (
                                        flag_addDocAnyOther === 1 ? (
                                          <>
                                            <Base64Image
                                              data={dialogRowData.addDocAnyOther}
                                              width="80"
                                              height="110"
                                            />
                                            <img
                                              src={tickicon}
                                              width="25px"
                                              height="25px"
                                              alt="Tick Icon"
                                              className="doc-verification-status-icon"
                                            />
                                          </>
                                        ) : flag_addDocAnyOther === -1 ? (
                                          <>
                                            <Base64Image
                                              data={dialogRowData.addDocAnyOther}
                                              width="80"
                                              height="110"
                                            />
                                            <img
                                              src={crossIcon}
                                              width="25px"
                                              height="25px"
                                              alt="Cross Icon"
                                              className="doc-verification-status-icon"
                                            />
                                          </>
                                        ) : (
                                          <Base64Image
                                            data={dialogRowData.addDocAnyOther}
                                            width="80"
                                            height="110"
                                          />
                                        )
                                      ) : (
                                        <Base64Image data={pdfIcon} width="40" />
                                      )}
                                      {!isCoaActivityLogDialogOpen && addDocAnyOtherVerifyPopUp && (
                                        <OpenBase64ImageInPopup
                                          docVerifyPopUp={addDocAnyOtherVerifyPopUp}
                                          hideDocVerifyPopup={hideAddAnyOtherVerifyAlert}
                                          documentName="Any Other Document"
                                          documentImage={dialogRowData.addDocAnyOther}
                                          width={"100%"}
                                          document={dialogRowData.addDocAnyOther}
                                          documentFlag={
                                            dialogRowData.anyOtherDocumentFlag
                                          }
                                          applicationProgressId={
                                            dialogRowData.applicationProgressId
                                          }
                                          objectionStatus={
                                            dialogRowData.objectionStatus
                                          }
                                          updateDocFlag={updateDocFlag}
                                          documentRemarks={
                                            addDocAnyOtherObjectionRemarks
                                          }
                                          titleToUpdateFlag="addDocAnyOther"
                                          flag_document={flag_addDocAnyOther}
                                        />
                                      )}
                                    </div>
                                  </Grid>
                                  <Grid item lg={12} className="tittlegrid">
                                    <p className="docTitle">Any Other Document</p>
                                  </Grid>
                                </Grid>
                              </Grid>
                            )}
                            {/* {
                                dialogRowData.fbrDocument &&
                                <Grid item lg={2}>
                                  <Grid container sx={{ backgroundColor: dialogRowData.fbrDocumentFlag ? getDocumentBackGroundColor(dialogRowData.fbrDocumentFlag) : getDocumentBackGroundColor(flag_fbrDocument), borderRadius: "10px", minHeight: "150px", height: 'auto' }}>
                                    <Grid item lg={12} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', }}>
                                      <div onClick={() => { if (!fbrDocumentVerifyPopUp) { setFbrDocumentVerifyPopUp(true) } }} style={{ display: 'flex', justifyContent: 'space-between' }} >
                                        {
                                          dialogRowData.fbrDocument.slice(0, 6) === 'data:i' ? (
                                            flag_fbrDocument === 1 ? (
                                              <>
                                                <Base64Image data={dialogRowData.fbrDocument} width='80' height='110' />
                                                <img
                                                  src={tickicon}
                                                  width='25px'
                                                  height='25px'
                                                  alt="Tick Icon"
                                                  className="doc-verification-status-icon"
                                                />
                                              </>
                                            ) : flag_fbrDocument === -1 ? (
                                              <>
                                                <Base64Image data={dialogRowData.fbrDocument} width='80' height='110' />
                                                <img
                                                  src={crossIcon}
                                                  width='25px'
                                                  height='25px'
                                                  alt="Cross Icon"
                                                  className="doc-verification-status-icon"
                                                />
                                              </>
                                            ) : (
                                              <Base64Image data={dialogRowData.fbrDocument} width='80' height='110' />
                                            )
                                          ) : (
                                            <Base64Image data={pdfIcon} width='40' />
                                          )
                                        }
                                        {
                                          fbrDocumentVerifyPopUp &&
                                          <OpenBase64ImageInPopup
                                            docVerifyPopUp={fbrDocumentVerifyPopUp}
                                            hideDocVerifyPopup={hideFbrDocumentVerifyAlert}
                                            documentName="FBR Document"
                                            documentImage={dialogRowData.fbrDocument}
                                            width={'100%'}
                                            document={dialogRowData.fbrDocument}
                                            documentFlag={dialogRowData.fbrDocumentFlag}
                                            applicationProgressId={dialogRowData.applicationProgressId}
                                            objectionStatus={dialogRowData.objectionStatus}
                                            updateDocFlag={updateDocFlag}
                                            documentRemarks={fbrDocumentObjectionRemarks}
                                            titleToUpdateFlag="fbrDocument"
                                            flag_document={flag_fbrDocument}
                                          />
                                        }
                                      </div>
                                    </Grid>
                                    <Grid item lg={12} className="tittlegrid" >
                                      <p className='docTitle'>FBR Document</p>
                                    </Grid>
                                  </Grid>
                                </Grid>
                              } */}
                          </Grid>
                        </>
                      ) : dialogRowData.applicationProgressId === 2 &&
                        (dialogRowData.objectionStatus != 1 ||
                          dialogRowData.objectionStatus == 2) ? (
                        <>
                          <h3 className="step-title">
                            {dialogRowData.wiringTestReportDocument
                              ? "Wiring Test Report Verification"
                              : "Wiring Test Report Upload"}
                          </h3>
                          <Grid container spacing={2} className="documents-container">
                            {wiringTestReportLoading ? (
                              <Grid item lg={12} sx={{ display: "flex", justifyContent: "center", py: 3 }}>
                                <AppLoader size={32} />
                              </Grid>
                            ) : dialogRowData.wiringTestReportDocument ? (
                              CheckPermissions(
                                permissions,
                                "General Services",
                                "Change of Attributes",
                                "Workflow Permissions",
                                "Wiring Test Report"
                              ) ? (
                                <Grid item lg={2}>
                                  <Grid
                                    container
                                    className={getCoaDocVerificationCardClass(
                                      getCoaWiringTestReportDisplayFlag()
                                    )}
                                    sx={{
                                      backgroundColor: getDocumentBackGroundColor(
                                        getCoaWiringTestReportDisplayFlag()
                                      ),
                                      borderRadius: "10px",
                                      minHeight: "150px",
                                      height: "auto",
                                      margin: "20px",
                                    }}
                                  >
                                    <Grid item lg={12} className="tittlegrid">
                                      <p className="docTitle" style={{ textAlign: "center" }}>
                                        Wiring Test Report
                                      </p>
                                    </Grid>
                                    <Grid
                                      item
                                      lg={12}
                                      style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        paddingBottom: "5px",
                                      }}
                                    >
                                      <div
                                        onClick={() => {
                                          if (!wiringTestReportVerifyPopUp) {
                                            setWiringTestReportVerifyPopUp(true);
                                          }
                                        }}
                                        style={{
                                          display: "flex",
                                          justifyContent: "center",
                                          alignItems: "center",
                                          position: "relative",
                                          width: "100%",
                                          minHeight: "72px",
                                        }}
                                      >
                                        {dialogRowData.wiringTestReportDocument.slice(
                                          0,
                                          6
                                        ) === "data:i" ? (
                                          <Base64Image
                                            data={dialogRowData.wiringTestReportDocument}
                                            width="80"
                                          />
                                        ) : (
                                          <Base64Image data={pdfIcon} width="40" />
                                        )}
                                        {Number(resolveCoaWiringTestReportFlag()) === 1 && (
                                          <img
                                            src={tickicon}
                                            width="25px"
                                            height="25px"
                                            alt="Tick Icon"
                                            className="doc-verification-status-icon"
                                          />
                                        )}
                                        {Number(resolveCoaWiringTestReportFlag()) === -1 && (
                                          <img
                                            src={crossIcon}
                                            width="25px"
                                            height="25px"
                                            alt="Cross Icon"
                                            className="doc-verification-status-icon"
                                          />
                                        )}
                                        {!isCoaActivityLogDialogOpen && wiringTestReportVerifyPopUp && (
                                          <OpenBase64ImageInPopup
                                            docVerifyPopUp={wiringTestReportVerifyPopUp}
                                            hideDocVerifyPopup={
                                              hideWiringTestReportVerifyAlert
                                            }
                                            documentName="Wiring Test Report"
                                            documentImage={
                                              dialogRowData.wiringTestReportDocument
                                            }
                                            width={"100%"}
                                            document={
                                              dialogRowData.wiringTestReportDocument
                                            }
                                            documentFlag={
                                              dialogRowData.wiringTestReportDocumentFlag
                                            }
                                            applicationProgressId={
                                              dialogRowData.applicationProgressId
                                            }
                                            objectionStatus={
                                              dialogRowData.objectionStatus
                                            }
                                            updateDocFlag={updateDocFlag}
                                            documentRemarks={getCoaWiringTestReportDocumentRemarks()}
                                            titleToUpdateFlag="wiringTestReport"
                                            flag_document={flag_wiringTestReport}
                                            verificationPermissionService="Change of Attributes"
                                          />
                                        )}
                                      </div>
                                    </Grid>
                                  </Grid>
                                </Grid>
                              ) : (
                                <div className="description-box description-box--error">
                                  <p className="group-description">
                                    <InfoIcon className="icon" />
                                    Wiring Test Report is in process by sanctioning
                                    authority.
                                  </p>
                                </div>
                              )
                            ) : CheckPermissions(
                              permissions,
                              "General Services",
                              "Change of Attributes",
                              "Basic Permissions",
                              "Update"
                            ) ? (
                              <Grid item lg={12} sx={{ display: "flex", justifyContent: "center", padding: "20px" }}>
                                <Box
                                  sx={{
                                    width: "100%",
                                    maxWidth: "400px",
                                    backgroundColor: "#ffffff",
                                    borderRadius: "12px",
                                    boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                                    padding: "24px",
                                    textAlign: "center",
                                  }}
                                >
                                  {newWiringTestReportDocumentThumbnail ? (
                                    <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "16px" }}>
                                      <Box
                                        sx={{
                                          position: "relative",
                                          padding: "16px",
                                          backgroundColor: "#f8fafc",
                                          borderRadius: "8px",
                                          border: "2px solid #e2e8f0",
                                        }}
                                      >
                                        {newWiringTestReportDocumentThumbnail.slice(0, 10) === "data:image" ? (
                                          <img
                                            src={newWiringTestReportDocumentThumbnail}
                                            alt="Wiring Test Report"
                                            style={{ maxWidth: "120px", maxHeight: "120px", borderRadius: "4px" }}
                                          />
                                        ) : (
                                          <img src={pdfIcon} alt="PDF" width="60" />
                                        )}
                                        <Box
                                          onClick={() => {
                                            setNewWiringTestReportDocument("");
                                            setNewWiringTestReportDocumentThumbnail("");
                                            setNewWiringTestReportDocumentError("");
                                          }}
                                          sx={{
                                            position: "absolute",
                                            top: "-8px",
                                            right: "-8px",
                                            width: "24px",
                                            height: "24px",
                                            backgroundColor: "#ef4444",
                                            borderRadius: "50%",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            cursor: "pointer",
                                          }}
                                        >
                                          <CloseIcon sx={{ fontSize: "16px", color: "#fff" }} />
                                        </Box>
                                      </Box>
                                      <Typography sx={{ color: "#22c55e", fontWeight: "500", fontSize: "14px" }}>
                                        File uploaded successfully
                                      </Typography>
                                    </Box>
                                  ) : (
                                    <Box
                                      component="label"
                                      sx={{
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        padding: "32px 24px",
                                        border: "2px dashed #cbd5e1",
                                        borderRadius: "12px",
                                        backgroundColor: "#f8fafc",
                                        marginTop: "10px",
                                        cursor: "pointer",
                                      }}
                                    >
                                      <FileUploadOutlinedIcon sx={{ fontSize: "28px", color: "#003971", marginBottom: "16px" }} />
                                      <Typography sx={{ fontSize: "16px", fontWeight: "600", color: "#1e293b", marginBottom: "4px" }}>
                                        Click to upload
                                      </Typography>
                                      <Typography sx={{ fontSize: "13px", color: "#64748b" }}>
                                        JPG, PNG or PDF (Max 2MB)
                                      </Typography>
                                      <input
                                        hidden
                                        accept=".jpg,.jpeg,.png,.pdf"
                                        type="file"
                                        onChange={NewWiringTestReportDocument}
                                      />
                                    </Box>
                                  )}
                                  {newWiringTestReportDocumentError && (
                                    <Box sx={{ color: "#ef4444", marginTop: "12px", fontSize: "13px", fontWeight: "600" }}>
                                      {newWiringTestReportDocumentError}
                                    </Box>
                                  )}
                                </Box>
                              </Grid>
                            ) : (
                              <div className="description-box description-box--error">
                                <p className="group-description">
                                  <InfoIcon className="icon" />
                                  {dialogRowData.wiringTestReportDocument
                                    ? "Wiring Test Report is in process by sanctioning authority."
                                    : "Wiring Test Report Upload is in process by CSR."}
                                </p>
                              </div>
                            )}
                          </Grid>
                        </>
                      ) : dialogRowData.applicationProgressId === 2 &&
                        dialogRowData.objectionStatus == 1 ? (
                        <>
                          <h3 className="step-title">Wiring Test Report Objection</h3>
                          <Grid container spacing={2} className="documents-container">
                            {wiringTestReportLoading ? (
                              <Grid item lg={12} sx={{ display: "flex", justifyContent: "center", py: 3 }}>
                                <AppLoader size={32} />
                              </Grid>
                            ) : CheckPermissions(
                              permissions,
                              "General Services",
                              "Change of Attributes",
                              "Basic Permissions",
                              "Update"
                            ) ? (
                              (() => {
                                const objectionWiringFlag = getCoaWiringTestObjectionCardFlag();
                                const isObjectionRejectedDefault =
                                  !newWiringTestReportDocumentThumbnail;
                                const objectionTitleColor =
                                  objectionWiringFlag === 1
                                    ? "#155724"
                                    : objectionWiringFlag === -1
                                      ? "#721c24"
                                      : "#5c6b7d";

                                return (
                                  <Grid item lg={2}>
                                    <Grid
                                      container
                                      className={
                                        isObjectionRejectedDefault
                                          ? "doc-verification-card"
                                          : getCoaDocVerificationCardClass(objectionWiringFlag)
                                      }
                                      sx={{
                                        backgroundColor: getDocumentBackGroundColor(
                                          objectionWiringFlag
                                        ),
                                        borderRadius: "10px",
                                        minHeight: "150px",
                                        height: "auto",
                                        margin: "20px",
                                      }}
                                    >
                                      <Grid item lg={12} className="tittlegrid">
                                        <p className="docTitle" style={{ textAlign: "center", color: objectionTitleColor }}>
                                          {newWiringTestReportDocumentThumbnail ? "Wiring Test Report (New)" : "Wiring Test Report (Rejected)"}
                                        </p>
                                      </Grid>
                                      <Grid
                                        item
                                        lg={12}
                                        style={{
                                          display: "flex",
                                          justifyContent: "center",
                                          alignItems: "center",
                                          paddingBottom: "5px",
                                        }}
                                      >
                                        {newWiringTestReportDocumentThumbnail ? (
                                          <div
                                            style={{
                                              position: "relative",
                                              display: "flex",
                                              justifyContent: "center",
                                              alignItems: "center",
                                              width: "100%",
                                              minHeight: "72px",
                                            }}
                                          >
                                            <div
                                              onClick={() => {
                                                if (!wiringTestReportVerifyPopUp) {
                                                  setWiringTestReportVerifyPopUp(true);
                                                }
                                              }}
                                              style={{
                                                cursor: "pointer",
                                                position: "relative",
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                width: "100%",
                                                minHeight: "72px",
                                              }}
                                            >
                                              {newWiringTestReportDocumentThumbnail.slice(0, 10) === "data:image" ? (
                                                <img
                                                  src={newWiringTestReportDocumentThumbnail}
                                                  alt="New Wiring Test Report"
                                                  width="80"
                                                />
                                              ) : (
                                                <img src={pdfIcon} alt="PDF" width="40" />
                                              )}
                                              {shouldShowCoaWiringTestObjectionStatusIcon() &&
                                                flag_wiringTestReport === 1 && (
                                                  <img
                                                    src={tickicon}
                                                    width="25px"
                                                    height="25px"
                                                    alt="Tick Icon"
                                                    className="doc-verification-status-icon"
                                                  />
                                                )}
                                              {shouldShowCoaWiringTestObjectionStatusIcon() &&
                                                flag_wiringTestReport === -1 && (
                                                  <img
                                                    src={crossIcon}
                                                    width="25px"
                                                    height="25px"
                                                    alt="Cross Icon"
                                                    className="doc-verification-status-icon"
                                                  />
                                                )}
                                            </div>
                                            <button
                                              type="button"
                                              className="coa-wiring-test-upload-preview__remove"
                                              onClick={(event) => {
                                                event.stopPropagation();
                                                setNewWiringTestReportDocument("");
                                                setNewWiringTestReportDocumentThumbnail("");
                                                setNewWiringTestReportDocumentError("");
                                                setFlag_wiringTestReport(null);
                                              }}
                                              aria-label="Remove uploaded file"
                                            >
                                              <CloseIcon sx={{ fontSize: "14px", color: "#fff" }} />
                                            </button>
                                            {!isCoaActivityLogDialogOpen && wiringTestReportVerifyPopUp && (
                                              <OpenBase64ImageInPopup
                                                docVerifyPopUp={wiringTestReportVerifyPopUp}
                                                hideDocVerifyPopup={hideWiringTestReportVerifyAlert}
                                                documentName="Wiring Test Report"
                                                documentImage={newWiringTestReportDocumentThumbnail}
                                                width={"100%"}
                                                document={newWiringTestReportDocumentThumbnail}
                                                documentFlag={null}
                                                applicationProgressId={dialogRowData.applicationProgressId}
                                                objectionStatus={dialogRowData.objectionStatus}
                                                updateDocFlag={updateDocFlag}
                                                documentRemarks=""
                                                titleToUpdateFlag="wiringTestReport"
                                                flag_document={null}
                                                verificationPermissionService="Change of Attributes"
                                                readOnly
                                              />
                                            )}
                                          </div>
                                        ) : (
                                          <div
                                            style={{
                                              display: "flex",
                                              flexDirection: "column",
                                              alignItems: "center",
                                              width: "100%",
                                            }}
                                          >
                                            <div
                                              className="coa-wiring-objection-rejected-preview"
                                              onClick={() => {
                                                if (!wiringTestReportVerifyPopUp) {
                                                  setWiringTestReportVerifyPopUp(true);
                                                }
                                              }}
                                            >
                                              {dialogRowData.wiringTestReportDocument?.slice(0, 6) === "data:i" ? (
                                                <Base64Image
                                                  data={dialogRowData.wiringTestReportDocument}
                                                  width="80"
                                                />
                                              ) : (
                                                <Base64Image data={pdfIcon} width="40" />
                                              )}
                                            </div>
                                            {!isCoaActivityLogDialogOpen && wiringTestReportVerifyPopUp && (
                                              <OpenBase64ImageInPopup
                                                docVerifyPopUp={wiringTestReportVerifyPopUp}
                                                hideDocVerifyPopup={hideWiringTestReportVerifyAlert}
                                                documentName="Wiring Test Report"
                                                documentImage={dialogRowData.wiringTestReportDocument}
                                                width={"100%"}
                                                document={dialogRowData.wiringTestReportDocument}
                                                documentFlag={dialogRowData.wiringTestReportDocumentFlag}
                                                applicationProgressId={dialogRowData.applicationProgressId}
                                                objectionStatus={dialogRowData.objectionStatus}
                                                updateDocFlag={updateDocFlag}
                                                documentRemarks={getCoaWiringTestReportDocumentRemarks()}
                                                titleToUpdateFlag="wiringTestReport"
                                                flag_document={flag_wiringTestReport}
                                                verificationPermissionService="Change of Attributes"
                                                readOnly
                                              />
                                            )}
                                            <Button
                                              variant="outlined"
                                              component="label"
                                              className="coa-wiring-objection-reupload-btn"
                                              startIcon={<FileUploadOutlinedIcon />}
                                              sx={{ textTransform: "none", fontSize: "10px", marginTop: "8px" }}
                                              size="small"
                                            >
                                              Reupload
                                              <input
                                                hidden
                                                accept=".jpg,.jpeg,.png,.pdf"
                                                type="file"
                                                onChange={NewWiringTestReportDocument}
                                              />
                                            </Button>
                                            {newWiringTestReportDocumentError ? (
                                              <Box
                                                sx={{
                                                  color: "#ef4444",
                                                  marginTop: "8px",
                                                  fontSize: "12px",
                                                  fontWeight: 600,
                                                  textAlign: "center",
                                                  px: 1,
                                                }}
                                              >
                                                {newWiringTestReportDocumentError}
                                              </Box>
                                            ) : (
                                              <Typography
                                                sx={{
                                                  fontSize: "10px",
                                                  color: "#64748b",
                                                  marginTop: "6px",
                                                  textAlign: "center",
                                                }}
                                              >
                                                JPG, PNG or PDF (Max 2MB)
                                              </Typography>
                                            )}
                                          </div>
                                        )}
                                      </Grid>
                                    </Grid>
                                  </Grid>
                                );
                              })()
                            ) : (
                              <>
                                <div className="description-box description-box--error">
                                  <p className="group-description">
                                    <InfoIcon className="icon" />
                                    <span style={{ color: "#b91c1c", fontWeight: 600 }}>
                                      The Wiring Test Report has been rejected by the
                                      Electric Inspector due to{" "}
                                      {dialogRowData.wiringTestReportDocumentObjectionRemarks ||
                                        dialogRowData.wiringTestReportDocumentRemarks ||
                                        wiringTestReportObjectionRemarks}{" "}
                                      indicating a fake wiring report.
                                    </span>
                                  </p>
                                </div>
                                <div className="description-box description-box--error">
                                  <p className="group-description">
                                    <InfoIcon className="icon" />
                                    CFC staff is required to re-upload a valid Wiring Test Report for further processing.
                                  </p>
                                </div>
                              </>
                            )}
                          </Grid>
                        </>
                      ) : dialogRowData.applicationProgressId === 3 &&
                        (dialogRowData.objectionStatus === 0 ||
                          dialogRowData.objectionStatus === 2) ? (
                        <>
                          <Grid
                            container
                            className="step-title step-title--with-action"
                          >
                            <h4>Arrear Verification</h4>
                            {paymentStatus === "Arrear exists" && (
                              <Box className="step-title__actions">
                                <Button
                                  className="rco-bill-btn"
                                  variant="outlined"
                                  onClick={() =>
                                    downloadBill(dialogRowData.referenceNumber)
                                  }
                                >
                                  <PrintIcon /> Bill
                                </Button>
                              </Box>
                            )}
                          </Grid>
                          {CheckPermissions(
                            permissions,
                            "General Services",
                            "Change of Attributes",
                            "Workflow Permissions",
                            "Arrears Verification"
                          ) &&
                            matchesCoaApprovalCategory(permissions, dialogRowData, allTariffList) ? (
                            <>
                              <Grid
                                container
                                className="field-survey-container"
                                spacing={3}
                              >
                                {!paymentStatus && (
                                  <>
                                    <Grid
                                      item
                                      lg={12}
                                      sx={{
                                        display: "flex",
                                        justifyContent: "center",
                                        marginTop: "20px",
                                      }}
                                    >
                                      <button
                                        onClick={() =>
                                          referenceApi(
                                            dialogRowData.referenceNumber
                                          )
                                        }
                                        style={{
                                          backgroundColor: "#003971",
                                          color: "white",
                                          border: "none",
                                          borderRadius: "20px",
                                          padding: "10px 40px",
                                          fontSize: "16px",
                                          cursor: "pointer",
                                        }}
                                        className="view-button"
                                      >
                                        Check Arrears
                                      </button>
                                    </Grid>
                                    <Grid item lg={12}>
                                      <Box className="coa-arrear-check-images">
                                        <img
                                          src={frontImg}
                                          alt="Cnic Front"
                                          className="coa-arrear-check-images__img"
                                        />
                                        <img
                                          src={backImg}
                                          alt="Cnic Back"
                                          className="coa-arrear-check-images__img"
                                        />
                                      </Box>
                                    </Grid>
                                  </>
                                )}

                                {paymentStatus && (
                                  <Grid
                                    item
                                    lg={12}
                                    sx={{ textAlign: "center", marginTop: "20px" }}
                                  >
                                    <Typography
                                      sx={{
                                        fontWeight: "bold",
                                        color:
                                          paymentStatus === "No arrear exists"
                                            ? "green"
                                            : "red",
                                        fontSize: "28px",
                                      }}
                                    >
                                      {paymentStatus}
                                    </Typography>
                                  </Grid>
                                )}
                              </Grid>
                              {paymentStatus === "Arrear exists" && (
                                <>
                                  <Grid
                                    container
                                    className="dn-payment-submission-container rco-arrear-top-row"
                                  >
                                    <Grid item lg={4} className="item">
                                      <Typography className="title">
                                        Arrear Amount
                                      </Typography>
                                      <Typography className="value">
                                        {arrearAmount
                                          ? numberFormatting(arrearAmount)
                                          : "-"}
                                      </Typography>
                                    </Grid>
                                    <Grid item lg={4} className="item">
                                      <Typography className="title">
                                        Bill Month
                                      </Typography>
                                      <Typography className="value">
                                        {billMonth ? convertDate(billMonth) : "-"}
                                      </Typography>
                                    </Grid>
                                    <Grid item lg={4} className="item">
                                      <Typography className="title">
                                        Paid Bill Receipt
                                      </Typography>

                                      {arrearPaymentReceiptFormik.values
                                        .iv_arrear_paid_bill_document ? (
                                        <Button
                                          variant="outlined"
                                          component="label"
                                          className="rco-arrear-upload-btn"
                                          startIcon={
                                            <CloseIcon
                                              sx={{ color: "red" }}
                                              onClick={() =>
                                                arrearPaymentReceiptFormik.setFieldValue(
                                                  "iv_arrear_paid_bill_document",
                                                  ""
                                                )
                                              }
                                            />
                                          }
                                        >
                                          <img
                                            src={URL.createObjectURL(
                                              arrearPaymentReceiptFormik.values
                                                .iv_arrear_paid_bill_document
                                            )}
                                            alt="Receipt Preview"
                                            width="80"
                                          />
                                        </Button>
                                      ) : (
                                        <Button
                                          variant="outlined"
                                          component="label"
                                          startIcon={<FileUploadOutlinedIcon />}
                                          className="rco-arrear-upload-btn"
                                        >
                                          Upload
                                          <input
                                            hidden
                                            accept={documentExtensions}
                                            id="iv_arrear_paid_bill_document"
                                            name="iv_arrear_paid_bill_document"
                                            type="file"
                                            onChange={(event) => {
                                              const file =
                                                event.currentTarget.files[0];
                                              arrearPaymentReceiptFormik.setFieldValue(
                                                "iv_arrear_paid_bill_document",
                                                file
                                              );

                                              const reader = new FileReader();
                                              reader.readAsDataURL(file);
                                              reader.onload = () => {
                                                const base64Image = reader.result;
                                                setArrearPaidReceiptImageThumbnail(
                                                  base64Image
                                                );
                                              };
                                            }}
                                          />
                                        </Button>
                                      )}

                                      <Box className="form-error">
                                        {arrearPaymentReceiptFormik.touched
                                          .iv_arrear_paid_bill_document &&
                                          arrearPaymentReceiptFormik.errors
                                            .iv_arrear_paid_bill_document
                                          ? arrearPaymentReceiptFormik.errors
                                            .iv_arrear_paid_bill_document
                                          : null}
                                      </Box>
                                    </Grid>
                                  </Grid>
                                </>
                              )}
                              {paymentStatus === "No arrear exists" && (
                                <>
                                  <Grid container spacing={2} sx={{}}>
                                    <Grid container item spacing={2}>
                                      <Grid
                                        container
                                        spacing={2}
                                        alignItems="flex-start"
                                        justifyContent="space-between"
                                        marginLeft={10}
                                        marginRight={10}
                                        marginTop={2}
                                      >
                                        <Grid
                                          item
                                          lg={6}
                                          md={6}
                                          sm={12}
                                          className="item"
                                        >
                                          <Typography className="title">
                                            CNIC Front
                                          </Typography>
                                          <Grid
                                            container
                                            sx={{
                                              backgroundColor:
                                                getDocumentBackGroundColor(0),
                                              borderRadius: "10px",
                                              height: "250px",
                                              width: "100%",
                                            }}
                                            className="docContainer"
                                          >
                                            <img
                                              src={
                                                frontImg ||
                                                (isPdfDataUrl(
                                                  dialogRowData.applicantCNICFront
                                                )
                                                  ? undefined
                                                  : dialogRowData.applicantCNICFront)
                                              }
                                              alt="Cnic Front"
                                              style={{
                                                width: "100%",
                                                height: "100%",
                                                borderRadius: "10px",
                                                objectFit: "contain",
                                              }}
                                            />
                                          </Grid>
                                        </Grid>

                                        <Grid
                                          item
                                          lg={6}
                                          md={6}
                                          sm={12}
                                          className="item"
                                        >
                                          <Typography className="title">
                                            CNIC Back
                                          </Typography>
                                          <Grid
                                            container
                                            sx={{
                                              backgroundColor:
                                                getDocumentBackGroundColor(0),
                                              borderRadius: "10px",
                                              height: "250px",
                                              width: "100%",
                                            }}
                                            className="docContainer"
                                          >
                                            <img
                                              src={
                                                backImg ||
                                                (isPdfDataUrl(
                                                  dialogRowData.applicantCNICBack
                                                )
                                                  ? undefined
                                                  : dialogRowData.applicantCNICBack)
                                              }
                                              alt="Cnic Back"
                                              style={{
                                                width: "100%",
                                                height: "100%",
                                                borderRadius: "10px",
                                                objectFit: "contain",
                                              }}
                                            />
                                          </Grid>
                                        </Grid>
                                      </Grid>
                                    </Grid>
                                  </Grid>
                                </>
                              )}
                            </>
                          ) : (
                            <div className="description-box description-box--error">
                              <p className="group-description">
                                <InfoIcon className="icon" />
                                Arrears Verification is in process by sanctioning
                                authority.{" "}
                              </p>
                            </div>
                          )}
                        </>
                      ) : dialogRowData.applicationProgressId === 3 &&
                        dialogRowData.objectionStatus === 1 ? (
                        <>
                          <Grid
                            container
                            className="step-title step-title--with-action"
                          >
                            <h4>Arrear Verification</h4>
                            <Box className="step-title__actions">
                              <Button
                                className="rco-bill-btn"
                                variant="outlined"
                                onClick={() =>
                                  downloadBill(dialogRowData.referenceNumber)
                                }
                              >
                                <PrintIcon /> Bill
                              </Button>
                            </Box>
                          </Grid>

                          <Grid
                            container
                            className="dn-payment-submission-container rco-arrear-top-row"
                          >
                            <Grid item lg={4} className="item">
                              <Typography className="title">
                                Arrear Amount
                              </Typography>
                              <Typography className="value">
                                {arrearAmount
                                  ? numberFormatting(arrearAmount)
                                  : "-"}
                              </Typography>
                            </Grid>
                            <Grid item lg={4} className="item">
                              <Typography className="title">Bill Month</Typography>
                              <Typography className="value">
                                {billMonth ? convertDate(billMonth) : "-"}
                              </Typography>
                            </Grid>
                            <Grid item lg={4} className="item">
                              <Typography className="title">
                                Paid Bill Receipt
                              </Typography>

                              {arrearPaymentReceiptFormik.values
                                .iv_arrear_paid_bill_document ? (
                                <Button
                                  variant="outlined"
                                  component="label"
                                  className="rco-arrear-upload-btn"
                                  startIcon={
                                    <CloseIcon
                                      sx={{ color: "red" }}
                                      onClick={() =>
                                        arrearPaymentReceiptFormik.setFieldValue(
                                          "iv_arrear_paid_bill_document",
                                          ""
                                        )
                                      }
                                    />
                                  }
                                >
                                  <img
                                    src={URL.createObjectURL(
                                      arrearPaymentReceiptFormik.values
                                        .iv_arrear_paid_bill_document
                                    )}
                                    alt="Receipt Preview"
                                    width="80"
                                  />
                                </Button>
                              ) : (
                                <Button
                                  variant="outlined"
                                  component="label"
                                  startIcon={<FileUploadOutlinedIcon />}
                                  className="rco-arrear-upload-btn"
                                >
                                  Upload
                                  <input
                                    hidden
                                    accept={documentExtensions}
                                    id="iv_arrear_paid_bill_document"
                                    name="iv_arrear_paid_bill_document"
                                    type="file"
                                    onChange={(event) => {
                                      const file = event.currentTarget.files[0];
                                      arrearPaymentReceiptFormik.setFieldValue(
                                        "iv_arrear_paid_bill_document",
                                        file
                                      );

                                      const reader = new FileReader();
                                      reader.readAsDataURL(file);
                                      reader.onload = () => {
                                        const base64Image = reader.result;
                                        setArrearPaidReceiptImageThumbnail(
                                          base64Image
                                        );
                                      };
                                    }}
                                  />
                                </Button>
                              )}

                              <Box className="form-error">
                                {arrearPaymentReceiptFormik.touched
                                  .iv_arrear_paid_bill_document &&
                                  arrearPaymentReceiptFormik.errors
                                    .iv_arrear_paid_bill_document
                                  ? arrearPaymentReceiptFormik.errors
                                    .iv_arrear_paid_bill_document
                                  : null}
                              </Box>
                            </Grid>
                          </Grid>
                        </>
                      ) : dialogRowData.applicationProgressId === 4 &&
                        (dialogRowData.objectionStatus === 0 ||
                          dialogRowData.objectionStatus === 2) ? (
                        <>
                          <h3 className="step-title">Field Survey</h3>
                          {CheckPermissions(
                            permissions,
                            "General Services",
                            "Change of Attributes",
                            "Workflow Permissions",
                            "Field Survey"
                          ) &&
                            matchesCoaApprovalCategory(permissions, dialogRowData, allTariffList) ? (
                            <>
                              <Grid
                                container
                                spacing={0.5}
                                className="field-survey-container coa-field-survey-container"
                              >
                                {dialogRowData.changeOfAttributesType == 1 ? (
                                  <>
                                    <Grid item className="coa-field-survey-cell">
                                      <Typography className="fieldLabel">
                                        Area Type
                                      </Typography>

                                      <FormControl className="form-control" fullWidth>
                                        <RadioGroup
                                          className="radio-group"
                                          name="iv_area_type"
                                          value={
                                            fieldFormik.values.iv_area_type === "U"
                                              ? "Urban"
                                              : fieldFormik.values.iv_area_type ===
                                                "R"
                                                ? "Rural"
                                                : ""
                                          }
                                          onChange={(e) => {
                                            const selectedValue =
                                              e.target.value === "Urban"
                                                ? "U"
                                                : "R";
                                            fieldFormik.setFieldValue(
                                              "iv_area_type",
                                              selectedValue
                                            );
                                          }}
                                          onBlur={fieldFormik.handleBlur}
                                          row
                                        >
                                          <FormControlLabel
                                            value="Urban"
                                            control={<Radio size="small" />}
                                            label="Urban"
                                          />
                                          <FormControlLabel
                                            value="Rural"
                                            control={<Radio size="small" />}
                                            label="Rural"
                                          />
                                        </RadioGroup>
                                      </FormControl>

                                      <Box className="from-Error-load">
                                        {fieldFormik.errors.iv_area_type &&
                                          fieldFormik.touched.iv_area_type
                                          ? fieldFormik.errors.iv_area_type
                                          : null}
                                      </Box>
                                    </Grid>

                                    {/* <Grid item lg={3} sx={{ marginTop: '2%', textAlign: 'center' }}>
                                          <Typography className="fieldLabel">Batch Change Required</Typography>

                                          <FormControl>
                                            <RadioGroup
                                              name="iv_batch_change"
                                              value={
                                                fieldFormik.values.iv_batch_change === true
                                                  ? 'true'
                                                  : fieldFormik.values.iv_batch_change === false
                                                    ? 'false'
                                                    : ''
                                              }
                                              onChange={(e) => {
                                                const isBatchChange = e.target.value === 'true';
                                                fieldFormik.setFieldValue('iv_batch_change', isBatchChange);

                                                if (!isBatchChange) {
                                                  fieldFormik.setFieldValue('iv_batch', '');
                                                  fieldFormik.setFieldValue('iv_sub_batch', '');
                                                  fieldFormik.setFieldValue('iv_reference_to_allot', '');
                                                }
                                              }}
                                              onBlur={fieldFormik.handleBlur}
                                              row
                                            >
                                              <Box sx={{ display: 'flex', flexDirection: 'row' }}>
                                                <FormControlLabel
                                                  value="true"
                                                  control={<Radio />}
                                                  label="Yes"
                                                  sx={{
                                                    backgroundColor: 'white',
                                                    padding: '0px 10px',
                                                    borderRadius: '5px',
                                                    marginLeft: '0px',
                                                    marginRight: '10px',
                                                    border: '1px solid lightgrey',
                                                    marginTop: '2%',
                                                  }}
                                                />
                                                <FormControlLabel
                                                  value="false"
                                                  control={<Radio />}
                                                  label="No"
                                                  sx={{
                                                    backgroundColor: 'white',
                                                    padding: '0px 10px',
                                                    borderRadius: '5px',
                                                    border: '1px solid lightgrey',
                                                    textAlign: 'right',
                                                    marginLeft: '2%',
                                                    marginTop: '2%',
                                                  }}
                                                />
                                              </Box>
                                            </RadioGroup>
                                          </FormControl>

                                          <Box className="from-Error-load">
                                            {fieldFormik.errors.iv_batch_change && fieldFormik.touched.iv_batch_change
                                              ? fieldFormik.errors.iv_batch_change
                                              : null}
                                          </Box>
                                        </Grid>

                                        {
                                          fieldFormik.values.iv_batch_change === true &&
                                          <>
                                            <Grid item lg={4} sx={{ marginTop: '2%', textAlign: 'center' }}>
                                              <Typography className='fieldLabel'>Allot Reference No.</Typography>
                                              <Grid container spacing={1} display='flex'>
                                                <Grid item lg={4.5}>
                                                  <Select
                                                    sx={{ width: '100%' }}
                                                    value={fieldFormik.values.iv_batch}
                                                    onChange={fieldFormik.handleChange}
                                                    onBlur={fieldFormik.handleBlur}
                                                    displayEmpty
                                                    className='fieldBatch'
                                                    name="iv_batch"
                                                    id="iv_batch"
                                                    MenuProps={{
                                                      PaperProps: {
                                                        style: {
                                                          width: 20,
                                                          height: 180,
                                                        },
                                                      },
                                                    }}
                                                  >
                                                    <MenuItem value='' sx={{ fontSize: '12px' }}>Batch</MenuItem>
                                                    {batchArray.map((option) => (
                                                      <MenuItem key={option} value={option} sx={{ fontSize: '12px' }}>
                                                        {option}
                                                      </MenuItem>
                                                    ))}
                                                  </Select>
                                                  <Box className='form-error'>
                                                    {fieldFormik.errors.iv_batch && fieldFormik.touched.iv_batch
                                                      ? fieldFormik.errors.iv_batch
                                                      : null}
                                                  </Box>
                                                </Grid>

                                                <Grid item lg={7.5}>
                                                  <TextField
                                                    name="iv_reference_to_allot"
                                                    value={fieldFormik.values.iv_reference_to_allot}
                                                    fullWidth
                                                    onChange={fieldFormik.handleChange}
                                                    onBlur={fieldFormik.handleBlur}
                                                    type='text'
                                                    sx={{ width: '100%' }}
                                                    inputProps={{ maxLength: 7 }}
                                                    InputProps={{
                                                      startAdornment: (
                                                        <InputAdornment
                                                          position="start"
                                                          sx={{ fontSize: '12px' }}
                                                          style={{ background: '#F2F4F6' }}
                                                        >
                                                          {partialValue}
                                                        </InputAdornment>
                                                      ),
                                                    }}
                                                    className='fieldCoverageMarla'
                                                  />
                                                  <Box className='form-error'>
                                                    {fieldFormik.errors.iv_reference_to_allot &&
                                                      fieldFormik.touched.iv_reference_to_allot
                                                      ? fieldFormik.errors.iv_reference_to_allot
                                                      : null}
                                                  </Box>
                                                </Grid>
                                              </Grid>
                                            </Grid>
                                            <Grid item lg={2} sx={{ marginTop: '2%', textAlign: 'center' }}>
                                              <Typography className='fieldLabel'>Sub Batch</Typography>
                                              <Select
                                                sx={{ width: '100%' }}
                                                value={fieldFormik.values.iv_sub_batch}
                                                onChange={fieldFormik.handleChange}
                                                onBlur={fieldFormik.handleBlur}
                                                displayEmpty
                                                className='fieldBatch'
                                                name="iv_sub_batch"
                                                id="iv_sub_batch"
                                                MenuProps={{
                                                  PaperProps: {
                                                    style: {
                                                      width: 20,
                                                      height: 180,
                                                    },
                                                  },
                                                }}
                                              >
                                                <MenuItem value='' sx={{ fontSize: '12px' }}>Select Sub Batch</MenuItem>
                                                {subBatchArray.map((option) => (
                                                  <MenuItem key={option} value={option} sx={{ fontSize: '12px' }}>
                                                    {option}
                                                  </MenuItem>
                                                ))}
                                              </Select>
                                              <p className='form-error'>
                                                {fieldFormik.errors.iv_sub_batch && fieldFormik.touched.iv_sub_batch
                                                  ? fieldFormik.errors.iv_sub_batch
                                                  : null}
                                              </p>
                                            </Grid>
                                          </>
                                        } */}
                                  </>
                                ) : (
                                  <>
                                    <Grid item className="coa-field-survey-cell">
                                      <Typography className="fieldLabel">
                                        Site Observation
                                      </Typography>

                                      <FormControl className="form-control" fullWidth>
                                        <Select
                                          labelId="site-observation-label"
                                          id="iv_objection_Type"
                                          name="iv_objection_Type"
                                          value={
                                            fieldFormik.values.iv_objection_Type ||
                                            ""
                                          }
                                          onChange={(e) => {
                                            fieldFormik.setFieldValue(
                                              "iv_objection_Type",
                                              e.target.value
                                            );
                                            if (e.target.value != "1") {
                                              fieldFormik.setFieldValue(
                                                "iv_batch_change",
                                                false
                                              );
                                              fieldFormik.setFieldValue(
                                                "iv_material_required",
                                                false
                                              );
                                            }
                                          }}
                                          onBlur={fieldFormik.handleBlur}
                                          className="fieldBatch textInputField"
                                          displayEmpty
                                          size="small"
                                        >
                                          {/* <MenuItem value="">
                                                        <em>Select Site Observation</em>
                                                      </MenuItem> */}

                                          {lookUpDataOfCON?.lookupFSObservation?.map(
                                            (item) => (
                                              <MenuItem
                                                key={item.observationType}
                                                value={item.observationType}
                                                style={{ fontSize: "14px" }}
                                              >
                                                {item.observationDetails}
                                              </MenuItem>
                                            )
                                          )}
                                        </Select>
                                      </FormControl>

                                      <Box className="from-Error-load">
                                        {fieldFormik.errors.iv_objection_Type &&
                                          fieldFormik.touched.iv_objection_Type
                                          ? fieldFormik.errors.iv_objection_Type
                                          : null}
                                      </Box>
                                    </Grid>

                                    {fieldFormik.values.iv_objection_Type ==
                                      "6" && (
                                        <Grid
                                          item
                                          className="coa-field-survey-cell coa-field-survey-cell--full"
                                        >
                                          <Typography className="fieldLabel">
                                            Remarks
                                          </Typography>

                                          <textarea
                                            id="iv_remarks_others"
                                            name="iv_remarks_others"
                                            className="coa-field-survey-remarks"
                                            placeholder="Enter your remarks..."
                                            rows={3}
                                            value={
                                              fieldFormik.values.iv_remarks_others
                                            }
                                            onChange={fieldFormik.handleChange}
                                            onBlur={fieldFormik.handleBlur}
                                          />

                                          <Box className="from-Error-load">
                                            {fieldFormik.touched.iv_remarks_others &&
                                              fieldFormik.errors.iv_remarks_others}
                                          </Box>
                                        </Grid>
                                      )}

                                    {fieldFormik.values.iv_objection_Type ==
                                      "5" && (
                                        <Grid
                                          item
                                          className="coa-field-survey-cell coa-field-survey-cell--wide"
                                        >
                                          <Typography className="fieldLabel">
                                            Allot Reference No.
                                          </Typography>
                                          <Grid container spacing={1}>
                                            <Grid item xs={4}>
                                              <Select
                                                sx={{ width: "100%" }}
                                                value={fieldFormik.values.iv_batch}
                                                onChange={fieldFormik.handleChange}
                                                onBlur={fieldFormik.handleBlur}
                                                displayEmpty
                                                className="fieldBatch"
                                                name="iv_batch"
                                                id="iv_batch"
                                                size="small"
                                                MenuProps={{
                                                  PaperProps: {
                                                    style: {
                                                      width: 20,
                                                      height: 180,
                                                    },
                                                  },
                                                }}
                                              >
                                                <MenuItem
                                                  value=""
                                                  sx={{ fontSize: "12px" }}
                                                >
                                                  Batch
                                                </MenuItem>
                                                {batchArray.map((option) => (
                                                  <MenuItem
                                                    key={option}
                                                    value={option}
                                                    sx={{ fontSize: "12px" }}
                                                  >
                                                    {option}
                                                  </MenuItem>
                                                ))}
                                              </Select>
                                              <Box className="form-error">
                                                {fieldFormik.errors.iv_batch &&
                                                  fieldFormik.touched.iv_batch
                                                  ? fieldFormik.errors.iv_batch
                                                  : null}
                                              </Box>
                                            </Grid>

                                            <Grid item xs={8}>
                                              <TextField
                                                name="iv_reference_to_allot"
                                                value={
                                                  fieldFormik.values
                                                    .iv_reference_to_allot
                                                }
                                                fullWidth
                                                size="small"
                                                onChange={fieldFormik.handleChange}
                                                onBlur={fieldFormik.handleBlur}
                                                type="text"
                                                inputProps={{ maxLength: 7 }}
                                                InputProps={{
                                                  startAdornment: (
                                                    <InputAdornment
                                                      position="start"
                                                      sx={{ fontSize: "12px" }}
                                                      style={{
                                                        background: "#F2F4F6",
                                                      }}
                                                    >
                                                      {partialValue}
                                                    </InputAdornment>
                                                  ),
                                                }}
                                                className="fieldCoverageMarla fieldBatch"
                                              />
                                              <Box className="form-error">
                                                {fieldFormik.errors
                                                  .iv_reference_to_allot &&
                                                  fieldFormik.touched
                                                    .iv_reference_to_allot
                                                  ? fieldFormik.errors
                                                    .iv_reference_to_allot
                                                  : null}
                                              </Box>
                                            </Grid>
                                          </Grid>
                                        </Grid>
                                      )}
                                    {fieldFormik.values.iv_objection_Type ==
                                      "1" && (
                                        <>
                                          <Grid
                                            item
                                            className="coa-field-survey-cell"
                                          >
                                            <Typography className="fieldLabel">
                                              Material Required
                                            </Typography>

                                            <FormControl className="form-control" fullWidth>
                                              <RadioGroup
                                                className="radio-group"
                                                name="iv_material_required"
                                                value={
                                                  fieldFormik.values
                                                    .iv_material_required === true
                                                    ? "true"
                                                    : fieldFormik.values
                                                      .iv_material_required ===
                                                      false
                                                      ? "false"
                                                      : ""
                                                }
                                                // onChange={(e) =>
                                                //   fieldFormik.setFieldValue(
                                                //     'iv_material_required',
                                                //     e.target.value === 'true'
                                                //   )
                                                // }
                                                onChange={(e) => {
                                                  const isMaterialRequired =
                                                    e.target.value === "true";
                                                  fieldFormik.setFieldValue(
                                                    "iv_material_required",
                                                    isMaterialRequired
                                                  );

                                                  if (isMaterialRequired) {
                                                    fieldFormik.setFieldValue(
                                                      "iv_grid_sharing_cost",
                                                      0
                                                    );
                                                    fieldFormik.setFieldValue(
                                                      "iv_feeder_rehab_charges",
                                                      0
                                                    );
                                                    setGridSharingCost(0);
                                                    setFeederRehabilitationCharges(0);
                                                  } else {
                                                    // setBoqItems();

                                                    setBoqItems([]);
                                                    setItemsAmount("");
                                                    setStoreCharges("");
                                                    setInstallationCharges("");
                                                    setTotalCharges("");
                                                    setItemsArray("");
                                                    setFixedChargesOfMetering("");

                                                    // fieldFormik.setFieldValue('iv_meter_to_replace', '');
                                                    // fieldFormik.setFieldValue('iv_meter_type', '');
                                                    setSketchDiagram(null);
                                                    setSketchDiagramUploaded("");
                                                    setSketchDiagramThumbnail("");
                                                  }
                                                }}
                                                onBlur={fieldFormik.handleBlur}
                                                row
                                              >
                                                <FormControlLabel
                                                  value="true"
                                                  control={<Radio size="small" />}
                                                  label="Yes"
                                                />
                                                <FormControlLabel
                                                  value="false"
                                                  control={<Radio size="small" />}
                                                  label="No"
                                                />
                                              </RadioGroup>
                                            </FormControl>

                                            <Box className="from-Error-load">
                                              {fieldFormik.errors
                                                .iv_material_required &&
                                                fieldFormik.touched.iv_material_required
                                                ? fieldFormik.errors
                                                  .iv_material_required
                                                : null}
                                            </Box>
                                          </Grid>
                                          {fieldFormik.values.iv_material_required ===
                                            true && (
                                              <>
                                                <Grid
                                                  item
                                                  className="coa-field-survey-cell"
                                                >
                                                  <Typography className="fieldLabel">
                                                    Meter needs to be replaced
                                                  </Typography>

                                                  <FormControl className="form-control" fullWidth>
                                                    <RadioGroup
                                                      className="radio-group"
                                                      name="iv_meter_to_replace"
                                                      value={
                                                        fieldFormik.values
                                                          .iv_meter_to_replace === true
                                                          ? "true"
                                                          : fieldFormik.values
                                                            .iv_meter_to_replace ===
                                                            false
                                                            ? "false"
                                                            : ""
                                                      }
                                                      onChange={(e) => {
                                                        const value =
                                                          e.target.value === "true";
                                                        fieldFormik.setFieldValue(
                                                          "iv_meter_to_replace",
                                                          value
                                                        );
                                                      }}
                                                      onBlur={fieldFormik.handleBlur}
                                                      row
                                                    >
                                                      <FormControlLabel
                                                        value="true"
                                                        control={<Radio size="small" />}
                                                        label="Yes"
                                                      />
                                                      <FormControlLabel
                                                        value="false"
                                                        control={<Radio size="small" />}
                                                        label="No"
                                                      />
                                                    </RadioGroup>
                                                  </FormControl>

                                                  <Box className="from-Error-load">
                                                    {fieldFormik.errors
                                                      .iv_meter_to_replace &&
                                                      fieldFormik.touched
                                                        .iv_meter_to_replace
                                                      ? fieldFormik.errors
                                                        .iv_meter_to_replace
                                                      : null}
                                                  </Box>
                                                </Grid>
                                                <Grid
                                                  item
                                                  className="coa-field-survey-cell"
                                                >
                                                  <Typography className="fieldLabel">
                                                    Sketch / Diagram
                                                  </Typography>

                                                  <Box className="form-error">
                                                    {fieldFormik.errors
                                                      .iv_sketch_diagram &&
                                                      fieldFormik.touched
                                                        .iv_sketch_diagram
                                                      ? fieldFormik.errors
                                                        .iv_sketch_diagram
                                                      : null}
                                                  </Box>
                                                  <Box className="form-error">
                                                    {sketchDiagramError
                                                      ? sketchDiagramError
                                                      : null}
                                                  </Box>

                                                  {(sketchDiagramUploaded &&
                                                    sketchDiagramUploaded !== "") ||
                                                    sketchDiagram ? (
                                                    <div className="rco-field-survey-image-preview">
                                                      {sketchDiagramThumbnail && (
                                                        <>
                                                          {sketchDiagramThumbnail.startsWith(
                                                            "data:image/"
                                                          ) ? (
                                                            <a
                                                              href="#"
                                                              onClick={(e) => {
                                                                e.preventDefault();
                                                                openBase64Image(
                                                                  sketchDiagramUploaded ||
                                                                  sketchDiagramThumbnail
                                                                );
                                                              }}
                                                            >
                                                              <img
                                                                src={
                                                                  sketchDiagramThumbnail
                                                                }
                                                                alt="Sketch Diagram"
                                                              />
                                                            </a>
                                                          ) : sketchDiagramThumbnail.startsWith(
                                                            "data:application/pdf"
                                                          ) ? (
                                                            <img
                                                              src={pdfIcon}
                                                              alt="Sketch Diagram PDF"
                                                            />
                                                          ) : (
                                                            <img
                                                              src={
                                                                sketchDiagramThumbnail
                                                              }
                                                              alt="Sketch Diagram"
                                                            />
                                                          )}
                                                        </>
                                                      )}
                                                      <button
                                                        type="button"
                                                        className="rco-field-survey-image-preview__remove"
                                                        onClick={
                                                          clearSketchDiagramSelection
                                                        }
                                                        disabled={
                                                          dnDetails &&
                                                          dnDetails.filledFlag ===
                                                          1 &&
                                                          CheckPermissions(
                                                            permissions,
                                                            "General Services",
                                                            "Change of Attributes",
                                                            "Workflow Permissions",
                                                            "Field Survey",
                                                            "Survey Form Creation"
                                                          )
                                                        }
                                                        aria-label="Remove sketch diagram"
                                                      >
                                                        <CloseIcon />
                                                      </button>
                                                    </div>
                                                  ) : (
                                                    <Button
                                                      variant="outlined"
                                                      component="label"
                                                      fullWidth
                                                      startIcon={
                                                        <FileUploadOutlinedIcon />
                                                      }
                                                      className="rco-field-survey-upload"
                                                      disabled={
                                                        dnDetails &&
                                                        dnDetails.filledFlag === 1 &&
                                                        CheckPermissions(
                                                          permissions,
                                                          "General Services",
                                                          "Change of Attributes",
                                                          "Workflow Permissions",
                                                          "Field Survey",
                                                          "Survey Form Creation"
                                                        )
                                                      }
                                                    >
                                                      Upload
                                                      <input
                                                        hidden
                                                        accept={documentExtensions}
                                                        id="iv_sketch_diagram"
                                                        name="iv_sketch_diagram"
                                                        type="file"
                                                        onChange={SketchDiagram}
                                                      />
                                                    </Button>
                                                  )}
                                                </Grid>

                                                <Grid
                                                  item
                                                  className="coa-field-survey-cell"
                                                >
                                                  <Typography className="fieldLabel">
                                                    Meter Type
                                                  </Typography>
                                                  <FormControl className="form-control" fullWidth>
                                                    <RadioGroup
                                                      className="radio-group"
                                                      row
                                                      name="iv_meter_type"
                                                      value={
                                                        dialogRowData.applicationId?.slice(
                                                          3,
                                                          5
                                                        ) === "13" ||
                                                          dialogRowData.applicationId?.slice(
                                                            3,
                                                            5
                                                          ) === "15"
                                                          ? "1"
                                                          : fieldFormik.values
                                                            .iv_meter_type
                                                      }
                                                      onChange={
                                                        fieldFormik.handleChange
                                                      }
                                                    >
                                                      <FormControlLabel
                                                        value="1"
                                                        control={<Radio size="small" />}
                                                        label="Smart"
                                                        disabled={
                                                          dialogRowData.applicationId?.slice(
                                                            3,
                                                            5
                                                          ) === "13" ||
                                                          dialogRowData.applicationId?.slice(
                                                            3,
                                                            5
                                                          ) === "15"
                                                        }
                                                      />
                                                      <FormControlLabel
                                                        value="0"
                                                        control={<Radio size="small" />}
                                                        label="Normal"
                                                        disabled={
                                                          dialogRowData.applicationId?.slice(
                                                            3,
                                                            5
                                                          ) === "13" ||
                                                          dialogRowData.applicationId?.slice(
                                                            3,
                                                            5
                                                          ) === "15"
                                                        }
                                                      />
                                                    </RadioGroup>
                                                  </FormControl>

                                                  {fieldFormik.touched.iv_meter_type &&
                                                    fieldFormik.errors
                                                      .iv_meter_type && (
                                                      <p className="form-error">
                                                        {
                                                          fieldFormik.errors
                                                            .iv_meter_type
                                                        }
                                                      </p>
                                                    )}
                                                </Grid>
                                              </>
                                            )}
                                          <Grid item className="coa-field-survey-cell">
                                            <Typography className="fieldLabel">
                                              Area Type
                                            </Typography>

                                            <FormControl className="form-control" fullWidth>
                                              <RadioGroup
                                                className="radio-group"
                                                name="iv_area_type"
                                                value={
                                                  fieldFormik.values.iv_area_type ===
                                                    "U"
                                                    ? "Urban"
                                                    : fieldFormik.values
                                                      .iv_area_type === "R"
                                                      ? "Rural"
                                                      : ""
                                                }
                                                onChange={(e) => {
                                                  const selectedValue =
                                                    e.target.value === "Urban"
                                                      ? "U"
                                                      : "R";
                                                  fieldFormik.setFieldValue(
                                                    "iv_area_type",
                                                    selectedValue
                                                  );
                                                }}
                                                onBlur={fieldFormik.handleBlur}
                                                row
                                              >
                                                <FormControlLabel
                                                  value="Urban"
                                                  control={<Radio size="small" />}
                                                  label="Urban"
                                                />
                                                <FormControlLabel
                                                  value="Rural"
                                                  control={<Radio size="small" />}
                                                  label="Rural"
                                                />
                                              </RadioGroup>
                                            </FormControl>

                                            <Box className="from-Error-load">
                                              {fieldFormik.errors.iv_area_type &&
                                                fieldFormik.touched.iv_area_type
                                                ? fieldFormik.errors.iv_area_type
                                                : null}
                                            </Box>
                                          </Grid>

                                          <Grid item className="coa-field-survey-cell">
                                            <Typography className="fieldLabel">
                                              Batch Change Required
                                            </Typography>

                                            <FormControl className="form-control" fullWidth>
                                              <RadioGroup
                                                className="radio-group"
                                                name="iv_batch_change"
                                                value={
                                                  fieldFormik.values
                                                    .iv_batch_change === true
                                                    ? "true"
                                                    : fieldFormik.values
                                                      .iv_batch_change === false
                                                      ? "false"
                                                      : ""
                                                }
                                                onChange={(e) => {
                                                  const isBatchChange =
                                                    e.target.value === "true";
                                                  fieldFormik.setFieldValue(
                                                    "iv_batch_change",
                                                    isBatchChange
                                                  );

                                                  if (!isBatchChange) {
                                                    fieldFormik.setFieldValue(
                                                      "iv_batch",
                                                      ""
                                                    );
                                                    fieldFormik.setFieldValue(
                                                      "iv_sub_batch",
                                                      ""
                                                    );
                                                    fieldFormik.setFieldValue(
                                                      "iv_reference_to_allot",
                                                      ""
                                                    );
                                                  }
                                                }}
                                                onBlur={fieldFormik.handleBlur}
                                                row
                                              >
                                                <FormControlLabel
                                                  value="true"
                                                  control={<Radio size="small" />}
                                                  label="Yes"
                                                />
                                                <FormControlLabel
                                                  value="false"
                                                  control={<Radio size="small" />}
                                                  label="No"
                                                />
                                              </RadioGroup>
                                            </FormControl>

                                            <Box className="from-Error-load">
                                              {fieldFormik.errors.iv_batch_change &&
                                                fieldFormik.touched.iv_batch_change
                                                ? fieldFormik.errors.iv_batch_change
                                                : null}
                                            </Box>
                                          </Grid>
                                          {dialogRowData.changeOfAttributesType ==
                                            3 ||
                                            dialogRowData.changeOfAttributesType ==
                                            4 ||
                                            dialogRowData.changeOfAttributesType ==
                                            6 ||
                                            (dialogRowData.changeOfAttributesType ==
                                              7 && (
                                                <>
                                                  {dialogRowData.newTariff &&
                                                    dialogRowData.newTariff
                                                      .replace("-", "")
                                                      .startsWith("B") && (
                                                      <Grid
                                                        item
                                                        className="coa-field-survey-cell"
                                                      >
                                                        <Typography className="fieldLabel">
                                                          Seasonal / Non Seasonal
                                                        </Typography>

                                                        <FormControl className="form-control" fullWidth>
                                                          <RadioGroup
                                                            className="radio-group"
                                                            row
                                                            name="iv_seasonal"
                                                            value={
                                                              fieldFormik.values
                                                                .iv_seasonal
                                                                ? "1"
                                                                : "0"
                                                            }
                                                            onChange={(e) => {
                                                              const isSeasonal =
                                                                e.target.value === "1";
                                                              fieldFormik.setFieldValue(
                                                                "iv_seasonal",
                                                                isSeasonal
                                                              );
                                                            }}
                                                            onBlur={
                                                              fieldFormik.handleBlur
                                                            }
                                                          >
                                                            <FormControlLabel
                                                              value="1"
                                                              control={<Radio size="small" />}
                                                              label="Seasonal"
                                                            />
                                                            <FormControlLabel
                                                              value="0"
                                                              control={<Radio size="small" />}
                                                              label="Non Seasonal"
                                                            />
                                                          </RadioGroup>
                                                        </FormControl>
                                                      </Grid>
                                                    )}
                                                </>
                                              ))}

                                          {fieldFormik.values.iv_batch_change ===
                                            true && (
                                              <>
                                                <Grid
                                                  item
                                                  className="coa-field-survey-cell coa-field-survey-cell--wide"
                                                >
                                                  <Typography className="fieldLabel">
                                                    Allot Reference No.
                                                  </Typography>
                                                  <Grid container spacing={1}>
                                                    <Grid item xs={4}>
                                                      <Select
                                                        sx={{ width: "100%" }}
                                                        value={
                                                          fieldFormik.values.iv_batch
                                                        }
                                                        onChange={
                                                          fieldFormik.handleChange
                                                        }
                                                        onBlur={fieldFormik.handleBlur}
                                                        displayEmpty
                                                        className="fieldBatch"
                                                        name="iv_batch"
                                                        id="iv_batch"
                                                        size="small"
                                                        MenuProps={{
                                                          PaperProps: {
                                                            style: {
                                                              width: 20,
                                                              height: 180,
                                                            },
                                                          },
                                                        }}
                                                      >
                                                        <MenuItem
                                                          value=""
                                                          sx={{ fontSize: "12px" }}
                                                        >
                                                          Batch
                                                        </MenuItem>
                                                        {batchArray.map((option) => (
                                                          <MenuItem
                                                            key={option}
                                                            value={option}
                                                            sx={{ fontSize: "12px" }}
                                                          >
                                                            {option}
                                                          </MenuItem>
                                                        ))}
                                                      </Select>
                                                      <Box className="form-error">
                                                        {fieldFormik.errors.iv_batch &&
                                                          fieldFormik.touched.iv_batch
                                                          ? fieldFormik.errors.iv_batch
                                                          : null}
                                                      </Box>
                                                    </Grid>

                                                    <Grid item xs={8}>
                                                      <TextField
                                                        name="iv_reference_to_allot"
                                                        value={
                                                          fieldFormik.values
                                                            .iv_reference_to_allot
                                                        }
                                                        fullWidth
                                                        size="small"
                                                        onChange={
                                                          fieldFormik.handleChange
                                                        }
                                                        onBlur={fieldFormik.handleBlur}
                                                        type="text"
                                                        inputProps={{ maxLength: 7 }}
                                                        InputProps={{
                                                          startAdornment: (
                                                            <InputAdornment
                                                              position="start"
                                                              sx={{ fontSize: "12px" }}
                                                              style={{
                                                                background: "#F2F4F6",
                                                              }}
                                                            >
                                                              {partialValue}
                                                            </InputAdornment>
                                                          ),
                                                        }}
                                                        className="fieldCoverageMarla fieldBatch"
                                                      />
                                                      <Box className="form-error">
                                                        {fieldFormik.errors
                                                          .iv_reference_to_allot &&
                                                          fieldFormik.touched
                                                            .iv_reference_to_allot
                                                          ? fieldFormik.errors
                                                            .iv_reference_to_allot
                                                          : null}
                                                      </Box>
                                                    </Grid>
                                                  </Grid>
                                                </Grid>
                                                <Grid
                                                  item
                                                  className="coa-field-survey-cell"
                                                >
                                                  <Typography className="fieldLabel">
                                                    Sub Batch
                                                  </Typography>
                                                  <Select
                                                    sx={{ width: "100%" }}
                                                    value={
                                                      fieldFormik.values.iv_sub_batch
                                                    }
                                                    onChange={fieldFormik.handleChange}
                                                    onBlur={fieldFormik.handleBlur}
                                                    displayEmpty
                                                    className="fieldBatch"
                                                    name="iv_sub_batch"
                                                    id="iv_sub_batch"
                                                    size="small"
                                                    MenuProps={{
                                                      PaperProps: {
                                                        style: {
                                                          width: 20,
                                                          height: 180,
                                                        },
                                                      },
                                                    }}
                                                  >
                                                    <MenuItem
                                                      value=""
                                                      sx={{ fontSize: "12px" }}
                                                    >
                                                      Select Sub Batch
                                                    </MenuItem>
                                                    {subBatchArray.map((option) => (
                                                      <MenuItem
                                                        key={option}
                                                        value={option}
                                                        sx={{ fontSize: "12px" }}
                                                      >
                                                        {option}
                                                      </MenuItem>
                                                    ))}
                                                  </Select>
                                                  <p className="form-error">
                                                    {fieldFormik.errors.iv_sub_batch &&
                                                      fieldFormik.touched.iv_sub_batch
                                                      ? fieldFormik.errors.iv_sub_batch
                                                      : null}
                                                  </p>
                                                </Grid>
                                              </>
                                            )}

                                          {fieldFormik.values.iv_material_required === true && (
                                            <Grid item className="coa-field-survey-cell">
                                              <Typography className="fieldLabel">
                                                {boqItems && boqItems.length > 0
                                                  ? "Edit Estimate"
                                                  : "Prepare Estimate"}
                                              </Typography>
                                              {boqItems.length === 0 ? (
                                                <Button
                                                  variant="contained"
                                                  fullWidth
                                                  className="rco-field-survey-prepare-btn"
                                                  startIcon={<AddIcon />}
                                                  onClick={() => onPressAddPrepare()}
                                                >
                                                  Prepare Estimate
                                                </Button>
                                              ) : (
                                                <Button
                                                  variant="contained"
                                                  fullWidth
                                                  className="rco-field-survey-prepare-btn rco-field-survey-prepare-btn--edit"
                                                  startIcon={<EditIcon />}
                                                  onClick={() => onPressAddPrepare()}
                                                >
                                                  Edit Estimate
                                                </Button>
                                              )}
                                              {errormessageBoqEstimation && (
                                                <Typography
                                                  variant="body2"
                                                  className="form-error"
                                                  sx={{ mt: 1, display: "block" }}
                                                >
                                                  {errormessageBoqEstimation}
                                                </Typography>
                                              )}
                                            </Grid>
                                          )}

                                          {/* Show inline charge fields when Material Required = No AND load > 4 */}
                                          {/* Material Required = No: Only Grid Sharing Cost and Feeder Rehab Charges */}
                                          {fieldFormik.values.iv_material_required === false &&
                                            (dialogRowData.newSanctionLoad || dialogRowData.currentSanctionLoad) > 4 && (
                                              <>
                                                {/* <Grid item lg={12} sx={{ marginTop: "2%" }}>
                                            <Typography className="fieldLabel" sx={{ fontWeight: "bold", marginBottom: "1%" }}>
                                              Charges Details
                                            </Typography>
                                          </Grid> */}

                                                {/* Grid Sharing Cost */}
                                                <Grid item className="coa-field-survey-cell">
                                                  <Typography className="fieldLabel">
                                                    Grid Sharing Cost
                                                  </Typography>
                                                  <TextField
                                                    name="iv_grid_sharing_cost"
                                                    value={formatWholeNumberInput(fieldFormik.values.iv_grid_sharing_cost)}
                                                    type="text"
                                                    inputProps={{ inputMode: "numeric" }}
                                                    fullWidth
                                                    size="small"
                                                    className="fieldBatch"
                                                    onChange={handleWholeNumberFieldChange(
                                                      "iv_grid_sharing_cost",
                                                      setGridSharingCost
                                                    )}
                                                  />
                                                </Grid>

                                                <Grid item className="coa-field-survey-cell">
                                                  <Typography className="fieldLabel">
                                                    Feeder Rehab Charges
                                                  </Typography>
                                                  <TextField
                                                    name="iv_feeder_rehab_charges"
                                                    value={formatWholeNumberInput(fieldFormik.values.iv_feeder_rehab_charges)}
                                                    type="text"
                                                    inputProps={{ inputMode: "numeric" }}
                                                    fullWidth
                                                    size="small"
                                                    className="fieldBatch"
                                                    onChange={handleWholeNumberFieldChange(
                                                      "iv_feeder_rehab_charges",
                                                      setFeederRehabilitationCharges
                                                    )}
                                                  />
                                                </Grid>
                                              </>
                                            )}

                                          {/* Material Required = Yes: All other charges */}
                                        </>
                                      )}
                                  </>
                                )}
                              </Grid>
                            </>
                          ) : (
                            <div className="description-box description-box--error">
                              <p className="group-description">
                                <InfoIcon className="icon" />
                                Field Survey is in process by sanctioning authority.{" "}
                              </p>
                            </div>
                          )}
                        </>
                      ) : dialogRowData.applicationProgressId === 4 &&
                        dialogRowData.objectionStatus === 1 ? (
                        <>
                          <h3 className="step-title">Field Survey Objection</h3>
                          {CheckPermissions(
                            permissions,
                            "General Services",
                            "Change of Attributes",
                            "Workflow Permissions",
                            "Field Survey"
                          ) &&
                            matchesCoaApprovalCategory(permissions, dialogRowData, allTariffList) ? (
                            <>
                              <Grid
                                container
                                spacing={2}
                                className="field-survey-container coa-field-survey-container"
                              >
                                <Grid item xs={12} md={4} className="coa-field-survey-cell">
                                  <Typography className="fieldLabel">
                                    Site Observation
                                  </Typography>

                                  <FormControl
                                    className="form-control"
                                    fullWidth
                                  >
                                    <Select
                                      labelId="site-observation-label"
                                      id="iv_objection_Type"
                                      name="iv_objection_Type"
                                      value={
                                        fieldFormik.values.iv_objection_Type || ""
                                      }
                                      onChange={(e) => {
                                        fieldFormik.setFieldValue(
                                          "iv_objection_Type",
                                          e.target.value
                                        );
                                        if (e.target.value != "1") {
                                          fieldFormik.setFieldValue(
                                            "iv_batch_change",
                                            false
                                          );
                                        }
                                      }}
                                      onBlur={fieldFormik.handleBlur}
                                      className="fieldBatch textInputField"
                                      displayEmpty
                                      size="small"
                                      disabled
                                    >
                                      <MenuItem value="">
                                        <em>Select Site Observation</em>
                                      </MenuItem>

                                      {lookUpDataOfCON?.lookupFSObservation?.map(
                                        (item) => (
                                          <MenuItem
                                            key={item.observationType}
                                            value={item.observationType}
                                            style={{ fontSize: "14px" }}
                                          >
                                            {item.observationDetails}
                                          </MenuItem>
                                        )
                                      )}
                                    </Select>
                                  </FormControl>

                                  <Box className="from-Error-load">
                                    {fieldFormik.errors.iv_objection_Type &&
                                      fieldFormik.touched.iv_objection_Type
                                      ? fieldFormik.errors.iv_objection_Type
                                      : null}
                                  </Box>
                                </Grid>
                                <Grid item xs={12} md={4} className="coa-field-survey-cell">
                                  <Typography className="fieldLabel">
                                    Remarks
                                  </Typography>

                                  <textarea
                                    id="iv_remarks"
                                    name="iv_remarks"
                                    className="coa-field-survey-remarks"
                                    placeholder="Enter your remarks..."
                                    rows={3}
                                    value={
                                      fieldRemoveObjectionFormik.values.iv_remarks
                                    }
                                    onChange={
                                      fieldRemoveObjectionFormik.handleChange
                                    }
                                    onBlur={fieldRemoveObjectionFormik.handleBlur}
                                  />

                                  <Box className="from-Error-load">
                                    {fieldRemoveObjectionFormik.touched
                                      .iv_remarks &&
                                      fieldRemoveObjectionFormik.errors.iv_remarks}
                                  </Box>
                                </Grid>
                                {fieldFormik.values.iv_objection_Type == "4" && (
                                  <Grid item xs={12} md={4} className="coa-field-survey-cell">
                                    <div className="rco-dn-submission-form__field">
                                      <Typography className="fieldLabel">
                                        Document from Civic Authority
                                      </Typography>

                                      {additionalCivicDocumentThumbnail ? (
                                        <div className="rco-dn-receipt-preview">
                                          {additionalCivicDocumentThumbnail.startsWith(
                                            "data:image/"
                                          ) ? (
                                            <img
                                              src={additionalCivicDocumentThumbnail}
                                              alt="Civic Document"
                                            />
                                          ) : (
                                            <img
                                              src={pdfIcon}
                                              alt="Civic Document PDF"
                                            />
                                          )}
                                          <button
                                            type="button"
                                            className="rco-dn-receipt-preview__remove"
                                            onClick={clearAdditionalCivicDocument}
                                            aria-label="Remove civic document"
                                          >
                                            <CloseIcon />
                                          </button>
                                        </div>
                                      ) : (
                                        <Button
                                          variant="outlined"
                                          component="label"
                                          startIcon={<FileUploadOutlinedIcon />}
                                          className="rco-dn-submission-upload"
                                        >
                                          Upload
                                          <input
                                            hidden
                                            accept={documentExtensions}
                                            id="iv_additional_civic_document"
                                            name="iv_additional_civic_document"
                                            type="file"
                                            onChange={AdditionalCivicDocument}
                                            onBlur={() =>
                                              fieldRemoveObjectionFormik.setFieldTouched(
                                                "iv_additional_civic_document",
                                                true
                                              )
                                            }
                                          />
                                        </Button>
                                      )}
                                      {(additionalCivicDocumentError ||
                                        (fieldRemoveObjectionFormik.touched
                                          .iv_additional_civic_document &&
                                          fieldRemoveObjectionFormik.errors
                                            .iv_additional_civic_document)) && (
                                          <p className="rco-dn-submission-form__error">
                                            {additionalCivicDocumentError ||
                                              fieldRemoveObjectionFormik.errors
                                                .iv_additional_civic_document}
                                          </p>
                                        )}
                                    </div>
                                  </Grid>
                                )}
                              </Grid>
                            </>
                          ) : (
                            <div className="description-box description-box--error">
                              <p className="group-description">
                                <InfoIcon className="icon" />
                                Field Survey is in process by sanctioning authority.{" "}
                              </p>
                            </div>
                          )}
                        </>
                      ) : dialogRowData.applicationProgressId === 5 &&
                        Number(dialogRowData.objectionStatus) === 1 ? (
                        <>
                          <h3 className="step-title">Application Rejected</h3>
                          {CheckPermissions(
                            permissions,
                            "General Services",
                            "Change of Attributes",
                            "Workflow Permissions",
                            "Restore Application"
                          ) &&
                            matchesCoaApprovalCategory(
                              permissions,
                              dialogRowData,
                              allTariffList,
                            ) ? (
                            <div className="nc-restore-application-panel">
                              <p className="nc-restore-application-panel__text">
                                You can restore this rejected application to
                                continue the DN Approval workflow. Provide remarks
                                and confirm to restore.
                              </p>
                            </div>
                          ) : (
                            <div className="description-box description-box--error">
                              <p className="group-description">
                                <InfoIcon className="icon" />
                                This application has been cancelled by the sanctioning authority.
                              </p>
                            </div>
                          )}
                        </>
                      ) : dialogRowData.applicationProgressId === 5 &&
                        (dialogRowData.objectionStatus === 0 ||
                          dialogRowData.objectionStatus === 2) ? (
                        <>
                          <Grid
                            container
                            className="step-title"
                            sx={{ marginBottom: "1%", padding: "0.5%" }}
                          >
                            <Grid item lg={1}></Grid>
                            <Grid item lg={10} sx={{ textAlign: "center" }}>
                              <h4>DN Approval</h4>
                            </Grid>
                            <Grid item lg={1}></Grid>
                          </Grid>
                          {
                            // CheckPermissions(permissions, 'General Services', 'Change of Attributes', 'Workflow Permissions', 'DN Approval') &&
                            CheckPermissions(
                              permissions,
                              "General Services",
                              "Change of Attributes",
                              "Workflow Permissions",
                              "Demand Note Approval"
                            ) &&
                              matchesCoaApprovalCategory(permissions, dialogRowData, allTariffList) ? (
                              <>
                                {dnApproveStep && (
                                  <>
                                    <Grid
                                      container
                                      spacing={2}
                                      className="dn-payment-submission-container"
                                    >
                                      {(() => {
                                        const total =
                                          (parseFloat(
                                            dnApproveStep.securityDepositeAmount
                                          ) || 0) +
                                          // (parseFloat(dnApproveStep.amountOfGridSharing) || 0) +
                                          // (parseFloat(dnApproveStep.amountOfFeederRehab) || 0) +
                                          (parseFloat(
                                            dnApproveStep.capitalCostAmount
                                          ) || 0);
                                        // (parseFloat(dnApproveStep.civilWorkCharges) || 0) +
                                        // (parseFloat(dnApproveStep.fixedChargesOfMetering) || 0) +
                                        // (parseFloat(dnApproveStep.miscellaneousCharges) || 0) -
                                        // (parseFloat(dnApproveStep.lessTheCost) || 0);

                                        // const fields = [
                                        //   { label: "Issue Date", value: dnApproveStep.issueDate ? convertDate(dnApproveStep.issueDate) : null },
                                        //   { label: "Due Date", value: dnApproveStep.dueDate ? convertDate(dnApproveStep.dueDate) : null },
                                        //   { label: "Bank Name", value: dnApproveStep.bankName },
                                        //   { label: "Previous Security Cost", value: parseFloat(dnApproveStep.previousSecurity) || 0 },
                                        //   { label: "Current Estimated Security Cost", value: parseFloat(dnApproveStep.securityDepositeAmount) || 0 },
                                        //   { label: "Amount of Grid Sharing", value: parseFloat(dnApproveStep.amountOfGridSharing) || 0 },
                                        //   { label: "Amount of Feeder Rehab", value: parseFloat(dnApproveStep.amountOfFeederRehab) || 0 },
                                        //   { label: "Capital Cost Amount", value: parseFloat(dnApproveStep.capitalCostAmount) || 0 },
                                        //   { label: "Civil Work Charges", value: parseFloat(dnApproveStep.civilWorkCharges) || 0 },
                                        //   { label: "Fixed Charges Of Metering", value: parseFloat(dnApproveStep.fixedChargesOfMetering) || 0 },
                                        //   { label: "Miscellaneous Charges", value: parseFloat(dnApproveStep.miscellaneousCharges) || 0 },
                                        //   { label: "Less the Cost", value: parseFloat(dnApproveStep.lessTheCost) || 0 },
                                        //   { label: "Grand Total", value: total },
                                        // ];
                                        const fields = [
                                          {
                                            label: "Issue Date",
                                            value: dnApproveStep.issueDate
                                              ? convertDate(dnApproveStep.issueDate)
                                              : null,
                                          },
                                          {
                                            label: "Due Date",
                                            value: dnApproveStep.dueDate
                                              ? convertDate(dnApproveStep.dueDate)
                                              : null,
                                          },
                                          {
                                            label: "Bank Name",
                                            value: dnApproveStep.bankName,
                                          },
                                          {
                                            label: "Capital Cost Amount",
                                            value:
                                              parseFloat(
                                                dnApproveStep.capitalCostAmount
                                              ) || 0,
                                          },
                                          {
                                            label: "Security Deposite Amount",
                                            value:
                                              parseFloat(
                                                dnApproveStep.securityDepositeAmount
                                              ) || 0,
                                          },
                                          {
                                            label:
                                              "Grand Total (Capital Amount + Security Amount)",
                                            value: total,
                                          },
                                        ];

                                        return fields
                                          .filter((item) => {
                                            // Special handling for Issue Date, Due Date, Bank Name
                                            if (
                                              [
                                                "Issue Date",
                                                "Due Date",
                                                "Bank Name",
                                              ].includes(item.label)
                                            ) {
                                              return (
                                                item.value !== null &&
                                                item.value !== undefined &&
                                                item.value !== ""
                                              );
                                            }
                                            return item.value > 0;
                                          })
                                          .map((item, index) => (
                                            <Grid
                                              item
                                              lg={4}
                                              md={6}
                                              sm={12}
                                              key={index}
                                              className="item"
                                            >
                                              <Typography
                                                className="title"
                                                sx={{
                                                  fontWeight: 600,
                                                  color:
                                                    item.label === "Grand Total"
                                                      ? "#1976d2"
                                                      : "#333",
                                                }}
                                              >
                                                {item.label}
                                              </Typography>
                                              <Typography
                                                className="value"
                                                sx={
                                                  item.label === "Grand Total"
                                                    ? {
                                                      backgroundColor:
                                                        "#1976d2 !important",
                                                      color: "#fff !important",
                                                      fontSize: "1.1rem",
                                                    }
                                                    : { color: "#444" }
                                                }
                                              >
                                                {["Issue Date", "Due Date"].includes(
                                                  item.label
                                                )
                                                  ? item.value
                                                  : item.label === "Bank Name"
                                                    ? item.value
                                                    : numberFormatting(item.value)}
                                              </Typography>
                                            </Grid>
                                          ));
                                      })()}
                                    </Grid>
                                    <Box className="ref-no-documents-certify">
                                      <FormControlLabel
                                        control={
                                          <Checkbox
                                            checked={dnDocumentsCertified}
                                            onChange={(e) =>
                                              setDnDocumentsCertified(e.target.checked)
                                            }
                                            color="primary"
                                          />
                                        }
                                        label="I do hereby certified that the all requisite documents have been checked and found accurate and complete"
                                      />
                                    </Box>
                                  </>
                                )}
                              </>
                            ) : (
                              <div className="description-box description-box--error">
                                <p className="group-description">
                                  <InfoIcon className="icon" />
                                  Demand Note Approval is in process by sanctioning
                                  authority.{" "}
                                </p>
                              </div>
                            )
                          }
                        </>
                      ) : dialogRowData.applicationProgressId === 6 &&
                        Number(dialogRowData.objectionStatus) === 1 ? (
                        <>
                          <h3 className="step-title">Demand Notice Objection</h3>
                          {matchesCoaApprovalCategory(
                            permissions,
                            dialogRowData,
                            allTariffList,
                          ) &&
                            (isCoaRestoreAllowedWithinDays(
                              getCoaRestoreReferenceDate(dialogRowData),
                            )
                              ? hasCoaRestoreApplicationPermission()
                              : hasCoaRestoreAfterLoePermission()) ? (
                            <div className="nc-restore-application-panel">
                              <p className="nc-restore-application-panel__text">
                                {isCoaRestoreAfterLoeWindow(dialogRowData)
                                  ? `The ${COA_RESTORE_ALLOWED_DAYS}-day restore window has expired. You can still restore this application with a Letter of Explanation (LOE) document. Upload the Letter of Explanation and provide remarks to continue the DN Submission workflow.`
                                  : "You can restore this rejected application to continue the DN Submission workflow. Provide remarks and confirm to restore."}
                              </p>
                              <div className="nc-restore-application-actions">
                                <button
                                  type="button"
                                  className="view-button"
                                  onClick={showRestoreApplicationPopup}
                                >
                                  Restore Application
                                </button>
                              </div>
                            </div>
                          ) : matchesCoaApprovalCategory(
                            permissions,
                            dialogRowData,
                            allTariffList,
                          ) &&
                            hasCoaRestoreApplicationPermission() &&
                            !isCoaRestoreAllowedWithinDays(
                              getCoaRestoreReferenceDate(dialogRowData),
                            ) ? (
                            <div className="description-box description-box--error">
                              <p className="group-description">
                                <InfoIcon className="icon" />
                                This application cannot be restored. The{" "}
                                {COA_RESTORE_ALLOWED_DAYS}-day restore window has
                                expired.
                              </p>
                            </div>
                          ) : (
                            <div className="description-box description-box--error">
                              <p className="group-description">
                                <InfoIcon className="icon" />
                                Unable to generate the demand notice. Please contact
                                the relevant field operations officer.{" "}
                              </p>
                            </div>
                          )}
                        </>
                      ) : dialogRowData.applicationProgressId === 6 &&
                        (dialogRowData.objectionStatus === 0 ||
                          dialogRowData.objectionStatus === 2) ? (
                        <>
                          <div className="step-title step-title--with-action coa-step-title--compact">
                            <h4>DN Submission</h4>
                            <Box className="step-title__actions">
                              {canDownloadCoaDemandNotice(
                                dialogRowData.applicationProgressId,
                              ) && (
                                  <Button
                                    variant="outlined"
                                    onClick={handleDialogDnDownload}
                                    className="rco-bill-btn"
                                  >
                                    <PrintIcon /> DN
                                  </Button>
                                )}
                            </Box>
                          </div>
                          {
                            // CheckPermissions(permissions, 'General Services', 'Change of Attributes', 'Workflow Permissions', 'DN Submission') &&
                            CheckPermissions(
                              permissions,
                              "General Services",
                              "Change of Attributes",
                              "Workflow Permissions",
                              "Demand Note Submission"
                            ) ? (
                              <>
                                {dnApproveStep && (
                                  <Grid
                                    container
                                    spacing={2}
                                    className="dn-payment-submission-container"
                                  >
                                    {(() => {
                                      const total =
                                        (parseFloat(
                                          dnApproveStep.securityDepositeAmount
                                        ) || 0) +
                                        // (parseFloat(dnApproveStep.amountOfGridSharing) || 0) +
                                        // (parseFloat(dnApproveStep.amountOfFeederRehab) || 0) +
                                        (parseFloat(
                                          dnApproveStep.capitalCostAmount
                                        ) || 0);
                                      // (parseFloat(dnApproveStep.civilWorkCharges) || 0) +
                                      // (parseFloat(dnApproveStep.fixedChargesOfMetering) || 0) +
                                      // (parseFloat(dnApproveStep.miscellaneousCharges) || 0) -
                                      // (parseFloat(dnApproveStep.lessTheCost) || 0);

                                      const fields = [
                                        ...(isCoaRaastIdApplication(
                                          dialogRowData.applicationId
                                        )
                                          ? [
                                            {
                                              label: "Capital Cost Raast ID",
                                              value:
                                                dnApproveStep.capitalCostQR ||
                                                null,
                                              isText: true,
                                            },
                                            {
                                              label: "Security Raast ID",
                                              value:
                                                dnApproveStep.securityAmountQR ||
                                                null,
                                              isText: true,
                                            },
                                          ]
                                          : []),
                                        {
                                          label: "Issue Date",
                                          value: dnApproveStep.issueDate
                                            ? convertDate(dnApproveStep.issueDate)
                                            : null,
                                          isText: true,
                                        },
                                        {
                                          label: "Due Date",
                                          value: dnApproveStep.dueDate
                                            ? convertDate(dnApproveStep.dueDate)
                                            : null,
                                          isText: true,
                                        },
                                        {
                                          label: "Bank Name",
                                          value: dnApproveStep.bankName,
                                          isText: true,
                                        },
                                        {
                                          label: "Capital Cost",
                                          value:
                                            parseFloat(
                                              dnApproveStep.capitalCostAmount
                                            ) || 0,
                                        },
                                        {
                                          label: "Security Deposite Amount",
                                          value:
                                            parseFloat(
                                              dnApproveStep.securityDepositeAmount
                                            ) || 0,
                                        },
                                        {
                                          label:
                                            "Grand Total (Capital Amount + Security Amount)",
                                          value: total,
                                        },
                                      ];

                                      return fields
                                        .filter((item) => {
                                          if (item.isText) {
                                            return (
                                              item.value !== null &&
                                              item.value !== undefined &&
                                              item.value !== ""
                                            );
                                          }
                                          // For all other fields: show only if value > 0
                                          return item.value > 0;
                                        })
                                        .map((item, index) => (
                                          <Grid
                                            item
                                            lg={4}
                                            md={6}
                                            sm={12}
                                            key={index}
                                            className="item"
                                          >
                                            <Typography
                                              className="title"
                                              sx={{
                                                fontWeight: 600,
                                                color:
                                                  item.label === "Grand Total"
                                                    ? "#1976d2"
                                                    : "#333",
                                              }}
                                            >
                                              {item.label}
                                            </Typography>
                                            <Typography
                                              className="value"
                                              sx={
                                                item.label === "Grand Total"
                                                  ? {
                                                    backgroundColor:
                                                      "#1976d2 !important",
                                                    color: "#fff !important",
                                                    fontSize: "1.1rem",
                                                  }
                                                  : { color: "#444" }
                                              }
                                            >
                                              {item.isText
                                                ? item.value
                                                : numberFormatting(item.value)}
                                            </Typography>
                                          </Grid>
                                        ));
                                    })()}
                                  </Grid>
                                )}

                                <div className="rco-dn-submission-form">
                                  <div className="rco-dn-submission-form__field">
                                    <label
                                      className="fieldLabel"
                                      htmlFor="iv_receipt_image"
                                    >
                                      Receipt Image
                                    </label>
                                    {dnReceiptImageThumbnail ? (
                                      <div className="rco-dn-receipt-preview">
                                        {dnReceiptImageThumbnail.startsWith(
                                          "data:image/"
                                        ) ? (
                                          <img
                                            src={dnReceiptImageThumbnail}
                                            alt="Receipt Image"
                                          />
                                        ) : dnReceiptImageThumbnail.startsWith(
                                          "data:application/pdf"
                                        ) ? (
                                          <img
                                            src={pdfIcon}
                                            alt="Receipt PDF"
                                          />
                                        ) : (
                                          <img
                                            src={dnReceiptImageThumbnail}
                                            alt="Receipt Image"
                                          />
                                        )}
                                        <button
                                          type="button"
                                          className="rco-dn-receipt-preview__remove"
                                          onClick={clearDnReceiptImage}
                                          aria-label="Remove receipt"
                                        >
                                          <CloseIcon />
                                        </button>
                                      </div>
                                    ) : (
                                      <Button
                                        variant="outlined"
                                        component="label"
                                        startIcon={<FileUploadOutlinedIcon />}
                                        className="rco-dn-submission-upload"
                                        disabled={
                                          dnDetails &&
                                          dnDetails.filledFlag === 1 &&
                                          CheckPermissions(
                                            permissions,
                                            "General Services",
                                            "Change of Attributes",
                                            "Workflow Permissions",
                                            "Field Survey",
                                            "Survey Form Creation"
                                          )
                                        }
                                      >
                                        Upload
                                        <input
                                          hidden
                                          accept={documentExtensions}
                                          id="iv_receipt_image"
                                          name="iv_receipt_image"
                                          type="file"
                                          onChange={DnReceiptImage}
                                          onBlur={() =>
                                            dnPymentReceiptFormik.setFieldTouched(
                                              "iv_receipt_image",
                                              true
                                            )
                                          }
                                        />
                                      </Button>
                                    )}
                                    {receiptImageError ? (
                                      <p className="rco-dn-submission-form__error">
                                        {receiptImageError}
                                      </p>
                                    ) : null}
                                  </div>

                                  <div className="rco-dn-submission-form__field">
                                    <label
                                      className="fieldLabel"
                                      htmlFor="iv_payment_date_field"
                                    >
                                      Payment Date
                                    </label>
                                    <input
                                      id="iv_payment_date_field"
                                      name="iv_payment_date"
                                      type="date"
                                      className="rco-dn-submission-date"
                                      value={
                                        dnPymentReceiptFormik.values
                                          .iv_payment_date || ""
                                      }
                                      onChange={dnPymentReceiptFormik.handleChange}
                                      onBlur={dnPymentReceiptFormik.handleBlur}
                                      max={new Date().toISOString().split("T")[0]}
                                      min={
                                        dnApproveStep?.approvedDate
                                          ? (() => {
                                            const [datePart] =
                                              dnApproveStep.approvedDate.split(
                                                " "
                                              );
                                            const [month, day, year] =
                                              datePart.split("/");
                                            return `${year}-${month.padStart(
                                              2,
                                              "0"
                                            )}-${day.padStart(2, "0")}`;
                                          })()
                                          : undefined
                                      }
                                    />
                                    {dnPymentReceiptFormik.errors.iv_payment_date &&
                                      dnPymentReceiptFormik.touched.iv_payment_date ? (
                                      <p className="rco-dn-submission-form__error">
                                        {
                                          dnPymentReceiptFormik.errors
                                            .iv_payment_date
                                        }
                                      </p>
                                    ) : null}
                                    {paymentDateError ? (
                                      <p className="rco-dn-submission-form__error">
                                        {paymentDateError}
                                      </p>
                                    ) : null}
                                  </div>
                                </div>
                              </>
                            ) : (
                              <div className="description-box description-box--error">
                                <p className="group-description">
                                  <InfoIcon className="icon" />
                                  Demand Note Submission is in process by
                                  sanctioning authority.{" "}
                                </p>
                              </div>
                            )
                          }
                        </>
                      ) : dialogRowData.applicationProgressId === 7 &&
                        (dialogRowData.objectionStatus === 0 ||
                          dialogRowData.objectionStatus === 2) ? (
                        <>
                          <div className="step-title step-title--with-action coa-step-title--compact">
                            <h4>DN Payment Verification</h4>
                            <Box className="step-title__actions">
                              {canDownloadCoaDemandNotice(
                                dialogRowData.applicationProgressId,
                              ) && (
                                  <Button
                                    variant="outlined"
                                    onClick={handleDialogDnDownload}
                                    className="rco-bill-btn"
                                  >
                                    <PrintIcon /> DN
                                  </Button>
                                )}
                            </Box>
                          </div>
                          {
                            // CheckPermissions(permissions, 'General Services', 'Change of Attributes', 'Workflow Permissions', 'DN Payment Verification') &&

                            CheckPermissions(
                              permissions,
                              "General Services",
                              "Change of Attributes",
                              "Workflow Permissions",
                              "Demand Note Payment Verification"
                            ) &&
                              matchesCoaApprovalCategory(permissions, dialogRowData, allTariffList) ? (
                              <>
                                <Grid
                                  container
                                  spacing={2}
                                  className="dn-payment-submission-container coa-dn-payment-verify"
                                >
                                  <Grid item className="item">
                                    <Typography className="title">
                                      Demand Notice No
                                    </Typography>
                                    <Typography className="value">
                                      {dnApproveStep.demandNoteNo
                                        ? dnApproveStep.demandNoteNo
                                        : "-"}
                                    </Typography>
                                  </Grid>
                                  {isCoaRaastIdApplication(
                                    dialogRowData.applicationId
                                  ) && (
                                      <>
                                        <Grid item className="item">
                                          <Typography className="title">
                                            Capital Cost Raast ID
                                          </Typography>
                                          <Typography className="value">
                                            {dnApproveStep.capitalCostQR
                                              ? dnApproveStep.capitalCostQR
                                              : "-"}
                                          </Typography>
                                        </Grid>
                                        <Grid item className="item">
                                          <Typography className="title">
                                            Security Raast ID
                                          </Typography>
                                          <Typography className="value">
                                            {dnApproveStep.securityAmountQR
                                              ? dnApproveStep.securityAmountQR
                                              : "-"}
                                          </Typography>
                                        </Grid>
                                      </>
                                    )}
                                  <Grid item className="item">
                                    <Typography className="title">
                                      Reference No
                                    </Typography>
                                    <Typography className="value">
                                      {dnApproveStep.connectionAccountNo
                                        ? dnApproveStep.connectionAccountNo
                                        : "-"}
                                    </Typography>
                                  </Grid>
                                  <Grid item className="item">
                                    <Typography className="title">
                                      DN Amount
                                    </Typography>
                                    <Typography className="value">
                                      {(() => {
                                        const total =
                                          (parseFloat(
                                            dnApproveStep.securityDepositeAmount
                                          ) || 0) +
                                          (parseFloat(
                                            dnApproveStep.capitalCostAmount
                                          ) || 0);

                                        return total > 0
                                          ? numberFormatting(total)
                                          : "-";
                                      })()}
                                    </Typography>
                                  </Grid>
                                  <Grid
                                    item
                                    className="item coa-dn-payment-verify__payment-date"
                                  >
                                    <Typography className="title">
                                      Payment Date
                                    </Typography>
                                    <Typography className="value">
                                      {dnApproveStep.paymentDate
                                        ? convertDate(dnApproveStep.paymentDate)
                                        : "-"}
                                    </Typography>
                                  </Grid>

                                  <Grid
                                    item
                                    className="item paidDnDocument coa-dn-payment-verify__doc"
                                  >
                                    <Typography className="title">
                                      Paid Demand Notice
                                    </Typography>
                                    <div
                                      className="rco-paid-dn-image"
                                      onClick={() => {
                                        openPaidDnImageViewer(
                                          paidDNVoucherImg || dnImage
                                        );
                                      }}
                                      onKeyDown={(e) => {
                                        if (e.key === "Enter" || e.key === " ") {
                                          openPaidDnImageViewer(
                                            paidDNVoucherImg || dnImage
                                          );
                                        }
                                      }}
                                      role="button"
                                      tabIndex={0}
                                    >
                                      {paidDNVoucherImg ? (
                                        <img
                                          src={paidDNVoucherImg}
                                          alt="Paid Demand Notice"
                                        />
                                      ) : (
                                        <Base64Image data={dnImage} width={80} />
                                      )}
                                    </div>
                                  </Grid>

                                  <Grid
                                    item
                                    className="item coa-dn-payment-verify__doc"
                                  >
                                    <Typography className="title">
                                      Customer ID. Front
                                    </Typography>
                                    <div
                                      className="rco-paid-dn-image"
                                      onClick={() => {
                                        if (!copyOfApplicantCNICVerifyPopUp) {
                                          setCopyOfApplicantCNICVerifyPopUp(true);
                                        }
                                      }}
                                      onKeyDown={(e) => {
                                        if (
                                          (e.key === "Enter" || e.key === " ") &&
                                          !copyOfApplicantCNICVerifyPopUp
                                        ) {
                                          setCopyOfApplicantCNICVerifyPopUp(true);
                                        }
                                      }}
                                      role="button"
                                      tabIndex={0}
                                    >
                                      <img
                                        src={
                                          frontImg ||
                                          (isPdfDataUrl(dialogRowData.applicantCNICFront)
                                            ? undefined
                                            : dialogRowData.applicantCNICFront)
                                        }
                                        alt="Cnic Front"
                                      />
                                    </div>
                                  </Grid>

                                  <Grid
                                    item
                                    className="item coa-dn-payment-verify__doc"
                                  >
                                    <Typography className="title">
                                      Customer ID. Back
                                    </Typography>
                                    <div
                                      className="rco-paid-dn-image"
                                      onClick={() => {
                                        if (!copyOfApplicantCNICVerifyPopUp) {
                                          setCopyOfApplicantCNICVerifyPopUp(true);
                                        }
                                      }}
                                      onKeyDown={(e) => {
                                        if (
                                          (e.key === "Enter" || e.key === " ") &&
                                          !copyOfApplicantCNICVerifyPopUp
                                        ) {
                                          setCopyOfApplicantCNICVerifyPopUp(true);
                                        }
                                      }}
                                      role="button"
                                      tabIndex={0}
                                    >
                                      <img
                                        src={
                                          backImg ||
                                          (isPdfDataUrl(dialogRowData.applicantCNICBack)
                                            ? undefined
                                            : dialogRowData.applicantCNICBack)
                                        }
                                        alt="Cnic Back"
                                      />
                                    </div>
                                    {!isCoaActivityLogDialogOpen &&
                                      copyOfApplicantCNICVerifyPopUp && (
                                        <OpenBase64ImageInPopup
                                          docVerifyPopUp={copyOfApplicantCNICVerifyPopUp}
                                          hideDocVerifyPopup={
                                            hideCopyOfApplicantCNICVerifyAlert
                                          }
                                          documentName="Applicant CNIC"
                                          documentImage={dialogRowData.applicantCNICFront}
                                          backDocumentImage={dialogRowData.applicantCNICBack}
                                          width={"100%"}
                                          readOnly
                                          document={dialogRowData.applicantCNICFront}
                                          documentFlag={dialogRowData.applicantCNICFrontFlag}
                                          applicationProgressId={
                                            dialogRowData.applicationProgressId
                                          }
                                          objectionStatus={dialogRowData.objectionStatus}
                                          updateDocFlag={updateDocFlag}
                                          titleToUpdateFlag="copyOfApplicantCNIC"
                                          flag_document={flag_applicantCNICFront}
                                          flag_documentBack={flag_applicantCNICBack}
                                        />
                                      )}
                                  </Grid>
                                </Grid>
                              </>
                            ) : (
                              <div className="description-box description-box--error">
                                <p className="group-description">
                                  <InfoIcon className="icon" />
                                  DN Payment Verification is in process by
                                  sanctioning authority.{" "}
                                </p>
                              </div>
                            )
                          }
                        </>
                      ) : dialogRowData.applicationProgressId === 8 &&
                        (dialogRowData.objectionStatus === 0 ||
                          dialogRowData.objectionStatus === 2) &&
                        dialogRowData.scoFillFlag === null ? (
                        <>
                          {(dialogRowData.changeOfAttributesType == 1 ||
                            dialogRowData.changeOfAttributesType == 2 ||
                            dialogRowData.changeOfAttributesType == 3 ||
                            dialogRowData.changeOfAttributesType == 4 ||
                            dialogRowData.changeOfAttributesType == 5 ||
                            dialogRowData.changeOfAttributesType == 6 ||
                            dialogRowData.changeOfAttributesType == 7) && (
                              <>
                                {/* Title & Button - Sirf Ek Dafa */}
                                <Grid
                                  container
                                  className="step-title"
                                  sx={{ marginBottom: "1%", padding: "0.5%" }}
                                >
                                  <Grid item lg={1}></Grid>
                                  <Grid item lg={10} sx={{ textAlign: "center" }}>
                                    <h4>Sundry Jobs Order</h4>
                                  </Grid>
                                </Grid>

                                {CheckPermissions(
                                  permissions,
                                  "General Services",
                                  "Change of Attributes",
                                  "Workflow Permissions",
                                  "Sundry Job Order",
                                  "SJO Submission"
                                ) &&
                                  matchesCoaApprovalCategory(permissions, dialogRowData, allTariffList) ? (
                                  <Grid
                                    container
                                    className="dn-payment-submission-container"
                                  >
                                    <Grid
                                      item
                                      lg={12}
                                      className="coa-sjo-paragraph-cell"
                                    >
                                      <Typography
                                        component="p"
                                        className="coa-sjo-paragraph"
                                      >
                                        {dnApproveStep.sjoData
                                          ? dnApproveStep.sjoData
                                          : "-"}
                                      </Typography>
                                    </Grid>

                                    {/* Table - Content Type ke Hisaab se Change */}
                                    <Grid item lg={12} mt={2} className="coa-sjo-table-cell">
                                      <Table
                                        sx={{
                                          borderCollapse: "collapse",
                                          width: "100%",
                                          boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                                          overflow: "hidden",
                                        }}
                                      >
                                        <TableHead>
                                          <TableRow
                                            sx={{
                                              backgroundImage:
                                                "linear-gradient(180deg, #1e52a7, #a0bbe7)",
                                            }}
                                          >
                                            <TableCell
                                              sx={{
                                                color: "white",
                                                fontWeight: "bold",
                                                border: "1px solid #1565c0",
                                                padding: "6px 10px",
                                              }}
                                            ></TableCell>

                                            {/* Column Labels: Current/New ya New/Old */}
                                            {[1, 4, 5, 6].includes(
                                              dialogRowData.changeOfAttributesType
                                            ) ? (
                                              <>
                                                <TableCell
                                                  sx={{
                                                    color: "white",
                                                    fontWeight: "bold",
                                                    border: "1px solid #1565c0",
                                                    padding: "6px 10px",
                                                  }}
                                                >
                                                  Current
                                                </TableCell>
                                                <TableCell
                                                  sx={{
                                                    color: "white",
                                                    fontWeight: "bold",
                                                    border: "1px solid #1565c0",
                                                    padding: "6px 10px",
                                                  }}
                                                >
                                                  New
                                                </TableCell>
                                              </>
                                            ) : (
                                              <>
                                                <TableCell
                                                  sx={{
                                                    color: "white",
                                                    fontWeight: "bold",
                                                    border: "1px solid #1565c0",
                                                    padding: "6px 10px",
                                                  }}
                                                >
                                                  Old
                                                </TableCell>
                                                <TableCell
                                                  sx={{
                                                    color: "white",
                                                    fontWeight: "bold",
                                                    border: "1px solid #1565c0",
                                                    padding: "6px 10px",
                                                  }}
                                                >
                                                  New
                                                </TableCell>
                                              </>
                                            )}
                                          </TableRow>
                                        </TableHead>

                                        <TableBody>
                                          {getTableRows(dialogRowData).map(
                                            (row, index) => (
                                              <TableRow
                                                key={index}
                                                sx={{
                                                  backgroundColor:
                                                    index % 2 === 0
                                                      ? "white"
                                                      : "rgb(213, 229, 255)",
                                                  "&:hover": {
                                                    backgroundColor: "#e3f2fd",
                                                  },
                                                }}
                                              >
                                                <TableCell
                                                  sx={{
                                                    fontWeight: "bold",
                                                    border: "1px solid #e0e0e0",
                                                    padding: "8px 16px",
                                                  }}
                                                >
                                                  {row.label || "-"}
                                                </TableCell>
                                                <TableCell
                                                  sx={{
                                                    border: "1px solid #e0e0e0",
                                                    padding: "8px 16px",
                                                  }}
                                                >
                                                  {row.current}
                                                </TableCell>
                                                <TableCell
                                                  sx={{
                                                    border: "1px solid #e0e0e0",
                                                    padding: "8px 16px",
                                                  }}
                                                >
                                                  {row.newVal}
                                                </TableCell>
                                              </TableRow>
                                            )
                                          )}
                                        </TableBody>
                                      </Table>
                                    </Grid>
                                  </Grid>
                                ) : (
                                  <div className="description-box description-box--error">
                                    <p className="group-description">
                                      <InfoIcon className="icon" />
                                      Sundary Job Order Submission is in process by
                                      sanctioning authority.{" "}
                                    </p>
                                  </div>
                                )}
                              </>
                            )}
                        </>
                      ) : dialogRowData.applicationProgressId === 8 &&
                        dialogRowData.scoFillFlag === 1 ? (
                        <>
                          {(dialogRowData.changeOfAttributesType == 1 ||
                            dialogRowData.changeOfAttributesType == 2 ||
                            dialogRowData.changeOfAttributesType == 3 ||
                            dialogRowData.changeOfAttributesType == 4 ||
                            dialogRowData.changeOfAttributesType == 5 ||
                            dialogRowData.changeOfAttributesType == 6 ||
                            dialogRowData.changeOfAttributesType == 7) && (
                              <>
                                <Grid
                                  container
                                  className="step-title"
                                  sx={{ marginBottom: "1%", padding: "0.5%" }}
                                >
                                  <Grid item lg={1}></Grid>
                                  <Grid item lg={10} sx={{ textAlign: "center" }}>
                                    <h4>Sundry Jobs Order</h4>
                                  </Grid>
                                </Grid>

                                {CheckPermissions(
                                  permissions,
                                  "General Services",
                                  "Change of Attributes",
                                  "Workflow Permissions",
                                  "Sundry Job Order",
                                  "SJO Approval"
                                ) &&
                                  matchesCoaApprovalCategory(permissions, dialogRowData, allTariffList) ? (
                                  <Grid
                                    container
                                    className="dn-payment-submission-container"
                                  >
                                    <Grid
                                      item
                                      lg={12}
                                      className="coa-sjo-paragraph-cell"
                                    >
                                      <Typography
                                        component="p"
                                        className="coa-sjo-paragraph"
                                      >
                                        {dnApproveStep.sjoData
                                          ? dnApproveStep.sjoData
                                          : "-"}
                                      </Typography>
                                    </Grid>

                                    {/* Table - Content Type ke Hisaab se Change */}
                                    <Grid item lg={12} mt={2} className="coa-sjo-table-cell">
                                      <Table
                                        sx={{
                                          borderCollapse: "collapse",
                                          width: "100%",
                                          boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                                          overflow: "hidden",
                                        }}
                                      >
                                        <TableHead>
                                          <TableRow
                                            sx={{
                                              backgroundImage:
                                                "linear-gradient(180deg, #1e52a7, #a0bbe7)",
                                            }}
                                          >
                                            <TableCell
                                              sx={{
                                                color: "white",
                                                fontWeight: "bold",
                                                border: "1px solid #1565c0",
                                                padding: "6px 10px",
                                              }}
                                            ></TableCell>

                                            {/* Column Labels: Current/New ya New/Old */}
                                            {[1, 4, 5, 6].includes(
                                              dialogRowData.changeOfAttributesType
                                            ) ? (
                                              <>
                                                <TableCell
                                                  sx={{
                                                    color: "white",
                                                    fontWeight: "bold",
                                                    border: "1px solid #1565c0",
                                                    padding: "6px 10px",
                                                  }}
                                                >
                                                  Current
                                                </TableCell>
                                                <TableCell
                                                  sx={{
                                                    color: "white",
                                                    fontWeight: "bold",
                                                    border: "1px solid #1565c0",
                                                    padding: "6px 10px",
                                                  }}
                                                >
                                                  New
                                                </TableCell>
                                              </>
                                            ) : (
                                              <>
                                                <TableCell
                                                  sx={{
                                                    color: "white",
                                                    fontWeight: "bold",
                                                    border: "1px solid #1565c0",
                                                    padding: "6px 10px",
                                                  }}
                                                >
                                                  Old
                                                </TableCell>
                                                <TableCell
                                                  sx={{
                                                    color: "white",
                                                    fontWeight: "bold",
                                                    border: "1px solid #1565c0",
                                                    padding: "6px 10px",
                                                  }}
                                                >
                                                  New
                                                </TableCell>
                                              </>
                                            )}
                                          </TableRow>
                                        </TableHead>

                                        <TableBody>
                                          {getTableRows(dialogRowData).map(
                                            (row, index) => (
                                              <TableRow
                                                key={index}
                                                sx={{
                                                  backgroundColor:
                                                    index % 2 === 0
                                                      ? "white"
                                                      : "rgb(213, 229, 255)",
                                                  "&:hover": {
                                                    backgroundColor: "#e3f2fd",
                                                  },
                                                }}
                                              >
                                                <TableCell
                                                  sx={{
                                                    fontWeight: "bold",
                                                    border: "1px solid #e0e0e0",
                                                    padding: "8px 16px",
                                                  }}
                                                >
                                                  {row.label || "-"}
                                                </TableCell>
                                                <TableCell
                                                  sx={{
                                                    border: "1px solid #e0e0e0",
                                                    padding: "8px 16px",
                                                  }}
                                                >
                                                  {row.current}
                                                </TableCell>
                                                <TableCell
                                                  sx={{
                                                    border: "1px solid #e0e0e0",
                                                    padding: "8px 16px",
                                                  }}
                                                >
                                                  {row.newVal}
                                                </TableCell>
                                              </TableRow>
                                            )
                                          )}
                                        </TableBody>
                                      </Table>
                                    </Grid>
                                  </Grid>
                                ) : (
                                  <div className="description-box description-box--error">
                                    <p className="group-description">
                                      <InfoIcon className="icon" />
                                      Sundary Job Order Approval is in process by
                                      sanctioning authority.{" "}
                                    </p>
                                  </div>
                                )}
                              </>
                            )}
                        </>
                      ) : dialogRowData.applicationProgressId === 9 &&
                        (dialogRowData.objectionStatus === 0 ||
                          dialogRowData.objectionStatus === 2) ? (
                        <>
                          <Grid
                            container
                            className="step-title"
                            sx={{ marginBottom: "1%", padding: "0.5%" }}
                          >
                            <Grid item lg={1}></Grid>
                            <Grid item lg={10} sx={{ textAlign: "center" }}>
                              <h4>Ready for Billing</h4>
                            </Grid>
                          </Grid>
                          {CheckPermissions(
                            permissions,
                            "General Services",
                            "Change of Attributes",
                            "Workflow Permissions",
                            "Ready For Billing"
                          ) &&
                            matchesCoaApprovalCategory(permissions, dialogRowData, allTariffList) ? (
                            <Grid
                              container
                              className="dn-payment-submission-container"
                            >
                              <Grid item lg={12} className="coa-sjo-paragraph-cell">
                                <Typography component="p" className="coa-sjo-paragraph">
                                  {dnApproveStep.sjoData
                                    ? dnApproveStep.sjoData
                                    : "-"}
                                </Typography>
                              </Grid>

                              {/* Table - Content Type ke Hisaab se Change */}
                              <Grid item lg={12} mt={2} className="coa-sjo-table-cell">
                                <Table
                                  sx={{
                                    borderCollapse: "collapse",
                                    width: "100%",
                                    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                                    overflow: "hidden",
                                  }}
                                >
                                  <TableHead>
                                    <TableRow
                                      sx={{
                                        backgroundImage:
                                          "linear-gradient(180deg, #1e52a7, #a0bbe7)",
                                      }}
                                    >
                                      <TableCell
                                        sx={{
                                          color: "white",
                                          fontWeight: "bold",
                                          border: "1px solid #1565c0",
                                          padding: "6px 10px",
                                        }}
                                      ></TableCell>

                                      {/* Column Labels: Current/New ya New/Old */}
                                      {[1, 4, 5, 6].includes(
                                        dialogRowData.changeOfAttributesType
                                      ) ? (
                                        <>
                                          <TableCell
                                            sx={{
                                              color: "white",
                                              fontWeight: "bold",
                                              border: "1px solid #1565c0",
                                              padding: "6px 10px",
                                            }}
                                          >
                                            Current
                                          </TableCell>
                                          <TableCell
                                            sx={{
                                              color: "white",
                                              fontWeight: "bold",
                                              border: "1px solid #1565c0",
                                              padding: "6px 10px",
                                            }}
                                          >
                                            New
                                          </TableCell>
                                        </>
                                      ) : (
                                        <>
                                          <TableCell
                                            sx={{
                                              color: "white",
                                              fontWeight: "bold",
                                              border: "1px solid #1565c0",
                                              padding: "6px 10px",
                                            }}
                                          >
                                            Old
                                          </TableCell>
                                          <TableCell
                                            sx={{
                                              color: "white",
                                              fontWeight: "bold",
                                              border: "1px solid #1565c0",
                                              padding: "6px 10px",
                                            }}
                                          >
                                            New
                                          </TableCell>
                                        </>
                                      )}
                                    </TableRow>
                                  </TableHead>

                                  <TableBody>
                                    {getTableRows(dialogRowData).map(
                                      (row, index) => (
                                        <TableRow
                                          key={index}
                                          sx={{
                                            backgroundColor:
                                              index % 2 === 0
                                                ? "white"
                                                : "rgb(213, 229, 255)",
                                            "&:hover": {
                                              backgroundColor: "#e3f2fd",
                                            },
                                          }}
                                        >
                                          <TableCell
                                            sx={{
                                              fontWeight: "bold",
                                              border: "1px solid #e0e0e0",
                                              padding: "8px 16px",
                                            }}
                                          >
                                            {row.label || "-"}
                                          </TableCell>
                                          <TableCell
                                            sx={{
                                              border: "1px solid #e0e0e0",
                                              padding: "8px 16px",
                                            }}
                                          >
                                            {row.current}
                                          </TableCell>
                                          <TableCell
                                            sx={{
                                              border: "1px solid #e0e0e0",
                                              padding: "8px 16px",
                                            }}
                                          >
                                            {row.newVal}
                                          </TableCell>
                                        </TableRow>
                                      )
                                    )}
                                  </TableBody>
                                </Table>
                              </Grid>
                            </Grid>
                          ) : (
                            <div className="description-box description-box--error">
                              <p className="group-description">
                                <InfoIcon className="icon" />
                                Ready for Billing Approval is in process by
                                sanctioning authority.{" "}
                              </p>
                            </div>
                          )}
                        </>
                      ) : dialogRowData.applicationProgressId === 10 &&
                        (dialogRowData.objectionStatus === 0 ||
                          dialogRowData.objectionStatus === 2) ? (
                        <>
                          <Grid
                            container
                            className="step-title step-title--with-action"
                          >
                            <h4>Application Completed</h4>
                            <Box className="step-title__actions">
                              <Button
                                variant="outlined"
                                onClick={() =>
                                  downloadSJOPDF(
                                    dialogRowData.applicationId,
                                    scoDetails,
                                    dialogRowData,
                                    dnDets
                                  )
                                }
                                className="rco-bill-btn"
                              >
                                <PrintIcon /> SJO
                              </Button>
                            </Box>
                          </Grid>
                          <div className="rco-workflow-success-banner">
                            <CheckCircleIcon className="rco-workflow-success-banner__icon" />
                            <p className="rco-workflow-success-banner__text">
                              Application Completed.
                            </p>
                          </div>
                        </>
                      ) : null}
                    </div>
                    <div className="actions">
                      {dialogRowData.applicationProgressId === 0 ? ( //Document Submission
                        // CheckPermissions(permissions, 'General Services', 'Change of Attributes', 'Basic Permissions', 'Update') ?
                        CheckPermissions(
                          permissions,
                          "General Services",
                          "Change of Attributes"
                        ) ? (
                          <Button
                            onClick={() =>
                              navigate("/change-of-attributes-update", {
                                state: { dialogRowData },
                              })
                            }
                            variant="contained"
                            sx={{ backgroundColor: "blue" }}
                          >
                            Upload Pending Documents
                          </Button>
                        ) : null
                      ) : dialogRowData.applicationProgressId === 1 &&
                        (dialogRowData.objectionStatus === 0 ||
                          dialogRowData.objectionStatus === 2) ? ( //
                        CheckPermissions(
                          permissions,
                          "General Services",
                          "Change of Attributes",
                          "Workflow Permissions",
                          "Documents Verification"
                        ) ? (
                          <>
                            {dialogRowData.applicantCNICFrontFlag !== 1 ||
                              dialogRowData.applicantCNICBackFlag !== 1 ||
                              dialogRowData.owenershipDocumentFlag !== 1 ||
                              dialogRowData.electricityBillDocumentFlag !== 1 ||
                              dialogRowData.fbrDocument !== 1 ? (
                              <>
                                <button
                                  disabled={!isCoaDocumentVerificationReadyToSubmit()}
                                  onClick={() => updateDocumentStatus()}
                                  className="view-button"
                                  style={{
                                    backgroundColor:
                                      flag_applicantCNICFront === -1 ||
                                        flag_applicantCNICBack === -1 ||
                                        flag_owenershipDocument === -1 ||
                                        flag_electricityBillDocument === -1 ||
                                        flag_fbrDocument === -1 ||
                                        flag_addDocAnyOther === -1
                                        ? "#E11B3C"
                                        : "#003971",
                                  }}
                                >
                                  {flag_applicantCNICFront === -1 ||
                                    flag_applicantCNICBack === -1 ||
                                    flag_owenershipDocument === -1 ||
                                    flag_electricityBillDocument === -1 ||
                                    flag_fbrDocument === -1 ||
                                    flag_addDocAnyOther === -1
                                    ? "Reject"
                                    : "Verify"}
                                </button>
                              </>
                            ) : null}
                          </>
                        ) : (
                          <></>
                        )
                      ) : dialogRowData.applicationProgressId === 2 &&
                        (dialogRowData.objectionStatus !== 1 ||
                          dialogRowData.objectionStatus == 2) ? (
                        <>
                          {dialogRowData.wiringTestReportDocument ? (
                            CheckPermissions(
                              permissions,
                              "General Services",
                              "Change of Attributes",
                              "Workflow Permissions",
                              "Wiring Test Report"
                            ) && (
                              <button
                                disabled={!hasCoaDocumentActionTaken(flag_wiringTestReport)}
                                onClick={() => {
                                  if (flag_wiringTestReport === 1) {
                                    verifyOrRejectWiringTestReport(
                                      dialogRowData.applicationId,
                                      3,
                                      0,
                                      "Wiring Test Report Verified",
                                      1,
                                      "Wiring Test Report Verified"
                                    );
                                  } else if (flag_wiringTestReport === -1) {
                                    verifyOrRejectWiringTestReport(
                                      dialogRowData.applicationId,
                                      2,
                                      1,
                                      "Wiring Test Report Rejected",
                                      -1,
                                      wiringTestReportObjectionRemarks
                                    );
                                  }
                                }}
                                className="view-button"
                                style={{
                                  backgroundColor:
                                    flag_wiringTestReport === -1
                                      ? "#E11B3C"
                                      : flag_wiringTestReport === 1
                                        ? "#003971"
                                        : "#cccccc",
                                }}
                              >
                                {flag_wiringTestReport === -1 ? "Reject" : "Verify"}
                              </button>
                            )
                          ) : (
                            CheckPermissions(
                              permissions,
                              "General Services",
                              "Change of Attributes",
                              "Basic Permissions",
                              "Update"
                            ) && (
                              <button
                                disabled={!newWiringTestReportDocumentThumbnail}
                                onClick={uploadWiringTestReport}
                                className="view-button"
                                style={{
                                  backgroundColor: newWiringTestReportDocumentThumbnail
                                    ? "#003971"
                                    : "#cccccc",
                                  cursor: newWiringTestReportDocumentThumbnail
                                    ? "pointer"
                                    : "not-allowed",
                                }}
                              >
                                Submit
                              </button>
                            )
                          )}
                        </>
                      ) : dialogRowData.applicationProgressId === 1 &&
                        dialogRowData.objectionStatus === 1 ? (
                        <>
                          {CheckPermissions(
                            permissions,
                            "General Services",
                            "Change of Attributes",
                            "Basic Permissions",
                            "Update"
                          ) ? (
                            <>
                              <button
                                type="button"
                                onClick={() => {
                                  setOpen(false);
                                  if (!props.showTable && typeof props.onCloseSearchResults === 'function') {
                                    props.onCloseSearchResults();
                                  }
                                  navigate("/change-of-attributes-update", {
                                    state: { dialogRowData },
                                  });
                                }}
                                className="view-button"
                              >
                                Re-Upload Document
                              </button>
                            </>
                          ) : (
                            <></>
                          )}
                        </>
                      ) : dialogRowData.applicationProgressId === 2 &&
                        dialogRowData.objectionStatus == 1 ? (
                        <>
                          {CheckPermissions(
                            permissions,
                            "General Services",
                            "Change of Attributes",
                            "Basic Permissions",
                            "Update"
                          ) && (
                              <button
                                disabled={!newWiringTestReportDocumentThumbnail}
                                onClick={reuploadWiringTestReportAndRemoveObjection}
                                className="view-button"
                                style={{
                                  marginRight: "10px",
                                  backgroundColor: newWiringTestReportDocumentThumbnail
                                    ? "#003971"
                                    : "#cccccc",
                                  cursor: newWiringTestReportDocumentThumbnail
                                    ? "pointer"
                                    : "not-allowed",
                                }}
                              >
                                Remove Objection
                              </button>
                            )}
                        </>
                      ) : dialogRowData.applicationProgressId === 3 &&
                        (dialogRowData.objectionStatus === 0 ||
                          dialogRowData.objectionStatus === 2) ? (
                        <>
                          {CheckPermissions(
                            permissions,
                            "General Services",
                            "Change of Attributes",
                            "Workflow Permissions",
                            "Arrears Verification"
                          ) &&
                            matchesCoaApprovalCategory(permissions, dialogRowData, allTariffList) && (
                              <Grid container spacing={2} justifyContent="end">
                                {paymentStatus === "No arrear exists" && (
                                  <Grid item>
                                    <button
                                      className="view-button"
                                      onClick={() =>
                                        callArrearVerificationAPI(
                                          dialogRowData.applicationId,
                                          dialogRowData.applicationProgressId + 1,
                                          0,
                                          "Arrears Verified",
                                          "Arrears Verified",
                                          0,
                                          "",
                                          null
                                        )
                                      }
                                      style={{
                                        backgroundColor: "#003971",
                                        color: "white",
                                        border: "none",
                                        borderRadius: "20px",
                                        padding: "10px 40px",
                                        fontSize: "16px",
                                        cursor: "pointer",
                                        width: "100%",
                                      }}
                                    >
                                      Approve
                                    </button>
                                  </Grid>
                                )}

                                {paymentStatus === "Arrear exists" && (
                                  <>
                                    <Grid item>
                                      <button
                                        className="view-button"
                                        onClick={() =>
                                          callArrearVerificationAPI(
                                            dialogRowData.applicationId,
                                            dialogRowData.applicationProgressId,
                                            1,
                                            "Arrears Exist",
                                            `Arrears Exist For Bill Month: ${billMonth}, Rs. : ${arrearAmount}`,
                                            arrearAmount,
                                            billMonth,
                                            null
                                          )
                                        }
                                        style={{
                                          backgroundColor: "#e11b3c",
                                          color: "white",
                                          border: "none",
                                          borderRadius: "20px",
                                          padding: "10px 40px",
                                          fontSize: "16px",
                                          cursor: "pointer",
                                          width: "100%",
                                        }}
                                      >
                                        Reject
                                      </button>
                                    </Grid>

                                    <Grid item>
                                      <button
                                        className="view-button"
                                        onClick={
                                          arrearPaymentReceiptFormik.handleSubmit
                                        }
                                        style={{
                                          backgroundColor: "#003971",
                                          color: "white",
                                          border: "none",
                                          borderRadius: "20px",
                                          padding: "10px 40px",
                                          fontSize: "16px",
                                          cursor: "pointer",
                                          width: "100%",
                                        }}
                                      >
                                        Approve
                                      </button>
                                    </Grid>
                                  </>
                                )}
                              </Grid>
                            )}
                        </>
                      ) : dialogRowData.applicationProgressId === 3 &&
                        dialogRowData.objectionStatus === 1 ? (
                        <>
                          {CheckPermissions(
                            permissions,
                            "General Services",
                            "Change of Attributes",
                            "Workflow Permissions",
                            "Arrears Verification"
                          ) &&
                            matchesCoaApprovalCategory(permissions, dialogRowData, allTariffList) && (
                              <Grid item>
                                <button
                                  className="view-button"
                                  onClick={arrearPaymentReceiptFormik.handleSubmit}
                                  style={{
                                    backgroundColor: "#e11b3c",
                                    color: "white",
                                    border: "none",
                                    borderRadius: "20px",
                                    padding: "10px 40px",
                                    fontSize: "16px",
                                    cursor: "pointer",
                                    width: "20%",
                                  }}
                                >
                                  Remove & Approve
                                </button>
                              </Grid>
                            )}
                        </>
                      ) : dialogRowData.applicationProgressId === 4 &&
                        (dialogRowData.objectionStatus === 0 ||
                          dialogRowData.objectionStatus === 2) ? (
                        <>
                          {CheckPermissions(
                            permissions,
                            "General Services",
                            "Change of Attributes",
                            "Workflow Permissions",
                            "Field Survey"
                          ) &&
                            matchesCoaApprovalCategory(permissions, dialogRowData, allTariffList) && (
                              <div className="rco-field-survey-actions">
                                <button
                                  type="submit"
                                  className="view-button"
                                  onClick={fieldFormik.handleSubmit}
                                >
                                  Submit
                                </button>
                              </div>
                            )}
                        </>
                      ) : dialogRowData.applicationProgressId === 4 &&
                        dialogRowData.objectionStatus === 1 ? (
                        <>
                          {CheckPermissions(
                            permissions,
                            "General Services",
                            "Change of Attributes",
                            "Workflow Permissions",
                            "Field Survey"
                          ) &&
                            matchesCoaApprovalCategory(permissions, dialogRowData, allTariffList) && (
                              <div className="rco-field-survey-actions">
                                <button
                                  type="button"
                                  className="view-button"
                                  onClick={handleRemoveFieldSurveyObjection}
                                >
                                  Remove Objection
                                </button>
                              </div>
                            )}
                        </>
                      ) : dialogRowData.applicationProgressId === 4 &&
                        (dialogRowData.objectionStatus === 0 ||
                          dialogRowData.objectionStatus === 2) &&
                        CheckPermissions(
                          permissions,
                          "General Services",
                          "Change of Attributes",
                          "Workflow Permissions",
                          "Field Survey"
                        ) &&
                        matchesCoaApprovalCategory(permissions, dialogRowData, allTariffList) ? (
                        <>
                          <button
                            className="view-button"
                            onClick={() => {
                              costEstimation(
                                dialogRowData.applicationId,
                                dialogRowData.referenceNumber,
                                4,
                                0,
                                "Cost Estimated.",
                                bankName,
                                dnDetails.previousSecurityAmount,
                                dnDetails.currentEstimatedSecurityAmount,
                                dnDetails.totalEstimatedAmount
                              );
                            }}
                          >
                            Save Estimation
                          </button>
                        </>
                      ) : dialogRowData.applicationProgressId === 5 &&
                        Number(dialogRowData.objectionStatus) === 1 &&
                        CheckPermissions(
                          permissions,
                          "General Services",
                          "Change of Attributes",
                          "Workflow Permissions",
                          "Restore Application"
                        ) &&
                        matchesCoaApprovalCategory(
                          permissions,
                          dialogRowData,
                          allTariffList,
                        ) ? (
                        <Box className="ref-no-allocation-footer">
                          <Box
                            className="ref-no-allocation-actions"
                            sx={{
                              display: "flex",
                              justifyContent: "flex-end",
                              alignItems: "center",
                              flexWrap: "wrap",
                              gap: "10px",
                              width: "100%",
                              "& .view-button, & .reject-button": {
                                float: "none !important",
                                width: "auto !important",
                                minWidth: "140px",
                                maxWidth: "220px",
                                margin: "0 !important",
                                padding: "10px 16px",
                                borderRadius: "8px",
                              },
                            }}
                          >
                            <button
                              type="button"
                              className="view-button"
                              onClick={showRestoreApplicationPopup}
                            >
                              Restore Application
                            </button>
                          </Box>
                        </Box>
                      ) : dialogRowData.applicationProgressId === 5 &&
                        (dialogRowData.objectionStatus === 0 ||
                          dialogRowData.objectionStatus === 2) &&
                        CheckPermissions(
                          permissions,
                          "General Services",
                          "Change of Attributes",
                          "Workflow Permissions",
                          "Demand Note Approval"
                        ) &&
                        matchesCoaApprovalCategory(permissions, dialogRowData, allTariffList) ? (
                        <Box className="ref-no-allocation-footer">
                          <Box
                            className="ref-no-allocation-actions"
                            sx={{
                              display: "flex",
                              justifyContent: "flex-end",
                              alignItems: "center",
                              flexWrap: "wrap",
                              gap: "10px",
                              width: "100%",
                              "& .view-button, & .reject-button": {
                                float: "none !important",
                                width: "auto !important",
                                minWidth: "140px",
                                maxWidth: "220px",
                                margin: "0 !important",
                                padding: "10px 16px",
                              },
                            }}
                          >
                            <button
                              onClick={() => {
                                showObjectionPopup();
                              }}
                              type="button"
                              className="reject-button"
                            >
                              Reject
                            </button>
                            <button
                              onClick={() => {
                                showCancelApplicationPopup();
                              }}
                              type="button"
                              className="reject-button"
                            >
                              Cancel Application
                            </button>
                            <button
                              onClick={() => {
                                DNApproveAPI(
                                  dialogRowData.applicationId,
                                  dialogRowData.applicationProgressId + 1,
                                  0,
                                  "Demand Note approved."
                                );
                              }}
                              type="button"
                              className="view-button"
                              disabled={!dnDocumentsCertified}
                            >
                              Approve
                            </button>
                          </Box>
                        </Box>
                      ) : dialogRowData.applicationProgressId === 6 &&
                        (dialogRowData.objectionStatus === 0 ||
                          dialogRowData.objectionStatus === 2) &&
                        CheckPermissions(
                          permissions,
                          "General Services",
                          "Change of Attributes",
                          "Workflow Permissions",
                          "Demand Note Submission"
                        ) ? (
                        <button
                          onClick={handleDnPaymentReceiptSubmit}
                          type="button"
                          className="view-button"
                        >
                          Submit
                        </button>
                      ) : dialogRowData.applicationProgressId === 7 &&
                        (dialogRowData.objectionStatus === 0 ||
                          dialogRowData.objectionStatus === 2) &&
                        CheckPermissions(
                          permissions,
                          "General Services",
                          "Change of Attributes",
                          "Workflow Permissions",
                          "Demand Note Payment Verification"
                        ) &&
                        matchesCoaApprovalCategory(permissions, dialogRowData, allTariffList) ? (
                        <div>
                          <button
                            onClick={() => {
                              DNPaymentVerificationAPI(
                                dialogRowData.applicationId,
                                dialogRowData.applicationProgressId + 1,
                                0,
                                "Demand Note Payment Verified.",
                                "Demand Note Payment Verified."
                              );
                            }}
                            className="view-button"
                          >
                            Verify
                          </button>
                          {/* <button onClick={() => { DNPaymentVerificationAPI(dialogRowData.applicationId, dialogRowData.applicationProgressId - 1, 1, "Demand Note Payment rejected.") }} className='reject-button' style={{ float: 'right', marginRight: '10px' }}>Reject</button> */}
                          <button
                            onClick={() => setRejectModalOpen(true)}
                            className="reject-button"
                            style={{ float: "right", marginRight: "10px" }}
                          >
                            {" "}
                            Reject{" "}
                          </button>
                        </div>
                      ) : dialogRowData.applicationProgressId === 8 &&
                        (dialogRowData.objectionStatus === 0 ||
                          dialogRowData.objectionStatus === 2 ||
                          dialogRowData.objectionStatus === 1) &&
                        dialogRowData.scoFillFlag === null &&
                        CheckPermissions(
                          permissions,
                          "General Services",
                          "Change of Attributes",
                          "Workflow Permissions",
                          "Sundry Job Order",
                          "SJO Submission"
                        ) &&
                        matchesCoaApprovalCategory(permissions, dialogRowData, allTariffList) ? (
                        <>
                          <button
                            onClick={() =>
                              SundaryJobSubmissionAPI(
                                dialogRowData.applicationId,
                                8,
                                0,
                                "Approved for billing."
                              )
                            }
                            type="submit"
                            className="view-button"
                          >
                            Submit
                          </button>
                        </>
                      ) : dialogRowData.applicationProgressId === 8 &&
                        dialogRowData.scoFillFlag === 1 &&
                        CheckPermissions(
                          permissions,
                          "General Services",
                          "Change of Attributes",
                          "Workflow Permissions",
                          "Sundry Job Order",
                          "SJO Approval"
                        ) &&
                        matchesCoaApprovalCategory(permissions, dialogRowData, allTariffList) ? (
                        <>
                          <button
                            onClick={() => SundaryJobApprovalAPI()}
                            type="submit"
                            className="view-button"
                          >
                            Approve
                          </button>
                        </>
                      ) : dialogRowData.applicationProgressId === 9 &&
                        (dialogRowData.objectionStatus === 0 ||
                          dialogRowData.objectionStatus === 2) ? (
                        <>
                          {CheckPermissions(
                            permissions,
                            "General Services",
                            "Change of Attributes",
                            "Workflow Permissions",
                            "Ready For Billing"
                          ) &&
                            matchesCoaApprovalCategory(permissions, dialogRowData, allTariffList) && (
                              <button
                                // onClick={() => SundaryJobApprovalAPI()}
                                onClick={() => processForBilling()}
                                type="submit"
                                className="view-button"
                              >
                                Approve
                              </button>
                            )}
                        </>
                      ) : null}
                    </div>
                  </div>
                </div>
              </Grid>
            </Grid>
          </DialogContentText>
        </DialogContent>
      </Dialog>

      {/* Application Submitted Sub pop up */}
      <RcoActivityLogDialog
        open={applicationSubittedPopUp}
        onClose={() => closeCoaHistoryPopup(setApplicationSubmittedPopUp)}
        title={getCoaApplicationSubmittedActivityTitle(historyData)}
        variant={
          !isCoaApplicationSubmittedHistoryView(historyData) &&
            (((historyData?.applicationProgressId == 1 ||
              historyData?.applicationProgressId == 4) &&
              isCoaRevertToDocumentsVerificationRemarks(
                getCoaHistoryRemarksText(historyData)
              )) ||
              (historyData?.applicationProgressId == 1 &&
                historyData?.remarks === "Documents Rejected"))
            ? "action"
            : "submitted"
        }
        maxWidth="lg"
        footer={
          historyData
            ? getCoaApplicationSubmittedActivityFooter(historyData)
            : null
        }
      >
        <div className="wf-application-details-body coa-activity-log-body">
          {isCoaApplicationSubmittedHistoryView(historyData) ? (

            <Grid container spacing={2} className="container">
              <Grid item lg={12} className="application-details">
                <Grid item lg={3} className="first-row-item">
                  <Typography className="prop-title">Application Id</Typography>
                  <Typography className="prop-detail">
                    {historyData?.applicationId
                      ? historyData?.applicationId
                      : "-"}
                  </Typography>
                </Grid>
                <Grid item lg={3} className="first-row-item">
                  <Typography className="prop-title">Applicant Name</Typography>
                  <Typography className="prop-detail">
                    {historyData?.applicantName
                      ? historyData?.applicantName
                      : "-"}
                  </Typography>
                </Grid>
                <Grid item lg={3} className="first-row-item">
                  <Typography className="prop-title">
                    Applicant CNIC.
                  </Typography>
                  <Typography className="prop-detail">
                    {historyData?.applicantCNIC
                      ? historyData?.applicantCNIC
                      : "-"}
                  </Typography>
                </Grid>
              </Grid>
              <Grid item lg={12} className="application-details">
                <Grid item lg={3} className="first-row-item">
                  <Typography className="prop-title">
                    Applicant Phone
                  </Typography>
                  <Typography className="prop-detail">
                    {historyData?.applicantPhoneNo
                      ? historyData?.applicantPhoneNo
                      : "-"}
                  </Typography>
                </Grid>
                <Grid item lg={3} className="first-row-item">
                  <Typography className="prop-title">
                    Applicant Email
                  </Typography>
                  <Typography className="prop-detail">
                    {historyData?.applicantEmail
                      ? historyData?.applicantEmail
                      : "-"}
                  </Typography>
                </Grid>
                <Grid item lg={3} className="first-row-item">
                  <Typography className="prop-title">Applied Date</Typography>
                  <Typography className="prop-detail">
                    {historyData?.creationDate
                      ? convertDate(historyData?.creationDate)
                      : "-"}
                  </Typography>
                </Grid>
              </Grid>
              <Grid item lg={12} className="application-details">
                <Grid item lg={3} className="first-row-item">
                  <Typography className="prop-title">Subdivision</Typography>
                  <Typography className="prop-detail">
                    {historyData?.subDivisionCode && subDivisions
                      ? subdivisionName(
                        historyData?.subDivisionCode,
                        subDivisions
                      )
                      : "-"}
                  </Typography>
                </Grid>
                <Grid item lg={3} className="first-row-item">
                  <Typography className="prop-title">
                    Submitted Through
                  </Typography>
                  <Typography className="prop-detail">
                    {historyData?.submittedThrough
                      ? historyData?.submittedThrough
                      : "-"}
                  </Typography>
                </Grid>
                <Grid item lg={3} sx={{ background: "#eef0f4" }}>
                  <Typography sx={{ color: "#eef0f4" }}></Typography>
                  <Typography sx={{ background: "#eef0f4" }}></Typography>
                </Grid>
              </Grid>
              <Grid
                container
                sx={{ display: "flex", flexDirection: "row", gap: 2 }}
              >
                <Grid item lg={2.5}>
                  <Grid
                    container
                    sx={{
                      backgroundColor: getDocumentBackGroundColor(
                        historyViewFlags?.applicantCNICFront
                      ),
                      borderRadius: "10px",
                      minHeight: "150px",
                      height: "auto",
                    }}
                  >
                    <Grid
                      item
                      lg={12}
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        paddingBottom: "5px",
                      }}
                    >
                      <div
                        onClick={() => {
                          if (!copyOfApplicantCNICVerifyPopUp) {
                            setCopyOfApplicantCNICVerifyPopUp(true);
                          }
                        }}
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          flexDirection: "column",
                          alignItems: "center",
                        }}
                      >
                        {historyData?.applicantCNICFront &&
                          historyData.applicantCNICFront.slice(0, 6) ===
                          "data:i" ? (
                          <Base64Image
                            data={historyData.applicantCNICFront}
                            width="80"
                            height="50"
                          />
                        ) : historyData?.applicantCNICFront ? (
                          <Base64Image data={pdfIcon} width="40" />
                        ) : null}
                        {historyData?.applicantCNICBack &&
                          historyData.applicantCNICBack.slice(0, 6) ===
                          "data:i" ? (
                          <Base64Image
                            data={historyData.applicantCNICBack}
                            width="80"
                            height="50"
                          />
                        ) : historyData?.applicantCNICBack ? (
                          <Base64Image data={pdfIcon} width="40" />
                        ) : null}
                        {copyOfApplicantCNICVerifyPopUp && (
                          <OpenBase64ImageInPopup
                            docVerifyPopUp={copyOfApplicantCNICVerifyPopUp}
                            hideDocVerifyPopup={
                              hideCopyOfApplicantCNICVerifyAlert
                            }
                            documentName="Applicant CNIC"
                            documentImage={historyData?.applicantCNICFront}
                            backDocumentImage={historyData?.applicantCNICBack}
                            width={"100%"}
                            readOnly
                            document={historyData?.applicantCNICFront}
                            documentFlag={historyData?.applicantCNICFrontFlag}
                            applicationProgressId={
                              historyData?.applicationProgressId
                            }
                            objectionStatus={historyData?.objectionStatus}
                            updateDocFlag={updateDocFlag}
                            titleToUpdateFlag="copyOfApplicantCNIC"
                            flag_document={historyViewFlags?.applicantCNICFront}
                            flag_documentBack={historyViewFlags?.applicantCNICBack}
                          />
                        )}
                      </div>
                    </Grid>
                    <Grid
                      item
                      lg={12}
                      className="tittlegrid"
                      sx={{ textAlign: "center" }}
                    >
                      <p className="docTitle">Applicant's CNIC.</p>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item lg={2.5}>
                  <Grid
                    container
                    sx={{
                      backgroundColor: getDocumentBackGroundColor(
                        historyViewFlags?.owenershipDocument
                      ),
                      borderRadius: "10px",
                      minHeight: "150px",
                      height: "auto",
                    }}
                  >
                    {/* <Grid container sx={{ backgroundColor: (historyData?.ownershipImage && historyData?.ownershipImage) ? getDocumentBackGroundColor(historyData?.ownershipImage) : getDocumentBackGroundColor(historyViewFlags?.owenershipDocument), borderRadius: "10px", minHeight: "150px", height: 'auto' }}> */}
                    <Grid
                      item
                      lg={12}
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        paddingBottom: "5px",
                      }}
                    >
                      <div
                        onClick={() => {
                          if (!owenershipDocumentVerifyPopUp) {
                            setOwenershipDocumentVerifyPopUp(true);
                          }
                        }}
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          flexDirection: "column",
                          alignItems: "center",
                        }}
                      >
                        {historyData?.ownershipImage?.slice(0, 6) ===
                          "data:i" ? (
                          historyViewFlags?.owenershipDocument === 1 ? (
                            <>
                              <Base64Image
                                data={historyData?.ownershipImage}
                                width="80"
                                height="50"
                              />
                            </>
                          ) : historyViewFlags?.owenershipDocument === -1 ? (
                            <>
                              <Base64Image
                                data={historyData?.ownershipImage}
                                width="80"
                                height="50"
                              />
                            </>
                          ) : (
                            <>
                              <Base64Image
                                data={historyData?.ownershipImage}
                                width="80"
                                height="50"
                              />
                            </>
                          )
                        ) : historyViewFlags?.owenershipDocument === 1 ? (
                          <>
                            <Base64Image data={pdfIcon} width="40" />
                            <img
                              src={tickicon}
                              width="25px"
                              height="25px"
                              alt="Tick Icon"
                              className="doc-verification-status-icon"
                            />
                          </>
                        ) : historyViewFlags?.owenershipDocument === -1 ? (
                          <>
                            <Base64Image data={pdfIcon} width="40" />
                            <img
                              src={crossIcon}
                              width="25px"
                              height="25px"
                              alt="Cross Icon"
                              className="doc-verification-status-icon"
                            />
                          </>
                        ) : (
                          <Base64Image data={pdfIcon} width="40" />
                        )}
                        {owenershipDocumentVerifyPopUp && (
                          <OpenBase64ImageInPopup
                            docVerifyPopUp={owenershipDocumentVerifyPopUp}
                            hideDocVerifyPopup={hidePropertyDocVerifyAlert}
                            documentName="OwnerShip Document"
                            documentImage={historyData?.ownershipImage}
                            width={"100%"}
                            readOnly
                            document={historyData?.ownershipImage}
                            documentFlag={historyData?.ownershipImageFlag}
                            applicationProgressId={
                              historyData?.applicationProgressId
                            }
                            objectionStatus={historyData?.objectionStatus}
                            updateDocFlag={updateDocFlag}
                            titleToUpdateFlag="ownershipDocument"
                            flag_document={historyViewFlags?.owenershipDocument}
                          />
                        )}
                      </div>
                    </Grid>
                    <Grid
                      item
                      lg={12}
                      className="tittlegrid"
                      sx={{ textAlign: "center" }}
                    >
                      <p className="docTitle">Proof Of OwnerShip</p>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item lg={2.5}>
                  <Grid
                    container
                    sx={{
                      backgroundColor: getDocumentBackGroundColor(
                        historyViewFlags?.electricityBillDocument
                      ),
                      borderRadius: "10px",
                      minHeight: "150px",
                      height: "auto",
                    }}
                  >
                    <Grid
                      item
                      lg={12}
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        paddingBottom: "5px",
                      }}
                    >
                      <div
                        onClick={() => {
                          if (!electricityBillDocumentVerifyPopUp) {
                            setElectricityBillDocumentVerifyPopUp(true);
                          }
                        }}
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          flexDirection: "column",
                          alignItems: "center",
                        }}
                      >
                        {historyData?.electricityBill?.slice(0, 6) ===
                          "data:i" ? (
                          historyViewFlags?.electricityBillDocument === 1 ? (
                            <>
                              <Base64Image
                                data={historyData?.electricityBill}
                                width="80"
                                height="50"
                              />
                            </>
                          ) : historyViewFlags?.electricityBillDocument === -1 ? (
                            <>
                              <Base64Image
                                data={historyData?.electricityBill}
                                width="80"
                                height="50"
                              />
                            </>
                          ) : (
                            <>
                              <Base64Image
                                data={historyData?.electricityBill}
                                width="80"
                                height="50"
                              />
                              {/* <Base64Image data={historyData?.electricityBill} width='80' height='50' /> */}
                            </>
                          )
                        ) : historyViewFlags?.electricityBillDocument === 1 ? (
                          <>
                            <Base64Image data={pdfIcon} width="40" />
                            <img
                              src={tickicon}
                              width="25px"
                              height="25px"
                              alt="Tick Icon"
                              className="doc-verification-status-icon"
                            />
                          </>
                        ) : historyViewFlags?.electricityBillDocument === -1 ? (
                          <>
                            <Base64Image data={pdfIcon} width="40" />
                            <img
                              src={crossIcon}
                              width="25px"
                              height="25px"
                              alt="Cross Icon"
                              className="doc-verification-status-icon"
                            />
                          </>
                        ) : (
                          <Base64Image data={pdfIcon} width="40" />
                        )}
                        {electricityBillDocumentVerifyPopUp && (
                          <OpenBase64ImageInPopup
                            docVerifyPopUp={electricityBillDocumentVerifyPopUp}
                            hideDocVerifyPopup={hideElectricityBillVerifyAlert}
                            documentName="Electricity Bill"
                            documentImage={historyData?.electricityBill}
                            // backDocumentImage={historyData?.applicantCNICBack}
                            width={"100%"}
                            readOnly
                            document={historyData?.electricityBill}
                            documentFlag={historyData?.electricityBillFlag}
                            applicationProgressId={
                              historyData?.applicationProgressId
                            }
                            objectionStatus={historyData?.objectionStatus}
                            updateDocFlag={updateDocFlag}
                            titleToUpdateFlag="electricityBill"
                            flag_document={historyViewFlags?.electricityBillDocument}
                          // flag_documentBack={historyViewFlags?.applicantCNICBack}
                          />
                        )}
                      </div>
                    </Grid>
                    <Grid
                      item
                      lg={12}
                      className="tittlegrid"
                      sx={{ textAlign: "center" }}
                    >
                      <p className="docTitle">Electricity Bill</p>
                    </Grid>
                  </Grid>
                </Grid>

                {historyData?.fbrDocument && (
                  <Grid item lg={2.5}>
                    <Grid
                      container
                      sx={{
                        backgroundColor: getDocumentBackGroundColor(
                          historyViewFlags?.fbrDocument
                        ),
                        borderRadius: "10px",
                        minHeight: "150px",
                        height: "auto",
                      }}
                    >
                      <Grid
                        item
                        lg={12}
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          paddingBottom: "5px",
                        }}
                      >
                        <div
                          onClick={() => {
                            if (!fbrDocumentVerifyPopUp) {
                              setFbrDocumentVerifyPopUp(true);
                            }
                          }}
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            flexDirection: "column",
                            alignItems: "center",
                          }}
                        >
                          {historyData?.fbrDocument?.slice(0, 6) === "data:i" ? (
                            historyViewFlags?.fbrDocument === 1 ? (
                              <>
                                <Base64Image
                                  data={historyData?.fbrDocument}
                                  width="80"
                                  height="50"
                                />
                              </>
                            ) : historyViewFlags?.fbrDocument === -1 ? (
                              <>
                                <Base64Image
                                  data={historyData?.fbrDocument}
                                  width="80"
                                  height="50"
                                />
                              </>
                            ) : (
                              <>
                                <Base64Image
                                  data={historyData?.fbrDocument}
                                  width="80"
                                  height="50"
                                />
                              </>
                            )
                          ) : (
                            <Base64Image data={pdfIcon} width="40" />
                          )}
                          {fbrDocumentVerifyPopUp && (
                            <OpenBase64ImageInPopup
                              docVerifyPopUp={fbrDocumentVerifyPopUp}
                              hideDocVerifyPopup={hideFbrDocumentVerifyAlert}
                              documentName="Fbr Document"
                              documentImage={historyData?.fbrDocument}
                              // backDocumentImage={historyData?.applicantCNICBack}
                              width={"100%"}
                              readOnly
                              document={historyData?.fbrDocument}
                              documentFlag={historyData?.fbrDocumentFlag}
                              applicationProgressId={
                                historyData?.applicationProgressId
                              }
                              objectionStatus={historyData?.objectionStatus}
                              updateDocFlag={updateDocFlag}
                              titleToUpdateFlag="fbrDocument"
                              flag_document={historyViewFlags?.fbrDocument}
                            // flag_documentBack={historyViewFlags?.applicantCNICBack}
                            />
                          )}
                        </div>
                      </Grid>
                      <Grid
                        item
                        lg={12}
                        className="tittlegrid"
                        sx={{ textAlign: "center" }}
                      >
                        <p className="docTitle">Fbr Document</p>
                      </Grid>
                    </Grid>
                  </Grid>
                )}

                {dialogRowData.addDocAnyOther && (
                  <Grid item lg={2}>
                    <Grid
                      container
                      sx={{
                        // backgroundColor: dialogRowData.anyOtherDocumentFlag
                        //   ? getDocumentBackGroundColor(
                        //     dialogRowData.anyOtherDocumentFlag
                        //   )
                        //   : getDocumentBackGroundColor(
                        //     flag_addDocAnyOther
                        //   ),
                        borderRadius: "10px",
                        minHeight: "150px",
                        height: "auto",
                      }}
                    >
                      <Grid
                        item
                        lg={12}
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <div
                          onClick={() => {
                            if (!addDocAnyOtherVerifyPopUp) {
                              setAddDocAnyOtherVerifyPopUp(true);
                            }
                          }}
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          {dialogRowData.addDocAnyOther.slice(0, 6) ===
                            "data:i" ? (
                            flag_addDocAnyOther === 1 ? (
                              <>
                                <Base64Image
                                  data={dialogRowData.addDocAnyOther}
                                  width="80"
                                  height="110"
                                />
                                {/* <img
                                  src={tickicon}
                                  width="25px"
                                  height="25px"
                                  alt="Tick Icon"
                                  className="doc-verification-status-icon"
                                /> */}
                              </>
                            ) : flag_addDocAnyOther === -1 ? (
                              <>
                                <Base64Image
                                  data={dialogRowData.addDocAnyOther}
                                  width="80"
                                  height="110"
                                />
                                {/* <img
                                  src={crossIcon}
                                  width="25px"
                                  height="25px"
                                  alt="Cross Icon"
                                  className="doc-verification-status-icon"
                                /> */}
                              </>
                            ) : (
                              <Base64Image
                                data={dialogRowData.addDocAnyOther}
                                width="80"
                                height="110"
                              />
                            )
                          ) : (
                            <Base64Image data={pdfIcon} width="40" />
                          )}
                          {addDocAnyOtherVerifyPopUp && (
                            <OpenBase64ImageInPopup
                              docVerifyPopUp={addDocAnyOtherVerifyPopUp}
                              hideDocVerifyPopup={
                                hideAddAnyOtherVerifyAlert
                              }
                              documentName="Any Other Document"
                              documentImage={
                                dialogRowData.addDocAnyOther
                              }
                              width={"100%"}
                              readOnly
                              document={dialogRowData.addDocAnyOther}
                              documentFlag={
                                dialogRowData.anyOtherDocumentFlag
                              }
                              applicationProgressId={
                                dialogRowData.applicationProgressId
                              }
                              objectionStatus={
                                dialogRowData.objectionStatus
                              }
                              updateDocFlag={updateDocFlag}
                              titleToUpdateFlag="addDocAnyOther"
                              flag_document={flag_addDocAnyOther}
                            />
                          )}
                        </div>
                      </Grid>
                      {/* <Grid item lg={12} className="tittlegrid">
                        <p className="docTitle">Any Other Document</p>
                      </Grid> */}
                      <Grid
                        item
                        lg={12}
                        className="tittlegrid"
                        sx={{ textAlign: "center" }}
                      >
                        <p className="docTitle">Any Other Document</p>
                      </Grid>
                    </Grid>
                  </Grid>
                )}
              </Grid>
            </Grid>

          ) :
            (historyData?.applicationProgressId == 1 ||
              historyData?.applicationProgressId == 4) &&
              isCoaRevertToDocumentsVerificationRemarks(
                getCoaHistoryRemarksText(historyData)
              ) ? (

              <Typography style={{ color: "red" }}>
                Application revert to Document Verification from DN Approval.
              </Typography>


            ) : (
              historyData?.applicationProgressId == 1 &&
              historyData.remarks === "Documents Rejected" && (

                <Typography style={{ color: "red" }}>
                  Application revert to Document Verification from DN Approval.
                </Typography>

              )
            )}
        </div>
      </RcoActivityLogDialog>

      <RcoActivityLogDialog
        open={coaApplicationRevertedSubPopUp}
        onClose={() => closeCoaHistoryPopup(setCoaApplicationRevertedSubPopUp)}
        title="Application Reverted"
        variant="action"
        maxWidth="md"
        footer={
          historyData
            ? `Reverted by: ${historyData?.lastModifiedBy || "-"} on: ${historyData?.lastModificationDate
              ? convertDatewithTime(historyData.lastModificationDate)
              : "-"
            }`
            : null
        }
      >
        <div className="wf-application-details-body coa-activity-log-body">
          <div className="rco-history-details-grid">
            <div>
              <label className="field-label">Remarks</label>
              <TextField
                fullWidth
                value={historyData?.remarks || "N/A"}
                InputProps={{ readOnly: true }}
                size="small"
                disabled
              />
            </div>
            <div>
              <label className="field-label">Remarks Detail</label>
              <TextField
                fullWidth
                multiline
                minRows={2}
                value={historyData?.remarksDetail || "N/A"}
                InputProps={{ readOnly: true }}
                size="small"
                disabled
              />
            </div>
          </div>
        </div>
      </RcoActivityLogDialog>

      <RcoActivityLogDialog
        open={documentsVerifiedSubPopUp}
        onClose={() => closeCoaHistoryPopup(setDocumentsVerifiedSubPopUp)}
        title={getCoaDocumentsVerifiedActivityTitle(historyData)}
        variant={
          isCoaWiringTestReportRejectedHistoryView(historyData) ||
            isCoaDocumentVerificationObjectionView(historyData) ||
            (historyData?.applicationProgressId == 3 &&
              historyData?.objectionStatus == 0 &&
              historyData.remarks === "Revert to Arrear Verification")
            ? "action"
            : "submitted"
        }
        maxWidth="lg"
        footer={
          historyData ? getCoaDocumentsVerifiedActivityFooter(historyData) : null
        }
      >
        <div className="wf-application-details-body coa-activity-log-body">
          {isCoaWiringTestReportPopupView(historyData)
            ? (() => {
              const wiringTestReportPreview = getCoaHistoryDocumentPreview(
                historyData?.wiringTestReportDocument,
                historyWiringTestReportImg
              );
              const wiringReportFlag = isCoaWiringTestReportRejectedHistoryView(
                historyData
              )
                ? -1
                : isCoaWiringTestReportReuploadedHistoryView(historyData)
                  ? 2
                  : historyViewFlags?.wiringTestReport;
              return (
                <Grid
                  container
                  sx={{ display: "flex", flexDirection: "row", gap: 2, justifyContent: "center" }}
                >
                  <Grid item lg={3}>
                    <Grid
                      container
                      sx={{
                        backgroundColor: getDocumentBackGroundColor(wiringReportFlag),
                        borderRadius: "10px",
                        minHeight: "150px",
                        height: "auto",
                      }}
                    >
                      <Grid
                        item
                        lg={12}
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          paddingBottom: "5px",
                        }}
                      >
                        <div
                          onClick={() => {
                            if (wiringTestReportPreview && !wiringTestReportVerifyPopUp) {
                              setWiringTestReportVerifyPopUp(true);
                            }
                          }}
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            cursor: wiringTestReportPreview ? "pointer" : "default",
                          }}
                        >
                          {historyWiringTestReportImgLoading ? (
                            <AppLoader size={28} />
                          ) : wiringTestReportPreview ? (
                            wiringReportFlag === 1 ? (
                              <>
                                <Base64Image
                                  data={wiringTestReportPreview}
                                  width="80"
                                />
                                <img
                                  src={tickicon}
                                  width="25px"
                                  height="25px"
                                  alt="Tick Icon"
                                  className="doc-verification-status-icon"
                                />
                              </>
                            ) : wiringReportFlag === -1 ? (
                              <>
                                <Base64Image
                                  data={wiringTestReportPreview}
                                  width="80"
                                />
                                <img
                                  src={crossIcon}
                                  width="25px"
                                  height="25px"
                                  alt="Cross Icon"
                                  className="doc-verification-status-icon"
                                />
                              </>
                            ) : (
                              <Base64Image
                                data={wiringTestReportPreview}
                                width="80"
                              />
                            )
                          ) : (
                            <Base64Image data={pdfIcon} width="40" />
                          )}
                          {wiringTestReportVerifyPopUp && wiringTestReportPreview && (
                            <OpenBase64ImageInPopup
                              docVerifyPopUp={wiringTestReportVerifyPopUp}
                              hideDocVerifyPopup={(x) =>
                                setWiringTestReportVerifyPopUp(x)
                              }
                              documentName="Wiring Test Report"
                              documentImage={wiringTestReportPreview}
                              width={"100%"}
                              readOnly
                              document={historyData?.wiringTestReportDocument}
                              documentFlag={historyData?.wiringTestReportDocumentFlag}
                              applicationProgressId={historyData?.applicationProgressId}
                              objectionStatus={historyData?.objectionStatus}
                              updateDocFlag={updateDocFlag}
                              documentRemarks={getCoaWiringTestReportDocumentRemarks(historyData)}
                              titleToUpdateFlag="wiringTestReport"
                              flag_document={wiringReportFlag}
                              verificationPermissionService="Change of Attributes"
                            />
                          )}
                        </div>
                      </Grid>
                      <Grid item lg={12} className="tittlegrid" sx={{ textAlign: "center" }}>
                        <p className="docTitle">Wiring Test Report</p>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              );
            })()
            : shouldShowCoaDocumentsVerifiedHistoryGrid(historyData) ? (

              <Grid
                container
                sx={{ display: "flex", flexDirection: "row", gap: 2 }}
              >
                <Grid item lg={2.5}>
                  <Grid
                    container
                    sx={{
                      backgroundColor: getDocumentBackGroundColor(
                        historyViewFlags?.applicantCNICFront
                      ),
                      borderRadius: "10px",
                      minHeight: "150px",
                      height: "auto",
                    }}
                  >
                    <Grid
                      item
                      lg={12}
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        paddingBottom: "5px",
                      }}
                    >
                      <div
                        onClick={() => {
                          if (!copyOfApplicantCNICVerifyPopUp) {
                            setCopyOfApplicantCNICVerifyPopUp(true);
                          }
                        }}
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          flexDirection: "column",
                          alignItems: "center",
                        }}
                      >
                        {historyData?.applicantCNICFront &&
                          historyData.applicantCNICFront.slice(0, 6) ===
                          "data:i" ? (
                          <Base64Image
                            data={historyData.applicantCNICFront}
                            width="80"
                            height="50"
                          />
                        ) : historyData?.applicantCNICFront ? (
                          <Base64Image data={pdfIcon} width="40" />
                        ) : null}
                        {historyData?.applicantCNICBack &&
                          historyData.applicantCNICBack.slice(0, 6) ===
                          "data:i" ? (
                          <Base64Image
                            data={historyData.applicantCNICBack}
                            width="80"
                            height="50"
                          />
                        ) : historyData?.applicantCNICBack ? (
                          <Base64Image data={pdfIcon} width="40" />
                        ) : null}
                        {historyViewFlags?.applicantCNICFront === 1 && (
                          <img
                            src={tickicon}
                            width="25px"
                            height="25px"
                            alt="Tick Icon"
                            className="doc-verification-status-icon"
                          />
                        )}
                        {historyViewFlags?.applicantCNICFront === -1 && (
                          <img
                            src={crossIcon}
                            width="25px"
                            height="25px"
                            alt="Cross Icon"
                            className="doc-verification-status-icon"
                          />
                        )}
                        {copyOfApplicantCNICVerifyPopUp && (
                          <OpenBase64ImageInPopup
                            docVerifyPopUp={copyOfApplicantCNICVerifyPopUp}
                            hideDocVerifyPopup={
                              hideCopyOfApplicantCNICVerifyAlert
                            }
                            documentName="Applicant CNIC"
                            documentImage={historyData?.applicantCNICFront}
                            backDocumentImage={historyData?.applicantCNICBack}
                            width={"100%"}
                            readOnly
                            document={historyData?.applicantCNICFront}
                            documentFlag={historyData?.applicantCNICFrontFlag}
                            applicationProgressId={
                              historyData?.applicationProgressId
                            }
                            objectionStatus={historyData?.objectionStatus}
                            updateDocFlag={updateDocFlag}
                            titleToUpdateFlag="copyOfApplicantCNIC"
                            flag_document={historyViewFlags?.applicantCNICFront}
                            flag_documentBack={historyViewFlags?.applicantCNICBack}
                          />
                        )}
                      </div>
                    </Grid>
                    <Grid
                      item
                      lg={12}
                      className="tittlegrid"
                      sx={{ textAlign: "center" }}
                    >
                      <p className="docTitle">Applicant's CNIC.</p>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item lg={2.5}>
                  {/* <Grid container sx={{ backgroundColor: (historyData?.electricityBillFlag && historyData?.electricityBillFlag) ? getDocumentBackGroundColor(historyData?.electricityBillFlag) : getDocumentBackGroundColor(historyViewFlags?.electricityBillDocument), borderRadius: "10px", minHeight: "150px", height: 'auto' }}> */}
                  <Grid
                    container
                    sx={{
                      backgroundColor: getDocumentBackGroundColor(
                        historyViewFlags?.owenershipDocument
                      ),
                      borderRadius: "10px",
                      minHeight: "150px",
                      height: "auto",
                    }}
                  >
                    {/* <Grid container sx={{ backgroundColor: (historyData?.ownershipImage && historyData?.ownershipImage) ? getDocumentBackGroundColor(historyData?.ownershipImage) : getDocumentBackGroundColor(historyViewFlags?.owenershipDocument), borderRadius: "10px", minHeight: "150px", height: 'auto' }}> */}
                    <Grid
                      item
                      lg={12}
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        paddingBottom: "5px",
                      }}
                    >
                      <div
                        onClick={() => {
                          if (!owenershipDocumentVerifyPopUp) {
                            setOwenershipDocumentVerifyPopUp(true);
                          }
                        }}
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          flexDirection: "column",
                          alignItems: "center",
                        }}
                      >
                        {historyData?.ownershipImage?.slice(0, 6) === "data:i" ? (
                          historyViewFlags?.owenershipDocument === 1 ? (
                            <>
                              <Base64Image
                                data={historyData?.ownershipImage}
                                width="80"
                                height="50"
                              />
                              <img
                                src={tickicon}
                                width="25px"
                                height="25px"
                                alt="Tick Icon"
                                className="doc-verification-status-icon"
                              />
                            </>
                          ) : historyViewFlags?.owenershipDocument === -1 ? (
                            <>
                              <Base64Image
                                data={historyData?.ownershipImage}
                                width="80"
                                height="50"
                              />
                              <img
                                src={crossIcon}
                                width="25px"
                                height="25px"
                                alt="Cross Icon"
                                className="doc-verification-status-icon"
                              />
                            </>
                          ) : (
                            <>
                              <Base64Image
                                data={historyData?.ownershipImage}
                                width="80"
                                height="50"
                              />
                            </>
                          )
                        ) : historyViewFlags?.owenershipDocument === 1 ? (
                          <>
                            <Base64Image data={pdfIcon} width="40" />
                            <img
                              src={tickicon}
                              width="25px"
                              height="25px"
                              alt="Tick Icon"
                              className="doc-verification-status-icon"
                            />
                          </>
                        ) : historyViewFlags?.owenershipDocument === -1 ? (
                          <>
                            <Base64Image data={pdfIcon} width="40" />
                            <img
                              src={crossIcon}
                              width="25px"
                              height="25px"
                              alt="Cross Icon"
                              className="doc-verification-status-icon"
                            />
                          </>
                        ) : (
                          <Base64Image data={pdfIcon} width="40" />
                        )}
                        {owenershipDocumentVerifyPopUp && (
                          <OpenBase64ImageInPopup
                            docVerifyPopUp={owenershipDocumentVerifyPopUp}
                            hideDocVerifyPopup={hidePropertyDocVerifyAlert}
                            documentName="OwnerShip Document"
                            documentImage={historyData?.ownershipImage}
                            width={"100%"}
                            readOnly
                            document={historyData?.ownershipImage}
                            documentFlag={historyData?.ownershipImageFlag}
                            applicationProgressId={
                              historyData?.applicationProgressId
                            }
                            objectionStatus={historyData?.objectionStatus}
                            updateDocFlag={updateDocFlag}
                            titleToUpdateFlag="ownershipDocument"
                            flag_document={historyViewFlags?.owenershipDocument}
                          />
                        )}
                      </div>
                    </Grid>
                    <Grid
                      item
                      lg={12}
                      className="tittlegrid"
                      sx={{ textAlign: "center" }}
                    >
                      <p className="docTitle">Proof Of OwnerSHip</p>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item lg={2.5}>
                  <Grid
                    container
                    sx={{
                      backgroundColor: getDocumentBackGroundColor(
                        historyViewFlags?.electricityBillDocument
                      ),
                      borderRadius: "10px",
                      minHeight: "150px",
                      height: "auto",
                    }}
                  >
                    <Grid
                      item
                      lg={12}
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        paddingBottom: "5px",
                      }}
                    >
                      <div
                        onClick={() => {
                          if (!electricityBillDocumentVerifyPopUp) {
                            setElectricityBillDocumentVerifyPopUp(true);
                          }
                        }}
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          flexDirection: "column",
                          alignItems: "center",
                        }}
                      >
                        {historyData?.electricityBill?.slice(0, 6) === "data:i" ? (
                          historyViewFlags?.electricityBillDocument === 1 ? (
                            <>
                              <Base64Image
                                data={historyData?.electricityBill}
                                width="80"
                                height="50"
                              />
                              {/* <Base64Image data={historyData?.applicantCNICBack} width='80' height='50' /> */}
                              <img
                                src={tickicon}
                                width="25px"
                                height="25px"
                                alt="Tick Icon"
                                className="doc-verification-status-icon"
                              />
                            </>
                          ) : historyViewFlags?.electricityBillDocument === -1 ? (
                            <>
                              <Base64Image
                                data={historyData?.electricityBill}
                                width="80"
                                height="50"
                              />
                              {/* <Base64Image data={historyData?.applicantCNICBack} width='80' height='50' /> */}
                              <img
                                src={crossIcon}
                                width="25px"
                                height="25px"
                                alt="Cross Icon"
                                className="doc-verification-status-icon"
                              />
                            </>
                          ) : (
                            <>
                              <Base64Image
                                data={historyData?.electricityBill}
                                width="80"
                                height="50"
                              />
                              {/* <Base64Image data={historyData?.electricityBill} width='80' height='50' /> */}
                            </>
                          )
                        ) : historyViewFlags?.electricityBillDocument === 1 ? (
                          <>
                            <Base64Image data={pdfIcon} width="40" />
                            <img
                              src={tickicon}
                              width="25px"
                              height="25px"
                              alt="Tick Icon"
                              className="doc-verification-status-icon"
                            />
                          </>
                        ) : historyViewFlags?.electricityBillDocument === -1 ? (
                          <>
                            <Base64Image data={pdfIcon} width="40" />
                            <img
                              src={crossIcon}
                              width="25px"
                              height="25px"
                              alt="Cross Icon"
                              className="doc-verification-status-icon"
                            />
                          </>
                        ) : (
                          <Base64Image data={pdfIcon} width="40" />
                        )}
                        {electricityBillDocumentVerifyPopUp && (
                          <OpenBase64ImageInPopup
                            docVerifyPopUp={electricityBillDocumentVerifyPopUp}
                            hideDocVerifyPopup={hideElectricityBillVerifyAlert}
                            documentName="Electricity Bill"
                            documentImage={historyData?.electricityBill}
                            // backDocumentImage={historyData?.applicantCNICBack}
                            width={"100%"}
                            readOnly
                            document={historyData?.electricityBill}
                            documentFlag={historyData?.electricityBillFlag}
                            applicationProgressId={
                              historyData?.applicationProgressId
                            }
                            objectionStatus={historyData?.objectionStatus}
                            updateDocFlag={updateDocFlag}
                            titleToUpdateFlag="electricityBill"
                            flag_document={historyViewFlags?.electricityBillDocument}
                          // flag_documentBack={historyViewFlags?.applicantCNICBack}
                          />
                        )}
                      </div>
                    </Grid>
                    <Grid
                      item
                      lg={12}
                      className="tittlegrid"
                      sx={{ textAlign: "center" }}
                    >
                      <p className="docTitle">Electricity Bill</p>
                    </Grid>
                  </Grid>
                </Grid>

                {historyData?.fbrDocument && (
                  <Grid item lg={2.5}>
                    <Grid
                      container
                      sx={{
                        backgroundColor:
                          getDocumentBackGroundColor(historyViewFlags?.fbrDocument),
                        borderRadius: "10px",
                        minHeight: "150px",
                        height: "auto",
                      }}
                    >
                      <Grid
                        item
                        lg={12}
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          paddingBottom: "5px",
                        }}
                      >
                        <div
                          onClick={() => {
                            if (!fbrDocumentVerifyPopUp) {
                              setFbrDocumentVerifyPopUp(true);
                            }
                          }}
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            flexDirection: "column",
                            alignItems: "center",
                          }}
                        >
                          {historyData?.fbrDocument?.slice(0, 6) === "data:i" ? (
                            historyViewFlags?.fbrDocument === 1 ? (
                              <>
                                <Base64Image
                                  data={historyData?.fbrDocument}
                                  width="80"
                                  height="50"
                                />
                                {/* <Base64Image data={historyData?.fbrDocument} width='80' height='50' /> */}
                                <img
                                  src={tickicon}
                                  width="25px"
                                  height="25px"
                                  alt="Tick Icon"
                                  className="doc-verification-status-icon"
                                />
                              </>
                            ) : historyViewFlags?.fbrDocument === -1 ? (
                              <>
                                <Base64Image
                                  data={historyData?.fbrDocument}
                                  width="80"
                                  height="50"
                                />
                                {/* <Base64Image data={historyData?.fbrDocument} width='80' height='50' /> */}
                                <img
                                  src={crossIcon}
                                  width="25px"
                                  height="25px"
                                  alt="Cross Icon"
                                  className="doc-verification-status-icon"
                                />
                              </>
                            ) : (
                              <>
                                <Base64Image
                                  data={historyData?.fbrDocument}
                                  width="80"
                                  height="50"
                                />
                                {/* <Base64Image data={historyData?.applicantCNICBack} width='80' height='50' /> */}
                              </>
                            )
                          ) : (
                            <Base64Image data={pdfIcon} width="40" />
                          )}
                          {fbrDocumentVerifyPopUp && (
                            <OpenBase64ImageInPopup
                              docVerifyPopUp={fbrDocumentVerifyPopUp}
                              hideDocVerifyPopup={hideFbrDocumentVerifyAlert}
                              documentName="Fbr Document"
                              documentImage={historyData?.fbrDocument}
                              // backDocumentImage={historyData?.applicantCNICBack}
                              width={"100%"}
                              readOnly
                              document={historyData?.fbrDocument}
                              documentFlag={historyData?.fbrDocumentFlag}
                              applicationProgressId={
                                historyData?.applicationProgressId
                              }
                              objectionStatus={historyData?.objectionStatus}
                              updateDocFlag={updateDocFlag}
                              titleToUpdateFlag="fbrDocument"
                              flag_document={historyViewFlags?.fbrDocument}
                            // flag_documentBack={historyViewFlags?.applicantCNICBack}
                            />
                          )}
                        </div>
                      </Grid>
                      <Grid
                        item
                        lg={12}
                        className="tittlegrid"
                        sx={{ textAlign: "center" }}
                      >
                        <p className="docTitle">Fbr Document</p>
                      </Grid>
                    </Grid>
                  </Grid>
                )}

                {getCoaHistoryAnyOtherDocument(historyData) && (
                  <Grid item lg={2}>
                    <Grid
                      container
                      sx={{
                        backgroundColor: getDocumentBackGroundColor(
                          historyViewFlags?.addDocAnyOther
                        ),
                        borderRadius: "10px",
                        minHeight: "150px",
                        height: "auto",
                      }}
                    >
                      <Grid
                        item
                        lg={12}
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <div
                          onClick={() => {
                            if (!addDocAnyOtherVerifyPopUp) {
                              setAddDocAnyOtherVerifyPopUp(true);
                            }
                          }}
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          {getCoaHistoryAnyOtherDocument(historyData).slice(0, 6) ===
                            "data:i" ? (
                            historyViewFlags?.addDocAnyOther === 1 ? (
                              <>
                                <Base64Image
                                  data={getCoaHistoryAnyOtherDocument(historyData)}
                                  width="80"
                                  height="110"
                                />
                                <img
                                  src={tickicon}
                                  width="25px"
                                  height="25px"
                                  alt="Tick Icon"
                                  className="doc-verification-status-icon"
                                />
                              </>
                            ) : historyViewFlags?.addDocAnyOther === -1 ? (
                              <>
                                <Base64Image
                                  data={getCoaHistoryAnyOtherDocument(historyData)}
                                  width="80"
                                  height="110"
                                />
                                <img
                                  src={crossIcon}
                                  width="25px"
                                  height="25px"
                                  alt="Cross Icon"
                                  className="doc-verification-status-icon"
                                />
                              </>
                            ) : (
                              <Base64Image
                                data={getCoaHistoryAnyOtherDocument(historyData)}
                                width="80"
                                height="110"
                              />
                            )
                          ) : (
                            <Base64Image data={pdfIcon} width="40" />
                          )}
                          {addDocAnyOtherVerifyPopUp && (
                            <OpenBase64ImageInPopup
                              docVerifyPopUp={addDocAnyOtherVerifyPopUp}
                              hideDocVerifyPopup={
                                hideAddAnyOtherVerifyAlert
                              }
                              documentName="Any Other Document"
                              documentImage={
                                getCoaHistoryAnyOtherDocument(historyData)
                              }
                              width={"100%"}
                              readOnly
                              document={getCoaHistoryAnyOtherDocument(historyData)}
                              documentFlag={
                                historyData?.anyOtherDocumentFlag
                              }
                              applicationProgressId={
                                historyData?.applicationProgressId
                              }
                              objectionStatus={
                                historyData?.objectionStatus
                              }
                              updateDocFlag={updateDocFlag}
                              titleToUpdateFlag="addDocAnyOther"
                              flag_document={historyViewFlags?.addDocAnyOther}
                            />
                          )}
                        </div>
                      </Grid>
                      <Grid item lg={12} className="tittlegrid">
                        <p className="docTitle">Any Other Document</p>
                      </Grid>
                    </Grid>
                  </Grid>
                )}
              </Grid>

            ) : (
              historyData?.applicationProgressId == 3 &&
              historyData?.objectionStatus == 0 &&
              historyData.remarks === "Revert to Arrear Verification" && (

                <Typography style={{ color: "red" }}>
                  Application Revert to Arrear Verification from DN Approval
                </Typography>

              )
            )}
        </div>
      </RcoActivityLogDialog>

      <RcoActivityLogDialog
        open={arrearVerifiedSubPopUp}
        onClose={() => closeCoaHistoryPopup(setArrearVerifiedSubPopUp)}
        title={getCoaArrearVerifiedActivityTitle(historyData)}
        variant={
          !isCoaArrearVerificationHistoryView(historyData) &&
            !(historyData?.applicationProgressId == 4 &&
              historyData?.objectionStatus == 0)
            ? "action"
            : "submitted"
        }
        maxWidth="md"
        footer={
          isCoaArrearVerificationHistoryView(historyData) && historyData
            ? `Arrear Verified by: ${historyData?.lastModifiedBy || "-"} on: ${historyData?.lastModificationDate
              ? convertDatewithTime(historyData.lastModificationDate)
              : "-"
            }`
            : null
        }
      >
        <div className="wf-application-details-body coa-activity-log-body">
          {(historyData?.applicationProgressId == 4 ||
            (historyData?.applicationProgressId == 3 &&
              historyData?.objectionStatus == 1)) &&
            (isCoaArrearVerificationHistoryView(historyData) ? (
              <div className="rco-history-details-grid">
                <div>
                  <label className="field-label">Remarks</label>
                  <TextField
                    fullWidth
                    value={historyData?.remarks || "N/A"}
                    InputProps={{ readOnly: true }}
                    size="small"
                    disabled
                  />
                </div>
                <div>
                  <label className="field-label">Remarks Detail</label>
                  <TextField
                    fullWidth
                    value={historyData?.remarksDetail || "N/A"}
                    InputProps={{ readOnly: true }}
                    size="small"
                    disabled
                  />
                </div>
                <div>
                  <label className="field-label">Verified By</label>
                  <TextField
                    fullWidth
                    value={historyData?.lastModifiedBy || "N/A"}
                    InputProps={{ readOnly: true }}
                    size="small"
                    disabled
                  />
                </div>
              </div>
            ) : (
              <DialogContentText component="div">
                <div style={{ textAlign: "center" }}>
                  {historyData?.applicationProgressId == 4 &&
                    historyData?.objectionStatus == 0 ? (
                    <div style={{ textAlign: "center" }}>
                      <p>
                        All dues were{" "}
                        <span style={{ fontWeight: "bold", color: "green" }}>
                          PAID
                        </span>{" "}
                        against the property.
                      </p>

                      <Grid
                        container
                        sx={{
                          borderRadius: "10px",
                          minHeight: "150px",
                          height: "auto",
                        }}
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          marginTop: "10px",
                        }}
                      >
                        <Grid
                          item
                          lg={12}
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            paddingBottom: "5px",
                          }}
                        >
                          <div
                            onClick={() => setPaidBillPopUp(true)}
                            style={{
                              cursor: "pointer",
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                            }}
                          >
                            {historyData?.paidBillImage?.slice(0, 6) ===
                              "data:i" ? (
                              <Base64Image
                                data={historyData?.paidBillImage}
                                width="100"
                                height="70"
                              />
                            ) : (
                              <Base64Image data={pdfIcon} width="40" />
                            )}
                          </div>
                        </Grid>

                        <Grid item lg={12} style={{ textAlign: "center" }}>
                          <p className="docTitle">Paid Bill</p>
                        </Grid>
                      </Grid>

                      {paidBillPopUp && (
                        <OpenBase64ImageInPopup
                          docVerifyPopUp={paidBillPopUp}
                          hideDocVerifyPopup={hidePaidBillAlert}
                          documentName="Paid Bill"
                          documentImage={historyData?.paidBillImage}
                          width={"100%"}
                          readOnly
                        />
                      )}
                    </div>
                  ) : (
                    <p>
                      Dues of{" "}
                      <span style={{ fontWeight: "bold", color: "red" }}>
                        Rs. {numberFormatting(historyData?.arrearsAmount)}
                      </span>{" "}
                      are still{" "}
                      <span style={{ fontWeight: "bold", color: "red" }}>
                        PENDING
                      </span>{" "}
                      against the property.
                    </p>
                  )}
                </div>
              </DialogContentText>
            ))}
        </div>
      </RcoActivityLogDialog>

      {/* Cost Estimated Sub Pop Up */}
      <RcoActivityLogDialog
        open={fieldSurveyedSubPopUp}
        onClose={() => closeCoaHistoryPopup(setFieldSurveyedSubPopUp)}
        title={getCoaFieldSurveyActivityTitle(historyData)}
        variant={
          (historyData?.applicationProgressId == 4 &&
            historyData?.objectionStatus == 1) ||
            isCoaRevertToFieldSurveyHistoryView(historyData)
            ? "action"
            : "submitted"
        }
        maxWidth="md"
        footer={
          historyData
            ? isCoaRevertToFieldSurveyHistoryView(historyData)
              ? `Application reverted to Field Survey by: ${historyData?.lastModifiedBy} on: ${convertDatewithTime(historyData?.lastModificationDate)}`
              : `Field Survey : ${historyData?.lastModifiedBy} on: ${convertDatewithTime(historyData?.lastModificationDate)}`
            : null
        }
      >
        <div className="wf-application-details-body coa-activity-log-body">
          {historyData?.applicationProgressId == 5 ? (

            <Grid container spacing={2} className="container coa-field-survey-cost-container">
              <Grid
                container
                item
                spacing={2}
                className="application-details coa-field-survey-cost-row"
                wrap="nowrap"
                xs={12}
              >
                <Grid item xs={4} className="first-row-item">
                  <Typography className="prop-title">Capital Cost</Typography>
                  <Typography className="prop-detail">
                    {Number(historyData?.capitalCostAmount) > 0
                      ? numberFormatting(historyData.capitalCostAmount)
                      : "-"}
                  </Typography>
                </Grid>

                <Grid item xs={4} className="first-row-item">
                  <Typography className="prop-title">
                    Security to be Deposited
                  </Typography>
                  <Typography className="prop-detail">
                    {Number(historyData?.securityDepositeAmount) > 0
                      ? numberFormatting(historyData.securityDepositeAmount)
                      : "-"}
                  </Typography>
                </Grid>

                <Grid item xs={4} className="first-row-item total-item">
                  <Typography className="prop-title">
                    Total Cost Estimates Deposit
                  </Typography>
                  <Typography className="prop-detail total-value">
                    {(() => {
                      const capitalCostAmount =
                        Number(historyData?.capitalCostAmount) || 0;
                      const securityDepositeAmount =
                        Number(historyData?.securityDepositeAmount) || 0;
                      const total =
                        capitalCostAmount + securityDepositeAmount;

                      return total > 0
                        ? `Rs. ${numberFormatting(parseInt(total))}`
                        : "-";
                    })()}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>

          ) : historyData?.applicationProgressId == 4 &&
            historyData?.objectionStatus == 1 ? (
            <>

              <Grid item lg={6} md={6} xs={12} className="first-row-item">
                <Typography className="prop-title">
                  Site Observation Objection
                </Typography>
                <TextField
                  fullWidth
                  disabled
                  value={
                    historyData?.observationType == 6
                      ? historyData?.remarksDetail || "No Remarks Found"
                      : lookUpDataOfCON?.lookupFSObservation?.find(
                        (o) =>
                          o.observationType == historyData?.observationType
                      )?.observationDetails || "No Objection Details Found"
                  }
                  InputProps={{
                    readOnly: true,
                  }}
                />
              </Grid>

            </>
          ) : historyData?.applicationProgressId == 4 &&
            historyData?.objectionStatus != 1 &&
            historyData?.remarks == "Field Survey Objection Removed." ? (
            <>

              <Grid item lg={6} md={6} xs={12} className="first-row-item">
                <Typography className="prop-title" style={{ color: "green" }}>
                  Site Observation Objection Removed
                </Typography>
              </Grid>

            </>
          ) : isCoaRevertToFieldSurveyHistoryView(historyData) ? (

            <Grid item lg={12} className="first-row-item">
              <Typography className="prop-title" style={{ color: "red" }}>
                Application Reverted to Field Survey from DN Approval
              </Typography>
            </Grid>

          ) : null}
        </div>
      </RcoActivityLogDialog>

      <RcoActivityLogDialog
        open={fieldSurveyedObjectionSubPopUp}
        onClose={() => closeCoaHistoryPopup(setFieldSurveyedObjectionSubPopUp)}
        title="Field Survey Objection"
        variant="action"
        maxWidth="md"
        footer={
          historyData
            ? `Field Survey : ${historyData?.lastModifiedBy} on: ${convertDatewithTime(historyData?.lastModificationDate)}`
            : null
        }
      >
        <div className="wf-application-details-body coa-activity-log-body">
          {historyData?.applicationProgressId == 4 &&
            historyData?.objectionStatus == 1 ? (
            <p className="rco-history-status-banner rco-history-status-banner--reject">
              {historyData?.observationType == 6
                ? historyData?.remarksDetail || "No Remarks Found"
                : lookUpDataOfCON?.lookupFSObservation?.find(
                  (o) => o.observationType == historyData?.observationType
                )?.observationDetails || "No Objection Details Found"}
            </p>
          ) : null}
        </div>
      </RcoActivityLogDialog>

      {/* Demand Note Approved Pop Up */}
      <RcoActivityLogDialog
        open={dnApprovalSubPopUp}
        onClose={() => closeCoaHistoryPopup(setDnApprovalSubPopUp)}
        title={getCoaDnApprovalActivityTitle(historyData)}
        variant={
          isCoaDemandNoteRejectionHistoryView(historyData) ||
            (historyData?.applicationProgressId == 6 &&
              historyData?.objectionStatus == 1)
            ? "action"
            : "submitted"
        }
        maxWidth="md"
        headerAction={
          !isCoaDemandNoteRejectionHistoryView(historyData) &&
            canDownloadCoaDemandNotice(historyData?.applicationProgressId) ? (
            <button
              type="button"
              className="rco-history-print-btn"
              onClick={handleDialogDnDownload}
              aria-label="Print DN"
            >
              <PrintIcon />
            </button>
          ) : null
        }
        footer={
          historyData
            ? isCoaDemandNoteRejectionHistoryView(historyData)
              ? `Demand Note Payment Rejected by: ${historyData?.lastModifiedBy || "-"} on: ${convertDatewithTime(historyData?.lastModificationDate)}`
              : `Demand Notice Approved by : ${historyData?.lastModifiedBy} on: ${convertDatewithTime(historyData?.lastModificationDate)} `
            : null
        }
      >
        <div className="wf-application-details-body coa-activity-log-body">
          {historyData?.applicationProgressId == 6 &&
            historyData?.objectionStatus !== 1 ? (
            <div className="rco-history-details-grid">
              <div>
                <label className="field-label">Issue Date</label>
                <TextField
                  fullWidth
                  value={
                    dnApproveStep?.issueDate
                      ? convertDate(dnApproveStep.issueDate)
                      : "N/A"
                  }
                  InputProps={{ readOnly: true }}
                  size="small"
                  disabled
                />
              </div>
              <div>
                <label className="field-label">Due Date</label>
                <TextField
                  fullWidth
                  value={
                    dnApproveStep?.dueDate
                      ? convertDate(dnApproveStep.dueDate)
                      : "N/A"
                  }
                  InputProps={{ readOnly: true }}
                  size="small"
                  disabled
                />
              </div>
              <div>
                <label className="field-label">Bank Name</label>
                <TextField
                  fullWidth
                  value={bankName || "N/A"}
                  InputProps={{ readOnly: true }}
                  size="small"
                  disabled
                />
              </div>
              {historyData?.capitalCostAmount > 0 ? (
                <div>
                  <label className="field-label">Capital Cost</label>
                  <TextField
                    fullWidth
                    value={numberFormatting(historyData.capitalCostAmount)}
                    InputProps={{ readOnly: true }}
                    size="small"
                    disabled
                  />
                </div>
              ) : null}
              {historyData?.securityDepositeAmount > 0 ? (
                <div>
                  <label className="field-label">Security to be Deposited</label>
                  <TextField
                    fullWidth
                    value={numberFormatting(historyData.securityDepositeAmount)}
                    InputProps={{ readOnly: true }}
                    size="small"
                    disabled
                  />
                </div>
              ) : null}
              <div className="coa-dn-grand-total">
                <label className="field-label">Grand Total</label>
                <TextField
                  fullWidth
                  value={(() => {
                    const capitalCostAmount =
                      Number(historyData?.capitalCostAmount) || 0;
                    const securityDepositeAmount =
                      Number(historyData?.securityDepositeAmount) || 0;
                    const total = capitalCostAmount + securityDepositeAmount;
                    return total > 0
                      ? `Rs. ${numberFormatting(parseInt(total))}`
                      : "N/A";
                  })()}
                  InputProps={{ readOnly: true }}
                  size="small"
                  disabled
                />
              </div>
            </div>
          ) : isCoaDemandNoteRejectionHistoryView(historyData) ? (

            <Grid container spacing={2} className="container">
              <Grid container item spacing={2} className="application-details">
                <Grid item lg={4} md={6} xs={12} className="first-row-item">
                  <Typography className="prop-title">Payment Date</Typography>
                  <Typography className="prop-detail">
                    {historyData?.paymentDate
                      ? convertDate(historyData.paymentDate)
                      : paidDnImageDetails?.paymentDate
                        ? convertDate(paidDnImageDetails.paymentDate)
                        : "-"}
                  </Typography>
                </Grid>
                <Grid item lg={4} md={6} xs={12} className="paidDnDocument item">
                  <Typography className="prop-title">Paid Demand Notice</Typography>
                  <Grid
                    container
                    sx={{
                      backgroundColor: getDocumentBackGroundColor(-1),
                      borderRadius: "10px",
                      minHeight: "180px",
                      width: "100%",
                    }}
                    className="docContainer"
                  >
                    <Grid
                      item
                      lg={12}
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        padding: "10px",
                      }}
                    >
                      {getCoaHistoryPaidDnImage(historyData) ? (
                        <div
                          onClick={() => {
                            openPaidDnImageViewer(
                              resolvePaidDnPreviewImage(
                                getCoaHistoryPaidDnImage(historyData)
                              ) || getCoaHistoryPaidDnImage(historyData)
                            );
                          }}
                          style={{
                            cursor: "pointer",
                            display: "flex",
                            justifyContent: "center",
                          }}
                        >
                          <Base64Image
                            data={
                              resolvePaidDnPreviewImage(
                                getCoaHistoryPaidDnImage(historyData)
                              ) || getCoaHistoryPaidDnImage(historyData)
                            }
                            width={100}
                          />
                        </div>
                      ) : (
                        <Typography className="prop-detail">-</Typography>
                      )}
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>

          ) : (
            historyData?.applicationProgressId == 6 &&
            historyData?.objectionStatus == 1 && (

              <Typography style={{ color: "red" }}>
                Objection raised on DN Payment Verification
              </Typography>

            )
          )}
        </div>
      </RcoActivityLogDialog>

      {/* Shared Paid DN viewer — one instance only (avoids double preview) */}
      {paidDNImagePopUp && paidDnViewerDocument ? (
        <OpenBase64ImageInPopup
          docVerifyPopUp={paidDNImagePopUp}
          hideDocVerifyPopup={hidePaidDnImagePopUp}
          documentName="Paid DN Image"
          documentImage={paidDnViewerDocument}
          width={"100%"}
          readOnly
          document={paidDnViewerDocument}
          documentFlag={1}
          applicationProgressId={dialogRowData.applicationProgressId}
          objectionStatus={dialogRowData.objectionStatus}
          updateDocFlag={updateDocFlag}
          titleToUpdateFlag="copyOfApplicantCNIC"
          flag_document={1}
        />
      ) : null}

      {/* DN Payment Submitted Pub Pop Up */}
      <RcoActivityLogDialog
        open={dnPaymentSubmittedSubPopUp}
        onClose={() => closeCoaHistoryPopup(setDnPaymentSubmittedSubPopUp)}
        title="DN Payment Submitted"
        variant="submitted"
        maxWidth="md"
        footer={
          historyData
            ? `Paid Demand Notice Image Uploaded by: ${historyData?.lastModifiedBy} on: ${convertDatewithTime(historyData?.lastModificationDate)}`
            : null
        }
      >
        <div className="wf-application-details-body coa-activity-log-body">
          <Grid container spacing={2} className="container">
            {/* --- Row 1: Demand Notice Info --- */}
            <Grid container item spacing={2} className="application-details">
              <Grid item lg={3} md={6} xs={12} className="first-row-item">
                <Typography className="prop-title">Demand Notice No</Typography>
                <Typography className="prop-detail">
                  {dnApproveStep?.demandNoteNo || "-"}
                </Typography>
              </Grid>

              {historyData?.capitalCostAmount > 0 && (
                <Grid item lg={3} md={6} xs={12} className="first-row-item">
                  <Typography className="prop-title">Capital Cost</Typography>
                  <Typography className="prop-detail">
                    {numberFormatting(historyData.capitalCostAmount)}
                  </Typography>
                </Grid>
              )}

              {historyData?.securityDepositeAmount > 0 && (
                <Grid item lg={3} md={6} xs={12} className="first-row-item">
                  <Typography className="prop-title">
                    Security to be Deposited
                  </Typography>
                  <Typography className="prop-detail">
                    {numberFormatting(historyData.securityDepositeAmount)}
                  </Typography>
                </Grid>
              )}


              {/* --- Total --- */}
              <Grid
                item
                lg={3}
                md={6}
                xs={12}
                className="first-row-item total-item"
              >
                <Typography className="prop-title">
                  Grand Total
                </Typography>
                <Typography className="prop-detail total-value">
                  {(() => {
                    const capitalCostAmount =
                      Number(historyData?.capitalCostAmount) || 0;
                    const securityDepositeAmount =
                      Number(historyData?.securityDepositeAmount) || 0;

                    const total =
                      capitalCostAmount +
                      securityDepositeAmount

                    return total > 0
                      ? `Rs. ${numberFormatting(parseInt(total))}`
                      : "-";
                  })()}
                </Typography>
              </Grid>
            </Grid>

            <Grid container item spacing={2} className="application-details">
              <Grid item lg={3} md={6} xs={12} className="first-row-item">
                <Typography className="prop-title">Payment Date</Typography>
                <Typography className="prop-detail">
                  {historyData?.paymentDate
                    ? convertDate(historyData.paymentDate)
                    : "-"}
                </Typography>
              </Grid>

              <Grid item lg={3} className="paidDnDocument item">
                <Typography className="title">Paid Demand Notice</Typography>
                <Grid
                  container
                  sx={{
                    backgroundColor: getDocumentBackGroundColor(0),
                    borderRadius: "10px",
                    height: "250px",
                    width: "100%",
                    marginRight: "2%",
                  }}
                  className="docContainer"
                >
                  <Grid
                    item
                    lg={12}
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      paddingBottom: "5px",
                    }}
                  >
                    <div
                      onClick={() => {
                        openPaidDnImageViewer(paidDNVoucherImg || dnImage);
                      }}
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      {paidDNVoucherImg ? (
                        <img
                          src={paidDNVoucherImg}
                          alt="Paid Demand Notice"
                          style={{ maxWidth: "100%", maxHeight: 200, padding: "5px" }}
                        />
                      ) : (
                        <Base64Image data={dnImage} width={80} />
                      )}
                    </div>
                  </Grid>
                </Grid>
              </Grid>

              <Grid item lg={3} md={6} xs={12}></Grid>
            </Grid>
          </Grid>
        </div>
      </RcoActivityLogDialog>

      <RcoActivityLogDialog
        open={dnPaymentVerifiedSubPopUp}
        onClose={() => closeCoaHistoryPopup(setDnPaymentVerifiedSubPopUp)}
        title="DN Payment Verified"
        variant="submitted"
        maxWidth="md"
        footer={
          historyData
            ? `Demand Notice Payment Verified by: ${historyData?.lastModifiedBy} on: ${convertDatewithTime(historyData?.lastModificationDate)}`
            : null
        }
      >
        <div className="wf-application-details-body coa-activity-log-body">
          <Grid container spacing={2} className="container">
            {/* --- Row 1: Demand Notice Info --- */}
            <Grid container item spacing={2} className="application-details">
              <Grid item lg={3} md={6} xs={12} className="first-row-item">
                <Typography className="prop-title">Demand Notice No</Typography>
                <Typography className="prop-detail">
                  {dnApproveStep?.demandNoteNo || "-"}
                </Typography>
              </Grid>

              {historyData?.capitalCostAmount > 0 && (
                <Grid item lg={3} md={6} xs={12} className="first-row-item">
                  <Typography className="prop-title">Capital Cost</Typography>
                  <Typography className="prop-detail">
                    {numberFormatting(historyData.capitalCostAmount)}
                  </Typography>
                </Grid>
              )}

              {historyData?.securityDepositeAmount > 0 && (
                <Grid item lg={3} md={6} xs={12} className="first-row-item">
                  <Typography className="prop-title">
                    Security to be Deposited
                  </Typography>
                  <Typography className="prop-detail">
                    {numberFormatting(historyData.securityDepositeAmount)}
                  </Typography>
                </Grid>
              )}

              {/* --- Total --- */}
              <Grid
                item
                lg={3}
                md={6}
                xs={12}
                className="first-row-item total-item"
              >
                <Typography className="prop-title">
                  Grand Total
                </Typography>
                <Typography className="prop-detail total-value">
                  {(() => {
                    const capitalCostAmount =
                      Number(historyData?.capitalCostAmount) || 0;
                    const securityDepositeAmount =
                      Number(historyData?.securityDepositeAmount) || 0;

                    const total =
                      capitalCostAmount +
                      securityDepositeAmount

                    return total > 0
                      ? `Rs. ${numberFormatting(parseInt(total))}`
                      : "-";
                  })()}
                </Typography>
              </Grid>
            </Grid>

            <Grid container item spacing={2} className="application-details">
              <Grid item lg={3} md={6} xs={12} className="first-row-item">
                <Typography className="prop-title">Payment Date</Typography>
                <Typography className="prop-detail">
                  {historyData?.paymentDate
                    ? convertDate(historyData.paymentDate)
                    : "-"}
                </Typography>
              </Grid>
              <Grid item lg={3} md={6} xs={12} className="first-row-item">
                <Typography className="prop-title">Verify By</Typography>
                <Typography className="prop-detail">
                  {historyData?.lastModifiedBy
                    ? historyData.lastModifiedBy
                    : "-"}
                </Typography>
              </Grid>
              <Grid item lg={3} md={6} xs={12} className="first-row-item">
                <Typography className="prop-title">
                  Verification Date
                </Typography>
                <Typography className="prop-detail">
                  {historyData?.lastModificationDate
                    ? convertDate(historyData.lastModificationDate)
                    : "-"}
                </Typography>
              </Grid>
              <Grid item lg={3} md={6} xs={12} className="first-row-item">
                <Typography className="prop-title">
                  Paid Demand Notice
                </Typography>
                <Grid
                  container
                  sx={{
                    backgroundColor: getDocumentBackGroundColor(0),
                    borderRadius: "10px",
                  }}
                  className="docContainer"
                >
                  <Grid
                    item
                    lg={12}
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <div
                      onClick={() =>
                        openPaidDnImageViewer(
                          resolvePaidDnPreviewImage(historyData?.paidDNImage) ||
                          historyData?.paidDNImage
                        )
                      }
                      style={{ display: "flex", justifyContent: "center" }}
                    >
                      <Base64Image
                        data={
                          resolvePaidDnPreviewImage(historyData?.paidDNImage) ||
                          historyData?.paidDNImage
                        }
                        width={100}
                      />
                    </div>
                  </Grid>
                </Grid>
              </Grid>

              <Grid item lg={3} md={6} xs={12}></Grid>
            </Grid>
          </Grid>
        </div>
      </RcoActivityLogDialog>

      <RcoActivityLogDialog
        open={serviceConnectionOrderedSubPopUp}
        onClose={() => closeCoaHistoryPopup(setServiceConnectionOrderedSubPopUp)}
        title="Sundary Job Order"
        variant="submitted"
        maxWidth="lg"
        footer={
          historyData
            ? isCoaSundryJobOrderApprovedHistoryView(historyData)
              ? `Sundary Job Order approved by: ${historyData?.lastModifiedBy || "-"} on: ${convertDatewithTime(historyData?.lastModificationDate)}`
              : isCoaSundryJobOrderSubmittedHistoryView(historyData)
                ? `Sundary Job Order submitted by: ${historyData?.lastModifiedBy || "-"} on: ${convertDatewithTime(historyData?.lastModificationDate)}`
                : "Sundary Job Order Issued"
            : null
        }
      >
        <div className="wf-application-details-body coa-activity-log-body">
          {isCoaSundryJobOrderApprovedHistoryView(historyData) ||
            isCoaSundryJobOrderSubmittedHistoryView(historyData) ? (
            <div className="rco-history-details-grid">
              <div>
                <label className="field-label">Remarks</label>
                <TextField
                  fullWidth
                  value={historyData?.remarks || "N/A"}
                  InputProps={{ readOnly: true }}
                  size="small"
                  disabled
                />
              </div>
              <div>
                <label className="field-label">Remarks Detail</label>
                <TextField
                  fullWidth
                  value={historyData?.remarksDetail || "N/A"}
                  InputProps={{ readOnly: true }}
                  size="small"
                  disabled
                />
              </div>
              <div>
                <label className="field-label">
                  {isCoaSundryJobOrderApprovedHistoryView(historyData)
                    ? "Approved By"
                    : "Submitted By"}
                </label>
                <TextField
                  fullWidth
                  value={historyData?.lastModifiedBy || "N/A"}
                  InputProps={{ readOnly: true }}
                  size="small"
                  disabled
                />
              </div>
            </div>
          ) : null}
        </div>
      </RcoActivityLogDialog>

      <RcoActivityLogDialog
        open={readyForBillingSubPopUp}
        onClose={() => closeCoaHistoryPopup(setReadyForBillingSubPopUp)}
        title="Ready for Billing"
        variant="submitted"
        maxWidth="sm"
        footer={
          historyData
            ? `Ready for billing is approved by: ${historyData?.lastModifiedBy || "-"} on: ${historyData?.lastModificationDate
              ? convertDatewithTime(historyData.lastModificationDate)
              : "-"
            }`
            : null
        }
      >
        <div className="wf-application-details-body coa-activity-log-body">
          <div className="rco-history-details-grid rco-history-details-grid--2col">
            <RcoHistoryField label="Remarks" value={historyData?.remarks} />
            <RcoHistoryField
              label="Remarks Detail"
              value={historyData?.remarksDetail}
            />
          </div>
        </div>
      </RcoActivityLogDialog>

      {/* Success / error response modal */}
      <Dialog
        open={openResponseModal}
        onClose={handleCloseResponseModal}
        className={`dde-result-dialog${responseModalMeta.isReject ? " dde-result-dialog--reject" : ""
          }`}
        fullWidth
        maxWidth="sm"
        PaperProps={{ className: "dde-result-dialog__paper" }}
      >
        <DialogTitle className="dde-result-dialog__title">
          <Box className="dde-result-dialog__icon-wrap">
            {responseModalMeta.isReject ? (
              <HighlightOffIcon className="dde-result-dialog__icon dde-result-dialog__icon--reject" />
            ) : (
              <CheckCircleIcon className="dde-result-dialog__icon dde-result-dialog__icon--approve" />
            )}
          </Box>
          <Typography variant="h6" className="dde-result-dialog__heading">
            {responseModalMeta.title}
          </Typography>
        </DialogTitle>

        <DialogContent className="dde-result-dialog__content">
          <DialogContentText component="div">
            <p className="dde-result-dialog__message">
              {responseMessageError || responseMessage}
            </p>

            {!responseMessageError && responseStoreRequisitionNo ? (
              <p className="dde-result-dialog__message">
                Store Requisition No: {responseStoreRequisitionNo}
              </p>
            ) : null}

            {(dialogRowData.applicationProgressId === 2) &&
              responseMessageError ? (
              <Box className="dde-result-dialog__actions">
                <Button
                  type="button"
                  variant="outlined"
                  className="dde-result-dialog__bill-btn"
                  onClick={() => downloadBill(dialogRowData.referenceNumber)}
                >
                  Open Your Bill
                </Button>
              </Box>
            ) : null}
          </DialogContentText>
        </DialogContent>
      </Dialog>

      <Dialog
        open={snackbar.open}
        onClose={handleCloseSnackbarDialog}
        className={`dde-result-dialog${snackbarDialogMeta.isReject ? " dde-result-dialog--reject" : ""
          }`}
        fullWidth
        maxWidth="sm"
        PaperProps={{ className: "dde-result-dialog__paper" }}
      >
        <DialogTitle className="dde-result-dialog__title">
          <Box className="dde-result-dialog__icon-wrap">
            {snackbarDialogMeta.isReject ? (
              <HighlightOffIcon className="dde-result-dialog__icon dde-result-dialog__icon--reject" />
            ) : (
              <CheckCircleIcon className="dde-result-dialog__icon dde-result-dialog__icon--approve" />
            )}
          </Box>
          <Typography variant="h6" className="dde-result-dialog__heading">
            {snackbarDialogMeta.title}
          </Typography>
        </DialogTitle>
        <DialogContent className="dde-result-dialog__content">
          <DialogContentText component="div">
            <p className="dde-result-dialog__message">{snackbar.message}</p>
          </DialogContentText>
        </DialogContent>
      </Dialog>

      {/* DN Rejection Modal FOR REMARLS */}
      <Dialog
        open={dnRejectModalOpen}
        onClose={() => {
          setDnRejectModalOpen(false);
          dnRejectFormik.resetForm();
        }}
        className="dn-reject-dialog"
        maxWidth="sm"
        fullWidth
        PaperProps={{ className: "dn-reject-dialog__paper" }}
      >
        <form
          onSubmit={(e) => {
            e.preventDefault();
            dnRejectFormik.handleSubmit();
          }}
        >
          <DialogTitle className="dn-reject-dialog__title">
            <div className="dn-reject-dialog__header">
              <Typography className="dn-reject-dialog__heading">
                Reject Demand Notice
              </Typography>
              <button
                type="button"
                className="dn-reject-dialog__close"
                onClick={() => {
                  setDnRejectModalOpen(false);
                  dnRejectFormik.resetForm();
                }}
                aria-label="Close dialog"
              >
                <CloseIcon />
              </button>
            </div>
          </DialogTitle>

          <DialogContent className="dn-reject-dialog__content">
            <div className="dn-reject-dialog__field">
              <label className="dn-reject-dialog__label" htmlFor="reasonType">
                Select Reason:
              </label>
              <TextField
                select
                id="reasonType"
                name="reasonType"
                fullWidth
                size="small"
                variant="outlined"
                className="dn-reject-dialog__select"
                value={dnRejectFormik.values.reasonType}
                onChange={dnRejectFormik.handleChange}
                onBlur={dnRejectFormik.handleBlur}
                error={
                  dnRejectFormik.touched.reasonType &&
                  Boolean(dnRejectFormik.errors.reasonType)
                }
              >
                <MenuItem value="">Select reason</MenuItem>
                <MenuItem value="4">Field Survey</MenuItem>
                <MenuItem value="3">Arrear Verification</MenuItem>
                <MenuItem value="1">Documents Verification</MenuItem>
              </TextField>
              {dnRejectFormik.touched.reasonType &&
                dnRejectFormik.errors.reasonType ? (
                <p className="dn-reject-dialog__error">
                  {dnRejectFormik.errors.reasonType}
                </p>
              ) : null}
            </div>

            <div className="dn-reject-dialog__field">
              <label className="dn-reject-dialog__label" htmlFor="remarks">
                Please provide a reason for rejection:
              </label>
              <TextField
                id="remarks"
                name="remarks"
                multiline
                rows={4}
                fullWidth
                variant="outlined"
                placeholder="Enter your remarks here..."
                className="dn-reject-dialog__textarea"
                value={dnRejectFormik.values.remarks}
                onChange={dnRejectFormik.handleChange}
                onBlur={dnRejectFormik.handleBlur}
                error={
                  dnRejectFormik.touched.remarks &&
                  Boolean(dnRejectFormik.errors.remarks)
                }
              />
              {dnRejectFormik.touched.remarks &&
                dnRejectFormik.errors.remarks ? (
                <p className="dn-reject-dialog__error">
                  {dnRejectFormik.errors.remarks}
                </p>
              ) : null}
            </div>
          </DialogContent>

          <DialogActions className="dn-reject-dialog__actions">
            <button
              type="button"
              onClick={() => {
                setDnRejectModalOpen(false);
                dnRejectFormik.resetForm();
              }}
              className="view-button"
            >
              Cancel
            </button>
            <button type="submit" className="reject-button">
              Reject
            </button>
          </DialogActions>
        </form>
      </Dialog>

      {/* Objection / Rejection Reason Dialog */}
      <Dialog
        open={objectionPopUpOpen}
        onClose={hideObjectionPopup}
        className="dn-reject-dialog"
        maxWidth="sm"
        fullWidth
        PaperProps={{ className: "dn-reject-dialog__paper" }}
      >
        <DialogTitle className="dn-reject-dialog__title">
          <div className="dn-reject-dialog__header">
            <Typography className="dn-reject-dialog__heading">
              Rejection Reason
            </Typography>
            <button
              type="button"
              className="dn-reject-dialog__close"
              onClick={hideObjectionPopup}
              aria-label="Close dialog"
            >
              <CloseIcon id="clearPopup" />
            </button>
          </div>
        </DialogTitle>

        <DialogContent className="dn-reject-dialog__content">
          <div className="dn-reject-dialog__field">
            <label className="dn-reject-dialog__label" htmlFor="iv_objection_step">
              Step
            </label>
            <TextField
              select
              id="iv_objection_step"
              name="iv_objection_step"
              fullWidth
              size="small"
              variant="outlined"
              className="dn-reject-dialog__select"
              value={objectionRevertFormik.values.iv_objection_step}
              onChange={objectionRevertFormik.handleChange}
              onBlur={objectionRevertFormik.handleBlur}
              error={
                objectionRevertFormik.touched.iv_objection_step &&
                Boolean(objectionRevertFormik.errors.iv_objection_step)
              }
            >
              <MenuItem value={4}>Field Survey</MenuItem>
              <MenuItem value={3}>Arrear Verification</MenuItem>
              <MenuItem value={1}>Document Verification</MenuItem>
            </TextField>
            {objectionRevertFormik.touched.iv_objection_step &&
              objectionRevertFormik.errors.iv_objection_step ? (
              <p className="dn-reject-dialog__error">
                {objectionRevertFormik.errors.iv_objection_step}
              </p>
            ) : null}
          </div>

          <div className="dn-reject-dialog__field">
            <label
              className="dn-reject-dialog__label"
              htmlFor="iv_objection_Descripton"
            >
              Reason
            </label>
            <TextField
              id="iv_objection_Descripton"
              name="iv_objection_Descripton"
              multiline
              rows={3}
              fullWidth
              variant="outlined"
              placeholder="Enter reason for rejection"
              className="dn-reject-dialog__textarea"
              value={objectionRevertFormik.values.iv_objection_Descripton}
              onChange={objectionRevertFormik.handleChange}
              onBlur={objectionRevertFormik.handleBlur}
              error={
                objectionRevertFormik.touched.iv_objection_Descripton &&
                Boolean(objectionRevertFormik.errors.iv_objection_Descripton)
              }
            />
            {objectionRevertFormik.touched.iv_objection_Descripton &&
              objectionRevertFormik.errors.iv_objection_Descripton ? (
              <p className="dn-reject-dialog__error">
                {objectionRevertFormik.errors.iv_objection_Descripton}
              </p>
            ) : null}
          </div>

          <DialogActions className="dn-reject-dialog__actions dn-reject-dialog__actions--inline">
            <button
              type="button"
              className="view-button"
              onClick={() => {
                objectionRevertFormik.handleSubmit();
              }}
            >
              Submit
            </button>
          </DialogActions>
        </DialogContent>
      </Dialog>

      {/* Cancel Application Dialog */}
      <Dialog
        open={cancelApplicationPopUpOpen}
        onClose={hideCancelApplicationPopup}
        className="dn-reject-dialog dn-reject-dialog--with-cancel"
        maxWidth="sm"
        fullWidth
        PaperProps={{ className: "dn-reject-dialog__paper" }}
      >
        <DialogTitle className="dn-reject-dialog__title">
          <div className="dn-reject-dialog__header">
            <Typography className="dn-reject-dialog__heading">
              Cancel Application
            </Typography>
            <button
              type="button"
              className="dn-reject-dialog__close"
              onClick={hideCancelApplicationPopup}
              aria-label="Close dialog"
            >
              <CloseIcon id="clearCancelApplicationPopup" />
            </button>
          </div>
        </DialogTitle>

        <DialogContent className="dn-reject-dialog__content">
          <Typography className="dn-reject-dialog__section-title">
            Cancels this application. User confirmation will be required before
            proceeding.
          </Typography>

          <div className="dn-reject-dialog__field">
            <label className="dn-reject-dialog__label" htmlFor="iv_cancel_remarks">
              Remarks
            </label>
            <TextField
              id="iv_cancel_remarks"
              name="iv_cancel_remarks"
              multiline
              rows={3}
              fullWidth
              variant="outlined"
              placeholder="Enter reason for cancellation"
              className="dn-reject-dialog__textarea"
              value={cancelApplicationRemarks}
              onChange={(e) => {
                setCancelApplicationRemarks(e.target.value);
                if (cancelRemarksError) {
                  const trimmed = e.target.value.trim();
                  if (trimmed.length >= 10) {
                    setCancelRemarksError("");
                  }
                }
              }}
              onBlur={() => {
                validateCancelRemarks();
              }}
              error={Boolean(cancelRemarksError)}
            />
            {cancelRemarksError ? (
              <p className="dn-reject-dialog__error">{cancelRemarksError}</p>
            ) : null}
          </div>

          <DialogActions className="dn-reject-dialog__actions dn-reject-dialog__actions--inline">
            <button
              type="button"
              className="reject-button"
              onClick={showCancelApplicationConfirm}
            >
              Cancel Application
            </button>
          </DialogActions>
        </DialogContent>
      </Dialog>

      {/* Cancel Application Confirmation */}
      <Dialog
        open={cancelApplicationConfirmOpen}
        onClose={hideCancelApplicationConfirm}
        fullWidth
        maxWidth="sm"
        className="cancel-application-confirm-dialog"
      >
        <DialogTitle className="cancel-confirm-dialog-title">
          <Grid container className="cancel-confirm-header">
            <Grid item className="cancel-confirm-title-wrap">
              <EventBusyIcon className="cancel-confirm-title-icon" />
              <span className="cancel-confirm-title-text">Confirm Cancellation</span>
            </Grid>
            <Grid item className="cancel-confirm-close">
              <CloseIcon
                id="clearCancelConfirmPopup"
                onClick={hideCancelApplicationConfirm}
              />
            </Grid>
          </Grid>
        </DialogTitle>
        <DialogContent className="cancel-confirm-dialog-content">
          <div className="cancel-confirm-body">
            <div className="cancel-confirm-icon-ring">
              <EventBusyIcon className="cancel-confirm-warning-icon" />
            </div>
            <Typography className="cancel-confirm-message">
              Are you sure you want to cancel this application?
            </Typography>
            <div className="cancel-confirm-app-id">
              {dialogRowData?.applicationId}
            </div>
            <Typography className="cancel-confirm-note">
              This action cannot be undone. User confirmation is required before
              the application is cancelled.
            </Typography>
          </div>
        </DialogContent>
        <DialogActions className="cancel-confirm-dialog-actions">
          <button
            type="button"
            className="cancel-confirm-no-btn"
            onClick={hideCancelApplicationConfirm}
          >
            No, Keep Application
          </button>
          <button
            type="button"
            className="cancel-confirm-yes-btn"
            onClick={submitCancelApplication}
          >
            Yes, Cancel Application
          </button>
        </DialogActions>
      </Dialog>

      {/* Restore Application Dialog */}
      <Dialog
        open={restoreApplicationPopUpOpen}
        onClose={hideRestoreApplicationPopup}
        className="dn-reject-dialog dn-reject-dialog--with-cancel"
        maxWidth="sm"
        fullWidth
        PaperProps={{ className: "dn-reject-dialog__paper" }}
      >
        <DialogTitle className="dn-reject-dialog__title">
          <div className="dn-reject-dialog__header">
            <Typography className="dn-reject-dialog__heading">
              Restore Application
            </Typography>
            <button
              type="button"
              className="dn-reject-dialog__close"
              onClick={hideRestoreApplicationPopup}
              aria-label="Close dialog"
            >
              <CloseIcon id="clearRestoreApplicationPopup" />
            </button>
          </div>
        </DialogTitle>

        <DialogContent className="dn-reject-dialog__content">
          <Typography className="dn-reject-dialog__section-title">
            {restoreRequiresLoeDocument || isCoaRestoreAfterLoeWindow()
              ? "The restore window has expired. Upload Letter of Explanation (LOE) document and remarks to restore this application."
              : "Restores this rejected application. User confirmation will be required before proceeding."}
          </Typography>

          {restoreRequiresLoeDocument || isCoaRestoreAfterLoeWindow()
            ? renderRestoreLoeDocumentField("iv_coa_restore_loe_document")
            : null}

          <div className="dn-reject-dialog__field">
            <label
              className="dn-reject-dialog__label"
              htmlFor="iv_coa_restore_remarks"
            >
              Remarks
            </label>
            <TextField
              id="iv_coa_restore_remarks"
              name="iv_coa_restore_remarks"
              multiline
              rows={3}
              fullWidth
              variant="outlined"
              placeholder="Enter reason for restoring application"
              className="dn-reject-dialog__textarea"
              value={restoreApplicationRemarks}
              onChange={(e) => {
                setRestoreApplicationRemarks(e.target.value);
                if (restoreRemarksError) {
                  const trimmed = e.target.value.trim();
                  if (trimmed.length >= 10) {
                    setRestoreRemarksError("");
                  }
                }
              }}
              onBlur={() => {
                validateRestoreRemarks();
              }}
              error={Boolean(restoreRemarksError)}
            />
            {restoreRemarksError ? (
              <p className="dn-reject-dialog__error">{restoreRemarksError}</p>
            ) : null}
          </div>

          <DialogActions className="dn-reject-dialog__actions dn-reject-dialog__actions--inline">
            <button
              type="button"
              className="view-button"
              onClick={showRestoreApplicationConfirm}
            >
              Restore Application
            </button>
          </DialogActions>
        </DialogContent>
      </Dialog>

      {/* Restore Application Confirmation */}
      <Dialog
        open={restoreApplicationConfirmOpen}
        onClose={hideRestoreApplicationConfirm}
        fullWidth
        maxWidth="sm"
        className="cancel-application-confirm-dialog"
      >
        <DialogTitle className="cancel-confirm-dialog-title">
          <Grid container className="cancel-confirm-header">
            <Grid item className="cancel-confirm-title-wrap">
              <RestoreIcon className="cancel-confirm-title-icon" />
              <span className="cancel-confirm-title-text">Confirm Restore</span>
            </Grid>
            <Grid item className="cancel-confirm-close">
              <CloseIcon
                id="clearCoaRestoreConfirmPopup"
                onClick={hideRestoreApplicationConfirm}
              />
            </Grid>
          </Grid>
        </DialogTitle>
        <DialogContent className="cancel-confirm-dialog-content">
          <div className="cancel-confirm-body">
            <div className="restore-confirm-icon-ring">
              <RestoreIcon className="restore-confirm-icon" />
            </div>
            <Typography className="cancel-confirm-message">
              Are you sure you want to restore this application?
            </Typography>
            <div className="cancel-confirm-app-id">
              {dialogRowData?.applicationId}
            </div>
            <Typography className="cancel-confirm-note">
              {restoreRequiresLoeDocument || isCoaRestoreAfterLoeWindow()
                ? "This will restore the rejected application with the uploaded Letter of Explanation (LOE) document so workflow can continue."
                : "This will restore the rejected application so DN Approval workflow can continue."}
            </Typography>
          </div>
        </DialogContent>
        <DialogActions className="cancel-confirm-dialog-actions">
          <button
            type="button"
            className="cancel-confirm-no-btn"
            onClick={hideRestoreApplicationConfirm}
          >
            No, Keep Rejected
          </button>
          <button
            type="button"
            className="restore-confirm-yes-btn"
            onClick={submitRestoreApplication}
          >
            Yes, Restore Application
          </button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={showBoq}
        onClose={() => setShowBoq(false)}
        fullWidth
        maxWidth="md"
        className="rco-prepare-estimate-dialog"
        PaperProps={{ className: "rco-prepare-estimate-dialog__paper" }}
      >
        <DialogTitle className="rco-prepare-estimate-dialog__title">
          <Box className="rco-prepare-estimate-dialog__header">
            <Typography className="rco-prepare-estimate-dialog__heading">
              Prepare Estimate
            </Typography>
            <CloseIcon
              id="clearPopup"
              className="rco-prepare-estimate-dialog__close"
              onClick={() => {
                arearBillDocumentFormik.resetForm();
                arearBillDocumentFormik.values.iv_arear_paid_bill_document = "";
                setShowBoq(false);
              }}
            />
          </Box>
        </DialogTitle>

        <DialogContent className="rco-prepare-estimate-dialog__content">
          {fieldFormik.values.iv_material_required === true && (
            <Box className="rco-prepare-estimate-dialog__item-panel">
              <Box className="rco-prepare-estimate-dialog__item-row">
                <Box>
                  <Typography className="fieldLabel">Item</Typography>
                  <Autocomplete
                    options={allMaterialList || []}
                    getOptionLabel={(option) =>
                      option
                        ? option.item_Name
                          ? `${option.item_Code} - ${option.item_Name}`
                          : option.item_Code
                        : ""
                    }
                    value={
                      (allMaterialList || []).find(
                        (item) =>
                          item.item_Code === fieldItemFormik.values.iv_fieldItemId
                      ) || null
                    }
                    onChange={(event, newValue) => {
                      fieldItemFormik.setFieldValue(
                        "iv_fieldItemId",
                        newValue ? newValue.item_Code : ""
                      );
                    }}
                    filterOptions={(options, state) =>
                      options.filter((option) => {
                        const input = state.inputValue.toLowerCase();
                        return (
                          String(option.item_Code)
                            .toLowerCase()
                            .includes(input) ||
                          (option.item_Name &&
                            String(option.item_Name)
                              .toLowerCase()
                              .includes(input))
                        );
                      })
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        placeholder="Select Item"
                        size="small"
                        error={
                          fieldItemFormik.touched.iv_fieldItemId &&
                          Boolean(fieldItemFormik.errors.iv_fieldItemId)
                        }
                        helperText={
                          fieldItemFormik.touched.iv_fieldItemId &&
                          fieldItemFormik.errors.iv_fieldItemId
                        }
                        sx={{
                          "& .MuiInputBase-root": {
                            height: 36,
                            minHeight: 36,
                          },
                          "& .MuiInputBase-input": {
                            padding: "0 8px",
                          },
                        }}
                      />
                    )}
                    disableClearable
                    fullWidth
                    disabled={dnDetails && dnDetails.filledFlag === 1}
                  />
                </Box>

                <Box>
                  <Typography className="fieldLabel">Unit</Typography>
                  <TextField
                    name="iv_fieldItemUnit"
                    value={fieldItemFormik.values.iv_fieldItemUnit}
                    fullWidth
                    disabled
                    size="small"
                    InputProps={{
                      sx: {
                        height: 36,
                        background: "#fff",
                        "& input": { textAlign: "right" },
                      },
                    }}
                  />
                </Box>

                <Box>
                  <Typography className="fieldLabel">Qty</Typography>
                  <TextField
                    name="iv_fieldItemQty"
                    disabled={dnDetails && dnDetails.filledFlag === 1}
                    value={formatWholeNumberInput(fieldItemFormik.values.iv_fieldItemQty)}
                    fullWidth
                    className="rco-prepare-estimate-dialog__qty-field"
                    onChange={(e) =>
                      fieldItemFormik.setFieldValue(
                        "iv_fieldItemQty",
                        sanitizeWholeNumberInput(e.target.value)
                      )
                    }
                    type="text"
                    inputProps={{ inputMode: "numeric" }}
                    size="small"
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            size="small"
                            disabled={dnDetails && dnDetails.filledFlag === 1}
                            onClick={() => {
                              const curr = parseInt(
                                fieldItemFormik.values.iv_fieldItemQty,
                                10
                              );
                              const current = isNaN(curr) ? 1 : curr;
                              const next = current - 1 >= 1 ? current - 1 : 1;
                              fieldItemFormik.setFieldValue(
                                "iv_fieldItemQty",
                                String(next)
                              );
                            }}
                          >
                            <RemoveIcon fontSize="small" />
                          </IconButton>
                          <IconButton
                            size="small"
                            disabled={dnDetails && dnDetails.filledFlag === 1}
                            onClick={() => {
                              const curr = parseInt(
                                fieldItemFormik.values.iv_fieldItemQty,
                                10
                              );
                              const current = isNaN(curr) || curr < 1 ? 0 : curr;
                              fieldItemFormik.setFieldValue(
                                "iv_fieldItemQty",
                                String(current + 1)
                              );
                            }}
                          >
                            <AddIcon fontSize="small" />
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                </Box>

                <Box>
                  <Button
                    variant="contained"
                    startIcon={<AddIcon />}
                    fullWidth
                    className="rco-prepare-estimate-dialog__add-btn"
                    onClick={fieldItemFormik.handleSubmit}
                    disabled={dnDetails && dnDetails.filledFlag === 1}
                  >
                    Add
                  </Button>
                </Box>
              </Box>
            </Box>
          )}

          {fieldFormik.values.iv_material_required === true &&
            itemsArray?.length > 0 && (
              <TableContainer
                component={Paper}
                className="rco-prepare-estimate-dialog__items-table"
                sx={{ maxHeight: 250, overflowY: "auto" }}
              >
                <Table size="small" stickyHeader>
                  <TableHead>
                    <TableRow>
                      <TableCell>Sr.</TableCell>
                      <TableCell>Item Name</TableCell>
                      <TableCell align="left">Unit</TableCell>
                      <TableCell align="center" sx={{ minWidth: 78 }}>
                        Qty
                      </TableCell>
                      <TableCell align="right">Rate</TableCell>
                      <TableCell align="right">Amount</TableCell>
                      <TableCell align="center"></TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {itemsArray.map((row, index) => {
                      const rowKey = row.item_Code ?? row.Id ?? index;
                      return (
                        <TableRow key={String(rowKey)}>
                          <TableCell>{index + 1}</TableCell>
                          <TableCell>{row.item_Name}</TableCell>
                          <TableCell align="left">{row.unit}</TableCell>
                          <TableCell align="center" sx={{ minWidth: 78 }}>
                            <Box className="rco-prepare-estimate-qty-control">
                              <IconButton
                                size="small"
                                onClick={() => updateItemQtyByDelta(rowKey, -1)}
                                disabled={dnDetails && dnDetails.filledFlag === 1}
                              >
                                <RemoveIcon fontSize="small" />
                              </IconButton>
                              <Typography component="span">
                                {numberFormatting(row.qty)}
                              </Typography>
                              <IconButton
                                size="small"
                                onClick={() => updateItemQtyByDelta(rowKey, 1)}
                                disabled={dnDetails && dnDetails.filledFlag === 1}
                              >
                                <AddIcon fontSize="small" />
                              </IconButton>
                            </Box>
                          </TableCell>
                          <TableCell align="right">
                            {numberFormatting(row.rate)}
                          </TableCell>
                          <TableCell align="right">
                            {numberFormatting(row.amount)}
                          </TableCell>
                          <TableCell align="center">
                            <IconButton
                              onClick={() => deleteItem(rowKey)}
                              disabled={dnDetails && dnDetails.filledFlag === 1}
                            >
                              <DeleteIcon fontSize="small" />
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </TableContainer>
            )}

          <Box className="rco-prepare-estimate-dialog__charges-grid">
            <Box className="rco-prepare-estimate-charge rco-prepare-estimate-charge--readonly">
              <Typography className="fieldLabel">Items' Total Amount</Typography>
              <TextField
                size="small"
                fullWidth
                disabled
                className="rco-prepare-estimate-charge__readonly-input"
                value={itemsAmount ? numberFormatting(itemsAmount) : "-"}
              />
            </Box>

            <Box className="rco-prepare-estimate-charge rco-prepare-estimate-charge--readonly">
              <Typography className="fieldLabel">
                {dialogRowData?.applicationId?.slice(3, 5) === "13"
                  ? "Store Charges (0%)"
                  : "Store Charges (12%)"}
              </Typography>
              <TextField
                size="small"
                fullWidth
                disabled
                className="rco-prepare-estimate-charge__readonly-input"
                value={
                  dialogRowData?.applicationId?.slice(3, 5) === "13"
                    ? 0
                    : storeCharges
                      ? formatBoqChargeAmount(storeCharges)
                      : "-"
                }
              />
            </Box>

            <Box className="rco-prepare-estimate-charge rco-prepare-estimate-charge--readonly">
              <Typography className="fieldLabel">Installation Charges (8%)</Typography>
              <TextField
                size="small"
                fullWidth
                disabled
                className="rco-prepare-estimate-charge__readonly-input"
                value={
                  installationCharges
                    ? formatBoqChargeAmount(installationCharges)
                    : "-"
                }
              />
            </Box>

            <Box className="rco-prepare-estimate-charge">
              <Typography className="fieldLabel">Grid Sharing Cost</Typography>
              <TextField
                name="iv_grid_sharing_cost"
                value={formatWholeNumberInput(fieldFormik.values.iv_grid_sharing_cost)}
                type="text"
                inputProps={{ inputMode: "numeric" }}
                size="small"
                fullWidth
                onChange={handleWholeNumberFieldChange(
                  "iv_grid_sharing_cost",
                  setGridSharingCost
                )}
              />
            </Box>

            <Box className="rco-prepare-estimate-charge">
              <Typography className="fieldLabel">Feeder Rehab Charges</Typography>
              <TextField
                name="iv_feeder_rehab_charges"
                value={formatWholeNumberInput(fieldFormik.values.iv_feeder_rehab_charges)}
                type="text"
                inputProps={{ inputMode: "numeric" }}
                size="small"
                fullWidth
                onChange={handleWholeNumberFieldChange(
                  "iv_feeder_rehab_charges",
                  setFeederRehabilitationCharges
                )}
              />
            </Box>

            <Box className="rco-prepare-estimate-charge">
              <Typography className="fieldLabel">Civil Work Charges</Typography>
              <TextField
                name="iv_civil_work_charges"
                value={formatWholeNumberInput(fieldFormik.values.iv_civil_work_charges)}
                type="text"
                inputProps={{ inputMode: "numeric" }}
                size="small"
                fullWidth
                onChange={handleWholeNumberFieldChange(
                  "iv_civil_work_charges",
                  setCivilWorkCharges
                )}
              />
            </Box>

            <Box className="rco-prepare-estimate-charge">
              <Typography className="fieldLabel">Misc. Charges</Typography>
              <TextField
                name="iv_miscellaneous_charges"
                value={formatWholeNumberInput(fieldFormik.values.iv_miscellaneous_charges)}
                type="text"
                inputProps={{ inputMode: "numeric" }}
                size="small"
                fullWidth
                onChange={handleWholeNumberFieldChange(
                  "iv_miscellaneous_charges",
                  setMiscellaneousCharges
                )}
              />
            </Box>

            <Box className="rco-prepare-estimate-charge">
              <Typography className="fieldLabel">Fixed Charges</Typography>
              <TextField
                name="iv_fixed_charges_of_metering"
                value={formatWholeNumberInput(fieldFormik.values.iv_fixed_charges_of_metering)}
                type="text"
                inputProps={{ inputMode: "numeric" }}
                size="small"
                fullWidth
                onChange={handleWholeNumberFieldChange(
                  "iv_fixed_charges_of_metering",
                  setFixedChargesOfMetering
                )}
              />
            </Box>

            <Box className="rco-prepare-estimate-charge">
              <Typography className="fieldLabel">Less the Cost</Typography>
              <TextField
                name="iv_less_the_cost"
                value={formatWholeNumberInput(fieldFormik.values.iv_less_the_cost)}
                type="text"
                inputProps={{ inputMode: "numeric" }}
                size="small"
                fullWidth
                onChange={handleWholeNumberFieldChange(
                  "iv_less_the_cost",
                  setLessTheCost
                )}
              />
            </Box>

            <Box className="rco-prepare-estimate-charge">
              <Typography className="fieldLabel">M&T Charges</Typography>
              <TextField
                name="iv_mnt_charges"
                value={formatWholeNumberInput(fieldFormik.values.iv_mnt_charges)}
                type="text"
                inputProps={{ inputMode: "numeric" }}
                size="small"
                fullWidth
                onChange={handleWholeNumberFieldChange(
                  "iv_mnt_charges",
                  setMntCharges
                )}
              />
            </Box>

            <Box className="rco-prepare-estimate-charge">
              <Typography className="fieldLabel">Labour Charges</Typography>
              <TextField
                name="iv_labour_charges"
                value={formatWholeNumberInput(fieldFormik.values.iv_labour_charges)}
                type="text"
                inputProps={{ inputMode: "numeric" }}
                size="small"
                fullWidth
                onChange={handleWholeNumberFieldChange(
                  "iv_labour_charges",
                  setLabourCharges
                )}
              />
            </Box>

            <Box className="rco-prepare-estimate-charge">
              <Typography className="fieldLabel">Design Vetting Fee</Typography>
              <TextField
                name="iv_design_vetting_fee"
                value={formatWholeNumberInput(fieldFormik.values.iv_design_vetting_fee)}
                type="text"
                inputProps={{ inputMode: "numeric" }}
                size="small"
                fullWidth
                onChange={handleWholeNumberFieldChange(
                  "iv_design_vetting_fee",
                  setDesignVettingFee
                )}
              />
            </Box>

            <Box className="rco-prepare-estimate-charge">
              <Typography className="fieldLabel">Consultancy Charges</Typography>
              <TextField
                name="iv_consultancy_charges"
                value={formatWholeNumberInput(fieldFormik.values.iv_consultancy_charges)}
                type="text"
                inputProps={{ inputMode: "numeric" }}
                size="small"
                fullWidth
                onChange={handleWholeNumberFieldChange(
                  "iv_consultancy_charges",
                  setConsultancyCharges
                )}
              />
            </Box>

            <Box className="rco-prepare-estimate-charge">
              <Typography className="fieldLabel">Variation Charges</Typography>
              <TextField
                name="iv_variation_charges"
                value={formatWholeNumberInput(fieldFormik.values.iv_variation_charges)}
                type="text"
                inputProps={{ inputMode: "numeric" }}
                size="small"
                fullWidth
                onChange={handleWholeNumberFieldChange(
                  "iv_variation_charges",
                  setVariationCharges
                )}
              />
            </Box>

            <Box className="rco-prepare-estimate-charge">
              <Typography className="fieldLabel">Dismantlement Charges</Typography>
              <TextField
                name="iv_dismantlement_charges"
                value={formatWholeNumberInput(fieldFormik.values.iv_dismantlement_charges)}
                type="text"
                inputProps={{ inputMode: "numeric" }}
                size="small"
                fullWidth
                onChange={handleWholeNumberFieldChange(
                  "iv_dismantlement_charges",
                  setDismantlementCharges
                )}
              />
            </Box>

            <Box className="rco-prepare-estimate-charge">
              <Typography className="fieldLabel">Earthing Charges</Typography>
              <TextField
                name="iv_earthing_charges"
                value={formatWholeNumberInput(fieldFormik.values.iv_earthing_charges)}
                type="text"
                inputProps={{ inputMode: "numeric" }}
                size="small"
                fullWidth
                onChange={handleWholeNumberFieldChange(
                  "iv_earthing_charges",
                  setEarthingCharges
                )}
              />
            </Box>

            <Box className="rco-prepare-estimate-dialog__total">
              <span>Total</span>
              <span>
                {grandTotalCharges ? numberFormatting(grandTotalCharges) : "-"}
              </span>
            </Box>
          </Box>
        </DialogContent>

        <DialogActions className="rco-prepare-estimate-dialog__actions">
          <Button
            variant="contained"
            className="rco-prepare-estimate-dialog__save-btn"
            onClick={onSaveCostEstimationConfirm}
          >
            Save Estimate
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={showCostEstimation}
        onClose={handleCostEstimationClose}
        fullWidth
        maxWidth="sm"
        className="rco-workflow-subdialog rco-workflow-subdialog--wide"
        PaperProps={{ className: "rco-workflow-subdialog__paper" }}
      >
        <DialogTitle className="rco-workflow-subdialog__title">
          <Box className="rco-workflow-subdialog__header">
            <Typography className="rco-workflow-subdialog__heading">
              Cost Estimation
            </Typography>
            <CloseIcon
              id="clearPopup"
              className="rco-workflow-subdialog__close"
              onClick={() => {
                arearBillDocumentFormik.resetForm();
                arearBillDocumentFormik.values.iv_arear_paid_bill_document = "";
                handleCostEstimationClose();
              }}
            />
          </Box>
        </DialogTitle>

        <DialogContent className="rco-workflow-subdialog__content">
          {costEstimationForNC ? (
            <Box className="rco-workflow-subdialog__summary-card">
              <Box className="rco-workflow-subdialog__summary-row">
                <strong>Items&apos; Total Amount:</strong>
                <span className="rco-workflow-subdialog__summary-value">
                  Rs.{" "}
                  {itemsAmount
                    ? Number(itemsAmount).toLocaleString()
                    : Number(
                      costEstimationForNC?.estimatedCapitalCost || 0
                    ).toLocaleString()}
                </span>
              </Box>

              <Box className="rco-workflow-subdialog__summary-row">
                <strong>
                  {dialogRowData?.applicationId?.slice(3, 5) === "13"
                    ? "Store Charges (0%):"
                    : "Store Charges (12%):"}
                </strong>
                <span className="rco-workflow-subdialog__summary-value">
                  Rs.{" "}
                  {dialogRowData?.applicationId?.slice(3, 5) === "13"
                    ? 0
                    : storeCharges
                      ? Number(storeCharges).toLocaleString()
                      : 0}
                </span>
              </Box>

              <Box className="rco-workflow-subdialog__summary-row">
                <strong>Installation Charges (8%):</strong>
                <span className="rco-workflow-subdialog__summary-value">
                  Rs.{" "}
                  {installationCharges
                    ? formatBoqChargeAmount(installationCharges)
                    : 0}
                </span>
              </Box>

              <Box className="rco-workflow-subdialog__summary-row">
                <strong>Grid Sharing Cost:</strong>
                <span className="rco-workflow-subdialog__summary-value">
                  Rs.{" "}
                  {gridSharingCost
                    ? Number(gridSharingCost).toLocaleString()
                    : Number(
                      costEstimationForNC?.amountOfGridSharing || 0
                    ).toLocaleString()}
                </span>
              </Box>

              <Box className="rco-workflow-subdialog__summary-row">
                <strong>Feeder Rehab Cost:</strong>
                <span className="rco-workflow-subdialog__summary-value">
                  Rs.{" "}
                  {feederRehabilitationCharges
                    ? Number(feederRehabilitationCharges).toLocaleString()
                    : Number(
                      costEstimationForNC?.amountOfFeederRehab || 0
                    ).toLocaleString()}
                </span>
              </Box>

              <Box className="rco-workflow-subdialog__summary-row">
                <strong>Civil Work Charges:</strong>
                <span className="rco-workflow-subdialog__summary-value">
                  Rs.{" "}
                  {civilWorkCharges
                    ? Number(civilWorkCharges).toLocaleString()
                    : Number(
                      costEstimationForNC?.civilWorkCharges || 0
                    ).toLocaleString()}
                </span>
              </Box>

              <Box className="rco-workflow-subdialog__summary-row">
                <strong>M&amp;T Charges:</strong>
                <span className="rco-workflow-subdialog__summary-value">
                  Rs.{" "}
                  {mntCharges
                    ? Number(mntCharges).toLocaleString()
                    : Number(costEstimationForNC?.mntCharges || 0).toLocaleString()}
                </span>
              </Box>

              <Box className="rco-workflow-subdialog__summary-row">
                <strong>Labour Charges:</strong>
                <span className="rco-workflow-subdialog__summary-value">
                  Rs.{" "}
                  {labourCharges
                    ? Number(labourCharges).toLocaleString()
                    : Number(
                      costEstimationForNC?.labourCharges || 0
                    ).toLocaleString()}
                </span>
              </Box>

              <Box className="rco-workflow-subdialog__summary-row">
                <strong>Design Vetting Fee:</strong>
                <span className="rco-workflow-subdialog__summary-value">
                  Rs.{" "}
                  {designVettingFee
                    ? Number(designVettingFee).toLocaleString()
                    : Number(
                      costEstimationForNC?.designVettingFee || 0
                    ).toLocaleString()}
                </span>
              </Box>

              <Box className="rco-workflow-subdialog__summary-row">
                <strong>Consultancy Charges:</strong>
                <span className="rco-workflow-subdialog__summary-value">
                  Rs.{" "}
                  {consultancyCharges
                    ? Number(consultancyCharges).toLocaleString()
                    : Number(
                      costEstimationForNC?.consultancyCharges || 0
                    ).toLocaleString()}
                </span>
              </Box>

              <Box className="rco-workflow-subdialog__summary-row">
                <strong>Variation Charges:</strong>
                <span className="rco-workflow-subdialog__summary-value">
                  Rs.{" "}
                  {variationCharges
                    ? Number(variationCharges).toLocaleString()
                    : Number(
                      costEstimationForNC?.variationCharges || 0
                    ).toLocaleString()}
                </span>
              </Box>

              <Box className="rco-workflow-subdialog__summary-row">
                <strong>Dismantlement Charges:</strong>
                <span className="rco-workflow-subdialog__summary-value">
                  Rs.{" "}
                  {dismantlementCharges
                    ? Number(dismantlementCharges).toLocaleString()
                    : Number(
                      costEstimationForNC?.dismantlementCharges || 0
                    ).toLocaleString()}
                </span>
              </Box>

              <Box className="rco-workflow-subdialog__summary-row">
                <strong>Earthing Charges:</strong>
                <span className="rco-workflow-subdialog__summary-value">
                  Rs.{" "}
                  {earthingCharges
                    ? Number(earthingCharges).toLocaleString()
                    : Number(
                      costEstimationForNC?.earthingCharges || 0
                    ).toLocaleString()}
                </span>
              </Box>

              <Box className="rco-workflow-subdialog__summary-row">
                <strong>Fixed Charges:</strong>
                <span className="rco-workflow-subdialog__summary-value">
                  Rs.{" "}
                  {fixedChargesOfMetering
                    ? Number(fixedChargesOfMetering).toLocaleString()
                    : Number(
                      costEstimationForNC?.fixedChargesOfMetering || 0
                    ).toLocaleString()}
                </span>
              </Box>

              <Box className="rco-workflow-subdialog__summary-row">
                <strong>Miscellaneous Charges:</strong>
                <span className="rco-workflow-subdialog__summary-value">
                  Rs.{" "}
                  {miscellaneousCharges
                    ? Number(miscellaneousCharges).toLocaleString()
                    : Number(
                      costEstimationForNC?.miscellaneousCharges || 0
                    ).toLocaleString()}
                </span>
              </Box>

              <Box className="rco-workflow-subdialog__summary-row">
                <strong>Less the Cost:</strong>
                <span className="rco-workflow-subdialog__summary-value">
                  Rs.{" "}
                  {lessTheCost
                    ? Number(lessTheCost).toLocaleString()
                    : Number(costEstimationForNC?.lessTheCost || 0).toLocaleString()}
                </span>
              </Box>

              <Box className="rco-workflow-subdialog__summary-row">
                <strong>Capital Cost:</strong>
                <span className="rco-workflow-subdialog__summary-value rco-workflow-subdialog__summary-value--highlight">
                  Rs.{" "}
                  {[
                    itemsAmount || 0,
                    gridSharingCost || 0,
                    dialogRowData?.applicationId?.slice(3, 5) === "13"
                      ? 0
                      : storeCharges || 0,
                    installationCharges || 0,
                    feederRehabilitationCharges || 0,
                    civilWorkCharges || 0,
                    mntCharges || 0,
                    labourCharges || 0,
                    designVettingFee || 0,
                    consultancyCharges || 0,
                    variationCharges || 0,
                    dismantlementCharges || 0,
                    earthingCharges || 0,
                    fixedChargesOfMetering || 0,
                    miscellaneousCharges || 0,
                    -(lessTheCost || 0),
                  ]
                    .map(Number)
                    .reduce((acc, val) => acc + val, 0)
                    .toLocaleString()}
                </span>
              </Box>

              <Box className="rco-workflow-subdialog__summary-row">
                <strong>Current Security:</strong>
                <span className="rco-workflow-subdialog__summary-value rco-workflow-subdialog__summary-value--danger">
                  Rs.{" "}
                  {Number(
                    costEstimationForNC?.currentSecurityAmount || 0
                  ).toLocaleString()}
                </span>
              </Box>

              <Box className="rco-workflow-subdialog__summary-row">
                <strong>Estimated Security:</strong>
                <span className="rco-workflow-subdialog__summary-value">
                  Rs.{" "}
                  {Number(
                    costEstimationForNC?.estimatedSecurityAmount || 0
                  ).toLocaleString()}
                </span>
              </Box>

              <Box className="rco-workflow-subdialog__summary-row">
                <strong>Diff. curr and Est. Security:</strong>
                <span className="rco-workflow-subdialog__summary-value">
                  Rs.{" "}
                  {Number(
                    (costEstimationForNC?.estimatedSecurityAmount || 0) -
                    (costEstimationForNC?.currentSecurityAmount || 0)
                  ).toLocaleString()}
                </span>
              </Box>

              <Box className="rco-workflow-subdialog__summary-row">
                <strong>Security to be Deposited:</strong>
                <span className="rco-workflow-subdialog__summary-value">
                  Rs.{" "}
                  {Math.max(
                    (Number(costEstimationForNC?.estimatedSecurityAmount) ||
                      0) -
                    (Number(costEstimationForNC?.currentSecurityAmount) ||
                      0),
                    0
                  ).toLocaleString()}
                </span>
              </Box>

              <Box className="rco-workflow-subdialog__summary-row">
                <strong>Total Cost Estimation Deposit:</strong>
                <span className="rco-workflow-subdialog__summary-value rco-workflow-subdialog__summary-value--highlight">
                  Rs.{" "}
                  {(() => {
                    const values = [
                      itemsAmount,
                      gridSharingCost,
                      dialogRowData?.applicationId?.slice(3, 5) === "13"
                        ? 0
                        : storeCharges,
                      installationCharges,
                      feederRehabilitationCharges,
                      civilWorkCharges,
                      mntCharges,
                      labourCharges,
                      designVettingFee,
                      consultancyCharges,
                      variationCharges,
                      dismantlementCharges,
                      earthingCharges,
                      fixedChargesOfMetering,
                      miscellaneousCharges,
                      -(Number(lessTheCost) || 0),
                      Math.max(
                        (Number(
                          costEstimationForNC?.estimatedSecurityAmount
                        ) || 0) -
                        (Number(
                          costEstimationForNC?.currentSecurityAmount
                        ) || 0),
                        0
                      ),
                    ];

                    return values
                      .map((v) => Number(v) || 0)
                      .reduce((acc, val) => acc + val, 0)
                      .toLocaleString();
                  })()}
                </span>
              </Box>
            </Box>
          ) : (
            <Typography variant="body2">Loading cost details...</Typography>
          )}
        </DialogContent>

        <DialogActions className="rco-workflow-subdialog__actions">
          <Button
            variant="contained"
            className="rco-workflow-subdialog__btn"
            onClick={onPressCostEstimationConfirm}
          >
            Save Cost Estimation
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={rejectModalOpen}
        onClose={() => {
          setRejectModalOpen(false);
          setRemarks("");
          setRemarksError("");
        }}
        className="rco-remarks-dialog rco-remarks-dialog--dn rco-remarks-dialog--reject"
        maxWidth="sm"
        fullWidth
        PaperProps={{ className: "rco-remarks-dialog__paper" }}
      >
        <DialogTitle className="rco-remarks-dialog__title">
          <div className="rco-remarks-dialog__header">
            <Typography className="rco-remarks-dialog__heading">
              Reject Demand Note Payment
            </Typography>
            <button
              type="button"
              className="rco-remarks-dialog__close"
              onClick={() => {
                setRejectModalOpen(false);
                setRemarks("");
                setRemarksError("");
              }}
              aria-label="Close dialog"
            >
              <CloseIcon id="clearPopup" />
            </button>
          </div>
        </DialogTitle>

        <DialogContent className="rco-remarks-dialog__content">
          <TextField
            autoFocus
            fullWidth
            multiline
            minRows={5}
            maxRows={8}
            variant="outlined"
            className="rco-remarks-dialog__textarea"
            placeholder="Enter Remarks"
            value={remarks}
            onChange={(e) => {
              setRemarks(e.target.value);
              if (e.target.value.trim().length >= 20) setRemarksError("");
            }}
            error={Boolean(remarksError)}
          />
          {remarksError ? (
            <p className="rco-remarks-dialog__error">{remarksError}</p>
          ) : null}
        </DialogContent>

        <DialogActions className="rco-remarks-dialog__actions">
          <Button
            type="button"
            onClick={() => {
              setRejectModalOpen(false);
              setRemarks("");
              setRemarksError("");
            }}
            className="rco-remarks-dialog__btn rco-remarks-dialog__btn--cancel"
          >
            Cancel
          </Button>
          <Button
            type="button"
            onClick={() => {
              if (remarks.trim().length < 20) {
                setRemarksError("Remarks must be at least 20 characters.");
                return;
              }
              DNPaymentVerificationAPI(
                dialogRowData.applicationId,
                dialogRowData.applicationProgressId - 1,
                1,
                "Demand Note Payment Rejected",
                remarks
              );
              setRejectModalOpen(false);
              setRemarks("");
              setRemarksError("");
            }}
            className="rco-remarks-dialog__btn rco-remarks-dialog__btn--confirm"
          >
            Reject
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={scoPopUp}
        onClose={scoHandleClose}
        className="dialog"
        fullWidth={true}
        maxWidth={"sm"}
        PaperProps={{
          style: { width: "100%", height: "45%", borderRadius: 20 },
        }}
      >
        <DialogTitle>
          <Box className="backgroundAttached">
            <DoneIcon className="icon" />
          </Box>
          {scoDetails.scoP2FillFlag &&
            CheckPermissions(
              permissions,
              "General Services",
              "Change of Attributes",
              "Workflow Permissions",
              "Meter Installation",
              "SCO P2 Creation"
            ) ? (
            <Typography variant="h6" className="groupTitle">
              SCO Generated
            </Typography>
          ) : (
            <Typography variant="h6" className="groupTitle">
              SCO Generated
            </Typography>
          )}
        </DialogTitle>
        <DialogContent>
          <DialogContentText component="div">
            {scoDetails.scoP2FillFlag &&
              CheckPermissions(
                permissions,
                "General Services",
                "Change of Attributes",
                "Workflow Permissions",
                "Meter Installation",
                "SCO P2 Creation"
              ) ? (
              <p className="applicationSubmit">
                Your Service Connection has been generated successfully.
              </p>
            ) : (
              <p className="applicationSubmit">
                Your Service Connection has been generated successfully.
              </p>
            )}
            <p className="trackId"> {dialogRowData.applicationId}</p>
            <div
              style={{
                borderRadius: "5px",
                marginLeft: "27%",
                marginTop: "2%",
                cursor: "pointer",
              }}
            >
              {scoDetails.scoP2FillFlag &&
                CheckPermissions(
                  permissions,
                  "General Services",
                  "Change of Attributes",
                  "Workflow Permissions",
                  "Meter Installation",
                  "SCO P2 Creation"
                ) ? (
                <></>
              ) : (
                // <Button variant="outlined" onClick={() => downloadSCOPDF(dialogRowData)} sx={{ backgroundColor: 'white', cursor: 'pointer', border: '1px solid #006ad1', boxShadow: 'none', padding: '2%', width: '60%' }} ><PrintIcon sx={{ color: '#006ad1' }} />Print SCO </Button>
                // <Button variant="outlined" onClick={() => downloadSCOPDF(dialogRowData)} sx={{ backgroundColor: 'white', cursor: 'pointer', border: '1px solid #006ad1', boxShadow: 'none', padding: '2%', width: '60%' }} ><PrintIcon sx={{ color: '#006ad1' }} />Print SCO </Button>
                <></>
              )}
            </div>
          </DialogContentText>
        </DialogContent>
        <DialogActions></DialogActions>
      </Dialog>

      <Dialog
        open={openRemarksDialog}
        onClose={handleCloseRemarks}
        className="rco-remarks-dialog rco-remarks-dialog--dn"
        maxWidth="sm"
        fullWidth
        PaperProps={{ className: "rco-remarks-dialog__paper" }}
      >
        <DialogTitle className="rco-remarks-dialog__title">
          <div className="rco-remarks-dialog__header coa-remarks-dialog__header">
            <Typography className="rco-remarks-dialog__heading">
              Enter Remark
            </Typography>
            {readyForBillingError !== "" ? (
              <Button
                type="button"
                variant="outlined"
                onClick={() =>
                  downloadSJOPDF(
                    dialogRowData.applicationId,
                    scoDetails,
                    dialogRowData,
                    dnDets
                  )
                }
                className="coa-remarks-dialog__sjo-btn"
              >
                <PrintIcon sx={{ color: "#006ad1", fontSize: "1rem" }} />
                SJO
              </Button>
            ) : null}
            <button
              type="button"
              className="rco-remarks-dialog__close"
              onClick={handleCloseRemarks}
              aria-label="Close dialog"
            >
              <CloseIcon id="clearPopup" />
            </button>
          </div>
        </DialogTitle>

        <DialogContent className="rco-remarks-dialog__content">
          <Typography component="p" className="rco-remarks-dialog__prompt">
            Please provide remarks before proceeding for billing:
          </Typography>

          <TextField
            autoFocus
            fullWidth
            multiline
            minRows={5}
            maxRows={8}
            variant="outlined"
            className="rco-remarks-dialog__textarea"
            placeholder="Type your remarks here..."
            value={odRemarks}
            onChange={(e) => {
              setOdRemarks(e.target.value);
              if (remarksError) setRemarksError("");
            }}
            error={Boolean(remarksError)}
          />
          {remarksError ? (
            <p className="rco-remarks-dialog__error">{remarksError}</p>
          ) : null}
          {readyForBillingError ? (
            <p className="rco-remarks-dialog__error">{readyForBillingError}</p>
          ) : null}
        </DialogContent>

        <DialogActions className="rco-remarks-dialog__actions">
          <Button
            type="button"
            onClick={handleCloseRemarks}
            className="rco-remarks-dialog__btn rco-remarks-dialog__btn--cancel"
          >
            Cancel
          </Button>
          <Button
            type="button"
            onClick={handleSubmitRemarks}
            className="rco-remarks-dialog__btn rco-remarks-dialog__btn--confirm"
          >
            Submit
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={showDnExpiryPopup}
        onClose={() => {
          setShowDnExpiryPopup(false);
        }}
        className="dialog"
        fullWidth={true}
        maxWidth={"sm"}
        PaperProps={{
          style: { width: "100%", height: "45%", borderRadius: 20 },
        }}
      >
        <DialogTitle>
          <Box className="backgroundRedAttached">
            <EventBusyIcon className="icon" />
          </Box>
          <Typography variant="h6" className="groupTitle">
            Demand Note Expired
          </Typography>
        </DialogTitle>
        <DialogContent>
          <DialogContentText component="div">
            <p className="applicationSubmit">
              Demand Note for below Application ID is expired.
            </p>
            <p className="trackId">{dnExpiryDialogData.applicationId}</p>
            <div
              style={{
                borderRadius: "5px",
                marginLeft: "27%",
                marginTop: "2%",
                cursor: "pointer",
              }}
            >
              <Button
                variant="outlined"
                onClick={async () => {
                  await callDemandNoteRenewalAPI(
                    dnExpiryDialogData.applicationId
                  );
                  setShowDnExpiryPopup(false);
                }}
                sx={{
                  backgroundColor: "white",
                  cursor: "pointer",
                  border: "1px solid #006ad1",
                  boxShadow: "none",
                  padding: "2%",
                  width: "60%",
                }}
              >
                Renew DN
              </Button>
            </div>
          </DialogContentText>
        </DialogContent>
        <DialogActions></DialogActions>
      </Dialog>

      {/* Edit Popup */}
      <Dialog
        open={showEditPopup}
        onClose={closeEditApplicationPopup}
        fullWidth
        maxWidth="lg"
        className="rco-workflow-subdialog coa-edit-application-dialog"
        PaperProps={{
          className:
            "rco-workflow-subdialog__paper coa-edit-application-dialog__paper",
        }}
      >
        <DialogTitle className="rco-workflow-subdialog__title">
          <Box className="rco-workflow-subdialog__header">
            <Typography className="rco-workflow-subdialog__heading">
              Edit Application
            </Typography>
            <button
              type="button"
              className="rco-workflow-subdialog__close"
              onClick={closeEditApplicationPopup}
              aria-label="Close dialog"
            >
              <CloseIcon id="clearPopup" />
            </button>
          </Box>
        </DialogTitle>
        <DialogContent className="rco-workflow-subdialog__content coa-edit-application-dialog__content">
          <DialogContentText component="div" className="dialog-content-text">
            <Typography variant="h6" className="group-title">
              <div className="redCell"></div>
              Application Details
            </Typography>
          </DialogContentText>

          {/* Common Fields Row */}
          <DialogContentText component="div" className="dialog-content-text">
            <div className="field-container">
              <Typography className="fieldLabel">Application ID</Typography>
              <TextField
                disabled
                type="text"
                value={dialogRowData.applicationId || ""}
                className="textfield"
              />
            </div>
            <div className="field-container">
              <Typography className="fieldLabel">Reference No.</Typography>
              <TextField
                type="text"
                value={editFormData.referenceNo}
                onChange={(e) => setEditFormData({ ...editFormData, referenceNo: e.target.value })}
                className="textfield"
                autoComplete="off"
                disabled
              />
            </div>
            <div className="field-container">
              <Typography className="fieldLabel">Address</Typography>
              <TextField
                type="text"
                value={editFormData.address}
                onChange={(e) => setEditFormData({ ...editFormData, address: e.target.value })}
                className="textfield"
                autoComplete="off"
                disabled
              />
            </div>
            <div className="field-container">
              <Typography className="fieldLabel">Tariff</Typography>
              <TextField
                type="text"
                value={editFormData.tariff}
                onChange={(e) => setEditFormData({ ...editFormData, tariff: e.target.value })}
                className="textfield"
                autoComplete="off"
                disabled
              />
            </div>
          </DialogContentText>

          {hasMultipleCoaSections(dialogRowData.changeOfAttributesType) && (
            <DialogContentText
              component="div"
              className="dialog-content-text coa-edit-application-dialog__checks"
            >
              <Typography
                component="p"
                className="coa-edit-application-dialog__section-heading"
              >
                Select section(s) to edit
              </Typography>
              <Box className="coa-edit-application-dialog__checks-group">
                {coaIncludesName(dialogRowData.changeOfAttributesType) && (
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={editSections.name}
                        onChange={(e) => {
                          setEditSaveError("");
                          setEditSections((prev) => ({ ...prev, name: e.target.checked }));
                        }}
                        sx={{ color: "#658bca", "&.Mui-checked": { color: "#003971" } }}
                      />
                    }
                    label="Change of Name"
                  />
                )}
                {coaIncludesLoad(dialogRowData.changeOfAttributesType) && (
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={editSections.load}
                        onChange={(e) => {
                          setEditSaveError("");
                          setEditSections((prev) => ({ ...prev, load: e.target.checked }));
                        }}
                        sx={{ color: "#658bca", "&.Mui-checked": { color: "#003971" } }}
                      />
                    }
                    label="Change of Load"
                  />
                )}
                {coaIncludesTariff(dialogRowData.changeOfAttributesType) && (
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={editSections.tariff}
                        onChange={(e) => {
                          setEditSaveError("");
                          setEditSections((prev) => ({ ...prev, tariff: e.target.checked }));
                        }}
                        sx={{ color: "#658bca", "&.Mui-checked": { color: "#003971" } }}
                      />
                    }
                    label="Change of Tariff"
                  />
                )}
              </Box>
            </DialogContentText>
          )}

          {/* Change of Name Fields */}
          {coaIncludesName(dialogRowData.changeOfAttributesType) && editSections.name && (
            <>
              <DialogContentText component="div" className="dialog-content-text">
                <Typography
                  component="p"
                  className="coa-edit-application-dialog__section-heading"
                >
                  Change of Name
                </Typography>
              </DialogContentText>
              <DialogContentText component="div" className="dialog-content-text">
                <div className="field-container">
                  <Typography className="fieldLabel">Current Name</Typography>
                  <TextField
                    type="text"
                    value={editFormData.currentName}
                    onChange={(e) => setEditFormData({ ...editFormData, currentName: e.target.value })}
                    className="textfield"
                    autoComplete="off"
                    disabled
                  />
                </div>
                <div className="field-container">
                  <Typography className="fieldLabel">New Name</Typography>
                  <TextField
                    type="text"
                    name="newName"
                    value={editFormData.newName}
                    onChange={(e) => {
                      const sanitized = sanitizePersonNameInput(e.target.value);
                      setEditFormData({ ...editFormData, newName: sanitized });
                      setEditNameErrors((prev) => ({ ...prev, newName: "" }));
                    }}
                    className="textfield"
                    autoComplete="off"
                    error={Boolean(editNameErrors.newName)}
                    helperText={editNameErrors.newName}
                  />
                </div>
                <div className="field-container">
                  <Typography className="fieldLabel">Relation</Typography>
                  <Select
                    value={editFormData.relation}
                    onChange={(e) => setEditFormData({ ...editFormData, relation: e.target.value })}
                    className="textfield"
                    displayEmpty
                  >
                    <MenuItem value={1}>S/O</MenuItem>
                    <MenuItem value={2}>D/O</MenuItem>
                    <MenuItem value={3}>W/O</MenuItem>
                    <MenuItem value={4}>C/O</MenuItem>
                  </Select>
                </div>
                <div className="field-container">
                  <Typography className="fieldLabel">Guardian Name</Typography>
                  <TextField
                    type="text"
                    name="guardianName"
                    value={editFormData.guardianName}
                    onChange={(e) => {
                      const sanitized = sanitizePersonNameInput(e.target.value);
                      setEditFormData({ ...editFormData, guardianName: sanitized });
                      setEditNameErrors((prev) => ({ ...prev, guardianName: "" }));
                    }}
                    className="textfield"
                    autoComplete="off"
                    error={Boolean(editNameErrors.guardianName)}
                    helperText={editNameErrors.guardianName}
                  />
                </div>
              </DialogContentText>
              <DialogContentText component="div" className="dialog-content-text">
                <div className="field-container">
                  <Typography className="fieldLabel">Current CNIC</Typography>
                  <TextField
                    type="text"
                    value={editFormData.currentCNIC}
                    onChange={(e) => setEditFormData({ ...editFormData, currentCNIC: e.target.value })}
                    className="textfield"
                    inputProps={{ maxLength: 13, autoComplete: "off" }}
                    disabled
                  />
                </div>
                <div className="field-container">
                  <Typography className="fieldLabel">New CNIC</Typography>
                  <TextField
                    type="text"
                    value={editFormData.newCNIC}
                    onChange={(e) => {
                      const val = e.target.value.replace(/\D/g, "");
                      setEditFormData({ ...editFormData, newCNIC: val });
                      setEditNameErrors((prev) => ({ ...prev, newCNIC: "" }));
                    }}
                    className="textfield"
                    inputProps={{ maxLength: 13, autoComplete: "off" }}
                    error={Boolean(editNameErrors.newCNIC)}
                    helperText={editNameErrors.newCNIC}
                  />
                </div>
                <div className="field-container">
                  <Typography className="fieldLabel">Current Phone</Typography>
                  <TextField
                    type="text"
                    value={editFormData.currentPhone}
                    onChange={(e) => setEditFormData({ ...editFormData, currentPhone: e.target.value })}
                    className="textfield"
                    inputProps={{ maxLength: 11, autoComplete: "off" }}
                    disabled
                  />
                </div>
                <div className="field-container">
                  <Typography className="fieldLabel">New Phone</Typography>
                  <TextField
                    type="text"
                    value={editFormData.newPhone}
                    onChange={(e) => {
                      const val = e.target.value.replace(/\D/g, "");
                      setEditFormData({ ...editFormData, newPhone: val });
                      setEditNameErrors((prev) => ({ ...prev, newPhone: "" }));
                    }}
                    className="textfield"
                    inputProps={{ maxLength: 11, autoComplete: "off" }}
                    error={Boolean(editNameErrors.newPhone)}
                    helperText={editNameErrors.newPhone}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start" sx={{ mr: 0 }}>
                          <Select
                            value={editFormData.telcoCode}
                            onChange={(e) => setEditFormData({ ...editFormData, telcoCode: e.target.value })}
                            variant="standard"
                            disableUnderline
                            sx={{
                              minWidth: 70,
                              '& .MuiSelect-select': {
                                paddingRight: '20px !important',
                                paddingLeft: '0px'
                              }
                            }}
                          >
                            <MenuItem value={1}>Jazz</MenuItem>
                            <MenuItem value={2}>Zong</MenuItem>
                            <MenuItem value={3}>Telenor</MenuItem>
                            <MenuItem value={4}>Ufone</MenuItem>
                            <MenuItem value={5}>SCom</MenuItem>
                          </Select>
                        </InputAdornment>
                      ),
                    }}
                  />
                </div>
              </DialogContentText>
            </>
          )}

          {/* Change of Load Fields */}
          {coaIncludesLoad(dialogRowData.changeOfAttributesType) && editSections.load && (
            <>
              <DialogContentText component="div" className="dialog-content-text">
                <Typography
                  component="p"
                  className="coa-edit-application-dialog__section-heading"
                >
                  Change of Load
                </Typography>
              </DialogContentText>
              <DialogContentText component="div" className="dialog-content-text">
                <div className="field-container">
                  <Typography className="fieldLabel">Load Change Type</Typography>
                  <Select
                    value={
                      editFormData.loadChangeType !== "" &&
                        editFormData.loadChangeType != null
                        ? String(editFormData.loadChangeType)
                        : ""
                    }
                    onChange={(e) => {
                      setEditFormData({
                        ...editFormData,
                        loadChangeType: e.target.value,
                      });
                      setEditLoadChangeTypeError("");
                      setEditLoadError("");
                    }}
                    className="textfield"
                    displayEmpty
                    error={Boolean(editLoadChangeTypeError)}
                  >
                    <MenuItem value="">
                      <em>Select Load Change Type</em>
                    </MenuItem>
                    {lookUpDataOfCON?.lookupLoadChangeType?.map((item) => (
                      <MenuItem key={item.typeId} value={String(item.typeId)}>
                        {item.typeName}
                      </MenuItem>
                    ))}
                  </Select>
                  {editLoadChangeTypeError ? (
                    <Typography variant="caption" color="error" sx={{ display: "block", mt: 0.5 }}>
                      {editLoadChangeTypeError}
                    </Typography>
                  ) : null}
                </div>
                <div className="field-container">
                  <Typography className="fieldLabel">Sanctioned Load (kW)</Typography>
                  <TextField
                    type="text"
                    value={editFormData.currentLoad}
                    className="textfield"
                    autoComplete="off"
                    disabled
                  />
                </div>
                <div className="field-container">
                  <Typography className="fieldLabel">New Load (KW)</Typography>
                  <TextField
                    type="text"
                    value={editFormData.newLoad}
                    onChange={(e) => {
                      const regex = /^[0-9]*\.?[0-9]*$/;
                      if (e.target.value === "" || regex.test(e.target.value)) {
                        setEditFormData({ ...editFormData, newLoad: e.target.value });
                        setEditLoadError("");
                      }
                    }}
                    onBlur={() => {
                      const loadErrors = validateEditLoad();
                      setEditLoadChangeTypeError(loadErrors.loadChangeType || "");
                      setEditLoadError(loadErrors.newLoad || "");
                    }}
                    className="textfield"
                    autoComplete="off"
                    error={Boolean(editLoadError)}
                    helperText={editLoadError}
                  />
                </div>
              </DialogContentText>
            </>
          )}

          {/* Change of Tariff Fields */}
          {coaIncludesTariff(dialogRowData.changeOfAttributesType) && editSections.tariff && (
            <>
              <DialogContentText component="div" className="dialog-content-text">
                <Typography
                  component="p"
                  className="coa-edit-application-dialog__section-heading"
                >
                  Change of Tariff
                </Typography>
              </DialogContentText>
              <DialogContentText component="div" className="dialog-content-text">
                <div className="field-container">
                  <Typography className="fieldLabel">Old Tariff</Typography>
                  <TextField
                    type="text"
                    value={editFormData.currentTariff}
                    className="textfield"
                    autoComplete="off"
                    disabled
                  />
                </div>
                <div className="field-container">
                  <Typography className="fieldLabel">New Tariff</Typography>
                  <FormControl fullWidth error={Boolean(editTariffError)}>
                    <Select
                      value={editFormData.newTariff || ""}
                      onChange={(e) => {
                        const newTariff = e.target.value;
                        setEditFormData({
                          ...editFormData,
                          newTariff,
                          ntnNo: requiresFbrDocument(newTariff)
                            ? editFormData.ntnNo
                            : "",
                        });
                        setEditTariffError(validateEditTariff(newTariff));
                        setEditSaveError("");
                        if (!requiresFbrDocument(newTariff)) {
                          setEditFbrDocument("");
                          setEditFbrDocumentThumbnail("");
                          setEditFbrDocumentError("");
                          setEditFbrDocumentCleared(false);
                          setEditNtnError("");
                        }
                      }}
                      className="textfield"
                      displayEmpty
                    >
                      <MenuItem value="">
                        <em>Select New Tariff</em>
                      </MenuItem>
                      {editFormData.newTariff &&
                        !allTariffList?.some(
                          (item) => item.tariffName === editFormData.newTariff
                        ) && (
                          <MenuItem value={editFormData.newTariff}>
                            {editFormData.newTariff}
                          </MenuItem>
                        )}
                      {allTariffList?.map((data, index) => (
                        <MenuItem key={index} value={data.tariffName}>
                          {data.tariffName}
                        </MenuItem>
                      ))}
                    </Select>
                    {editTariffError ? (
                      <FormHelperText>{editTariffError}</FormHelperText>
                    ) : null}
                  </FormControl>
                </div>
              </DialogContentText>
              {requiresFbrDocument(editFormData.newTariff) &&
                !hasExistingEditNtn(dialogRowData) && (
                  <DialogContentText component="div" className="dialog-content-text">
                    <div className="field-container coa-edit-application-dialog__field--full">
                      <Typography className="fieldLabel">
                        NTN No. <span className="coa-edit-application-dialog__required">*</span>
                      </Typography>
                      <TextField
                        type="text"
                        value={editFormData.ntnNo}
                        onChange={(e) => {
                          const val = e.target.value.replace(/\D/g, "");
                          if (val.length <= 13) {
                            setEditFormData({ ...editFormData, ntnNo: val });
                            setEditNtnError("");
                          }
                        }}
                        className="textfield"
                        autoComplete="off"
                        inputProps={{ maxLength: 13 }}
                        error={Boolean(editNtnError)}
                        helperText={editNtnError}
                      />
                    </div>
                  </DialogContentText>
                )}
              {requiresFbrDocument(editFormData.newTariff) &&
                !hasExistingEditFbrDocument(dialogRowData) &&
                (() => {
                  const activeEditFbrDocument = editFbrDocumentThumbnail || "";

                  return (
                    <DialogContentText component="div" className="dialog-content-text">
                      <div className="field-container coa-edit-application-dialog__field--full">
                        <Typography className="fieldLabel">
                          FBR Document <span className="coa-edit-application-dialog__required">*</span>
                        </Typography>
                        <Box className="coa-edit-application-dialog__fbr-upload-row">
                          {activeEditFbrDocument ? (
                            <Box
                              onClick={() => openBase64Image(activeEditFbrDocument)}
                              className="coa-edit-application-dialog__fbr-preview"
                            >
                              {activeEditFbrDocument.slice(0, 6) === "data:i" ? (
                                <Base64Image
                                  data={activeEditFbrDocument}
                                  width="120"
                                  height="160"
                                />
                              ) : isPdf(activeEditFbrDocument) ? (
                                <Base64Image data={pdfIcon} width="80" height="100" />
                              ) : (
                                <Base64Image
                                  data={activeEditFbrDocument}
                                  width="120"
                                  height="160"
                                />
                              )}
                            </Box>
                          ) : null}
                          <Button
                            variant="outlined"
                            component="label"
                            startIcon={<FileUploadOutlinedIcon />}
                          >
                            {activeEditFbrDocument
                              ? "Re-upload FBR Document"
                              : "Upload FBR Document"}
                            <input
                              hidden
                              accept={documentExtensions}
                              type="file"
                              onChange={(e) => {
                                EditFbrDocument(e);
                                setEditFbrDocumentCleared(false);
                                setEditFbrDocumentError("");
                              }}
                            />
                          </Button>
                        </Box>
                        {editFbrDocumentError && (
                          <Typography variant="caption" color="error" sx={{ display: "block", mt: 0.5 }}>
                            {editFbrDocumentError}
                          </Typography>
                        )}
                      </div>
                    </DialogContentText>
                  );
                })()}
            </>
          )}
          {(() => {
              const coaType = Number(dialogRowData.changeOfAttributesType);
              const shouldEditLoad =
                coaIncludesLoad(coaType) && editSections.load;
              const shouldEditTariff =
                coaIncludesTariff(coaType) && editSections.tariff;
              const loadOrTariffWillChange = isEditLoadOrTariffValueChanged({
                shouldEditLoad,
                shouldEditTariff,
              });
              if (!loadOrTariffWillChange) {
                return null;
              }

              const wiringPreview =
                editWiringTestReportThumbnail ||
                (!editWiringTestReportCleared &&
                  dialogRowData.wiringTestReportDocument) ||
                "";
              const wiringFileLabel =
                editWiringTestReportDocument ||
                (wiringPreview ? "wiringTestReportDocument" : "");
              const hasWiringFile = Boolean(wiringFileLabel || wiringPreview);

              const clearEditWiringTestReport = () => {
                setEditWiringTestReportDocument("");
                setEditWiringTestReportThumbnail("");
                setEditWiringTestReportError("");
                setEditWiringTestReportCleared(true);
              };

              return (
                <DialogContentText component="div" className="dialog-content-text">
                  <div className="field-container coa-edit-application-dialog__field--full">
                    <Typography className="fieldLabel">
                      Wiring Test Report
                      <span className="coa-edit-application-dialog__required">
                        {" "}
                        *
                      </span>
                    </Typography>
                    <div className="upload-wrap">
                      {hasWiringFile ? (
                        <Button
                          component="span"
                          className="upload-preview"
                          startIcon={
                            <CloseIcon
                              className="button-with-image"
                              onClick={(event) => {
                                event.preventDefault();
                                event.stopPropagation();
                                clearEditWiringTestReport();
                              }}
                            />
                          }
                        >
                          {wiringPreview &&
                          (isImage(wiringFileLabel) ||
                            wiringPreview.slice(0, 6) === "data:i") ? (
                            <div
                              className="btn-div"
                              onClick={() => openBase64Image(wiringPreview)}
                              role="presentation"
                            >
                              <img
                                src={wiringPreview}
                                alt="Wiring Test Report"
                                width="80"
                              />
                            </div>
                          ) : isPdf(wiringFileLabel) || isPdf(wiringPreview) ? (
                            <div
                              className="btn-div"
                              onClick={() => openBase64Image(wiringPreview)}
                              role="presentation"
                            >
                              <img src={pdfIcon} alt="PDF" width="80" />
                            </div>
                          ) : (
                            <span>Other file type</span>
                          )}
                        </Button>
                      ) : (
                        <>
                          <Button
                            variant="outlined"
                            component="label"
                            startIcon={<FileUploadOutlinedIcon />}
                            className="btn"
                          >
                            Upload
                            <input
                              hidden
                              accept={documentExtensions}
                              type="file"
                              onChange={(event) => {
                                EditWiringTestReportDocument(event);
                              }}
                            />
                          </Button>
                          {editWiringTestReportError ? (
                            <Box className="documentError">
                              {editWiringTestReportError}
                            </Box>
                          ) : null}
                        </>
                      )}
                    </div>
                    {hasWiringFile && editWiringTestReportError ? (
                      <Box className="documentError">{editWiringTestReportError}</Box>
                    ) : null}
                  </div>
                </DialogContentText>
              );
            })()}
          {editSaveError ? (
            <p className="rco-workflow-subdialog__error coa-edit-application-dialog__error">
              {editSaveError}
            </p>
          ) : null}
        </DialogContent>
        <DialogActions className="rco-workflow-subdialog__actions coa-edit-application-dialog__actions">
          <Button
            type="button"
            onClick={closeEditApplicationPopup}
            className="coa-edit-application-dialog__btn coa-edit-application-dialog__btn--cancel"
          >
            Cancel
          </Button>
          <Button
            type="button"
            onClick={async () => {
              setEditSaveError("");
              setEditWiringTestReportError("");
              if (Number(dialogRowData.applicationProgressId) >= 3) {
                setEditSaveError(
                  "Application can only be edited before Arrear Verification.",
                );
                return;
              }
              const coaType = Number(dialogRowData.changeOfAttributesType);
              const shouldEditName = coaIncludesName(coaType) && editSections.name;
              const shouldEditLoad = coaIncludesLoad(coaType) && editSections.load;
              const shouldEditTariff = coaIncludesTariff(coaType) && editSections.tariff;

              if (hasMultipleCoaSections(coaType) && !shouldEditName && !shouldEditLoad && !shouldEditTariff) {
                setEditSaveError("Please select at least one section to edit");
                return;
              }

              const nameErrors = shouldEditName
                ? validateEditName()
                : { newName: "", guardianName: "", newCNIC: "", newPhone: "" };
              const loadErrors = shouldEditLoad
                ? validateEditLoad()
                : { loadChangeType: "", newLoad: "" };
              const tariffError = shouldEditTariff
                ? validateEditTariff(editFormData.newTariff)
                : "";

              setEditNameErrors(nameErrors);
              setEditLoadChangeTypeError(loadErrors.loadChangeType || "");
              setEditLoadError(loadErrors.newLoad || "");
              setEditTariffError(tariffError);

              // Field errors stay under their inputs only — do not mirror them at the bottom.
              if (
                getFirstEditValidationError(nameErrors, loadErrors, tariffError)
              ) {
                return;
              }

              if (shouldEditTariff) {
                const newTariff = String(editFormData.newTariff || "").trim();
                if (requiresFbrDocument(newTariff)) {
                  if (!hasExistingEditNtn(dialogRowData)) {
                    const ntnError = validateEditNtn(editFormData.ntnNo, newTariff);
                    if (ntnError) {
                      setEditNtnError(ntnError);
                      return;
                    }
                  }
                  if (!hasExistingEditFbrDocument(dialogRowData) && !editFbrDocumentThumbnail) {
                    setEditFbrDocumentError(
                      "FBR Document is required for this tariff."
                    );
                    return;
                  }
                }
              }

              if (
                !hasSelectedEditChanges({
                  shouldEditName,
                  shouldEditLoad,
                  shouldEditTariff,
                })
              ) {
                setEditSaveError(
                  "No changes detected. Please modify at least one value before saving."
                );
                return;
              }

              const loadOrTariffChanged = isEditLoadOrTariffValueChanged({
                shouldEditLoad,
                shouldEditTariff,
              });
              if (
                loadOrTariffChanged &&
                !resolveEditWiringTestReportDocument(dialogRowData)
              ) {
                setEditWiringTestReportError(
                  "Wiring Test Report is required when sanctioned load or tariff changes.",
                );
                return;
              }

              setViewBackdrop(true);
              try {
                const myHeaders = new Headers();
                myHeaders.append("Authorization", token);
                myHeaders.append("Content-Type", "application/json");

                const resolvedNewTariff = shouldEditTariff
                  ? String(editFormData.newTariff || "").trim()
                  : String(dialogRowData.newTariff || "").trim();
                const payload = {
                  applicationId: dialogRowData.applicationId,
                  remarks: "Application updated.",
                  changeOfAttributesType: coaType,
                  telcoCode: Number(editFormData.telcoCode || dialogRowData.telcoCode) || 1,
                  ntnNo: shouldEditTariff && requiresFbrDocument(resolvedNewTariff)
                    ? String(
                      editFormData.ntnNo || dialogRowData.ntnNo || ""
                    ).trim()
                    : dialogRowData.ntnNo || "",
                };

                // Always include applicantName (backend may require it even when not editing name)
                payload.applicantName =
                  dialogRowData.applicantName ? dialogRowData.applicantName : "";

                if (coaIncludesName(coaType)) {
                  payload.applicantName = shouldEditName
                    ? editFormData.newName || dialogRowData.applicantName
                    : dialogRowData.applicantName;
                  payload.applicantGuardianType = String(
                    shouldEditName
                      ? editFormData.relation || dialogRowData.applicantGuardianType
                      : dialogRowData.applicantGuardianType
                  );
                  payload.applicantGuardianName = shouldEditName
                    ? editFormData.guardianName || dialogRowData.applicantGuardianName
                    : dialogRowData.applicantGuardianName;
                  payload.applicantCNIC = shouldEditName
                    ? editFormData.newCNIC || dialogRowData.applicantCNIC
                    : dialogRowData.applicantCNIC;
                  payload.applicantPhoneNo = shouldEditName
                    ? editFormData.newPhone || dialogRowData.applicantPhoneNo
                    : dialogRowData.applicantPhoneNo;
                  payload.applicantEmail = shouldEditName
                    ? editFormData.newEmail || dialogRowData.applicantEmail || ""
                    : dialogRowData.applicantEmail || "";
                }

                if (coaIncludesLoad(coaType)) {
                  payload.changeOfLoadType = Number(
                    shouldEditLoad
                      ? editFormData.loadChangeType || dialogRowData.changeOfLoadType
                      : dialogRowData.changeOfLoadType
                  );
                  payload.currentSanctionLoad = parseFloat(
                    shouldEditLoad
                      ? editFormData.currentLoad || dialogRowData.currentSanctionLoad
                      : dialogRowData.currentSanctionLoad
                  );
                  payload.newSanctionLoad = parseFloat(
                    shouldEditLoad
                      ? editFormData.newLoad || dialogRowData.newSanctionLoad
                      : dialogRowData.newSanctionLoad
                  );
                }

                if (coaIncludesTariff(coaType)) {
                  payload.currentTariff = shouldEditTariff
                    ? editFormData.currentTariff || dialogRowData.currentTariff
                    : dialogRowData.currentTariff;
                  payload.newTariff = shouldEditTariff
                    ? resolvedNewTariff
                    : dialogRowData.newTariff;
                  payload.fbrDocument =
                    editFbrDocumentThumbnail ||
                    (!editFbrDocumentCleared && dialogRowData.fbrDocument) ||
                    "";
                }

                if (loadOrTariffChanged) {
                  payload.wiringTestReportDocument =
                    resolveEditWiringTestReportDocument(dialogRowData);
                }

                const requestOptions = {
                  method: "POST",
                  headers: myHeaders,
                  body: JSON.stringify(payload),
                  redirect: "follow",
                };

                const response = await fetch(
                  cfpBaseUrl + "changeOfAttributes/updateApplicationAttributes",
                  requestOptions
                );
                const result = await response.json();

                if (result.status == 200) {
                  mergeEditApiResponseIntoDialog(result.data, {
                    resolvedNewTariff,
                    shouldEditTariff,
                  });
                  const refreshedRow = await refreshDialogRowFromServer(
                    dialogRowData.applicationId
                  );
                  await callEfileAPI(
                    dialogRowData.applicationId,
                    refreshedRow || { ...dialogRowData, newTariff: resolvedNewTariff }
                  );

                  const updatedApplicantName =
                    payload.applicantName ||
                    refreshedRow?.applicantName ||
                    dialogRowData.applicantName;
                  const updatedApplicantCNIC =
                    payload.applicantCNIC ||
                    refreshedRow?.applicantCNIC ||
                    dialogRowData.applicantCNIC;

                  if (typeof props.onSearchResultUpdated === "function") {
                    props.onSearchResultUpdated({
                      applicationId: dialogRowData.applicationId,
                      applicantName: updatedApplicantName,
                      name: updatedApplicantName,
                      applicantCNIC: updatedApplicantCNIC,
                      cnic: updatedApplicantCNIC,
                    });
                  }

                  closeEditApplicationPopup();
                  openCoaResponseModal(
                    result.message || "Application updated successfully."
                  );
                } else {
                  closeEditApplicationPopup();
                  openCoaResponseModal(
                    result.message || "Failed to update application.",
                    { isError: true }
                  );
                }
              } catch (error) {
                closeEditApplicationPopup();
                openCoaResponseModal(
                  "Error updating application. Please try again.",
                  { isError: true }
                );
              } finally {
                setViewBackdrop(false);
              }
            }}
            className="coa-edit-application-dialog__btn coa-edit-application-dialog__btn--save"
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>

      {/* Activity Log - Application Updated Details */}
      <RcoActivityLogDialog
        open={coaApplicationUpdatedPopUp}
        onClose={() => {
          setCoaApplicationUpdatedPopUp(false);
          setCoaApplicationUpdatedHistoryData(null);
        }}
        title="Application Updated"
        variant="submitted"
        maxWidth="md"
        footer={
          coaApplicationUpdatedHistoryData
            ? `Processed by: ${coaApplicationUpdatedHistoryData.lastModifiedBy || "-"} on: ${coaApplicationUpdatedHistoryData.lastModificationDate
              ? convertDatewithTime(
                coaApplicationUpdatedHistoryData.lastModificationDate
              )
              : "-"
            }`
            : null
        }
      >
        <div className="wf-application-details-body coa-activity-log-body">
          {coaApplicationUpdatedHistoryData ? (
            <>
              <Grid container spacing={2} sx={{ mb: 2 }}>
                <Grid item xs={12} sm={6}>
                  <Typography className="fieldLabel">Application ID</Typography>
                  <Typography>
                    {coaApplicationUpdatedHistoryData.applicationId || "-"}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography className="fieldLabel">Application Type</Typography>
                  <Typography>
                    {applicationName(
                      coaApplicationUpdatedHistoryData.changeOfAttributesType
                    ) || "-"}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography className="fieldLabel">Step</Typography>
                  <Typography>
                    {coaApplicationUpdatedHistoryData.coaProgStatusName ||
                      progFunc(
                        getCoaApplicationUpdatedStepProgressId(
                          coaApplicationUpdatedHistoryData
                        )
                      ) ||
                      "-"}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography className="fieldLabel">Remarks</Typography>
                  <Typography>
                    {coaApplicationUpdatedHistoryData.remarks || "-"}
                  </Typography>
                </Grid>
                {coaIncludesLoad(
                  coaApplicationUpdatedHistoryData.changeOfAttributesType
                ) && coaApplicationUpdatedHistoryData.changeOfLoadType ? (
                  <Grid item xs={12} sm={6}>
                    <Typography className="fieldLabel">Load Change Type</Typography>
                    <Typography>
                      {getLoadChangeTypeName(
                        coaApplicationUpdatedHistoryData.changeOfLoadType
                      ) || "-"}
                    </Typography>
                  </Grid>
                ) : null}
                {coaIncludesTariff(
                  coaApplicationUpdatedHistoryData.changeOfAttributesType
                ) && coaApplicationUpdatedHistoryData.ntnNo ? (
                  <Grid item xs={12} sm={6}>
                    <Typography className="fieldLabel">NTN No.</Typography>
                    <Typography>{coaApplicationUpdatedHistoryData.ntnNo}</Typography>
                  </Grid>
                ) : null}
              </Grid>

              <TableContainer component={Paper} sx={{ mb: 2 }}>
                <Table size="small">
                  <TableHead>
                    <TableRow sx={{ backgroundColor: "#1e4e8c" }}>
                      <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                        Field
                      </TableCell>
                      <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                        Previous
                      </TableCell>
                      <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                        Updated
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {getCoaApplicationUpdatedTableRows(
                      coaApplicationUpdatedHistoryData,
                      dialogRowData
                    ).map((row, index) => (
                      <TableRow
                        key={`${row.label}-${index}`}
                        sx={{
                          backgroundColor:
                            index % 2 === 0 ? "white" : "rgb(213, 229, 255)",
                        }}
                      >
                        <TableCell sx={{ fontWeight: "bold" }}>
                          {row.label || "-"}
                        </TableCell>
                        <TableCell>{row.current || "-"}</TableCell>
                        <TableCell>{row.newVal || "-"}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </>
          ) : (
            <Typography>No update details found.</Typography>
          )}
        </div>
      </RcoActivityLogDialog>

      <RcoActivityLogDetailDialog
        open={activityLogDetailOpen}
        onClose={() => setActivityLogDetailOpen(false)}
        historyItems={eFileData}
        currentStatus={eFileCurrentStatus || {}}
        currentProgressId={dialogRowData?.applicationProgressId}
        buildDetailRows={buildCoaActivityLogDetailRows}
        applicationDetails={buildCoaActivityLogApplicationDetails(dialogRowData)}
        formatDateFn={convertDatewithTime}
        onStepClick={openDetailsPopUp}
        timelineType={ACTIVITY_LOG_TIMELINE_TYPES.CHANGE_OF_ATTRIBUTES}
      />

      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1000 }}
        open={viewBackdrop}
      >
        <AppLoader />
      </Backdrop>
    </>
  );
});

export default ChangeAttributesTable;

